/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(274);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            var args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays (ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        var weekdays = isArray(this._weekdays) ? this._weekdays :
	            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
	        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
	            : (m) ? weekdays[m.day()] : weekdays;
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                __webpack_require__(221)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000;
	    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
	    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
	    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return (dividend % divisor + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':   return months;
	                case 'quarter': return months / 3;
	                case 'year':    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asQuarters     = makeAs('Q');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asQuarters     = asQuarters;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.24.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(161)(module)))

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	"use strict";
	
	var _slicedToArray = function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { var _arr = []; for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) { _arr.push(_step.value); if (i && _arr.length === i) break; } return _arr; } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } };
	
	/**
	 * Get age for rebate purposes (age as at end of current financial year)
	 */
	exports.calculateRebateAge = calculateRebateAge;
	
	/**
	 * Age for rebate calculations will be the greater of the two 'rebate ages' on the application (personal + partner)
	 * @param applicant: AonApplicationService application record
	 * @return {*}
	 */
	exports.calculateCombinedRebateAge = calculateCombinedRebateAge;
	exports.calcRebate = calcRebate;
	exports.calculate2Age = calculate2Age;
	exports.determineLHCBaseDate = determineLHCBaseDate;
	exports.doesLHCApply = doesLHCApply;
	exports.calcAgeFrom = calcAgeFrom;
	exports.getLastFinancialYearEndDate = getLastFinancialYearEndDate;
	exports.getCurrentDate = getCurrentDate;
	exports.getLastFinancialYearBaseDate = getLastFinancialYearBaseDate;
	exports.calculateAge = calculateAge;
	
	//Function to display what their LHC Age would be based on the LHC Base day calculation. Used for Frontend display only,
	// for LHC calculcation see: CalculateAge / DoesLHCApply()
	exports.calculateLHCAge = calculateLHCAge;
	exports.calcLHC = calcLHC;
	
	// For any price package that has direct debit discount available, apply the discount
	exports.applyDirectDebitDiscount = applyDirectDebitDiscount;
	
	// Adds a 'calculations' field to each price in a price package, containing LHC, rebate, total, etc
	exports.priceCalculations = priceCalculations;
	exports.splitServicesIntoColumns = splitServicesIntoColumns;
	
	// Copy the applicant data, and add in DOB's calculated from the rebate tier index
	// if required (corporate can be configured to not capture DOB or AGE)
	// This is done to simplify pricing calculation assumptions in the backend
	exports.applicantWithDOB = applicantWithDOB;
	
	/**
	 * Takes a price package (returned from package search api for example), a list of services,
	 * and the services associated with a price, and returns a map of service id to the matching
	 * service on the price.
	 * @param pricePackage
	 * @param services
	 * @param productServices
	 */
	exports.getProductFeatures = getProductFeatures;
	
	/**
	 * Return the payment frequency key in AonConfig.jsConstants.PaymentFrequencies
	 * given the numeric value
	 * @param frequency number Numeric payment frequency (see AonConfig.jsConstants.PaymentFrequencies)
	 */
	exports.getPaymentFrequencyKey = getPaymentFrequencyKey;
	
	/**
	 * Given a key into the payment frequency config, return a normalized
	 * string value that can be used as <select> option values
	 * @param key
	 * @return {string}
	 */
	exports.getPaymentFrequencyOptionFromKey = getPaymentFrequencyOptionFromKey;
	
	/**
	 * Get pricing based on current/future, direct debit, payment frequency, etc.
	 * @param pkg The price package to get pricing for
	 * @param which 'available'|'future' Current or future pricing
	 * @param frequency number Numeric payment frequency (see AonConfig.jsConstants.PaymentFrequencies)
	 * @param directDebitDiscount true|false Whether to apply DD discount
	 * @param noDiscounts true|false Whether to pull from the no discounts pricing
	 */
	exports.getPricingForFrequency = getPricingForFrequency;
	exports.getDiscountCodeRestrictions = getDiscountCodeRestrictions;
	
	/**
	 * If a discount code has been selected which limits form choices, apply those limits here.
	 * Note that this will mutate the fieldsets dictionary.
	 */
	exports.restrictFieldSets = restrictFieldSets;
	
	/**
	 * The debug link to pricing summary information requires the current applicant
	 * data in order to pass it along to the fetch price endpoint, to get accurate
	 * pricing. We store that in local storage (just a copy of the current applicant struct).
	 */
	exports.savePriceSummaryLinkInformation = savePriceSummaryLinkInformation;
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var rebateTable = [{
	    range: [0, 65],
	    tiers: [27.82, 18.547, 9.273, 0]
	}, {
	    range: [65, 70],
	    tiers: [32.457, 23.184, 13.91, 0]
	}, {
	    range: [70, 200],
	    tiers: [37.094, 27.82, 18.547, 0]
	}];
	function calculateRebateAge(_ref) {
	    var age = _ref.age;
	    var dob = _ref.dob;
	
	    return age || calculateAge(dob);
	}
	
	function calculateCombinedRebateAge(applicant) {
	    var age = calculateRebateAge(applicant.personal);
	
	    // If a partner is specified, use the oldest of the two ages for rebate purposes
	    if (applicant.hasPartner() && _.get(applicant, "partner.dob", false)) {
	        var partnerAge = calculateRebateAge(applicant.partner);
	        age = Math.max(age, partnerAge);
	    }
	
	    return age;
	}
	
	function calcRebate(applicant, AonApplicationService) {
	    if (!applicant.policy.federal_rebate) {
	        return 0;
	    }
	
	    var age = calculateCombinedRebateAge(applicant, AonApplicationService);
	    var tier = applicant.policy.rebate_tier;
	
	    // The rebate tier matrix is used in 'operator' mode, operator explicitly
	    // selects the age range
	    if (_.get(applicant.policy, "rebate_tier_matrix", false) !== false) {
	        return rebateTable[applicant.policy.rebate_tier_age_index].tiers[tier] / 100;
	    }
	
	    for (var i = 0; i < rebateTable.length; i++) {
	        if (age >= rebateTable[i].range[0] && age < rebateTable[i].range[1]) {
	            return rebateTable[i].tiers[tier] / 100;
	        }
	    }
	}
	
	;
	
	function calculate2Age(dob) {
	    var options = arguments[1] === undefined ? { financialYear: true } : arguments[1];
	
	    if (!dob) {
	        return null;
	    }
	    var now = options.financialYear ? getLastFinancialYearEndDate() : getCurrentDate();
	
	    var _dob$split = dob.split("-");
	
	    var _dob$split2 = _slicedToArray(_dob$split, 3);
	
	    var year = _dob$split2[0];
	    var month = _dob$split2[1];
	    var day = _dob$split2[2];
	
	    var birthDate = new Date(year, month, day, 0, 0, 0);
	    var age = now.getFullYear() - birthDate.getFullYear();
	    var m = now.getMonth() - birthDate.getMonth();
	    if (m < 0 || m === 0 && now.getDate() < birthDate.getDate()) {
	        age--;
	    }
	    return age;
	}
	
	;
	
	function determineLHCBaseDate(dob) {
	    if (!dob) {
	        return null;
	    }
	    var baseDate = getLastFinancialYearEndDate();
	
	    var age = calculate2Age(dob, { financialYear: false });
	
	    var _dob$split = dob.split("-");
	
	    var _dob$split2 = _slicedToArray(_dob$split, 3);
	
	    var year = _dob$split2[0];
	    var month = _dob$split2[1];
	    var day = _dob$split2[2];
	
	    var birthDate = new Date(year, month, day, 0, 0, 0);
	    var now = getCurrentDate();
	    var yearDiff = now.getFullYear() - birthDate.getFullYear();
	
	    if (age > 31) {
	        return baseDate;
	    }
	
	    if (age == 31) {
	        if (birthDate.getMonth() > 6) {
	            return new Date(baseDate.getFullYear() + 1, baseDate.getMonth(), baseDate.getDate(), 0, 0, 0);
	        } else if (birthDate.getMonth() <= 6) {
	            if (yearDiff == 31) {
	                return new Date(baseDate.getFullYear() + 1, baseDate.getMonth(), baseDate.getDate(), 0, 0, 0);
	            }
	        }return baseDate;
	    }
	
	    return baseDate;
	}
	
	function doesLHCApply(dob) {
	    // If born before Jul 1, 1934, there is no LHC
	    var born = new Date(dob);
	    var cutoff = new Date("1934-07-01");
	    if (cutoff.getTime() > born.getTime()) {
	        return false;
	    }
	    var age = calculate2Age(dob, { financialYear: true });
	
	    if (age <= 30) {
	        return false;
	    }
	    if (age > 31) {
	        return true;
	    }
	
	    if (age == 31) {
	        var baseDay = determineLHCBaseDate(dob);
	        var birthdayThisYear = new Date(new Date().getFullYear(), born.getMonth(), born.getDate(), 0, 0, 0);
	        if (birthdayThisYear > baseDay) {
	            return true;
	        } else {
	            return false;
	        }
	    }
	}
	
	;
	
	function calcAgeFrom(dateFrom, dob) {
	    if (!dob) {
	        return null;
	    }
	
	    var _dob$split = dob.split("-");
	
	    var _dob$split2 = _slicedToArray(_dob$split, 3);
	
	    var year = _dob$split2[0];
	    var month = _dob$split2[1];
	    var day = _dob$split2[2];
	
	    var birthDate = new Date(year, month, day, 0, 0, 0);
	    var age = dateFrom.getFullYear() - birthDate.getFullYear();
	    var m = dateFrom.getMonth() - birthDate.getMonth();
	    if (m < 0 || m === 0 & dateFrom.getDate() < birthDate.getDate()) {
	        age--;
	    }
	    return age;
	}
	
	function getLastFinancialYearEndDate() {
	    var now = new Date();
	    var isAfterJuly1st = now.getMonth() >= 6 && now.getDate() >= 1;
	    var finYear = now.getFullYear() - (isAfterJuly1st ? 0 : 1);
	    return new Date(finYear, 6, 1, 0, 0, 0);
	}
	
	function getCurrentDate() {
	    var now = new Date();
	    return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 0, 0);
	}
	
	function getLastFinancialYearBaseDate() {
	    var now = new Date();
	    var isAfterJuly1st = now.getMonth() >= 6 && now.getDate() >= 1;
	    var finYear = now.getFullYear() - (isAfterJuly1st ? 0 : 1);
	    return new Date(finYear, 7, 1, 0, 0, 0);
	}
	
	function calculateAge(dob) {
	    var options = arguments[1] === undefined ? { financialYear: true } : arguments[1];
	
	    if (!dob) {
	        return null;
	    }
	    var now = options.financialYear ? getLastFinancialYearEndDate() : getCurrentDate();
	
	    var _dob$split = dob.split("-");
	
	    var _dob$split2 = _slicedToArray(_dob$split, 3);
	
	    var year = _dob$split2[0];
	    var month = _dob$split2[1];
	    var day = _dob$split2[2];
	
	    var birthDate = new Date(year, month - 1, day, 0, 0, 0);
	    var ageDiffMs = now - birthDate.getTime();
	    var ageDate = new Date(ageDiffMs); // miliseconds from epoch
	
	    return Math.abs(ageDate.getUTCFullYear() - 1970);
	}
	
	;
	function calculateLHCAge(dob) {
	
	    var age = calculate2Age(dob, { financialYear: false });
	    if (age == null) {
	        return null;
	    }
	
	    var _dob$split = dob.split("-");
	
	    var _dob$split2 = _slicedToArray(_dob$split, 3);
	
	    var year = _dob$split2[0];
	    var month = _dob$split2[1];
	    var day = _dob$split2[2];
	
	    var birthDate = new Date(year, month - 1, day, 0, 0, 0);
	    var now = getLastFinancialYearEndDate();
	    var yearDiff = Math.abs(birthDate.getUTCFullYear() - now.getUTCFullYear());
	    var baseDate = undefined;
	    if (age == 31) {
	        if (yearDiff != 32) {
	            if (birthDate.getMonth() + 1 >= 7) {
	                baseDate = new Date(now.getFullYear() + 1, 7, 1, 0, 0, 0);
	            } else {
	                baseDate = new Date(now.getFullYear(), 7, 1, 0, 0, 0);
	            }
	        } else {
	            baseDate = new Date(now.getFullYear(), 7, 1, 0, 0, 0);
	        }
	        if (now < baseDate) {
	            age -= 1;
	        }
	    }
	    age = age > 65 ? 65 : age;
	    return age;
	}
	
	;
	
	function calcLHC(applicant, AonApplicationService) {
	
	    var result = {
	        totalLHC: 0,
	        primaryLHC: "N/A",
	        primaryAge: "N/A",
	        partnerLHC: "N/A",
	        partnerAge: "N/A"
	    };
	
	    // LHC does not apply to only extras cover
	    if (applicant.policy.cover_type == 1) {
	        return result;
	    }
	
	    if (!applicant.personal.dob) {
	        return result;
	    }
	
	    var ageToLHC = function (age) {
	        return Math.min(Math.max(0, age - 30) * 0.02, 0.7);
	    };
	
	    // If LHC age is supplied, use that instead of DOB:
	    var supplied_lhc_age = _.get(applicant, "policy.lhc_age", null);
	    var supplied_lhc_age_partner = _.get(applicant, "policy.lhc_age_partner", null);
	    // primaryAge doesn't seem to be used anywhere other than in calculation of primaryLHC, despite being returned from this function
	    var lhcBaseDate = determineLHCBaseDate(applicant.personal.dob);
	    var primaryAge = supplied_lhc_age ? supplied_lhc_age : calcAgeFrom(lhcBaseDate, applicant.personal.dob);
	    var primaryLHC = doesLHCApply(applicant.personal.dob) ? ageToLHC(primaryAge) : 0;
	    result.primaryAge = primaryAge;
	    result.primaryLHC = primaryLHC;
	    var totalLHC = primaryLHC;
	    if (applicant.hasPartner()) {
	        // Average the loading between the primary and partner
	        var partnerLhcBaseDate = determineLHCBaseDate(applicant.partner.dob);
	        var partnerAge = supplied_lhc_age_partner !== null ? supplied_lhc_age_partner : (partnerLhcBaseDate, applicant.partner.dob);
	        var partnerLHC = doesLHCApply(applicant.partner.dob) ? ageToLHC(partnerAge) : 0;
	        totalLHC = (partnerLHC + primaryLHC) / 2;
	        result.partnerAge = partnerAge;
	        result.partnerLHC = partnerLHC;
	    }
	
	    result.totalLHC = totalLHC;
	    return result;
	}
	
	;
	
	function checkDirectDebitDiscountForPrice(price, pricePackage) {
	    // If DD discount is available, the discounts on the DD pricing will be more than normal pricing
	    if (price.pricing === undefined) {
	        return;
	    }
	    var dd_discounts = [];
	    var discounts = [];
	    try {
	        var pricing = price.pricing.available;
	        discounts = pricing.monthly_adjusted_price.discounts;
	        dd_discounts = pricing.monthly_adjusted_price_dd_discount.discounts;
	    } catch (e) {}
	    var hasDirectDebitDiscount = dd_discounts.length > discounts.length;
	    if (hasDirectDebitDiscount) {
	        pricePackage.hasDirectDebitDiscount = true;
	        pricePackage.apply_direct_debit_discount = true;
	        return;
	    }
	}
	function applyDirectDebitDiscount(pricePackage) {
	    pricePackage.hasDirectDebitDiscount = false;
	    if (pricePackage.prices !== undefined) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = pricePackage.prices[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var price = _step.value;
	
	                checkDirectDebitDiscountForPrice(price, pricePackage);
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator["return"]) {
	                    _iterator["return"]();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	    } else if (pricePackage.price !== undefined) {
	        checkDirectDebitDiscountForPrice(pricePackage.price, pricePackage);
	    }
	}
	
	function priceCalculations(pricePackage, rebatePercentage, healthCoverLoading, paymentFrequency) {
	    for (var i = 0; i < pricePackage.prices.length; i++) {
	        var premium = parseFloat(pricePackage.prices[i].gross_monthly_full_premium);
	        var lhcBase = parseFloat(pricePackage.prices[i].gross_monthly_lhc);
	
	        if (paymentFrequency !== null && paymentFrequency === "fortnightly") {
	            premium = parseFloat(pricePackage.prices[i].gross_fortnightly_full_premium);
	            lhcBase = parseFloat(pricePackage.prices[i].gross_fortnightly_lhc);
	        }
	
	        if (lhcBase === 0) {
	            lhcBase = premium;
	        }
	
	        // Include discounts
	        var discounted_premium = premium;
	        var calculations = {
	            discounts: [] };
	        var dd_discount = _.get(pricePackage, "apply_direct_debit_discount", false);
	
	        for (var d = 0; d < pricePackage.discounts.length; d++) {
	            var discount = pricePackage.discounts[d];
	            if (discount.is_direct_debit && !dd_discount) {
	                continue;
	            }
	
	            var discountDollars = 0;
	            if (discount.is_absolute) {
	                discountDollars = discount.value;
	            } else {
	                // Percentage discount
	                discountDollars = discount.value / 100 * premium;
	            }
	            discounted_premium -= discountDollars;
	            // Track discounts which are applied
	            discount.dollarAmount = discountDollars;
	            calculations.discounts.push(discount);
	        }
	
	        calculations.paymentFrequency = paymentFrequency || "monthly";
	        calculations.basePremium = premium;
	        calculations.discountedPremium = discounted_premium;
	        calculations.rebatePercent = rebatePercentage * 100;
	        calculations.rebateAmount = discounted_premium * rebatePercentage;
	        calculations.priceWithRebate = discounted_premium - calculations.rebateAmount;
	        calculations.lhcPercent = healthCoverLoading.totalLHC * 100;
	        calculations.lhcAmount = lhcBase * healthCoverLoading.totalLHC;
	        calculations.lhcBreakdown = "Primary: " + (healthCoverLoading.primaryLHC !== "N/A" ? healthCoverLoading.primaryLHC * 100 + "%" : healthCoverLoading.primaryLHC) + " Partner: " + (healthCoverLoading.partnerLHC !== "N/A" ? healthCoverLoading.partnerLHC * 100 + "%" : healthCoverLoading.partnerLHC);
	        calculations.priceWithLHC = discounted_premium + calculations.lhcAmount;
	        calculations.totalPrice = discounted_premium + calculations.lhcAmount - calculations.rebateAmount;
	        pricePackage.prices[i].calculations = calculations;
	    }
	}
	
	;
	
	function splitServicesIntoColumns(services) {
	    var splitToKeys = function (col, keys) {
	        var parts = _.chunk(col, Math.ceil(col.length / keys.length));
	        return _.zipObject(keys, parts);
	    };
	
	    var visible = function (service) {
	        return service.visible;
	    };
	
	    return {
	        hospital: splitToKeys(services.hospital.filter(visible).sort(function (a, b) {
	            return b.sort_order - a.sort_order;
	        }), ["left", "right"]),
	        ancillary: splitToKeys(services.ancillary.filter(visible).sort(function (a, b) {
	            return b.sort_order - a.sort_order;
	        }), ["left", "right"]) };
	}
	
	function applicantWithDOB(applicant) {
	    var applicantData = _.cloneDeep(applicant);
	    var federalRebate = _.get(applicantData, "policy.federal_rebate", false);
	    var rebateTierAgeIndex = _.get(applicantData, "policy.rebate_tier_age_index", 0);
	    if (_.get(applicantData, "personal.dob", null) === null && federalRebate) {
	        var dobFromAge = function (age) {
	            var dob = new Date();
	            dob.setYear(dob.getFullYear() - age);
	            return [dob.getFullYear(), dob.getMonth() + 1, dob.getDate()].join("-");
	        };
	        var rebateTierAge = [30, 67, 80];
	        applicantData.personal.dob = dobFromAge(rebateTierAge[rebateTierAgeIndex]);
	    }
	    return applicantData;
	}
	
	;
	function getProductFeatures(pricePackage, services, productServices) {
	    var productFeatures = {};
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = services[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            (function () {
	                var feature = _step.value;
	
	                productFeatures[feature.id] = _(productServices).filter(function (productService) {
	                    return productService.service === feature.id;
	                }).first();
	            })();
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator["return"]) {
	                _iterator["return"]();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return productFeatures;
	}
	
	function getPaymentFrequencyKey(frequency) {
	    var jsConstants = window.__APP_CONTEXT__.jsConstants;
	    return Object.keys(jsConstants.PaymentFrequencies).find(function (key) {
	        return jsConstants.PaymentFrequencies[key] === frequency;
	    });
	}
	
	function getPaymentFrequencyOptionFromKey(key) {
	    return key.toLowerCase().replace(/[^a-z]/, "");
	}
	
	function getPricingForFrequency(pkg, which, frequency, directDebitDiscount, noDiscounts) {
	    if (!pkg.selectedPrice.pricing.hasOwnProperty(which)) {
	        return null;
	    }
	
	    // Convert a numeric payment frequency into a key into the pricing information structure
	    var paymentFrequency = getPaymentFrequencyOptionFromKey(getPaymentFrequencyKey(frequency));
	    var pricingKey = "" + paymentFrequency + "_adjusted_price";
	    var pricingKeySuffix = directDebitDiscount ? "_dd_discount" : noDiscounts ? "_no_discounts" : "";
	    var pricing = pkg.selectedPrice.pricing[which];
	    var finalPricingKey = "" + pricingKey + "" + pricingKeySuffix;
	    return pricing[finalPricingKey];
	}
	
	function getDiscountCodeRestrictions(code) {
	    var formChoices = window.__APP_CONTEXT__.formChoices;
	    return formChoices.discount_code_restrictions[code];
	}
	
	function restrictFieldSets(applicant, fieldSets) {
	    var selectedDiscount = _.get(applicant, "policy.discount_code");
	    var restrictions = getDiscountCodeRestrictions(selectedDiscount);
	    if (restrictions) {
	        var frequencyRestriction = restrictions.payment_frequency;
	        if (Number.isFinite(frequencyRestriction)) {
	            _.set(fieldSets, "payment.frequency.choices", [[frequencyRestriction, getPaymentFrequencyKey(frequencyRestriction)]]);
	        }
	    }
	}
	
	function savePriceSummaryLinkInformation(application) {
	    window.localStorage.setItem("price-summary-application", JSON.stringify(application));
	}
	
	// if the relevant pricing attributes cannot be retrieved, will return that no dd discount is available

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(10),
	    isLength = __webpack_require__(6),
	    isObjectLike = __webpack_require__(8);
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	module.exports = isArray;


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(4);
	
	/**
	 * Converts `value` to an object if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Object} Returns the object.
	 */
	function toObject(value) {
	  return isObject(value) ? value : Object(value);
	}
	
	module.exports = toObject;


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(25),
	    isLength = __webpack_require__(6);
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 8 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(10),
	    isArrayLike = __webpack_require__(7),
	    isObject = __webpack_require__(4),
	    shimKeys = __webpack_require__(212);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object != 'function' && isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	module.exports = keys;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var isNative = __webpack_require__(214);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(196),
	    baseMatchesProperty = __webpack_require__(197),
	    bindCallback = __webpack_require__(22),
	    identity = __webpack_require__(32),
	    property = __webpack_require__(220);
	
	/**
	 * The base implementation of `_.callback` which supports specifying the
	 * number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {*} [func=_.identity] The value to convert to a callback.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function baseCallback(func, thisArg, argCount) {
	  var type = typeof func;
	  if (type == 'function') {
	    return thisArg === undefined
	      ? func
	      : bindCallback(func, thisArg, argCount);
	  }
	  if (func == null) {
	    return identity;
	  }
	  if (type == 'object') {
	    return baseMatches(func);
	  }
	  return thisArg === undefined
	    ? property(func)
	    : baseMatchesProperty(func, thisArg);
	}
	
	module.exports = baseCallback;


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	/**
	 * Converts `value` to a string if it's not one. An empty string is returned
	 * for `null` or `undefined` values.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  return value == null ? '' : (value + '');
	}
	
	module.exports = baseToString;


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	module.exports = isIndex;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var assignWith = __webpack_require__(186),
	    baseAssign = __webpack_require__(187),
	    createAssigner = __webpack_require__(202);
	
	/**
	 * Assigns own enumerable properties of source object(s) to the destination
	 * object. Subsequent sources overwrite property assignments of previous sources.
	 * If `customizer` is provided it's invoked to produce the assigned values.
	 * The `customizer` is bound to `thisArg` and invoked with five arguments:
	 * (objectValue, sourceValue, key, object, source).
	 *
	 * **Note:** This method mutates `object` and is based on
	 * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
	 *
	 * @static
	 * @memberOf _
	 * @alias extend
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	 * // => { 'user': 'fred', 'age': 40 }
	 *
	 * // using a customizer callback
	 * var defaults = _.partialRight(_.assign, function(value, other) {
	 *   return _.isUndefined(value) ? other : value;
	 * });
	 *
	 * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	 * // => { 'user': 'barney', 'age': 36 }
	 */
	var assign = createAssigner(function(object, source, customizer) {
	  return customizer
	    ? assignWith(object, source, customizer)
	    : baseAssign(object, source);
	});
	
	module.exports = assign;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(184),
	    baseCallback = __webpack_require__(11),
	    baseMap = __webpack_require__(195),
	    isArray = __webpack_require__(3);
	
	/**
	 * Creates an array of values by running each element in `collection` through
	 * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * If a property name is provided for `iteratee` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `iteratee` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
	 * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
	 * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
	 * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
	 * `sum`, `uniq`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @alias collect
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function timesThree(n) {
	 *   return n * 3;
	 * }
	 *
	 * _.map([1, 2], timesThree);
	 * // => [3, 6]
	 *
	 * _.map({ 'a': 1, 'b': 2 }, timesThree);
	 * // => [3, 6] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // using the `_.property` callback shorthand
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee, thisArg) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  iteratee = baseCallback(iteratee, thisArg, 3);
	  return func(collection, iteratee);
	}
	
	module.exports = map;


/***/ }),
/* 16 */
/***/ (function(module, exports) {

	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as an array.
	 *
	 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/Web/JavaScript/Reference/Functions/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.restParam(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function restParam(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        rest = Array(length);
	
	    while (++index < length) {
	      rest[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, rest);
	      case 1: return func.call(this, args[0], rest);
	      case 2: return func.call(this, args[0], args[1], rest);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = rest;
	    return func.apply(this, otherArgs);
	  };
	}
	
	module.exports = restParam;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(192),
	    createBaseEach = __webpack_require__(203);
	
	/**
	 * The base implementation of `_.forEach` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object|string} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(5);
	
	/**
	 * The base implementation of `get` without support for string paths
	 * and default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path of the property to get.
	 * @param {string} [pathKey] The key representation of path.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path, pathKey) {
	  if (object == null) {
	    return;
	  }
	  if (pathKey !== undefined && pathKey in toObject(object)) {
	    path = [pathKey];
	  }
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[path[index++]];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var indexOfNaN = __webpack_require__(211);
	
	/**
	 * The base implementation of `_.indexOf` without support for binary searches.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return indexOfNaN(array, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseIndexOf;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(193),
	    isObject = __webpack_require__(4),
	    isObjectLike = __webpack_require__(8);
	
	/**
	 * The base implementation of `_.isEqual` without support for `this` binding
	 * `customizer` functions.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 21 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(32);
	
	/**
	 * A specialized version of `baseCallback` which only supports `this` binding
	 * and specifying the number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function bindCallback(func, thisArg, argCount) {
	  if (typeof func != 'function') {
	    return identity;
	  }
	  if (thisArg === undefined) {
	    return func;
	  }
	  switch (argCount) {
	    case 1: return function(value) {
	      return func.call(thisArg, value);
	    };
	    case 3: return function(value, index, collection) {
	      return func.call(thisArg, value, index, collection);
	    };
	    case 4: return function(accumulator, value, index, collection) {
	      return func.call(thisArg, accumulator, value, index, collection);
	    };
	    case 5: return function(value, other, key, object, source) {
	      return func.call(thisArg, value, other, key, object, source);
	    };
	  }
	  return function() {
	    return func.apply(thisArg, arguments);
	  };
	}
	
	module.exports = bindCallback;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(4);
	
	/**
	 * Checks if `value` is in `cache` mimicking the return signature of
	 * `_.indexOf` by returning `0` if the value is found, else `-1`.
	 *
	 * @private
	 * @param {Object} cache The cache to search.
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `0` if `value` is found, else `-1`.
	 */
	function cacheIndexOf(cache, value) {
	  var data = cache.data,
	      result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	  return result ? 0 : -1;
	}
	
	module.exports = cacheIndexOf;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var SetCache = __webpack_require__(182),
	    getNative = __webpack_require__(10);
	
	/** Native method references. */
	var Set = getNative(global, 'Set');
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = getNative(Object, 'create');
	
	/**
	 * Creates a `Set` cache object to optimize linear searches of large arrays.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	 */
	function createCache(values) {
	  return (nativeCreate && Set) ? new SetCache(values) : null;
	}
	
	module.exports = createCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(21);
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	module.exports = getLength;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(7),
	    isIndex = __webpack_require__(13),
	    isObject = __webpack_require__(4);
	
	/**
	 * Checks if the provided arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	      ? (isArrayLike(object) && isIndex(index, object.length))
	      : (type == 'string' && index in object)) {
	    var other = object[index];
	    return value === value ? (value === other) : (other !== other);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(3),
	    toObject = __webpack_require__(5);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  var type = typeof value;
	  if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	    return true;
	  }
	  if (isArray(value)) {
	    return false;
	  }
	  var result = !reIsDeepProp.test(value);
	  return result || (object != null && value in toObject(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(4);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(12),
	    isArray = __webpack_require__(3);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `value` to property path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Array} Returns the property path array.
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return value;
	  }
	  var result = [];
	  baseToString(value).replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	}
	
	module.exports = toPath;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(7),
	    isObjectLike = __webpack_require__(8);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Native method references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is classified as an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  return isObjectLike(value) && isArrayLike(value) &&
	    hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	}
	
	module.exports = isArguments;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(4);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 which returns 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 32 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            ss : '%d sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	})));


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arDz;
	
	})));


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '1',
	        '2': '2',
	        '3': '3',
	        '4': '4',
	        '5': '5',
	        '6': '6',
	        '7': '7',
	        '8': '8',
	        '9': '9',
	        '0': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss : '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return ar;
	
	})));


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyə',
	            ss : '%d saniyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return az;
	
	})));


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return be;
	
	})));


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return bg;
	
	})));


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bm = moment.defineLocale('bm', {
	        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'MMMM [tile] D [san] YYYY',
	            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bi lɛrɛ] LT',
	            nextDay : '[Sini lɛrɛ] LT',
	            nextWeek : 'dddd [don lɛrɛ] LT',
	            lastDay : '[Kunu lɛrɛ] LT',
	            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s kɔnɔ',
	            past : 'a bɛ %s bɔ',
	            s : 'sanga dama dama',
	            ss : 'sekondi %d',
	            m : 'miniti kelen',
	            mm : 'miniti %d',
	            h : 'lɛrɛ kelen',
	            hh : 'lɛrɛ %d',
	            d : 'tile kelen',
	            dd : 'tile %d',
	            M : 'kalo kelen',
	            MM : 'kalo %d',
	            y : 'san kelen',
	            yy : 'san %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return bm;
	
	})));


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            ss : '%d সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            ss : '%d སྐར་ཆ།',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            ss : '%d eilenn',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	})));


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	            isFormat: /D[oD]?(\s)+MMMM/
	        },
	        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [de] YYYY',
	            ll : 'D MMM YYYY',
	            LLL : 'D MMMM [de] YYYY [a les] H:mm',
	            lll : 'D MMM YYYY, H:mm',
	            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll : 'ddd D MMM YYYY, H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'd\'aquí %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            ss : '%d segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	
	    var monthsParse = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i];
	    // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	    var monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex : /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex : /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm',
	            l : 'D. M. YYYY'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            ss : '%d ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay : '[i dag kl.] LT',
	            nextDay : '[i morgen kl.] LT',
	            nextWeek : 'på dddd [kl.] LT',
	            lastDay : '[i går kl.] LT',
	            lastWeek : '[i] dddd[s kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            ss : '%d sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	})));


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	})));


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];
	
	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {
	
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            ss : 'd% ސިކުންތު',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return dv;
	
	})));


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            ss : '%d δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	})));


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enSG = moment.defineLocale('en-SG', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enSG;
	
	})));


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enAu = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enCa = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enGb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIe = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIl = moment.defineLocale('en-il', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enNz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-a de] MMMM, YYYY',
	            LLL : 'D[-a de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'post %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            ss : '%d sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return eo;
	
	})));


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'MM/DD/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	})));


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'ss': [number + 'sekundi', number + 'sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	})));


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            ss : '%d segundo',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چند ثانیه',
	            ss : 'ثانیه d%',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                return isFuture ? 'sekunnin' : 'sekuntia';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            ss : '%d sekundir',
	            m : 'ein minuttur',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaður',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        }
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            ss : '%d sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	    var months = [
	        'Eanáir', 'Feabhra', 'Márta', 'Aibreán', 'Bealtaine', 'Méitheamh', 'Iúil', 'Lúnasa', 'Meán Fómhair', 'Deaireadh Fómhair', 'Samhain', 'Nollaig'
	    ];
	
	    var monthsShort = ['Eaná', 'Feab', 'Márt', 'Aibr', 'Beal', 'Méit', 'Iúil', 'Lúna', 'Meán', 'Deai', 'Samh', 'Noll'];
	
	    var weekdays = ['Dé Domhnaigh', 'Dé Luain', 'Dé Máirt', 'Dé Céadaoin', 'Déardaoin', 'Dé hAoine', 'Dé Satharn'];
	
	    var weekdaysShort = ['Dom', 'Lua', 'Mái', 'Céa', 'Déa', 'hAo', 'Sat'];
	
	    var weekdaysMin = ['Do', 'Lu', 'Má', 'Ce', 'Dé', 'hA', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné aig] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d mí',
	            y: 'bliain',
	            yy: '%d bliain'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ga;
	
	})));


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];
	
	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            ss : '%d diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gd;
	
	})));


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['thodde secondanim', 'thodde second'],
	            'ss': [number + ' secondanim', number + ' second'],
	            'm': ['eka mintan', 'ek minute'],
	            'mm': [number + ' mintanim', number + ' mintam'],
	            'h': ['eka voran', 'ek vor'],
	            'hh': [number + ' voranim', number + ' voram'],
	            'd': ['eka disan', 'ek dis'],
	            'dd': [number + ' disanim', number + ' dis'],
	            'M': ['eka mhoinean', 'ek mhoino'],
	            'MM': [number + ' mhoineanim', number + ' mhoine'],
	            'y': ['eka vorsan', 'ek voros'],
	            'yy': [number + ' vorsanim', number + ' vorsam']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'A h:mm [vazta]',
	            LTS : 'A h:mm:ss [vazta]',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY A h:mm [vazta]',
	            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	        },
	        calendar : {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Ieta to] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fatlo] dddd[,] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s',
	            past : '%s adim',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /rati|sokalli|donparam|sanje/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokalli') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokalli';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        }
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	            '1': '૧',
	            '2': '૨',
	            '3': '૩',
	            '4': '૪',
	            '5': '૫',
	            '6': '૬',
	            '7': '૭',
	            '8': '૮',
	            '9': '૯',
	            '0': '૦'
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0'
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પેહલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ'
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            ss : '%d שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });
	
	    return he;
	
	})));


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            ss : '%d सेकंड',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            ss : '%d վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            ss : '%d detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return id;
	
	})));


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	})));


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var itCh = moment.defineLocale('it-ch', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return itCh;
	
	})));


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	})));


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日 dddd HH:mm',
	            l : 'YYYY/MM/DD',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日(ddd) HH:mm'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : function (now) {
	                if (now.week() < this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay : '[昨日] LT',
	            lastWeek : function (now) {
	                if (this.week() < now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            ss : '%d秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            ss : '%d detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return jv;
	
	})));


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            ss : '%d წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            ss : '%d секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return kk;
	
	})));


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '១',
	        '2': '២',
	        '3': '៣',
	        '4': '៤',
	        '5': '៥',
	        '6': '៦',
	        '7': '៧',
	        '8': '៨',
	        '9': '៩',
	        '0': '០'
	    }, numberMap = {
	        '១': '1',
	        '២': '2',
	        '៣': '3',
	        '៤': '4',
	        '៥': '5',
	        '៦': '6',
	        '៧': '7',
	        '៨': '8',
	        '៩': '9',
	        '០': '0'
	    };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
	        ordinal : 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	})));


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '೧',
	        '2': '೨',
	        '3': '೩',
	        '4': '೪',
	        '5': '೫',
	        '6': '೬',
	        '7': '೭',
	        '8': '೮',
	        '9': '೯',
	        '0': '೦'
	    },
	    numberMap = {
	        '೧': '1',
	        '೨': '2',
	        '೩': '3',
	        '೪': '4',
	        '೫': '5',
	        '೬': '6',
	        '೭': '7',
	        '೮': '8',
	        '೯': '9',
	        '೦': '0'
	    };
	
	    var kn = moment.defineLocale('kn', {
	        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[ಇಂದು] LT',
	            nextDay : '[ನಾಳೆ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ನಿನ್ನೆ] LT',
	            lastWeek : '[ಕೊನೆಯ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ನಂತರ',
	            past : '%s ಹಿಂದೆ',
	            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss : '%d ಸೆಕೆಂಡುಗಳು',
	            m : 'ಒಂದು ನಿಮಿಷ',
	            mm : '%d ನಿಮಿಷ',
	            h : 'ಒಂದು ಗಂಟೆ',
	            hh : '%d ಗಂಟೆ',
	            d : 'ಒಂದು ದಿನ',
	            dd : '%d ದಿನ',
	            M : 'ಒಂದು ತಿಂಗಳು',
	            MM : '%d ತಿಂಗಳು',
	            y : 'ಒಂದು ವರ್ಷ',
	            yy : '%d ವರ್ಷ'
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal : function (number) {
	            return number + 'ನೇ';
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h:mm',
	            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	            l : 'YYYY.MM.DD.',
	            ll : 'YYYY년 MMMM D일',
	            lll : 'YYYY년 MMMM D일 A h:mm',
	            llll : 'YYYY년 MMMM D일 dddd A h:mm'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '1분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    },
	    months = [
	        'کانونی دووەم',
	        'شوبات',
	        'ئازار',
	        'نیسان',
	        'ئایار',
	        'حوزەیران',
	        'تەمموز',
	        'ئاب',
	        'ئەیلوول',
	        'تشرینی یەكەم',
	        'تشرینی دووەم',
	        'كانونی یەکەم'
	    ];
	
	
	    var ku = moment.defineLocale('ku', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysShort : 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar : {
	            sameDay : '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay : '[به‌یانی كاتژمێر] LT',
	            nextWeek : 'dddd [كاتژمێر] LT',
	            lastDay : '[دوێنێ كاتژمێر] LT',
	            lastWeek : 'dddd [كاتژمێر] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'له‌ %s',
	            past : '%s',
	            s : 'چه‌ند چركه‌یه‌ك',
	            ss : 'چركه‌ %d',
	            m : 'یه‌ك خوله‌ك',
	            mm : '%d خوله‌ك',
	            h : 'یه‌ك كاتژمێر',
	            hh : '%d كاتژمێر',
	            d : 'یه‌ك ڕۆژ',
	            dd : '%d ڕۆژ',
	            M : 'یه‌ك مانگ',
	            MM : '%d مانگ',
	            y : 'یه‌ك ساڵ',
	            yy : '%d ساڵ'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return ku;
	
	})));


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кечээ саат] LT',
	            lastWeek : '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            ss : '%d секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ky;
	
	})));


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            ss : '%d Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss : '%d ວິນາທີ' ,
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss' : 'sekundė_sekundžių_sekundes',
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            ss : translate,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return me;
	
	})));


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return mk;
	
	})));


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            ss : '%d സെക്കൻഡ്',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
	        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY оны MMMMын D',
	            LLL : 'YYYY оны MMMMын D HH:mm',
	            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM : function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar : {
	            sameDay : '[Өнөөдөр] LT',
	            nextDay : '[Маргааш] LT',
	            nextWeek : '[Ирэх] dddd LT',
	            lastDay : '[Өчигдөр] LT',
	            lastWeek : '[Өнгөрсөн] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s дараа',
	            past : '%s өмнө',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        }
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'ss': output = '%d सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'ss': output = '%d सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var msMy = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return msMy;
	
	})));


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ms;
	
	})));


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mt = moment.defineLocale('mt', {
	        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
	        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
	        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Illum fil-]LT',
	            nextDay : '[Għada fil-]LT',
	            nextWeek : 'dddd [fil-]LT',
	            lastDay : '[Il-bieraħ fil-]LT',
	            lastWeek : 'dddd [li għadda] [fil-]LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'f’ %s',
	            past : '%s ilu',
	            s : 'ftit sekondi',
	            ss : '%d sekondi',
	            m : 'minuta',
	            mm : '%d minuti',
	            h : 'siegħa',
	            hh : '%d siegħat',
	            d : 'ġurnata',
	            dd : '%d ġranet',
	            M : 'xahar',
	            MM : '%d xhur',
	            y : 'sena',
	            yy : '%d sni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss : '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return my;
	
	})));


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            ss : '%d sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            ss : '%d सेकेण्ड',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            ss : '%d sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : '[ਅਗਲਾ] dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            ss : '%d ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix  ? 'godzina'  : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'poucos segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'ss': 'secunde',
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            ss : relativeTimeWithPlural,
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., H:mm',
	            LLLL : 'dddd, D MMMM YYYY г., H:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوري',
	        'فيبروري',
	        'مارچ',
	        'اپريل',
	        'مئي',
	        'جون',
	        'جولاءِ',
	        'آگسٽ',
	        'سيپٽمبر',
	        'آڪٽوبر',
	        'نومبر',
	        'ڊسمبر'
	    ];
	    var days = [
	        'آچر',
	        'سومر',
	        'اڱارو',
	        'اربع',
	        'خميس',
	        'جمع',
	        'ڇنڇر'
	    ];
	
	    var sd = moment.defineLocale('sd', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[اڄ] LT',
	            nextDay : '[سڀاڻي] LT',
	            nextWeek : 'dddd [اڳين هفتي تي] LT',
	            lastDay : '[ڪالهه] LT',
	            lastWeek : '[گزريل هفتي] dddd [تي] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s پوء',
	            past : '%s اڳ',
	            s : 'چند سيڪنڊ',
	            ss : '%d سيڪنڊ',
	            m : 'هڪ منٽ',
	            mm : '%d منٽ',
	            h : 'هڪ ڪلاڪ',
	            hh : '%d ڪلاڪ',
	            d : 'هڪ ڏينهن',
	            dd : '%d ڏينهن',
	            M : 'هڪ مهينو',
	            MM : '%d مهينا',
	            y : 'هڪ سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sd;
	
	})));


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return se;
	
	})));


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            ss : 'තත්පර %d',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	})));


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            ss : '%d sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	})));


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ss = moment.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            ss : '%d mzuzwana',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            ss : '%d sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	})));


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            ss : 'sekunde %d',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            ss : '%d விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            ss : '%d సెకన్లు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return te;
	
	})));


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tet = moment.defineLocale('tet', {
	        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'iha %s',
	            past : '%s liuba',
	            s : 'minutu balun',
	            ss : 'minutu %d',
	            m : 'minutu ida',
	            mm : 'minutu %d',
	            h : 'oras ida',
	            hh : 'oras %d',
	            d : 'loron ida',
	            dd : 'loron %d',
	            M : 'fulan ida',
	            MM : 'fulan %d',
	            y : 'tinan ida',
	            yy : 'tinan %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tet;
	
	})));


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум'
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
	        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Имрӯз соати] LT',
	            nextDay : '[Пагоҳ соати] LT',
	            lastDay : '[Дирӯз соати] LT',
	            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'баъди %s',
	            past : '%s пеш',
	            s : 'якчанд сония',
	            m : 'як дақиқа',
	            mm : '%d дақиқа',
	            h : 'як соат',
	            hh : '%d соат',
	            d : 'як рӯз',
	            dd : '%d рӯз',
	            M : 'як моҳ',
	            MM : '%d моҳ',
	            y : 'як сол',
	            yy : '%d сол'
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1th is the first week of the year.
	        }
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H:mm',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            ss : '%d วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	})));


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            ss : '%d segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlPh;
	
	})));


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'leS' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'waQ' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'nem' :
	        time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'Hu’' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'wen' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'ben' :
	        time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	        ten = Math.floor((number % 100) / 10),
	        one = number % 10,
	        word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            ss : translate,
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[gelecek] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            ss : '%d saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {  // special case for zero
	                        return number + '\'ıncı';
	                    }
	                    var a = number % 10,
	                        b = number % 100 - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'ss': [number + ' secunds', '' + number + ' secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }
	
	    return tzl;
	
	})));


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            ss : '%d imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            ss : '%d ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js language configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل'
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        };
	
	        if (m === true) {
	            return weekdays['nominative'].slice(1, 7).concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوری',
	        'فروری',
	        'مارچ',
	        'اپریل',
	        'مئی',
	        'جون',
	        'جولائی',
	        'اگست',
	        'ستمبر',
	        'اکتوبر',
	        'نومبر',
	        'دسمبر'
	    ];
	    var days = [
	        'اتوار',
	        'پیر',
	        'منگل',
	        'بدھ',
	        'جمعرات',
	        'جمعہ',
	        'ہفتہ'
	    ];
	
	    var ur = moment.defineLocale('ur', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[آج بوقت] LT',
	            nextDay : '[کل بوقت] LT',
	            nextWeek : 'dddd [بوقت] LT',
	            lastDay : '[گذشتہ روز بوقت] LT',
	            lastWeek : '[گذشتہ] dddd [بوقت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s بعد',
	            past : '%s قبل',
	            s : 'چند سیکنڈ',
	            ss : '%d سیکنڈ',
	            m : 'ایک منٹ',
	            mm : '%d منٹ',
	            h : 'ایک گھنٹہ',
	            hh : '%d گھنٹے',
	            d : 'ایک دن',
	            dd : '%d دن',
	            M : 'ایک ماہ',
	            MM : '%d ماہ',
	            y : 'ایک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ur;
	
	})));


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bugun soat] LT [da]',
	            nextDay : '[Ertaga] LT [da]',
	            nextWeek : 'dddd [kuni soat] LT [da]',
	            lastDay : '[Kecha soat] LT [da]',
	            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Yaqin %s ichida',
	            past : 'Bir necha %s oldin',
	            s : 'soniya',
	            ss : '%d soniya',
	            m : 'bir daqiqa',
	            mm : '%d daqiqa',
	            h : 'bir soat',
	            hh : '%d soat',
	            d : 'bir kun',
	            dd : '%d kun',
	            M : 'bir oy',
	            MM : '%d oy',
	            y : 'bir yil',
	            yy : '%d yil'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            ss : '%d фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	})));


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            ss : '%d giây' ,
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            ss : '%d s~écóñ~ds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var yo = moment.defineLocale('yo', {
	        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Ònì ni] LT',
	            nextDay : '[Ọ̀la ni] LT',
	            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	            lastDay : '[Àna ni] LT',
	            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ní %s',
	            past : '%s kọjá',
	            s : 'ìsẹjú aayá die',
	            ss :'aayá %d',
	            m : 'ìsẹjú kan',
	            mm : 'ìsẹjú %d',
	            h : 'wákati kan',
	            hh : 'wákati %d',
	            d : 'ọjọ́ kan',
	            dd : 'ọjọ́ %d',
	            M : 'osù kan',
	            MM : 'osù %d',
	            y : 'ọdún kan',
	            yy : 'ọdún %d'
	        },
	        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	        ordinal : 'ọjọ́ %d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return yo;
	
	})));


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah点mm分',
	            LLLL : 'YYYY年M月D日ddddAh点mm分',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            ss : '%d 秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhHk;
	
	})));


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天] LT',
	            nextDay : '[明天] LT',
	            nextWeek : '[下]dddd LT',
	            lastDay : '[昨天] LT',
	            lastWeek : '[上]dddd LT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhTw;
	
	})));


/***/ }),
/* 160 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.linkDynamicHTML = linkDynamicHTML;
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function linkDynamicHTML(scope, html) {
	    // Find all the 'ng-model="modelName"' directives in html, and use these
	    // to set up watchers on scope, so that we can update the provided model with
	    // changes in those values. This assumes scope has 'model' attribute to hold
	    // the data.
	    var modelDirectives = /ng-model=["']([a-zA-Z_]+)["']/g;
	    var result = modelDirectives.exec(html);
	    while (result !== null) {
	        (function () {
	            var modelName = result[1];
	            scope.$watch(modelName, function (newValue) {
	                scope.model[modelName] = newValue;
	            });
	            result = modelDirectives.exec(html);
	        })();
	    }
	}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 162 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.2.32
	 * (c) 2010-2014 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular, undefined) {'use strict';
	
	/* jshint maxlen: false */
	
	/**
	 * @ngdoc module
	 * @name ngAnimate
	 * @description
	 *
	 * # ngAnimate
	 *
	 * The `ngAnimate` module provides support for JavaScript, CSS3 transition and CSS3 keyframe animation hooks within existing core and custom directives.
	 *
	 *
	 * <div doc-module-components="ngAnimate"></div>
	 *
	 * # Usage
	 *
	 * To see animations in action, all that is required is to define the appropriate CSS classes
	 * or to register a JavaScript animation via the myModule.animation() function. The directives that support animation automatically are:
	 * `ngRepeat`, `ngInclude`, `ngIf`, `ngSwitch`, `ngShow`, `ngHide`, `ngView` and `ngClass`. Custom directives can take advantage of animation
	 * by using the `$animate` service.
	 *
	 * Below is a more detailed breakdown of the supported animation events provided by pre-existing ng directives:
	 *
	 * | Directive                                                 | Supported Animations                               |
	 * |---------------------------------------------------------- |----------------------------------------------------|
	 * | {@link ng.directive:ngRepeat#usage_animations ngRepeat}         | enter, leave and move                              |
	 * | {@link ngRoute.directive:ngView#usage_animations ngView}        | enter and leave                                    |
	 * | {@link ng.directive:ngInclude#usage_animations ngInclude}       | enter and leave                                    |
	 * | {@link ng.directive:ngSwitch#usage_animations ngSwitch}         | enter and leave                                    |
	 * | {@link ng.directive:ngIf#usage_animations ngIf}                 | enter and leave                                    |
	 * | {@link ng.directive:ngClass#usage_animations ngClass}           | add and remove                                     |
	 * | {@link ng.directive:ngShow#usage_animations ngShow & ngHide}    | add and remove (the ng-hide class value)           |
	 * | {@link ng.directive:form#usage_animations form}                 | add and remove (dirty, pristine, valid, invalid & all other validations)                |
	 * | {@link ng.directive:ngModel#usage_animations ngModel}           | add and remove (dirty, pristine, valid, invalid & all other validations)                |
	 *
	 * You can find out more information about animations upon visiting each directive page.
	 *
	 * Below is an example of how to apply animations to a directive that supports animation hooks:
	 *
	 * ```html
	 * <style type="text/css">
	 * .slide.ng-enter, .slide.ng-leave {
	 *   -webkit-transition:0.5s linear all;
	 *   transition:0.5s linear all;
	 * }
	 *
	 * .slide.ng-enter { }        /&#42; starting animations for enter &#42;/
	 * .slide.ng-enter.ng-enter-active { } /&#42; terminal animations for enter &#42;/
	 * .slide.ng-leave { }        /&#42; starting animations for leave &#42;/
	 * .slide.ng-leave.ng-leave-active { } /&#42; terminal animations for leave &#42;/
	 * </style>
	 *
	 * <!--
	 * the animate service will automatically add .ng-enter and .ng-leave to the element
	 * to trigger the CSS transition/animations
	 * -->
	 * <ANY class="slide" ng-include="..."></ANY>
	 * ```
	 *
	 * Keep in mind that, by default, if an animation is running, any child elements cannot be animated
	 * until the parent element's animation has completed. This blocking feature can be overridden by
	 * placing the `ng-animate-children` attribute on a parent container tag.
	 *
	 * ```html
	 * <div class="slide-animation" ng-if="on" ng-animate-children>
	 *   <div class="fade-animation" ng-if="on">
	 *     <div class="explode-animation" ng-if="on">
	 *        ...
	 *     </div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * When the `on` expression value changes and an animation is triggered then each of the elements within
	 * will all animate without the block being applied to child elements.
	 *
	 * <h2>CSS-defined Animations</h2>
	 * The animate service will automatically apply two CSS classes to the animated element and these two CSS classes
	 * are designed to contain the start and end CSS styling. Both CSS transitions and keyframe animations are supported
	 * and can be used to play along with this naming structure.
	 *
	 * The following code below demonstrates how to perform animations using **CSS transitions** with Angular:
	 *
	 * ```html
	 * <style type="text/css">
	 * /&#42;
	 *  The animate class is apart of the element and the ng-enter class
	 *  is attached to the element once the enter animation event is triggered
	 * &#42;/
	 * .reveal-animation.ng-enter {
	 *  -webkit-transition: 1s linear all; /&#42; Safari/Chrome &#42;/
	 *  transition: 1s linear all; /&#42; All other modern browsers and IE10+ &#42;/
	 *
	 *  /&#42; The animation preparation code &#42;/
	 *  opacity: 0;
	 * }
	 *
	 * /&#42;
	 *  Keep in mind that you want to combine both CSS
	 *  classes together to avoid any CSS-specificity
	 *  conflicts
	 * &#42;/
	 * .reveal-animation.ng-enter.ng-enter-active {
	 *  /&#42; The animation code itself &#42;/
	 *  opacity: 1;
	 * }
	 * </style>
	 *
	 * <div class="view-container">
	 *   <div ng-view class="reveal-animation"></div>
	 * </div>
	 * ```
	 *
	 * The following code below demonstrates how to perform animations using **CSS animations** with Angular:
	 *
	 * ```html
	 * <style type="text/css">
	 * .reveal-animation.ng-enter {
	 *   -webkit-animation: enter_sequence 1s linear; /&#42; Safari/Chrome &#42;/
	 *   animation: enter_sequence 1s linear; /&#42; IE10+ and Future Browsers &#42;/
	 * }
	 * @-webkit-keyframes enter_sequence {
	 *   from { opacity:0; }
	 *   to { opacity:1; }
	 * }
	 * @keyframes enter_sequence {
	 *   from { opacity:0; }
	 *   to { opacity:1; }
	 * }
	 * </style>
	 *
	 * <div class="view-container">
	 *   <div ng-view class="reveal-animation"></div>
	 * </div>
	 * ```
	 *
	 * Both CSS3 animations and transitions can be used together and the animate service will figure out the correct duration and delay timing.
	 *
	 * Upon DOM mutation, the event class is added first (something like `ng-enter`), then the browser prepares itself to add
	 * the active class (in this case `ng-enter-active`) which then triggers the animation. The animation module will automatically
	 * detect the CSS code to determine when the animation ends. Once the animation is over then both CSS classes will be
	 * removed from the DOM. If a browser does not support CSS transitions or CSS animations then the animation will start and end
	 * immediately resulting in a DOM element that is at its final state. This final state is when the DOM element
	 * has no CSS transition/animation classes applied to it.
	 *
	 * <h3>CSS Staggering Animations</h3>
	 * A Staggering animation is a collection of animations that are issued with a slight delay in between each successive operation resulting in a
	 * curtain-like effect. The ngAnimate module, as of 1.2.0, supports staggering animations and the stagger effect can be
	 * performed by creating a **ng-EVENT-stagger** CSS class and attaching that class to the base CSS class used for
	 * the animation. The style property expected within the stagger class can either be a **transition-delay** or an
	 * **animation-delay** property (or both if your animation contains both transitions and keyframe animations).
	 *
	 * ```css
	 * .my-animation.ng-enter {
	 *   /&#42; standard transition code &#42;/
	 *   -webkit-transition: 1s linear all;
	 *   transition: 1s linear all;
	 *   opacity:0;
	 * }
	 * .my-animation.ng-enter-stagger {
	 *   /&#42; this will have a 100ms delay between each successive leave animation &#42;/
	 *   -webkit-transition-delay: 0.1s;
	 *   transition-delay: 0.1s;
	 *
	 *   /&#42; in case the stagger doesn't work then these two values
	 *    must be set to 0 to avoid an accidental CSS inheritance &#42;/
	 *   -webkit-transition-duration: 0s;
	 *   transition-duration: 0s;
	 * }
	 * .my-animation.ng-enter.ng-enter-active {
	 *   /&#42; standard transition styles &#42;/
	 *   opacity:1;
	 * }
	 * ```
	 *
	 * Staggering animations work by default in ngRepeat (so long as the CSS class is defined). Outside of ngRepeat, to use staggering animations
	 * on your own, they can be triggered by firing multiple calls to the same event on $animate. However, the restrictions surrounding this
	 * are that each of the elements must have the same CSS className value as well as the same parent element. A stagger operation
	 * will also be reset if more than 10ms has passed after the last animation has been fired.
	 *
	 * The following code will issue the **ng-leave-stagger** event on the element provided:
	 *
	 * ```js
	 * var kids = parent.children();
	 *
	 * $animate.leave(kids[0]); //stagger index=0
	 * $animate.leave(kids[1]); //stagger index=1
	 * $animate.leave(kids[2]); //stagger index=2
	 * $animate.leave(kids[3]); //stagger index=3
	 * $animate.leave(kids[4]); //stagger index=4
	 *
	 * $timeout(function() {
	 *   //stagger has reset itself
	 *   $animate.leave(kids[5]); //stagger index=0
	 *   $animate.leave(kids[6]); //stagger index=1
	 * }, 100, false);
	 * ```
	 *
	 * Stagger animations are currently only supported within CSS-defined animations.
	 *
	 * <h2>JavaScript-defined Animations</h2>
	 * In the event that you do not want to use CSS3 transitions or CSS3 animations or if you wish to offer animations on browsers that do not
	 * yet support CSS transitions/animations, then you can make use of JavaScript animations defined inside of your AngularJS module.
	 *
	 * ```js
	 * //!annotate="YourApp" Your AngularJS Module|Replace this or ngModule with the module that you used to define your application.
	 * var ngModule = angular.module('YourApp', ['ngAnimate']);
	 * ngModule.animation('.my-crazy-animation', function() {
	 *   return {
	 *     enter: function(element, done) {
	 *       //run the animation here and call done when the animation is complete
	 *       return function(cancelled) {
	 *         //this (optional) function will be called when the animation
	 *         //completes or when the animation is cancelled (the cancelled
	 *         //flag will be set to true if cancelled).
	 *       };
	 *     },
	 *     leave: function(element, done) { },
	 *     move: function(element, done) { },
	 *
	 *     //animation that can be triggered before the class is added
	 *     beforeAddClass: function(element, className, done) { },
	 *
	 *     //animation that can be triggered after the class is added
	 *     addClass: function(element, className, done) { },
	 *
	 *     //animation that can be triggered before the class is removed
	 *     beforeRemoveClass: function(element, className, done) { },
	 *
	 *     //animation that can be triggered after the class is removed
	 *     removeClass: function(element, className, done) { }
	 *   };
	 * });
	 * ```
	 *
	 * JavaScript-defined animations are created with a CSS-like class selector and a collection of events which are set to run
	 * a javascript callback function. When an animation is triggered, $animate will look for a matching animation which fits
	 * the element's CSS class attribute value and then run the matching animation event function (if found).
	 * In other words, if the CSS classes present on the animated element match any of the JavaScript animations then the callback function will
	 * be executed. It should be also noted that only simple, single class selectors are allowed (compound class selectors are not supported).
	 *
	 * Within a JavaScript animation, an object containing various event callback animation functions is expected to be returned.
	 * As explained above, these callbacks are triggered based on the animation event. Therefore if an enter animation is run,
	 * and the JavaScript animation is found, then the enter callback will handle that animation (in addition to the CSS keyframe animation
	 * or transition code that is defined via a stylesheet).
	 *
	 */
	
	angular.module('ngAnimate', ['ng'])
	
	  /**
	   * @ngdoc provider
	   * @name $animateProvider
	   * @description
	   *
	   * The `$animateProvider` allows developers to register JavaScript animation event handlers directly inside of a module.
	   * When an animation is triggered, the $animate service will query the $animate service to find any animations that match
	   * the provided name value.
	   *
	   * Requires the {@link ngAnimate `ngAnimate`} module to be installed.
	   *
	   * Please visit the {@link ngAnimate `ngAnimate`} module overview page learn more about how to use animations in your application.
	   *
	   */
	  .directive('ngAnimateChildren', function() {
	    var NG_ANIMATE_CHILDREN = '$$ngAnimateChildren';
	    return function(scope, element, attrs) {
	      var val = attrs.ngAnimateChildren;
	      if(angular.isString(val) && val.length === 0) { //empty attribute
	        element.data(NG_ANIMATE_CHILDREN, true);
	      } else {
	        scope.$watch(val, function(value) {
	          element.data(NG_ANIMATE_CHILDREN, !!value);
	        });
	      }
	    };
	  })
	
	  //this private service is only used within CSS-enabled animations
	  //IE8 + IE9 do not support rAF natively, but that is fine since they
	  //also don't support transitions and keyframes which means that the code
	  //below will never be used by the two browsers.
	  .factory('$$animateReflow', ['$$rAF', '$document', function($$rAF, $document) {
	    var bod = $document[0].body;
	    return function(fn) {
	      //the returned function acts as the cancellation function
	      return $$rAF(function() {
	        //the line below will force the browser to perform a repaint
	        //so that all the animated elements within the animation frame
	        //will be properly updated and drawn on screen. This is
	        //required to perform multi-class CSS based animations with
	        //Firefox. DO NOT REMOVE THIS LINE. DO NOT OPTIMIZE THIS LINE.
	        //THE MINIFIER WILL REMOVE IT OTHERWISE WHICH WILL RESULT IN AN
	        //UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND WILL
	        //TAKE YEARS AWAY FROM YOUR LIFE!
	        fn(bod.offsetWidth);
	      });
	    };
	  }])
	
	  .config(['$provide', '$animateProvider', function($provide, $animateProvider) {
	    var noop = angular.noop;
	    var forEach = angular.forEach;
	    var selectors = $animateProvider.$$selectors;
	
	    var ELEMENT_NODE = 1;
	    var NG_ANIMATE_STATE = '$$ngAnimateState';
	    var NG_ANIMATE_CHILDREN = '$$ngAnimateChildren';
	    var NG_ANIMATE_CLASS_NAME = 'ng-animate';
	    var rootAnimateState = {running: true};
	
	    function extractElementNode(element) {
	      for(var i = 0; i < element.length; i++) {
	        var elm = element[i];
	        if(elm.nodeType == ELEMENT_NODE) {
	          return elm;
	        }
	      }
	    }
	
	    function prepareElement(element) {
	      return element && angular.element(element);
	    }
	
	    function stripCommentsFromElement(element) {
	      return angular.element(extractElementNode(element));
	    }
	
	    function isMatchingElement(elm1, elm2) {
	      return extractElementNode(elm1) == extractElementNode(elm2);
	    }
	
	    $provide.decorator('$animate', ['$delegate', '$injector', '$sniffer', '$rootElement', '$$asyncCallback', '$rootScope', '$document',
	                            function($delegate,   $injector,   $sniffer,   $rootElement,   $$asyncCallback,    $rootScope,   $document) {
	
	      var globalAnimationCounter = 0;
	      $rootElement.data(NG_ANIMATE_STATE, rootAnimateState);
	
	      // disable animations during bootstrap, but once we bootstrapped, wait again
	      // for another digest until enabling animations. The reason why we digest twice
	      // is because all structural animations (enter, leave and move) all perform a
	      // post digest operation before animating. If we only wait for a single digest
	      // to pass then the structural animation would render its animation on page load.
	      // (which is what we're trying to avoid when the application first boots up.)
	      $rootScope.$$postDigest(function() {
	        $rootScope.$$postDigest(function() {
	          rootAnimateState.running = false;
	        });
	      });
	
	      var classNameFilter = $animateProvider.classNameFilter();
	      var isAnimatableClassName = !classNameFilter
	              ? function() { return true; }
	              : function(className) {
	                return classNameFilter.test(className);
	              };
	
	      function blockElementAnimations(element) {
	        var data = element.data(NG_ANIMATE_STATE) || {};
	        data.running = true;
	        element.data(NG_ANIMATE_STATE, data);
	      }
	
	      function lookup(name) {
	        if (name) {
	          var matches = [],
	              flagMap = {},
	              classes = name.substr(1).split('.');
	
	          //the empty string value is the default animation
	          //operation which performs CSS transition and keyframe
	          //animations sniffing. This is always included for each
	          //element animation procedure if the browser supports
	          //transitions and/or keyframe animations. The default
	          //animation is added to the top of the list to prevent
	          //any previous animations from affecting the element styling
	          //prior to the element being animated.
	          if ($sniffer.transitions || $sniffer.animations) {
	            matches.push($injector.get(selectors['']));
	          }
	
	          for(var i=0; i < classes.length; i++) {
	            var klass = classes[i],
	                selectorFactoryName = selectors[klass];
	            if(selectorFactoryName && !flagMap[klass]) {
	              matches.push($injector.get(selectorFactoryName));
	              flagMap[klass] = true;
	            }
	          }
	          return matches;
	        }
	      }
	
	      function animationRunner(element, animationEvent, className) {
	        //transcluded directives may sometimes fire an animation using only comment nodes
	        //best to catch this early on to prevent any animation operations from occurring
	        var node = element[0];
	        if(!node) {
	          return;
	        }
	
	        var isSetClassOperation = animationEvent == 'setClass';
	        var isClassBased = isSetClassOperation ||
	                           animationEvent == 'addClass' ||
	                           animationEvent == 'removeClass';
	
	        var classNameAdd, classNameRemove;
	        if(angular.isArray(className)) {
	          classNameAdd = className[0];
	          classNameRemove = className[1];
	          className = classNameAdd + ' ' + classNameRemove;
	        }
	
	        var currentClassName = element.attr('class');
	        var classes = currentClassName + ' ' + className;
	        if(!isAnimatableClassName(classes)) {
	          return;
	        }
	
	        var beforeComplete = noop,
	            beforeCancel = [],
	            before = [],
	            afterComplete = noop,
	            afterCancel = [],
	            after = [];
	
	        var animationLookup = (' ' + classes).replace(/\s+/g,'.');
	        forEach(lookup(animationLookup), function(animationFactory) {
	          var created = registerAnimation(animationFactory, animationEvent);
	          if(!created && isSetClassOperation) {
	            registerAnimation(animationFactory, 'addClass');
	            registerAnimation(animationFactory, 'removeClass');
	          }
	        });
	
	        function registerAnimation(animationFactory, event) {
	          var afterFn = animationFactory[event];
	          var beforeFn = animationFactory['before' + event.charAt(0).toUpperCase() + event.substr(1)];
	          if(afterFn || beforeFn) {
	            if(event == 'leave') {
	              beforeFn = afterFn;
	              //when set as null then animation knows to skip this phase
	              afterFn = null;
	            }
	            after.push({
	              event : event, fn : afterFn
	            });
	            before.push({
	              event : event, fn : beforeFn
	            });
	            return true;
	          }
	        }
	
	        function run(fns, cancellations, allCompleteFn) {
	          var animations = [];
	          forEach(fns, function(animation) {
	            animation.fn && animations.push(animation);
	          });
	
	          var count = 0;
	          function afterAnimationComplete(index) {
	            if(cancellations) {
	              (cancellations[index] || noop)();
	              if(++count < animations.length) return;
	              cancellations = null;
	            }
	            allCompleteFn();
	          }
	
	          //The code below adds directly to the array in order to work with
	          //both sync and async animations. Sync animations are when the done()
	          //operation is called right away. DO NOT REFACTOR!
	          forEach(animations, function(animation, index) {
	            var progress = function() {
	              afterAnimationComplete(index);
	            };
	            switch(animation.event) {
	              case 'setClass':
	                cancellations.push(animation.fn(element, classNameAdd, classNameRemove, progress));
	                break;
	              case 'addClass':
	                cancellations.push(animation.fn(element, classNameAdd || className,     progress));
	                break;
	              case 'removeClass':
	                cancellations.push(animation.fn(element, classNameRemove || className,  progress));
	                break;
	              default:
	                cancellations.push(animation.fn(element, progress));
	                break;
	            }
	          });
	
	          if(cancellations && cancellations.length === 0) {
	            allCompleteFn();
	          }
	        }
	
	        return {
	          node : node,
	          event : animationEvent,
	          className : className,
	          isClassBased : isClassBased,
	          isSetClassOperation : isSetClassOperation,
	          before : function(allCompleteFn) {
	            beforeComplete = allCompleteFn;
	            run(before, beforeCancel, function() {
	              beforeComplete = noop;
	              allCompleteFn();
	            });
	          },
	          after : function(allCompleteFn) {
	            afterComplete = allCompleteFn;
	            run(after, afterCancel, function() {
	              afterComplete = noop;
	              allCompleteFn();
	            });
	          },
	          cancel : function() {
	            if(beforeCancel) {
	              forEach(beforeCancel, function(cancelFn) {
	                (cancelFn || noop)(true);
	              });
	              beforeComplete(true);
	            }
	            if(afterCancel) {
	              forEach(afterCancel, function(cancelFn) {
	                (cancelFn || noop)(true);
	              });
	              afterComplete(true);
	            }
	          }
	        };
	      }
	
	      /**
	       * @ngdoc service
	       * @name $animate
	       * @kind function
	       *
	       * @description
	       * The `$animate` service provides animation detection support while performing DOM operations (enter, leave and move) as well as during addClass and removeClass operations.
	       * When any of these operations are run, the $animate service
	       * will examine any JavaScript-defined animations (which are defined by using the $animateProvider provider object)
	       * as well as any CSS-defined animations against the CSS classes present on the element once the DOM operation is run.
	       *
	       * The `$animate` service is used behind the scenes with pre-existing directives and animation with these directives
	       * will work out of the box without any extra configuration.
	       *
	       * Requires the {@link ngAnimate `ngAnimate`} module to be installed.
	       *
	       * Please visit the {@link ngAnimate `ngAnimate`} module overview page learn more about how to use animations in your application.
	       *
	       */
	      return {
	        /**
	         * @ngdoc method
	         * @name $animate#enter
	         * @kind function
	         *
	         * @description
	         * Appends the element to the parentElement element that resides in the document and then runs the enter animation. Once
	         * the animation is started, the following CSS classes will be present on the element for the duration of the animation:
	         *
	         * Below is a breakdown of each step that occurs during enter animation:
	         *
	         * | Animation Step                                                                               | What the element class attribute looks like |
	         * |----------------------------------------------------------------------------------------------|---------------------------------------------|
	         * | 1. $animate.enter(...) is called                                                             | class="my-animation"                        |
	         * | 2. element is inserted into the parentElement element or beside the afterElement element     | class="my-animation"                        |
	         * | 3. $animate runs any JavaScript-defined animations on the element                            | class="my-animation ng-animate"             |
	         * | 4. the .ng-enter class is added to the element                                               | class="my-animation ng-animate ng-enter"    |
	         * | 5. $animate scans the element styles to get the CSS transition/animation duration and delay  | class="my-animation ng-animate ng-enter"    |
	         * | 6. $animate waits for 10ms (this performs a reflow)                                          | class="my-animation ng-animate ng-enter"    |
	         * | 7. the .ng-enter-active and .ng-animate-active classes are added (this triggers the CSS transition/animation) | class="my-animation ng-animate ng-animate-active ng-enter ng-enter-active" |
	         * | 8. $animate waits for X milliseconds for the animation to complete                           | class="my-animation ng-animate ng-animate-active ng-enter ng-enter-active" |
	         * | 9. The animation ends and all generated CSS classes are removed from the element             | class="my-animation"                        |
	         * | 10. The doneCallback() callback is fired (if provided)                                       | class="my-animation"                        |
	         *
	         * @param {DOMElement} element the element that will be the focus of the enter animation
	         * @param {DOMElement} parentElement the parent element of the element that will be the focus of the enter animation
	         * @param {DOMElement} afterElement the sibling element (which is the previous element) of the element that will be the focus of the enter animation
	         * @param {function()=} doneCallback the callback function that will be called once the animation is complete
	        */
	        enter : function(element, parentElement, afterElement, doneCallback) {
	          element = angular.element(element);
	          parentElement = prepareElement(parentElement);
	          afterElement = prepareElement(afterElement);
	
	          blockElementAnimations(element);
	          $delegate.enter(element, parentElement, afterElement);
	          $rootScope.$$postDigest(function() {
	            element = stripCommentsFromElement(element);
	            performAnimation('enter', 'ng-enter', element, parentElement, afterElement, noop, doneCallback);
	          });
	        },
	
	        /**
	         * @ngdoc method
	         * @name $animate#leave
	         * @kind function
	         *
	         * @description
	         * Runs the leave animation operation and, upon completion, removes the element from the DOM. Once
	         * the animation is started, the following CSS classes will be added for the duration of the animation:
	         *
	         * Below is a breakdown of each step that occurs during leave animation:
	         *
	         * | Animation Step                                                                               | What the element class attribute looks like |
	         * |----------------------------------------------------------------------------------------------|---------------------------------------------|
	         * | 1. $animate.leave(...) is called                                                             | class="my-animation"                        |
	         * | 2. $animate runs any JavaScript-defined animations on the element                            | class="my-animation ng-animate"             |
	         * | 3. the .ng-leave class is added to the element                                               | class="my-animation ng-animate ng-leave"    |
	         * | 4. $animate scans the element styles to get the CSS transition/animation duration and delay  | class="my-animation ng-animate ng-leave"    |
	         * | 5. $animate waits for 10ms (this performs a reflow)                                          | class="my-animation ng-animate ng-leave"    |
	         * | 6. the .ng-leave-active and .ng-animate-active classes is added (this triggers the CSS transition/animation) | class="my-animation ng-animate ng-animate-active ng-leave ng-leave-active" |
	         * | 7. $animate waits for X milliseconds for the animation to complete                           | class="my-animation ng-animate ng-animate-active ng-leave ng-leave-active" |
	         * | 8. The animation ends and all generated CSS classes are removed from the element             | class="my-animation"                        |
	         * | 9. The element is removed from the DOM                                                       | ...                                         |
	         * | 10. The doneCallback() callback is fired (if provided)                                       | ...                                         |
	         *
	         * @param {DOMElement} element the element that will be the focus of the leave animation
	         * @param {function()=} doneCallback the callback function that will be called once the animation is complete
	        */
	        leave : function(element, doneCallback) {
	          element = angular.element(element);
	          cancelChildAnimations(element);
	          blockElementAnimations(element);
	          $rootScope.$$postDigest(function() {
	            performAnimation('leave', 'ng-leave', stripCommentsFromElement(element), null, null, function() {
	              $delegate.leave(element);
	            }, doneCallback);
	          });
	        },
	
	        /**
	         * @ngdoc method
	         * @name $animate#move
	         * @kind function
	         *
	         * @description
	         * Fires the move DOM operation. Just before the animation starts, the animate service will either append it into the parentElement container or
	         * add the element directly after the afterElement element if present. Then the move animation will be run. Once
	         * the animation is started, the following CSS classes will be added for the duration of the animation:
	         *
	         * Below is a breakdown of each step that occurs during move animation:
	         *
	         * | Animation Step                                                                               | What the element class attribute looks like |
	         * |----------------------------------------------------------------------------------------------|---------------------------------------------|
	         * | 1. $animate.move(...) is called                                                              | class="my-animation"                        |
	         * | 2. element is moved into the parentElement element or beside the afterElement element        | class="my-animation"                        |
	         * | 3. $animate runs any JavaScript-defined animations on the element                            | class="my-animation ng-animate"             |
	         * | 4. the .ng-move class is added to the element                                                | class="my-animation ng-animate ng-move"     |
	         * | 5. $animate scans the element styles to get the CSS transition/animation duration and delay  | class="my-animation ng-animate ng-move"     |
	         * | 6. $animate waits for 10ms (this performs a reflow)                                          | class="my-animation ng-animate ng-move"     |
	         * | 7. the .ng-move-active and .ng-animate-active classes is added (this triggers the CSS transition/animation) | class="my-animation ng-animate ng-animate-active ng-move ng-move-active" |
	         * | 8. $animate waits for X milliseconds for the animation to complete                           | class="my-animation ng-animate ng-animate-active ng-move ng-move-active" |
	         * | 9. The animation ends and all generated CSS classes are removed from the element             | class="my-animation"                        |
	         * | 10. The doneCallback() callback is fired (if provided)                                       | class="my-animation"                        |
	         *
	         * @param {DOMElement} element the element that will be the focus of the move animation
	         * @param {DOMElement} parentElement the parentElement element of the element that will be the focus of the move animation
	         * @param {DOMElement} afterElement the sibling element (which is the previous element) of the element that will be the focus of the move animation
	         * @param {function()=} doneCallback the callback function that will be called once the animation is complete
	        */
	        move : function(element, parentElement, afterElement, doneCallback) {
	          element = angular.element(element);
	          parentElement = prepareElement(parentElement);
	          afterElement = prepareElement(afterElement);
	
	          cancelChildAnimations(element);
	          blockElementAnimations(element);
	          $delegate.move(element, parentElement, afterElement);
	          $rootScope.$$postDigest(function() {
	            element = stripCommentsFromElement(element);
	            performAnimation('move', 'ng-move', element, parentElement, afterElement, noop, doneCallback);
	          });
	        },
	
	        /**
	         * @ngdoc method
	         * @name $animate#addClass
	         *
	         * @description
	         * Triggers a custom animation event based off the className variable and then attaches the className value to the element as a CSS class.
	         * Unlike the other animation methods, the animate service will suffix the className value with {@type -add} in order to provide
	         * the animate service the setup and active CSS classes in order to trigger the animation (this will be skipped if no CSS transitions
	         * or keyframes are defined on the -add or base CSS class).
	         *
	         * Below is a breakdown of each step that occurs during addClass animation:
	         *
	         * | Animation Step                                                                                 | What the element class attribute looks like |
	         * |------------------------------------------------------------------------------------------------|---------------------------------------------|
	         * | 1. $animate.addClass(element, 'super') is called                                               | class="my-animation"                        |
	         * | 2. $animate runs any JavaScript-defined animations on the element                              | class="my-animation ng-animate"             |
	         * | 3. the .super-add class are added to the element                                               | class="my-animation ng-animate super-add"   |
	         * | 4. $animate scans the element styles to get the CSS transition/animation duration and delay    | class="my-animation ng-animate super-add"   |
	         * | 5. $animate waits for 10ms (this performs a reflow)                                            | class="my-animation ng-animate super-add"   |
	         * | 6. the .super, .super-add-active and .ng-animate-active classes are added (this triggers the CSS transition/animation) | class="my-animation ng-animate ng-animate-active super super-add super-add-active"          |
	         * | 7. $animate waits for X milliseconds for the animation to complete                             | class="my-animation super super-add super-add-active"  |
	         * | 8. The animation ends and all generated CSS classes are removed from the element               | class="my-animation super"                  |
	         * | 9. The super class is kept on the element                                                      | class="my-animation super"                  |
	         * | 10. The doneCallback() callback is fired (if provided)                                         | class="my-animation super"                  |
	         *
	         * @param {DOMElement} element the element that will be animated
	         * @param {string} className the CSS class that will be added to the element and then animated
	         * @param {function()=} doneCallback the callback function that will be called once the animation is complete
	        */
	        addClass : function(element, className, doneCallback) {
	          element = angular.element(element);
	          element = stripCommentsFromElement(element);
	          performAnimation('addClass', className, element, null, null, function() {
	            $delegate.addClass(element, className);
	          }, doneCallback);
	        },
	
	        /**
	         * @ngdoc method
	         * @name $animate#removeClass
	         *
	         * @description
	         * Triggers a custom animation event based off the className variable and then removes the CSS class provided by the className value
	         * from the element. Unlike the other animation methods, the animate service will suffix the className value with {@type -remove} in
	         * order to provide the animate service the setup and active CSS classes in order to trigger the animation (this will be skipped if
	         * no CSS transitions or keyframes are defined on the -remove or base CSS classes).
	         *
	         * Below is a breakdown of each step that occurs during removeClass animation:
	         *
	         * | Animation Step                                                                                | What the element class attribute looks like     |
	         * |-----------------------------------------------------------------------------------------------|---------------------------------------------|
	         * | 1. $animate.removeClass(element, 'super') is called                                           | class="my-animation super"                  |
	         * | 2. $animate runs any JavaScript-defined animations on the element                             | class="my-animation super ng-animate"       |
	         * | 3. the .super-remove class are added to the element                                           | class="my-animation super ng-animate super-remove"|
	         * | 4. $animate scans the element styles to get the CSS transition/animation duration and delay   | class="my-animation super ng-animate super-remove"   |
	         * | 5. $animate waits for 10ms (this performs a reflow)                                           | class="my-animation super ng-animate super-remove"   |
	         * | 6. the .super-remove-active and .ng-animate-active classes are added and .super is removed (this triggers the CSS transition/animation) | class="my-animation ng-animate ng-animate-active super-remove super-remove-active"          |
	         * | 7. $animate waits for X milliseconds for the animation to complete                            | class="my-animation ng-animate ng-animate-active super-remove super-remove-active"   |
	         * | 8. The animation ends and all generated CSS classes are removed from the element              | class="my-animation"                        |
	         * | 9. The doneCallback() callback is fired (if provided)                                         | class="my-animation"                        |
	         *
	         *
	         * @param {DOMElement} element the element that will be animated
	         * @param {string} className the CSS class that will be animated and then removed from the element
	         * @param {function()=} doneCallback the callback function that will be called once the animation is complete
	        */
	        removeClass : function(element, className, doneCallback) {
	          element = angular.element(element);
	          element = stripCommentsFromElement(element);
	          performAnimation('removeClass', className, element, null, null, function() {
	            $delegate.removeClass(element, className);
	          }, doneCallback);
	        },
	
	          /**
	           *
	           * @ngdoc function
	           * @name $animate#setClass
	           * @function
	           * @description Adds and/or removes the given CSS classes to and from the element.
	           * Once complete, the done() callback will be fired (if provided).
	           * @param {DOMElement} element the element which will its CSS classes changed
	           *   removed from it
	           * @param {string} add the CSS classes which will be added to the element
	           * @param {string} remove the CSS class which will be removed from the element
	           * @param {Function=} done the callback function (if provided) that will be fired after the
	           *   CSS classes have been set on the element
	           */
	        setClass : function(element, add, remove, doneCallback) {
	          element = angular.element(element);
	          element = stripCommentsFromElement(element);
	          performAnimation('setClass', [add, remove], element, null, null, function() {
	            $delegate.setClass(element, add, remove);
	          }, doneCallback);
	        },
	
	        /**
	         * @ngdoc method
	         * @name $animate#enabled
	         * @kind function
	         *
	         * @param {boolean=} value If provided then set the animation on or off.
	         * @param {DOMElement=} element If provided then the element will be used to represent the enable/disable operation
	         * @return {boolean} Current animation state.
	         *
	         * @description
	         * Globally enables/disables animations.
	         *
	        */
	        enabled : function(value, element) {
	          switch(arguments.length) {
	            case 2:
	              if(value) {
	                cleanup(element);
	              } else {
	                var data = element.data(NG_ANIMATE_STATE) || {};
	                data.disabled = true;
	                element.data(NG_ANIMATE_STATE, data);
	              }
	            break;
	
	            case 1:
	              rootAnimateState.disabled = !value;
	            break;
	
	            default:
	              value = !rootAnimateState.disabled;
	            break;
	          }
	          return !!value;
	         }
	      };
	
	      /*
	        all animations call this shared animation triggering function internally.
	        The animationEvent variable refers to the JavaScript animation event that will be triggered
	        and the className value is the name of the animation that will be applied within the
	        CSS code. Element, parentElement and afterElement are provided DOM elements for the animation
	        and the onComplete callback will be fired once the animation is fully complete.
	      */
	      function performAnimation(animationEvent, className, element, parentElement, afterElement, domOperation, doneCallback) {
	
	        var runner = animationRunner(element, animationEvent, className);
	        if(!runner) {
	          fireDOMOperation();
	          fireBeforeCallbackAsync();
	          fireAfterCallbackAsync();
	          closeAnimation();
	          return;
	        }
	
	        className = runner.className;
	        var elementEvents = angular.element._data(runner.node);
	        elementEvents = elementEvents && elementEvents.events;
	
	        if (!parentElement) {
	          parentElement = afterElement ? afterElement.parent() : element.parent();
	        }
	
	        var ngAnimateState  = element.data(NG_ANIMATE_STATE) || {};
	        var runningAnimations     = ngAnimateState.active || {};
	        var totalActiveAnimations = ngAnimateState.totalActive || 0;
	        var lastAnimation         = ngAnimateState.last;
	
	        //only allow animations if the currently running animation is not structural
	        //or if there is no animation running at all
	        var skipAnimations;
	        if (runner.isClassBased) {
	          skipAnimations = ngAnimateState.running ||
	                           ngAnimateState.disabled ||
	                           (lastAnimation && !lastAnimation.isClassBased);
	        }
	
	        //skip the animation if animations are disabled, a parent is already being animated,
	        //the element is not currently attached to the document body or then completely close
	        //the animation if any matching animations are not found at all.
	        //NOTE: IE8 + IE9 should close properly (run closeAnimation()) in case an animation was found.
	        if (skipAnimations || animationsDisabled(element, parentElement)) {
	          fireDOMOperation();
	          fireBeforeCallbackAsync();
	          fireAfterCallbackAsync();
	          closeAnimation();
	          return;
	        }
	
	        var skipAnimation = false;
	        if(totalActiveAnimations > 0) {
	          var animationsToCancel = [];
	          if(!runner.isClassBased) {
	            if(animationEvent == 'leave' && runningAnimations['ng-leave']) {
	              skipAnimation = true;
	            } else {
	              //cancel all animations when a structural animation takes place
	              for(var klass in runningAnimations) {
	                animationsToCancel.push(runningAnimations[klass]);
	                cleanup(element, klass);
	              }
	              runningAnimations = {};
	              totalActiveAnimations = 0;
	            }
	          } else if(lastAnimation.event == 'setClass') {
	            animationsToCancel.push(lastAnimation);
	            cleanup(element, className);
	          }
	          else if(runningAnimations[className]) {
	            var current = runningAnimations[className];
	            if(current.event == animationEvent) {
	              skipAnimation = true;
	            } else {
	              animationsToCancel.push(current);
	              cleanup(element, className);
	            }
	          }
	
	          if(animationsToCancel.length > 0) {
	            forEach(animationsToCancel, function(operation) {
	              operation.cancel();
	            });
	          }
	        }
	
	        if(runner.isClassBased && !runner.isSetClassOperation && !skipAnimation) {
	          skipAnimation = (animationEvent == 'addClass') == element.hasClass(className); //opposite of XOR
	        }
	
	        if(skipAnimation) {
	          fireDOMOperation();
	          fireBeforeCallbackAsync();
	          fireAfterCallbackAsync();
	          fireDoneCallbackAsync();
	          return;
	        }
	
	        if(animationEvent == 'leave') {
	          //there's no need to ever remove the listener since the element
	          //will be removed (destroyed) after the leave animation ends or
	          //is cancelled midway
	          element.one('$destroy', function(e) {
	            var element = angular.element(this);
	            var state = element.data(NG_ANIMATE_STATE);
	            if(state) {
	              var activeLeaveAnimation = state.active['ng-leave'];
	              if(activeLeaveAnimation) {
	                activeLeaveAnimation.cancel();
	                cleanup(element, 'ng-leave');
	              }
	            }
	          });
	        }
	
	        //the ng-animate class does nothing, but it's here to allow for
	        //parent animations to find and cancel child animations when needed
	        element.addClass(NG_ANIMATE_CLASS_NAME);
	
	        var localAnimationCount = globalAnimationCounter++;
	        totalActiveAnimations++;
	        runningAnimations[className] = runner;
	
	        element.data(NG_ANIMATE_STATE, {
	          last : runner,
	          active : runningAnimations,
	          index : localAnimationCount,
	          totalActive : totalActiveAnimations
	        });
	
	        //first we run the before animations and when all of those are complete
	        //then we perform the DOM operation and run the next set of animations
	        fireBeforeCallbackAsync();
	        runner.before(function(cancelled) {
	          var data = element.data(NG_ANIMATE_STATE);
	          cancelled = cancelled ||
	                        !data || !data.active[className] ||
	                        (runner.isClassBased && data.active[className].event != animationEvent);
	
	          fireDOMOperation();
	          if(cancelled === true) {
	            closeAnimation();
	          } else {
	            fireAfterCallbackAsync();
	            runner.after(closeAnimation);
	          }
	        });
	
	        function fireDOMCallback(animationPhase) {
	          var eventName = '$animate:' + animationPhase;
	          if(elementEvents && elementEvents[eventName] && elementEvents[eventName].length > 0) {
	            $$asyncCallback(function() {
	              element.triggerHandler(eventName, {
	                event : animationEvent,
	                className : className
	              });
	            });
	          }
	        }
	
	        function fireBeforeCallbackAsync() {
	          fireDOMCallback('before');
	        }
	
	        function fireAfterCallbackAsync() {
	          fireDOMCallback('after');
	        }
	
	        function fireDoneCallbackAsync() {
	          fireDOMCallback('close');
	          if(doneCallback) {
	            $$asyncCallback(function() {
	              doneCallback();
	            });
	          }
	        }
	
	        //it is less complicated to use a flag than managing and canceling
	        //timeouts containing multiple callbacks.
	        function fireDOMOperation() {
	          if(!fireDOMOperation.hasBeenRun) {
	            fireDOMOperation.hasBeenRun = true;
	            domOperation();
	          }
	        }
	
	        function closeAnimation() {
	          if(!closeAnimation.hasBeenRun) {
	            closeAnimation.hasBeenRun = true;
	            var data = element.data(NG_ANIMATE_STATE);
	            if(data) {
	              /* only structural animations wait for reflow before removing an
	                 animation, but class-based animations don't. An example of this
	                 failing would be when a parent HTML tag has a ng-class attribute
	                 causing ALL directives below to skip animations during the digest */
	              if(runner && runner.isClassBased) {
	                cleanup(element, className);
	              } else {
	                $$asyncCallback(function() {
	                  var data = element.data(NG_ANIMATE_STATE) || {};
	                  if(localAnimationCount == data.index) {
	                    cleanup(element, className, animationEvent);
	                  }
	                });
	                element.data(NG_ANIMATE_STATE, data);
	              }
	            }
	            fireDoneCallbackAsync();
	          }
	        }
	      }
	
	      function cancelChildAnimations(element) {
	        var node = extractElementNode(element);
	        if (node) {
	          var nodes = angular.isFunction(node.getElementsByClassName) ?
	            node.getElementsByClassName(NG_ANIMATE_CLASS_NAME) :
	            node.querySelectorAll('.' + NG_ANIMATE_CLASS_NAME);
	          forEach(nodes, function(element) {
	            element = angular.element(element);
	            var data = element.data(NG_ANIMATE_STATE);
	            if(data && data.active) {
	              forEach(data.active, function(runner) {
	                runner.cancel();
	              });
	            }
	          });
	        }
	      }
	
	      function cleanup(element, className) {
	        if(isMatchingElement(element, $rootElement)) {
	          if(!rootAnimateState.disabled) {
	            rootAnimateState.running = false;
	            rootAnimateState.structural = false;
	          }
	        } else if(className) {
	          var data = element.data(NG_ANIMATE_STATE) || {};
	
	          var removeAnimations = className === true;
	          if(!removeAnimations && data.active && data.active[className]) {
	            data.totalActive--;
	            delete data.active[className];
	          }
	
	          if(removeAnimations || !data.totalActive) {
	            element.removeClass(NG_ANIMATE_CLASS_NAME);
	            element.removeData(NG_ANIMATE_STATE);
	          }
	        }
	      }
	
	      function animationsDisabled(element, parentElement) {
	        if (rootAnimateState.disabled) {
	          return true;
	        }
	
	        if (isMatchingElement(element, $rootElement)) {
	          return rootAnimateState.running;
	        }
	
	        var allowChildAnimations, parentRunningAnimation, hasParent;
	        do {
	          //the element did not reach the root element which means that it
	          //is not apart of the DOM. Therefore there is no reason to do
	          //any animations on it
	          if (parentElement.length === 0) break;
	
	          var isRoot = isMatchingElement(parentElement, $rootElement);
	          var state = isRoot ? rootAnimateState : (parentElement.data(NG_ANIMATE_STATE) || {});
	          if (state.disabled) {
	            return true;
	          }
	
	          //no matter what, for an animation to work it must reach the root element
	          //this implies that the element is attached to the DOM when the animation is run
	          if (isRoot) {
	            hasParent = true;
	          }
	
	          //once a flag is found that is strictly false then everything before
	          //it will be discarded and all child animations will be restricted
	          if (allowChildAnimations !== false) {
	            var animateChildrenFlag = parentElement.data(NG_ANIMATE_CHILDREN);
	            if(angular.isDefined(animateChildrenFlag)) {
	              allowChildAnimations = animateChildrenFlag;
	            }
	          }
	
	          parentRunningAnimation = parentRunningAnimation ||
	                                   state.running ||
	                                   (state.last && !state.last.isClassBased);
	        }
	        while(parentElement = parentElement.parent());
	
	        return !hasParent || (!allowChildAnimations && parentRunningAnimation);
	      }
	    }]);
	
	    $animateProvider.register('', ['$window', '$sniffer', '$timeout', '$$animateReflow',
	                           function($window,   $sniffer,   $timeout,   $$animateReflow) {
	      // Detect proper transitionend/animationend event names.
	      var CSS_PREFIX = '', TRANSITION_PROP, TRANSITIONEND_EVENT, ANIMATION_PROP, ANIMATIONEND_EVENT;
	
	      // If unprefixed events are not supported but webkit-prefixed are, use the latter.
	      // Otherwise, just use W3C names, browsers not supporting them at all will just ignore them.
	      // Note: Chrome implements `window.onwebkitanimationend` and doesn't implement `window.onanimationend`
	      // but at the same time dispatches the `animationend` event and not `webkitAnimationEnd`.
	      // Register both events in case `window.onanimationend` is not supported because of that,
	      // do the same for `transitionend` as Safari is likely to exhibit similar behavior.
	      // Also, the only modern browser that uses vendor prefixes for transitions/keyframes is webkit
	      // therefore there is no reason to test anymore for other vendor prefixes: http://caniuse.com/#search=transition
	      if (window.ontransitionend === undefined && window.onwebkittransitionend !== undefined) {
	        CSS_PREFIX = '-webkit-';
	        TRANSITION_PROP = 'WebkitTransition';
	        TRANSITIONEND_EVENT = 'webkitTransitionEnd transitionend';
	      } else {
	        TRANSITION_PROP = 'transition';
	        TRANSITIONEND_EVENT = 'transitionend';
	      }
	
	      if (window.onanimationend === undefined && window.onwebkitanimationend !== undefined) {
	        CSS_PREFIX = '-webkit-';
	        ANIMATION_PROP = 'WebkitAnimation';
	        ANIMATIONEND_EVENT = 'webkitAnimationEnd animationend';
	      } else {
	        ANIMATION_PROP = 'animation';
	        ANIMATIONEND_EVENT = 'animationend';
	      }
	
	      var DURATION_KEY = 'Duration';
	      var PROPERTY_KEY = 'Property';
	      var DELAY_KEY = 'Delay';
	      var ANIMATION_ITERATION_COUNT_KEY = 'IterationCount';
	      var NG_ANIMATE_PARENT_KEY = '$$ngAnimateKey';
	      var NG_ANIMATE_CSS_DATA_KEY = '$$ngAnimateCSS3Data';
	      var NG_ANIMATE_BLOCK_CLASS_NAME = 'ng-animate-block-transitions';
	      var ELAPSED_TIME_MAX_DECIMAL_PLACES = 3;
	      var CLOSING_TIME_BUFFER = 1.5;
	      var ONE_SECOND = 1000;
	
	      var lookupCache = {};
	      var parentCounter = 0;
	      var animationReflowQueue = [];
	      var cancelAnimationReflow;
	      function clearCacheAfterReflow() {
	        if (!cancelAnimationReflow) {
	          cancelAnimationReflow = $$animateReflow(function() {
	            animationReflowQueue = [];
	            cancelAnimationReflow = null;
	            lookupCache = {};
	          });
	        }
	      }
	
	      function afterReflow(element, callback) {
	        if(cancelAnimationReflow) {
	          cancelAnimationReflow();
	        }
	        animationReflowQueue.push(callback);
	        cancelAnimationReflow = $$animateReflow(function() {
	          forEach(animationReflowQueue, function(fn) {
	            fn();
	          });
	
	          animationReflowQueue = [];
	          cancelAnimationReflow = null;
	          lookupCache = {};
	        });
	      }
	
	      var closingTimer = null;
	      var closingTimestamp = 0;
	      var animationElementQueue = [];
	      function animationCloseHandler(element, totalTime) {
	        var node = extractElementNode(element);
	        element = angular.element(node);
	
	        //this item will be garbage collected by the closing
	        //animation timeout
	        animationElementQueue.push(element);
	
	        //but it may not need to cancel out the existing timeout
	        //if the timestamp is less than the previous one
	        var futureTimestamp = Date.now() + totalTime;
	        if(futureTimestamp <= closingTimestamp) {
	          return;
	        }
	
	        $timeout.cancel(closingTimer);
	
	        closingTimestamp = futureTimestamp;
	        closingTimer = $timeout(function() {
	          closeAllAnimations(animationElementQueue);
	          animationElementQueue = [];
	        }, totalTime, false);
	      }
	
	      function closeAllAnimations(elements) {
	        forEach(elements, function(element) {
	          var elementData = element.data(NG_ANIMATE_CSS_DATA_KEY);
	          if(elementData) {
	            (elementData.closeAnimationFn || noop)();
	          }
	        });
	      }
	
	      function getElementAnimationDetails(element, cacheKey) {
	        var data = cacheKey ? lookupCache[cacheKey] : null;
	        if(!data) {
	          var transitionDuration = 0;
	          var transitionDelay = 0;
	          var animationDuration = 0;
	          var animationDelay = 0;
	          var transitionDelayStyle;
	          var animationDelayStyle;
	          var transitionDurationStyle;
	          var transitionPropertyStyle;
	
	          //we want all the styles defined before and after
	          forEach(element, function(element) {
	            if (element.nodeType == ELEMENT_NODE) {
	              var elementStyles = $window.getComputedStyle(element) || {};
	
	              transitionDurationStyle = elementStyles[TRANSITION_PROP + DURATION_KEY];
	
	              transitionDuration = Math.max(parseMaxTime(transitionDurationStyle), transitionDuration);
	
	              transitionPropertyStyle = elementStyles[TRANSITION_PROP + PROPERTY_KEY];
	
	              transitionDelayStyle = elementStyles[TRANSITION_PROP + DELAY_KEY];
	
	              transitionDelay  = Math.max(parseMaxTime(transitionDelayStyle), transitionDelay);
	
	              animationDelayStyle = elementStyles[ANIMATION_PROP + DELAY_KEY];
	
	              animationDelay   = Math.max(parseMaxTime(animationDelayStyle), animationDelay);
	
	              var aDuration  = parseMaxTime(elementStyles[ANIMATION_PROP + DURATION_KEY]);
	
	              if(aDuration > 0) {
	                aDuration *= parseInt(elementStyles[ANIMATION_PROP + ANIMATION_ITERATION_COUNT_KEY], 10) || 1;
	              }
	
	              animationDuration = Math.max(aDuration, animationDuration);
	            }
	          });
	          data = {
	            total : 0,
	            transitionPropertyStyle: transitionPropertyStyle,
	            transitionDurationStyle: transitionDurationStyle,
	            transitionDelayStyle: transitionDelayStyle,
	            transitionDelay: transitionDelay,
	            transitionDuration: transitionDuration,
	            animationDelayStyle: animationDelayStyle,
	            animationDelay: animationDelay,
	            animationDuration: animationDuration
	          };
	          if(cacheKey) {
	            lookupCache[cacheKey] = data;
	          }
	        }
	        return data;
	      }
	
	      function parseMaxTime(str) {
	        var maxValue = 0;
	        var values = angular.isString(str) ?
	          str.split(/\s*,\s*/) :
	          [];
	        forEach(values, function(value) {
	          maxValue = Math.max(parseFloat(value) || 0, maxValue);
	        });
	        return maxValue;
	      }
	
	      function getCacheKey(element) {
	        var parentElement = element.parent();
	        var parentID = parentElement.data(NG_ANIMATE_PARENT_KEY);
	        if(!parentID) {
	          parentElement.data(NG_ANIMATE_PARENT_KEY, ++parentCounter);
	          parentID = parentCounter;
	        }
	        return parentID + '-' + extractElementNode(element).getAttribute('class');
	      }
	
	      function animateSetup(animationEvent, element, className, calculationDecorator) {
	        var cacheKey = getCacheKey(element);
	        var eventCacheKey = cacheKey + ' ' + className;
	        var itemIndex = lookupCache[eventCacheKey] ? ++lookupCache[eventCacheKey].total : 0;
	
	        var stagger = {};
	        if(itemIndex > 0) {
	          var staggerClassName = className + '-stagger';
	          var staggerCacheKey = cacheKey + ' ' + staggerClassName;
	          var applyClasses = !lookupCache[staggerCacheKey];
	
	          applyClasses && element.addClass(staggerClassName);
	
	          stagger = getElementAnimationDetails(element, staggerCacheKey);
	
	          applyClasses && element.removeClass(staggerClassName);
	        }
	
	        /* the animation itself may need to add/remove special CSS classes
	         * before calculating the anmation styles */
	        calculationDecorator = calculationDecorator ||
	                               function(fn) { return fn(); };
	
	        element.addClass(className);
	
	        var formerData = element.data(NG_ANIMATE_CSS_DATA_KEY) || {};
	
	        var timings = calculationDecorator(function() {
	          return getElementAnimationDetails(element, eventCacheKey);
	        });
	
	        var transitionDuration = timings.transitionDuration;
	        var animationDuration = timings.animationDuration;
	        if(transitionDuration === 0 && animationDuration === 0) {
	          element.removeClass(className);
	          return false;
	        }
	
	        element.data(NG_ANIMATE_CSS_DATA_KEY, {
	          running : formerData.running || 0,
	          itemIndex : itemIndex,
	          stagger : stagger,
	          timings : timings,
	          closeAnimationFn : noop
	        });
	
	        //temporarily disable the transition so that the enter styles
	        //don't animate twice (this is here to avoid a bug in Chrome/FF).
	        var isCurrentlyAnimating = formerData.running > 0 || animationEvent == 'setClass';
	        if(transitionDuration > 0) {
	          blockTransitions(element, className, isCurrentlyAnimating);
	        }
	
	        //staggering keyframe animations work by adjusting the `animation-delay` CSS property
	        //on the given element, however, the delay value can only calculated after the reflow
	        //since by that time $animate knows how many elements are being animated. Therefore,
	        //until the reflow occurs the element needs to be blocked (where the keyframe animation
	        //is set to `none 0s`). This blocking mechanism should only be set for when a stagger
	        //animation is detected and when the element item index is greater than 0.
	        if(animationDuration > 0 && stagger.animationDelay > 0 && stagger.animationDuration === 0) {
	          blockKeyframeAnimations(element);
	        }
	
	        return true;
	      }
	
	      function isStructuralAnimation(className) {
	        return className == 'ng-enter' || className == 'ng-move' || className == 'ng-leave';
	      }
	
	      function blockTransitions(element, className, isAnimating) {
	        if(isStructuralAnimation(className) || !isAnimating) {
	          extractElementNode(element).style[TRANSITION_PROP + PROPERTY_KEY] = 'none';
	        } else {
	          element.addClass(NG_ANIMATE_BLOCK_CLASS_NAME);
	        }
	      }
	
	      function blockKeyframeAnimations(element) {
	        extractElementNode(element).style[ANIMATION_PROP] = 'none 0s';
	      }
	
	      function unblockTransitions(element, className) {
	        var prop = TRANSITION_PROP + PROPERTY_KEY;
	        var node = extractElementNode(element);
	        if(node.style[prop] && node.style[prop].length > 0) {
	          node.style[prop] = '';
	        }
	        element.removeClass(NG_ANIMATE_BLOCK_CLASS_NAME);
	      }
	
	      function unblockKeyframeAnimations(element) {
	        var prop = ANIMATION_PROP;
	        var node = extractElementNode(element);
	        if(node.style[prop] && node.style[prop].length > 0) {
	          node.style[prop] = '';
	        }
	      }
	
	      function animateRun(animationEvent, element, className, activeAnimationComplete) {
	        var node = extractElementNode(element);
	        var elementData = element.data(NG_ANIMATE_CSS_DATA_KEY);
	        if(node.getAttribute('class').indexOf(className) == -1 || !elementData) {
	          activeAnimationComplete();
	          return;
	        }
	
	        var activeClassName = '';
	        forEach(className.split(' '), function(klass, i) {
	          activeClassName += (i > 0 ? ' ' : '') + klass + '-active';
	        });
	
	        var stagger = elementData.stagger;
	        var timings = elementData.timings;
	        var itemIndex = elementData.itemIndex;
	        var maxDuration = Math.max(timings.transitionDuration, timings.animationDuration);
	        var maxDelay = Math.max(timings.transitionDelay, timings.animationDelay);
	        var maxDelayTime = maxDelay * ONE_SECOND;
	
	        var startTime = Date.now();
	        var css3AnimationEvents = ANIMATIONEND_EVENT + ' ' + TRANSITIONEND_EVENT;
	
	        var style = '', appliedStyles = [];
	        if(timings.transitionDuration > 0) {
	          var propertyStyle = timings.transitionPropertyStyle;
	          if(propertyStyle.indexOf('all') == -1) {
	            style += CSS_PREFIX + 'transition-property: ' + propertyStyle + ';';
	            style += CSS_PREFIX + 'transition-duration: ' + timings.transitionDurationStyle + ';';
	            appliedStyles.push(CSS_PREFIX + 'transition-property');
	            appliedStyles.push(CSS_PREFIX + 'transition-duration');
	          }
	        }
	
	        if(itemIndex > 0) {
	          if(stagger.transitionDelay > 0 && stagger.transitionDuration === 0) {
	            var delayStyle = timings.transitionDelayStyle;
	            style += CSS_PREFIX + 'transition-delay: ' +
	                     prepareStaggerDelay(delayStyle, stagger.transitionDelay, itemIndex) + '; ';
	            appliedStyles.push(CSS_PREFIX + 'transition-delay');
	          }
	
	          if(stagger.animationDelay > 0 && stagger.animationDuration === 0) {
	            style += CSS_PREFIX + 'animation-delay: ' +
	                     prepareStaggerDelay(timings.animationDelayStyle, stagger.animationDelay, itemIndex) + '; ';
	            appliedStyles.push(CSS_PREFIX + 'animation-delay');
	          }
	        }
	
	        if(appliedStyles.length > 0) {
	          //the element being animated may sometimes contain comment nodes in
	          //the jqLite object, so we're safe to use a single variable to house
	          //the styles since there is always only one element being animated
	          var oldStyle = node.getAttribute('style') || '';
	          node.setAttribute('style', oldStyle + '; ' + style);
	        }
	
	        element.on(css3AnimationEvents, onAnimationProgress);
	        element.addClass(activeClassName);
	        elementData.closeAnimationFn = function() {
	          onEnd();
	          activeAnimationComplete();
	        };
	
	        var staggerTime       = itemIndex * (Math.max(stagger.animationDelay, stagger.transitionDelay) || 0);
	        var animationTime     = (maxDelay + maxDuration) * CLOSING_TIME_BUFFER;
	        var totalTime         = (staggerTime + animationTime) * ONE_SECOND;
	
	        elementData.running++;
	        animationCloseHandler(element, totalTime);
	        return onEnd;
	
	        // This will automatically be called by $animate so
	        // there is no need to attach this internally to the
	        // timeout done method.
	        function onEnd(cancelled) {
	          element.off(css3AnimationEvents, onAnimationProgress);
	          element.removeClass(activeClassName);
	          animateClose(element, className);
	          var node = extractElementNode(element);
	          for (var i in appliedStyles) {
	            node.style.removeProperty(appliedStyles[i]);
	          }
	        }
	
	        function onAnimationProgress(event) {
	          event.stopPropagation();
	          var ev = event.originalEvent || event;
	          var timeStamp = ev.$manualTimeStamp || Date.now();
	
	          /* Firefox (or possibly just Gecko) likes to not round values up
	           * when a ms measurement is used for the animation */
	          var elapsedTime = parseFloat(ev.elapsedTime.toFixed(ELAPSED_TIME_MAX_DECIMAL_PLACES));
	
	          /* $manualTimeStamp is a mocked timeStamp value which is set
	           * within browserTrigger(). This is only here so that tests can
	           * mock animations properly. Real events fallback to Date.now(),
	           * or, if they don't, then a timeStamp is automatically created for them.
	           * We're checking to see if the timeStamp surpasses the expected delay,
	           * but we're using elapsedTime instead of the timeStamp on the 2nd
	           * pre-condition since animations sometimes close off early */
	          if(Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
	            activeAnimationComplete();
	          }
	        }
	      }
	
	      function prepareStaggerDelay(delayStyle, staggerDelay, index) {
	        var style = '';
	        forEach(delayStyle.split(','), function(val, i) {
	          style += (i > 0 ? ',' : '') +
	                   (index * staggerDelay + parseInt(val, 10)) + 's';
	        });
	        return style;
	      }
	
	      function animateBefore(animationEvent, element, className, calculationDecorator) {
	        if(animateSetup(animationEvent, element, className, calculationDecorator)) {
	          return function(cancelled) {
	            cancelled && animateClose(element, className);
	          };
	        }
	      }
	
	      function animateAfter(animationEvent, element, className, afterAnimationComplete) {
	        if(element.data(NG_ANIMATE_CSS_DATA_KEY)) {
	          return animateRun(animationEvent, element, className, afterAnimationComplete);
	        } else {
	          animateClose(element, className);
	          afterAnimationComplete();
	        }
	      }
	
	      function animate(animationEvent, element, className, animationComplete) {
	        //If the animateSetup function doesn't bother returning a
	        //cancellation function then it means that there is no animation
	        //to perform at all
	        var preReflowCancellation = animateBefore(animationEvent, element, className);
	        if (!preReflowCancellation) {
	          clearCacheAfterReflow();
	          animationComplete();
	          return;
	        }
	
	        //There are two cancellation functions: one is before the first
	        //reflow animation and the second is during the active state
	        //animation. The first function will take care of removing the
	        //data from the element which will not make the 2nd animation
	        //happen in the first place
	        var cancel = preReflowCancellation;
	        afterReflow(element, function() {
	          unblockTransitions(element, className);
	          unblockKeyframeAnimations(element);
	          //once the reflow is complete then we point cancel to
	          //the new cancellation function which will remove all of the
	          //animation properties from the active animation
	          cancel = animateAfter(animationEvent, element, className, animationComplete);
	        });
	
	        return function(cancelled) {
	          (cancel || noop)(cancelled);
	        };
	      }
	
	      function animateClose(element, className) {
	        element.removeClass(className);
	        var data = element.data(NG_ANIMATE_CSS_DATA_KEY);
	        if(data) {
	          if(data.running) {
	            data.running--;
	          }
	          if(!data.running || data.running === 0) {
	            element.removeData(NG_ANIMATE_CSS_DATA_KEY);
	          }
	        }
	      }
	
	      return {
	        enter : function(element, animationCompleted) {
	          return animate('enter', element, 'ng-enter', animationCompleted);
	        },
	
	        leave : function(element, animationCompleted) {
	          return animate('leave', element, 'ng-leave', animationCompleted);
	        },
	
	        move : function(element, animationCompleted) {
	          return animate('move', element, 'ng-move', animationCompleted);
	        },
	
	        beforeSetClass : function(element, add, remove, animationCompleted) {
	          var className = suffixClasses(remove, '-remove') + ' ' +
	                          suffixClasses(add, '-add');
	          var cancellationMethod = animateBefore('setClass', element, className, function(fn) {
	            /* when classes are removed from an element then the transition style
	             * that is applied is the transition defined on the element without the
	             * CSS class being there. This is how CSS3 functions outside of ngAnimate.
	             * http://plnkr.co/edit/j8OzgTNxHTb4n3zLyjGW?p=preview */
	            var klass = element.attr('class');
	            element.removeClass(remove);
	            element.addClass(add);
	            var timings = fn();
	            element.attr('class', klass);
	            return timings;
	          });
	
	          if(cancellationMethod) {
	            afterReflow(element, function() {
	              unblockTransitions(element, className);
	              unblockKeyframeAnimations(element);
	              animationCompleted();
	            });
	            return cancellationMethod;
	          }
	          clearCacheAfterReflow();
	          animationCompleted();
	        },
	
	        beforeAddClass : function(element, className, animationCompleted) {
	          var cancellationMethod = animateBefore('addClass', element, suffixClasses(className, '-add'), function(fn) {
	
	            /* when a CSS class is added to an element then the transition style that
	             * is applied is the transition defined on the element when the CSS class
	             * is added at the time of the animation. This is how CSS3 functions
	             * outside of ngAnimate. */
	            element.addClass(className);
	            var timings = fn();
	            element.removeClass(className);
	            return timings;
	          });
	
	          if(cancellationMethod) {
	            afterReflow(element, function() {
	              unblockTransitions(element, className);
	              unblockKeyframeAnimations(element);
	              animationCompleted();
	            });
	            return cancellationMethod;
	          }
	          clearCacheAfterReflow();
	          animationCompleted();
	        },
	
	        setClass : function(element, add, remove, animationCompleted) {
	          remove = suffixClasses(remove, '-remove');
	          add = suffixClasses(add, '-add');
	          var className = remove + ' ' + add;
	          return animateAfter('setClass', element, className, animationCompleted);
	        },
	
	        addClass : function(element, className, animationCompleted) {
	          return animateAfter('addClass', element, suffixClasses(className, '-add'), animationCompleted);
	        },
	
	        beforeRemoveClass : function(element, className, animationCompleted) {
	          var cancellationMethod = animateBefore('removeClass', element, suffixClasses(className, '-remove'), function(fn) {
	            /* when classes are removed from an element then the transition style
	             * that is applied is the transition defined on the element without the
	             * CSS class being there. This is how CSS3 functions outside of ngAnimate.
	             * http://plnkr.co/edit/j8OzgTNxHTb4n3zLyjGW?p=preview */
	            var klass = element.attr('class');
	            element.removeClass(className);
	            var timings = fn();
	            element.attr('class', klass);
	            return timings;
	          });
	
	          if(cancellationMethod) {
	            afterReflow(element, function() {
	              unblockTransitions(element, className);
	              unblockKeyframeAnimations(element);
	              animationCompleted();
	            });
	            return cancellationMethod;
	          }
	          animationCompleted();
	        },
	
	        removeClass : function(element, className, animationCompleted) {
	          return animateAfter('removeClass', element, suffixClasses(className, '-remove'), animationCompleted);
	        }
	      };
	
	      function suffixClasses(classes, suffix) {
	        var className = '';
	        classes = angular.isArray(classes) ? classes : classes.split(/\s+/);
	        forEach(classes, function(klass, i) {
	          if(klass && klass.length > 0) {
	            className += (i > 0 ? ' ' : '') + klass + suffix;
	          }
	        });
	        return className;
	      }
	    }]);
	  }]);
	
	
	})(window, window.angular);


/***/ }),
/* 163 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.2.32
	 * (c) 2010-2014 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular, undefined) {'use strict';
	
	/**
	 * @ngdoc module
	 * @name ngCookies
	 * @description
	 *
	 * # ngCookies
	 *
	 * The `ngCookies` module provides a convenient wrapper for reading and writing browser cookies.
	 *
	 *
	 * <div doc-module-components="ngCookies"></div>
	 *
	 * See {@link ngCookies.$cookies `$cookies`} and
	 * {@link ngCookies.$cookieStore `$cookieStore`} for usage.
	 */
	
	
	angular.module('ngCookies', ['ng']).
	  /**
	   * @ngdoc service
	   * @name $cookies
	   *
	   * @description
	   * Provides read/write access to browser's cookies.
	   *
	   * Only a simple Object is exposed and by adding or removing properties to/from this object, new
	   * cookies are created/deleted at the end of current $eval.
	   * The object's properties can only be strings.
	   *
	   * Requires the {@link ngCookies `ngCookies`} module to be installed.
	   *
	   * @example
	   *
	   * ```js
	   * angular.module('cookiesExample', ['ngCookies'])
	   *   .controller('ExampleController', ['$cookies', function($cookies) {
	   *     // Retrieving a cookie
	   *     var favoriteCookie = $cookies.myFavorite;
	   *     // Setting a cookie
	   *     $cookies.myFavorite = 'oatmeal';
	   *   }]);
	   * ```
	   */
	   factory('$cookies', ['$rootScope', '$browser', function ($rootScope, $browser) {
	      var cookies = {},
	          lastCookies = {},
	          lastBrowserCookies,
	          runEval = false,
	          copy = angular.copy,
	          isUndefined = angular.isUndefined;
	
	      //creates a poller fn that copies all cookies from the $browser to service & inits the service
	      $browser.addPollFn(function() {
	        var currentCookies = $browser.cookies();
	        if (lastBrowserCookies != currentCookies) { //relies on browser.cookies() impl
	          lastBrowserCookies = currentCookies;
	          copy(currentCookies, lastCookies);
	          copy(currentCookies, cookies);
	          if (runEval) $rootScope.$apply();
	        }
	      })();
	
	      runEval = true;
	
	      //at the end of each eval, push cookies
	      //TODO: this should happen before the "delayed" watches fire, because if some cookies are not
	      //      strings or browser refuses to store some cookies, we update the model in the push fn.
	      $rootScope.$watch(push);
	
	      return cookies;
	
	
	      /**
	       * Pushes all the cookies from the service to the browser and verifies if all cookies were
	       * stored.
	       */
	      function push() {
	        var name,
	            value,
	            browserCookies,
	            updated;
	
	        //delete any cookies deleted in $cookies
	        for (name in lastCookies) {
	          if (isUndefined(cookies[name])) {
	            $browser.cookies(name, undefined);
	          }
	        }
	
	        //update all cookies updated in $cookies
	        for(name in cookies) {
	          value = cookies[name];
	          if (!angular.isString(value)) {
	            value = '' + value;
	            cookies[name] = value;
	          }
	          if (value !== lastCookies[name]) {
	            $browser.cookies(name, value);
	            updated = true;
	          }
	        }
	
	        //verify what was actually stored
	        if (updated){
	          updated = false;
	          browserCookies = $browser.cookies();
	
	          for (name in cookies) {
	            if (cookies[name] !== browserCookies[name]) {
	              //delete or reset all cookies that the browser dropped from $cookies
	              if (isUndefined(browserCookies[name])) {
	                delete cookies[name];
	              } else {
	                cookies[name] = browserCookies[name];
	              }
	              updated = true;
	            }
	          }
	        }
	      }
	    }]).
	
	
	  /**
	   * @ngdoc service
	   * @name $cookieStore
	   * @requires $cookies
	   *
	   * @description
	   * Provides a key-value (string-object) storage, that is backed by session cookies.
	   * Objects put or retrieved from this storage are automatically serialized or
	   * deserialized by angular's toJson/fromJson.
	   *
	   * Requires the {@link ngCookies `ngCookies`} module to be installed.
	   *
	   * @example
	   *
	   * ```js
	   * angular.module('cookieStoreExample', ['ngCookies'])
	   *   .controller('ExampleController', ['$cookieStore', function($cookieStore) {
	   *     // Put cookie
	   *     $cookieStore.put('myFavorite','oatmeal');
	   *     // Get cookie
	   *     var favoriteCookie = $cookieStore.get('myFavorite');
	   *     // Removing a cookie
	   *     $cookieStore.remove('myFavorite');
	   *   }]);
	   * ```
	   */
	   factory('$cookieStore', ['$cookies', function($cookies) {
	
	      return {
	        /**
	         * @ngdoc method
	         * @name $cookieStore#get
	         *
	         * @description
	         * Returns the value of given cookie key
	         *
	         * @param {string} key Id to use for lookup.
	         * @returns {Object} Deserialized cookie value.
	         */
	        get: function(key) {
	          var value = $cookies[key];
	          return value ? angular.fromJson(value) : value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookieStore#put
	         *
	         * @description
	         * Sets a value for given cookie key
	         *
	         * @param {string} key Id for the `value`.
	         * @param {Object} value Value to be stored.
	         */
	        put: function(key, value) {
	          $cookies[key] = angular.toJson(value);
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookieStore#remove
	         *
	         * @description
	         * Remove given cookie
	         *
	         * @param {string} key Id of the key-value pair to delete.
	         */
	        remove: function(key) {
	          delete $cookies[key];
	        }
	      };
	
	    }]);
	
	
	})(window, window.angular);


/***/ }),
/* 164 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.2.32
	 * (c) 2010-2014 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular, undefined) {'use strict';
	
	var $sanitizeMinErr = angular.$$minErr('$sanitize');
	
	/**
	 * @ngdoc module
	 * @name ngSanitize
	 * @description
	 *
	 * # ngSanitize
	 *
	 * The `ngSanitize` module provides functionality to sanitize HTML.
	 *
	 *
	 * <div doc-module-components="ngSanitize"></div>
	 *
	 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
	 */
	
	/*
	 * HTML Parser By Misko Hevery (misko@hevery.com)
	 * based on:  HTML Parser By John Resig (ejohn.org)
	 * Original code by Erik Arvidsson, Mozilla Public License
	 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
	 *
	 * // Use like so:
	 * htmlParser(htmlString, {
	 *     start: function(tag, attrs, unary) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * });
	 *
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $sanitize
	 * @kind function
	 *
	 * @description
	 *   The input is sanitized by parsing the html into tokens. All safe tokens (from a whitelist) are
	 *   then serialized back to properly escaped html string. This means that no unsafe input can make
	 *   it into the returned string, however, since our parser is more strict than a typical browser
	 *   parser, it's possible that some obscure input, which would be recognized as valid HTML by a
	 *   browser, won't make it through the sanitizer.
	 *   The whitelist is configured using the functions `aHrefSanitizationWhitelist` and
	 *   `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider `$compileProvider`}.
	 *
	 * @param {string} html Html input.
	 * @returns {string} Sanitized html.
	 *
	 * @example
	   <example module="sanitizeExample" deps="angular-sanitize.js">
	   <file name="index.html">
	     <script>
	         angular.module('sanitizeExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
	             $scope.snippet =
	               '<p style="color:blue">an html\n' +
	               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
	               'snippet</p>';
	             $scope.deliberatelyTrustDangerousSnippet = function() {
	               return $sce.trustAsHtml($scope.snippet);
	             };
	           }]);
	     </script>
	     <div ng-controller="ExampleController">
	        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Directive</td>
	           <td>How</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="bind-html-with-sanitize">
	           <td>ng-bind-html</td>
	           <td>Automatically uses $sanitize</td>
	           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind-html="snippet"></div></td>
	         </tr>
	         <tr id="bind-html-with-trust">
	           <td>ng-bind-html</td>
	           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
	           <td>
	           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
	&lt;/div&gt;</pre>
	           </td>
	           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
	         </tr>
	         <tr id="bind-default">
	           <td>ng-bind</td>
	           <td>Automatically escapes</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	       </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should sanitize the html snippet by default', function() {
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
	     });
	
	     it('should inline raw snippet if bound to a trusted value', function() {
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).
	         toBe("<p style=\"color:blue\">an html\n" +
	              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
	              "snippet</p>");
	     });
	
	     it('should escape snippet without any filter', function() {
	       expect(element(by.css('#bind-default div')).getInnerHtml()).
	         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
	              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
	              "snippet&lt;/p&gt;");
	     });
	
	     it('should update', function() {
	       element(by.model('snippet')).clear();
	       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('new <b>text</b>');
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).toBe(
	         'new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-default div')).getInnerHtml()).toBe(
	         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
	     });
	   </file>
	   </example>
	 */
	function $SanitizeProvider() {
	  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
	    return function(html) {
	      var buf = [];
	      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
	        return !/^unsafe/.test($$sanitizeUri(uri, isImage));
	      }));
	      return buf.join('');
	    };
	  }];
	}
	
	function sanitizeText(chars) {
	  var buf = [];
	  var writer = htmlSanitizeWriter(buf, angular.noop);
	  writer.chars(chars);
	  return buf.join('');
	}
	
	
	// Regular Expressions for parsing tags and attributes
	var START_TAG_REGEXP =
	       /^<((?:[a-zA-Z])[\w:-]*)((?:\s+[\w:-]+(?:\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)\s*(>?)/,
	  END_TAG_REGEXP = /^<\/\s*([\w:-]+)[^>]*>/,
	  ATTR_REGEXP = /([\w:-]+)(?:\s*=\s*(?:(?:"((?:[^"])*)")|(?:'((?:[^'])*)')|([^>\s]+)))?/g,
	  BEGIN_TAG_REGEXP = /^</,
	  BEGING_END_TAGE_REGEXP = /^<\//,
	  COMMENT_REGEXP = /<!--(.*?)-->/g,
	  DOCTYPE_REGEXP = /<!DOCTYPE([^>]*?)>/i,
	  CDATA_REGEXP = /<!\[CDATA\[(.*?)]]>/g,
	  SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	  // Match everything outside of normal chars and " (quote character)
	  NON_ALPHANUMERIC_REGEXP = /([^\#-~| |!])/g;
	
	
	// Good source of info about elements and attributes
	// http://dev.w3.org/html5/spec/Overview.html#semantics
	// http://simon.html5.org/html-elements
	
	// Safe Void Elements - HTML5
	// http://dev.w3.org/html5/spec/Overview.html#void-elements
	var voidElements = makeMap("area,br,col,hr,img,wbr");
	
	// Elements that you can, intentionally, leave open (and which close themselves)
	// http://dev.w3.org/html5/spec/Overview.html#optional-tags
	var optionalEndTagBlockElements = makeMap("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr"),
	    optionalEndTagInlineElements = makeMap("rp,rt"),
	    optionalEndTagElements = angular.extend({},
	                                            optionalEndTagInlineElements,
	                                            optionalEndTagBlockElements);
	
	// Safe Block Elements - HTML5
	var blockElements = angular.extend({}, optionalEndTagBlockElements, makeMap("address,article," +
	        "aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5," +
	        "h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,script,section,table,ul"));
	
	// Inline Elements - HTML5
	var inlineElements = angular.extend({}, optionalEndTagInlineElements, makeMap("a,abbr,acronym,b," +
	        "bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s," +
	        "samp,small,span,strike,strong,sub,sup,time,tt,u,var"));
	
	
	// Special Elements (can contain anything)
	var specialElements = makeMap("script,style");
	
	var validElements = angular.extend({},
	                                   voidElements,
	                                   blockElements,
	                                   inlineElements,
	                                   optionalEndTagElements);
	
	//Attributes that have href and hence need to be sanitized
	var uriAttrs = makeMap("background,cite,href,longdesc,src");
	var validAttrs = angular.extend({}, uriAttrs, makeMap(
	    'abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,'+
	    'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,'+
	    'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,'+
	    'scope,scrolling,shape,size,span,start,summary,target,title,type,'+
	    'valign,value,vspace,width'));
	
	function makeMap(str) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) obj[items[i]] = true;
	  return obj;
	}
	
	
	/**
	 * @example
	 * htmlParser(htmlString, {
	 *     start: function(tag, attrs, unary) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * });
	 *
	 * @param {string} html string
	 * @param {object} handler
	 */
	function htmlParser( html, handler ) {
	  if (typeof html !== 'string') {
	    if (html === null || typeof html === 'undefined') {
	      html = '';
	    } else {
	      html = '' + html;
	    }
	  }
	  var index, chars, match, stack = [], last = html, text;
	  stack.last = function() { return stack[ stack.length - 1 ]; };
	
	  while ( html ) {
	    text = '';
	    chars = true;
	
	    // Make sure we're not in a script or style element
	    if ( !stack.last() || !specialElements[ stack.last() ] ) {
	
	      // Comment
	      if ( html.indexOf("<!--") === 0 ) {
	        // comments containing -- are not allowed unless they terminate the comment
	        index = html.indexOf("--", 4);
	
	        if ( index >= 0 && html.lastIndexOf("-->", index) === index) {
	          if (handler.comment) handler.comment( html.substring( 4, index ) );
	          html = html.substring( index + 3 );
	          chars = false;
	        }
	      // DOCTYPE
	      } else if ( DOCTYPE_REGEXP.test(html) ) {
	        match = html.match( DOCTYPE_REGEXP );
	
	        if ( match ) {
	          html = html.replace( match[0], '');
	          chars = false;
	        }
	      // end tag
	      } else if ( BEGING_END_TAGE_REGEXP.test(html) ) {
	        match = html.match( END_TAG_REGEXP );
	
	        if ( match ) {
	          html = html.substring( match[0].length );
	          match[0].replace( END_TAG_REGEXP, parseEndTag );
	          chars = false;
	        }
	
	      // start tag
	      } else if ( BEGIN_TAG_REGEXP.test(html) ) {
	        match = html.match( START_TAG_REGEXP );
	
	        if ( match ) {
	          // We only have a valid start-tag if there is a '>'.
	          if ( match[4] ) {
	            html = html.substring( match[0].length );
	            match[0].replace( START_TAG_REGEXP, parseStartTag );
	          }
	          chars = false;
	        } else {
	          // no ending tag found --- this piece should be encoded as an entity.
	          text += '<';
	          html = html.substring(1);
	        }
	      }
	
	      if ( chars ) {
	        index = html.indexOf("<");
	
	        text += index < 0 ? html : html.substring( 0, index );
	        html = index < 0 ? "" : html.substring( index );
	
	        if (handler.chars) handler.chars( decodeEntities(text) );
	      }
	
	    } else {
	      html = html.replace(new RegExp("(.*)<\\s*\\/\\s*" + stack.last() + "[^>]*>", 'i'),
	        function(all, text){
	          text = text.replace(COMMENT_REGEXP, "$1").replace(CDATA_REGEXP, "$1");
	
	          if (handler.chars) handler.chars( decodeEntities(text) );
	
	          return "";
	      });
	
	      parseEndTag( "", stack.last() );
	    }
	
	    if ( html == last ) {
	      throw $sanitizeMinErr('badparse', "The sanitizer was unable to parse the following block " +
	                                        "of html: {0}", html);
	    }
	    last = html;
	  }
	
	  // Clean up any remaining tags
	  parseEndTag();
	
	  function parseStartTag( tag, tagName, rest, unary ) {
	    tagName = angular.lowercase(tagName);
	    if ( blockElements[ tagName ] ) {
	      while ( stack.last() && inlineElements[ stack.last() ] ) {
	        parseEndTag( "", stack.last() );
	      }
	    }
	
	    if ( optionalEndTagElements[ tagName ] && stack.last() == tagName ) {
	      parseEndTag( "", tagName );
	    }
	
	    unary = voidElements[ tagName ] || !!unary;
	
	    if ( !unary )
	      stack.push( tagName );
	
	    var attrs = {};
	
	    rest.replace(ATTR_REGEXP,
	      function(match, name, doubleQuotedValue, singleQuotedValue, unquotedValue) {
	        var value = doubleQuotedValue
	          || singleQuotedValue
	          || unquotedValue
	          || '';
	
	        attrs[name] = decodeEntities(value);
	    });
	    if (handler.start) handler.start( tagName, attrs, unary );
	  }
	
	  function parseEndTag( tag, tagName ) {
	    var pos = 0, i;
	    tagName = angular.lowercase(tagName);
	    if ( tagName )
	      // Find the closest opened tag of the same type
	      for ( pos = stack.length - 1; pos >= 0; pos-- )
	        if ( stack[ pos ] == tagName )
	          break;
	
	    if ( pos >= 0 ) {
	      // Close all the open elements, up the stack
	      for ( i = stack.length - 1; i >= pos; i-- )
	        if (handler.end) handler.end( stack[ i ] );
	
	      // Remove the open elements from the stack
	      stack.length = pos;
	    }
	  }
	}
	
	var hiddenPre=document.createElement("pre");
	var spaceRe = /^(\s*)([\s\S]*?)(\s*)$/;
	/**
	 * decodes all entities into regular string
	 * @param value
	 * @returns {string} A string with decoded entities.
	 */
	function decodeEntities(value) {
	  if (!value) { return ''; }
	
	  // Note: IE8 does not preserve spaces at the start/end of innerHTML
	  // so we must capture them and reattach them afterward
	  var parts = spaceRe.exec(value);
	  var spaceBefore = parts[1];
	  var spaceAfter = parts[3];
	  var content = parts[2];
	  if (content) {
	    hiddenPre.innerHTML=content.replace(/</g,"&lt;");
	    // innerText depends on styling as it doesn't display hidden elements.
	    // Therefore, it's better to use textContent not to cause unnecessary
	    // reflows. However, IE<9 don't support textContent so the innerText
	    // fallback is necessary.
	    content = 'textContent' in hiddenPre ?
	      hiddenPre.textContent : hiddenPre.innerText;
	  }
	  return spaceBefore + content + spaceAfter;
	}
	
	/**
	 * Escapes all potentially dangerous characters, so that the
	 * resulting string can be safely inserted into attribute or
	 * element text.
	 * @param value
	 * @returns {string} escaped text
	 */
	function encodeEntities(value) {
	  return value.
	    replace(/&/g, '&amp;').
	    replace(SURROGATE_PAIR_REGEXP, function (value) {
	      var hi = value.charCodeAt(0);
	      var low = value.charCodeAt(1);
	      return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
	    }).
	    replace(NON_ALPHANUMERIC_REGEXP, function(value){
	      return '&#' + value.charCodeAt(0) + ';';
	    }).
	    replace(/</g, '&lt;').
	    replace(/>/g, '&gt;');
	}
	
	/**
	 * create an HTML/XML writer which writes to buffer
	 * @param {Array} buf use buf.jain('') to get out sanitized html string
	 * @returns {object} in the form of {
	 *     start: function(tag, attrs, unary) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * }
	 */
	function htmlSanitizeWriter(buf, uriValidator){
	  var ignore = false;
	  var out = angular.bind(buf, buf.push);
	  return {
	    start: function(tag, attrs, unary){
	      tag = angular.lowercase(tag);
	      if (!ignore && specialElements[tag]) {
	        ignore = tag;
	      }
	      if (!ignore && validElements[tag] === true) {
	        out('<');
	        out(tag);
	        angular.forEach(attrs, function(value, key){
	          var lkey=angular.lowercase(key);
	          var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
	          if (validAttrs[lkey] === true &&
	            (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
	            out(' ');
	            out(key);
	            out('="');
	            out(encodeEntities(value));
	            out('"');
	          }
	        });
	        out(unary ? '/>' : '>');
	      }
	    },
	    end: function(tag){
	        tag = angular.lowercase(tag);
	        if (!ignore && validElements[tag] === true) {
	          out('</');
	          out(tag);
	          out('>');
	        }
	        if (tag == ignore) {
	          ignore = false;
	        }
	      },
	    chars: function(chars){
	        if (!ignore) {
	          out(encodeEntities(chars));
	        }
	      }
	  };
	}
	
	
	// define ngSanitize module and register $sanitize service
	angular.module('ngSanitize', []).provider('$sanitize', $SanitizeProvider);
	
	/* global sanitizeText: false */
	
	/**
	 * @ngdoc filter
	 * @name linky
	 * @kind function
	 *
	 * @description
	 * Finds links in text input and turns them into html links. Supports http/https/ftp/mailto and
	 * plain email address links.
	 *
	 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
	 *
	 * @param {string} text Input text.
	 * @param {string} target Window (_blank|_self|_parent|_top) or named frame to open links in.
	 * @returns {string} Html-linkified text.
	 *
	 * @usage
	   <span ng-bind-html="linky_expression | linky"></span>
	 *
	 * @example
	   <example module="linkyExample" deps="angular-sanitize.js">
	     <file name="index.html">
	       <script>
	         angular.module('linkyExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.snippet =
	               'Pretty text with some links:\n'+
	               'http://angularjs.org/,\n'+
	               'mailto:us@somewhere.org,\n'+
	               'another@somewhere.org,\n'+
	               'and one more: ftp://127.0.0.1/.';
	             $scope.snippetWithTarget = 'http://angularjs.org/';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Filter</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="linky-filter">
	           <td>linky filter</td>
	           <td>
	             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
	           </td>
	           <td>
	             <div ng-bind-html="snippet | linky"></div>
	           </td>
	         </tr>
	         <tr id="linky-target">
	          <td>linky target</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithTarget | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithTarget | linky:'_blank'"></div>
	          </td>
	         </tr>
	         <tr id="escaped-html">
	           <td>no filter</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should linkify the snippet with urls', function() {
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
	       });
	
	       it('should not linkify snippet without the linky filter', function() {
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
	       });
	
	       it('should update', function() {
	         element(by.model('snippet')).clear();
	         element(by.model('snippet')).sendKeys('new http://link.');
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('new http://link.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
	             .toBe('new http://link.');
	       });
	
	       it('should work with the target property', function() {
	        expect(element(by.id('linky-target')).
	            element(by.binding("snippetWithTarget | linky:'_blank'")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
	       });
	     </file>
	   </example>
	 */
	angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
	  var LINKY_URL_REGEXP =
	        /((ftp|https?):\/\/|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"]/,
	      MAILTO_REGEXP = /^mailto:/;
	
	  return function(text, target) {
	    if (!text) return text;
	    var match;
	    var raw = text;
	    var html = [];
	    var url;
	    var i;
	    while ((match = raw.match(LINKY_URL_REGEXP))) {
	      // We can not end in these as they are sometimes found at the end of the sentence
	      url = match[0];
	      // if we did not match ftp/http/mailto then assume mailto
	      if (match[2] == match[3]) url = 'mailto:' + url;
	      i = match.index;
	      addText(raw.substr(0, i));
	      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
	      raw = raw.substring(i + match[0].length);
	    }
	    addText(raw);
	    return $sanitize(html.join(''));
	
	    function addText(text) {
	      if (!text) {
	        return;
	      }
	      html.push(sanitizeText(text));
	    }
	
	    function addLink(url, text) {
	      html.push('<a ');
	      if (angular.isDefined(target)) {
	        html.push('target="');
	        html.push(target);
	        html.push('" ');
	      }
	      html.push('href="',
	                url.replace('"', '&quot;'),
	                '">');
	      addText(text);
	      html.push('</a>');
	    }
	  };
	}]);
	
	
	})(window, window.angular);


/***/ }),
/* 165 */
/***/ (function(module, exports) {

	/**
	 * State-based routing for AngularJS
	 * @version v0.2.18
	 * @link http://angular-ui.github.com/
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	
	/* commonjs package manager support (eg componentjs) */
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports){
	  module.exports = 'ui.router';
	}
	
	(function (window, angular, undefined) {
	/*jshint globalstrict:true*/
	/*global angular:false*/
	'use strict';
	
	var isDefined = angular.isDefined,
	    isFunction = angular.isFunction,
	    isString = angular.isString,
	    isObject = angular.isObject,
	    isArray = angular.isArray,
	    forEach = angular.forEach,
	    extend = angular.extend,
	    copy = angular.copy,
	    toJson = angular.toJson;
	
	function inherit(parent, extra) {
	  return extend(new (extend(function() {}, { prototype: parent }))(), extra);
	}
	
	function merge(dst) {
	  forEach(arguments, function(obj) {
	    if (obj !== dst) {
	      forEach(obj, function(value, key) {
	        if (!dst.hasOwnProperty(key)) dst[key] = value;
	      });
	    }
	  });
	  return dst;
	}
	
	/**
	 * Finds the common ancestor path between two states.
	 *
	 * @param {Object} first The first state.
	 * @param {Object} second The second state.
	 * @return {Array} Returns an array of state names in descending order, not including the root.
	 */
	function ancestors(first, second) {
	  var path = [];
	
	  for (var n in first.path) {
	    if (first.path[n] !== second.path[n]) break;
	    path.push(first.path[n]);
	  }
	  return path;
	}
	
	/**
	 * IE8-safe wrapper for `Object.keys()`.
	 *
	 * @param {Object} object A JavaScript object.
	 * @return {Array} Returns the keys of the object as an array.
	 */
	function objectKeys(object) {
	  if (Object.keys) {
	    return Object.keys(object);
	  }
	  var result = [];
	
	  forEach(object, function(val, key) {
	    result.push(key);
	  });
	  return result;
	}
	
	/**
	 * IE8-safe wrapper for `Array.prototype.indexOf()`.
	 *
	 * @param {Array} array A JavaScript array.
	 * @param {*} value A value to search the array for.
	 * @return {Number} Returns the array index value of `value`, or `-1` if not present.
	 */
	function indexOf(array, value) {
	  if (Array.prototype.indexOf) {
	    return array.indexOf(value, Number(arguments[2]) || 0);
	  }
	  var len = array.length >>> 0, from = Number(arguments[2]) || 0;
	  from = (from < 0) ? Math.ceil(from) : Math.floor(from);
	
	  if (from < 0) from += len;
	
	  for (; from < len; from++) {
	    if (from in array && array[from] === value) return from;
	  }
	  return -1;
	}
	
	/**
	 * Merges a set of parameters with all parameters inherited between the common parents of the
	 * current state and a given destination state.
	 *
	 * @param {Object} currentParams The value of the current state parameters ($stateParams).
	 * @param {Object} newParams The set of parameters which will be composited with inherited params.
	 * @param {Object} $current Internal definition of object representing the current state.
	 * @param {Object} $to Internal definition of object representing state to transition to.
	 */
	function inheritParams(currentParams, newParams, $current, $to) {
	  var parents = ancestors($current, $to), parentParams, inherited = {}, inheritList = [];
	
	  for (var i in parents) {
	    if (!parents[i] || !parents[i].params) continue;
	    parentParams = objectKeys(parents[i].params);
	    if (!parentParams.length) continue;
	
	    for (var j in parentParams) {
	      if (indexOf(inheritList, parentParams[j]) >= 0) continue;
	      inheritList.push(parentParams[j]);
	      inherited[parentParams[j]] = currentParams[parentParams[j]];
	    }
	  }
	  return extend({}, inherited, newParams);
	}
	
	/**
	 * Performs a non-strict comparison of the subset of two objects, defined by a list of keys.
	 *
	 * @param {Object} a The first object.
	 * @param {Object} b The second object.
	 * @param {Array} keys The list of keys within each object to compare. If the list is empty or not specified,
	 *                     it defaults to the list of keys in `a`.
	 * @return {Boolean} Returns `true` if the keys match, otherwise `false`.
	 */
	function equalForKeys(a, b, keys) {
	  if (!keys) {
	    keys = [];
	    for (var n in a) keys.push(n); // Used instead of Object.keys() for IE8 compatibility
	  }
	
	  for (var i=0; i<keys.length; i++) {
	    var k = keys[i];
	    if (a[k] != b[k]) return false; // Not '===', values aren't necessarily normalized
	  }
	  return true;
	}
	
	/**
	 * Returns the subset of an object, based on a list of keys.
	 *
	 * @param {Array} keys
	 * @param {Object} values
	 * @return {Boolean} Returns a subset of `values`.
	 */
	function filterByKeys(keys, values) {
	  var filtered = {};
	
	  forEach(keys, function (name) {
	    filtered[name] = values[name];
	  });
	  return filtered;
	}
	
	// like _.indexBy
	// when you know that your index values will be unique, or you want last-one-in to win
	function indexBy(array, propName) {
	  var result = {};
	  forEach(array, function(item) {
	    result[item[propName]] = item;
	  });
	  return result;
	}
	
	// extracted from underscore.js
	// Return a copy of the object only containing the whitelisted properties.
	function pick(obj) {
	  var copy = {};
	  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
	  forEach(keys, function(key) {
	    if (key in obj) copy[key] = obj[key];
	  });
	  return copy;
	}
	
	// extracted from underscore.js
	// Return a copy of the object omitting the blacklisted properties.
	function omit(obj) {
	  var copy = {};
	  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
	  for (var key in obj) {
	    if (indexOf(keys, key) == -1) copy[key] = obj[key];
	  }
	  return copy;
	}
	
	function pluck(collection, key) {
	  var result = isArray(collection) ? [] : {};
	
	  forEach(collection, function(val, i) {
	    result[i] = isFunction(key) ? key(val) : val[key];
	  });
	  return result;
	}
	
	function filter(collection, callback) {
	  var array = isArray(collection);
	  var result = array ? [] : {};
	  forEach(collection, function(val, i) {
	    if (callback(val, i)) {
	      result[array ? result.length : i] = val;
	    }
	  });
	  return result;
	}
	
	function map(collection, callback) {
	  var result = isArray(collection) ? [] : {};
	
	  forEach(collection, function(val, i) {
	    result[i] = callback(val, i);
	  });
	  return result;
	}
	
	/**
	 * @ngdoc overview
	 * @name ui.router.util
	 *
	 * @description
	 * # ui.router.util sub-module
	 *
	 * This module is a dependency of other sub-modules. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 *
	 */
	angular.module('ui.router.util', ['ng']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router.router
	 * 
	 * @requires ui.router.util
	 *
	 * @description
	 * # ui.router.router sub-module
	 *
	 * This module is a dependency of other sub-modules. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 */
	angular.module('ui.router.router', ['ui.router.util']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router.state
	 * 
	 * @requires ui.router.router
	 * @requires ui.router.util
	 *
	 * @description
	 * # ui.router.state sub-module
	 *
	 * This module is a dependency of the main ui.router module. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 * 
	 */
	angular.module('ui.router.state', ['ui.router.router', 'ui.router.util']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router
	 *
	 * @requires ui.router.state
	 *
	 * @description
	 * # ui.router
	 * 
	 * ## The main module for ui.router 
	 * There are several sub-modules included with the ui.router module, however only this module is needed
	 * as a dependency within your angular app. The other modules are for organization purposes. 
	 *
	 * The modules are:
	 * * ui.router - the main "umbrella" module
	 * * ui.router.router - 
	 * 
	 * *You'll need to include **only** this module as the dependency within your angular app.*
	 * 
	 * <pre>
	 * <!doctype html>
	 * <html ng-app="myApp">
	 * <head>
	 *   <script src="js/angular.js"></script>
	 *   <!-- Include the ui-router script -->
	 *   <script src="js/angular-ui-router.min.js"></script>
	 *   <script>
	 *     // ...and add 'ui.router' as a dependency
	 *     var myApp = angular.module('myApp', ['ui.router']);
	 *   </script>
	 * </head>
	 * <body>
	 * </body>
	 * </html>
	 * </pre>
	 */
	angular.module('ui.router', ['ui.router.state']);
	
	angular.module('ui.router.compat', ['ui.router']);
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$resolve
	 *
	 * @requires $q
	 * @requires $injector
	 *
	 * @description
	 * Manages resolution of (acyclic) graphs of promises.
	 */
	$Resolve.$inject = ['$q', '$injector'];
	function $Resolve(  $q,    $injector) {
	  
	  var VISIT_IN_PROGRESS = 1,
	      VISIT_DONE = 2,
	      NOTHING = {},
	      NO_DEPENDENCIES = [],
	      NO_LOCALS = NOTHING,
	      NO_PARENT = extend($q.when(NOTHING), { $$promises: NOTHING, $$values: NOTHING });
	  
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$resolve#study
	   * @methodOf ui.router.util.$resolve
	   *
	   * @description
	   * Studies a set of invocables that are likely to be used multiple times.
	   * <pre>
	   * $resolve.study(invocables)(locals, parent, self)
	   * </pre>
	   * is equivalent to
	   * <pre>
	   * $resolve.resolve(invocables, locals, parent, self)
	   * </pre>
	   * but the former is more efficient (in fact `resolve` just calls `study` 
	   * internally).
	   *
	   * @param {object} invocables Invocable objects
	   * @return {function} a function to pass in locals, parent and self
	   */
	  this.study = function (invocables) {
	    if (!isObject(invocables)) throw new Error("'invocables' must be an object");
	    var invocableKeys = objectKeys(invocables || {});
	    
	    // Perform a topological sort of invocables to build an ordered plan
	    var plan = [], cycle = [], visited = {};
	    function visit(value, key) {
	      if (visited[key] === VISIT_DONE) return;
	      
	      cycle.push(key);
	      if (visited[key] === VISIT_IN_PROGRESS) {
	        cycle.splice(0, indexOf(cycle, key));
	        throw new Error("Cyclic dependency: " + cycle.join(" -> "));
	      }
	      visited[key] = VISIT_IN_PROGRESS;
	      
	      if (isString(value)) {
	        plan.push(key, [ function() { return $injector.get(value); }], NO_DEPENDENCIES);
	      } else {
	        var params = $injector.annotate(value);
	        forEach(params, function (param) {
	          if (param !== key && invocables.hasOwnProperty(param)) visit(invocables[param], param);
	        });
	        plan.push(key, value, params);
	      }
	      
	      cycle.pop();
	      visited[key] = VISIT_DONE;
	    }
	    forEach(invocables, visit);
	    invocables = cycle = visited = null; // plan is all that's required
	    
	    function isResolve(value) {
	      return isObject(value) && value.then && value.$$promises;
	    }
	    
	    return function (locals, parent, self) {
	      if (isResolve(locals) && self === undefined) {
	        self = parent; parent = locals; locals = null;
	      }
	      if (!locals) locals = NO_LOCALS;
	      else if (!isObject(locals)) {
	        throw new Error("'locals' must be an object");
	      }       
	      if (!parent) parent = NO_PARENT;
	      else if (!isResolve(parent)) {
	        throw new Error("'parent' must be a promise returned by $resolve.resolve()");
	      }
	      
	      // To complete the overall resolution, we have to wait for the parent
	      // promise and for the promise for each invokable in our plan.
	      var resolution = $q.defer(),
	          result = resolution.promise,
	          promises = result.$$promises = {},
	          values = extend({}, locals),
	          wait = 1 + plan.length/3,
	          merged = false;
	          
	      function done() {
	        // Merge parent values we haven't got yet and publish our own $$values
	        if (!--wait) {
	          if (!merged) merge(values, parent.$$values); 
	          result.$$values = values;
	          result.$$promises = result.$$promises || true; // keep for isResolve()
	          delete result.$$inheritedValues;
	          resolution.resolve(values);
	        }
	      }
	      
	      function fail(reason) {
	        result.$$failure = reason;
	        resolution.reject(reason);
	      }
	
	      // Short-circuit if parent has already failed
	      if (isDefined(parent.$$failure)) {
	        fail(parent.$$failure);
	        return result;
	      }
	      
	      if (parent.$$inheritedValues) {
	        merge(values, omit(parent.$$inheritedValues, invocableKeys));
	      }
	
	      // Merge parent values if the parent has already resolved, or merge
	      // parent promises and wait if the parent resolve is still in progress.
	      extend(promises, parent.$$promises);
	      if (parent.$$values) {
	        merged = merge(values, omit(parent.$$values, invocableKeys));
	        result.$$inheritedValues = omit(parent.$$values, invocableKeys);
	        done();
	      } else {
	        if (parent.$$inheritedValues) {
	          result.$$inheritedValues = omit(parent.$$inheritedValues, invocableKeys);
	        }        
	        parent.then(done, fail);
	      }
	      
	      // Process each invocable in the plan, but ignore any where a local of the same name exists.
	      for (var i=0, ii=plan.length; i<ii; i+=3) {
	        if (locals.hasOwnProperty(plan[i])) done();
	        else invoke(plan[i], plan[i+1], plan[i+2]);
	      }
	      
	      function invoke(key, invocable, params) {
	        // Create a deferred for this invocation. Failures will propagate to the resolution as well.
	        var invocation = $q.defer(), waitParams = 0;
	        function onfailure(reason) {
	          invocation.reject(reason);
	          fail(reason);
	        }
	        // Wait for any parameter that we have a promise for (either from parent or from this
	        // resolve; in that case study() will have made sure it's ordered before us in the plan).
	        forEach(params, function (dep) {
	          if (promises.hasOwnProperty(dep) && !locals.hasOwnProperty(dep)) {
	            waitParams++;
	            promises[dep].then(function (result) {
	              values[dep] = result;
	              if (!(--waitParams)) proceed();
	            }, onfailure);
	          }
	        });
	        if (!waitParams) proceed();
	        function proceed() {
	          if (isDefined(result.$$failure)) return;
	          try {
	            invocation.resolve($injector.invoke(invocable, self, values));
	            invocation.promise.then(function (result) {
	              values[key] = result;
	              done();
	            }, onfailure);
	          } catch (e) {
	            onfailure(e);
	          }
	        }
	        // Publish promise synchronously; invocations further down in the plan may depend on it.
	        promises[key] = invocation.promise;
	      }
	      
	      return result;
	    };
	  };
	  
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$resolve#resolve
	   * @methodOf ui.router.util.$resolve
	   *
	   * @description
	   * Resolves a set of invocables. An invocable is a function to be invoked via 
	   * `$injector.invoke()`, and can have an arbitrary number of dependencies. 
	   * An invocable can either return a value directly,
	   * or a `$q` promise. If a promise is returned it will be resolved and the 
	   * resulting value will be used instead. Dependencies of invocables are resolved 
	   * (in this order of precedence)
	   *
	   * - from the specified `locals`
	   * - from another invocable that is part of this `$resolve` call
	   * - from an invocable that is inherited from a `parent` call to `$resolve` 
	   *   (or recursively
	   * - from any ancestor `$resolve` of that parent).
	   *
	   * The return value of `$resolve` is a promise for an object that contains 
	   * (in this order of precedence)
	   *
	   * - any `locals` (if specified)
	   * - the resolved return values of all injectables
	   * - any values inherited from a `parent` call to `$resolve` (if specified)
	   *
	   * The promise will resolve after the `parent` promise (if any) and all promises 
	   * returned by injectables have been resolved. If any invocable 
	   * (or `$injector.invoke`) throws an exception, or if a promise returned by an 
	   * invocable is rejected, the `$resolve` promise is immediately rejected with the 
	   * same error. A rejection of a `parent` promise (if specified) will likewise be 
	   * propagated immediately. Once the `$resolve` promise has been rejected, no 
	   * further invocables will be called.
	   * 
	   * Cyclic dependencies between invocables are not permitted and will cause `$resolve`
	   * to throw an error. As a special case, an injectable can depend on a parameter 
	   * with the same name as the injectable, which will be fulfilled from the `parent` 
	   * injectable of the same name. This allows inherited values to be decorated. 
	   * Note that in this case any other injectable in the same `$resolve` with the same
	   * dependency would see the decorated value, not the inherited value.
	   *
	   * Note that missing dependencies -- unlike cyclic dependencies -- will cause an 
	   * (asynchronous) rejection of the `$resolve` promise rather than a (synchronous) 
	   * exception.
	   *
	   * Invocables are invoked eagerly as soon as all dependencies are available. 
	   * This is true even for dependencies inherited from a `parent` call to `$resolve`.
	   *
	   * As a special case, an invocable can be a string, in which case it is taken to 
	   * be a service name to be passed to `$injector.get()`. This is supported primarily 
	   * for backwards-compatibility with the `resolve` property of `$routeProvider` 
	   * routes.
	   *
	   * @param {object} invocables functions to invoke or 
	   * `$injector` services to fetch.
	   * @param {object} locals  values to make available to the injectables
	   * @param {object} parent  a promise returned by another call to `$resolve`.
	   * @param {object} self  the `this` for the invoked methods
	   * @return {object} Promise for an object that contains the resolved return value
	   * of all invocables, as well as any inherited and local values.
	   */
	  this.resolve = function (invocables, locals, parent, self) {
	    return this.study(invocables)(locals, parent, self);
	  };
	}
	
	angular.module('ui.router.util').service('$resolve', $Resolve);
	
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$templateFactory
	 *
	 * @requires $http
	 * @requires $templateCache
	 * @requires $injector
	 *
	 * @description
	 * Service. Manages loading of templates.
	 */
	$TemplateFactory.$inject = ['$http', '$templateCache', '$injector'];
	function $TemplateFactory(  $http,   $templateCache,   $injector) {
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromConfig
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template from a configuration object. 
	   *
	   * @param {object} config Configuration object for which to load a template. 
	   * The following properties are search in the specified order, and the first one 
	   * that is defined is used to create the template:
	   *
	   * @param {string|object} config.template html string template or function to 
	   * load via {@link ui.router.util.$templateFactory#fromString fromString}.
	   * @param {string|object} config.templateUrl url to load or a function returning 
	   * the url to load via {@link ui.router.util.$templateFactory#fromUrl fromUrl}.
	   * @param {Function} config.templateProvider function to invoke via 
	   * {@link ui.router.util.$templateFactory#fromProvider fromProvider}.
	   * @param {object} params  Parameters to pass to the template function.
	   * @param {object} locals Locals to pass to `invoke` if the template is loaded 
	   * via a `templateProvider`. Defaults to `{ params: params }`.
	   *
	   * @return {string|object}  The template html as a string, or a promise for 
	   * that string,or `null` if no template is configured.
	   */
	  this.fromConfig = function (config, params, locals) {
	    return (
	      isDefined(config.template) ? this.fromString(config.template, params) :
	      isDefined(config.templateUrl) ? this.fromUrl(config.templateUrl, params) :
	      isDefined(config.templateProvider) ? this.fromProvider(config.templateProvider, params, locals) :
	      null
	    );
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromString
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template from a string or a function returning a string.
	   *
	   * @param {string|object} template html template as a string or function that 
	   * returns an html template as a string.
	   * @param {object} params Parameters to pass to the template function.
	   *
	   * @return {string|object} The template html as a string, or a promise for that 
	   * string.
	   */
	  this.fromString = function (template, params) {
	    return isFunction(template) ? template(params) : template;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromUrl
	   * @methodOf ui.router.util.$templateFactory
	   * 
	   * @description
	   * Loads a template from the a URL via `$http` and `$templateCache`.
	   *
	   * @param {string|Function} url url of the template to load, or a function 
	   * that returns a url.
	   * @param {Object} params Parameters to pass to the url function.
	   * @return {string|Promise.<string>} The template html as a string, or a promise 
	   * for that string.
	   */
	  this.fromUrl = function (url, params) {
	    if (isFunction(url)) url = url(params);
	    if (url == null) return null;
	    else return $http
	        .get(url, { cache: $templateCache, headers: { Accept: 'text/html' }})
	        .then(function(response) { return response.data; });
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromProvider
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template by invoking an injectable provider function.
	   *
	   * @param {Function} provider Function to invoke via `$injector.invoke`
	   * @param {Object} params Parameters for the template.
	   * @param {Object} locals Locals to pass to `invoke`. Defaults to 
	   * `{ params: params }`.
	   * @return {string|Promise.<string>} The template html as a string, or a promise 
	   * for that string.
	   */
	  this.fromProvider = function (provider, params, locals) {
	    return $injector.invoke(provider, null, locals || { params: params });
	  };
	}
	
	angular.module('ui.router.util').service('$templateFactory', $TemplateFactory);
	
	var $$UMFP; // reference to $UrlMatcherFactoryProvider
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Matches URLs against patterns and extracts named parameters from the path or the search
	 * part of the URL. A URL pattern consists of a path pattern, optionally followed by '?' and a list
	 * of search parameters. Multiple search parameter names are separated by '&'. Search parameters
	 * do not influence whether or not a URL is matched, but their values are passed through into
	 * the matched parameters returned by {@link ui.router.util.type:UrlMatcher#methods_exec exec}.
	 *
	 * Path parameter placeholders can be specified using simple colon/catch-all syntax or curly brace
	 * syntax, which optionally allows a regular expression for the parameter to be specified:
	 *
	 * * `':'` name - colon placeholder
	 * * `'*'` name - catch-all placeholder
	 * * `'{' name '}'` - curly placeholder
	 * * `'{' name ':' regexp|type '}'` - curly placeholder with regexp or type name. Should the
	 *   regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
	 *
	 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
	 * must be unique within the pattern (across both path and search parameters). For colon
	 * placeholders or curly placeholders without an explicit regexp, a path parameter matches any
	 * number of characters other than '/'. For catch-all placeholders the path parameter matches
	 * any number of characters.
	 *
	 * Examples:
	 *
	 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
	 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
	 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
	 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
	 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
	 * * `'/user/{id:[^/]*}'` - Same as the previous example.
	 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
	 *   parameter consists of 1 to 8 hex digits.
	 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
	 *   path into the parameter 'path'.
	 * * `'/files/*path'` - ditto.
	 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
	 *   in the built-in  `date` Type matches `2014-11-12`) and provides a Date object in $stateParams.start
	 *
	 * @param {string} pattern  The pattern to compile into a matcher.
	 * @param {Object} config  A configuration object hash:
	 * @param {Object=} parentMatcher Used to concatenate the pattern/config onto
	 *   an existing UrlMatcher
	 *
	 * * `caseInsensitive` - `true` if URL matching should be case insensitive, otherwise `false`, the default value (for backward compatibility) is `false`.
	 * * `strict` - `false` if matching against a URL with a trailing slash should be treated as equivalent to a URL without a trailing slash, the default value is `true`.
	 *
	 * @property {string} prefix  A static prefix of this pattern. The matcher guarantees that any
	 *   URL matching this matcher (i.e. any string for which {@link ui.router.util.type:UrlMatcher#methods_exec exec()} returns
	 *   non-null) will start with this prefix.
	 *
	 * @property {string} source  The pattern that was passed into the constructor
	 *
	 * @property {string} sourcePath  The path portion of the source property
	 *
	 * @property {string} sourceSearch  The search portion of the source property
	 *
	 * @property {string} regex  The constructed regex that will be used to match against the url when
	 *   it is time to determine which url will match.
	 *
	 * @returns {Object}  New `UrlMatcher` object
	 */
	function UrlMatcher(pattern, config, parentMatcher) {
	  config = extend({ params: {} }, isObject(config) ? config : {});
	
	  // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
	  //   '*' name
	  //   ':' name
	  //   '{' name '}'
	  //   '{' name ':' regexp '}'
	  // The regular expression is somewhat complicated due to the need to allow curly braces
	  // inside the regular expression. The placeholder regexp breaks down as follows:
	  //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
	  //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
	  //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
	  //    [^{}\\]+                       - anything other than curly braces or backslash
	  //    \\.                            - a backslash escape
	  //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
	  var placeholder       = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
	      searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
	      compiled = '^', last = 0, m,
	      segments = this.segments = [],
	      parentParams = parentMatcher ? parentMatcher.params : {},
	      params = this.params = parentMatcher ? parentMatcher.params.$$new() : new $$UMFP.ParamSet(),
	      paramNames = [];
	
	  function addParameter(id, type, config, location) {
	    paramNames.push(id);
	    if (parentParams[id]) return parentParams[id];
	    if (!/^\w+([-.]+\w+)*(?:\[\])?$/.test(id)) throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
	    if (params[id]) throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
	    params[id] = new $$UMFP.Param(id, type, config, location);
	    return params[id];
	  }
	
	  function quoteRegExp(string, pattern, squash, optional) {
	    var surroundPattern = ['',''], result = string.replace(/[\\\[\]\^$*+?.()|{}]/g, "\\$&");
	    if (!pattern) return result;
	    switch(squash) {
	      case false: surroundPattern = ['(', ')' + (optional ? "?" : "")]; break;
	      case true:
	        result = result.replace(/\/$/, '');
	        surroundPattern = ['(?:\/(', ')|\/)?'];
	      break;
	      default:    surroundPattern = ['(' + squash + "|", ')?']; break;
	    }
	    return result + surroundPattern[0] + pattern + surroundPattern[1];
	  }
	
	  this.source = pattern;
	
	  // Split into static segments separated by path parameter placeholders.
	  // The number of segments is always 1 more than the number of parameters.
	  function matchDetails(m, isSearch) {
	    var id, regexp, segment, type, cfg, arrayMode;
	    id          = m[2] || m[3]; // IE[78] returns '' for unmatched groups instead of null
	    cfg         = config.params[id];
	    segment     = pattern.substring(last, m.index);
	    regexp      = isSearch ? m[4] : m[4] || (m[1] == '*' ? '.*' : null);
	
	    if (regexp) {
	      type      = $$UMFP.type(regexp) || inherit($$UMFP.type("string"), { pattern: new RegExp(regexp, config.caseInsensitive ? 'i' : undefined) });
	    }
	
	    return {
	      id: id, regexp: regexp, segment: segment, type: type, cfg: cfg
	    };
	  }
	
	  var p, param, segment;
	  while ((m = placeholder.exec(pattern))) {
	    p = matchDetails(m, false);
	    if (p.segment.indexOf('?') >= 0) break; // we're into the search part
	
	    param = addParameter(p.id, p.type, p.cfg, "path");
	    compiled += quoteRegExp(p.segment, param.type.pattern.source, param.squash, param.isOptional);
	    segments.push(p.segment);
	    last = placeholder.lastIndex;
	  }
	  segment = pattern.substring(last);
	
	  // Find any search parameter names and remove them from the last segment
	  var i = segment.indexOf('?');
	
	  if (i >= 0) {
	    var search = this.sourceSearch = segment.substring(i);
	    segment = segment.substring(0, i);
	    this.sourcePath = pattern.substring(0, last + i);
	
	    if (search.length > 0) {
	      last = 0;
	      while ((m = searchPlaceholder.exec(search))) {
	        p = matchDetails(m, true);
	        param = addParameter(p.id, p.type, p.cfg, "search");
	        last = placeholder.lastIndex;
	        // check if ?&
	      }
	    }
	  } else {
	    this.sourcePath = pattern;
	    this.sourceSearch = '';
	  }
	
	  compiled += quoteRegExp(segment) + (config.strict === false ? '\/?' : '') + '$';
	  segments.push(segment);
	
	  this.regexp = new RegExp(compiled, config.caseInsensitive ? 'i' : undefined);
	  this.prefix = segments[0];
	  this.$$paramNames = paramNames;
	}
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#concat
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Returns a new matcher for a pattern constructed by appending the path part and adding the
	 * search parameters of the specified pattern to this pattern. The current pattern is not
	 * modified. This can be understood as creating a pattern for URLs that are relative to (or
	 * suffixes of) the current pattern.
	 *
	 * @example
	 * The following two matchers are equivalent:
	 * <pre>
	 * new UrlMatcher('/user/{id}?q').concat('/details?date');
	 * new UrlMatcher('/user/{id}/details?q&date');
	 * </pre>
	 *
	 * @param {string} pattern  The pattern to append.
	 * @param {Object} config  An object hash of the configuration for the matcher.
	 * @returns {UrlMatcher}  A matcher for the concatenated pattern.
	 */
	UrlMatcher.prototype.concat = function (pattern, config) {
	  // Because order of search parameters is irrelevant, we can add our own search
	  // parameters to the end of the new pattern. Parse the new pattern by itself
	  // and then join the bits together, but it's much easier to do this on a string level.
	  var defaultConfig = {
	    caseInsensitive: $$UMFP.caseInsensitive(),
	    strict: $$UMFP.strictMode(),
	    squash: $$UMFP.defaultSquashPolicy()
	  };
	  return new UrlMatcher(this.sourcePath + pattern + this.sourceSearch, extend(defaultConfig, config), this);
	};
	
	UrlMatcher.prototype.toString = function () {
	  return this.source;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#exec
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Tests the specified path against this matcher, and returns an object containing the captured
	 * parameter values, or null if the path does not match. The returned object contains the values
	 * of any search parameters that are mentioned in the pattern, but their value may be null if
	 * they are not present in `searchParams`. This means that search parameters are always treated
	 * as optional.
	 *
	 * @example
	 * <pre>
	 * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
	 *   x: '1', q: 'hello'
	 * });
	 * // returns { id: 'bob', q: 'hello', r: null }
	 * </pre>
	 *
	 * @param {string} path  The URL path to match, e.g. `$location.path()`.
	 * @param {Object} searchParams  URL search parameters, e.g. `$location.search()`.
	 * @returns {Object}  The captured parameter values.
	 */
	UrlMatcher.prototype.exec = function (path, searchParams) {
	  var m = this.regexp.exec(path);
	  if (!m) return null;
	  searchParams = searchParams || {};
	
	  var paramNames = this.parameters(), nTotal = paramNames.length,
	    nPath = this.segments.length - 1,
	    values = {}, i, j, cfg, paramName;
	
	  if (nPath !== m.length - 1) throw new Error("Unbalanced capture group in route '" + this.source + "'");
	
	  function decodePathArray(string) {
	    function reverseString(str) { return str.split("").reverse().join(""); }
	    function unquoteDashes(str) { return str.replace(/\\-/g, "-"); }
	
	    var split = reverseString(string).split(/-(?!\\)/);
	    var allReversed = map(split, reverseString);
	    return map(allReversed, unquoteDashes).reverse();
	  }
	
	  var param, paramVal;
	  for (i = 0; i < nPath; i++) {
	    paramName = paramNames[i];
	    param = this.params[paramName];
	    paramVal = m[i+1];
	    // if the param value matches a pre-replace pair, replace the value before decoding.
	    for (j = 0; j < param.replace.length; j++) {
	      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
	    }
	    if (paramVal && param.array === true) paramVal = decodePathArray(paramVal);
	    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
	    values[paramName] = param.value(paramVal);
	  }
	  for (/**/; i < nTotal; i++) {
	    paramName = paramNames[i];
	    values[paramName] = this.params[paramName].value(searchParams[paramName]);
	    param = this.params[paramName];
	    paramVal = searchParams[paramName];
	    for (j = 0; j < param.replace.length; j++) {
	      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
	    }
	    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
	    values[paramName] = param.value(paramVal);
	  }
	
	  return values;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#parameters
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Returns the names of all path and search parameters of this pattern in an unspecified order.
	 *
	 * @returns {Array.<string>}  An array of parameter names. Must be treated as read-only. If the
	 *    pattern has no parameters, an empty array is returned.
	 */
	UrlMatcher.prototype.parameters = function (param) {
	  if (!isDefined(param)) return this.$$paramNames;
	  return this.params[param] || null;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#validates
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Checks an object hash of parameters to validate their correctness according to the parameter
	 * types of this `UrlMatcher`.
	 *
	 * @param {Object} params The object hash of parameters to validate.
	 * @returns {boolean} Returns `true` if `params` validates, otherwise `false`.
	 */
	UrlMatcher.prototype.validates = function (params) {
	  return this.params.$$validates(params);
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#format
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Creates a URL that matches this pattern by substituting the specified values
	 * for the path and search parameters. Null values for path parameters are
	 * treated as empty strings.
	 *
	 * @example
	 * <pre>
	 * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
	 * // returns '/user/bob?q=yes'
	 * </pre>
	 *
	 * @param {Object} values  the values to substitute for the parameters in this pattern.
	 * @returns {string}  the formatted URL (path and optionally search part).
	 */
	UrlMatcher.prototype.format = function (values) {
	  values = values || {};
	  var segments = this.segments, params = this.parameters(), paramset = this.params;
	  if (!this.validates(values)) return null;
	
	  var i, search = false, nPath = segments.length - 1, nTotal = params.length, result = segments[0];
	
	  function encodeDashes(str) { // Replace dashes with encoded "\-"
	    return encodeURIComponent(str).replace(/-/g, function(c) { return '%5C%' + c.charCodeAt(0).toString(16).toUpperCase(); });
	  }
	
	  for (i = 0; i < nTotal; i++) {
	    var isPathParam = i < nPath;
	    var name = params[i], param = paramset[name], value = param.value(values[name]);
	    var isDefaultValue = param.isOptional && param.type.equals(param.value(), value);
	    var squash = isDefaultValue ? param.squash : false;
	    var encoded = param.type.encode(value);
	
	    if (isPathParam) {
	      var nextSegment = segments[i + 1];
	      var isFinalPathParam = i + 1 === nPath;
	
	      if (squash === false) {
	        if (encoded != null) {
	          if (isArray(encoded)) {
	            result += map(encoded, encodeDashes).join("-");
	          } else {
	            result += encodeURIComponent(encoded);
	          }
	        }
	        result += nextSegment;
	      } else if (squash === true) {
	        var capture = result.match(/\/$/) ? /\/?(.*)/ : /(.*)/;
	        result += nextSegment.match(capture)[1];
	      } else if (isString(squash)) {
	        result += squash + nextSegment;
	      }
	
	      if (isFinalPathParam && param.squash === true && result.slice(-1) === '/') result = result.slice(0, -1);
	    } else {
	      if (encoded == null || (isDefaultValue && squash !== false)) continue;
	      if (!isArray(encoded)) encoded = [ encoded ];
	      if (encoded.length === 0) continue;
	      encoded = map(encoded, encodeURIComponent).join('&' + name + '=');
	      result += (search ? '&' : '?') + (name + '=' + encoded);
	      search = true;
	    }
	  }
	
	  return result;
	};
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.type:Type
	 *
	 * @description
	 * Implements an interface to define custom parameter types that can be decoded from and encoded to
	 * string parameters matched in a URL. Used by {@link ui.router.util.type:UrlMatcher `UrlMatcher`}
	 * objects when matching or formatting URLs, or comparing or validating parameter values.
	 *
	 * See {@link ui.router.util.$urlMatcherFactory#methods_type `$urlMatcherFactory#type()`} for more
	 * information on registering custom types.
	 *
	 * @param {Object} config  A configuration object which contains the custom type definition.  The object's
	 *        properties will override the default methods and/or pattern in `Type`'s public interface.
	 * @example
	 * <pre>
	 * {
	 *   decode: function(val) { return parseInt(val, 10); },
	 *   encode: function(val) { return val && val.toString(); },
	 *   equals: function(a, b) { return this.is(a) && a === b; },
	 *   is: function(val) { return angular.isNumber(val) isFinite(val) && val % 1 === 0; },
	 *   pattern: /\d+/
	 * }
	 * </pre>
	 *
	 * @property {RegExp} pattern The regular expression pattern used to match values of this type when
	 *           coming from a substring of a URL.
	 *
	 * @returns {Object}  Returns a new `Type` object.
	 */
	function Type(config) {
	  extend(this, config);
	}
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#is
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Detects whether a value is of a particular type. Accepts a native (decoded) value
	 * and determines whether it matches the current `Type` object.
	 *
	 * @param {*} val  The value to check.
	 * @param {string} key  Optional. If the type check is happening in the context of a specific
	 *        {@link ui.router.util.type:UrlMatcher `UrlMatcher`} object, this is the name of the
	 *        parameter in which `val` is stored. Can be used for meta-programming of `Type` objects.
	 * @returns {Boolean}  Returns `true` if the value matches the type, otherwise `false`.
	 */
	Type.prototype.is = function(val, key) {
	  return true;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#encode
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Encodes a custom/native type value to a string that can be embedded in a URL. Note that the
	 * return value does *not* need to be URL-safe (i.e. passed through `encodeURIComponent()`), it
	 * only needs to be a representation of `val` that has been coerced to a string.
	 *
	 * @param {*} val  The value to encode.
	 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
	 *        meta-programming of `Type` objects.
	 * @returns {string}  Returns a string representation of `val` that can be encoded in a URL.
	 */
	Type.prototype.encode = function(val, key) {
	  return val;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#decode
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Converts a parameter value (from URL string or transition param) to a custom/native value.
	 *
	 * @param {string} val  The URL parameter value to decode.
	 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
	 *        meta-programming of `Type` objects.
	 * @returns {*}  Returns a custom representation of the URL parameter value.
	 */
	Type.prototype.decode = function(val, key) {
	  return val;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#equals
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Determines whether two decoded values are equivalent.
	 *
	 * @param {*} a  A value to compare against.
	 * @param {*} b  A value to compare against.
	 * @returns {Boolean}  Returns `true` if the values are equivalent/equal, otherwise `false`.
	 */
	Type.prototype.equals = function(a, b) {
	  return a == b;
	};
	
	Type.prototype.$subPattern = function() {
	  var sub = this.pattern.toString();
	  return sub.substr(1, sub.length - 2);
	};
	
	Type.prototype.pattern = /.*/;
	
	Type.prototype.toString = function() { return "{Type:" + this.name + "}"; };
	
	/** Given an encoded string, or a decoded object, returns a decoded object */
	Type.prototype.$normalize = function(val) {
	  return this.is(val) ? val : this.decode(val);
	};
	
	/*
	 * Wraps an existing custom Type as an array of Type, depending on 'mode'.
	 * e.g.:
	 * - urlmatcher pattern "/path?{queryParam[]:int}"
	 * - url: "/path?queryParam=1&queryParam=2
	 * - $stateParams.queryParam will be [1, 2]
	 * if `mode` is "auto", then
	 * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
	 * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
	 */
	Type.prototype.$asArray = function(mode, isSearch) {
	  if (!mode) return this;
	  if (mode === "auto" && !isSearch) throw new Error("'auto' array mode is for query parameters only");
	
	  function ArrayType(type, mode) {
	    function bindTo(type, callbackName) {
	      return function() {
	        return type[callbackName].apply(type, arguments);
	      };
	    }
	
	    // Wrap non-array value as array
	    function arrayWrap(val) { return isArray(val) ? val : (isDefined(val) ? [ val ] : []); }
	    // Unwrap array value for "auto" mode. Return undefined for empty array.
	    function arrayUnwrap(val) {
	      switch(val.length) {
	        case 0: return undefined;
	        case 1: return mode === "auto" ? val[0] : val;
	        default: return val;
	      }
	    }
	    function falsey(val) { return !val; }
	
	    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
	    function arrayHandler(callback, allTruthyMode) {
	      return function handleArray(val) {
	        if (isArray(val) && val.length === 0) return val;
	        val = arrayWrap(val);
	        var result = map(val, callback);
	        if (allTruthyMode === true)
	          return filter(result, falsey).length === 0;
	        return arrayUnwrap(result);
	      };
	    }
	
	    // Wraps type (.equals) functions to operate on each value of an array
	    function arrayEqualsHandler(callback) {
	      return function handleArray(val1, val2) {
	        var left = arrayWrap(val1), right = arrayWrap(val2);
	        if (left.length !== right.length) return false;
	        for (var i = 0; i < left.length; i++) {
	          if (!callback(left[i], right[i])) return false;
	        }
	        return true;
	      };
	    }
	
	    this.encode = arrayHandler(bindTo(type, 'encode'));
	    this.decode = arrayHandler(bindTo(type, 'decode'));
	    this.is     = arrayHandler(bindTo(type, 'is'), true);
	    this.equals = arrayEqualsHandler(bindTo(type, 'equals'));
	    this.pattern = type.pattern;
	    this.$normalize = arrayHandler(bindTo(type, '$normalize'));
	    this.name = type.name;
	    this.$arrayMode = mode;
	  }
	
	  return new ArrayType(this, mode);
	};
	
	
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$urlMatcherFactory
	 *
	 * @description
	 * Factory for {@link ui.router.util.type:UrlMatcher `UrlMatcher`} instances. The factory
	 * is also available to providers under the name `$urlMatcherFactoryProvider`.
	 */
	function $UrlMatcherFactory() {
	  $$UMFP = this;
	
	  var isCaseInsensitive = false, isStrictMode = true, defaultSquashPolicy = false;
	
	  // Use tildes to pre-encode slashes.
	  // If the slashes are simply URLEncoded, the browser can choose to pre-decode them,
	  // and bidirectional encoding/decoding fails.
	  // Tilde was chosen because it's not a RFC 3986 section 2.2 Reserved Character
	  function valToString(val) { return val != null ? val.toString().replace(/~/g, "~~").replace(/\//g, "~2F") : val; }
	  function valFromString(val) { return val != null ? val.toString().replace(/~2F/g, "/").replace(/~~/g, "~") : val; }
	
	  var $types = {}, enqueue = true, typeQueue = [], injector, defaultTypes = {
	    "string": {
	      encode: valToString,
	      decode: valFromString,
	      // TODO: in 1.0, make string .is() return false if value is undefined/null by default.
	      // In 0.2.x, string params are optional by default for backwards compat
	      is: function(val) { return val == null || !isDefined(val) || typeof val === "string"; },
	      pattern: /[^/]*/
	    },
	    "int": {
	      encode: valToString,
	      decode: function(val) { return parseInt(val, 10); },
	      is: function(val) { return isDefined(val) && this.decode(val.toString()) === val; },
	      pattern: /\d+/
	    },
	    "bool": {
	      encode: function(val) { return val ? 1 : 0; },
	      decode: function(val) { return parseInt(val, 10) !== 0; },
	      is: function(val) { return val === true || val === false; },
	      pattern: /0|1/
	    },
	    "date": {
	      encode: function (val) {
	        if (!this.is(val))
	          return undefined;
	        return [ val.getFullYear(),
	          ('0' + (val.getMonth() + 1)).slice(-2),
	          ('0' + val.getDate()).slice(-2)
	        ].join("-");
	      },
	      decode: function (val) {
	        if (this.is(val)) return val;
	        var match = this.capture.exec(val);
	        return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
	      },
	      is: function(val) { return val instanceof Date && !isNaN(val.valueOf()); },
	      equals: function (a, b) { return this.is(a) && this.is(b) && a.toISOString() === b.toISOString(); },
	      pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
	      capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
	    },
	    "json": {
	      encode: angular.toJson,
	      decode: angular.fromJson,
	      is: angular.isObject,
	      equals: angular.equals,
	      pattern: /[^/]*/
	    },
	    "any": { // does not encode/decode
	      encode: angular.identity,
	      decode: angular.identity,
	      equals: angular.equals,
	      pattern: /.*/
	    }
	  };
	
	  function getDefaultConfig() {
	    return {
	      strict: isStrictMode,
	      caseInsensitive: isCaseInsensitive
	    };
	  }
	
	  function isInjectable(value) {
	    return (isFunction(value) || (isArray(value) && isFunction(value[value.length - 1])));
	  }
	
	  /**
	   * [Internal] Get the default value of a parameter, which may be an injectable function.
	   */
	  $UrlMatcherFactory.$$getDefaultValue = function(config) {
	    if (!isInjectable(config.value)) return config.value;
	    if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
	    return injector.invoke(config.value);
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#caseInsensitive
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Defines whether URL matching should be case sensitive (the default behavior), or not.
	   *
	   * @param {boolean} value `false` to match URL in a case sensitive manner; otherwise `true`;
	   * @returns {boolean} the current value of caseInsensitive
	   */
	  this.caseInsensitive = function(value) {
	    if (isDefined(value))
	      isCaseInsensitive = value;
	    return isCaseInsensitive;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#strictMode
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Defines whether URLs should match trailing slashes, or not (the default behavior).
	   *
	   * @param {boolean=} value `false` to match trailing slashes in URLs, otherwise `true`.
	   * @returns {boolean} the current value of strictMode
	   */
	  this.strictMode = function(value) {
	    if (isDefined(value))
	      isStrictMode = value;
	    return isStrictMode;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#defaultSquashPolicy
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Sets the default behavior when generating or matching URLs with default parameter values.
	   *
	   * @param {string} value A string that defines the default parameter URL squashing behavior.
	   *    `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
	   *    `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
	   *             parameter is surrounded by slashes, squash (remove) one slash from the URL
	   *    any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
	   *             the parameter value from the URL and replace it with this string.
	   */
	  this.defaultSquashPolicy = function(value) {
	    if (!isDefined(value)) return defaultSquashPolicy;
	    if (value !== true && value !== false && !isString(value))
	      throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
	    defaultSquashPolicy = value;
	    return value;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#compile
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Creates a {@link ui.router.util.type:UrlMatcher `UrlMatcher`} for the specified pattern.
	   *
	   * @param {string} pattern  The URL pattern.
	   * @param {Object} config  The config object hash.
	   * @returns {UrlMatcher}  The UrlMatcher.
	   */
	  this.compile = function (pattern, config) {
	    return new UrlMatcher(pattern, extend(getDefaultConfig(), config));
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#isMatcher
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Returns true if the specified object is a `UrlMatcher`, or false otherwise.
	   *
	   * @param {Object} object  The object to perform the type check against.
	   * @returns {Boolean}  Returns `true` if the object matches the `UrlMatcher` interface, by
	   *          implementing all the same methods.
	   */
	  this.isMatcher = function (o) {
	    if (!isObject(o)) return false;
	    var result = true;
	
	    forEach(UrlMatcher.prototype, function(val, name) {
	      if (isFunction(val)) {
	        result = result && (isDefined(o[name]) && isFunction(o[name]));
	      }
	    });
	    return result;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#type
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Registers a custom {@link ui.router.util.type:Type `Type`} object that can be used to
	   * generate URLs with typed parameters.
	   *
	   * @param {string} name  The type name.
	   * @param {Object|Function} definition   The type definition. See
	   *        {@link ui.router.util.type:Type `Type`} for information on the values accepted.
	   * @param {Object|Function} definitionFn (optional) A function that is injected before the app
	   *        runtime starts.  The result of this function is merged into the existing `definition`.
	   *        See {@link ui.router.util.type:Type `Type`} for information on the values accepted.
	   *
	   * @returns {Object}  Returns `$urlMatcherFactoryProvider`.
	   *
	   * @example
	   * This is a simple example of a custom type that encodes and decodes items from an
	   * array, using the array index as the URL-encoded value:
	   *
	   * <pre>
	   * var list = ['John', 'Paul', 'George', 'Ringo'];
	   *
	   * $urlMatcherFactoryProvider.type('listItem', {
	   *   encode: function(item) {
	   *     // Represent the list item in the URL using its corresponding index
	   *     return list.indexOf(item);
	   *   },
	   *   decode: function(item) {
	   *     // Look up the list item by index
	   *     return list[parseInt(item, 10)];
	   *   },
	   *   is: function(item) {
	   *     // Ensure the item is valid by checking to see that it appears
	   *     // in the list
	   *     return list.indexOf(item) > -1;
	   *   }
	   * });
	   *
	   * $stateProvider.state('list', {
	   *   url: "/list/{item:listItem}",
	   *   controller: function($scope, $stateParams) {
	   *     console.log($stateParams.item);
	   *   }
	   * });
	   *
	   * // ...
	   *
	   * // Changes URL to '/list/3', logs "Ringo" to the console
	   * $state.go('list', { item: "Ringo" });
	   * </pre>
	   *
	   * This is a more complex example of a type that relies on dependency injection to
	   * interact with services, and uses the parameter name from the URL to infer how to
	   * handle encoding and decoding parameter values:
	   *
	   * <pre>
	   * // Defines a custom type that gets a value from a service,
	   * // where each service gets different types of values from
	   * // a backend API:
	   * $urlMatcherFactoryProvider.type('dbObject', {}, function(Users, Posts) {
	   *
	   *   // Matches up services to URL parameter names
	   *   var services = {
	   *     user: Users,
	   *     post: Posts
	   *   };
	   *
	   *   return {
	   *     encode: function(object) {
	   *       // Represent the object in the URL using its unique ID
	   *       return object.id;
	   *     },
	   *     decode: function(value, key) {
	   *       // Look up the object by ID, using the parameter
	   *       // name (key) to call the correct service
	   *       return services[key].findById(value);
	   *     },
	   *     is: function(object, key) {
	   *       // Check that object is a valid dbObject
	   *       return angular.isObject(object) && object.id && services[key];
	   *     }
	   *     equals: function(a, b) {
	   *       // Check the equality of decoded objects by comparing
	   *       // their unique IDs
	   *       return a.id === b.id;
	   *     }
	   *   };
	   * });
	   *
	   * // In a config() block, you can then attach URLs with
	   * // type-annotated parameters:
	   * $stateProvider.state('users', {
	   *   url: "/users",
	   *   // ...
	   * }).state('users.item', {
	   *   url: "/{user:dbObject}",
	   *   controller: function($scope, $stateParams) {
	   *     // $stateParams.user will now be an object returned from
	   *     // the Users service
	   *   },
	   *   // ...
	   * });
	   * </pre>
	   */
	  this.type = function (name, definition, definitionFn) {
	    if (!isDefined(definition)) return $types[name];
	    if ($types.hasOwnProperty(name)) throw new Error("A type named '" + name + "' has already been defined.");
	
	    $types[name] = new Type(extend({ name: name }, definition));
	    if (definitionFn) {
	      typeQueue.push({ name: name, def: definitionFn });
	      if (!enqueue) flushTypeQueue();
	    }
	    return this;
	  };
	
	  // `flushTypeQueue()` waits until `$urlMatcherFactory` is injected before invoking the queued `definitionFn`s
	  function flushTypeQueue() {
	    while(typeQueue.length) {
	      var type = typeQueue.shift();
	      if (type.pattern) throw new Error("You cannot override a type's .pattern at runtime.");
	      angular.extend($types[type.name], injector.invoke(type.def));
	    }
	  }
	
	  // Register default types. Store them in the prototype of $types.
	  forEach(defaultTypes, function(type, name) { $types[name] = new Type(extend({name: name}, type)); });
	  $types = inherit($types, {});
	
	  /* No need to document $get, since it returns this */
	  this.$get = ['$injector', function ($injector) {
	    injector = $injector;
	    enqueue = false;
	    flushTypeQueue();
	
	    forEach(defaultTypes, function(type, name) {
	      if (!$types[name]) $types[name] = new Type(type);
	    });
	    return this;
	  }];
	
	  this.Param = function Param(id, type, config, location) {
	    var self = this;
	    config = unwrapShorthand(config);
	    type = getType(config, type, location);
	    var arrayMode = getArrayMode();
	    type = arrayMode ? type.$asArray(arrayMode, location === "search") : type;
	    if (type.name === "string" && !arrayMode && location === "path" && config.value === undefined)
	      config.value = ""; // for 0.2.x; in 0.3.0+ do not automatically default to ""
	    var isOptional = config.value !== undefined;
	    var squash = getSquashPolicy(config, isOptional);
	    var replace = getReplace(config, arrayMode, isOptional, squash);
	
	    function unwrapShorthand(config) {
	      var keys = isObject(config) ? objectKeys(config) : [];
	      var isShorthand = indexOf(keys, "value") === -1 && indexOf(keys, "type") === -1 &&
	                        indexOf(keys, "squash") === -1 && indexOf(keys, "array") === -1;
	      if (isShorthand) config = { value: config };
	      config.$$fn = isInjectable(config.value) ? config.value : function () { return config.value; };
	      return config;
	    }
	
	    function getType(config, urlType, location) {
	      if (config.type && urlType) throw new Error("Param '"+id+"' has two type configurations.");
	      if (urlType) return urlType;
	      if (!config.type) return (location === "config" ? $types.any : $types.string);
	
	      if (angular.isString(config.type))
	        return $types[config.type];
	      if (config.type instanceof Type)
	        return config.type;
	      return new Type(config.type);
	    }
	
	    // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
	    function getArrayMode() {
	      var arrayDefaults = { array: (location === "search" ? "auto" : false) };
	      var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
	      return extend(arrayDefaults, arrayParamNomenclature, config).array;
	    }
	
	    /**
	     * returns false, true, or the squash value to indicate the "default parameter url squash policy".
	     */
	    function getSquashPolicy(config, isOptional) {
	      var squash = config.squash;
	      if (!isOptional || squash === false) return false;
	      if (!isDefined(squash) || squash == null) return defaultSquashPolicy;
	      if (squash === true || isString(squash)) return squash;
	      throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
	    }
	
	    function getReplace(config, arrayMode, isOptional, squash) {
	      var replace, configuredKeys, defaultPolicy = [
	        { from: "",   to: (isOptional || arrayMode ? undefined : "") },
	        { from: null, to: (isOptional || arrayMode ? undefined : "") }
	      ];
	      replace = isArray(config.replace) ? config.replace : [];
	      if (isString(squash))
	        replace.push({ from: squash, to: undefined });
	      configuredKeys = map(replace, function(item) { return item.from; } );
	      return filter(defaultPolicy, function(item) { return indexOf(configuredKeys, item.from) === -1; }).concat(replace);
	    }
	
	    /**
	     * [Internal] Get the default value of a parameter, which may be an injectable function.
	     */
	    function $$getDefaultValue() {
	      if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
	      var defaultValue = injector.invoke(config.$$fn);
	      if (defaultValue !== null && defaultValue !== undefined && !self.type.is(defaultValue))
	        throw new Error("Default value (" + defaultValue + ") for parameter '" + self.id + "' is not an instance of Type (" + self.type.name + ")");
	      return defaultValue;
	    }
	
	    /**
	     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
	     * default value, which may be the result of an injectable function.
	     */
	    function $value(value) {
	      function hasReplaceVal(val) { return function(obj) { return obj.from === val; }; }
	      function $replace(value) {
	        var replacement = map(filter(self.replace, hasReplaceVal(value)), function(obj) { return obj.to; });
	        return replacement.length ? replacement[0] : value;
	      }
	      value = $replace(value);
	      return !isDefined(value) ? $$getDefaultValue() : self.type.$normalize(value);
	    }
	
	    function toString() { return "{Param:" + id + " " + type + " squash: '" + squash + "' optional: " + isOptional + "}"; }
	
	    extend(this, {
	      id: id,
	      type: type,
	      location: location,
	      array: arrayMode,
	      squash: squash,
	      replace: replace,
	      isOptional: isOptional,
	      value: $value,
	      dynamic: undefined,
	      config: config,
	      toString: toString
	    });
	  };
	
	  function ParamSet(params) {
	    extend(this, params || {});
	  }
	
	  ParamSet.prototype = {
	    $$new: function() {
	      return inherit(this, extend(new ParamSet(), { $$parent: this}));
	    },
	    $$keys: function () {
	      var keys = [], chain = [], parent = this,
	        ignore = objectKeys(ParamSet.prototype);
	      while (parent) { chain.push(parent); parent = parent.$$parent; }
	      chain.reverse();
	      forEach(chain, function(paramset) {
	        forEach(objectKeys(paramset), function(key) {
	            if (indexOf(keys, key) === -1 && indexOf(ignore, key) === -1) keys.push(key);
	        });
	      });
	      return keys;
	    },
	    $$values: function(paramValues) {
	      var values = {}, self = this;
	      forEach(self.$$keys(), function(key) {
	        values[key] = self[key].value(paramValues && paramValues[key]);
	      });
	      return values;
	    },
	    $$equals: function(paramValues1, paramValues2) {
	      var equal = true, self = this;
	      forEach(self.$$keys(), function(key) {
	        var left = paramValues1 && paramValues1[key], right = paramValues2 && paramValues2[key];
	        if (!self[key].type.equals(left, right)) equal = false;
	      });
	      return equal;
	    },
	    $$validates: function $$validate(paramValues) {
	      var keys = this.$$keys(), i, param, rawVal, normalized, encoded;
	      for (i = 0; i < keys.length; i++) {
	        param = this[keys[i]];
	        rawVal = paramValues[keys[i]];
	        if ((rawVal === undefined || rawVal === null) && param.isOptional)
	          break; // There was no parameter value, but the param is optional
	        normalized = param.type.$normalize(rawVal);
	        if (!param.type.is(normalized))
	          return false; // The value was not of the correct Type, and could not be decoded to the correct Type
	        encoded = param.type.encode(normalized);
	        if (angular.isString(encoded) && !param.type.pattern.exec(encoded))
	          return false; // The value was of the correct type, but when encoded, did not match the Type's regexp
	      }
	      return true;
	    },
	    $$parent: undefined
	  };
	
	  this.ParamSet = ParamSet;
	}
	
	// Register as a provider so it's available to other providers
	angular.module('ui.router.util').provider('$urlMatcherFactory', $UrlMatcherFactory);
	angular.module('ui.router.util').run(['$urlMatcherFactory', function($urlMatcherFactory) { }]);
	
	/**
	 * @ngdoc object
	 * @name ui.router.router.$urlRouterProvider
	 *
	 * @requires ui.router.util.$urlMatcherFactoryProvider
	 * @requires $locationProvider
	 *
	 * @description
	 * `$urlRouterProvider` has the responsibility of watching `$location`. 
	 * When `$location` changes it runs through a list of rules one by one until a 
	 * match is found. `$urlRouterProvider` is used behind the scenes anytime you specify 
	 * a url in a state configuration. All urls are compiled into a UrlMatcher object.
	 *
	 * There are several methods on `$urlRouterProvider` that make it useful to use directly
	 * in your module config.
	 */
	$UrlRouterProvider.$inject = ['$locationProvider', '$urlMatcherFactoryProvider'];
	function $UrlRouterProvider(   $locationProvider,   $urlMatcherFactory) {
	  var rules = [], otherwise = null, interceptDeferred = false, listener;
	
	  // Returns a string that is a prefix of all strings matching the RegExp
	  function regExpPrefix(re) {
	    var prefix = /^\^((?:\\[^a-zA-Z0-9]|[^\\\[\]\^$*+?.()|{}]+)*)/.exec(re.source);
	    return (prefix != null) ? prefix[1].replace(/\\(.)/g, "$1") : '';
	  }
	
	  // Interpolates matched values into a String.replace()-style pattern
	  function interpolate(pattern, match) {
	    return pattern.replace(/\$(\$|\d{1,2})/, function (m, what) {
	      return match[what === '$' ? 0 : Number(what)];
	    });
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#rule
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Defines rules that are used by `$urlRouterProvider` to find matches for
	   * specific URLs.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   // Here's an example of how you might allow case insensitive urls
	   *   $urlRouterProvider.rule(function ($injector, $location) {
	   *     var path = $location.path(),
	   *         normalized = path.toLowerCase();
	   *
	   *     if (path !== normalized) {
	   *       return normalized;
	   *     }
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {function} rule Handler function that takes `$injector` and `$location`
	   * services as arguments. You can use them to return a valid path as a string.
	   *
	   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	   */
	  this.rule = function (rule) {
	    if (!isFunction(rule)) throw new Error("'rule' must be a function");
	    rules.push(rule);
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.router.$urlRouterProvider#otherwise
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Defines a path that is used when an invalid route is requested.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   // if the path doesn't match any of the urls you configured
	   *   // otherwise will take care of routing the user to the
	   *   // specified url
	   *   $urlRouterProvider.otherwise('/index');
	   *
	   *   // Example of using function rule as param
	   *   $urlRouterProvider.otherwise(function ($injector, $location) {
	   *     return '/a/valid/url';
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {string|function} rule The url path you want to redirect to or a function 
	   * rule that returns the url path. The function version is passed two params: 
	   * `$injector` and `$location` services, and must return a url string.
	   *
	   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	   */
	  this.otherwise = function (rule) {
	    if (isString(rule)) {
	      var redirect = rule;
	      rule = function () { return redirect; };
	    }
	    else if (!isFunction(rule)) throw new Error("'rule' must be a function");
	    otherwise = rule;
	    return this;
	  };
	
	
	  function handleIfMatch($injector, handler, match) {
	    if (!match) return false;
	    var result = $injector.invoke(handler, handler, { $match: match });
	    return isDefined(result) ? result : true;
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#when
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Registers a handler for a given url matching. 
	   * 
	   * If the handler is a string, it is
	   * treated as a redirect, and is interpolated according to the syntax of match
	   * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
	   *
	   * If the handler is a function, it is injectable. It gets invoked if `$location`
	   * matches. You have the option of inject the match object as `$match`.
	   *
	   * The handler can return
	   *
	   * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
	   *   will continue trying to find another one that matches.
	   * - **string** which is treated as a redirect and passed to `$location.url()`
	   * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
	   *     if ($state.$current.navigable !== state ||
	   *         !equalForKeys($match, $stateParams) {
	   *      $state.transitionTo(state, $match, false);
	   *     }
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {string|object} what The incoming path that you want to redirect.
	   * @param {string|function} handler The path you want to redirect your user to.
	   */
	  this.when = function (what, handler) {
	    var redirect, handlerIsString = isString(handler);
	    if (isString(what)) what = $urlMatcherFactory.compile(what);
	
	    if (!handlerIsString && !isFunction(handler) && !isArray(handler))
	      throw new Error("invalid 'handler' in when()");
	
	    var strategies = {
	      matcher: function (what, handler) {
	        if (handlerIsString) {
	          redirect = $urlMatcherFactory.compile(handler);
	          handler = ['$match', function ($match) { return redirect.format($match); }];
	        }
	        return extend(function ($injector, $location) {
	          return handleIfMatch($injector, handler, what.exec($location.path(), $location.search()));
	        }, {
	          prefix: isString(what.prefix) ? what.prefix : ''
	        });
	      },
	      regex: function (what, handler) {
	        if (what.global || what.sticky) throw new Error("when() RegExp must not be global or sticky");
	
	        if (handlerIsString) {
	          redirect = handler;
	          handler = ['$match', function ($match) { return interpolate(redirect, $match); }];
	        }
	        return extend(function ($injector, $location) {
	          return handleIfMatch($injector, handler, what.exec($location.path()));
	        }, {
	          prefix: regExpPrefix(what)
	        });
	      }
	    };
	
	    var check = { matcher: $urlMatcherFactory.isMatcher(what), regex: what instanceof RegExp };
	
	    for (var n in check) {
	      if (check[n]) return this.rule(strategies[n](what, handler));
	    }
	
	    throw new Error("invalid 'what' in when()");
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#deferIntercept
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Disables (or enables) deferring location change interception.
	   *
	   * If you wish to customize the behavior of syncing the URL (for example, if you wish to
	   * defer a transition but maintain the current URL), call this method at configuration time.
	   * Then, at run time, call `$urlRouter.listen()` after you have configured your own
	   * `$locationChangeSuccess` event handler.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *
	   *   // Prevent $urlRouter from automatically intercepting URL changes;
	   *   // this allows you to configure custom behavior in between
	   *   // location changes and route synchronization:
	   *   $urlRouterProvider.deferIntercept();
	   *
	   * }).run(function ($rootScope, $urlRouter, UserService) {
	   *
	   *   $rootScope.$on('$locationChangeSuccess', function(e) {
	   *     // UserService is an example service for managing user state
	   *     if (UserService.isLoggedIn()) return;
	   *
	   *     // Prevent $urlRouter's default handler from firing
	   *     e.preventDefault();
	   *
	   *     UserService.handleLogin().then(function() {
	   *       // Once the user has logged in, sync the current URL
	   *       // to the router:
	   *       $urlRouter.sync();
	   *     });
	   *   });
	   *
	   *   // Configures $urlRouter's listener *after* your custom listener
	   *   $urlRouter.listen();
	   * });
	   * </pre>
	   *
	   * @param {boolean} defer Indicates whether to defer location change interception. Passing
	            no parameter is equivalent to `true`.
	   */
	  this.deferIntercept = function (defer) {
	    if (defer === undefined) defer = true;
	    interceptDeferred = defer;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.router.$urlRouter
	   *
	   * @requires $location
	   * @requires $rootScope
	   * @requires $injector
	   * @requires $browser
	   *
	   * @description
	   *
	   */
	  this.$get = $get;
	  $get.$inject = ['$location', '$rootScope', '$injector', '$browser', '$sniffer'];
	  function $get(   $location,   $rootScope,   $injector,   $browser,   $sniffer) {
	
	    var baseHref = $browser.baseHref(), location = $location.url(), lastPushedUrl;
	
	    function appendBasePath(url, isHtml5, absolute) {
	      if (baseHref === '/') return url;
	      if (isHtml5) return baseHref.slice(0, -1) + url;
	      if (absolute) return baseHref.slice(1) + url;
	      return url;
	    }
	
	    // TODO: Optimize groups of rules with non-empty prefix into some sort of decision tree
	    function update(evt) {
	      if (evt && evt.defaultPrevented) return;
	      var ignoreUpdate = lastPushedUrl && $location.url() === lastPushedUrl;
	      lastPushedUrl = undefined;
	      // TODO: Re-implement this in 1.0 for https://github.com/angular-ui/ui-router/issues/1573
	      //if (ignoreUpdate) return true;
	
	      function check(rule) {
	        var handled = rule($injector, $location);
	
	        if (!handled) return false;
	        if (isString(handled)) $location.replace().url(handled);
	        return true;
	      }
	      var n = rules.length, i;
	
	      for (i = 0; i < n; i++) {
	        if (check(rules[i])) return;
	      }
	      // always check otherwise last to allow dynamic updates to the set of rules
	      if (otherwise) check(otherwise);
	    }
	
	    function listen() {
	      listener = listener || $rootScope.$on('$locationChangeSuccess', update);
	      return listener;
	    }
	
	    if (!interceptDeferred) listen();
	
	    return {
	      /**
	       * @ngdoc function
	       * @name ui.router.router.$urlRouter#sync
	       * @methodOf ui.router.router.$urlRouter
	       *
	       * @description
	       * Triggers an update; the same update that happens when the address bar url changes, aka `$locationChangeSuccess`.
	       * This method is useful when you need to use `preventDefault()` on the `$locationChangeSuccess` event,
	       * perform some custom logic (route protection, auth, config, redirection, etc) and then finally proceed
	       * with the transition by calling `$urlRouter.sync()`.
	       *
	       * @example
	       * <pre>
	       * angular.module('app', ['ui.router'])
	       *   .run(function($rootScope, $urlRouter) {
	       *     $rootScope.$on('$locationChangeSuccess', function(evt) {
	       *       // Halt state change from even starting
	       *       evt.preventDefault();
	       *       // Perform custom logic
	       *       var meetsRequirement = ...
	       *       // Continue with the update and state transition if logic allows
	       *       if (meetsRequirement) $urlRouter.sync();
	       *     });
	       * });
	       * </pre>
	       */
	      sync: function() {
	        update();
	      },
	
	      listen: function() {
	        return listen();
	      },
	
	      update: function(read) {
	        if (read) {
	          location = $location.url();
	          return;
	        }
	        if ($location.url() === location) return;
	
	        $location.url(location);
	        $location.replace();
	      },
	
	      push: function(urlMatcher, params, options) {
	         var url = urlMatcher.format(params || {});
	
	        // Handle the special hash param, if needed
	        if (url !== null && params && params['#']) {
	            url += '#' + params['#'];
	        }
	
	        $location.url(url);
	        lastPushedUrl = options && options.$$avoidResync ? $location.url() : undefined;
	        if (options && options.replace) $location.replace();
	      },
	
	      /**
	       * @ngdoc function
	       * @name ui.router.router.$urlRouter#href
	       * @methodOf ui.router.router.$urlRouter
	       *
	       * @description
	       * A URL generation method that returns the compiled URL for a given
	       * {@link ui.router.util.type:UrlMatcher `UrlMatcher`}, populated with the provided parameters.
	       *
	       * @example
	       * <pre>
	       * $bob = $urlRouter.href(new UrlMatcher("/about/:person"), {
	       *   person: "bob"
	       * });
	       * // $bob == "/about/bob";
	       * </pre>
	       *
	       * @param {UrlMatcher} urlMatcher The `UrlMatcher` object which is used as the template of the URL to generate.
	       * @param {object=} params An object of parameter values to fill the matcher's required parameters.
	       * @param {object=} options Options object. The options are:
	       *
	       * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	       *
	       * @returns {string} Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
	       */
	      href: function(urlMatcher, params, options) {
	        if (!urlMatcher.validates(params)) return null;
	
	        var isHtml5 = $locationProvider.html5Mode();
	        if (angular.isObject(isHtml5)) {
	          isHtml5 = isHtml5.enabled;
	        }
	
	        isHtml5 = isHtml5 && $sniffer.history;
	        
	        var url = urlMatcher.format(params);
	        options = options || {};
	
	        if (!isHtml5 && url !== null) {
	          url = "#" + $locationProvider.hashPrefix() + url;
	        }
	
	        // Handle special hash param, if needed
	        if (url !== null && params && params['#']) {
	          url += '#' + params['#'];
	        }
	
	        url = appendBasePath(url, isHtml5, options.absolute);
	
	        if (!options.absolute || !url) {
	          return url;
	        }
	
	        var slash = (!isHtml5 && url ? '/' : ''), port = $location.port();
	        port = (port === 80 || port === 443 ? '' : ':' + port);
	
	        return [$location.protocol(), '://', $location.host(), port, slash, url].join('');
	      }
	    };
	  }
	}
	
	angular.module('ui.router.router').provider('$urlRouter', $UrlRouterProvider);
	
	/**
	 * @ngdoc object
	 * @name ui.router.state.$stateProvider
	 *
	 * @requires ui.router.router.$urlRouterProvider
	 * @requires ui.router.util.$urlMatcherFactoryProvider
	 *
	 * @description
	 * The new `$stateProvider` works similar to Angular's v1 router, but it focuses purely
	 * on state.
	 *
	 * A state corresponds to a "place" in the application in terms of the overall UI and
	 * navigation. A state describes (via the controller / template / view properties) what
	 * the UI looks like and does at that place.
	 *
	 * States often have things in common, and the primary way of factoring out these
	 * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
	 * nested states.
	 *
	 * The `$stateProvider` provides interfaces to declare these states for your app.
	 */
	$StateProvider.$inject = ['$urlRouterProvider', '$urlMatcherFactoryProvider'];
	function $StateProvider(   $urlRouterProvider,   $urlMatcherFactory) {
	
	  var root, states = {}, $state, queue = {}, abstractKey = 'abstract';
	
	  // Builds state properties from definition passed to registerState()
	  var stateBuilder = {
	
	    // Derive parent state from a hierarchical name only if 'parent' is not explicitly defined.
	    // state.children = [];
	    // if (parent) parent.children.push(state);
	    parent: function(state) {
	      if (isDefined(state.parent) && state.parent) return findState(state.parent);
	      // regex matches any valid composite state name
	      // would match "contact.list" but not "contacts"
	      var compositeName = /^(.+)\.[^.]+$/.exec(state.name);
	      return compositeName ? findState(compositeName[1]) : root;
	    },
	
	    // inherit 'data' from parent and override by own values (if any)
	    data: function(state) {
	      if (state.parent && state.parent.data) {
	        state.data = state.self.data = inherit(state.parent.data, state.data);
	      }
	      return state.data;
	    },
	
	    // Build a URLMatcher if necessary, either via a relative or absolute URL
	    url: function(state) {
	      var url = state.url, config = { params: state.params || {} };
	
	      if (isString(url)) {
	        if (url.charAt(0) == '^') return $urlMatcherFactory.compile(url.substring(1), config);
	        return (state.parent.navigable || root).url.concat(url, config);
	      }
	
	      if (!url || $urlMatcherFactory.isMatcher(url)) return url;
	      throw new Error("Invalid url '" + url + "' in state '" + state + "'");
	    },
	
	    // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
	    navigable: function(state) {
	      return state.url ? state : (state.parent ? state.parent.navigable : null);
	    },
	
	    // Own parameters for this state. state.url.params is already built at this point. Create and add non-url params
	    ownParams: function(state) {
	      var params = state.url && state.url.params || new $$UMFP.ParamSet();
	      forEach(state.params || {}, function(config, id) {
	        if (!params[id]) params[id] = new $$UMFP.Param(id, null, config, "config");
	      });
	      return params;
	    },
	
	    // Derive parameters for this state and ensure they're a super-set of parent's parameters
	    params: function(state) {
	      var ownParams = pick(state.ownParams, state.ownParams.$$keys());
	      return state.parent && state.parent.params ? extend(state.parent.params.$$new(), ownParams) : new $$UMFP.ParamSet();
	    },
	
	    // If there is no explicit multi-view configuration, make one up so we don't have
	    // to handle both cases in the view directive later. Note that having an explicit
	    // 'views' property will mean the default unnamed view properties are ignored. This
	    // is also a good time to resolve view names to absolute names, so everything is a
	    // straight lookup at link time.
	    views: function(state) {
	      var views = {};
	
	      forEach(isDefined(state.views) ? state.views : { '': state }, function (view, name) {
	        if (name.indexOf('@') < 0) name += '@' + state.parent.name;
	        views[name] = view;
	      });
	      return views;
	    },
	
	    // Keep a full path from the root down to this state as this is needed for state activation.
	    path: function(state) {
	      return state.parent ? state.parent.path.concat(state) : []; // exclude root from path
	    },
	
	    // Speed up $state.contains() as it's used a lot
	    includes: function(state) {
	      var includes = state.parent ? extend({}, state.parent.includes) : {};
	      includes[state.name] = true;
	      return includes;
	    },
	
	    $delegates: {}
	  };
	
	  function isRelative(stateName) {
	    return stateName.indexOf(".") === 0 || stateName.indexOf("^") === 0;
	  }
	
	  function findState(stateOrName, base) {
	    if (!stateOrName) return undefined;
	
	    var isStr = isString(stateOrName),
	        name  = isStr ? stateOrName : stateOrName.name,
	        path  = isRelative(name);
	
	    if (path) {
	      if (!base) throw new Error("No reference point given for path '"  + name + "'");
	      base = findState(base);
	      
	      var rel = name.split("."), i = 0, pathLength = rel.length, current = base;
	
	      for (; i < pathLength; i++) {
	        if (rel[i] === "" && i === 0) {
	          current = base;
	          continue;
	        }
	        if (rel[i] === "^") {
	          if (!current.parent) throw new Error("Path '" + name + "' not valid for state '" + base.name + "'");
	          current = current.parent;
	          continue;
	        }
	        break;
	      }
	      rel = rel.slice(i).join(".");
	      name = current.name + (current.name && rel ? "." : "") + rel;
	    }
	    var state = states[name];
	
	    if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
	      return state;
	    }
	    return undefined;
	  }
	
	  function queueState(parentName, state) {
	    if (!queue[parentName]) {
	      queue[parentName] = [];
	    }
	    queue[parentName].push(state);
	  }
	
	  function flushQueuedChildren(parentName) {
	    var queued = queue[parentName] || [];
	    while(queued.length) {
	      registerState(queued.shift());
	    }
	  }
	
	  function registerState(state) {
	    // Wrap a new object around the state so we can store our private details easily.
	    state = inherit(state, {
	      self: state,
	      resolve: state.resolve || {},
	      toString: function() { return this.name; }
	    });
	
	    var name = state.name;
	    if (!isString(name) || name.indexOf('@') >= 0) throw new Error("State must have a valid name");
	    if (states.hasOwnProperty(name)) throw new Error("State '" + name + "' is already defined");
	
	    // Get parent name
	    var parentName = (name.indexOf('.') !== -1) ? name.substring(0, name.lastIndexOf('.'))
	        : (isString(state.parent)) ? state.parent
	        : (isObject(state.parent) && isString(state.parent.name)) ? state.parent.name
	        : '';
	
	    // If parent is not registered yet, add state to queue and register later
	    if (parentName && !states[parentName]) {
	      return queueState(parentName, state.self);
	    }
	
	    for (var key in stateBuilder) {
	      if (isFunction(stateBuilder[key])) state[key] = stateBuilder[key](state, stateBuilder.$delegates[key]);
	    }
	    states[name] = state;
	
	    // Register the state in the global state list and with $urlRouter if necessary.
	    if (!state[abstractKey] && state.url) {
	      $urlRouterProvider.when(state.url, ['$match', '$stateParams', function ($match, $stateParams) {
	        if ($state.$current.navigable != state || !equalForKeys($match, $stateParams)) {
	          $state.transitionTo(state, $match, { inherit: true, location: false });
	        }
	      }]);
	    }
	
	    // Register any queued children
	    flushQueuedChildren(name);
	
	    return state;
	  }
	
	  // Checks text to see if it looks like a glob.
	  function isGlob (text) {
	    return text.indexOf('*') > -1;
	  }
	
	  // Returns true if glob matches current $state name.
	  function doesStateMatchGlob (glob) {
	    var globSegments = glob.split('.'),
	        segments = $state.$current.name.split('.');
	
	    //match single stars
	    for (var i = 0, l = globSegments.length; i < l; i++) {
	      if (globSegments[i] === '*') {
	        segments[i] = '*';
	      }
	    }
	
	    //match greedy starts
	    if (globSegments[0] === '**') {
	       segments = segments.slice(indexOf(segments, globSegments[1]));
	       segments.unshift('**');
	    }
	    //match greedy ends
	    if (globSegments[globSegments.length - 1] === '**') {
	       segments.splice(indexOf(segments, globSegments[globSegments.length - 2]) + 1, Number.MAX_VALUE);
	       segments.push('**');
	    }
	
	    if (globSegments.length != segments.length) {
	      return false;
	    }
	
	    return segments.join('') === globSegments.join('');
	  }
	
	
	  // Implicit root state that is always active
	  root = registerState({
	    name: '',
	    url: '^',
	    views: null,
	    'abstract': true
	  });
	  root.navigable = null;
	
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$stateProvider#decorator
	   * @methodOf ui.router.state.$stateProvider
	   *
	   * @description
	   * Allows you to extend (carefully) or override (at your own peril) the 
	   * `stateBuilder` object used internally by `$stateProvider`. This can be used 
	   * to add custom functionality to ui-router, for example inferring templateUrl 
	   * based on the state name.
	   *
	   * When passing only a name, it returns the current (original or decorated) builder
	   * function that matches `name`.
	   *
	   * The builder functions that can be decorated are listed below. Though not all
	   * necessarily have a good use case for decoration, that is up to you to decide.
	   *
	   * In addition, users can attach custom decorators, which will generate new 
	   * properties within the state's internal definition. There is currently no clear 
	   * use-case for this beyond accessing internal states (i.e. $state.$current), 
	   * however, expect this to become increasingly relevant as we introduce additional 
	   * meta-programming features.
	   *
	   * **Warning**: Decorators should not be interdependent because the order of 
	   * execution of the builder functions in non-deterministic. Builder functions 
	   * should only be dependent on the state definition object and super function.
	   *
	   *
	   * Existing builder functions and current return values:
	   *
	   * - **parent** `{object}` - returns the parent state object.
	   * - **data** `{object}` - returns state data, including any inherited data that is not
	   *   overridden by own values (if any).
	   * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
	   *   or `null`.
	   * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is 
	   *   navigable).
	   * - **params** `{object}` - returns an array of state params that are ensured to 
	   *   be a super-set of parent's params.
	   * - **views** `{object}` - returns a views object where each key is an absolute view 
	   *   name (i.e. "viewName@stateName") and each value is the config object 
	   *   (template, controller) for the view. Even when you don't use the views object 
	   *   explicitly on a state config, one is still created for you internally.
	   *   So by decorating this builder function you have access to decorating template 
	   *   and controller properties.
	   * - **ownParams** `{object}` - returns an array of params that belong to the state, 
	   *   not including any params defined by ancestor states.
	   * - **path** `{string}` - returns the full path from the root down to this state. 
	   *   Needed for state activation.
	   * - **includes** `{object}` - returns an object that includes every state that 
	   *   would pass a `$state.includes()` test.
	   *
	   * @example
	   * <pre>
	   * // Override the internal 'views' builder with a function that takes the state
	   * // definition, and a reference to the internal function being overridden:
	   * $stateProvider.decorator('views', function (state, parent) {
	   *   var result = {},
	   *       views = parent(state);
	   *
	   *   angular.forEach(views, function (config, name) {
	   *     var autoName = (state.name + '.' + name).replace('.', '/');
	   *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
	   *     result[name] = config;
	   *   });
	   *   return result;
	   * });
	   *
	   * $stateProvider.state('home', {
	   *   views: {
	   *     'contact.list': { controller: 'ListController' },
	   *     'contact.item': { controller: 'ItemController' }
	   *   }
	   * });
	   *
	   * // ...
	   *
	   * $state.go('home');
	   * // Auto-populates list and item views with /partials/home/contact/list.html,
	   * // and /partials/home/contact/item.html, respectively.
	   * </pre>
	   *
	   * @param {string} name The name of the builder function to decorate. 
	   * @param {object} func A function that is responsible for decorating the original 
	   * builder function. The function receives two parameters:
	   *
	   *   - `{object}` - state - The state config object.
	   *   - `{object}` - super - The original builder function.
	   *
	   * @return {object} $stateProvider - $stateProvider instance
	   */
	  this.decorator = decorator;
	  function decorator(name, func) {
	    /*jshint validthis: true */
	    if (isString(name) && !isDefined(func)) {
	      return stateBuilder[name];
	    }
	    if (!isFunction(func) || !isString(name)) {
	      return this;
	    }
	    if (stateBuilder[name] && !stateBuilder.$delegates[name]) {
	      stateBuilder.$delegates[name] = stateBuilder[name];
	    }
	    stateBuilder[name] = func;
	    return this;
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$stateProvider#state
	   * @methodOf ui.router.state.$stateProvider
	   *
	   * @description
	   * Registers a state configuration under a given state name. The stateConfig object
	   * has the following acceptable properties.
	   *
	   * @param {string} name A unique state name, e.g. "home", "about", "contacts".
	   * To create a parent/child state use a dot, e.g. "about.sales", "home.newest".
	   * @param {object} stateConfig State configuration object.
	   * @param {string|function=} stateConfig.template
	   * <a id='template'></a>
	   *   html template as a string or a function that returns
	   *   an html template as a string which should be used by the uiView directives. This property 
	   *   takes precedence over templateUrl.
	   *   
	   *   If `template` is a function, it will be called with the following parameters:
	   *
	   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by
	   *     applying the current state
	   *
	   * <pre>template:
	   *   "<h1>inline template definition</h1>" +
	   *   "<div ui-view></div>"</pre>
	   * <pre>template: function(params) {
	   *       return "<h1>generated template</h1>"; }</pre>
	   * </div>
	   *
	   * @param {string|function=} stateConfig.templateUrl
	   * <a id='templateUrl'></a>
	   *
	   *   path or function that returns a path to an html
	   *   template that should be used by uiView.
	   *   
	   *   If `templateUrl` is a function, it will be called with the following parameters:
	   *
	   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by 
	   *     applying the current state
	   *
	   * <pre>templateUrl: "home.html"</pre>
	   * <pre>templateUrl: function(params) {
	   *     return myTemplates[params.pageId]; }</pre>
	   *
	   * @param {function=} stateConfig.templateProvider
	   * <a id='templateProvider'></a>
	   *    Provider function that returns HTML content string.
	   * <pre> templateProvider:
	   *       function(MyTemplateService, params) {
	   *         return MyTemplateService.getTemplate(params.pageId);
	   *       }</pre>
	   *
	   * @param {string|function=} stateConfig.controller
	   * <a id='controller'></a>
	   *
	   *  Controller fn that should be associated with newly
	   *   related scope or the name of a registered controller if passed as a string.
	   *   Optionally, the ControllerAs may be declared here.
	   * <pre>controller: "MyRegisteredController"</pre>
	   * <pre>controller:
	   *     "MyRegisteredController as fooCtrl"}</pre>
	   * <pre>controller: function($scope, MyService) {
	   *     $scope.data = MyService.getData(); }</pre>
	   *
	   * @param {function=} stateConfig.controllerProvider
	   * <a id='controllerProvider'></a>
	   *
	   * Injectable provider function that returns the actual controller or string.
	   * <pre>controllerProvider:
	   *   function(MyResolveData) {
	   *     if (MyResolveData.foo)
	   *       return "FooCtrl"
	   *     else if (MyResolveData.bar)
	   *       return "BarCtrl";
	   *     else return function($scope) {
	   *       $scope.baz = "Qux";
	   *     }
	   *   }</pre>
	   *
	   * @param {string=} stateConfig.controllerAs
	   * <a id='controllerAs'></a>
	   * 
	   * A controller alias name. If present the controller will be
	   *   published to scope under the controllerAs name.
	   * <pre>controllerAs: "myCtrl"</pre>
	   *
	   * @param {string|object=} stateConfig.parent
	   * <a id='parent'></a>
	   * Optionally specifies the parent state of this state.
	   *
	   * <pre>parent: 'parentState'</pre>
	   * <pre>parent: parentState // JS variable</pre>
	   *
	   * @param {object=} stateConfig.resolve
	   * <a id='resolve'></a>
	   *
	   * An optional map&lt;string, function&gt; of dependencies which
	   *   should be injected into the controller. If any of these dependencies are promises, 
	   *   the router will wait for them all to be resolved before the controller is instantiated.
	   *   If all the promises are resolved successfully, the $stateChangeSuccess event is fired
	   *   and the values of the resolved promises are injected into any controllers that reference them.
	   *   If any  of the promises are rejected the $stateChangeError event is fired.
	   *
	   *   The map object is:
	   *   
	   *   - key - {string}: name of dependency to be injected into controller
	   *   - factory - {string|function}: If string then it is alias for service. Otherwise if function, 
	   *     it is injected and return value it treated as dependency. If result is a promise, it is 
	   *     resolved before its value is injected into controller.
	   *
	   * <pre>resolve: {
	   *     myResolve1:
	   *       function($http, $stateParams) {
	   *         return $http.get("/api/foos/"+stateParams.fooID);
	   *       }
	   *     }</pre>
	   *
	   * @param {string=} stateConfig.url
	   * <a id='url'></a>
	   *
	   *   A url fragment with optional parameters. When a state is navigated or
	   *   transitioned to, the `$stateParams` service will be populated with any 
	   *   parameters that were passed.
	   *
	   *   (See {@link ui.router.util.type:UrlMatcher UrlMatcher} `UrlMatcher`} for
	   *   more details on acceptable patterns )
	   *
	   * examples:
	   * <pre>url: "/home"
	   * url: "/users/:userid"
	   * url: "/books/{bookid:[a-zA-Z_-]}"
	   * url: "/books/{categoryid:int}"
	   * url: "/books/{publishername:string}/{categoryid:int}"
	   * url: "/messages?before&after"
	   * url: "/messages?{before:date}&{after:date}"
	   * url: "/messages/:mailboxid?{before:date}&{after:date}"
	   * </pre>
	   *
	   * @param {object=} stateConfig.views
	   * <a id='views'></a>
	   * an optional map&lt;string, object&gt; which defined multiple views, or targets views
	   * manually/explicitly.
	   *
	   * Examples:
	   *
	   * Targets three named `ui-view`s in the parent state's template
	   * <pre>views: {
	   *     header: {
	   *       controller: "headerCtrl",
	   *       templateUrl: "header.html"
	   *     }, body: {
	   *       controller: "bodyCtrl",
	   *       templateUrl: "body.html"
	   *     }, footer: {
	   *       controller: "footCtrl",
	   *       templateUrl: "footer.html"
	   *     }
	   *   }</pre>
	   *
	   * Targets named `ui-view="header"` from grandparent state 'top''s template, and named `ui-view="body" from parent state's template.
	   * <pre>views: {
	   *     'header@top': {
	   *       controller: "msgHeaderCtrl",
	   *       templateUrl: "msgHeader.html"
	   *     }, 'body': {
	   *       controller: "messagesCtrl",
	   *       templateUrl: "messages.html"
	   *     }
	   *   }</pre>
	   *
	   * @param {boolean=} [stateConfig.abstract=false]
	   * <a id='abstract'></a>
	   * An abstract state will never be directly activated,
	   *   but can provide inherited properties to its common children states.
	   * <pre>abstract: true</pre>
	   *
	   * @param {function=} stateConfig.onEnter
	   * <a id='onEnter'></a>
	   *
	   * Callback function for when a state is entered. Good way
	   *   to trigger an action or dispatch an event, such as opening a dialog.
	   * If minifying your scripts, make sure to explicitly annotate this function,
	   * because it won't be automatically annotated by your build tools.
	   *
	   * <pre>onEnter: function(MyService, $stateParams) {
	   *     MyService.foo($stateParams.myParam);
	   * }</pre>
	   *
	   * @param {function=} stateConfig.onExit
	   * <a id='onExit'></a>
	   *
	   * Callback function for when a state is exited. Good way to
	   *   trigger an action or dispatch an event, such as opening a dialog.
	   * If minifying your scripts, make sure to explicitly annotate this function,
	   * because it won't be automatically annotated by your build tools.
	   *
	   * <pre>onExit: function(MyService, $stateParams) {
	   *     MyService.cleanup($stateParams.myParam);
	   * }</pre>
	   *
	   * @param {boolean=} [stateConfig.reloadOnSearch=true]
	   * <a id='reloadOnSearch'></a>
	   *
	   * If `false`, will not retrigger the same state
	   *   just because a search/query parameter has changed (via $location.search() or $location.hash()). 
	   *   Useful for when you'd like to modify $location.search() without triggering a reload.
	   * <pre>reloadOnSearch: false</pre>
	   *
	   * @param {object=} stateConfig.data
	   * <a id='data'></a>
	   *
	   * Arbitrary data object, useful for custom configuration.  The parent state's `data` is
	   *   prototypally inherited.  In other words, adding a data property to a state adds it to
	   *   the entire subtree via prototypal inheritance.
	   *
	   * <pre>data: {
	   *     requiredRole: 'foo'
	   * } </pre>
	   *
	   * @param {object=} stateConfig.params
	   * <a id='params'></a>
	   *
	   * A map which optionally configures parameters declared in the `url`, or
	   *   defines additional non-url parameters.  For each parameter being
	   *   configured, add a configuration object keyed to the name of the parameter.
	   *
	   *   Each parameter configuration object may contain the following properties:
	   *
	   *   - ** value ** - {object|function=}: specifies the default value for this
	   *     parameter.  This implicitly sets this parameter as optional.
	   *
	   *     When UI-Router routes to a state and no value is
	   *     specified for this parameter in the URL or transition, the
	   *     default value will be used instead.  If `value` is a function,
	   *     it will be injected and invoked, and the return value used.
	   *
	   *     *Note*: `undefined` is treated as "no default value" while `null`
	   *     is treated as "the default value is `null`".
	   *
	   *     *Shorthand*: If you only need to configure the default value of the
	   *     parameter, you may use a shorthand syntax.   In the **`params`**
	   *     map, instead mapping the param name to a full parameter configuration
	   *     object, simply set map it to the default parameter value, e.g.:
	   *
	   * <pre>// define a parameter's default value
	   * params: {
	   *     param1: { value: "defaultValue" }
	   * }
	   * // shorthand default values
	   * params: {
	   *     param1: "defaultValue",
	   *     param2: "param2Default"
	   * }</pre>
	   *
	   *   - ** array ** - {boolean=}: *(default: false)* If true, the param value will be
	   *     treated as an array of values.  If you specified a Type, the value will be
	   *     treated as an array of the specified Type.  Note: query parameter values
	   *     default to a special `"auto"` mode.
	   *
	   *     For query parameters in `"auto"` mode, if multiple  values for a single parameter
	   *     are present in the URL (e.g.: `/foo?bar=1&bar=2&bar=3`) then the values
	   *     are mapped to an array (e.g.: `{ foo: [ '1', '2', '3' ] }`).  However, if
	   *     only one value is present (e.g.: `/foo?bar=1`) then the value is treated as single
	   *     value (e.g.: `{ foo: '1' }`).
	   *
	   * <pre>params: {
	   *     param1: { array: true }
	   * }</pre>
	   *
	   *   - ** squash ** - {bool|string=}: `squash` configures how a default parameter value is represented in the URL when
	   *     the current parameter value is the same as the default value. If `squash` is not set, it uses the
	   *     configured default squash policy.
	   *     (See {@link ui.router.util.$urlMatcherFactory#methods_defaultSquashPolicy `defaultSquashPolicy()`})
	   *
	   *   There are three squash settings:
	   *
	   *     - false: The parameter's default value is not squashed.  It is encoded and included in the URL
	   *     - true: The parameter's default value is omitted from the URL.  If the parameter is preceeded and followed
	   *       by slashes in the state's `url` declaration, then one of those slashes are omitted.
	   *       This can allow for cleaner looking URLs.
	   *     - `"<arbitrary string>"`: The parameter's default value is replaced with an arbitrary placeholder of  your choice.
	   *
	   * <pre>params: {
	   *     param1: {
	   *       value: "defaultId",
	   *       squash: true
	   * } }
	   * // squash "defaultValue" to "~"
	   * params: {
	   *     param1: {
	   *       value: "defaultValue",
	   *       squash: "~"
	   * } }
	   * </pre>
	   *
	   *
	   * @example
	   * <pre>
	   * // Some state name examples
	   *
	   * // stateName can be a single top-level name (must be unique).
	   * $stateProvider.state("home", {});
	   *
	   * // Or it can be a nested state name. This state is a child of the
	   * // above "home" state.
	   * $stateProvider.state("home.newest", {});
	   *
	   * // Nest states as deeply as needed.
	   * $stateProvider.state("home.newest.abc.xyz.inception", {});
	   *
	   * // state() returns $stateProvider, so you can chain state declarations.
	   * $stateProvider
	   *   .state("home", {})
	   *   .state("about", {})
	   *   .state("contacts", {});
	   * </pre>
	   *
	   */
	  this.state = state;
	  function state(name, definition) {
	    /*jshint validthis: true */
	    if (isObject(name)) definition = name;
	    else definition.name = name;
	    registerState(definition);
	    return this;
	  }
	
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$state
	   *
	   * @requires $rootScope
	   * @requires $q
	   * @requires ui.router.state.$view
	   * @requires $injector
	   * @requires ui.router.util.$resolve
	   * @requires ui.router.state.$stateParams
	   * @requires ui.router.router.$urlRouter
	   *
	   * @property {object} params A param object, e.g. {sectionId: section.id)}, that 
	   * you'd like to test against the current active state.
	   * @property {object} current A reference to the state's config object. However 
	   * you passed it in. Useful for accessing custom data.
	   * @property {object} transition Currently pending transition. A promise that'll 
	   * resolve or reject.
	   *
	   * @description
	   * `$state` service is responsible for representing states as well as transitioning
	   * between them. It also provides interfaces to ask for current state or even states
	   * you're coming from.
	   */
	  this.$get = $get;
	  $get.$inject = ['$rootScope', '$q', '$view', '$injector', '$resolve', '$stateParams', '$urlRouter', '$location', '$urlMatcherFactory'];
	  function $get(   $rootScope,   $q,   $view,   $injector,   $resolve,   $stateParams,   $urlRouter,   $location,   $urlMatcherFactory) {
	
	    var TransitionSuperseded = $q.reject(new Error('transition superseded'));
	    var TransitionPrevented = $q.reject(new Error('transition prevented'));
	    var TransitionAborted = $q.reject(new Error('transition aborted'));
	    var TransitionFailed = $q.reject(new Error('transition failed'));
	
	    // Handles the case where a state which is the target of a transition is not found, and the user
	    // can optionally retry or defer the transition
	    function handleRedirect(redirect, state, params, options) {
	      /**
	       * @ngdoc event
	       * @name ui.router.state.$state#$stateNotFound
	       * @eventOf ui.router.state.$state
	       * @eventType broadcast on root scope
	       * @description
	       * Fired when a requested state **cannot be found** using the provided state name during transition.
	       * The event is broadcast allowing any handlers a single chance to deal with the error (usually by
	       * lazy-loading the unfound state). A special `unfoundState` object is passed to the listener handler,
	       * you can see its three properties in the example. You can use `event.preventDefault()` to abort the
	       * transition and the promise returned from `go` will be rejected with a `'transition aborted'` value.
	       *
	       * @param {Object} event Event object.
	       * @param {Object} unfoundState Unfound State information. Contains: `to, toParams, options` properties.
	       * @param {State} fromState Current state object.
	       * @param {Object} fromParams Current state params.
	       *
	       * @example
	       *
	       * <pre>
	       * // somewhere, assume lazy.state has not been defined
	       * $state.go("lazy.state", {a:1, b:2}, {inherit:false});
	       *
	       * // somewhere else
	       * $scope.$on('$stateNotFound',
	       * function(event, unfoundState, fromState, fromParams){
	       *     console.log(unfoundState.to); // "lazy.state"
	       *     console.log(unfoundState.toParams); // {a:1, b:2}
	       *     console.log(unfoundState.options); // {inherit:false} + default options
	       * })
	       * </pre>
	       */
	      var evt = $rootScope.$broadcast('$stateNotFound', redirect, state, params);
	
	      if (evt.defaultPrevented) {
	        $urlRouter.update();
	        return TransitionAborted;
	      }
	
	      if (!evt.retry) {
	        return null;
	      }
	
	      // Allow the handler to return a promise to defer state lookup retry
	      if (options.$retry) {
	        $urlRouter.update();
	        return TransitionFailed;
	      }
	      var retryTransition = $state.transition = $q.when(evt.retry);
	
	      retryTransition.then(function() {
	        if (retryTransition !== $state.transition) return TransitionSuperseded;
	        redirect.options.$retry = true;
	        return $state.transitionTo(redirect.to, redirect.toParams, redirect.options);
	      }, function() {
	        return TransitionAborted;
	      });
	      $urlRouter.update();
	
	      return retryTransition;
	    }
	
	    root.locals = { resolve: null, globals: { $stateParams: {} } };
	
	    $state = {
	      params: {},
	      current: root.self,
	      $current: root,
	      transition: null
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#reload
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A method that force reloads the current state. All resolves are re-resolved,
	     * controllers reinstantiated, and events re-fired.
	     *
	     * @example
	     * <pre>
	     * var app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     $state.reload();
	     *   }
	     * });
	     * </pre>
	     *
	     * `reload()` is just an alias for:
	     * <pre>
	     * $state.transitionTo($state.current, $stateParams, { 
	     *   reload: true, inherit: false, notify: true
	     * });
	     * </pre>
	     *
	     * @param {string=|object=} state - A state name or a state object, which is the root of the resolves to be re-resolved.
	     * @example
	     * <pre>
	     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item' 
	     * //and current state is 'contacts.detail.item'
	     * var app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     //will reload 'contact.detail' and 'contact.detail.item' states
	     *     $state.reload('contact.detail');
	     *   }
	     * });
	     * </pre>
	     *
	     * `reload()` is just an alias for:
	     * <pre>
	     * $state.transitionTo($state.current, $stateParams, { 
	     *   reload: true, inherit: false, notify: true
	     * });
	     * </pre>
	
	     * @returns {promise} A promise representing the state of the new transition. See
	     * {@link ui.router.state.$state#methods_go $state.go}.
	     */
	    $state.reload = function reload(state) {
	      return $state.transitionTo($state.current, $stateParams, { reload: state || true, inherit: false, notify: true});
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#go
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Convenience method for transitioning to a new state. `$state.go` calls 
	     * `$state.transitionTo` internally but automatically sets options to 
	     * `{ location: true, inherit: true, relative: $state.$current, notify: true }`. 
	     * This allows you to easily use an absolute or relative to path and specify 
	     * only the parameters you'd like to update (while letting unspecified parameters 
	     * inherit from the currently active ancestor states).
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.go('contact.detail');
	     *   };
	     * });
	     * </pre>
	     * <img src='../ngdoc_assets/StateGoExamples.png'/>
	     *
	     * @param {string} to Absolute state name or relative state path. Some examples:
	     *
	     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
	     * - `$state.go('^')` - will go to a parent state
	     * - `$state.go('^.sibling')` - will go to a sibling state
	     * - `$state.go('.child.grandchild')` - will go to grandchild state
	     *
	     * @param {object=} params A map of the parameters that will be sent to the state, 
	     * will populate $stateParams. Any parameters that are not specified will be inherited from currently 
	     * defined parameters. Only parameters specified in the state definition can be overridden, new 
	     * parameters will be ignored. This allows, for example, going to a sibling state that shares parameters
	     * specified in a parent state. Parameter inheritance only works between common ancestor states, I.e.
	     * transitioning to a sibling will get you the parameters for all parents, transitioning to a child
	     * will get you all current parameters, etc.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
	     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
	     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
	     * - **`reload`** (v0.2.5) - {boolean=false|string|object}, If `true` will force transition even if no state or params
	     *    have changed.  It will reload the resolves and views of the current state and parent states.
	     *    If `reload` is a string (or state object), the state object is fetched (by name, or object reference); and \
	     *    the transition reloads the resolves and views for that matched state, and all its children states.
	     *
	     * @returns {promise} A promise representing the state of the new transition.
	     *
	     * Possible success values:
	     *
	     * - $state.current
	     *
	     * <br/>Possible rejection values:
	     *
	     * - 'transition superseded' - when a newer transition has been started after this one
	     * - 'transition prevented' - when `event.preventDefault()` has been called in a `$stateChangeStart` listener
	     * - 'transition aborted' - when `event.preventDefault()` has been called in a `$stateNotFound` listener or
	     *   when a `$stateNotFound` `event.retry` promise errors.
	     * - 'transition failed' - when a state has been unsuccessfully found after 2 tries.
	     * - *resolve error* - when an error has occurred with a `resolve`
	     *
	     */
	    $state.go = function go(to, params, options) {
	      return $state.transitionTo(to, params, extend({ inherit: true, relative: $state.$current }, options));
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#transitionTo
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Low-level method for transitioning to a new state. {@link ui.router.state.$state#methods_go $state.go}
	     * uses `transitionTo` internally. `$state.go` is recommended in most situations.
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.transitionTo('contact.detail');
	     *   };
	     * });
	     * </pre>
	     *
	     * @param {string} to State name.
	     * @param {object=} toParams A map of the parameters that will be sent to the state,
	     * will populate $stateParams.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
	     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
	     * - **`inherit`** - {boolean=false}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
	     * - **`reload`** (v0.2.5) - {boolean=false|string=|object=}, If `true` will force transition even if the state or params 
	     *    have not changed, aka a reload of the same state. It differs from reloadOnSearch because you'd
	     *    use this when you want to force a reload when *everything* is the same, including search params.
	     *    if String, then will reload the state with the name given in reload, and any children.
	     *    if Object, then a stateObj is expected, will reload the state found in stateObj, and any children.
	     *
	     * @returns {promise} A promise representing the state of the new transition. See
	     * {@link ui.router.state.$state#methods_go $state.go}.
	     */
	    $state.transitionTo = function transitionTo(to, toParams, options) {
	      toParams = toParams || {};
	      options = extend({
	        location: true, inherit: false, relative: null, notify: true, reload: false, $retry: false
	      }, options || {});
	
	      var from = $state.$current, fromParams = $state.params, fromPath = from.path;
	      var evt, toState = findState(to, options.relative);
	
	      // Store the hash param for later (since it will be stripped out by various methods)
	      var hash = toParams['#'];
	
	      if (!isDefined(toState)) {
	        var redirect = { to: to, toParams: toParams, options: options };
	        var redirectResult = handleRedirect(redirect, from.self, fromParams, options);
	
	        if (redirectResult) {
	          return redirectResult;
	        }
	
	        // Always retry once if the $stateNotFound was not prevented
	        // (handles either redirect changed or state lazy-definition)
	        to = redirect.to;
	        toParams = redirect.toParams;
	        options = redirect.options;
	        toState = findState(to, options.relative);
	
	        if (!isDefined(toState)) {
	          if (!options.relative) throw new Error("No such state '" + to + "'");
	          throw new Error("Could not resolve '" + to + "' from state '" + options.relative + "'");
	        }
	      }
	      if (toState[abstractKey]) throw new Error("Cannot transition to abstract state '" + to + "'");
	      if (options.inherit) toParams = inheritParams($stateParams, toParams || {}, $state.$current, toState);
	      if (!toState.params.$$validates(toParams)) return TransitionFailed;
	
	      toParams = toState.params.$$values(toParams);
	      to = toState;
	
	      var toPath = to.path;
	
	      // Starting from the root of the path, keep all levels that haven't changed
	      var keep = 0, state = toPath[keep], locals = root.locals, toLocals = [];
	
	      if (!options.reload) {
	        while (state && state === fromPath[keep] && state.ownParams.$$equals(toParams, fromParams)) {
	          locals = toLocals[keep] = state.locals;
	          keep++;
	          state = toPath[keep];
	        }
	      } else if (isString(options.reload) || isObject(options.reload)) {
	        if (isObject(options.reload) && !options.reload.name) {
	          throw new Error('Invalid reload state object');
	        }
	        
	        var reloadState = options.reload === true ? fromPath[0] : findState(options.reload);
	        if (options.reload && !reloadState) {
	          throw new Error("No such reload state '" + (isString(options.reload) ? options.reload : options.reload.name) + "'");
	        }
	
	        while (state && state === fromPath[keep] && state !== reloadState) {
	          locals = toLocals[keep] = state.locals;
	          keep++;
	          state = toPath[keep];
	        }
	      }
	
	      // If we're going to the same state and all locals are kept, we've got nothing to do.
	      // But clear 'transition', as we still want to cancel any other pending transitions.
	      // TODO: We may not want to bump 'transition' if we're called from a location change
	      // that we've initiated ourselves, because we might accidentally abort a legitimate
	      // transition initiated from code?
	      if (shouldSkipReload(to, toParams, from, fromParams, locals, options)) {
	        if (hash) toParams['#'] = hash;
	        $state.params = toParams;
	        copy($state.params, $stateParams);
	        copy(filterByKeys(to.params.$$keys(), $stateParams), to.locals.globals.$stateParams);
	        if (options.location && to.navigable && to.navigable.url) {
	          $urlRouter.push(to.navigable.url, toParams, {
	            $$avoidResync: true, replace: options.location === 'replace'
	          });
	          $urlRouter.update(true);
	        }
	        $state.transition = null;
	        return $q.when($state.current);
	      }
	
	      // Filter parameters before we pass them to event handlers etc.
	      toParams = filterByKeys(to.params.$$keys(), toParams || {});
	      
	      // Re-add the saved hash before we start returning things or broadcasting $stateChangeStart
	      if (hash) toParams['#'] = hash;
	      
	      // Broadcast start event and cancel the transition if requested
	      if (options.notify) {
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeStart
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired when the state transition **begins**. You can use `event.preventDefault()`
	         * to prevent the transition from happening and then the transition promise will be
	         * rejected with a `'transition prevented'` value.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         *
	         * @example
	         *
	         * <pre>
	         * $rootScope.$on('$stateChangeStart',
	         * function(event, toState, toParams, fromState, fromParams){
	         *     event.preventDefault();
	         *     // transitionTo() promise will be rejected with
	         *     // a 'transition prevented' error
	         * })
	         * </pre>
	         */
	        if ($rootScope.$broadcast('$stateChangeStart', to.self, toParams, from.self, fromParams, options).defaultPrevented) {
	          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
	          //Don't update and resync url if there's been a new transition started. see issue #2238, #600
	          if ($state.transition == null) $urlRouter.update();
	          return TransitionPrevented;
	        }
	      }
	
	      // Resolve locals for the remaining states, but don't update any global state just
	      // yet -- if anything fails to resolve the current state needs to remain untouched.
	      // We also set up an inheritance chain for the locals here. This allows the view directive
	      // to quickly look up the correct definition for each view in the current state. Even
	      // though we create the locals object itself outside resolveState(), it is initially
	      // empty and gets filled asynchronously. We need to keep track of the promise for the
	      // (fully resolved) current locals, and pass this down the chain.
	      var resolved = $q.when(locals);
	
	      for (var l = keep; l < toPath.length; l++, state = toPath[l]) {
	        locals = toLocals[l] = inherit(locals);
	        resolved = resolveState(state, toParams, state === to, resolved, locals, options);
	      }
	
	      // Once everything is resolved, we are ready to perform the actual transition
	      // and return a promise for the new state. We also keep track of what the
	      // current promise is, so that we can detect overlapping transitions and
	      // keep only the outcome of the last transition.
	      var transition = $state.transition = resolved.then(function () {
	        var l, entering, exiting;
	
	        if ($state.transition !== transition) return TransitionSuperseded;
	
	        // Exit 'from' states not kept
	        for (l = fromPath.length - 1; l >= keep; l--) {
	          exiting = fromPath[l];
	          if (exiting.self.onExit) {
	            $injector.invoke(exiting.self.onExit, exiting.self, exiting.locals.globals);
	          }
	          exiting.locals = null;
	        }
	
	        // Enter 'to' states not kept
	        for (l = keep; l < toPath.length; l++) {
	          entering = toPath[l];
	          entering.locals = toLocals[l];
	          if (entering.self.onEnter) {
	            $injector.invoke(entering.self.onEnter, entering.self, entering.locals.globals);
	          }
	        }
	
	        // Run it again, to catch any transitions in callbacks
	        if ($state.transition !== transition) return TransitionSuperseded;
	
	        // Update globals in $state
	        $state.$current = to;
	        $state.current = to.self;
	        $state.params = toParams;
	        copy($state.params, $stateParams);
	        $state.transition = null;
	
	        if (options.location && to.navigable) {
	          $urlRouter.push(to.navigable.url, to.navigable.locals.globals.$stateParams, {
	            $$avoidResync: true, replace: options.location === 'replace'
	          });
	        }
	
	        if (options.notify) {
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeSuccess
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired once the state transition is **complete**.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         */
	          $rootScope.$broadcast('$stateChangeSuccess', to.self, toParams, from.self, fromParams);
	        }
	        $urlRouter.update(true);
	
	        return $state.current;
	      }, function (error) {
	        if ($state.transition !== transition) return TransitionSuperseded;
	
	        $state.transition = null;
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeError
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired when an **error occurs** during transition. It's important to note that if you
	         * have any errors in your resolve functions (javascript errors, non-existent services, etc)
	         * they will not throw traditionally. You must listen for this $stateChangeError event to
	         * catch **ALL** errors.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         * @param {Error} error The resolve error object.
	         */
	        evt = $rootScope.$broadcast('$stateChangeError', to.self, toParams, from.self, fromParams, error);
	
	        if (!evt.defaultPrevented) {
	            $urlRouter.update();
	        }
	
	        return $q.reject(error);
	      });
	
	      return transition;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#is
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Similar to {@link ui.router.state.$state#methods_includes $state.includes},
	     * but only checks for the full state name. If params is supplied then it will be
	     * tested for strict equality against the current active params object, so all params
	     * must match with none missing and no extras.
	     *
	     * @example
	     * <pre>
	     * $state.$current.name = 'contacts.details.item';
	     *
	     * // absolute name
	     * $state.is('contact.details.item'); // returns true
	     * $state.is(contactDetailItemStateObject); // returns true
	     *
	     * // relative name (. and ^), typically from a template
	     * // E.g. from the 'contacts.details' template
	     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
	     * </pre>
	     *
	     * @param {string|object} stateOrName The state name (absolute or relative) or state object you'd like to check.
	     * @param {object=} params A param object, e.g. `{sectionId: section.id}`, that you'd like
	     * to test against the current active state.
	     * @param {object=} options An options object.  The options are:
	     *
	     * - **`relative`** - {string|object} -  If `stateOrName` is a relative state name and `options.relative` is set, .is will
	     * test relative to `options.relative` state (or name).
	     *
	     * @returns {boolean} Returns true if it is the state.
	     */
	    $state.is = function is(stateOrName, params, options) {
	      options = extend({ relative: $state.$current }, options || {});
	      var state = findState(stateOrName, options.relative);
	
	      if (!isDefined(state)) { return undefined; }
	      if ($state.$current !== state) { return false; }
	      return params ? equalForKeys(state.params.$$values(params), $stateParams) : true;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#includes
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A method to determine if the current active state is equal to or is the child of the
	     * state stateName. If any params are passed then they will be tested for a match as well.
	     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
	     *
	     * @example
	     * Partial and relative names
	     * <pre>
	     * $state.$current.name = 'contacts.details.item';
	     *
	     * // Using partial names
	     * $state.includes("contacts"); // returns true
	     * $state.includes("contacts.details"); // returns true
	     * $state.includes("contacts.details.item"); // returns true
	     * $state.includes("contacts.list"); // returns false
	     * $state.includes("about"); // returns false
	     *
	     * // Using relative names (. and ^), typically from a template
	     * // E.g. from the 'contacts.details' template
	     * <div ng-class="{highlighted: $state.includes('.item')}">Item</div>
	     * </pre>
	     *
	     * Basic globbing patterns
	     * <pre>
	     * $state.$current.name = 'contacts.details.item.url';
	     *
	     * $state.includes("*.details.*.*"); // returns true
	     * $state.includes("*.details.**"); // returns true
	     * $state.includes("**.item.**"); // returns true
	     * $state.includes("*.details.item.url"); // returns true
	     * $state.includes("*.details.*.url"); // returns true
	     * $state.includes("*.details.*"); // returns false
	     * $state.includes("item.**"); // returns false
	     * </pre>
	     *
	     * @param {string} stateOrName A partial name, relative name, or glob pattern
	     * to be searched for within the current state name.
	     * @param {object=} params A param object, e.g. `{sectionId: section.id}`,
	     * that you'd like to test against the current active state.
	     * @param {object=} options An options object.  The options are:
	     *
	     * - **`relative`** - {string|object=} -  If `stateOrName` is a relative state reference and `options.relative` is set,
	     * .includes will test relative to `options.relative` state (or name).
	     *
	     * @returns {boolean} Returns true if it does include the state
	     */
	    $state.includes = function includes(stateOrName, params, options) {
	      options = extend({ relative: $state.$current }, options || {});
	      if (isString(stateOrName) && isGlob(stateOrName)) {
	        if (!doesStateMatchGlob(stateOrName)) {
	          return false;
	        }
	        stateOrName = $state.$current.name;
	      }
	
	      var state = findState(stateOrName, options.relative);
	      if (!isDefined(state)) { return undefined; }
	      if (!isDefined($state.$current.includes[state.name])) { return false; }
	      return params ? equalForKeys(state.params.$$values(params), $stateParams, objectKeys(params)) : true;
	    };
	
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#href
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A url generation method that returns the compiled url for the given state populated with the given params.
	     *
	     * @example
	     * <pre>
	     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
	     * </pre>
	     *
	     * @param {string|object} stateOrName The state name or state object you'd like to generate a url from.
	     * @param {object=} params An object of parameter values to fill the state's required parameters.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`lossy`** - {boolean=true} -  If true, and if there is no url associated with the state provided in the
	     *    first parameter, then the constructed href url will be built from the first navigable ancestor (aka
	     *    ancestor with a valid url).
	     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	     * 
	     * @returns {string} compiled state url
	     */
	    $state.href = function href(stateOrName, params, options) {
	      options = extend({
	        lossy:    true,
	        inherit:  true,
	        absolute: false,
	        relative: $state.$current
	      }, options || {});
	
	      var state = findState(stateOrName, options.relative);
	
	      if (!isDefined(state)) return null;
	      if (options.inherit) params = inheritParams($stateParams, params || {}, $state.$current, state);
	      
	      var nav = (state && options.lossy) ? state.navigable : state;
	
	      if (!nav || nav.url === undefined || nav.url === null) {
	        return null;
	      }
	      return $urlRouter.href(nav.url, filterByKeys(state.params.$$keys().concat('#'), params || {}), {
	        absolute: options.absolute
	      });
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#get
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Returns the state configuration object for any specific state or all states.
	     *
	     * @param {string|object=} stateOrName (absolute or relative) If provided, will only get the config for
	     * the requested state. If not provided, returns an array of ALL state configs.
	     * @param {string|object=} context When stateOrName is a relative state reference, the state will be retrieved relative to context.
	     * @returns {Object|Array} State configuration object or array of all objects.
	     */
	    $state.get = function (stateOrName, context) {
	      if (arguments.length === 0) return map(objectKeys(states), function(name) { return states[name].self; });
	      var state = findState(stateOrName, context || $state.$current);
	      return (state && state.self) ? state.self : null;
	    };
	
	    function resolveState(state, params, paramsAreFiltered, inherited, dst, options) {
	      // Make a restricted $stateParams with only the parameters that apply to this state if
	      // necessary. In addition to being available to the controller and onEnter/onExit callbacks,
	      // we also need $stateParams to be available for any $injector calls we make during the
	      // dependency resolution process.
	      var $stateParams = (paramsAreFiltered) ? params : filterByKeys(state.params.$$keys(), params);
	      var locals = { $stateParams: $stateParams };
	
	      // Resolve 'global' dependencies for the state, i.e. those not specific to a view.
	      // We're also including $stateParams in this; that way the parameters are restricted
	      // to the set that should be visible to the state, and are independent of when we update
	      // the global $state and $stateParams values.
	      dst.resolve = $resolve.resolve(state.resolve, locals, dst.resolve, state);
	      var promises = [dst.resolve.then(function (globals) {
	        dst.globals = globals;
	      })];
	      if (inherited) promises.push(inherited);
	
	      function resolveViews() {
	        var viewsPromises = [];
	
	        // Resolve template and dependencies for all views.
	        forEach(state.views, function (view, name) {
	          var injectables = (view.resolve && view.resolve !== state.resolve ? view.resolve : {});
	          injectables.$template = [ function () {
	            return $view.load(name, { view: view, locals: dst.globals, params: $stateParams, notify: options.notify }) || '';
	          }];
	
	          viewsPromises.push($resolve.resolve(injectables, dst.globals, dst.resolve, state).then(function (result) {
	            // References to the controller (only instantiated at link time)
	            if (isFunction(view.controllerProvider) || isArray(view.controllerProvider)) {
	              var injectLocals = angular.extend({}, injectables, dst.globals);
	              result.$$controller = $injector.invoke(view.controllerProvider, null, injectLocals);
	            } else {
	              result.$$controller = view.controller;
	            }
	            // Provide access to the state itself for internal use
	            result.$$state = state;
	            result.$$controllerAs = view.controllerAs;
	            dst[name] = result;
	          }));
	        });
	
	        return $q.all(viewsPromises).then(function(){
	          return dst.globals;
	        });
	      }
	
	      // Wait for all the promises and then return the activation object
	      return $q.all(promises).then(resolveViews).then(function (values) {
	        return dst;
	      });
	    }
	
	    return $state;
	  }
	
	  function shouldSkipReload(to, toParams, from, fromParams, locals, options) {
	    // Return true if there are no differences in non-search (path/object) params, false if there are differences
	    function nonSearchParamsEqual(fromAndToState, fromParams, toParams) {
	      // Identify whether all the parameters that differ between `fromParams` and `toParams` were search params.
	      function notSearchParam(key) {
	        return fromAndToState.params[key].location != "search";
	      }
	      var nonQueryParamKeys = fromAndToState.params.$$keys().filter(notSearchParam);
	      var nonQueryParams = pick.apply({}, [fromAndToState.params].concat(nonQueryParamKeys));
	      var nonQueryParamSet = new $$UMFP.ParamSet(nonQueryParams);
	      return nonQueryParamSet.$$equals(fromParams, toParams);
	    }
	
	    // If reload was not explicitly requested
	    // and we're transitioning to the same state we're already in
	    // and    the locals didn't change
	    //     or they changed in a way that doesn't merit reloading
	    //        (reloadOnParams:false, or reloadOnSearch.false and only search params changed)
	    // Then return true.
	    if (!options.reload && to === from &&
	      (locals === from.locals || (to.self.reloadOnSearch === false && nonSearchParamsEqual(from, fromParams, toParams)))) {
	      return true;
	    }
	  }
	}
	
	angular.module('ui.router.state')
	  .factory('$stateParams', function () { return {}; })
	  .provider('$state', $StateProvider);
	
	
	$ViewProvider.$inject = [];
	function $ViewProvider() {
	
	  this.$get = $get;
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$view
	   *
	   * @requires ui.router.util.$templateFactory
	   * @requires $rootScope
	   *
	   * @description
	   *
	   */
	  $get.$inject = ['$rootScope', '$templateFactory'];
	  function $get(   $rootScope,   $templateFactory) {
	    return {
	      // $view.load('full.viewName', { template: ..., controller: ..., resolve: ..., async: false, params: ... })
	      /**
	       * @ngdoc function
	       * @name ui.router.state.$view#load
	       * @methodOf ui.router.state.$view
	       *
	       * @description
	       *
	       * @param {string} name name
	       * @param {object} options option object.
	       */
	      load: function load(name, options) {
	        var result, defaults = {
	          template: null, controller: null, view: null, locals: null, notify: true, async: true, params: {}
	        };
	        options = extend(defaults, options);
	
	        if (options.view) {
	          result = $templateFactory.fromConfig(options.view, options.params, options.locals);
	        }
	        return result;
	      }
	    };
	  }
	}
	
	angular.module('ui.router.state').provider('$view', $ViewProvider);
	
	/**
	 * @ngdoc object
	 * @name ui.router.state.$uiViewScrollProvider
	 *
	 * @description
	 * Provider that returns the {@link ui.router.state.$uiViewScroll} service function.
	 */
	function $ViewScrollProvider() {
	
	  var useAnchorScroll = false;
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$uiViewScrollProvider#useAnchorScroll
	   * @methodOf ui.router.state.$uiViewScrollProvider
	   *
	   * @description
	   * Reverts back to using the core [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll) service for
	   * scrolling based on the url anchor.
	   */
	  this.useAnchorScroll = function () {
	    useAnchorScroll = true;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$uiViewScroll
	   *
	   * @requires $anchorScroll
	   * @requires $timeout
	   *
	   * @description
	   * When called with a jqLite element, it scrolls the element into view (after a
	   * `$timeout` so the DOM has time to refresh).
	   *
	   * If you prefer to rely on `$anchorScroll` to scroll the view to the anchor,
	   * this can be enabled by calling {@link ui.router.state.$uiViewScrollProvider#methods_useAnchorScroll `$uiViewScrollProvider.useAnchorScroll()`}.
	   */
	  this.$get = ['$anchorScroll', '$timeout', function ($anchorScroll, $timeout) {
	    if (useAnchorScroll) {
	      return $anchorScroll;
	    }
	
	    return function ($element) {
	      return $timeout(function () {
	        $element[0].scrollIntoView();
	      }, 0, false);
	    };
	  }];
	}
	
	angular.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);
	
	var ngMajorVer = angular.version.major;
	var ngMinorVer = angular.version.minor;
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-view
	 *
	 * @requires ui.router.state.$state
	 * @requires $compile
	 * @requires $controller
	 * @requires $injector
	 * @requires ui.router.state.$uiViewScroll
	 * @requires $document
	 *
	 * @restrict ECA
	 *
	 * @description
	 * The ui-view directive tells $state where to place your templates.
	 *
	 * @param {string=} name A view name. The name should be unique amongst the other views in the
	 * same state. You can have views of the same name that live in different states.
	 *
	 * @param {string=} autoscroll It allows you to set the scroll behavior of the browser window
	 * when a view is populated. By default, $anchorScroll is overridden by ui-router's custom scroll
	 * service, {@link ui.router.state.$uiViewScroll}. This custom service let's you
	 * scroll ui-view elements into view when they are populated during a state activation.
	 *
	 * @param {string=} noanimation If truthy, the non-animated renderer will be selected (no animations
	 * will be applied to the ui-view)
	 *
	 * *Note: To revert back to old [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll)
	 * functionality, call `$uiViewScrollProvider.useAnchorScroll()`.*
	 *
	 * @param {string=} onload Expression to evaluate whenever the view updates.
	 * 
	 * @example
	 * A view can be unnamed or named. 
	 * <pre>
	 * <!-- Unnamed -->
	 * <div ui-view></div> 
	 * 
	 * <!-- Named -->
	 * <div ui-view="viewName"></div>
	 * </pre>
	 *
	 * You can only have one unnamed view within any template (or root html). If you are only using a 
	 * single view and it is unnamed then you can populate it like so:
	 * <pre>
	 * <div ui-view></div> 
	 * $stateProvider.state("home", {
	 *   template: "<h1>HELLO!</h1>"
	 * })
	 * </pre>
	 * 
	 * The above is a convenient shortcut equivalent to specifying your view explicitly with the {@link ui.router.state.$stateProvider#views `views`}
	 * config property, by name, in this case an empty name:
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "": {
	 *       template: "<h1>HELLO!</h1>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 * 
	 * But typically you'll only use the views property if you name your view or have more than one view 
	 * in the same template. There's not really a compelling reason to name a view if its the only one, 
	 * but you could if you wanted, like so:
	 * <pre>
	 * <div ui-view="main"></div>
	 * </pre> 
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "main": {
	 *       template: "<h1>HELLO!</h1>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 * 
	 * Really though, you'll use views to set up multiple views:
	 * <pre>
	 * <div ui-view></div>
	 * <div ui-view="chart"></div> 
	 * <div ui-view="data"></div> 
	 * </pre>
	 * 
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "": {
	 *       template: "<h1>HELLO!</h1>"
	 *     },
	 *     "chart": {
	 *       template: "<chart_thing/>"
	 *     },
	 *     "data": {
	 *       template: "<data_thing/>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 *
	 * Examples for `autoscroll`:
	 *
	 * <pre>
	 * <!-- If autoscroll present with no expression,
	 *      then scroll ui-view into view -->
	 * <ui-view autoscroll/>
	 *
	 * <!-- If autoscroll present with valid expression,
	 *      then scroll ui-view into view if expression evaluates to true -->
	 * <ui-view autoscroll='true'/>
	 * <ui-view autoscroll='false'/>
	 * <ui-view autoscroll='scopeVariable'/>
	 * </pre>
	 */
	$ViewDirective.$inject = ['$state', '$injector', '$uiViewScroll', '$interpolate'];
	function $ViewDirective(   $state,   $injector,   $uiViewScroll,   $interpolate) {
	
	  function getService() {
	    return ($injector.has) ? function(service) {
	      return $injector.has(service) ? $injector.get(service) : null;
	    } : function(service) {
	      try {
	        return $injector.get(service);
	      } catch (e) {
	        return null;
	      }
	    };
	  }
	
	  var service = getService(),
	      $animator = service('$animator'),
	      $animate = service('$animate');
	
	  // Returns a set of DOM manipulation functions based on which Angular version
	  // it should use
	  function getRenderer(attrs, scope) {
	    var statics = {
	      enter: function (element, target, cb) { target.after(element); cb(); },
	      leave: function (element, cb) { element.remove(); cb(); }
	    };
	
	    if (!!attrs.noanimation) return statics;
	
	    function animEnabled(element) {
	      if (ngMajorVer === 1 && ngMinorVer >= 4) return !!$animate.enabled(element);
	      if (ngMajorVer === 1 && ngMinorVer >= 2) return !!$animate.enabled();
	      return (!!$animator);
	    }
	
	    // ng 1.2+
	    if ($animate) {
	      return {
	        enter: function(element, target, cb) {
	          if (!animEnabled(element)) {
	            statics.enter(element, target, cb);
	          } else if (angular.version.minor > 2) {
	            $animate.enter(element, null, target).then(cb);
	          } else {
	            $animate.enter(element, null, target, cb);
	          }
	        },
	        leave: function(element, cb) {
	          if (!animEnabled(element)) {
	            statics.leave(element, cb);
	          } else if (angular.version.minor > 2) {
	            $animate.leave(element).then(cb);
	          } else {
	            $animate.leave(element, cb);
	          }
	        }
	      };
	    }
	
	    // ng 1.1.5
	    if ($animator) {
	      var animate = $animator && $animator(scope, attrs);
	
	      return {
	        enter: function(element, target, cb) {animate.enter(element, null, target); cb(); },
	        leave: function(element, cb) { animate.leave(element); cb(); }
	      };
	    }
	
	    return statics;
	  }
	
	  var directive = {
	    restrict: 'ECA',
	    terminal: true,
	    priority: 400,
	    transclude: 'element',
	    compile: function (tElement, tAttrs, $transclude) {
	      return function (scope, $element, attrs) {
	        var previousEl, currentEl, currentScope, latestLocals,
	            onloadExp     = attrs.onload || '',
	            autoScrollExp = attrs.autoscroll,
	            renderer      = getRenderer(attrs, scope);
	
	        scope.$on('$stateChangeSuccess', function() {
	          updateView(false);
	        });
	
	        updateView(true);
	
	        function cleanupLastView() {
	          var _previousEl = previousEl;
	          var _currentScope = currentScope;
	
	          if (_currentScope) {
	            _currentScope._willBeDestroyed = true;
	          }
	
	          function cleanOld() {
	            if (_previousEl) {
	              _previousEl.remove();
	            }
	
	            if (_currentScope) {
	              _currentScope.$destroy();
	            }
	          }
	
	          if (currentEl) {
	            renderer.leave(currentEl, function() {
	              cleanOld();
	              previousEl = null;
	            });
	
	            previousEl = currentEl;
	          } else {
	            cleanOld();
	            previousEl = null;
	          }
	
	          currentEl = null;
	          currentScope = null;
	        }
	
	        function updateView(firstTime) {
	          var newScope,
	              name            = getUiViewName(scope, attrs, $element, $interpolate),
	              previousLocals  = name && $state.$current && $state.$current.locals[name];
	
	          if (!firstTime && previousLocals === latestLocals || scope._willBeDestroyed) return; // nothing to do
	          newScope = scope.$new();
	          latestLocals = $state.$current.locals[name];
	
	          /**
	           * @ngdoc event
	           * @name ui.router.state.directive:ui-view#$viewContentLoading
	           * @eventOf ui.router.state.directive:ui-view
	           * @eventType emits on ui-view directive scope
	           * @description
	           *
	           * Fired once the view **begins loading**, *before* the DOM is rendered.
	           *
	           * @param {Object} event Event object.
	           * @param {string} viewName Name of the view.
	           */
	          newScope.$emit('$viewContentLoading', name);
	
	          var clone = $transclude(newScope, function(clone) {
	            renderer.enter(clone, $element, function onUiViewEnter() {
	              if(currentScope) {
	                currentScope.$emit('$viewContentAnimationEnded');
	              }
	
	              if (angular.isDefined(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) {
	                $uiViewScroll(clone);
	              }
	            });
	            cleanupLastView();
	          });
	
	          currentEl = clone;
	          currentScope = newScope;
	          /**
	           * @ngdoc event
	           * @name ui.router.state.directive:ui-view#$viewContentLoaded
	           * @eventOf ui.router.state.directive:ui-view
	           * @eventType emits on ui-view directive scope
	           * @description
	           * Fired once the view is **loaded**, *after* the DOM is rendered.
	           *
	           * @param {Object} event Event object.
	           * @param {string} viewName Name of the view.
	           */
	          currentScope.$emit('$viewContentLoaded', name);
	          currentScope.$eval(onloadExp);
	        }
	      };
	    }
	  };
	
	  return directive;
	}
	
	$ViewDirectiveFill.$inject = ['$compile', '$controller', '$state', '$interpolate'];
	function $ViewDirectiveFill (  $compile,   $controller,   $state,   $interpolate) {
	  return {
	    restrict: 'ECA',
	    priority: -400,
	    compile: function (tElement) {
	      var initial = tElement.html();
	      return function (scope, $element, attrs) {
	        var current = $state.$current,
	            name = getUiViewName(scope, attrs, $element, $interpolate),
	            locals  = current && current.locals[name];
	
	        if (! locals) {
	          return;
	        }
	
	        $element.data('$uiView', { name: name, state: locals.$$state });
	        $element.html(locals.$template ? locals.$template : initial);
	
	        var link = $compile($element.contents());
	
	        if (locals.$$controller) {
	          locals.$scope = scope;
	          locals.$element = $element;
	          var controller = $controller(locals.$$controller, locals);
	          if (locals.$$controllerAs) {
	            scope[locals.$$controllerAs] = controller;
	          }
	          $element.data('$ngControllerController', controller);
	          $element.children().data('$ngControllerController', controller);
	        }
	
	        link(scope);
	      };
	    }
	  };
	}
	
	/**
	 * Shared ui-view code for both directives:
	 * Given scope, element, and its attributes, return the view's name
	 */
	function getUiViewName(scope, attrs, element, $interpolate) {
	  var name = $interpolate(attrs.uiView || attrs.name || '')(scope);
	  var inherited = element.inheritedData('$uiView');
	  return name.indexOf('@') >= 0 ?  name :  (name + '@' + (inherited ? inherited.state.name : ''));
	}
	
	angular.module('ui.router.state').directive('uiView', $ViewDirective);
	angular.module('ui.router.state').directive('uiView', $ViewDirectiveFill);
	
	function parseStateRef(ref, current) {
	  var preparsed = ref.match(/^\s*({[^}]*})\s*$/), parsed;
	  if (preparsed) ref = current + '(' + preparsed[1] + ')';
	  parsed = ref.replace(/\n/g, " ").match(/^([^(]+?)\s*(\((.*)\))?$/);
	  if (!parsed || parsed.length !== 4) throw new Error("Invalid state ref '" + ref + "'");
	  return { state: parsed[1], paramExpr: parsed[3] || null };
	}
	
	function stateContext(el) {
	  var stateData = el.parent().inheritedData('$uiView');
	
	  if (stateData && stateData.state && stateData.state.name) {
	    return stateData.state;
	  }
	}
	
	function getTypeInfo(el) {
	  // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	  var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
	  var isForm = el[0].nodeName === "FORM";
	
	  return {
	    attr: isForm ? "action" : (isSvg ? 'xlink:href' : 'href'),
	    isAnchor: el.prop("tagName").toUpperCase() === "A",
	    clickable: !isForm
	  };
	}
	
	function clickHook(el, $state, $timeout, type, current) {
	  return function(e) {
	    var button = e.which || e.button, target = current();
	
	    if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || el.attr('target'))) {
	      // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
	      var transition = $timeout(function() {
	        $state.go(target.state, target.params, target.options);
	      });
	      e.preventDefault();
	
	      // if the state has no URL, ignore one preventDefault from the <a> directive.
	      var ignorePreventDefaultCount = type.isAnchor && !target.href ? 1: 0;
	
	      e.preventDefault = function() {
	        if (ignorePreventDefaultCount-- <= 0) $timeout.cancel(transition);
	      };
	    }
	  };
	}
	
	function defaultOpts(el, $state) {
	  return { relative: stateContext(el) || $state.$current, inherit: true };
	}
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref
	 *
	 * @requires ui.router.state.$state
	 * @requires $timeout
	 *
	 * @restrict A
	 *
	 * @description
	 * A directive that binds a link (`<a>` tag) to a state. If the state has an associated
	 * URL, the directive will automatically generate & update the `href` attribute via
	 * the {@link ui.router.state.$state#methods_href $state.href()} method. Clicking
	 * the link will trigger a state transition with optional parameters.
	 *
	 * Also middle-clicking, right-clicking, and ctrl-clicking on the link will be
	 * handled natively by the browser.
	 *
	 * You can also use relative state paths within ui-sref, just like the relative
	 * paths passed to `$state.go()`. You just need to be aware that the path is relative
	 * to the state that the link lives in, in other words the state that loaded the
	 * template containing the link.
	 *
	 * You can specify options to pass to {@link ui.router.state.$state#go $state.go()}
	 * using the `ui-sref-opts` attribute. Options are restricted to `location`, `inherit`,
	 * and `reload`.
	 *
	 * @example
	 * Here's an example of how you'd use ui-sref and how it would compile. If you have the
	 * following template:
	 * <pre>
	 * <a ui-sref="home">Home</a> | <a ui-sref="about">About</a> | <a ui-sref="{page: 2}">Next page</a>
	 *
	 * <ul>
	 *     <li ng-repeat="contact in contacts">
	 *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
	 *     </li>
	 * </ul>
	 * </pre>
	 *
	 * Then the compiled html would be (assuming Html5Mode is off and current state is contacts):
	 * <pre>
	 * <a href="#/home" ui-sref="home">Home</a> | <a href="#/about" ui-sref="about">About</a> | <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
	 *
	 * <ul>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
	 *     </li>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
	 *     </li>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
	 *     </li>
	 * </ul>
	 *
	 * <a ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
	 * </pre>
	 *
	 * @param {string} ui-sref 'stateName' can be any valid absolute or relative state
	 * @param {Object} ui-sref-opts options to pass to {@link ui.router.state.$state#go $state.go()}
	 */
	$StateRefDirective.$inject = ['$state', '$timeout'];
	function $StateRefDirective($state, $timeout) {
	  return {
	    restrict: 'A',
	    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	    link: function(scope, element, attrs, uiSrefActive) {
	      var ref    = parseStateRef(attrs.uiSref, $state.current.name);
	      var def    = { state: ref.state, href: null, params: null };
	      var type   = getTypeInfo(element);
	      var active = uiSrefActive[1] || uiSrefActive[0];
	
	      def.options = extend(defaultOpts(element, $state), attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {});
	
	      var update = function(val) {
	        if (val) def.params = angular.copy(val);
	        def.href = $state.href(ref.state, def.params, def.options);
	
	        if (active) active.$$addStateInfo(ref.state, def.params);
	        if (def.href !== null) attrs.$set(type.attr, def.href);
	      };
	
	      if (ref.paramExpr) {
	        scope.$watch(ref.paramExpr, function(val) { if (val !== def.params) update(val); }, true);
	        def.params = angular.copy(scope.$eval(ref.paramExpr));
	      }
	      update();
	
	      if (!type.clickable) return;
	      element.bind("click", clickHook(element, $state, $timeout, type, function() { return def; }));
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-state
	 *
	 * @requires ui.router.state.uiSref
	 *
	 * @restrict A
	 *
	 * @description
	 * Much like ui-sref, but will accept named $scope properties to evaluate for a state definition,
	 * params and override options.
	 *
	 * @param {string} ui-state 'stateName' can be any valid absolute or relative state
	 * @param {Object} ui-state-params params to pass to {@link ui.router.state.$state#href $state.href()}
	 * @param {Object} ui-state-opts options to pass to {@link ui.router.state.$state#go $state.go()}
	 */
	$StateRefDynamicDirective.$inject = ['$state', '$timeout'];
	function $StateRefDynamicDirective($state, $timeout) {
	  return {
	    restrict: 'A',
	    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	    link: function(scope, element, attrs, uiSrefActive) {
	      var type   = getTypeInfo(element);
	      var active = uiSrefActive[1] || uiSrefActive[0];
	      var group  = [attrs.uiState, attrs.uiStateParams || null, attrs.uiStateOpts || null];
	      var watch  = '[' + group.map(function(val) { return val || 'null'; }).join(', ') + ']';
	      var def    = { state: null, params: null, options: null, href: null };
	
	      function runStateRefLink (group) {
	        def.state = group[0]; def.params = group[1]; def.options = group[2];
	        def.href = $state.href(def.state, def.params, def.options);
	
	        if (active) active.$$addStateInfo(def.state, def.params);
	        if (def.href) attrs.$set(type.attr, def.href);
	      }
	
	      scope.$watch(watch, runStateRefLink, true);
	      runStateRefLink(scope.$eval(watch));
	
	      if (!type.clickable) return;
	      element.bind("click", clickHook(element, $state, $timeout, type, function() { return def; }));
	    }
	  };
	}
	
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref-active
	 *
	 * @requires ui.router.state.$state
	 * @requires ui.router.state.$stateParams
	 * @requires $interpolate
	 *
	 * @restrict A
	 *
	 * @description
	 * A directive working alongside ui-sref to add classes to an element when the
	 * related ui-sref directive's state is active, and removing them when it is inactive.
	 * The primary use-case is to simplify the special appearance of navigation menus
	 * relying on `ui-sref`, by having the "active" state's menu button appear different,
	 * distinguishing it from the inactive menu items.
	 *
	 * ui-sref-active can live on the same element as ui-sref or on a parent element. The first
	 * ui-sref-active found at the same level or above the ui-sref will be used.
	 *
	 * Will activate when the ui-sref's target state or any child state is active. If you
	 * need to activate only when the ui-sref target state is active and *not* any of
	 * it's children, then you will use
	 * {@link ui.router.state.directive:ui-sref-active-eq ui-sref-active-eq}
	 *
	 * @example
	 * Given the following template:
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active="active" class="item">
	 *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 *
	 * When the app state is "app.user" (or any children states), and contains the state parameter "user" with value "bilbobaggins",
	 * the resulting HTML will appear as (note the 'active' class):
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active="active" class="item active">
	 *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 * The class name is interpolated **once** during the directives link time (any further changes to the
	 * interpolated value are ignored).
	 *
	 * Multiple classes may be specified in a space-separated format:
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active='class1 class2 class3'>
	 *     <a ui-sref="app.user">link</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 * It is also possible to pass ui-sref-active an expression that evaluates
	 * to an object hash, whose keys represent active class names and whose
	 * values represent the respective state names/globs.
	 * ui-sref-active will match if the current active state **includes** any of
	 * the specified state names/globs, even the abstract ones.
	 *
	 * @Example
	 * Given the following template, with "admin" being an abstract state:
	 * <pre>
	 * <div ui-sref-active="{'active': 'admin.*'}">
	 *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
	 * </div>
	 * </pre>
	 *
	 * When the current state is "admin.roles" the "active" class will be applied
	 * to both the <div> and <a> elements. It is important to note that the state
	 * names/globs passed to ui-sref-active shadow the state provided by ui-sref.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref-active-eq
	 *
	 * @requires ui.router.state.$state
	 * @requires ui.router.state.$stateParams
	 * @requires $interpolate
	 *
	 * @restrict A
	 *
	 * @description
	 * The same as {@link ui.router.state.directive:ui-sref-active ui-sref-active} but will only activate
	 * when the exact target state used in the `ui-sref` is active; no child states.
	 *
	 */
	$StateRefActiveDirective.$inject = ['$state', '$stateParams', '$interpolate'];
	function $StateRefActiveDirective($state, $stateParams, $interpolate) {
	  return  {
	    restrict: "A",
	    controller: ['$scope', '$element', '$attrs', '$timeout', function ($scope, $element, $attrs, $timeout) {
	      var states = [], activeClasses = {}, activeEqClass, uiSrefActive;
	
	      // There probably isn't much point in $observing this
	      // uiSrefActive and uiSrefActiveEq share the same directive object with some
	      // slight difference in logic routing
	      activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);
	
	      try {
	        uiSrefActive = $scope.$eval($attrs.uiSrefActive);
	      } catch (e) {
	        // Do nothing. uiSrefActive is not a valid expression.
	        // Fall back to using $interpolate below
	      }
	      uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
	      if (isObject(uiSrefActive)) {
	        forEach(uiSrefActive, function(stateOrName, activeClass) {
	          if (isString(stateOrName)) {
	            var ref = parseStateRef(stateOrName, $state.current.name);
	            addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
	          }
	        });
	      }
	
	      // Allow uiSref to communicate with uiSrefActive[Equals]
	      this.$$addStateInfo = function (newState, newParams) {
	        // we already got an explicit state provided by ui-sref-active, so we
	        // shadow the one that comes from ui-sref
	        if (isObject(uiSrefActive) && states.length > 0) {
	          return;
	        }
	        addState(newState, newParams, uiSrefActive);
	        update();
	      };
	
	      $scope.$on('$stateChangeSuccess', update);
	
	      function addState(stateName, stateParams, activeClass) {
	        var state = $state.get(stateName, stateContext($element));
	        var stateHash = createStateHash(stateName, stateParams);
	
	        states.push({
	          state: state || { name: stateName },
	          params: stateParams,
	          hash: stateHash
	        });
	
	        activeClasses[stateHash] = activeClass;
	      }
	
	      /**
	       * @param {string} state
	       * @param {Object|string} [params]
	       * @return {string}
	       */
	      function createStateHash(state, params) {
	        if (!isString(state)) {
	          throw new Error('state should be a string');
	        }
	        if (isObject(params)) {
	          return state + toJson(params);
	        }
	        params = $scope.$eval(params);
	        if (isObject(params)) {
	          return state + toJson(params);
	        }
	        return state;
	      }
	
	      // Update route state
	      function update() {
	        for (var i = 0; i < states.length; i++) {
	          if (anyMatch(states[i].state, states[i].params)) {
	            addClass($element, activeClasses[states[i].hash]);
	          } else {
	            removeClass($element, activeClasses[states[i].hash]);
	          }
	
	          if (exactMatch(states[i].state, states[i].params)) {
	            addClass($element, activeEqClass);
	          } else {
	            removeClass($element, activeEqClass);
	          }
	        }
	      }
	
	      function addClass(el, className) { $timeout(function () { el.addClass(className); }); }
	      function removeClass(el, className) { el.removeClass(className); }
	      function anyMatch(state, params) { return $state.includes(state.name, params); }
	      function exactMatch(state, params) { return $state.is(state.name, params); }
	
	      update();
	    }]
	  };
	}
	
	angular.module('ui.router.state')
	  .directive('uiSref', $StateRefDirective)
	  .directive('uiSrefActive', $StateRefActiveDirective)
	  .directive('uiSrefActiveEq', $StateRefActiveDirective)
	  .directive('uiState', $StateRefDynamicDirective);
	
	/**
	 * @ngdoc filter
	 * @name ui.router.state.filter:isState
	 *
	 * @requires ui.router.state.$state
	 *
	 * @description
	 * Translates to {@link ui.router.state.$state#methods_is $state.is("stateName")}.
	 */
	$IsStateFilter.$inject = ['$state'];
	function $IsStateFilter($state) {
	  var isFilter = function (state, params) {
	    return $state.is(state, params);
	  };
	  isFilter.$stateful = true;
	  return isFilter;
	}
	
	/**
	 * @ngdoc filter
	 * @name ui.router.state.filter:includedByState
	 *
	 * @requires ui.router.state.$state
	 *
	 * @description
	 * Translates to {@link ui.router.state.$state#methods_includes $state.includes('fullOrPartialStateName')}.
	 */
	$IncludedByStateFilter.$inject = ['$state'];
	function $IncludedByStateFilter($state) {
	  var includesFilter = function (state, params, options) {
	    return $state.includes(state, params, options);
	  };
	  includesFilter.$stateful = true;
	  return  includesFilter;
	}
	
	angular.module('ui.router.state')
	  .filter('isState', $IsStateFilter)
	  .filter('includedByState', $IncludedByStateFilter);
	})(window, window.angular);

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel/polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	__webpack_require__(171);
	
	__webpack_require__(324);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(166);


/***/ }),
/* 168 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function placeHoldersCount (b64) {
	  var len = b64.length
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
	}
	
	function byteLength (b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return (b64.length * 3 / 4) - placeHoldersCount(b64)
	}
	
	function toByteArray (b64) {
	  var i, l, tmp, placeHolders, arr
	  var len = b64.length
	  placeHolders = placeHoldersCount(b64)
	
	  arr = new Arr((len * 3 / 4) - placeHolders)
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len
	
	  var L = 0
	
	  for (i = 0; i < l; i += 4) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
	    arr[L++] = (tmp >> 16) & 0xFF
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[L++] = tmp & 0xFF
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var output = ''
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    output += lookup[tmp >> 2]
	    output += lookup[(tmp << 4) & 0x3F]
	    output += '=='
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
	    output += lookup[tmp >> 10]
	    output += lookup[(tmp >> 4) & 0x3F]
	    output += lookup[(tmp << 2) & 0x3F]
	    output += '='
	  }
	
	  parts.push(output)
	
	  return parts.join('')
	}


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(168)
	var ieee754 = __webpack_require__(174)
	var isArray = __webpack_require__(170)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 170 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 171 */
/***/ (function(module, exports) {

	/**
	 * Core.js 0.6.1
	 * https://github.com/zloirock/core-js
	 * License: http://rock.mit-license.org
	 * © 2015 Denis Pushkarev
	 */
	!function(global, framework, undefined){
	'use strict';
	
	/******************************************************************************
	 * Module : common                                                            *
	 ******************************************************************************/
	
	  // Shortcuts for [[Class]] & property names
	var OBJECT          = 'Object'
	  , FUNCTION        = 'Function'
	  , ARRAY           = 'Array'
	  , STRING          = 'String'
	  , NUMBER          = 'Number'
	  , REGEXP          = 'RegExp'
	  , DATE            = 'Date'
	  , MAP             = 'Map'
	  , SET             = 'Set'
	  , WEAKMAP         = 'WeakMap'
	  , WEAKSET         = 'WeakSet'
	  , SYMBOL          = 'Symbol'
	  , PROMISE         = 'Promise'
	  , MATH            = 'Math'
	  , ARGUMENTS       = 'Arguments'
	  , PROTOTYPE       = 'prototype'
	  , CONSTRUCTOR     = 'constructor'
	  , TO_STRING       = 'toString'
	  , TO_STRING_TAG   = TO_STRING + 'Tag'
	  , TO_LOCALE       = 'toLocaleString'
	  , HAS_OWN         = 'hasOwnProperty'
	  , FOR_EACH        = 'forEach'
	  , ITERATOR        = 'iterator'
	  , FF_ITERATOR     = '@@' + ITERATOR
	  , PROCESS         = 'process'
	  , CREATE_ELEMENT  = 'createElement'
	  // Aliases global objects and prototypes
	  , Function        = global[FUNCTION]
	  , Object          = global[OBJECT]
	  , Array           = global[ARRAY]
	  , String          = global[STRING]
	  , Number          = global[NUMBER]
	  , RegExp          = global[REGEXP]
	  , Date            = global[DATE]
	  , Map             = global[MAP]
	  , Set             = global[SET]
	  , WeakMap         = global[WEAKMAP]
	  , WeakSet         = global[WEAKSET]
	  , Symbol          = global[SYMBOL]
	  , Math            = global[MATH]
	  , TypeError       = global.TypeError
	  , RangeError      = global.RangeError
	  , setTimeout      = global.setTimeout
	  , setImmediate    = global.setImmediate
	  , clearImmediate  = global.clearImmediate
	  , parseInt        = global.parseInt
	  , isFinite        = global.isFinite
	  , process         = global[PROCESS]
	  , nextTick        = process && process.nextTick
	  , document        = global.document
	  , html            = document && document.documentElement
	  , navigator       = global.navigator
	  , define          = global.define
	  , console         = global.console || {}
	  , ArrayProto      = Array[PROTOTYPE]
	  , ObjectProto     = Object[PROTOTYPE]
	  , FunctionProto   = Function[PROTOTYPE]
	  , Infinity        = 1 / 0
	  , DOT             = '.';
	
	// http://jsperf.com/core-js-isobject
	function isObject(it){
	  return it !== null && (typeof it == 'object' || typeof it == 'function');
	}
	function isFunction(it){
	  return typeof it == 'function';
	}
	// Native function?
	var isNative = ctx(/./.test, /\[native code\]\s*\}\s*$/, 1);
	
	// Object internal [[Class]] or toStringTag
	// http://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring
	var toString = ObjectProto[TO_STRING];
	function setToStringTag(it, tag, stat){
	  if(it && !has(it = stat ? it : it[PROTOTYPE], SYMBOL_TAG))hidden(it, SYMBOL_TAG, tag);
	}
	function cof(it){
	  return toString.call(it).slice(8, -1);
	}
	function classof(it){
	  var O, T;
	  return it == undefined ? it === undefined ? 'Undefined' : 'Null'
	    : typeof (T = (O = Object(it))[SYMBOL_TAG]) == 'string' ? T : cof(O);
	}
	
	// Function
	var call  = FunctionProto.call
	  , apply = FunctionProto.apply
	  , REFERENCE_GET;
	// Partial apply
	function part(/* ...args */){
	  var fn     = assertFunction(this)
	    , length = arguments.length
	    , args   = Array(length)
	    , i      = 0
	    , _      = path._
	    , holder = false;
	  while(length > i)if((args[i] = arguments[i++]) === _)holder = true;
	  return function(/* ...args */){
	    var that    = this
	      , _length = arguments.length
	      , i = 0, j = 0, _args;
	    if(!holder && !_length)return invoke(fn, args, that);
	    _args = args.slice();
	    if(holder)for(;length > i; i++)if(_args[i] === _)_args[i] = arguments[j++];
	    while(_length > j)_args.push(arguments[j++]);
	    return invoke(fn, _args, that);
	  }
	}
	// Optional / simple context binding
	function ctx(fn, that, length){
	  assertFunction(fn);
	  if(~length && that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    }
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    }
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    }
	  } return function(/* ...args */){
	      return fn.apply(that, arguments);
	  }
	}
	// Fast apply
	// http://jsperf.lnkit.com/fast-apply/5
	function invoke(fn, args, that){
	  var un = that === undefined;
	  switch(args.length | 0){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	    case 5: return un ? fn(args[0], args[1], args[2], args[3], args[4])
	                      : fn.call(that, args[0], args[1], args[2], args[3], args[4]);
	  } return              fn.apply(that, args);
	}
	
	// Object:
	var create           = Object.create
	  , getPrototypeOf   = Object.getPrototypeOf
	  , setPrototypeOf   = Object.setPrototypeOf
	  , defineProperty   = Object.defineProperty
	  , defineProperties = Object.defineProperties
	  , getOwnDescriptor = Object.getOwnPropertyDescriptor
	  , getKeys          = Object.keys
	  , getNames         = Object.getOwnPropertyNames
	  , getSymbols       = Object.getOwnPropertySymbols
	  , isFrozen         = Object.isFrozen
	  , has              = ctx(call, ObjectProto[HAS_OWN], 2)
	  // Dummy, fix for not array-like ES3 string in es5 module
	  , ES5Object        = Object
	  , Dict;
	function toObject(it){
	  return ES5Object(assertDefined(it));
	}
	function returnIt(it){
	  return it;
	}
	function returnThis(){
	  return this;
	}
	function get(object, key){
	  if(has(object, key))return object[key];
	}
	function ownKeys(it){
	  assertObject(it);
	  return getSymbols ? getNames(it).concat(getSymbols(it)) : getNames(it);
	}
	// 19.1.2.1 Object.assign(target, source, ...)
	var assign = Object.assign || function(target, source){
	  var T = Object(assertDefined(target))
	    , l = arguments.length
	    , i = 1;
	  while(l > i){
	    var S      = ES5Object(arguments[i++])
	      , keys   = getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)T[key = keys[j++]] = S[key];
	  }
	  return T;
	}
	function keyOf(object, el){
	  var O      = toObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	}
	
	// Array
	// array('str1,str2,str3') => ['str1', 'str2', 'str3']
	function array(it){
	  return String(it).split(',');
	}
	var push    = ArrayProto.push
	  , unshift = ArrayProto.unshift
	  , slice   = ArrayProto.slice
	  , splice  = ArrayProto.splice
	  , indexOf = ArrayProto.indexOf
	  , forEach = ArrayProto[FOR_EACH];
	/*
	 * 0 -> forEach
	 * 1 -> map
	 * 2 -> filter
	 * 3 -> some
	 * 4 -> every
	 * 5 -> find
	 * 6 -> findIndex
	 */
	function createArrayMethod(type){
	  var isMap       = type == 1
	    , isFilter    = type == 2
	    , isSome      = type == 3
	    , isEvery     = type == 4
	    , isFindIndex = type == 6
	    , noholes     = type == 5 || isFindIndex;
	  return function(callbackfn/*, that = undefined */){
	    var O      = Object(assertDefined(this))
	      , that   = arguments[1]
	      , self   = ES5Object(O)
	      , f      = ctx(callbackfn, that, 3)
	      , length = toLength(self.length)
	      , index  = 0
	      , result = isMap ? Array(length) : isFilter ? [] : undefined
	      , val, res;
	    for(;length > index; index++)if(noholes || index in self){
	      val = self[index];
	      res = f(val, index, O);
	      if(type){
	        if(isMap)result[index] = res;             // map
	        else if(res)switch(type){
	          case 3: return true;                    // some
	          case 5: return val;                     // find
	          case 6: return index;                   // findIndex
	          case 2: result.push(val);               // filter
	        } else if(isEvery)return false;           // every
	      }
	    }
	    return isFindIndex ? -1 : isSome || isEvery ? isEvery : result;
	  }
	}
	function createArrayContains(isContains){
	  return function(el /*, fromIndex = 0 */){
	    var O      = toObject(this)
	      , length = toLength(O.length)
	      , index  = toIndex(arguments[1], length);
	    if(isContains && el != el){
	      for(;length > index; index++)if(sameNaN(O[index]))return isContains || index;
	    } else for(;length > index; index++)if(isContains || index in O){
	      if(O[index] === el)return isContains || index;
	    } return !isContains && -1;
	  }
	}
	function generic(A, B){
	  // strange IE quirks mode bug -> use typeof vs isFunction
	  return typeof A == 'function' ? A : B;
	}
	
	// Math
	var MAX_SAFE_INTEGER = 0x1fffffffffffff // pow(2, 53) - 1 == 9007199254740991
	  , pow    = Math.pow
	  , abs    = Math.abs
	  , ceil   = Math.ceil
	  , floor  = Math.floor
	  , max    = Math.max
	  , min    = Math.min
	  , random = Math.random
	  , trunc  = Math.trunc || function(it){
	      return (it > 0 ? floor : ceil)(it);
	    }
	// 20.1.2.4 Number.isNaN(number)
	function sameNaN(number){
	  return number != number;
	}
	// 7.1.4 ToInteger
	function toInteger(it){
	  return isNaN(it) ? 0 : trunc(it);
	}
	// 7.1.15 ToLength
	function toLength(it){
	  return it > 0 ? min(toInteger(it), MAX_SAFE_INTEGER) : 0;
	}
	function toIndex(index, length){
	  var index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	}
	function lz(num){
	  return num > 9 ? num : '0' + num;
	}
	
	function createReplacer(regExp, replace, isStatic){
	  var replacer = isObject(replace) ? function(part){
	    return replace[part];
	  } : replace;
	  return function(it){
	    return String(isStatic ? it : this).replace(regExp, replacer);
	  }
	}
	function createPointAt(toString){
	  return function(pos){
	    var s = String(assertDefined(this))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return toString ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? toString ? s.charAt(i) : a
	      : toString ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  }
	}
	
	// Assertion & errors
	var REDUCE_ERROR = 'Reduce of empty object with no initial value';
	function assert(condition, msg1, msg2){
	  if(!condition)throw TypeError(msg2 ? msg1 + msg2 : msg1);
	}
	function assertDefined(it){
	  if(it == undefined)throw TypeError('Function called on null or undefined');
	  return it;
	}
	function assertFunction(it){
	  assert(isFunction(it), it, ' is not a function!');
	  return it;
	}
	function assertObject(it){
	  assert(isObject(it), it, ' is not an object!');
	  return it;
	}
	function assertInstance(it, Constructor, name){
	  assert(it instanceof Constructor, name, ": use the 'new' operator!");
	}
	
	// Property descriptors & Symbol
	function descriptor(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  }
	}
	function simpleSet(object, key, value){
	  object[key] = value;
	  return object;
	}
	function createDefiner(bitmap){
	  return DESC ? function(object, key, value){
	    return defineProperty(object, key, descriptor(bitmap, value));
	  } : simpleSet;
	}
	function uid(key){
	  return SYMBOL + '(' + key + ')_' + (++sid + random())[TO_STRING](36);
	}
	function getWellKnownSymbol(name, setter){
	  return (Symbol && Symbol[name]) || (setter ? Symbol : safeSymbol)(SYMBOL + DOT + name);
	}
	// The engine works fine with descriptors? Thank's IE8 for his funny defineProperty.
	var DESC = !!function(){
	      try {
	        return defineProperty({}, 'a', {get: function(){ return 2 }}).a == 2;
	      } catch(e){}
	    }()
	  , sid    = 0
	  , hidden = createDefiner(1)
	  , set    = Symbol ? simpleSet : hidden
	  , safeSymbol = Symbol || uid;
	function assignHidden(target, src){
	  for(var key in src)hidden(target, key, src[key]);
	  return target;
	}
	
	var SYMBOL_UNSCOPABLES = getWellKnownSymbol('unscopables')
	  , ArrayUnscopables   = ArrayProto[SYMBOL_UNSCOPABLES] || {}
	  , SYMBOL_TAG         = getWellKnownSymbol(TO_STRING_TAG)
	  , SYMBOL_SPECIES     = getWellKnownSymbol('species')
	  , SYMBOL_ITERATOR;
	function setSpecies(C){
	  if(DESC && (framework || !isNative(C)))defineProperty(C, SYMBOL_SPECIES, {
	    configurable: true,
	    get: returnThis
	  });
	}
	
	/******************************************************************************
	 * Module : common.export                                                     *
	 ******************************************************************************/
	
	var NODE = cof(process) == PROCESS
	  , core = {}
	  , path = framework ? global : core
	  , old  = global.core
	  , exportGlobal
	  // type bitmap
	  , FORCED = 1
	  , GLOBAL = 2
	  , STATIC = 4
	  , PROTO  = 8
	  , BIND   = 16
	  , WRAP   = 32;
	function $define(type, name, source){
	  var key, own, out, exp
	    , isGlobal = type & GLOBAL
	    , target   = isGlobal ? global : (type & STATIC)
	        ? global[name] : (global[name] || ObjectProto)[PROTOTYPE]
	    , exports  = isGlobal ? core : core[name] || (core[name] = {});
	  if(isGlobal)source = name;
	  for(key in source){
	    // there is a similar native
	    own = !(type & FORCED) && target && key in target
	      && (!isFunction(target[key]) || isNative(target[key]));
	    // export native or passed
	    out = (own ? target : source)[key];
	    // prevent global pollution for namespaces
	    if(!framework && isGlobal && !isFunction(target[key]))exp = source[key];
	    // bind timers to global for call from export context
	    else if(type & BIND && own)exp = ctx(out, global);
	    // wrap global constructors for prevent change them in library
	    else if(type & WRAP && !framework && target[key] == out){
	      exp = function(param){
	        return this instanceof out ? new out(param) : out(param);
	      }
	      exp[PROTOTYPE] = out[PROTOTYPE];
	    } else exp = type & PROTO && isFunction(out) ? ctx(call, out) : out;
	    // extend global
	    if(framework && target && !own){
	      if(isGlobal)target[key] = out;
	      else delete target[key] && hidden(target, key, out);
	    }
	    // export
	    if(exports[key] != out)hidden(exports, key, exp);
	  }
	}
	// CommonJS export
	if(typeof module != 'undefined' && module.exports)module.exports = core;
	// RequireJS export
	else if(isFunction(define) && define.amd)define(function(){return core});
	// Export to global object
	else exportGlobal = true;
	if(exportGlobal || framework){
	  core.noConflict = function(){
	    global.core = old;
	    return core;
	  }
	  global.core = core;
	}
	
	/******************************************************************************
	 * Module : common.iterators                                                  *
	 ******************************************************************************/
	
	SYMBOL_ITERATOR = getWellKnownSymbol(ITERATOR);
	var ITER  = safeSymbol('iter')
	  , KEY   = 1
	  , VALUE = 2
	  , Iterators = {}
	  , IteratorPrototype = {}
	    // Safari has byggy iterators w/o `next`
	  , BUGGY_ITERATORS = 'keys' in ArrayProto && !('next' in [].keys());
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	setIterator(IteratorPrototype, returnThis);
	function setIterator(O, value){
	  hidden(O, SYMBOL_ITERATOR, value);
	  // Add iterator for FF iterator protocol
	  FF_ITERATOR in ArrayProto && hidden(O, FF_ITERATOR, value);
	}
	function createIterator(Constructor, NAME, next, proto){
	  Constructor[PROTOTYPE] = create(proto || IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	}
	function defineIterator(Constructor, NAME, value, DEFAULT){
	  var proto = Constructor[PROTOTYPE]
	    , iter  = get(proto, SYMBOL_ITERATOR) || get(proto, FF_ITERATOR) || (DEFAULT && get(proto, DEFAULT)) || value;
	  if(framework){
	    // Define iterator
	    setIterator(proto, iter);
	    if(iter !== value){
	      var iterProto = getPrototypeOf(iter.call(new Constructor));
	      // Set @@toStringTag to native iterators
	      setToStringTag(iterProto, NAME + ' Iterator', true);
	      // FF fix
	      has(proto, FF_ITERATOR) && setIterator(iterProto, returnThis);
	    }
	  }
	  // Plug for library
	  Iterators[NAME] = iter;
	  // FF & v8 fix
	  Iterators[NAME + ' Iterator'] = returnThis;
	  return iter;
	}
	function defineStdIterators(Base, NAME, Constructor, next, DEFAULT, IS_SET){
	  function createIter(kind){
	    return function(){
	      return new Constructor(this, kind);
	    }
	  }
	  createIterator(Constructor, NAME, next);
	  var entries = createIter(KEY+VALUE)
	    , values  = createIter(VALUE);
	  if(DEFAULT == VALUE)values = defineIterator(Base, NAME, values, 'values');
	  else entries = defineIterator(Base, NAME, entries, 'entries');
	  if(DEFAULT){
	    $define(PROTO + FORCED * BUGGY_ITERATORS, NAME, {
	      entries: entries,
	      keys: IS_SET ? values : createIter(KEY),
	      values: values
	    });
	  }
	}
	function iterResult(done, value){
	  return {value: value, done: !!done};
	}
	function isIterable(it){
	  var O      = Object(it)
	    , Symbol = global[SYMBOL]
	    , hasExt = (Symbol && Symbol[ITERATOR] || FF_ITERATOR) in O;
	  return hasExt || SYMBOL_ITERATOR in O || has(Iterators, classof(O));
	}
	function getIterator(it){
	  var Symbol  = global[SYMBOL]
	    , ext     = it[Symbol && Symbol[ITERATOR] || FF_ITERATOR]
	    , getIter = ext || it[SYMBOL_ITERATOR] || Iterators[classof(it)];
	  return assertObject(getIter.call(it));
	}
	function stepCall(fn, value, entries){
	  return entries ? invoke(fn, value) : fn(value);
	}
	function checkDangerIterClosing(fn){
	  var danger = true;
	  var O = {
	    next: function(){ throw 1 },
	    'return': function(){ danger = false }
	  };
	  O[SYMBOL_ITERATOR] = returnThis;
	  try {
	    fn(O);
	  } catch(e){}
	  return danger;
	}
	function closeIterator(iterator){
	  var ret = iterator['return'];
	  if(ret !== undefined)ret.call(iterator);
	}
	function safeIterClose(exec, iterator){
	  try {
	    exec(iterator);
	  } catch(e){
	    closeIterator(iterator);
	    throw e;
	  }
	}
	function forOf(iterable, entries, fn, that){
	  safeIterClose(function(iterator){
	    var f = ctx(fn, that, entries ? 2 : 1)
	      , step;
	    while(!(step = iterator.next()).done)if(stepCall(f, step.value, entries) === false){
	      return closeIterator(iterator);
	    }
	  }, getIterator(iterable));
	}
	
	/******************************************************************************
	 * Module : es6.symbol                                                        *
	 ******************************************************************************/
	
	// ECMAScript 6 symbols shim
	!function(TAG, SymbolRegistry, AllSymbols, setter){
	  // 19.4.1.1 Symbol([description])
	  if(!isNative(Symbol)){
	    Symbol = function(description){
	      assert(!(this instanceof Symbol), SYMBOL + ' is not a ' + CONSTRUCTOR);
	      var tag = uid(description)
	        , sym = set(create(Symbol[PROTOTYPE]), TAG, tag);
	      AllSymbols[tag] = sym;
	      DESC && setter && defineProperty(ObjectProto, tag, {
	        configurable: true,
	        set: function(value){
	          hidden(this, tag, value);
	        }
	      });
	      return sym;
	    }
	    hidden(Symbol[PROTOTYPE], TO_STRING, function(){
	      return this[TAG];
	    });
	  }
	  $define(GLOBAL + WRAP, {Symbol: Symbol});
	  
	  var symbolStatics = {
	    // 19.4.2.1 Symbol.for(key)
	    'for': function(key){
	      return has(SymbolRegistry, key += '')
	        ? SymbolRegistry[key]
	        : SymbolRegistry[key] = Symbol(key);
	    },
	    // 19.4.2.4 Symbol.iterator
	    iterator: SYMBOL_ITERATOR || getWellKnownSymbol(ITERATOR),
	    // 19.4.2.5 Symbol.keyFor(sym)
	    keyFor: part.call(keyOf, SymbolRegistry),
	    // 19.4.2.10 Symbol.species
	    species: SYMBOL_SPECIES,
	    // 19.4.2.13 Symbol.toStringTag
	    toStringTag: SYMBOL_TAG = getWellKnownSymbol(TO_STRING_TAG, true),
	    // 19.4.2.14 Symbol.unscopables
	    unscopables: SYMBOL_UNSCOPABLES,
	    pure: safeSymbol,
	    set: set,
	    useSetter: function(){setter = true},
	    useSimple: function(){setter = false}
	  };
	  // 19.4.2.2 Symbol.hasInstance
	  // 19.4.2.3 Symbol.isConcatSpreadable
	  // 19.4.2.6 Symbol.match
	  // 19.4.2.8 Symbol.replace
	  // 19.4.2.9 Symbol.search
	  // 19.4.2.11 Symbol.split
	  // 19.4.2.12 Symbol.toPrimitive
	  forEach.call(array('hasInstance,isConcatSpreadable,match,replace,search,split,toPrimitive'),
	    function(it){
	      symbolStatics[it] = getWellKnownSymbol(it);
	    }
	  );
	  $define(STATIC, SYMBOL, symbolStatics);
	  
	  setToStringTag(Symbol, SYMBOL);
	  
	  $define(STATIC + FORCED * !isNative(Symbol), OBJECT, {
	    // 19.1.2.7 Object.getOwnPropertyNames(O)
	    getOwnPropertyNames: function(it){
	      var names = getNames(toObject(it)), result = [], key, i = 0;
	      while(names.length > i)has(AllSymbols, key = names[i++]) || result.push(key);
	      return result;
	    },
	    // 19.1.2.8 Object.getOwnPropertySymbols(O)
	    getOwnPropertySymbols: function(it){
	      var names = getNames(toObject(it)), result = [], key, i = 0;
	      while(names.length > i)has(AllSymbols, key = names[i++]) && result.push(AllSymbols[key]);
	      return result;
	    }
	  });
	  
	  // 20.2.1.9 Math[@@toStringTag]
	  setToStringTag(Math, MATH, true);
	  // 24.3.3 JSON[@@toStringTag]
	  setToStringTag(global.JSON, 'JSON', true);
	}(safeSymbol('tag'), {}, {}, true);
	
	/******************************************************************************
	 * Module : es6.object.statics                                                *
	 ******************************************************************************/
	
	!function(){
	  var objectStatic = {
	    // 19.1.3.1 Object.assign(target, source)
	    assign: assign,
	    // 19.1.3.10 Object.is(value1, value2)
	    is: function(x, y){
	      return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	    }
	  };
	  // 19.1.3.19 Object.setPrototypeOf(O, proto)
	  // Works with __proto__ only. Old v8 can't works with null proto objects.
	  '__proto__' in ObjectProto && function(buggy, set){
	    try {
	      set = ctx(call, getOwnDescriptor(ObjectProto, '__proto__').set, 2);
	      set({}, ArrayProto);
	    } catch(e){ buggy = true }
	    objectStatic.setPrototypeOf = setPrototypeOf = setPrototypeOf || function(O, proto){
	      assertObject(O);
	      assert(proto === null || isObject(proto), proto, ": can't set as prototype!");
	      if(buggy)O.__proto__ = proto;
	      else set(O, proto);
	      return O;
	    }
	  }();
	  $define(STATIC, OBJECT, objectStatic);
	}();
	
	/******************************************************************************
	 * Module : es6.object.prototype                                              *
	 ******************************************************************************/
	
	!function(tmp){
	  // 19.1.3.6 Object.prototype.toString()
	  tmp[SYMBOL_TAG] = DOT;
	  if(cof(tmp) != DOT)hidden(ObjectProto, TO_STRING, function(){
	    return '[object ' + classof(this) + ']';
	  });
	}({});
	
	/******************************************************************************
	 * Module : es6.object.statics-accept-primitives                              *
	 ******************************************************************************/
	
	!function(){
	  // Object static methods accept primitives
	  function wrapObjectMethod(key, MODE){
	    var fn  = Object[key]
	      , exp = core[OBJECT][key]
	      , f   = 0
	      , o   = {};
	    if(!exp || isNative(exp)){
	      o[key] = MODE == 1 ? function(it){
	        return isObject(it) ? fn(it) : it;
	      } : MODE == 2 ? function(it){
	        return isObject(it) ? fn(it) : true;
	      } : MODE == 3 ? function(it){
	        return isObject(it) ? fn(it) : false;
	      } : MODE == 4 ? function(it, key){
	        return fn(toObject(it), key);
	      } : function(it){
	        return fn(toObject(it));
	      };
	      try { fn(DOT) }
	      catch(e){ f = 1 }
	      $define(STATIC + FORCED * f, OBJECT, o);
	    }
	  }
	  wrapObjectMethod('freeze', 1);
	  wrapObjectMethod('seal', 1);
	  wrapObjectMethod('preventExtensions', 1);
	  wrapObjectMethod('isFrozen', 2);
	  wrapObjectMethod('isSealed', 2);
	  wrapObjectMethod('isExtensible', 3);
	  wrapObjectMethod('getOwnPropertyDescriptor', 4);
	  wrapObjectMethod('getPrototypeOf');
	  wrapObjectMethod('keys');
	  wrapObjectMethod('getOwnPropertyNames');
	}();
	
	/******************************************************************************
	 * Module : es6.function                                                      *
	 ******************************************************************************/
	
	!function(NAME){
	  // 19.2.4.2 name
	  NAME in FunctionProto || (DESC && defineProperty(FunctionProto, NAME, {
	    configurable: true,
	    get: function(){
	      var match = String(this).match(/^\s*function ([^ (]*)/)
	        , name  = match ? match[1] : '';
	      has(this, NAME) || defineProperty(this, NAME, descriptor(5, name));
	      return name;
	    },
	    set: function(value){
	      has(this, NAME) || defineProperty(this, NAME, descriptor(0, value));
	    }
	  }));
	}('name');
	
	/******************************************************************************
	 * Module : es6.number.constructor                                            *
	 ******************************************************************************/
	
	Number('0o1') && Number('0b1') || function(_Number, NumberProto){
	  function toNumber(it){
	    if(isObject(it))it = toPrimitive(it);
	    if(typeof it == 'string' && it.length > 2 && it.charCodeAt(0) == 48){
	      var binary = false;
	      switch(it.charCodeAt(1)){
	        case 66 : case 98  : binary = true;
	        case 79 : case 111 : return parseInt(it.slice(2), binary ? 2 : 8);
	      }
	    } return +it;
	  }
	  function toPrimitive(it){
	    var fn, val;
	    if(isFunction(fn = it.valueOf) && !isObject(val = fn.call(it)))return val;
	    if(isFunction(fn = it[TO_STRING]) && !isObject(val = fn.call(it)))return val;
	    throw TypeError("Can't convert object to number");
	  }
	  Number = function Number(it){
	    return this instanceof Number ? new _Number(toNumber(it)) : toNumber(it);
	  }
	  forEach.call(DESC ? getNames(_Number)
	  : array('MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY'), function(key){
	    key in Number || defineProperty(Number, key, getOwnDescriptor(_Number, key));
	  });
	  Number[PROTOTYPE] = NumberProto;
	  NumberProto[CONSTRUCTOR] = Number;
	  hidden(global, NUMBER, Number);
	}(Number, Number[PROTOTYPE]);
	
	/******************************************************************************
	 * Module : es6.number.statics                                                *
	 ******************************************************************************/
	
	!function(isInteger){
	  $define(STATIC, NUMBER, {
	    // 20.1.2.1 Number.EPSILON
	    EPSILON: pow(2, -52),
	    // 20.1.2.2 Number.isFinite(number)
	    isFinite: function(it){
	      return typeof it == 'number' && isFinite(it);
	    },
	    // 20.1.2.3 Number.isInteger(number)
	    isInteger: isInteger,
	    // 20.1.2.4 Number.isNaN(number)
	    isNaN: sameNaN,
	    // 20.1.2.5 Number.isSafeInteger(number)
	    isSafeInteger: function(number){
	      return isInteger(number) && abs(number) <= MAX_SAFE_INTEGER;
	    },
	    // 20.1.2.6 Number.MAX_SAFE_INTEGER
	    MAX_SAFE_INTEGER: MAX_SAFE_INTEGER,
	    // 20.1.2.10 Number.MIN_SAFE_INTEGER
	    MIN_SAFE_INTEGER: -MAX_SAFE_INTEGER,
	    // 20.1.2.12 Number.parseFloat(string)
	    parseFloat: parseFloat,
	    // 20.1.2.13 Number.parseInt(string, radix)
	    parseInt: parseInt
	  });
	// 20.1.2.3 Number.isInteger(number)
	}(Number.isInteger || function(it){
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	});
	
	/******************************************************************************
	 * Module : es6.math                                                          *
	 ******************************************************************************/
	
	// ECMAScript 6 shim
	!function(){
	  // 20.2.2.28 Math.sign(x)
	  var E    = Math.E
	    , exp  = Math.exp
	    , log  = Math.log
	    , sqrt = Math.sqrt
	    , sign = Math.sign || function(x){
	        return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	      };
	  
	  // 20.2.2.5 Math.asinh(x)
	  function asinh(x){
	    return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : log(x + sqrt(x * x + 1));
	  }
	  // 20.2.2.14 Math.expm1(x)
	  function expm1(x){
	    return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : exp(x) - 1;
	  }
	    
	  $define(STATIC, MATH, {
	    // 20.2.2.3 Math.acosh(x)
	    acosh: function(x){
	      return (x = +x) < 1 ? NaN : isFinite(x) ? log(x / E + sqrt(x + 1) * sqrt(x - 1) / E) + 1 : x;
	    },
	    // 20.2.2.5 Math.asinh(x)
	    asinh: asinh,
	    // 20.2.2.7 Math.atanh(x)
	    atanh: function(x){
	      return (x = +x) == 0 ? x : log((1 + x) / (1 - x)) / 2;
	    },
	    // 20.2.2.9 Math.cbrt(x)
	    cbrt: function(x){
	      return sign(x = +x) * pow(abs(x), 1 / 3);
	    },
	    // 20.2.2.11 Math.clz32(x)
	    clz32: function(x){
	      return (x >>>= 0) ? 32 - x[TO_STRING](2).length : 32;
	    },
	    // 20.2.2.12 Math.cosh(x)
	    cosh: function(x){
	      return (exp(x = +x) + exp(-x)) / 2;
	    },
	    // 20.2.2.14 Math.expm1(x)
	    expm1: expm1,
	    // 20.2.2.16 Math.fround(x)
	    // TODO: fallback for IE9-
	    fround: function(x){
	      return new Float32Array([x])[0];
	    },
	    // 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	    hypot: function(value1, value2){
	      var sum  = 0
	        , len1 = arguments.length
	        , len2 = len1
	        , args = Array(len1)
	        , larg = -Infinity
	        , arg;
	      while(len1--){
	        arg = args[len1] = +arguments[len1];
	        if(arg == Infinity || arg == -Infinity)return Infinity;
	        if(arg > larg)larg = arg;
	      }
	      larg = arg || 1;
	      while(len2--)sum += pow(args[len2] / larg, 2);
	      return larg * sqrt(sum);
	    },
	    // 20.2.2.18 Math.imul(x, y)
	    imul: function(x, y){
	      var UInt16 = 0xffff
	        , xn = +x
	        , yn = +y
	        , xl = UInt16 & xn
	        , yl = UInt16 & yn;
	      return 0 | xl * yl + ((UInt16 & xn >>> 16) * yl + xl * (UInt16 & yn >>> 16) << 16 >>> 0);
	    },
	    // 20.2.2.20 Math.log1p(x)
	    log1p: function(x){
	      return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : log(1 + x);
	    },
	    // 20.2.2.21 Math.log10(x)
	    log10: function(x){
	      return log(x) / Math.LN10;
	    },
	    // 20.2.2.22 Math.log2(x)
	    log2: function(x){
	      return log(x) / Math.LN2;
	    },
	    // 20.2.2.28 Math.sign(x)
	    sign: sign,
	    // 20.2.2.30 Math.sinh(x)
	    sinh: function(x){
	      return (abs(x = +x) < 1) ? (expm1(x) - expm1(-x)) / 2 : (exp(x - 1) - exp(-x - 1)) * (E / 2);
	    },
	    // 20.2.2.33 Math.tanh(x)
	    tanh: function(x){
	      var a = expm1(x = +x)
	        , b = expm1(-x);
	      return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	    },
	    // 20.2.2.34 Math.trunc(x)
	    trunc: trunc
	  });
	}();
	
	/******************************************************************************
	 * Module : es6.string                                                        *
	 ******************************************************************************/
	
	!function(fromCharCode){
	  function assertNotRegExp(it){
	    if(cof(it) == REGEXP)throw TypeError();
	  }
	  
	  $define(STATIC, STRING, {
	    // 21.1.2.2 String.fromCodePoint(...codePoints)
	    fromCodePoint: function(x){
	      var res = []
	        , len = arguments.length
	        , i   = 0
	        , code
	      while(len > i){
	        code = +arguments[i++];
	        if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
	        res.push(code < 0x10000
	          ? fromCharCode(code)
	          : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	        );
	      } return res.join('');
	    },
	    // 21.1.2.4 String.raw(callSite, ...substitutions)
	    raw: function(callSite){
	      var raw = toObject(callSite.raw)
	        , len = toLength(raw.length)
	        , sln = arguments.length
	        , res = []
	        , i   = 0;
	      while(len > i){
	        res.push(String(raw[i++]));
	        if(i < sln)res.push(String(arguments[i]));
	      } return res.join('');
	    }
	  });
	  
	  $define(PROTO, STRING, {
	    // 21.1.3.3 String.prototype.codePointAt(pos)
	    codePointAt: createPointAt(false),
	    // 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	    endsWith: function(searchString /*, endPosition = @length */){
	      assertNotRegExp(searchString);
	      var that = String(assertDefined(this))
	        , endPosition = arguments[1]
	        , len = toLength(that.length)
	        , end = endPosition === undefined ? len : min(toLength(endPosition), len);
	      searchString += '';
	      return that.slice(end - searchString.length, end) === searchString;
	    },
	    // 21.1.3.7 String.prototype.includes(searchString, position = 0)
	    includes: function(searchString /*, position = 0 */){
	      assertNotRegExp(searchString);
	      return !!~String(assertDefined(this)).indexOf(searchString, arguments[1]);
	    },
	    // 21.1.3.13 String.prototype.repeat(count)
	    repeat: function(count){
	      var str = String(assertDefined(this))
	        , res = ''
	        , n   = toInteger(count);
	      if(0 > n || n == Infinity)throw RangeError("Count can't be negative");
	      for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
	      return res;
	    },
	    // 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	    startsWith: function(searchString /*, position = 0 */){
	      assertNotRegExp(searchString);
	      var that  = String(assertDefined(this))
	        , index = toLength(min(arguments[1], that.length));
	      searchString += '';
	      return that.slice(index, index + searchString.length) === searchString;
	    }
	  });
	}(String.fromCharCode);
	
	/******************************************************************************
	 * Module : es6.array.statics                                                 *
	 ******************************************************************************/
	
	!function(){
	  $define(STATIC + FORCED * checkDangerIterClosing(Array.from), ARRAY, {
	    // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	    from: function(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	      var O       = Object(assertDefined(arrayLike))
	        , mapfn   = arguments[1]
	        , mapping = mapfn !== undefined
	        , f       = mapping ? ctx(mapfn, arguments[2], 2) : undefined
	        , index   = 0
	        , length, result, step;
	      if(isIterable(O)){
	        result = new (generic(this, Array));
	        safeIterClose(function(iterator){
	          for(; !(step = iterator.next()).done; index++){
	            result[index] = mapping ? f(step.value, index) : step.value;
	          }
	        }, getIterator(O));
	      } else {
	        result = new (generic(this, Array))(length = toLength(O.length));
	        for(; length > index; index++){
	          result[index] = mapping ? f(O[index], index) : O[index];
	        }
	      }
	      result.length = index;
	      return result;
	    }
	  });
	  
	  $define(STATIC, ARRAY, {
	    // 22.1.2.3 Array.of( ...items)
	    of: function(/* ...args */){
	      var index  = 0
	        , length = arguments.length
	        , result = new (generic(this, Array))(length);
	      while(length > index)result[index] = arguments[index++];
	      result.length = length;
	      return result;
	    }
	  });
	  
	  setSpecies(Array);
	}();
	
	/******************************************************************************
	 * Module : es6.array.prototype                                               *
	 ******************************************************************************/
	
	!function(){
	  $define(PROTO, ARRAY, {
	    // 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	    copyWithin: function(target /* = 0 */, start /* = 0, end = @length */){
	      var O     = Object(assertDefined(this))
	        , len   = toLength(O.length)
	        , to    = toIndex(target, len)
	        , from  = toIndex(start, len)
	        , end   = arguments[2]
	        , fin   = end === undefined ? len : toIndex(end, len)
	        , count = min(fin - from, len - to)
	        , inc   = 1;
	      if(from < to && to < from + count){
	        inc  = -1;
	        from = from + count - 1;
	        to   = to + count - 1;
	      }
	      while(count-- > 0){
	        if(from in O)O[to] = O[from];
	        else delete O[to];
	        to += inc;
	        from += inc;
	      } return O;
	    },
	    // 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	    fill: function(value /*, start = 0, end = @length */){
	      var O      = Object(assertDefined(this))
	        , length = toLength(O.length)
	        , index  = toIndex(arguments[1], length)
	        , end    = arguments[2]
	        , endPos = end === undefined ? length : toIndex(end, length);
	      while(endPos > index)O[index++] = value;
	      return O;
	    },
	    // 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	    find: createArrayMethod(5),
	    // 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	    findIndex: createArrayMethod(6)
	  });
	  
	  if(framework){
	    // 22.1.3.31 Array.prototype[@@unscopables]
	    forEach.call(array('find,findIndex,fill,copyWithin,entries,keys,values'), function(it){
	      ArrayUnscopables[it] = true;
	    });
	    SYMBOL_UNSCOPABLES in ArrayProto || hidden(ArrayProto, SYMBOL_UNSCOPABLES, ArrayUnscopables);
	  }
	}();
	
	/******************************************************************************
	 * Module : es6.iterators                                                     *
	 ******************************************************************************/
	
	!function(at){
	  // 22.1.3.4 Array.prototype.entries()
	  // 22.1.3.13 Array.prototype.keys()
	  // 22.1.3.29 Array.prototype.values()
	  // 22.1.3.30 Array.prototype[@@iterator]()
	  defineStdIterators(Array, ARRAY, function(iterated, kind){
	    set(this, ITER, {o: toObject(iterated), i: 0, k: kind});
	  // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	  }, function(){
	    var iter  = this[ITER]
	      , O     = iter.o
	      , kind  = iter.k
	      , index = iter.i++;
	    if(!O || index >= O.length){
	      iter.o = undefined;
	      return iterResult(1);
	    }
	    if(kind == KEY)  return iterResult(0, index);
	    if(kind == VALUE)return iterResult(0, O[index]);
	                     return iterResult(0, [index, O[index]]);
	  }, VALUE);
	  
	  // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	  Iterators[ARGUMENTS] = Iterators[ARRAY];
	  
	  // 21.1.3.27 String.prototype[@@iterator]()
	  defineStdIterators(String, STRING, function(iterated){
	    set(this, ITER, {o: String(iterated), i: 0});
	  // 21.1.5.2.1 %StringIteratorPrototype%.next()
	  }, function(){
	    var iter  = this[ITER]
	      , O     = iter.o
	      , index = iter.i
	      , point;
	    if(index >= O.length)return iterResult(1);
	    point = at.call(O, index);
	    iter.i += point.length;
	    return iterResult(0, point);
	  });
	}(createPointAt(true));
	
	/******************************************************************************
	 * Module : es6.regexp                                                        *
	 ******************************************************************************/
	
	DESC && !function(RegExpProto, _RegExp){  
	  // RegExp allows a regex with flags as the pattern
	  if(!function(){try{return RegExp(/a/g, 'i') == '/a/i'}catch(e){}}()){
	    RegExp = function RegExp(pattern, flags){
	      return new _RegExp(cof(pattern) == REGEXP && flags !== undefined
	        ? pattern.source : pattern, flags);
	    }
	    forEach.call(getNames(_RegExp), function(key){
	      key in RegExp || defineProperty(RegExp, key, {
	        configurable: true,
	        get: function(){ return _RegExp[key] },
	        set: function(it){ _RegExp[key] = it }
	      });
	    });
	    RegExpProto[CONSTRUCTOR] = RegExp;
	    RegExp[PROTOTYPE] = RegExpProto;
	    hidden(global, REGEXP, RegExp);
	  }
	  
	  // 21.2.5.3 get RegExp.prototype.flags()
	  if(/./g.flags != 'g')defineProperty(RegExpProto, 'flags', {
	    configurable: true,
	    get: createReplacer(/^.*\/(\w*)$/, '$1')
	  });
	  
	  setSpecies(RegExp);
	}(RegExp[PROTOTYPE], RegExp);
	
	/******************************************************************************
	 * Module : web.immediate                                                     *
	 ******************************************************************************/
	
	// setImmediate shim
	// Node.js 0.9+ & IE10+ has setImmediate, else:
	isFunction(setImmediate) && isFunction(clearImmediate) || function(ONREADYSTATECHANGE){
	  var postMessage      = global.postMessage
	    , addEventListener = global.addEventListener
	    , MessageChannel   = global.MessageChannel
	    , counter          = 0
	    , queue            = {}
	    , defer, channel, port;
	  setImmediate = function(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(isFunction(fn) ? fn : Function(fn), args);
	    }
	    defer(counter);
	    return counter;
	  }
	  clearImmediate = function(id){
	    delete queue[id];
	  }
	  function run(id){
	    if(has(queue, id)){
	      var fn = queue[id];
	      delete queue[id];
	      fn();
	    }
	  }
	  function listner(event){
	    run(event.data);
	  }
	  // Node.js 0.8-
	  if(NODE){
	    defer = function(id){
	      nextTick(part.call(run, id));
	    }
	  // Modern browsers, skip implementation for WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is object
	  } else if(addEventListener && isFunction(postMessage) && !global.importScripts){
	    defer = function(id){
	      postMessage(id, '*');
	    }
	    addEventListener('message', listner, false);
	  // WebWorkers
	  } else if(isFunction(MessageChannel)){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listner;
	    defer = ctx(port.postMessage, port, 1);
	  // IE8-
	  } else if(document && ONREADYSTATECHANGE in document[CREATE_ELEMENT]('script')){
	    defer = function(id){
	      html.appendChild(document[CREATE_ELEMENT]('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run(id);
	      }
	    }
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(run, 0, id);
	    }
	  }
	}('onreadystatechange');
	$define(GLOBAL + BIND, {
	  setImmediate:   setImmediate,
	  clearImmediate: clearImmediate
	});
	
	/******************************************************************************
	 * Module : es6.promise                                                       *
	 ******************************************************************************/
	
	// ES6 promises shim
	// Based on https://github.com/getify/native-promise-only/
	!function(Promise, test){
	  isFunction(Promise) && isFunction(Promise.resolve)
	  && Promise.resolve(test = new Promise(function(){})) == test
	  || function(asap, RECORD){
	    function isThenable(it){
	      var then;
	      if(isObject(it))then = it.then;
	      return isFunction(then) ? then : false;
	    }
	    function handledRejectionOrHasOnRejected(promise){
	      var record = promise[RECORD]
	        , chain  = record.c
	        , i      = 0
	        , react;
	      if(record.h)return true;
	      while(chain.length > i){
	        react = chain[i++];
	        if(react.fail || handledRejectionOrHasOnRejected(react.P))return true;
	      }
	    }
	    function notify(record, reject){
	      var chain = record.c;
	      if(reject || chain.length)asap(function(){
	        var promise = record.p
	          , value   = record.v
	          , ok      = record.s == 1
	          , i       = 0;
	        if(reject && !handledRejectionOrHasOnRejected(promise)){
	          setTimeout(function(){
	            if(!handledRejectionOrHasOnRejected(promise)){
	              if(NODE){
	                if(!process.emit('unhandledRejection', value, promise)){
	                  // default node.js behavior
	                }
	              } else if(isFunction(console.error)){
	                console.error('Unhandled promise rejection', value);
	              }
	            }
	          }, 1e3);
	        } else while(chain.length > i)!function(react){
	          var cb = ok ? react.ok : react.fail
	            , ret, then;
	          try {
	            if(cb){
	              if(!ok)record.h = true;
	              ret = cb === true ? value : cb(value);
	              if(ret === react.P){
	                react.rej(TypeError(PROMISE + '-chain cycle'));
	              } else if(then = isThenable(ret)){
	                then.call(ret, react.res, react.rej);
	              } else react.res(ret);
	            } else react.rej(value);
	          } catch(err){
	            react.rej(err);
	          }
	        }(chain[i++]);
	        chain.length = 0;
	      });
	    }
	    function resolve(value){
	      var record = this
	        , then, wrapper;
	      if(record.d)return;
	      record.d = true;
	      record = record.r || record; // unwrap
	      try {
	        if(then = isThenable(value)){
	          wrapper = {r: record, d: false}; // wrap
	          then.call(value, ctx(resolve, wrapper, 1), ctx(reject, wrapper, 1));
	        } else {
	          record.v = value;
	          record.s = 1;
	          notify(record);
	        }
	      } catch(err){
	        reject.call(wrapper || {r: record, d: false}, err); // wrap
	      }
	    }
	    function reject(value){
	      var record = this;
	      if(record.d)return;
	      record.d = true;
	      record = record.r || record; // unwrap
	      record.v = value;
	      record.s = 2;
	      notify(record, true);
	    }
	    function getConstructor(C){
	      var S = assertObject(C)[SYMBOL_SPECIES];
	      return S != undefined ? S : C;
	    }
	    // 25.4.3.1 Promise(executor)
	    Promise = function(executor){
	      assertFunction(executor);
	      assertInstance(this, Promise, PROMISE);
	      var record = {
	        p: this,      // promise
	        c: [],        // chain
	        s: 0,         // state
	        d: false,     // done
	        v: undefined, // value
	        h: false      // handled rejection
	      };
	      hidden(this, RECORD, record);
	      try {
	        executor(ctx(resolve, record, 1), ctx(reject, record, 1));
	      } catch(err){
	        reject.call(record, err);
	      }
	    }
	    assignHidden(Promise[PROTOTYPE], {
	      // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	      then: function(onFulfilled, onRejected){
	        var S = assertObject(assertObject(this)[CONSTRUCTOR])[SYMBOL_SPECIES];
	        var react = {
	          ok:   isFunction(onFulfilled) ? onFulfilled : true,
	          fail: isFunction(onRejected)  ? onRejected  : false
	        } , P = react.P = new (S != undefined ? S : Promise)(function(resolve, reject){
	          react.res = assertFunction(resolve);
	          react.rej = assertFunction(reject);
	        }), record = this[RECORD];
	        record.c.push(react);
	        record.s && notify(record);
	        return P;
	      },
	      // 25.4.5.1 Promise.prototype.catch(onRejected)
	      'catch': function(onRejected){
	        return this.then(undefined, onRejected);
	      }
	    });
	    assignHidden(Promise, {
	      // 25.4.4.1 Promise.all(iterable)
	      all: function(iterable){
	        var Promise = getConstructor(this)
	          , values  = [];
	        return new Promise(function(resolve, reject){
	          forOf(iterable, false, push, values);
	          var remaining = values.length
	            , results   = Array(remaining);
	          if(remaining)forEach.call(values, function(promise, index){
	            Promise.resolve(promise).then(function(value){
	              results[index] = value;
	              --remaining || resolve(results);
	            }, reject);
	          });
	          else resolve(results);
	        });
	      },
	      // 25.4.4.4 Promise.race(iterable)
	      race: function(iterable){
	        var Promise = getConstructor(this);
	        return new Promise(function(resolve, reject){
	          forOf(iterable, false, function(promise){
	            Promise.resolve(promise).then(resolve, reject);
	          });
	        });
	      },
	      // 25.4.4.5 Promise.reject(r)
	      reject: function(r){
	        return new (getConstructor(this))(function(resolve, reject){
	          reject(r);
	        });
	      },
	      // 25.4.4.6 Promise.resolve(x)
	      resolve: function(x){
	        return isObject(x) && RECORD in x && getPrototypeOf(x) === this[PROTOTYPE]
	          ? x : new (getConstructor(this))(function(resolve, reject){
	            resolve(x);
	          });
	      }
	    });
	  }(nextTick || setImmediate, safeSymbol('record'));
	  setToStringTag(Promise, PROMISE);
	  setSpecies(Promise);
	  $define(GLOBAL + FORCED * !isNative(Promise), {Promise: Promise});
	}(global[PROMISE]);
	
	/******************************************************************************
	 * Module : es6.collections                                                   *
	 ******************************************************************************/
	
	// ECMAScript 6 collections shim
	!function(){
	  var UID   = safeSymbol('uid')
	    , O1    = safeSymbol('O1')
	    , WEAK  = safeSymbol('weak')
	    , LEAK  = safeSymbol('leak')
	    , LAST  = safeSymbol('last')
	    , FIRST = safeSymbol('first')
	    , SIZE  = DESC ? safeSymbol('size') : 'size'
	    , uid   = 0
	    , tmp   = {};
	  
	  function getCollection(C, NAME, methods, commonMethods, isMap, isWeak){
	    var ADDER = isMap ? 'set' : 'add'
	      , proto = C && C[PROTOTYPE]
	      , O     = {};
	    function initFromIterable(that, iterable){
	      if(iterable != undefined)forOf(iterable, isMap, that[ADDER], that);
	      return that;
	    }
	    function fixSVZ(key, chain){
	      var method = proto[key];
	      if(framework)proto[key] = function(a, b){
	        var result = method.call(this, a === 0 ? 0 : a, b);
	        return chain ? this : result;
	      };
	    }
	    if(!isNative(C) || !(isWeak || (!BUGGY_ITERATORS && has(proto, FOR_EACH) && has(proto, 'entries')))){
	      // create collection constructor
	      C = isWeak
	        ? function(iterable){
	            assertInstance(this, C, NAME);
	            set(this, UID, uid++);
	            initFromIterable(this, iterable);
	          }
	        : function(iterable){
	            var that = this;
	            assertInstance(that, C, NAME);
	            set(that, O1, create(null));
	            set(that, SIZE, 0);
	            set(that, LAST, undefined);
	            set(that, FIRST, undefined);
	            initFromIterable(that, iterable);
	          };
	      assignHidden(assignHidden(C[PROTOTYPE], methods), commonMethods);
	      isWeak || !DESC || defineProperty(C[PROTOTYPE], 'size', {get: function(){
	        return assertDefined(this[SIZE]);
	      }});
	    } else {
	      var Native = C
	        , inst   = new C
	        , chain  = inst[ADDER](isWeak ? {} : -0, 1)
	        , buggyZero;
	      // wrap to init collections from iterable
	      if(checkDangerIterClosing(function(O){ new C(O) })){
	        C = function(iterable){
	          assertInstance(this, C, NAME);
	          return initFromIterable(new Native, iterable);
	        }
	        C[PROTOTYPE] = proto;
	        if(framework)proto[CONSTRUCTOR] = C;
	      }
	      isWeak || inst[FOR_EACH](function(val, key){
	        buggyZero = 1 / key === -Infinity;
	      });
	      // fix converting -0 key to +0
	      if(buggyZero){
	        fixSVZ('delete');
	        fixSVZ('has');
	        isMap && fixSVZ('get');
	      }
	      // + fix .add & .set for chaining
	      if(buggyZero || chain !== inst)fixSVZ(ADDER, true);
	    }
	    setToStringTag(C, NAME);
	    setSpecies(C);
	    
	    O[NAME] = C;
	    $define(GLOBAL + WRAP + FORCED * !isNative(C), O);
	    
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    isWeak || defineStdIterators(C, NAME, function(iterated, kind){
	      set(this, ITER, {o: iterated, k: kind});
	    }, function(){
	      var iter  = this[ITER]
	        , kind  = iter.k
	        , entry = iter.l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!iter.o || !(iter.l = entry = entry ? entry.n : iter.o[FIRST])){
	        // or finish the iteration
	        iter.o = undefined;
	        return iterResult(1);
	      }
	      // return step by kind
	      if(kind == KEY)  return iterResult(0, entry.k);
	      if(kind == VALUE)return iterResult(0, entry.v);
	                       return iterResult(0, [entry.k, entry.v]);   
	    }, isMap ? KEY+VALUE : VALUE, !isMap);
	    
	    return C;
	  }
	  
	  function fastKey(it, create){
	    // return primitive with prefix
	    if(!isObject(it))return (typeof it == 'string' ? 'S' : 'P') + it;
	    // can't set id to frozen object
	    if(isFrozen(it))return 'F';
	    if(!has(it, UID)){
	      // not necessary to add id
	      if(!create)return 'E';
	      // add missing object id
	      hidden(it, UID, ++uid);
	    // return object id with prefix
	    } return 'O' + it[UID];
	  }
	  function getEntry(that, key){
	    // fast case
	    var index = fastKey(key), entry;
	    if(index != 'F')return that[O1][index];
	    // frozen object case
	    for(entry = that[FIRST]; entry; entry = entry.n){
	      if(entry.k == key)return entry;
	    }
	  }
	  function def(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry)entry.v = value;
	    // create new entry
	    else {
	      that[LAST] = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that[LAST],          // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that[FIRST])that[FIRST] = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index != 'F')that[O1][index] = entry;
	    } return that;
	  }
	
	  var collectionMethods = {
	    // 23.1.3.1 Map.prototype.clear()
	    // 23.2.3.2 Set.prototype.clear()
	    clear: function(){
	      for(var that = this, data = that[O1], entry = that[FIRST]; entry; entry = entry.n){
	        entry.r = true;
	        if(entry.p)entry.p = entry.p.n = undefined;
	        delete data[entry.i];
	      }
	      that[FIRST] = that[LAST] = undefined;
	      that[SIZE] = 0;
	    },
	    // 23.1.3.3 Map.prototype.delete(key)
	    // 23.2.3.4 Set.prototype.delete(value)
	    'delete': function(key){
	      var that  = this
	        , entry = getEntry(that, key);
	      if(entry){
	        var next = entry.n
	          , prev = entry.p;
	        delete that[O1][entry.i];
	        entry.r = true;
	        if(prev)prev.n = next;
	        if(next)next.p = prev;
	        if(that[FIRST] == entry)that[FIRST] = next;
	        if(that[LAST] == entry)that[LAST] = prev;
	        that[SIZE]--;
	      } return !!entry;
	    },
	    // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	    // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	    forEach: function(callbackfn /*, that = undefined */){
	      var f = ctx(callbackfn, arguments[1], 3)
	        , entry;
	      while(entry = entry ? entry.n : this[FIRST]){
	        f(entry.v, entry.k, this);
	        // revert to the last existing entry
	        while(entry && entry.r)entry = entry.p;
	      }
	    },
	    // 23.1.3.7 Map.prototype.has(key)
	    // 23.2.3.7 Set.prototype.has(value)
	    has: function(key){
	      return !!getEntry(this, key);
	    }
	  }
	  
	  // 23.1 Map Objects
	  Map = getCollection(Map, MAP, {
	    // 23.1.3.6 Map.prototype.get(key)
	    get: function(key){
	      var entry = getEntry(this, key);
	      return entry && entry.v;
	    },
	    // 23.1.3.9 Map.prototype.set(key, value)
	    set: function(key, value){
	      return def(this, key === 0 ? 0 : key, value);
	    }
	  }, collectionMethods, true);
	  
	  // 23.2 Set Objects
	  Set = getCollection(Set, SET, {
	    // 23.2.3.1 Set.prototype.add(value)
	    add: function(value){
	      return def(this, value = value === 0 ? 0 : value, value);
	    }
	  }, collectionMethods);
	  
	  function defWeak(that, key, value){
	    if(isFrozen(assertObject(key)))leakStore(that).set(key, value);
	    else {
	      has(key, WEAK) || hidden(key, WEAK, {});
	      key[WEAK][that[UID]] = value;
	    } return that;
	  }
	  function leakStore(that){
	    return that[LEAK] || hidden(that, LEAK, new Map)[LEAK];
	  }
	  
	  var weakMethods = {
	    // 23.3.3.2 WeakMap.prototype.delete(key)
	    // 23.4.3.3 WeakSet.prototype.delete(value)
	    'delete': function(key){
	      if(!isObject(key))return false;
	      if(isFrozen(key))return leakStore(this)['delete'](key);
	      return has(key, WEAK) && has(key[WEAK], this[UID]) && delete key[WEAK][this[UID]];
	    },
	    // 23.3.3.4 WeakMap.prototype.has(key)
	    // 23.4.3.4 WeakSet.prototype.has(value)
	    has: function(key){
	      if(!isObject(key))return false;
	      if(isFrozen(key))return leakStore(this).has(key);
	      return has(key, WEAK) && has(key[WEAK], this[UID]);
	    }
	  };
	  
	  // 23.3 WeakMap Objects
	  WeakMap = getCollection(WeakMap, WEAKMAP, {
	    // 23.3.3.3 WeakMap.prototype.get(key)
	    get: function(key){
	      if(isObject(key)){
	        if(isFrozen(key))return leakStore(this).get(key);
	        if(has(key, WEAK))return key[WEAK][this[UID]];
	      }
	    },
	    // 23.3.3.5 WeakMap.prototype.set(key, value)
	    set: function(key, value){
	      return defWeak(this, key, value);
	    }
	  }, weakMethods, true, true);
	  
	  // IE11 WeakMap frozen keys fix
	  if(framework && new WeakMap().set(Object.freeze(tmp), 7).get(tmp) != 7){
	    forEach.call(array('delete,has,get,set'), function(key){
	      var method = WeakMap[PROTOTYPE][key];
	      WeakMap[PROTOTYPE][key] = function(a, b){
	        // store frozen objects on leaky map
	        if(isObject(a) && isFrozen(a)){
	          var result = leakStore(this)[key](a, b);
	          return key == 'set' ? this : result;
	        // store all the rest on native weakmap
	        } return method.call(this, a, b);
	      };
	    });
	  }
	  
	  // 23.4 WeakSet Objects
	  WeakSet = getCollection(WeakSet, WEAKSET, {
	    // 23.4.3.1 WeakSet.prototype.add(value)
	    add: function(value){
	      return defWeak(this, value, true);
	    }
	  }, weakMethods, false, true);
	}();
	
	/******************************************************************************
	 * Module : es6.reflect                                                       *
	 ******************************************************************************/
	
	!function(){
	  function Enumerate(iterated){
	    var keys = [], key;
	    for(key in iterated)keys.push(key);
	    set(this, ITER, {o: iterated, a: keys, i: 0});
	  }
	  createIterator(Enumerate, OBJECT, function(){
	    var iter = this[ITER]
	      , keys = iter.a
	      , key;
	    do {
	      if(iter.i >= keys.length)return iterResult(1);
	    } while(!((key = keys[iter.i++]) in iter.o));
	    return iterResult(0, key);
	  });
	  
	  function wrap(fn){
	    return function(it){
	      assertObject(it);
	      try {
	        return fn.apply(undefined, arguments), true;
	      } catch(e){
	        return false;
	      }
	    }
	  }
	  
	  function reflectGet(target, propertyKey/*, receiver*/){
	    var receiver = arguments.length < 3 ? target : arguments[2]
	      , desc = getOwnDescriptor(assertObject(target), propertyKey), proto;
	    if(desc)return has(desc, 'value')
	      ? desc.value
	      : desc.get === undefined
	        ? undefined
	        : desc.get.call(receiver);
	    return isObject(proto = getPrototypeOf(target))
	      ? reflectGet(proto, propertyKey, receiver)
	      : undefined;
	  }
	  function reflectSet(target, propertyKey, V/*, receiver*/){
	    var receiver = arguments.length < 4 ? target : arguments[3]
	      , ownDesc  = getOwnDescriptor(assertObject(target), propertyKey)
	      , existingDescriptor, proto;
	    if(!ownDesc){
	      if(isObject(proto = getPrototypeOf(target))){
	        return reflectSet(proto, propertyKey, V, receiver);
	      }
	      ownDesc = descriptor(0);
	    }
	    if(has(ownDesc, 'value')){
	      if(ownDesc.writable === false || !isObject(receiver))return false;
	      existingDescriptor = getOwnDescriptor(receiver, propertyKey) || descriptor(0);
	      existingDescriptor.value = V;
	      return defineProperty(receiver, propertyKey, existingDescriptor), true;
	    }
	    return ownDesc.set === undefined
	      ? false
	      : (ownDesc.set.call(receiver, V), true);
	  }
	  var isExtensible = Object.isExtensible || returnIt;
	  
	  var reflect = {
	    // 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	    apply: ctx(call, apply, 3),
	    // 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	    construct: function(target, argumentsList /*, newTarget*/){
	      var proto    = assertFunction(arguments.length < 3 ? target : arguments[2])[PROTOTYPE]
	        , instance = create(isObject(proto) ? proto : ObjectProto)
	        , result   = apply.call(target, instance, argumentsList);
	      return isObject(result) ? result : instance;
	    },
	    // 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	    defineProperty: wrap(defineProperty),
	    // 26.1.4 Reflect.deleteProperty(target, propertyKey)
	    deleteProperty: function(target, propertyKey){
	      var desc = getOwnDescriptor(assertObject(target), propertyKey);
	      return desc && !desc.configurable ? false : delete target[propertyKey];
	    },
	    // 26.1.5 Reflect.enumerate(target)
	    enumerate: function(target){
	      return new Enumerate(assertObject(target));
	    },
	    // 26.1.6 Reflect.get(target, propertyKey [, receiver])
	    get: reflectGet,
	    // 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	    getOwnPropertyDescriptor: function(target, propertyKey){
	      return getOwnDescriptor(assertObject(target), propertyKey);
	    },
	    // 26.1.8 Reflect.getPrototypeOf(target)
	    getPrototypeOf: function(target){
	      return getPrototypeOf(assertObject(target));
	    },
	    // 26.1.9 Reflect.has(target, propertyKey)
	    has: function(target, propertyKey){
	      return propertyKey in target;
	    },
	    // 26.1.10 Reflect.isExtensible(target)
	    isExtensible: function(target){
	      return !!isExtensible(assertObject(target));
	    },
	    // 26.1.11 Reflect.ownKeys(target)
	    ownKeys: ownKeys,
	    // 26.1.12 Reflect.preventExtensions(target)
	    preventExtensions: wrap(Object.preventExtensions || returnIt),
	    // 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	    set: reflectSet
	  }
	  // 26.1.14 Reflect.setPrototypeOf(target, proto)
	  if(setPrototypeOf)reflect.setPrototypeOf = function(target, proto){
	    return setPrototypeOf(assertObject(target), proto), true;
	  };
	  
	  $define(GLOBAL, {Reflect: {}});
	  $define(STATIC, 'Reflect', reflect);
	}();
	
	/******************************************************************************
	 * Module : es7.proposals                                                     *
	 ******************************************************************************/
	
	!function(){
	  $define(PROTO, ARRAY, {
	    // https://github.com/domenic/Array.prototype.includes
	    includes: createArrayContains(true)
	  });
	  $define(PROTO, STRING, {
	    // https://github.com/mathiasbynens/String.prototype.at
	    at: createPointAt(true)
	  });
	  
	  function createObjectToArray(isEntries){
	    return function(object){
	      var O      = toObject(object)
	        , keys   = getKeys(object)
	        , length = keys.length
	        , i      = 0
	        , result = Array(length)
	        , key;
	      if(isEntries)while(length > i)result[i] = [key = keys[i++], O[key]];
	      else while(length > i)result[i] = O[keys[i++]];
	      return result;
	    }
	  }
	  $define(STATIC, OBJECT, {
	    // https://gist.github.com/WebReflection/9353781
	    getOwnPropertyDescriptors: function(object){
	      var O      = toObject(object)
	        , result = {};
	      forEach.call(ownKeys(O), function(key){
	        defineProperty(result, key, descriptor(0, getOwnDescriptor(O, key)));
	      });
	      return result;
	    },
	    // https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-04/apr-9.md#51-objectentries-objectvalues
	    values:  createObjectToArray(false),
	    entries: createObjectToArray(true)
	  });
	  $define(STATIC, REGEXP, {
	    // https://gist.github.com/kangax/9698100
	    escape: createReplacer(/([\\\-[\]{}()*+?.,^$|])/g, '\\$1', true)
	  });
	}();
	
	/******************************************************************************
	 * Module : es7.abstract-refs                                                 *
	 ******************************************************************************/
	
	// https://github.com/zenparsing/es-abstract-refs
	!function(REFERENCE){
	  REFERENCE_GET = getWellKnownSymbol(REFERENCE+'Get', true);
	  var REFERENCE_SET = getWellKnownSymbol(REFERENCE+SET, true)
	    , REFERENCE_DELETE = getWellKnownSymbol(REFERENCE+'Delete', true);
	  
	  $define(STATIC, SYMBOL, {
	    referenceGet: REFERENCE_GET,
	    referenceSet: REFERENCE_SET,
	    referenceDelete: REFERENCE_DELETE
	  });
	  
	  hidden(FunctionProto, REFERENCE_GET, returnThis);
	  
	  function setMapMethods(Constructor){
	    if(Constructor){
	      var MapProto = Constructor[PROTOTYPE];
	      hidden(MapProto, REFERENCE_GET, MapProto.get);
	      hidden(MapProto, REFERENCE_SET, MapProto.set);
	      hidden(MapProto, REFERENCE_DELETE, MapProto['delete']);
	    }
	  }
	  setMapMethods(Map);
	  setMapMethods(WeakMap);
	}('reference');
	
	/******************************************************************************
	 * Module : js.array.statics                                                  *
	 ******************************************************************************/
	
	// JavaScript 1.6 / Strawman array statics shim
	!function(arrayStatics){
	  function setArrayStatics(keys, length){
	    forEach.call(array(keys), function(key){
	      if(key in ArrayProto)arrayStatics[key] = ctx(call, ArrayProto[key], length);
	    });
	  }
	  setArrayStatics('pop,reverse,shift,keys,values,entries', 1);
	  setArrayStatics('indexOf,every,some,forEach,map,filter,find,findIndex,includes', 3);
	  setArrayStatics('join,slice,concat,push,splice,unshift,sort,lastIndexOf,' +
	                  'reduce,reduceRight,copyWithin,fill,turn');
	  $define(STATIC, ARRAY, arrayStatics);
	}({});
	
	/******************************************************************************
	 * Module : web.dom.itarable                                                  *
	 ******************************************************************************/
	
	!function(NodeList){
	  if(framework && NodeList && !(SYMBOL_ITERATOR in NodeList[PROTOTYPE])){
	    hidden(NodeList[PROTOTYPE], SYMBOL_ITERATOR, Iterators[ARRAY]);
	  }
	  Iterators.NodeList = Iterators[ARRAY];
	}(global.NodeList);
	}(typeof self != 'undefined' && self.Math === Math ? self : Function('return this')(), true);

/***/ }),
/* 172 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 173 */
172,
/* 174 */
/***/ (function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 175 */
/***/ (function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array ? array.length : 0;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(11),
	    baseUniq = __webpack_require__(200),
	    isIterateeCall = __webpack_require__(26),
	    sortedUniq = __webpack_require__(213);
	
	/**
	 * Creates a duplicate-free version of an array, using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons, in which only the first occurence of each element
	 * is kept. Providing `true` for `isSorted` performs a faster search algorithm
	 * for sorted arrays. If an iteratee function is provided it's invoked for
	 * each element in the array to generate the criterion by which uniqueness
	 * is computed. The `iteratee` is bound to `thisArg` and invoked with three
	 * arguments: (value, index, array).
	 *
	 * If a property name is provided for `iteratee` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `iteratee` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @alias unique
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {boolean} [isSorted] Specify the array is sorted.
	 * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Array} Returns the new duplicate-value-free array.
	 * @example
	 *
	 * _.uniq([2, 1, 2]);
	 * // => [2, 1]
	 *
	 * // using `isSorted`
	 * _.uniq([1, 1, 2], true);
	 * // => [1, 2]
	 *
	 * // using an iteratee function
	 * _.uniq([1, 2.5, 1.5, 2], function(n) {
	 *   return this.floor(n);
	 * }, Math);
	 * // => [1, 2.5]
	 *
	 * // using the `_.property` callback shorthand
	 * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 1 }, { 'x': 2 }]
	 */
	function uniq(array, isSorted, iteratee, thisArg) {
	  var length = array ? array.length : 0;
	  if (!length) {
	    return [];
	  }
	  if (isSorted != null && typeof isSorted != 'boolean') {
	    thisArg = iteratee;
	    iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
	    isSorted = false;
	  }
	  iteratee = iteratee == null ? iteratee : baseCallback(iteratee, thisArg, 3);
	  return (isSorted)
	    ? sortedUniq(array, iteratee)
	    : baseUniq(array, iteratee);
	}
	
	module.exports = uniq;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(176);


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(189),
	    isArrayLike = __webpack_require__(7),
	    restParam = __webpack_require__(16);
	
	/**
	 * Creates an array excluding all provided values using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to filter.
	 * @param {...*} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.without([1, 2, 1, 3], 1, 2);
	 * // => [3]
	 */
	var without = restParam(function(array, values) {
	  return isArrayLike(array)
	    ? baseDifference(array, values)
	    : [];
	});
	
	module.exports = without;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(3);
	
	/**
	 * The inverse of `_.pairs`; this method returns an object composed from arrays
	 * of property names and values. Provide either a single two dimensional array,
	 * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
	 * and one of corresponding values.
	 *
	 * @static
	 * @memberOf _
	 * @alias object
	 * @category Array
	 * @param {Array} props The property names.
	 * @param {Array} [values=[]] The property values.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * _.zipObject([['fred', 30], ['barney', 40]]);
	 * // => { 'fred': 30, 'barney': 40 }
	 *
	 * _.zipObject(['fred', 'barney'], [30, 40]);
	 * // => { 'fred': 30, 'barney': 40 }
	 */
	function zipObject(props, values) {
	  var index = -1,
	      length = props ? props.length : 0,
	      result = {};
	
	  if (length && !values && !isArray(props[0])) {
	    values = [];
	  }
	  while (++index < length) {
	    var key = props[index];
	    if (values) {
	      result[key] = values[index];
	    } else if (key) {
	      result[key[0]] = key[1];
	    }
	  }
	  return result;
	}
	
	module.exports = zipObject;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(183),
	    baseCallback = __webpack_require__(11),
	    baseFilter = __webpack_require__(190),
	    isArray = __webpack_require__(3);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @alias select
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {Array} Returns the new filtered array.
	 * @example
	 *
	 * _.filter([4, 5, 6], function(n) {
	 *   return n % 2 == 0;
	 * });
	 * // => [4, 6]
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * // using the `_.matches` callback shorthand
	 * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
	 * // => ['barney']
	 *
	 * // using the `_.matchesProperty` callback shorthand
	 * _.pluck(_.filter(users, 'active', false), 'user');
	 * // => ['fred']
	 *
	 * // using the `_.property` callback shorthand
	 * _.pluck(_.filter(users, 'active'), 'user');
	 * // => ['barney']
	 */
	function filter(collection, predicate, thisArg) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  predicate = baseCallback(predicate, thisArg, 3);
	  return func(collection, predicate);
	}
	
	module.exports = filter;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * @license
	 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern -d -o ./index.js`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '3.10.1';
	
	  /** Used to compose bitmasks for wrapper metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256;
	
	  /** Used as default options for `_.trunc`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect when a function becomes hot. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2;
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      weakMapTag = '[object WeakMap]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	  /**
	   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
	   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
	   */
	  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
	      reHasRegExpChars = RegExp(reRegExpChars.source);
	
	  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
	  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0[xX]/;
	
	  /** Used to detect host constructors (Safari > 5). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^\d+$/;
	
	  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to match words to create compound words. */
	  var reWords = (function() {
	    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
	        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';
	
	    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
	  }());
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
	    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
	    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	  cloneableTags[dateTag] = cloneableTags[float32Tag] =
	  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[stringTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[mapTag] = cloneableTags[setTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map latin-1 supplementary letters to basic latin letters. */
	  var deburredLetters = {
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };
	
	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };
	
	  /** Used to escape characters for inclusion in compiled regexes. */
	  var regexpEscapes = {
	    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
	    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
	    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
	    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
	    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Detect free variable `exports`. */
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = objectTypes[typeof self] && self && self.Object && self;
	
	  /** Detect free variable `window`. */
	  var freeWindow = objectTypes[typeof window] && window && window.Object && window;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;
	
	  /**
	   * Used as a reference to the global object.
	   *
	   * The `this` value is used if it's the global object to avoid Greasemonkey's
	   * restricted `window` object, otherwise the `window` object is used.
	   */
	  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * The base implementation of `compareAscending` which compares values and
	   * sorts them in ascending order without guaranteeing a stable sort.
	   *
	   * @private
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @returns {number} Returns the sort order indicator for `value`.
	   */
	  function baseCompareAscending(value, other) {
	    if (value !== other) {
	      var valIsNull = value === null,
	          valIsUndef = value === undefined,
	          valIsReflexive = value === value;
	
	      var othIsNull = other === null,
	          othIsUndef = other === undefined,
	          othIsReflexive = other === other;
	
	      if ((value > other && !othIsNull) || !valIsReflexive ||
	          (valIsNull && !othIsUndef && othIsReflexive) ||
	          (valIsUndef && othIsReflexive)) {
	        return 1;
	      }
	      if ((value < other && !valIsNull) || !othIsReflexive ||
	          (othIsNull && !valIsUndef && valIsReflexive) ||
	          (othIsUndef && valIsReflexive)) {
	        return -1;
	      }
	    }
	    return 0;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromRight) {
	    var length = array.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without support for binary searches.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return indexOfNaN(array, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isFunction` without support for environments
	   * with incorrect `typeof` results.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   */
	  function baseIsFunction(value) {
	    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
	    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
	    return typeof value == 'function' || false;
	  }
	
	  /**
	   * Converts `value` to a string if it's not one. An empty string is returned
	   * for `null` or `undefined` values.
	   *
	   * @private
	   * @param {*} value The value to process.
	   * @returns {string} Returns the string.
	   */
	  function baseToString(value) {
	    return value == null ? '' : (value + '');
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the first character not found in `chars`.
	   */
	  function charsLeftIndex(string, chars) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the last character not found in `chars`.
	   */
	  function charsRightIndex(string, chars) {
	    var index = string.length;
	
	    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.sortBy` to compare transformed elements of a collection and stable
	   * sort them in ascending order.
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareAscending(object, other) {
	    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
	  }
	
	  /**
	   * Used by `_.sortByOrder` to compare multiple properties of a value to another
	   * and stable sort them.
	   *
	   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
	   * a value is sorted in ascending order if its corresponding order is "asc", and
	   * descending if "desc".
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @param {boolean[]} orders The order to sort by for each property.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareMultiple(object, other, orders) {
	    var index = -1,
	        objCriteria = object.criteria,
	        othCriteria = other.criteria,
	        length = objCriteria.length,
	        ordersLength = orders.length;
	
	    while (++index < length) {
	      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
	      if (result) {
	        if (index >= ordersLength) {
	          return result;
	        }
	        var order = orders[index];
	        return result * ((order === 'asc' || order === true) ? 1 : -1);
	      }
	    }
	    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	    // that causes it, under certain circumstances, to provide the same value for
	    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	    // for more details.
	    //
	    // This also ensures a stable sort in V8 and other engines.
	    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
	    return object.index - other.index;
	  }
	
	  /**
	   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  function deburrLetter(letter) {
	    return deburredLetters[letter];
	  }
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeHtmlChar(chr) {
	    return htmlEscapes[chr];
	  }
	
	  /**
	   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @param {string} leadingChar The capture group for a leading character.
	   * @param {string} whitespaceChar The capture group for a whitespace character.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
	    if (leadingChar) {
	      chr = regexpEscapes[chr];
	    } else if (whitespaceChar) {
	      chr = stringEscapes[chr];
	    }
	    return '\\' + chr;
	  }
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the index at which the first occurrence of `NaN` is found in `array`.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	   */
	  function indexOfNaN(array, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 0 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var other = array[index];
	      if (other !== other) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * Checks if `value` is object-like.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	   */
	  function isObjectLike(value) {
	    return !!value && typeof value == 'object';
	  }
	
	  /**
	   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
	   * character code is whitespace.
	   *
	   * @private
	   * @param {number} charCode The character code to inspect.
	   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
	   */
	  function isSpace(charCode) {
	    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
	      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      if (array[index] === placeholder) {
	        array[index] = PLACEHOLDER;
	        result[++resIndex] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * An implementation of `_.uniq` optimized for sorted arrays without support
	   * for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} [iteratee] The function invoked per iteration.
	   * @returns {Array} Returns the new duplicate-value-free array.
	   */
	  function sortedUniq(array, iteratee) {
	    var seen,
	        index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index],
	          computed = iteratee ? iteratee(value, index, array) : value;
	
	      if (!index || seen !== computed) {
	        seen = computed;
	        result[++resIndex] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the first non-whitespace character.
	   */
	  function trimmedLeftIndex(string) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedRightIndex(string) {
	    var index = string.length;
	
	    while (index-- && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  function unescapeHtmlChar(chr) {
	    return htmlUnescapes[chr];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the given `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Utility
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // using `context` to mock `Date#getTime` use in `_.now`
	   * var mock = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': getTimeMock };
	   *   }
	   * });
	   *
	   * // or creating a suped-up `defer` in Node.js
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    // Avoid issues with some ES3 environments that attempt to use values, named
	    // after built-in constructors like `Object`, for the creation of literals.
	    // ES5 clears this up by stating that literals must use built-in constructors.
	    // See https://es5.github.io/#x11.1.5 for more details.
	    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;
	
	    /** Native constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Number = context.Number,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for native method references. */
	    var arrayProto = Array.prototype,
	        objectProto = Object.prototype,
	        stringProto = String.prototype;
	
	    /** Used to resolve the decompiled source of functions. */
	    var fnToString = Function.prototype.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /**
	     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Native method references. */
	    var ArrayBuffer = context.ArrayBuffer,
	        clearTimeout = context.clearTimeout,
	        parseFloat = context.parseFloat,
	        pow = Math.pow,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        Set = getNative(context, 'Set'),
	        setTimeout = context.setTimeout,
	        splice = arrayProto.splice,
	        Uint8Array = context.Uint8Array,
	        WeakMap = getNative(context, 'WeakMap');
	
	    /* Native method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeCreate = getNative(Object, 'create'),
	        nativeFloor = Math.floor,
	        nativeIsArray = getNative(Array, 'isArray'),
	        nativeIsFinite = context.isFinite,
	        nativeKeys = getNative(Object, 'keys'),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = getNative(Date, 'now'),
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random;
	
	    /** Used as references for `-Infinity` and `Infinity`. */
	    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
	        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;
	
	    /** Used as references for the maximum length and index of an array. */
	    var MAX_ARRAY_LENGTH = 4294967295,
	        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	    /**
	     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	     * of an array-like value.
	     */
	    var MAX_SAFE_INTEGER = 9007199254740991;
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
	     * Methods that operate on and return arrays, collections, and functions can
	     * be chained together. Methods that retrieve a single value or may return a
	     * primitive value will automatically end the chain returning the unwrapped
	     * value. Explicit chaining may be enabled using `_.chain`. The execution of
	     * chained methods is lazy, that is, execution is deferred until `_#value`
	     * is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
	     * fusion is an optimization strategy which merge iteratee calls; this can help
	     * to avoid the creation of intermediate data structures and greatly reduce the
	     * number of iteratee executions.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
	     * `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
	     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
	     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
	     * and `where`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
	     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
	     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
	     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
	     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
	     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
	     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
	     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
	     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
	     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
	     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
	     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
	     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
	     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
	     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
	     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
	     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
	     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
	     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
	     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
	     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
	     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
	     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
	     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
	     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
	     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
	     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
	     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
	     * `unescape`, `uniqueId`, `value`, and `words`
	     *
	     * The wrapper method `sample` will return a wrapped value when `n` is provided,
	     * otherwise an unwrapped value is returned.
	     *
	     * @name _
	     * @constructor
	     * @category Chain
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // returns an unwrapped value
	     * wrapped.reduce(function(total, n) {
	     *   return total + n;
	     * });
	     * // => 6
	     *
	     * // returns a wrapped value
	     * var squares = wrapped.map(function(n) {
	     *   return n * n;
	     * });
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The function whose prototype all chaining wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
	     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
	     */
	    function LodashWrapper(value, chainAll, actions) {
	      this.__wrapped__ = value;
	      this.__actions__ = actions || [];
	      this.__chain__ = !!chainAll;
	    }
	
	    /**
	     * An object environment feature flags.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    var support = lodash.support = {};
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type string
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type Object
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type Function
	         */
	        '_': lodash
	      }
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = POSITIVE_INFINITY;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = arrayCopy(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = arrayCopy(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = arrayCopy(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
	        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a cache object to store key/value pairs.
	     *
	     * @private
	     * @static
	     * @name Cache
	     * @memberOf _.memoize
	     */
	    function MapCache() {
	      this.__data__ = {};
	    }
	
	    /**
	     * Removes `key` and its value from the cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
	     */
	    function mapDelete(key) {
	      return this.has(key) && delete this.__data__[key];
	    }
	
	    /**
	     * Gets the cached value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the cached value.
	     */
	    function mapGet(key) {
	      return key == '__proto__' ? undefined : this.__data__[key];
	    }
	
	    /**
	     * Checks if a cached value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapHas(key) {
	      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
	    }
	
	    /**
	     * Sets `value` to `key` of the cache.
	     *
	     * @private
	     * @name set
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to cache.
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache object.
	     */
	    function mapSet(key, value) {
	      if (key != '__proto__') {
	        this.__data__[key] = value;
	      }
	      return this;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates a cache object to store unique values.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var length = values ? values.length : 0;
	
	      this.data = { 'hash': nativeCreate(null), 'set': new Set };
	      while (length--) {
	        this.push(values[length]);
	      }
	    }
	
	    /**
	     * Checks if `value` is in `cache` mimicking the return signature of
	     * `_.indexOf` by returning `0` if the value is found, else `-1`.
	     *
	     * @private
	     * @param {Object} cache The cache to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `0` if `value` is found, else `-1`.
	     */
	    function cacheIndexOf(cache, value) {
	      var data = cache.data,
	          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	      return result ? 0 : -1;
	    }
	
	    /**
	     * Adds `value` to the cache.
	     *
	     * @private
	     * @name push
	     * @memberOf SetCache
	     * @param {*} value The value to cache.
	     */
	    function cachePush(value) {
	      var data = this.data;
	      if (typeof value == 'string' || isObject(value)) {
	        data.set.add(value);
	      } else {
	        data.hash[value] = true;
	      }
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a new array joining `array` with `other`.
	     *
	     * @private
	     * @param {Array} array The array to join.
	     * @param {Array} other The other array to join.
	     * @returns {Array} Returns the new concatenated array.
	     */
	    function arrayConcat(array, other) {
	      var index = -1,
	          length = array.length,
	          othIndex = -1,
	          othLength = other.length,
	          result = Array(length + othLength);
	
	      while (++index < length) {
	        result[index] = array[index];
	      }
	      while (++othIndex < othLength) {
	        result[index++] = other[othIndex];
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayCopy(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEach` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEach(array, iteratee) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (iteratee(array[index], index, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEachRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEachRight(array, iteratee) {
	      var length = array.length;
	
	      while (length--) {
	        if (iteratee(array[length], length, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.every` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     */
	    function arrayEvery(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (!predicate(array[index], index, array)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
	     * with one argument: (value).
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function arrayExtremum(array, iteratee, comparator, exValue) {
	      var index = -1,
	          length = array.length,
	          computed = exValue,
	          result = computed;
	
	      while (++index < length) {
	        var value = array[index],
	            current = +iteratee(value);
	
	        if (comparator(current, computed)) {
	          computed = current;
	          result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.filter` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function arrayFilter(array, predicate) {
	      var index = -1,
	          length = array.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.map` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function arrayMap(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = iteratee(array[index], index, array);
	      }
	      return result;
	    }
	
	    /**
	     * Appends the elements of `values` to `array`.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to append.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayPush(array, values) {
	      var index = -1,
	          length = values.length,
	          offset = array.length;
	
	      while (++index < length) {
	        array[offset + index] = values[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.reduce` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the first element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduce(array, iteratee, accumulator, initFromArray) {
	      var index = -1,
	          length = array.length;
	
	      if (initFromArray && length) {
	        accumulator = array[++index];
	      }
	      while (++index < length) {
	        accumulator = iteratee(accumulator, array[index], index, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.reduceRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the last element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
	      var length = array.length;
	      if (initFromArray && length) {
	        accumulator = array[--length];
	      }
	      while (length--) {
	        accumulator = iteratee(accumulator, array[length], length, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.some` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function arraySome(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (predicate(array[index], index, array)) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `_.sum` for arrays without support for callback
	     * shorthands and `this` binding..
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function arraySum(array, iteratee) {
	      var length = array.length,
	          result = 0;
	
	      while (length--) {
	        result += +iteratee(array[length]) || 0;
	      }
	      return result;
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assign` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : objectValue;
	    }
	
	    /**
	     * Used by `_.template` to customize its `_.assign` use.
	     *
	     * **Note:** This function is like `assignDefaults` except that it ignores
	     * inherited property values when checking if a property is `undefined`.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @param {string} key The key associated with the object and source values.
	     * @param {Object} object The destination object.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignOwnDefaults(objectValue, sourceValue, key, object) {
	      return (objectValue === undefined || !hasOwnProperty.call(object, key))
	        ? sourceValue
	        : objectValue;
	    }
	
	    /**
	     * A specialized version of `_.assign` for customizing assigned values without
	     * support for argument juggling, multiple sources, and `this` binding `customizer`
	     * functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     */
	    function assignWith(object, source, customizer) {
	      var index = -1,
	          props = keys(source),
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key],
	            result = customizer(value, source[key], key, object, source);
	
	        if ((result === result ? (result !== value) : (value === value)) ||
	            (value === undefined && !(key in object))) {
	          object[key] = result;
	        }
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for argument juggling,
	     * multiple sources, and `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return source == null
	        ? object
	        : baseCopy(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.at` without support for string collections
	     * and individual key arguments.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {number[]|string[]} props The property names or indexes of elements to pick.
	     * @returns {Array} Returns the new array of picked elements.
	     */
	    function baseAt(collection, props) {
	      var index = -1,
	          isNil = collection == null,
	          isArr = !isNil && isArrayLike(collection),
	          length = isArr ? collection.length : 0,
	          propsLength = props.length,
	          result = Array(propsLength);
	
	      while(++index < propsLength) {
	        var key = props[index];
	        if (isArr) {
	          result[index] = isIndex(key, length) ? collection[key] : undefined;
	        } else {
	          result[index] = isNil ? undefined : collection[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property names to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @returns {Object} Returns `object`.
	     */
	    function baseCopy(source, props, object) {
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	        object[key] = source[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.callback` which supports specifying the
	     * number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function baseCallback(func, thisArg, argCount) {
	      var type = typeof func;
	      if (type == 'function') {
	        return thisArg === undefined
	          ? func
	          : bindCallback(func, thisArg, argCount);
	      }
	      if (func == null) {
	        return identity;
	      }
	      if (type == 'object') {
	        return baseMatches(func);
	      }
	      return thisArg === undefined
	        ? property(func)
	        : baseMatchesProperty(func, thisArg);
	    }
	
	    /**
	     * The base implementation of `_.clone` without support for argument juggling
	     * and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The object `value` belongs to.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates clones with source counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return arrayCopy(value, result);
	        }
	      } else {
	        var tag = objToString.call(value),
	            isFunc = tag == funcTag;
	
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return baseAssign(result, value);
	          }
	        } else {
	          return cloneableTags[tag]
	            ? initCloneByTag(value, tag, isDeep)
	            : (object ? value : {});
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == value) {
	          return stackB[length];
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate it with its clone.
	      stackA.push(value);
	      stackB.push(result);
	
	      // Recursively populate clone (susceptible to call stack limits).
	      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(prototype) {
	        if (isObject(prototype)) {
	          object.prototype = prototype;
	          var result = new object;
	          object.prototype = undefined;
	        }
	        return result || {};
	      };
	    }());
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts an index
	     * of where to slice the arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Object} args The arguments provide to `func`.
	     * @returns {number} Returns the timer id.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of `_.difference` which accepts a single array
	     * of values to exclude.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values) {
	      var length = array ? array.length : 0,
	          result = [];
	
	      if (!length) {
	        return result;
	      }
	      var index = -1,
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	          valuesLength = values.length;
	
	      if (cache) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	        values = cache;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index];
	
	        if (isCommon && value === value) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === value) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (indexOf(values, value, 0) < 0) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * Gets the extremum value of `collection` invoking `iteratee` for each value
	     * in `collection` to generate the criterion by which the value is ranked.
	     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(collection, iteratee, comparator, exValue) {
	      var computed = exValue,
	          result = computed;
	
	      baseEach(collection, function(value, index, collection) {
	        var current = +iteratee(value, index, collection);
	        if (comparator(current, computed) || (current === exValue && current === result)) {
	          computed = current;
	          result = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : (end >>> 0);
	      start >>>= 0;
	
	      while (start < length) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	     * without support for callback shorthands and `this` binding, which iterates
	     * over `collection` using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @param {boolean} [retKey] Specify returning the key of the found element
	     *  instead of the element itself.
	     * @returns {*} Returns the found element or its key, else `undefined`.
	     */
	    function baseFind(collection, predicate, eachFunc, retKey) {
	      var result;
	      eachFunc(collection, function(value, key, collection) {
	        if (predicate(value, key, collection)) {
	          result = retKey ? key : value;
	          return false;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with added support for restricting
	     * flattening and specifying the start index.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, isDeep, isStrict, result) {
	      result || (result = []);
	
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index];
	        if (isObjectLike(value) && isArrayLike(value) &&
	            (isStrict || isArray(value) || isArguments(value))) {
	          if (isDeep) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, isDeep, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForIn` and `baseForOwn` which iterates
	     * over `object` properties returned by `keysFunc` invoking `iteratee` for
	     * each property. Iteratee functions may exit iteration early by explicitly
	     * returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forIn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForIn(object, iteratee) {
	      return baseFor(object, iteratee, keysIn);
	    }
	
	    /**
	     * The base implementation of `_.forOwn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from those provided.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the new array of filtered property names.
	     */
	    function baseFunctions(object, props) {
	      var index = -1,
	          length = props.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var key = props[index];
	        if (isFunction(object[key])) {
	          result[++resIndex] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `get` without support for string paths
	     * and default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path of the property to get.
	     * @param {string} [pathKey] The key representation of path.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path, pathKey) {
	      if (object == null) {
	        return;
	      }
	      if (pathKey !== undefined && pathKey in toObject(object)) {
	        path = [pathKey];
	      }
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[path[index++]];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` without support for `this` binding
	     * `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = objToString.call(object);
	        if (objTag == argsTag) {
	          objTag = objectTag;
	        } else if (objTag != objectTag) {
	          objIsArr = isTypedArray(object);
	        }
	      }
	      if (!othIsArr) {
	        othTag = objToString.call(other);
	        if (othTag == argsTag) {
	          othTag = objectTag;
	        } else if (othTag != objectTag) {
	          othIsArr = isTypedArray(other);
	        }
	      }
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && !(objIsArr || objIsObj)) {
	        return equalByTag(object, other, objTag);
	      }
	      if (!isLoose) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      // For more information on detecting circular references see https://es5.github.io/#JO.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == object) {
	          return stackB[length] == other;
	        }
	      }
	      // Add `object` and `other` to the stack of traversed objects.
	      stackA.push(object);
	      stackB.push(other);
	
	      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	      stackA.pop();
	      stackB.pop();
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} matchData The propery names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = toObject(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which does not clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        var key = matchData[0][0],
	            value = matchData[0][1];
	
	        return function(object) {
	          if (object == null) {
	            return false;
	          }
	          return object[key] === value && (value !== undefined || (key in toObject(object)));
	        };
	      }
	      return function(object) {
	        return baseIsMatch(object, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to compare.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      var isArr = isArray(path),
	          isCommon = isKey(path) && isStrictComparable(srcValue),
	          pathKey = (path + '');
	
	      path = toPath(path);
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        var key = pathKey;
	        object = toObject(object);
	        if ((isArr || !isCommon) && !(key in object)) {
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          if (object == null) {
	            return false;
	          }
	          key = last(path);
	          object = toObject(object);
	        }
	        return object[key] === srcValue
	          ? (srcValue !== undefined || (key in object))
	          : baseIsEqual(srcValue, object[key], undefined, true);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for argument juggling,
	     * multiple sources, and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {Object} Returns `object`.
	     */
	    function baseMerge(object, source, customizer, stackA, stackB) {
	      if (!isObject(object)) {
	        return object;
	      }
	      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
	          props = isSrcArr ? undefined : keys(source);
	
	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObjectLike(srcValue)) {
	          stackA || (stackA = []);
	          stackB || (stackB = []);
	          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
	        }
	        else {
	          var value = object[key],
	              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	              isCommon = result === undefined;
	
	          if (isCommon) {
	            result = srcValue;
	          }
	          if ((result !== undefined || (isSrcArr && !(key in object))) &&
	              (isCommon || (result === result ? (result !== value) : (value === value)))) {
	            object[key] = result;
	          }
	        }
	      });
	      return object;
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
	      var length = stackA.length,
	          srcValue = source[key];
	
	      while (length--) {
	        if (stackA[length] == srcValue) {
	          object[key] = stackB[length];
	          return;
	        }
	      }
	      var value = object[key],
	          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	          isCommon = result === undefined;
	
	      if (isCommon) {
	        result = srcValue;
	        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
	          result = isArray(value)
	            ? value
	            : (isArrayLike(value) ? arrayCopy(value) : []);
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          result = isArguments(value)
	            ? toPlainObject(value)
	            : (isPlainObject(value) ? value : {});
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate
	      // it with its merged value.
	      stackA.push(srcValue);
	      stackB.push(result);
	
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
	      } else if (result === result ? (result !== value) : (value === value)) {
	        object[key] = result;
	      }
	    }
	
	    /**
	     * The base implementation of `_.property` without support for deep paths.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function baseProperty(key) {
	      return function(object) {
	        return object == null ? undefined : object[key];
	      };
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function basePropertyDeep(path) {
	      var pathKey = (path + '');
	      path = toPath(path);
	      return function(object) {
	        return baseGet(object, path, pathKey);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * index arguments and capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0;
	      while (length--) {
	        var index = indexes[length];
	        if (index != previous && isIndex(index)) {
	          var previous = index;
	          splice.call(array, index, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for argument juggling
	     * and returning floating-point numbers.
	     *
	     * @private
	     * @param {number} min The minimum possible value.
	     * @param {number} max The maximum possible value.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(min, max) {
	      return min + nativeFloor(nativeRandom() * (max - min + 1));
	    }
	
	    /**
	     * The base implementation of `_.reduce` and `_.reduceRight` without support
	     * for callback shorthands and `this` binding, which iterates over `collection`
	     * using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} accumulator The initial value.
	     * @param {boolean} initFromCollection Specify using the first or last element
	     *  of `collection` as the initial value.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @returns {*} Returns the accumulated value.
	     */
	    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
	      eachFunc(collection, function(value, index, collection) {
	        accumulator = initFromCollection
	          ? (initFromCollection = false, value)
	          : iteratee(accumulator, value, index, collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortBy` which uses `comparer` to define
	     * the sort order of `array` and replaces criteria objects with their
	     * corresponding values.
	     *
	     * @private
	     * @param {Array} array The array to sort.
	     * @param {Function} comparer The function to define sort order.
	     * @returns {Array} Returns `array`.
	     */
	    function baseSortBy(array, comparer) {
	      var length = array.length;
	
	      array.sort(comparer);
	      while (length--) {
	        array[length] = array[length].value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.sortByOrder` without param guards.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseSortByOrder(collection, iteratees, orders) {
	      var callback = getCallback(),
	          index = -1;
	
	      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });
	
	      var result = baseMap(collection, function(value) {
	        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.sum` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function baseSum(collection, iteratee) {
	      var result = 0;
	      baseEach(collection, function(value, index, collection) {
	        result += +iteratee(value, index, collection) || 0;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.uniq` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The function invoked per iteration.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     */
	    function baseUniq(array, iteratee) {
	      var index = -1,
	          indexOf = getIndexOf(),
	          length = array.length,
	          isCommon = indexOf == baseIndexOf,
	          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
	          seen = isLarge ? createCache() : null,
	          result = [];
	
	      if (seen) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	      } else {
	        isLarge = false;
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value, index, array) : value;
	
	        if (isCommon && value === value) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (indexOf(seen, computed, 0) < 0) {
	          if (iteratee || isLarge) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.values` and `_.valuesIn` which creates an
	     * array of `object` property values corresponding to the property names
	     * of `props`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} props The property names to get values for.
	     * @returns {Object} Returns the array of property values.
	     */
	    function baseValues(object, props) {
	      var index = -1,
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = object[props[index]];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
	     * and `_.takeWhile` without support for callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to peform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      var index = -1,
	          length = actions.length;
	
	      while (++index < length) {
	        var action = actions[index];
	        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }
	      return result;
	    }
	
	    /**
	     * Performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return binaryIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * This function is like `binaryIndex` except that it invokes `iteratee` for
	     * `value` and each element of `array` to compute their sort ranking. The
	     * iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsUndef = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            isDef = computed !== undefined,
	            isReflexive = computed === computed;
	
	        if (valIsNaN) {
	          var setLow = isReflexive || retHighest;
	        } else if (valIsNull) {
	          setLow = isReflexive && isDef && (retHighest || computed != null);
	        } else if (valIsUndef) {
	          setLow = isReflexive && (retHighest || isDef);
	        } else if (computed == null) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * A specialized version of `baseCallback` which only supports `this` binding
	     * and specifying the number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function bindCallback(func, thisArg, argCount) {
	      if (typeof func != 'function') {
	        return identity;
	      }
	      if (thisArg === undefined) {
	        return func;
	      }
	      switch (argCount) {
	        case 1: return function(value) {
	          return func.call(thisArg, value);
	        };
	        case 3: return function(value, index, collection) {
	          return func.call(thisArg, value, index, collection);
	        };
	        case 4: return function(accumulator, value, index, collection) {
	          return func.call(thisArg, accumulator, value, index, collection);
	        };
	        case 5: return function(value, other, key, object, source) {
	          return func.call(thisArg, value, other, key, object, source);
	        };
	      }
	      return function() {
	        return func.apply(thisArg, arguments);
	      };
	    }
	
	    /**
	     * Creates a clone of the given array buffer.
	     *
	     * @private
	     * @param {ArrayBuffer} buffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function bufferClone(buffer) {
	      var result = new ArrayBuffer(buffer.byteLength),
	          view = new Uint8Array(result);
	
	      view.set(new Uint8Array(buffer));
	      return result;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders) {
	      var holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          leftIndex = -1,
	          leftLength = partials.length,
	          result = Array(leftLength + argsLength);
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        result[holders[argsIndex]] = args[argsIndex];
	      }
	      while (argsLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders) {
	      var holdersIndex = -1,
	          holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          rightIndex = -1,
	          rightLength = partials.length,
	          result = Array(argsLength + rightLength);
	
	      while (++argsIndex < argsLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        result[offset + holders[holdersIndex]] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
	     *
	     * @private
	     * @param {Function} setter The function to set keys and values of the accumulator object.
	     * @param {Function} [initializer] The function to initialize the accumulator object.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee, thisArg) {
	        var result = initializer ? initializer() : {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        if (isArray(collection)) {
	          var index = -1,
	              length = collection.length;
	
	          while (++index < length) {
	            var value = collection[index];
	            setter(result, value, iteratee(value, index, collection), collection);
	          }
	        } else {
	          baseEach(collection, function(value, key, collection) {
	            setter(result, value, iteratee(value, key, collection), collection);
	          });
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return restParam(function(object, sources) {
	        var index = -1,
	            length = object == null ? 0 : sources.length,
	            customizer = length > 2 ? sources[length - 2] : undefined,
	            guard = length > 2 ? sources[2] : undefined,
	            thisArg = length > 1 ? sources[length - 1] : undefined;
	
	        if (typeof customizer == 'function') {
	          customizer = bindCallback(customizer, thisArg, 5);
	          length -= 2;
	        } else {
	          customizer = typeof thisArg == 'function' ? thisArg : undefined;
	          length -= (customizer ? 1 : 0);
	        }
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        var length = collection ? getLength(collection) : 0;
	        if (!isLength(length)) {
	          return eachFunc(collection, iteratee);
	        }
	        var index = fromRight ? length : -1,
	            iterable = toObject(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var iterable = toObject(object),
	            props = keysFunc(object),
	            length = props.length,
	            index = fromRight ? length : -1;
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var key = props[index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createBindWrapper(func, thisArg) {
	      var Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(thisArg, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `Set` cache object to optimize linear searches of large arrays.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	     */
	    function createCache(values) {
	      return (nativeCreate && Set) ? new SetCache(values) : null;
	    }
	
	    /**
	     * Creates a function that produces compound words out of the words in a
	     * given string.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        var index = -1,
	            array = words(deburr(string)),
	            length = array.length,
	            result = '';
	
	        while (++index < length) {
	          result = callback(result, array[index], index);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtorWrapper(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors.
	        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a `_.curry` or `_.curryRight` function.
	     *
	     * @private
	     * @param {boolean} flag The curry bit flag.
	     * @returns {Function} Returns the new curry function.
	     */
	    function createCurry(flag) {
	      function curryFunc(func, arity, guard) {
	        if (guard && isIterateeCall(func, arity, guard)) {
	          arity = undefined;
	        }
	        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
	        result.placeholder = curryFunc.placeholder;
	        return result;
	      }
	      return curryFunc;
	    }
	
	    /**
	     * Creates a `_.defaults` or `_.defaultsDeep` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Function} Returns the new defaults function.
	     */
	    function createDefaults(assigner, customizer) {
	      return restParam(function(args) {
	        var object = args[0];
	        if (object == null) {
	          return object;
	        }
	        args.push(customizer);
	        return assigner.apply(undefined, args);
	      });
	    }
	
	    /**
	     * Creates a `_.max` or `_.min` function.
	     *
	     * @private
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {Function} Returns the new extremum function.
	     */
	    function createExtremum(comparator, exValue) {
	      return function(collection, iteratee, thisArg) {
	        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	          iteratee = undefined;
	        }
	        iteratee = getCallback(iteratee, thisArg, 3);
	        if (iteratee.length == 1) {
	          collection = isArray(collection) ? collection : toIterable(collection);
	          var result = arrayExtremum(collection, iteratee, comparator, exValue);
	          if (!(collection.length && result === exValue)) {
	            return result;
	          }
	        }
	        return baseExtremum(collection, iteratee, comparator, exValue);
	      };
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(eachFunc, fromRight) {
	      return function(collection, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        if (isArray(collection)) {
	          var index = baseFindIndex(collection, predicate, fromRight);
	          return index > -1 ? collection[index] : undefined;
	        }
	        return baseFind(collection, predicate, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a `_.findIndex` or `_.findLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindIndex(fromRight) {
	      return function(array, predicate, thisArg) {
	        if (!(array && array.length)) {
	          return -1;
	        }
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFindIndex(array, predicate, fromRight);
	      };
	    }
	
	    /**
	     * Creates a `_.findKey` or `_.findLastKey` function.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindKey(objectFunc) {
	      return function(object, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFind(object, predicate, objectFunc, true);
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return function() {
	        var wrapper,
	            length = arguments.length,
	            index = fromRight ? length : -1,
	            leftIndex = 0,
	            funcs = Array(length);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var func = funcs[leftIndex++] = arguments[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
	            wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? -1 : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      };
	    }
	
	    /**
	     * Creates a function for `_.forEach` or `_.forEachRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForEach(arrayFunc, eachFunc) {
	      return function(collection, iteratee, thisArg) {
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee)
	          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
	      };
	    }
	
	    /**
	     * Creates a function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForIn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee, keysIn);
	      };
	    }
	
	    /**
	     * Creates a function for `_.forOwn` or `_.forOwnRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForOwn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee);
	      };
	    }
	
	    /**
	     * Creates a function for `_.mapKeys` or `_.mapValues`.
	     *
	     * @private
	     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
	     * @returns {Function} Returns the new map function.
	     */
	    function createObjectMapper(isMapKeys) {
	      return function(object, iteratee, thisArg) {
	        var result = {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        baseForOwn(object, function(value, key, object) {
	          var mapped = iteratee(value, key, object);
	          key = isMapKeys ? mapped : key;
	          value = isMapKeys ? value : mapped;
	          result[key] = value;
	        });
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function for `_.padLeft` or `_.padRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify padding from the right.
	     * @returns {Function} Returns the new pad function.
	     */
	    function createPadDir(fromRight) {
	      return function(string, length, chars) {
	        string = baseToString(string);
	        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
	      };
	    }
	
	    /**
	     * Creates a `_.partial` or `_.partialRight` function.
	     *
	     * @private
	     * @param {boolean} flag The partial bit flag.
	     * @returns {Function} Returns the new partial function.
	     */
	    function createPartial(flag) {
	      var partialFunc = restParam(function(func, partials) {
	        var holders = replaceHolders(partials, partialFunc.placeholder);
	        return createWrapper(func, flag, undefined, partials, holders);
	      });
	      return partialFunc;
	    }
	
	    /**
	     * Creates a function for `_.reduce` or `_.reduceRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createReduce(arrayFunc, eachFunc) {
	      return function(collection, iteratee, accumulator, thisArg) {
	        var initFromArray = arguments.length < 3;
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
	          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with optional `this`
	     * binding of, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurry = bitmask & CURRY_FLAG,
	          isCurryBound = bitmask & CURRY_BOUND_FLAG,
	          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
	          Ctor = isBindKey ? undefined : createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it to other functions.
	        var length = arguments.length,
	            index = length,
	            args = Array(length);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight);
	        }
	        if (isCurry || isCurryRight) {
	          var placeholder = wrapper.placeholder,
	              argsHolders = replaceHolders(args, placeholder);
	
	          length -= argsHolders.length;
	          if (length < arity) {
	            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
	                newArity = nativeMax(arity - length, 0),
	                newsHolders = isCurry ? argsHolders : undefined,
	                newHoldersRight = isCurry ? undefined : argsHolders,
	                newPartials = isCurry ? args : undefined,
	                newPartialsRight = isCurry ? undefined : args;
	
	            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	            if (!isCurryBound) {
	              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	            }
	            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
	                result = createHybridWrapper.apply(undefined, newData);
	
	            if (isLaziable(func)) {
	              setData(result, newData);
	            }
	            result.placeholder = placeholder;
	            return result;
	          }
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        if (argPos) {
	          args = reorder(args, argPos);
	        }
	        if (isAry && ary < args.length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtorWrapper(func);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates the padding required for `string` based on the given `length`.
	     * The `chars` string is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {string} string The string to create padding for.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the pad for `string`.
	     */
	    function createPadding(string, length, chars) {
	      var strLength = string.length;
	      length = +length;
	
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return '';
	      }
	      var padLength = length - strLength;
	      chars = chars == null ? ' ' : (chars + '');
	      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the optional `this`
	     * binding of `thisArg` and the `partials` prepended to those provided to
	     * the wrapper.
	     *
	     * @private
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to the new function.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createPartialWrapper(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it `func`.
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength);
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        precision = precision === undefined ? 0 : (+precision || 0);
	        if (precision) {
	          precision = pow(10, precision);
	          return func(number * precision) / precision;
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {Function} Returns the new index function.
	     */
	    function createSortedIndex(retHighest) {
	      return function(array, value, iteratee, thisArg) {
	        var callback = getCallback(iteratee);
	        return (iteratee == null && callback === baseCallback)
	          ? binaryIndex(array, value, retHighest)
	          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      length -= (holders ? holders.length : 0);
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func),
	          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
	
	      if (data) {
	        mergeData(newData, data);
	        bitmask = newData[1];
	        arity = newData[9];
	      }
	      newData[9] = arity == null
	        ? (isBindKey ? 0 : func.length)
	        : (nativeMax(arity - length, 0) || 0);
	
	      if (bitmask == BIND_FLAG) {
	        var result = createBindWrapper(newData[0], newData[2]);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
	        result = createPartialWrapper.apply(undefined, newData);
	      } else {
	        result = createHybridWrapper.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setter(result, newData);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing arrays.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var index = -1,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	        return false;
	      }
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index],
	            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	        if (result !== undefined) {
	          if (result) {
	            continue;
	          }
	          return false;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (isLoose) {
	          if (!arraySome(other, function(othValue) {
	                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	              })) {
	            return false;
	          }
	        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag) {
	      switch (tag) {
	        case boolTag:
	        case dateTag:
	          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	          return +object == +other;
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case numberTag:
	          // Treat `NaN` vs. `NaN` as equal.
	          return (object != +object)
	            ? other != +other
	            : object == +other;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings primitives and string
	          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	          return object == (other + '');
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isLoose) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      var skipCtor = isLoose;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key],
	            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	          return false;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (!skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Gets the appropriate "callback" function. If the `_.callback` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseCallback` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getCallback(func, thisArg, argCount) {
	      var result = lodash.callback || callback;
	      result = result === callback ? baseCallback : result;
	      return argCount ? result(func, thisArg, argCount) : result;
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = func.name,
	          array = realNames[result],
	          length = array ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseIndexOf` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function|number} Returns the chosen function or its result.
	     */
	    function getIndexOf(collection, target, fromIndex) {
	      var result = lodash.indexOf || indexOf;
	      result = result === indexOf ? baseIndexOf : result;
	      return collection ? result(collection, target, fromIndex) : result;
	    }
	
	    /**
	     * Gets the "length" property value of `object`.
	     *
	     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	     * that affects Safari on at least iOS 8.1-8.3 ARM64.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {*} Returns the "length" value.
	     */
	    var getLength = baseProperty('length');
	
	    /**
	     * Gets the propery names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = pairs(object),
	          length = result.length;
	
	      while (length--) {
	        result[length][2] = isStrictComparable(result[length][1]);
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = object == null ? undefined : object[key];
	      return isNative(value) ? value : undefined;
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add array properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      var Ctor = object.constructor;
	      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
	        Ctor = Object;
	      }
	      return new Ctor;
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return bufferClone(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          var buffer = object.buffer;
	          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          var result = new Ctor(object.source, reFlags.exec(object));
	          result.lastIndex = object.lastIndex;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the method at `path` on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function invokePath(object, path, args) {
	      if (object != null && !isKey(path, object)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        path = last(path);
	      }
	      var func = object == null ? object : object[path];
	      return func == null ? undefined : func.apply(object, args);
	    }
	
	    /**
	     * Checks if `value` is array-like.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(getLength(value));
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return value > -1 && value % 1 == 0 && value < length;
	    }
	
	    /**
	     * Checks if the provided arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	          ? (isArrayLike(object) && isIndex(index, object.length))
	          : (type == 'string' && index in object)) {
	        var other = object[index];
	        return value === value ? (value === other) : (other !== other);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      var type = typeof value;
	      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	        return true;
	      }
	      if (isArray(value)) {
	        return false;
	      }
	      var result = !reIsDeepProp.test(value);
	      return result || (object != null && value in toObject(object));
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func);
	      if (!(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      var other = lodash[funcName];
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     */
	    function isLength(value) {
	      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers required to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
	     * augment function arguments, making the order in which they are executed important,
	     * preventing the merging of metadata. However, we make an exception for a safe
	     * common case where curried functions have `_.ary` and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < ARY_FLAG;
	
	      var isCombo =
	        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
	        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
	        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = arrayCopy(value);
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function mergeDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties specified
	     * by `props`.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property names to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByArray(object, props) {
	      object = toObject(object);
	
	      var index = -1,
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index];
	        if (key in object) {
	          result[key] = object[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties `predicate`
	     * returns truthy for.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByCallback(object, predicate) {
	      var result = {};
	      baseForIn(object, function(value, key, object) {
	        if (predicate(value, key, object)) {
	          result[key] = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = arrayCopy(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity function
	     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;
	
	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());
	
	    /**
	     * A fallback implementation of `Object.keys` which creates an array of the
	     * own enumerable property names of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function shimKeys(object) {
	      var props = keysIn(object),
	          propsLength = props.length,
	          length = propsLength && object.length;
	
	      var allowIndexes = !!length && isLength(length) &&
	        (isArray(object) || isArguments(object));
	
	      var index = -1,
	          result = [];
	
	      while (++index < propsLength) {
	        var key = props[index];
	        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to an array-like object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array|Object} Returns the array-like object.
	     */
	    function toIterable(value) {
	      if (value == null) {
	        return [];
	      }
	      if (!isArrayLike(value)) {
	        return values(value);
	      }
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to an object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Object} Returns the object.
	     */
	    function toObject(value) {
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to property path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array} Returns the property path array.
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return value;
	      }
	      var result = [];
	      baseToString(value).replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      return wrapper instanceof LazyWrapper
	        ? wrapper.clone()
	        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `collection` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new array containing chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if (guard ? isIterateeCall(array, size, guard) : size == null) {
	        size = 1;
	      } else {
	        size = nativeMax(nativeFloor(size) || 1, 1);
	      }
	      var index = 0,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[++resIndex] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of unique `array` values not included in the other
	     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The arrays of values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.difference([1, 2, 3], [4, 2]);
	     * // => [1, 3]
	     */
	    var difference = restParam(function(array, values) {
	      return (isObjectLike(array) && isArrayLike(array))
	        ? baseDifference(array, baseFlatten(values, false, true))
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that match the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [1]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active', false), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8], '*', 1, 2);
	     * // => [4, '*', 8]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(chr) {
	     *   return chr.user == 'barney';
	     * });
	     * // => 0
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findIndex(users, 'active', false);
	     * // => 0
	     *
	     * // using the `_.property` callback shorthand
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    var findIndex = createFindIndex();
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(chr) {
	     *   return chr.user == 'pebbles';
	     * });
	     * // => 2
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastIndex(users, 'active', false);
	     * // => 2
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    var findLastIndex = createFindIndex(true);
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias head
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.first([1, 2, 3]);
	     * // => 1
	     *
	     * _.first([]);
	     * // => undefined
	     */
	    function first(array) {
	      return array ? array[0] : undefined;
	    }
	
	    /**
	     * Flattens a nested array. If `isDeep` is `true` the array is recursively
	     * flattened, otherwise it is only flattened a single level.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, [4]]
	     *
	     * // using `isDeep`
	     * _.flatten([1, [2, 3, [4]]], true);
	     * // => [1, 2, 3, 4]
	     */
	    function flatten(array, isDeep, guard) {
	      var length = array ? array.length : 0;
	      if (guard && isIterateeCall(array, isDeep, guard)) {
	        isDeep = false;
	      }
	      return length ? baseFlatten(array, isDeep) : [];
	    }
	
	    /**
	     * Recursively flattens a nested array.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to recursively flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, 4]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, true) : [];
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
	     * performs a faster binary search.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
	     *  to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // using `fromIndex`
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     *
	     * // performing a binary search
	     * _.indexOf([1, 1, 2, 2], 2, true);
	     * // => 2
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      if (typeof fromIndex == 'number') {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
	      } else if (fromIndex) {
	        var index = binaryIndex(array, value);
	        if (index < length &&
	            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
	          return index;
	        }
	        return -1;
	      }
	      return baseIndexOf(array, value, fromIndex || 0);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      return dropRight(array, 1);
	    }
	
	    /**
	     * Creates an array of unique values that are included in all of the provided
	     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of shared values.
	     * @example
	     * _.intersection([1, 2], [4, 2], [2, 1]);
	     * // => [2]
	     */
	    var intersection = restParam(function(arrays) {
	      var othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(length),
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          result = [];
	
	      while (othIndex--) {
	        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
	        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
	      }
	      var array = arrays[0],
	          index = -1,
	          length = array ? array.length : 0,
	          seen = caches[0];
	
	      outer:
	      while (++index < length) {
	        value = array[index];
	        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
	          var othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(value);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    });
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
	     *  or `true` to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // using `fromIndex`
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     *
	     * // performing a binary search
	     * _.lastIndexOf([1, 1, 2, 2], 2, true);
	     * // => 3
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (typeof fromIndex == 'number') {
	        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
	      } else if (fromIndex) {
	        index = binaryIndex(array, value, true) - 1;
	        var other = array[index];
	        if (value === value ? (value === other) : (other !== other)) {
	          return index;
	        }
	        return -1;
	      }
	      if (value !== value) {
	        return indexOfNaN(array, index, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Removes all provided values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     *
	     * _.pull(array, 2, 3);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    function pull() {
	      var args = arguments,
	          array = args[0];
	
	      if (!(array && array.length)) {
	        return array;
	      }
	      var index = 0,
	          indexOf = getIndexOf(),
	          length = args.length;
	
	      while (++index < length) {
	        var fromIndex = 0,
	            value = args[index];
	
	        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to the given indexes and returns
	     * an array of the removed elements. Indexes may be specified as an array of
	     * indexes or as individual arguments.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [5, 10, 15, 20];
	     * var evens = _.pullAt(array, 1, 3);
	     *
	     * console.log(array);
	     * // => [5, 15]
	     *
	     * console.log(evens);
	     * // => [10, 20]
	     */
	    var pullAt = restParam(function(array, indexes) {
	      indexes = baseFlatten(indexes);
	
	      var result = baseAt(array, indexes);
	      basePullAt(array, indexes.sort(baseCompareAscending));
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate, thisArg) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getCallback(predicate, thisArg, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias tail
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.rest([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function rest(array) {
	      return drop(array, 1);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of `Array#slice` to support node
	     * lists in IE < 9 and to ensure dense arrays are returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value` should
	     * be inserted into `array` in order to maintain its sort order. If an iteratee
	     * function is provided it is invoked for `value` and each element of `array`
	     * to compute their sort ranking. The iteratee is bound to `thisArg` and
	     * invoked with one argument; (value).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     *
	     * _.sortedIndex([4, 4, 5, 5], 5);
	     * // => 2
	     *
	     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
	     *
	     * // using an iteratee function
	     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
	     *   return this.data[word];
	     * }, dict);
	     * // => 1
	     *
	     * // using the `_.property` callback shorthand
	     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
	     * // => 1
	     */
	    var sortedIndex = createSortedIndex();
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 4, 5, 5], 5);
	     * // => 4
	     */
	    var sortedLastIndex = createSortedIndex(true);
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
	     * and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [2, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [1, 2]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active', false), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all of the provided arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([1, 2], [4, 2], [2, 1]);
	     * // => [1, 2, 4]
	     */
	    var union = restParam(function(arrays) {
	      return baseUniq(baseFlatten(arrays, false, true));
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurence of each element
	     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
	     * for sorted arrays. If an iteratee function is provided it is invoked for
	     * each element in the array to generate the criterion by which uniqueness
	     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, array).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias unique
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {boolean} [isSorted] Specify the array is sorted.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     *
	     * // using `isSorted`
	     * _.uniq([1, 1, 2], true);
	     * // => [1, 2]
	     *
	     * // using an iteratee function
	     * _.uniq([1, 2.5, 1.5, 2], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => [1, 2.5]
	     *
	     * // using the `_.property` callback shorthand
	     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniq(array, isSorted, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (isSorted != null && typeof isSorted != 'boolean') {
	        thisArg = iteratee;
	        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
	        isSorted = false;
	      }
	      var callback = getCallback();
	      if (!(iteratee == null && callback === baseCallback)) {
	        iteratee = callback(iteratee, thisArg, 3);
	      }
	      return (isSorted && getIndexOf() == baseIndexOf)
	        ? sortedUniq(array, iteratee)
	        : baseUniq(array, iteratee);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['fred', 'barney'], [30, 40], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var index = -1,
	          length = 0;
	
	      array = arrayFilter(array, function(group) {
	        if (isArrayLike(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = arrayMap(array, baseProperty(index));
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts an iteratee to specify
	     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee] The function to combine regrouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      iteratee = bindCallback(iteratee, thisArg, 4);
	      return arrayMap(result, function(group) {
	        return arrayReduce(group, iteratee, undefined, true);
	      });
	    }
	
	    /**
	     * Creates an array excluding all provided values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to filter.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.without([1, 2, 1, 3], 1, 2);
	     * // => [3]
	     */
	    var without = restParam(function(array, values) {
	      return isArrayLike(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the provided arrays.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * _.xor([1, 2], [4, 2]);
	     * // => [1, 4]
	     */
	    function xor() {
	      var index = -1,
	          length = arguments.length;
	
	      while (++index < length) {
	        var array = arguments[index];
	        if (isArrayLike(array)) {
	          var result = result
	            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
	            : array;
	        }
	      }
	      return result ? baseUniq(result) : [];
	    }
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the first
	     * elements of the given arrays, the second of which contains the second elements
	     * of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     */
	    var zip = restParam(unzip);
	
	    /**
	     * The inverse of `_.pairs`; this method returns an object composed from arrays
	     * of property names and values. Provide either a single two dimensional array,
	     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
	     * and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @alias object
	     * @category Array
	     * @param {Array} props The property names.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject([['fred', 30], ['barney', 40]]);
	     * // => { 'fred': 30, 'barney': 40 }
	     *
	     * _.zipObject(['fred', 'barney'], [30, 40]);
	     * // => { 'fred': 30, 'barney': 40 }
	     */
	    function zipObject(props, values) {
	      var index = -1,
	          length = props ? props.length : 0,
	          result = {};
	
	      if (length && !values && !isArray(props[0])) {
	        values = [];
	      }
	      while (++index < length) {
	        var key = props[index];
	        if (values) {
	          result[key] = values[index];
	        } else if (key) {
	          result[key[0]] = key[1];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an iteratee to specify
	     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee] The function to combine grouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
	     * // => [111, 222]
	     */
	    var zipWith = restParam(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 2 ? arrays[length - 2] : undefined,
	          thisArg = length > 1 ? arrays[length - 1] : undefined;
	
	      if (length > 2 && typeof iteratee == 'function') {
	        length -= 2;
	      } else {
	        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
	        thisArg = undefined;
	      }
	      arrays.length = length;
	      return unzipWith(arrays, iteratee, thisArg);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object that wraps `value` with explicit method
	     * chaining enabled.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _.chain(users)
	     *   .sortBy('age')
	     *   .map(function(chr) {
	     *     return chr.user + ' is ' + chr.age;
	     *   })
	     *   .first()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor is
	     * bound to `thisArg` and invoked with one argument; (value). The purpose of
	     * this method is to "tap into" a method chain in order to perform operations
	     * on intermediate results within the chain.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor, thisArg) {
	      interceptor.call(thisArg, value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor, thisArg) {
	      return interceptor.call(thisArg, value);
	    }
	
	    /**
	     * Enables explicit method chaining on the wrapper object.
	     *
	     * @name chain
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // without explicit chaining
	     * _(users).first();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // with explicit chaining
	     * _(users).chain()
	     *   .first()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chained sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Creates a new array joining a wrapped array with any additional arrays
	     * and/or values.
	     *
	     * @name concat
	     * @memberOf _
	     * @category Chain
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var wrapped = _(array).concat(2, [3], [[4]]);
	     *
	     * console.log(wrapped.value());
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    var wrapperConcat = restParam(function(values) {
	      values = baseFlatten(values);
	      return this.thru(function(array) {
	        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
	      });
	    });
	
	    /**
	     * Creates a clone of the chained sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).map(function(value) {
	     *   return Math.pow(value, 2);
	     * });
	     *
	     * var other = [3, 4];
	     * var otherWrapped = wrapped.plant(other);
	     *
	     * otherWrapped.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * Reverses the wrapped array so the first element becomes the last, the
	     * second element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	
	      var interceptor = function(value) {
	        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
	      };
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(interceptor);
	    }
	
	    /**
	     * Produces the result of coercing the unwrapped value to a string.
	     *
	     * @name toString
	     * @memberOf _
	     * @category Chain
	     * @returns {string} Returns the coerced string value.
	     * @example
	     *
	     * _([1, 2, 3]).toString();
	     * // => '1,2,3'
	     */
	    function wrapperToString() {
	      return (this.value() + '');
	    }
	
	    /**
	     * Executes the chained sequence to extract the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @alias run, toJSON, valueOf
	     * @category Chain
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements corresponding to the given keys, or indexes,
	     * of `collection`. Keys may be specified as individual arguments or as arrays
	     * of keys.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(number|number[]|string|string[])} [props] The property names
	     *  or indexes of elements to pick, specified individually or in arrays.
	     * @returns {Array} Returns the new array of picked elements.
	     * @example
	     *
	     * _.at(['a', 'b', 'c'], [0, 2]);
	     * // => ['a', 'c']
	     *
	     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
	     * // => ['barney', 'pebbles']
	     */
	    var at = restParam(function(collection, props) {
	      return baseAt(collection, baseFlatten(props));
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the number of times the key was returned by `iteratee`.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * The predicate is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias all
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': false },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.every(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias select
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.filter([4, 5, 6], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 6]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.filter(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.filter(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function filter(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias detect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.result(_.find(users, function(chr) {
	     *   return chr.age < 40;
	     * }), 'user');
	     * // => 'barney'
	     *
	     * // using the `_.matches` callback shorthand
	     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.result(_.find(users, 'active', false), 'user');
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.result(_.find(users, 'active'), 'user');
	     * // => 'barney'
	     */
	    var find = createFind(baseEach);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(baseEachRight, true);
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning the first element that has equivalent property
	     * values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
	     * // => 'barney'
	     *
	     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
	     * // => 'fred'
	     */
	    function findWhere(collection, source) {
	      return find(collection, baseMatches(source));
	    }
	
	    /**
	     * Iterates over elements of `collection` invoking `iteratee` for each element.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection). Iteratee functions may exit iteration early
	     * by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length" property
	     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
	     * may be used for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @alias each
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEach(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from left to right and returns the array
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
	     *   console.log(n, key);
	     * });
	     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
	     */
	    var forEach = createForEach(arrayEach, baseEach);
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEachRight(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from right to left and returns the array
	     */
	    var forEachRight = createForEach(arrayEachRight, baseEachRight);
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is an array of the elements responsible for generating the key.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * // using the `_.property` callback shorthand
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @alias contains, include
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {*} target The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	     * // => true
	     *
	     * _.includes('pebbles', 'eb');
	     * // => true
	     */
	    function includes(collection, target, fromIndex, guard) {
	      var length = collection ? getLength(collection) : 0;
	      if (!isLength(length)) {
	        collection = values(collection);
	        length = collection.length;
	      }
	      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
	        fromIndex = 0;
	      } else {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
	      }
	      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
	        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
	        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the last element responsible for generating the key. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var keyData = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.indexBy(keyData, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return String.fromCharCode(object.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return this.fromCharCode(object.code);
	     * }, String);
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     */
	    var indexBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `methodName` is a function it is
	     * invoked for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invoke([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invoke = restParam(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` through
	     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
	     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
	     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
	     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
	     * `sum`, `uniq`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @alias collect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function timesThree(n) {
	     *   return n * 3;
	     * }
	     *
	     * _.map([1, 2], timesThree);
	     * // => [3, 6]
	     *
	     * _.map({ 'a': 1, 'b': 2 }, timesThree);
	     * // => [3, 6] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee, thisArg) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return func(collection, iteratee);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, while the second of which
	     * contains elements `predicate` returns falsey for. The predicate is bound
	     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * _.partition([1, 2, 3], function(n) {
	     *   return n % 2;
	     * });
	     * // => [[1, 3], [2]]
	     *
	     * _.partition([1.2, 2.3, 3.4], function(n) {
	     *   return this.floor(n) % 2;
	     * }, Math);
	     * // => [[1.2, 3.4], [2.3]]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * var mapper = function(array) {
	     *   return _.pluck(array, 'user');
	     * };
	     *
	     * // using the `_.matches` callback shorthand
	     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
	     * // => [['pebbles'], ['barney', 'fred']]
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.map(_.partition(users, 'active', false), mapper);
	     * // => [['barney', 'pebbles'], ['fred']]
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(_.partition(users, 'active'), mapper);
	     * // => [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Gets the property value of `path` from all elements in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|string} path The path of the property to pluck.
	     * @returns {Array} Returns the property values.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.pluck(users, 'user');
	     * // => ['barney', 'fred']
	     *
	     * var userIndex = _.indexBy(users, 'user');
	     * _.pluck(userIndex, 'age');
	     * // => [36, 40] (iteration order is not guaranteed)
	     */
	    function pluck(collection, path) {
	      return map(collection, property(path));
	    }
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` through `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not provided the first element of `collection` is used as the initial
	     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
	     * and `sortByOrder`
	     *
	     * @static
	     * @memberOf _
	     * @alias foldl, inject
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.reduce([1, 2], function(total, n) {
	     *   return total + n;
	     * });
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     *   return result;
	     * }, {});
	     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
	     */
	    var reduce = createReduce(arrayReduce, baseEach);
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias foldr
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    var reduceRight = createReduce(arrayReduceRight, baseEachRight);
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.reject([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [1, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.reject(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.reject(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function reject(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, function(value, index, collection) {
	        return !predicate(value, index, collection);
	      });
	    }
	
	    /**
	     * Gets a random element or `n` random elements from a collection.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to sample.
	     * @param {number} [n] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {*} Returns the random sample(s).
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     *
	     * _.sample([1, 2, 3, 4], 2);
	     * // => [3, 1]
	     */
	    function sample(collection, n, guard) {
	      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
	        collection = toIterable(collection);
	        var length = collection.length;
	        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
	      }
	      var index = -1,
	          result = toArray(collection),
	          length = result.length,
	          lastIndex = length - 1;
	
	      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
	      while (++index < n) {
	        var rand = baseRandom(index, lastIndex),
	            value = result[rand];
	
	        result[rand] = result[index];
	        result[index] = value;
	      }
	      result.length = n;
	      return result;
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      return sample(collection, POSITIVE_INFINITY);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the size of `collection`.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      var length = collection ? getLength(collection) : 0;
	      return isLength(length) ? length : keys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * The function returns as soon as it finds a passing value and does not iterate
	     * over the entire collection. The predicate is bound to `thisArg` and invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias any
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.some(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection through `iteratee`. This method performs
	     * a stable sort, that is, it preserves the original sort order of equal elements.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return Math.sin(n);
	     * });
	     * // => [3, 1, 2]
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return this.sin(n);
	     * }, Math);
	     * // => [3, 1, 2]
	     *
	     * var users = [
	     *   { 'user': 'fred' },
	     *   { 'user': 'pebbles' },
	     *   { 'user': 'barney' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.sortBy(users, 'user'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function sortBy(collection, iteratee, thisArg) {
	      if (collection == null) {
	        return [];
	      }
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      var index = -1;
	      iteratee = getCallback(iteratee, thisArg, 3);
	
	      var result = baseMap(collection, function(value, key, collection) {
	        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
	      });
	      return baseSortBy(result, compareAscending);
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it can sort by multiple iteratees
	     * or property names.
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
	     *  The iteratees to sort by, specified as individual values or arrays of values.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
	     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
	     *
	     * _.map(_.sortByAll(users, 'user', function(chr) {
	     *   return Math.floor(chr.age / 10);
	     * }), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    var sortByAll = restParam(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var guard = iteratees[2];
	      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
	        iteratees.length = 1;
	      }
	      return baseSortByOrder(collection, baseFlatten(iteratees), []);
	    });
	
	    /**
	     * This method is like `_.sortByAll` except that it allows specifying the
	     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
	     * values are sorted in ascending order. Otherwise, a value is sorted in
	     * ascending order if its corresponding order is "asc", and descending if "desc".
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // sort by `user` in ascending order and by `age` in descending order
	     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    function sortByOrder(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (guard && isIterateeCall(iteratees, orders, guard)) {
	        orders = undefined;
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseSortByOrder(collection, iteratees, orders);
	    }
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning an array of all elements that have equivalent
	     * property values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
	     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
	     * ];
	     *
	     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
	     * // => ['fred']
	     */
	    function where(collection, source) {
	      return filter(collection, baseMatches(source));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the number of milliseconds that have elapsed since the Unix epoch
	     * (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @category Date
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => logs the number of milliseconds it took for the deferred function to be invoked
	     */
	    var now = nativeNow || function() {
	      return new Date().getTime();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it is called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => logs 'done saving!' after the two async saves have completed
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      n = nativeIsFinite(n = +n) ? n : 0;
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that accepts up to `n` arguments ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      if (guard && isIterateeCall(func, n, guard)) {
	        n = undefined;
	      }
	      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
	      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it is called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery('#add').on('click', _.before(5, addContactToList));
	     * // => allows adding up to 4 contacts to the list
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and prepends any additional `_.bind` arguments to those provided to the
	     * bound function.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind` this method does not set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var greet = function(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * };
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // using placeholders
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = restParam(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bind.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method. Method names may be specified as individual arguments or as arrays
	     * of method names. If no method names are provided all enumerable function
	     * properties, own and inherited, of `object` are bound.
	     *
	     * **Note:** This method does not set the "length" property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} [methodNames] The object method names to bind,
	     *  specified as individual method names or arrays of method names.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'onClick': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view);
	     * jQuery('#docs').on('click', view.onClick);
	     * // => logs 'clicked docs' when the element is clicked
	     */
	    var bindAll = restParam(function(object, methodNames) {
	      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);
	
	      var index = -1,
	          length = methodNames.length;
	
	      while (++index < length) {
	        var key = methodNames[index];
	        object[key] = createWrapper(object[key], BIND_FLAG, object);
	      }
	      return object;
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` and prepends
	     * any additional `_.bindKey` arguments to those provided to the bound function.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist.
	     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object the method belongs to.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // using placeholders
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = restParam(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bindKey.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts one or more arguments of `func` that when
	     * called either invokes `func` returning its result, if all `func` arguments
	     * have been provided, or returns a function that accepts one or more of the
	     * remaining `func` arguments, and so on. The arity of `func` may be specified
	     * if `func.length` is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    var curry = createCurry(CURRY_FLAG);
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    var curryRight = createCurry(CURRY_RIGHT_FLAG);
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed invocations. Provide an options object to indicate that `func`
	     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
	     * Subsequent calls to the debounced function return the result of the last
	     * `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the debounced function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=false] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	     *  delayed before it is invoked.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // avoid costly calculations while the window size is in flux
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
	     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // ensure `batchLog` is invoked once after 1 second of debounced calls
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', _.debounce(batchLog, 250, {
	     *   'maxWait': 1000
	     * }));
	     *
	     * // cancel a debounced call
	     * var todoChanges = _.debounce(batchLog, 1000);
	     * Object.observe(models.todo, todoChanges);
	     *
	     * Object.observe(models, function(changes) {
	     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
	     *     todoChanges.cancel();
	     *   }
	     * }, ['delete']);
	     *
	     * // ...at some point `models.todo` is changed
	     * models.todo.completed = true;
	     *
	     * // ...before 1 second has passed `models.todo` is deleted
	     * // which cancels the debounced `todoChanges` call
	     * delete models.todo;
	     */
	    function debounce(func, wait, options) {
	      var args,
	          maxTimeoutId,
	          result,
	          stamp,
	          thisArg,
	          timeoutId,
	          trailingCall,
	          lastCalled = 0,
	          maxWait = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = wait < 0 ? 0 : (+wait || 0);
	      if (options === true) {
	        var leading = true;
	        trailing = false;
	      } else if (isObject(options)) {
	        leading = !!options.leading;
	        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function cancel() {
	        if (timeoutId) {
	          clearTimeout(timeoutId);
	        }
	        if (maxTimeoutId) {
	          clearTimeout(maxTimeoutId);
	        }
	        lastCalled = 0;
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	      }
	
	      function complete(isCalled, id) {
	        if (id) {
	          clearTimeout(id);
	        }
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	        if (isCalled) {
	          lastCalled = now();
	          result = func.apply(thisArg, args);
	          if (!timeoutId && !maxTimeoutId) {
	            args = thisArg = undefined;
	          }
	        }
	      }
	
	      function delayed() {
	        var remaining = wait - (now() - stamp);
	        if (remaining <= 0 || remaining > wait) {
	          complete(trailingCall, maxTimeoutId);
	        } else {
	          timeoutId = setTimeout(delayed, remaining);
	        }
	      }
	
	      function maxDelayed() {
	        complete(trailing, timeoutId);
	      }
	
	      function debounced() {
	        args = arguments;
	        stamp = now();
	        thisArg = this;
	        trailingCall = trailing && (timeoutId || !leading);
	
	        if (maxWait === false) {
	          var leadingCall = leading && !timeoutId;
	        } else {
	          if (!maxTimeoutId && !leading) {
	            lastCalled = stamp;
	          }
	          var remaining = maxWait - (stamp - lastCalled),
	              isCalled = remaining <= 0 || remaining > maxWait;
	
	          if (isCalled) {
	            if (maxTimeoutId) {
	              maxTimeoutId = clearTimeout(maxTimeoutId);
	            }
	            lastCalled = stamp;
	            result = func.apply(thisArg, args);
	          }
	          else if (!maxTimeoutId) {
	            maxTimeoutId = setTimeout(maxDelayed, remaining);
	          }
	        }
	        if (isCalled && timeoutId) {
	          timeoutId = clearTimeout(timeoutId);
	        }
	        else if (!timeoutId && wait !== maxWait) {
	          timeoutId = setTimeout(delayed, wait);
	        }
	        if (leadingCall) {
	          isCalled = true;
	          result = func.apply(thisArg, args);
	        }
	        if (isCalled && !timeoutId && !maxTimeoutId) {
	          args = thisArg = undefined;
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // logs 'deferred' after one or more milliseconds
	     */
	    var defer = restParam(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => logs 'later' after one second
	     */
	    var delay = restParam(function(func, wait, args) {
	      return baseDelay(func, wait, args);
	    });
	
	    /**
	     * Creates a function that returns the result of invoking the provided
	     * functions with the `this` binding of the created function, where each
	     * successive invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow(_.add, square);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the provided functions from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias backflow, compose
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight(square, _.add);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is coerced to a string and used as the
	     * cache key. The `func` is invoked with the `this` binding of the memoized
	     * function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoizing function.
	     * @example
	     *
	     * var upperCase = _.memoize(function(string) {
	     *   return string.toUpperCase();
	     * });
	     *
	     * upperCase('fred');
	     * // => 'FRED'
	     *
	     * // modifying the result cache
	     * upperCase.cache.set('fred', 'BARNEY');
	     * upperCase('fred');
	     * // => 'BARNEY'
	     *
	     * // replacing `_.memoize.Cache`
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'barney' };
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'fred' }
	     *
	     * _.memoize.Cache = WeakMap;
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'barney' }
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new memoize.Cache;
	      return memoized;
	    }
	
	    /**
	     * Creates a function that runs each argument through a corresponding
	     * transform function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms] The functions to transform
	     * arguments, specified as individual functions or arrays of functions.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var modded = _.modArgs(function(x, y) {
	     *   return [x, y];
	     * }, square, doubled);
	     *
	     * modded(1, 2);
	     * // => [1, 4]
	     *
	     * modded(5, 10);
	     * // => [25, 20]
	     */
	    var modArgs = restParam(function(func, transforms) {
	      transforms = baseFlatten(transforms);
	      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = transforms.length;
	      return restParam(function(args) {
	        var index = nativeMin(args.length, length);
	        while (index--) {
	          args[index] = transforms[index](args[index]);
	        }
	        return func.apply(this, args);
	      });
	    });
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        return !predicate.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first call. The `func` is invoked
	     * with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // `initialize` invokes `createApplication` once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with `partial` arguments prepended
	     * to those provided to the new function. This method is like `_.bind` except
	     * it does **not** alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // using placeholders
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = createPartial(PARTIAL_FLAG);
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to those provided to the new function.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // using placeholders
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified indexes where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, 2, 0, 1);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     *
	     * var map = _.rearg(_.map, [1, 0]);
	     * map(function(n) {
	     *   return n * 3;
	     * }, [1, 2, 3]);
	     * // => [3, 6, 9]
	     */
	    var rearg = restParam(function(func, indexes) {
	      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as an array.
	     *
	     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.restParam(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function restParam(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            rest = Array(length);
	
	        while (++index < length) {
	          rest[index] = args[start + index];
	        }
	        switch (start) {
	          case 0: return func.call(this, rest);
	          case 1: return func.call(this, args[0], rest);
	          case 2: return func.call(this, args[0], args[1], rest);
	        }
	        var otherArgs = Array(start + 1);
	        index = -1;
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = rest;
	        return func.apply(this, otherArgs);
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the created
	     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
	     *
	     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * // with a Promise
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function(array) {
	        return func.apply(this, array);
	      };
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed invocations. Provide an options object to indicate
	     * that `func` should be invoked on the leading and/or trailing edge of the
	     * `wait` timeout. Subsequent calls to the throttled function return the
	     * result of the last `func` call.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the throttled function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=true] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // avoid excessively updating the position while scrolling
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
	     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
	     *   'trailing': false
	     * }));
	     *
	     * // cancel a trailing throttled call
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (options === false) {
	        leading = false;
	      } else if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
	    }
	
	    /**
	     * Creates a function that provides `value` to the wrapper function as its
	     * first argument. Any additional arguments provided to the function are
	     * appended to those provided to the wrapper function. The wrapper is invoked
	     * with the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} wrapper The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
	     * otherwise they are assigned by reference. If `customizer` is provided it is
	     * invoked to produce the cloned values. If `customizer` returns `undefined`
	     * cloning is handled by the method instead. The `customizer` is bound to
	     * `thisArg` and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var shallow = _.clone(users);
	     * shallow[0] === users[0];
	     * // => true
	     *
	     * var deep = _.clone(users, true);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.clone(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 0
	     */
	    function clone(value, isDeep, customizer, thisArg) {
	      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
	        isDeep = false;
	      }
	      else if (typeof isDeep == 'function') {
	        thisArg = customizer;
	        customizer = isDeep;
	        isDeep = false;
	      }
	      return typeof customizer == 'function'
	        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, isDeep);
	    }
	
	    /**
	     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
	     * to produce the cloned values. If `customizer` returns `undefined` cloning
	     * is handled by the method instead. The `customizer` is bound to `thisArg`
	     * and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the deep cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var deep = _.cloneDeep(users);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.cloneDeep(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 20
	     */
	    function cloneDeep(value, customizer, thisArg) {
	      return typeof customizer == 'function'
	        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, true);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    function gt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    function gte(value, other) {
	      return value >= other;
	    }
	
	    /**
	     * Checks if `value` is classified as an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      return isObjectLike(value) && isArrayLike(value) &&
	        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	    }
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(function() { return arguments; }());
	     * // => false
	     */
	    var isArray = nativeIsArray || function(value) {
	      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	    };
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    function isDate(value) {
	      return isObjectLike(value) && objToString.call(value) == dateTag;
	    }
	
	    /**
	     * Checks if `value` is a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is empty. A value is considered empty unless it is an
	     * `arguments` object, array, string, or jQuery-like collection with a length
	     * greater than `0` or an object with own enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Array|Object|string} value The value to inspect.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
	          (isObjectLike(value) && isFunction(value.splice)))) {
	        return !value.length;
	      }
	      return !keys(value).length;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent. If `customizer` is provided it is invoked to compare values.
	     * If `customizer` returns `undefined` comparisons are handled by the method
	     * instead. The `customizer` is bound to `thisArg` and invoked with three
	     * arguments: (value, other [, index|key]).
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. Functions and DOM nodes
	     * are **not** supported. Provide a customizer function to extend support
	     * for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @alias eq
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * object == other;
	     * // => false
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * // using a customizer callback
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqual(array, other, function(value, other) {
	     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
	     *     return true;
	     *   }
	     * });
	     * // => true
	     */
	    function isEqual(value, other, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(10);
	     * // => true
	     *
	     * _.isFinite('10');
	     * // => false
	     *
	     * _.isFinite(true);
	     * // => false
	     *
	     * _.isFinite(Object(10));
	     * // => false
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in older versions of Chrome and Safari which return 'function' for regexes
	      // and Safari 8 equivalents which return 'object' for typed array constructors.
	      return isObject(value) && objToString.call(value) == funcTag;
	    }
	
	    /**
	     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(1);
	     * // => false
	     */
	    function isObject(value) {
	      // Avoid a V8 JIT bug in Chrome 19-20.
	      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Performs a deep comparison between `object` and `source` to determine if
	     * `object` contains equivalent property values. If `customizer` is provided
	     * it is invoked to compare values. If `customizer` returns `undefined`
	     * comparisons are handled by the method instead. The `customizer` is bound
	     * to `thisArg` and invoked with three arguments: (value, other, index|key).
	     *
	     * **Note:** This method supports comparing properties of arrays, booleans,
	     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
	     * and DOM nodes are **not** supported. Provide a customizer function to extend
	     * support for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.isMatch(object, { 'age': 40 });
	     * // => true
	     *
	     * _.isMatch(object, { 'age': 36 });
	     * // => false
	     *
	     * // using a customizer callback
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatch(object, source, function(value, other) {
	     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
	     * });
	     * // => true
	     */
	    function isMatch(object, source, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      return baseIsMatch(object, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
	     * which returns `true` for `undefined` and other non-numeric values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a native function.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (value == null) {
	        return false;
	      }
	      if (isFunction(value)) {
	        return reIsNative.test(fnToString.call(value));
	      }
	      return isObjectLike(value) && reIsHostCtor.test(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	     * as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isNumber(8.4);
	     * // => true
	     *
	     * _.isNumber(NaN);
	     * // => true
	     *
	     * _.isNumber('8.4');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * **Note:** This method assumes objects created by the `Object` constructor
	     * have no inherited enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      var Ctor;
	
	      // Exit early for non `Object` objects.
	      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	        return false;
	      }
	      // IE < 9 iterates inherited properties before own properties. If the first
	      // iterated property is an object's own property then there are no inherited
	      // enumerable properties.
	      var result;
	      // In most environments an object's own properties are iterated before
	      // its inherited properties. If the last iterated property is an object's
	      // own property then there are no inherited enumerable properties.
	      baseForIn(value, function(subValue, key) {
	        result = key;
	      });
	      return result === undefined || hasOwnProperty.call(value, result);
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    function isRegExp(value) {
	      return isObject(value) && objToString.call(value) == regexpTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    function isTypedArray(value) {
	      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	    }
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    function lt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    function lte(value, other) {
	      return value <= other;
	    }
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * (function() {
	     *   return _.toArray(arguments).slice(1);
	     * }(1, 2, 3));
	     * // => [2, 3]
	     */
	    function toArray(value) {
	      var length = value ? getLength(value) : 0;
	      if (!isLength(length)) {
	        return values(value);
	      }
	      if (!length) {
	        return [];
	      }
	      return arrayCopy(value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable
	     * properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return baseCopy(value, keysIn(value));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Recursively merges own enumerable properties of the source object(s), that
	     * don't resolve to `undefined` into the destination object. Subsequent sources
	     * overwrite property assignments of previous sources. If `customizer` is
	     * provided it is invoked to produce the merged values of the destination and
	     * source properties. If `customizer` returns `undefined` merging is handled
	     * by the method instead. The `customizer` is bound to `thisArg` and invoked
	     * with five arguments: (objectValue, sourceValue, key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var users = {
	     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	     * };
	     *
	     * var ages = {
	     *   'data': [{ 'age': 36 }, { 'age': 40 }]
	     * };
	     *
	     * _.merge(users, ages);
	     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	     *
	     * // using a customizer callback
	     * var object = {
	     *   'fruits': ['apple'],
	     *   'vegetables': ['beet']
	     * };
	     *
	     * var other = {
	     *   'fruits': ['banana'],
	     *   'vegetables': ['carrot']
	     * };
	     *
	     * _.merge(object, other, function(a, b) {
	     *   if (_.isArray(a)) {
	     *     return a.concat(b);
	     *   }
	     * });
	     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	     */
	    var merge = createAssigner(baseMerge);
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object. Subsequent sources overwrite property assignments of previous sources.
	     * If `customizer` is provided it is invoked to produce the assigned values.
	     * The `customizer` is bound to `thisArg` and invoked with five arguments:
	     * (objectValue, sourceValue, key, object, source).
	     *
	     * **Note:** This method mutates `object` and is based on
	     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
	     *
	     * @static
	     * @memberOf _
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using a customizer callback
	     * var defaults = _.partialRight(_.assign, function(value, other) {
	     *   return _.isUndefined(value) ? other : value;
	     * });
	     *
	     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var assign = createAssigner(function(object, source, customizer) {
	      return customizer
	        ? assignWith(object, source, customizer)
	        : baseAssign(object, source);
	    });
	
	    /**
	     * Creates an object that inherits from the given `prototype` object. If a
	     * `properties` object is provided its own enumerable properties are assigned
	     * to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties, guard) {
	      var result = baseCreate(prototype);
	      if (guard && isIterateeCall(prototype, properties, guard)) {
	        properties = undefined;
	      }
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object for all destination properties that resolve to `undefined`. Once a
	     * property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var defaults = createDefaults(assign, assignDefaults);
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
	     * // => { 'user': { 'name': 'barney', 'age': 36 } }
	     *
	     */
	    var defaultsDeep = createDefaults(merge, mergeDefaults);
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    var findKey = createFindKey(baseForOwn);
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => returns `pebbles` assuming `_.findKey` returns `barney`
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    var findLastKey = createFindKey(baseForOwnRight);
	
	    /**
	     * Iterates over own and inherited enumerable properties of an object invoking
	     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
	     */
	    var forIn = createForIn(baseFor);
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
	     */
	    var forInRight = createForIn(baseForRight);
	
	    /**
	     * Iterates over own enumerable properties of an object invoking `iteratee`
	     * for each property. The `iteratee` is bound to `thisArg` and invoked with
	     * three arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a' and 'b' (iteration order is not guaranteed)
	     */
	    var forOwn = createForOwn(baseForOwn);
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
	     */
	    var forOwnRight = createForOwn(baseForOwnRight);
	
	    /**
	     * Creates an array of function property names from all enumerable properties,
	     * own and inherited, of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @alias methods
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the new array of property names.
	     * @example
	     *
	     * _.functions(_);
	     * // => ['after', 'ary', 'assign', ...]
	     */
	    function functions(object) {
	      return baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the property value at `path` of `object`. If the resolved value is
	     * `undefined` the `defaultValue` is used in its place.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': { 'c': 3 } } };
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b.c');
	     * // => true
	     *
	     * _.has(object, ['a', 'b', 'c']);
	     * // => true
	     */
	    function has(object, path) {
	      if (object == null) {
	        return false;
	      }
	      var result = hasOwnProperty.call(object, path);
	      if (!result && !isKey(path)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        if (object == null) {
	          return false;
	        }
	        path = last(path);
	        result = hasOwnProperty.call(object, path);
	      }
	      return result || (isLength(object.length) && isIndex(path, object.length) &&
	        (isArray(object) || isArguments(object)));
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite property
	     * assignments of previous values unless `multiValue` is `true`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {boolean} [multiValue] Allow multiple values per key.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     *
	     * // with `multiValue`
	     * _.invert(object, true);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function invert(object, multiValue, guard) {
	      if (guard && isIterateeCall(object, multiValue, guard)) {
	        multiValue = undefined;
	      }
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key];
	
	        if (multiValue) {
	          if (hasOwnProperty.call(result, value)) {
	            result[value].push(key);
	          } else {
	            result[value] = [key];
	          }
	        }
	        else {
	          result[value] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    var keys = !nativeKeys ? shimKeys : function(object) {
	      var Ctor = object == null ? undefined : object.constructor;
	      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	          (typeof object != 'function' && isArrayLike(object))) {
	        return shimKeys(object);
	      }
	      return isObject(object) ? nativeKeys(object) : [];
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      if (object == null) {
	        return [];
	      }
	      if (!isObject(object)) {
	        object = Object(object);
	      }
	      var length = object.length;
	      length = (length && isLength(length) &&
	        (isArray(object) || isArguments(object)) && length) || 0;
	
	      var Ctor = object.constructor,
	          index = -1,
	          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	          result = Array(length),
	          skipIndexes = length > 0;
	
	      while (++index < length) {
	        result[index] = (index + '');
	      }
	      for (var key in object) {
	        if (!(skipIndexes && isIndex(key, length)) &&
	            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * property of `object` through `iteratee`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    var mapKeys = createObjectMapper(true);
	
	    /**
	     * Creates an object with the same keys as `object` and values generated by
	     * running each own enumerable property of `object` through `iteratee`. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, key, object).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
	     *   return n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * // using the `_.property` callback shorthand
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    var mapValues = createObjectMapper();
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable properties of `object` that are not omitted.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to omit, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.omit(object, 'age');
	     * // => { 'user': 'fred' }
	     *
	     * _.omit(object, _.isNumber);
	     * // => { 'user': 'fred' }
	     */
	    var omit = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      if (typeof props[0] != 'function') {
	        var props = arrayMap(baseFlatten(props), String);
	        return pickByArray(object, baseDifference(keysIn(object), props));
	      }
	      var predicate = bindCallback(props[0], props[1], 3);
	      return pickByCallback(object, function(value, key, object) {
	        return !predicate(value, key, object);
	      });
	    });
	
	    /**
	     * Creates a two dimensional array of the key-value pairs for `object`,
	     * e.g. `[[key1, value1], [key2, value2]]`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the new array of key-value pairs.
	     * @example
	     *
	     * _.pairs({ 'barney': 36, 'fred': 40 });
	     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	     */
	    function pairs(object) {
	      object = toObject(object);
	
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        var key = props[index];
	        result[index] = [key, object[key]];
	      }
	      return result;
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties. Property
	     * names may be specified as individual arguments or as arrays of property
	     * names. If `predicate` is provided it is invoked for each property of `object`
	     * picking the properties `predicate` returns truthy for. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to pick, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.pick(object, 'user');
	     * // => { 'user': 'fred' }
	     *
	     * _.pick(object, _.isString);
	     * // => { 'user': 'fred' }
	     */
	    var pick = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      return typeof props[0] == 'function'
	        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
	        : pickByArray(object, baseFlatten(props));
	    });
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a function
	     * it is invoked with the `this` binding of its parent object and its result
	     * is returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a.b.c', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a.b.c', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      var result = object == null ? undefined : object[path];
	      if (result === undefined) {
	        if (object != null && !isKey(path, object)) {
	          path = toPath(path);
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          result = object == null ? undefined : object[last(path)];
	        }
	        result = result === undefined ? defaultValue : result;
	      }
	      return isFunction(result) ? result.call(object) : result;
	    }
	
	    /**
	     * Sets the property value of `path` on `object`. If a portion of `path`
	     * does not exist it is created.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to augment.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, 'x[0].y.z', 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      if (object == null) {
	        return object;
	      }
	      var pathKey = (path + '');
	      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = path[index];
	        if (isObject(nested)) {
	          if (index == lastIndex) {
	            nested[key] = value;
	          } else if (nested[key] == null) {
	            nested[key] = isIndex(path[index + 1]) ? [] : {};
	          }
	        }
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own enumerable
	     * properties through `iteratee`, with each invocation potentially mutating
	     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
	     * with four arguments: (accumulator, value, key, object). Iteratee functions
	     * may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Array|Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     */
	    function transform(object, iteratee, accumulator, thisArg) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getCallback(iteratee, thisArg, 4);
	
	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Creates an array of the own enumerable property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property values
	     * of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Checks if `n` is between `start` and up to but not including, `end`. If
	     * `end` is not specified it is set to `start` with `start` then set to `0`.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} n The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     */
	    function inRange(value, start, end) {
	      start = +start || 0;
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      return value >= nativeMin(start, end) && value < nativeMax(start, end);
	    }
	
	    /**
	     * Produces a random number between `min` and `max` (inclusive). If only one
	     * argument is provided a number between `0` and the given number is returned.
	     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
	     * number is returned instead of an integer.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} [min=0] The minimum possible value.
	     * @param {number} [max=1] The maximum possible value.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(min, max, floating) {
	      if (floating && isIterateeCall(min, max, floating)) {
	        max = floating = undefined;
	      }
	      var noMin = min == null,
	          noMax = max == null;
	
	      if (floating == null) {
	        if (noMax && typeof min == 'boolean') {
	          floating = min;
	          min = 1;
	        }
	        else if (typeof max == 'boolean') {
	          floating = max;
	          noMax = true;
	        }
	      }
	      if (noMin && noMax) {
	        max = 1;
	        noMax = false;
	      }
	      min = +min || 0;
	      if (noMax) {
	        max = min;
	        min = 0;
	      } else {
	        max = +max || 0;
	      }
	      if (floating || min % 1 || max % 1) {
	        var rand = nativeRandom();
	        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
	      }
	      return baseRandom(min, max);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__foo_bar__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
	    });
	
	    /**
	     * Capitalizes the first character of `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('fred');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      string = baseToString(string);
	      return string && (string.charAt(0).toUpperCase() + string.slice(1));
	    }
	
	    /**
	     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = baseToString(string);
	      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search from.
	     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = baseToString(string);
	      target = (target + '');
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : nativeMin(position < 0 ? 0 : (+position || 0), length);
	
	      position -= target.length;
	      return position >= 0 && string.indexOf(target, position) == position;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional characters
	     * use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value.
	     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in Internet Explorer < 9, they can break out
	     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
	     * for more details.
	     *
	     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
	     * to reduce XSS vectors.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
	      string = baseToString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
	     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
	     */
	    function escapeRegExp(string) {
	      string = baseToString(string);
	      return (string && reHasRegExpChars.test(string))
	        ? string.replace(reRegExpChars, escapeRegExpChar)
	        : (string || '(?:)');
	    }
	
	    /**
	     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__foo_bar__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = baseToString(string);
	      length = +length;
	
	      var strLength = string.length;
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return string;
	      }
	      var mid = (length - strLength) / 2,
	          leftLength = nativeFloor(mid),
	          rightLength = nativeCeil(mid);
	
	      chars = createPadding('', rightLength, chars);
	      return chars.slice(0, leftLength) + string + chars;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padLeft('abc', 6);
	     * // => '   abc'
	     *
	     * _.padLeft('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padLeft('abc', 3);
	     * // => 'abc'
	     */
	    var padLeft = createPadDir();
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padRight('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padRight('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padRight('abc', 3);
	     * // => 'abc'
	     */
	    var padRight = createPadDir(true);
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
	     * in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
	     * of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
	      // Chrome fails to trim leading <BOM> whitespace characters.
	      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
	      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      string = trim(string);
	      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=0] The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n) {
	      var result = '';
	      string = baseToString(string);
	      n = +n;
	      if (n < 1 || !string || !nativeIsFinite(n)) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        string += string;
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--foo-bar');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__foo_bar__');
	     * // => 'Foo Bar'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = baseToString(string);
	      position = position == null
	        ? 0
	        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);
	
	      return string.lastIndexOf(target, position) == position;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is provided it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options] The options object.
	     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
	     * @param {Object} [options.imports] An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
	     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
	     * @param {string} [options.variable] The data object variable name.
	     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // using the "interpolate" delimiter to create a compiled template
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // using the HTML "escape" delimiter to escape data property values
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the internal `print` function in "evaluate" delimiters
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // using custom template delimiters
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // using backslashes to treat delimiters as plain text
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // using the `imports` option to import `jQuery` as `jq`
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the `sourceURL` option to specify a custom sourceURL for the template
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
	     *
	     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // using the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and a stack trace
	     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, otherOptions) {
	      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
	        options = otherOptions = undefined;
	      }
	      string = baseToString(string);
	      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);
	
	      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products requires returning the `match`
	        // string in order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
	      }
	      chars = (chars + '');
	      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimLeft('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimLeft('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimLeft(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string));
	      }
	      return string.slice(charsLeftIndex(string, (chars + '')));
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimRight('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimRight('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimRight(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(0, trimmedRightIndex(string) + 1);
	      }
	      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object|number} [options] The options object or maximum string length.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.trunc('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', 24);
	     * // => 'hi-diddly-ho there, n...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function trunc(string, options, guard) {
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (options != null) {
	        if (isObject(options)) {
	          var separator = 'separator' in options ? options.separator : separator;
	          length = 'length' in options ? (+options.length || 0) : length;
	          omission = 'omission' in options ? baseToString(options.omission) : omission;
	        } else {
	          length = +options || 0;
	        }
	      }
	      string = baseToString(string);
	      if (length >= string.length) {
	        return string;
	      }
	      var end = length - omission.length;
	      if (end < 1) {
	        return omission;
	      }
	      var result = string.slice(0, end);
	      if (separator == null) {
	        return result + omission;
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              newEnd,
	              substring = string.slice(0, end);
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            newEnd = match.index;
	          }
	          result = result.slice(0, newEnd == null ? end : newEnd);
	        }
	      } else if (string.indexOf(separator, end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
	     * corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
	     * entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = baseToString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      if (guard && isIterateeCall(string, pattern, guard)) {
	        pattern = undefined;
	      }
	      string = baseToString(string);
	      return string.match(pattern || reWords) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function} func The function to attempt.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // avoid throwing errors for invalid selectors
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = restParam(function(func, args) {
	      try {
	        return func.apply(undefined, args);
	      } catch(e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and arguments of the created function. If `func` is a property name the
	     * created callback returns the property value for a given element. If `func`
	     * is an object the created callback returns `true` for elements that contain
	     * the equivalent object properties, otherwise it returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias iteratee
	     * @category Utility
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // wrap to create custom callback shorthands
	     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
	     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
	     *   if (!match) {
	     *     return callback(func, thisArg);
	     *   }
	     *   return function(object) {
	     *     return match[2] == 'gt'
	     *       ? object[match[1]] > match[3]
	     *       : object[match[1]] < match[3];
	     *   };
	     * });
	     *
	     * _.filter(users, 'age__gt36');
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function callback(func, thisArg, guard) {
	      if (guard && isIterateeCall(func, thisArg, guard)) {
	        thisArg = undefined;
	      }
	      return isObjectLike(func)
	        ? matches(func)
	        : baseCallback(func, thisArg);
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var getter = _.constant(object);
	     *
	     * getter() === object;
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * This method returns the first argument provided to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.identity(object) === object;
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that performs a deep comparison between a given object
	     * and `source`, returning `true` if the given object has equivalent property
	     * values, else `false`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that compares the property value of `path` on a given
	     * object to `value`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * _.find(users, _.matchesProperty('user', 'fred'));
	     * // => { 'user': 'fred' }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` on a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': _.constant(2) } } },
	     *   { 'a': { 'b': { 'c': _.constant(1) } } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    var method = restParam(function(path, args) {
	      return function(object) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path on `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = restParam(function(object, args) {
	      return function(path) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable function properties of a source object to the
	     * destination object. If `object` is a function then methods are added to
	     * its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.chain=true] Specify whether the functions added
	     *  are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      if (options == null) {
	        var isObj = isObject(source),
	            props = isObj ? keys(source) : undefined,
	            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;
	
	        if (!(methodNames ? methodNames.length : isObj)) {
	          methodNames = false;
	          options = source;
	          source = object;
	          object = this;
	        }
	      }
	      if (!methodNames) {
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = true,
	          index = -1,
	          isFunc = isFunction(object),
	          length = methodNames.length;
	
	      if (options === false) {
	        chain = false;
	      } else if (isObject(options) && 'chain' in options) {
	        chain = options.chain;
	      }
	      while (++index < length) {
	        var methodName = methodNames[index],
	            func = source[methodName];
	
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = (function(func) {
	            return function() {
	              var chainAll = this.__chain__;
	              if (chain || chainAll) {
	                var result = object(this.__wrapped__),
	                    actions = result.__actions__ = arrayCopy(this.__actions__);
	
	                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	                result.__chain__ = chainAll;
	                return result;
	              }
	              return func.apply(object, arrayPush([this.value()], arguments));
	            };
	          }(func));
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      root._ = oldDash;
	      return this;
	    }
	
	    /**
	     * A no-operation function that returns `undefined` regardless of the
	     * arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.noop(object) === undefined;
	     * // => true
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that returns the property value at `path` on a
	     * given object.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': 2 } } },
	     *   { 'a': { 'b': { 'c': 1 } } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the property value at a given path on `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return baseGet(object, toPath(path), path + '');
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. If `end` is not specified it is
	     * set to `start` with `start` then set to `0`. If `end` is less than `start`
	     * a zero-length range is created unless a negative `step` is specified.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the new array of numbers.
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    function range(start, end, step) {
	      if (step && isIterateeCall(start, end, step)) {
	        end = step = undefined;
	      }
	      start = +start || 0;
	      step = step == null ? 1 : (+step || 0);
	
	      if (end == null) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
	      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the iteratee function `n` times, returning an array of the results
	     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
	     * one argument; (index).
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
	     * // => [3, 6, 4]
	     *
	     * _.times(3, function(n) {
	     *   mage.castSpell(n);
	     * });
	     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
	     *
	     * _.times(3, function(n) {
	     *   this.cast(n);
	     * }, mage);
	     * // => also invokes `mage.castSpell(n)` three times
	     */
	    function times(n, iteratee, thisArg) {
	      n = nativeFloor(n);
	
	      // Exit early to avoid a JSC JIT bug in Safari 8
	      // where `Array(0)` is treated as `Array(1)`.
	      if (n < 1 || !nativeIsFinite(n)) {
	        return [];
	      }
	      var index = -1,
	          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));
	
	      iteratee = bindCallback(iteratee, thisArg, 1);
	      while (++index < n) {
	        if (index < MAX_ARRAY_LENGTH) {
	          result[index] = iteratee(index);
	        } else {
	          iteratee(index);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {string} [prefix] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return baseToString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} augend The first number to add.
	     * @param {number} addend The second number to add.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    function add(augend, addend) {
	      return (+augend || 0) + (+addend || 0);
	    }
	
	    /**
	     * Calculates `n` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Calculates `n` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Gets the maximum value of `collection`. If `collection` is empty or falsey
	     * `-Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => -Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.max(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.max(users, 'age');
	     * // => { 'user': 'fred', 'age': 40 }
	     */
	    var max = createExtremum(gt, NEGATIVE_INFINITY);
	
	    /**
	     * Gets the minimum value of `collection`. If `collection` is empty or falsey
	     * `Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.min(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.min(users, 'age');
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var min = createExtremum(lt, POSITIVE_INFINITY);
	
	    /**
	     * Calculates `n` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Gets the sum of the values in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 6]);
	     * // => 10
	     *
	     * _.sum({ 'a': 4, 'b': 6 });
	     * // => 10
	     *
	     * var objects = [
	     *   { 'n': 4 },
	     *   { 'n': 6 }
	     * ];
	     *
	     * _.sum(objects, function(object) {
	     *   return object.n;
	     * });
	     * // => 10
	     *
	     * // using the `_.property` callback shorthand
	     * _.sum(objects, 'n');
	     * // => 10
	     */
	    function sum(collection, iteratee, thisArg) {
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return iteratee.length == 1
	        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
	        : baseSum(collection, iteratee);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    // Add functions to the `Map` cache.
	    MapCache.prototype['delete'] = mapDelete;
	    MapCache.prototype.get = mapGet;
	    MapCache.prototype.has = mapHas;
	    MapCache.prototype.set = mapSet;
	
	    // Add functions to the `Set` cache.
	    SetCache.prototype.push = cachePush;
	
	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;
	
	    // Add functions that return wrapped values when chaining.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.callback = callback;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.functions = functions;
	    lodash.groupBy = groupBy;
	    lodash.indexBy = indexBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.invert = invert;
	    lodash.invoke = invoke;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.modArgs = modArgs;
	    lodash.negate = negate;
	    lodash.omit = omit;
	    lodash.once = once;
	    lodash.pairs = pairs;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pluck = pluck;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.restParam = restParam;
	    lodash.set = set;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortByAll = sortByAll;
	    lodash.sortByOrder = sortByOrder;
	    lodash.spread = spread;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.times = times;
	    lodash.toArray = toArray;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.union = union;
	    lodash.uniq = uniq;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.where = where;
	    lodash.without = without;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.backflow = flowRight;
	    lodash.collect = map;
	    lodash.compose = flowRight;
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.extend = assign;
	    lodash.iteratee = callback;
	    lodash.methods = functions;
	    lodash.object = zipObject;
	    lodash.select = filter;
	    lodash.tail = rest;
	    lodash.unique = uniq;
	
	    // Add functions to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions that return unwrapped values when chaining.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.deburr = deburr;
	    lodash.endsWith = endsWith;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.findWhere = findWhere;
	    lodash.first = first;
	    lodash.floor = floor;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isBoolean = isBoolean;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isMatch = isMatch;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isString = isString;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.min = min;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padLeft = padLeft;
	    lodash.padRight = padRight;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.sum = sum;
	    lodash.template = template;
	    lodash.trim = trim;
	    lodash.trimLeft = trimLeft;
	    lodash.trimRight = trimRight;
	    lodash.trunc = trunc;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.words = words;
	
	    // Add aliases.
	    lodash.all = every;
	    lodash.any = some;
	    lodash.contains = includes;
	    lodash.eq = isEqual;
	    lodash.detect = find;
	    lodash.foldl = reduce;
	    lodash.foldr = reduceRight;
	    lodash.head = first;
	    lodash.include = includes;
	    lodash.inject = reduce;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!lodash.prototype[methodName]) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), false);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions capable of returning wrapped and unwrapped values when chaining.
	    lodash.sample = sample;
	
	    lodash.prototype.sample = function(n) {
	      if (!this.__chain__ && n == null) {
	        return sample(this.value());
	      }
	      return this.thru(function(value) {
	        return sample(value, n);
	      });
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type string
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);
	
	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(result.__takeCount__, n);
	        } else {
	          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type != LAZY_MAP_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
	        var result = this.clone();
	        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.first` and `_.last`.
	    arrayEach(['first', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
	    arrayEach(['initial', 'rest'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
	    arrayEach(['pluck', 'where'], function(methodName, index) {
	      var operationName = index ? 'filter' : 'map',
	          createCallback = index ? baseMatches : property;
	
	      LazyWrapper.prototype[methodName] = function(value) {
	        return this[operationName](createCallback(value));
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.reject = function(predicate, thisArg) {
	      predicate = getCallback(predicate, thisArg, 1);
	      return this.filter(function(value) {
	        return !predicate(value);
	      });
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = start == null ? 0 : (+start || 0);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = (+end || 0);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
	      return this.reverse().takeWhile(predicate, thisArg).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(POSITIVE_INFINITY);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
	          retUnwrapped = /^(?:first|last)$/.test(methodName),
	          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var args = retUnwrapped ? [1] : arguments,
	            chainAll = this.__chain__,
	            value = this.__wrapped__,
	            isHybrid = !!this.__actions__.length,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var interceptor = function(value) {
	          return (retUnwrapped && chainAll)
	            ? lodashFunc(value, 1)[0]
	            : lodashFunc.apply(undefined, arrayPush([value], args));
	        };
	
	        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
	            onlyLazy = isLazy && !isHybrid;
	
	        if (retUnwrapped && !chainAll) {
	          if (onlyLazy) {
	            value = value.clone();
	            value.__actions__.push(action);
	            return func.call(value);
	          }
	          return lodashFunc.call(undefined, this.value())[0];
	        }
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push(action);
	          return new LodashWrapper(result, chainAll);
	        }
	        return this.thru(interceptor);
	      };
	    });
	
	    // Add `Array` and `String` methods to `lodash.prototype`.
	    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
	      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          return func.apply(this.value(), args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(value, args);
	        });
	      };
	    });
	
	    // Map minified function names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name,
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];
	
	    // Add functions to the lazy wrapper.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chaining functions to the `lodash` wrapper.
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.concat = wrapperConcat;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toString = wrapperToString;
	    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add function aliases to the `lodash` wrapper.
	    lodash.prototype.collect = lodash.prototype.map;
	    lodash.prototype.head = lodash.prototype.first;
	    lodash.prototype.select = lodash.prototype.filter;
	    lodash.prototype.tail = lodash.prototype.rest;
	
	    return lodash;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers like r.js check for condition patterns like the following:
	  if (true) {
	    // Expose lodash to the global object when an AMD loader is present to avoid
	    // errors in cases where lodash is loaded by a script tag and not intended
	    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
	    // more details.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for Node.js or RingoJS.
	    if (moduleExports) {
	      (freeModule.exports = _)._ = _;
	    }
	    // Export for Rhino with CommonJS support.
	    else {
	      freeExports._ = _;
	    }
	  }
	  else {
	    // Export for a browser or Rhino.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(161)(module), (function() { return this; }())))

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var cachePush = __webpack_require__(201),
	    getNative = __webpack_require__(10);
	
	/** Native method references. */
	var Set = getNative(global, 'Set');
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = getNative(Object, 'create');
	
	/**
	 *
	 * Creates a cache object to store unique values.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var length = values ? values.length : 0;
	
	  this.data = { 'hash': nativeCreate(null), 'set': new Set };
	  while (length--) {
	    this.push(values[length]);
	  }
	}
	
	// Add functions to the `Set` cache.
	SetCache.prototype.push = cachePush;
	
	module.exports = SetCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 183 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array.length,
	      resIndex = -1,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[++resIndex] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 184 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 185 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(9);
	
	/**
	 * A specialized version of `_.assign` for customizing assigned values without
	 * support for argument juggling, multiple sources, and `this` binding `customizer`
	 * functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {Function} customizer The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 */
	function assignWith(object, source, customizer) {
	  var index = -1,
	      props = keys(source),
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index],
	        value = object[key],
	        result = customizer(value, source[key], key, object, source);
	
	    if ((result === result ? (result !== value) : (value === value)) ||
	        (value === undefined && !(key in object))) {
	      object[key] = result;
	    }
	  }
	  return object;
	}
	
	module.exports = assignWith;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCopy = __webpack_require__(188),
	    keys = __webpack_require__(9);
	
	/**
	 * The base implementation of `_.assign` without support for argument juggling,
	 * multiple sources, and `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return source == null
	    ? object
	    : baseCopy(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ }),
/* 188 */
/***/ (function(module, exports) {

	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property names to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @returns {Object} Returns `object`.
	 */
	function baseCopy(source, props, object) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	    object[key] = source[key];
	  }
	  return object;
	}
	
	module.exports = baseCopy;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(19),
	    cacheIndexOf = __webpack_require__(23),
	    createCache = __webpack_require__(24);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.difference` which accepts a single array
	 * of values to exclude.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values) {
	  var length = array ? array.length : 0,
	      result = [];
	
	  if (!length) {
	    return result;
	  }
	  var index = -1,
	      indexOf = baseIndexOf,
	      isCommon = true,
	      cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	      valuesLength = values.length;
	
	  if (cache) {
	    indexOf = cacheIndexOf;
	    isCommon = false;
	    values = cache;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index];
	
	    if (isCommon && value === value) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === value) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (indexOf(values, value, 0) < 0) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(17);
	
	/**
	 * The base implementation of `_.filter` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(204);
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(191),
	    keys = __webpack_require__(9);
	
	/**
	 * The base implementation of `_.forOwn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	var equalArrays = __webpack_require__(207),
	    equalByTag = __webpack_require__(208),
	    equalObjects = __webpack_require__(209),
	    isArray = __webpack_require__(3),
	    isTypedArray = __webpack_require__(215);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	 * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = objToString.call(object);
	    if (objTag == argsTag) {
	      objTag = objectTag;
	    } else if (objTag != objectTag) {
	      objIsArr = isTypedArray(object);
	    }
	  }
	  if (!othIsArr) {
	    othTag = objToString.call(other);
	    if (othTag == argsTag) {
	      othTag = objectTag;
	    } else if (othTag != objectTag) {
	      othIsArr = isTypedArray(other);
	    }
	  }
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !(objIsArr || objIsObj)) {
	    return equalByTag(object, other, objTag);
	  }
	  if (!isLoose) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  // For more information on detecting circular references see https://es5.github.io/#JO.
	  stackA || (stackA = []);
	  stackB || (stackB = []);
	
	  var length = stackA.length;
	  while (length--) {
	    if (stackA[length] == object) {
	      return stackB[length] == other;
	    }
	  }
	  // Add `object` and `other` to the stack of traversed objects.
	  stackA.push(object);
	  stackB.push(other);
	
	  var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	  stackA.pop();
	  stackB.pop();
	
	  return result;
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(20),
	    toObject = __webpack_require__(5);
	
	/**
	 * The base implementation of `_.isMatch` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Array} matchData The propery names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = toObject(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	      if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(17),
	    isArrayLike = __webpack_require__(7);
	
	/**
	 * The base implementation of `_.map` without support for callback shorthands
	 * and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(194),
	    getMatchData = __webpack_require__(210),
	    toObject = __webpack_require__(5);
	
	/**
	 * The base implementation of `_.matches` which does not clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    var key = matchData[0][0],
	        value = matchData[0][1];
	
	    return function(object) {
	      if (object == null) {
	        return false;
	      }
	      return object[key] === value && (value !== undefined || (key in toObject(object)));
	    };
	  }
	  return function(object) {
	    return baseIsMatch(object, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(18),
	    baseIsEqual = __webpack_require__(20),
	    baseSlice = __webpack_require__(199),
	    isArray = __webpack_require__(3),
	    isKey = __webpack_require__(27),
	    isStrictComparable = __webpack_require__(28),
	    last = __webpack_require__(175),
	    toObject = __webpack_require__(5),
	    toPath = __webpack_require__(29);
	
	/**
	 * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to compare.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  var isArr = isArray(path),
	      isCommon = isKey(path) && isStrictComparable(srcValue),
	      pathKey = (path + '');
	
	  path = toPath(path);
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    var key = pathKey;
	    object = toObject(object);
	    if ((isArr || !isCommon) && !(key in object)) {
	      object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	      if (object == null) {
	        return false;
	      }
	      key = last(path);
	      object = toObject(object);
	    }
	    return object[key] === srcValue
	      ? (srcValue !== undefined || (key in object))
	      : baseIsEqual(srcValue, object[key], undefined, true);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(18),
	    toPath = __webpack_require__(29);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function basePropertyDeep(path) {
	  var pathKey = (path + '');
	  path = toPath(path);
	  return function(object) {
	    return baseGet(object, path, pathKey);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 199 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  start = start == null ? 0 : (+start || 0);
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = (end === undefined || end > length) ? length : (+end || 0);
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(19),
	    cacheIndexOf = __webpack_require__(23),
	    createCache = __webpack_require__(24);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniq` without support for callback shorthands
	 * and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The function invoked per iteration.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee) {
	  var index = -1,
	      indexOf = baseIndexOf,
	      length = array.length,
	      isCommon = true,
	      isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
	      seen = isLarge ? createCache() : null,
	      result = [];
	
	  if (seen) {
	    indexOf = cacheIndexOf;
	    isCommon = false;
	  } else {
	    isLarge = false;
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value, index, array) : value;
	
	    if (isCommon && value === value) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (indexOf(seen, computed, 0) < 0) {
	      if (iteratee || isLarge) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(4);
	
	/**
	 * Adds `value` to the cache.
	 *
	 * @private
	 * @name push
	 * @memberOf SetCache
	 * @param {*} value The value to cache.
	 */
	function cachePush(value) {
	  var data = this.data;
	  if (typeof value == 'string' || isObject(value)) {
	    data.set.add(value);
	  } else {
	    data.hash[value] = true;
	  }
	}
	
	module.exports = cachePush;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	var bindCallback = __webpack_require__(22),
	    isIterateeCall = __webpack_require__(26),
	    restParam = __webpack_require__(16);
	
	/**
	 * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return restParam(function(object, sources) {
	    var index = -1,
	        length = object == null ? 0 : sources.length,
	        customizer = length > 2 ? sources[length - 2] : undefined,
	        guard = length > 2 ? sources[2] : undefined,
	        thisArg = length > 1 ? sources[length - 1] : undefined;
	
	    if (typeof customizer == 'function') {
	      customizer = bindCallback(customizer, thisArg, 5);
	      length -= 2;
	    } else {
	      customizer = typeof thisArg == 'function' ? thisArg : undefined;
	      length -= (customizer ? 1 : 0);
	    }
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(25),
	    isLength = __webpack_require__(6),
	    toObject = __webpack_require__(5);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    var length = collection ? getLength(collection) : 0;
	    if (!isLength(length)) {
	      return eachFunc(collection, iteratee);
	    }
	    var index = fromRight ? length : -1,
	        iterable = toObject(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(5);
	
	/**
	 * Creates a base function for `_.forIn` or `_.forInRight`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var iterable = toObject(object),
	        props = keysFunc(object),
	        length = props.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var key = props[index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(12),
	    createPadding = __webpack_require__(206);
	
	/**
	 * Creates a function for `_.padLeft` or `_.padRight`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify padding from the right.
	 * @returns {Function} Returns the new pad function.
	 */
	function createPadDir(fromRight) {
	  return function(string, length, chars) {
	    string = baseToString(string);
	    return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
	  };
	}
	
	module.exports = createPadDir;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var repeat = __webpack_require__(219);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeIsFinite = global.isFinite;
	
	/**
	 * Creates the padding required for `string` based on the given `length`.
	 * The `chars` string is truncated if the number of characters exceeds `length`.
	 *
	 * @private
	 * @param {string} string The string to create padding for.
	 * @param {number} [length=0] The padding length.
	 * @param {string} [chars=' '] The string used as padding.
	 * @returns {string} Returns the pad for `string`.
	 */
	function createPadding(string, length, chars) {
	  var strLength = string.length;
	  length = +length;
	
	  if (strLength >= length || !nativeIsFinite(length)) {
	    return '';
	  }
	  var padLength = length - strLength;
	  chars = chars == null ? ' ' : (chars + '');
	  return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
	}
	
	module.exports = createPadding;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(185);
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing arrays.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var index = -1,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	    return false;
	  }
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index],
	        result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	    if (result !== undefined) {
	      if (result) {
	        continue;
	      }
	      return false;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (isLoose) {
	      if (!arraySome(other, function(othValue) {
	            return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	          })) {
	        return false;
	      }
	    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 208 */
/***/ (function(module, exports) {

	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    stringTag = '[object String]';
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag) {
	  switch (tag) {
	    case boolTag:
	    case dateTag:
	      // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	      // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	      return +object == +other;
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case numberTag:
	      // Treat `NaN` vs. `NaN` as equal.
	      return (object != +object)
	        ? other != +other
	        : object == +other;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings primitives and string
	      // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	      return object == (other + '');
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(9);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isLoose) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  var skipCtor = isLoose;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key],
	        result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	      return false;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (!skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(28),
	    pairs = __webpack_require__(217);
	
	/**
	 * Gets the propery names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = pairs(object),
	      length = result.length;
	
	  while (length--) {
	    result[length][2] = isStrictComparable(result[length][1]);
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 211 */
/***/ (function(module, exports) {

	/**
	 * Gets the index at which the first occurrence of `NaN` is found in `array`.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	 */
	function indexOfNaN(array, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 0 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    var other = array[index];
	    if (other !== other) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = indexOfNaN;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(30),
	    isArray = __webpack_require__(3),
	    isIndex = __webpack_require__(13),
	    isLength = __webpack_require__(6),
	    keysIn = __webpack_require__(216);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = shimKeys;


/***/ }),
/* 213 */
/***/ (function(module, exports) {

	/**
	 * An implementation of `_.uniq` optimized for sorted arrays without support
	 * for callback shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The function invoked per iteration.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function sortedUniq(array, iteratee) {
	  var seen,
	      index = -1,
	      length = array.length,
	      resIndex = -1,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value, index, array) : value;
	
	    if (!index || seen !== computed) {
	      seen = computed;
	      result[++resIndex] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = sortedUniq;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(31),
	    isObjectLike = __webpack_require__(8);
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isNative;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(6),
	    isObjectLike = __webpack_require__(8);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	function isTypedArray(value) {
	  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	}
	
	module.exports = isTypedArray;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(30),
	    isArray = __webpack_require__(3),
	    isIndex = __webpack_require__(13),
	    isLength = __webpack_require__(6),
	    isObject = __webpack_require__(4);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(9),
	    toObject = __webpack_require__(5);
	
	/**
	 * Creates a two dimensional array of the key-value pairs for `object`,
	 * e.g. `[[key1, value1], [key2, value2]]`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the new array of key-value pairs.
	 * @example
	 *
	 * _.pairs({ 'barney': 36, 'fred': 40 });
	 * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	 */
	function pairs(object) {
	  object = toObject(object);
	
	  var index = -1,
	      props = keys(object),
	      length = props.length,
	      result = Array(length);
	
	  while (++index < length) {
	    var key = props[index];
	    result[index] = [key, object[key]];
	  }
	  return result;
	}
	
	module.exports = pairs;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	var createPadDir = __webpack_require__(205);
	
	/**
	 * Pads `string` on the left side if it's shorter than `length`. Padding
	 * characters are truncated if they exceed `length`.
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to pad.
	 * @param {number} [length=0] The padding length.
	 * @param {string} [chars=' '] The string used as padding.
	 * @returns {string} Returns the padded string.
	 * @example
	 *
	 * _.padLeft('abc', 6);
	 * // => '   abc'
	 *
	 * _.padLeft('abc', 6, '_-');
	 * // => '_-_abc'
	 *
	 * _.padLeft('abc', 3);
	 * // => 'abc'
	 */
	var padLeft = createPadDir();
	
	module.exports = padLeft;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var baseToString = __webpack_require__(12);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeFloor = Math.floor,
	    nativeIsFinite = global.isFinite;
	
	/**
	 * Repeats the given string `n` times.
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to repeat.
	 * @param {number} [n=0] The number of times to repeat the string.
	 * @returns {string} Returns the repeated string.
	 * @example
	 *
	 * _.repeat('*', 3);
	 * // => '***'
	 *
	 * _.repeat('abc', 2);
	 * // => 'abcabc'
	 *
	 * _.repeat('abc', 0);
	 * // => ''
	 */
	function repeat(string, n) {
	  var result = '';
	  string = baseToString(string);
	  n = +n;
	  if (n < 1 || !string || !nativeIsFinite(n)) {
	    return result;
	  }
	  // Leverage the exponentiation by squaring algorithm for a faster repeat.
	  // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	  do {
	    if (n % 2) {
	      result += string;
	    }
	    n = nativeFloor(n / 2);
	    string += string;
	  } while (n);
	
	  return result;
	}
	
	module.exports = repeat;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(21),
	    basePropertyDeep = __webpack_require__(198),
	    isKey = __webpack_require__(27);
	
	/**
	 * Creates a function that returns the property value at `path` on a
	 * given object.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': { 'c': 2 } } },
	 *   { 'a': { 'b': { 'c': 1 } } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b.c'));
	 * // => [2, 1]
	 *
	 * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 33,
		"./af.js": 33,
		"./ar": 40,
		"./ar-dz": 34,
		"./ar-dz.js": 34,
		"./ar-kw": 35,
		"./ar-kw.js": 35,
		"./ar-ly": 36,
		"./ar-ly.js": 36,
		"./ar-ma": 37,
		"./ar-ma.js": 37,
		"./ar-sa": 38,
		"./ar-sa.js": 38,
		"./ar-tn": 39,
		"./ar-tn.js": 39,
		"./ar.js": 40,
		"./az": 41,
		"./az.js": 41,
		"./be": 42,
		"./be.js": 42,
		"./bg": 43,
		"./bg.js": 43,
		"./bm": 44,
		"./bm.js": 44,
		"./bn": 45,
		"./bn.js": 45,
		"./bo": 46,
		"./bo.js": 46,
		"./br": 47,
		"./br.js": 47,
		"./bs": 48,
		"./bs.js": 48,
		"./ca": 49,
		"./ca.js": 49,
		"./cs": 50,
		"./cs.js": 50,
		"./cv": 51,
		"./cv.js": 51,
		"./cy": 52,
		"./cy.js": 52,
		"./da": 53,
		"./da.js": 53,
		"./de": 56,
		"./de-at": 54,
		"./de-at.js": 54,
		"./de-ch": 55,
		"./de-ch.js": 55,
		"./de.js": 56,
		"./dv": 57,
		"./dv.js": 57,
		"./el": 58,
		"./el.js": 58,
		"./en-SG": 59,
		"./en-SG.js": 59,
		"./en-au": 60,
		"./en-au.js": 60,
		"./en-ca": 61,
		"./en-ca.js": 61,
		"./en-gb": 62,
		"./en-gb.js": 62,
		"./en-ie": 63,
		"./en-ie.js": 63,
		"./en-il": 64,
		"./en-il.js": 64,
		"./en-nz": 65,
		"./en-nz.js": 65,
		"./eo": 66,
		"./eo.js": 66,
		"./es": 69,
		"./es-do": 67,
		"./es-do.js": 67,
		"./es-us": 68,
		"./es-us.js": 68,
		"./es.js": 69,
		"./et": 70,
		"./et.js": 70,
		"./eu": 71,
		"./eu.js": 71,
		"./fa": 72,
		"./fa.js": 72,
		"./fi": 73,
		"./fi.js": 73,
		"./fo": 74,
		"./fo.js": 74,
		"./fr": 77,
		"./fr-ca": 75,
		"./fr-ca.js": 75,
		"./fr-ch": 76,
		"./fr-ch.js": 76,
		"./fr.js": 77,
		"./fy": 78,
		"./fy.js": 78,
		"./ga": 79,
		"./ga.js": 79,
		"./gd": 80,
		"./gd.js": 80,
		"./gl": 81,
		"./gl.js": 81,
		"./gom-latn": 82,
		"./gom-latn.js": 82,
		"./gu": 83,
		"./gu.js": 83,
		"./he": 84,
		"./he.js": 84,
		"./hi": 85,
		"./hi.js": 85,
		"./hr": 86,
		"./hr.js": 86,
		"./hu": 87,
		"./hu.js": 87,
		"./hy-am": 88,
		"./hy-am.js": 88,
		"./id": 89,
		"./id.js": 89,
		"./is": 90,
		"./is.js": 90,
		"./it": 92,
		"./it-ch": 91,
		"./it-ch.js": 91,
		"./it.js": 92,
		"./ja": 93,
		"./ja.js": 93,
		"./jv": 94,
		"./jv.js": 94,
		"./ka": 95,
		"./ka.js": 95,
		"./kk": 96,
		"./kk.js": 96,
		"./km": 97,
		"./km.js": 97,
		"./kn": 98,
		"./kn.js": 98,
		"./ko": 99,
		"./ko.js": 99,
		"./ku": 100,
		"./ku.js": 100,
		"./ky": 101,
		"./ky.js": 101,
		"./lb": 102,
		"./lb.js": 102,
		"./lo": 103,
		"./lo.js": 103,
		"./lt": 104,
		"./lt.js": 104,
		"./lv": 105,
		"./lv.js": 105,
		"./me": 106,
		"./me.js": 106,
		"./mi": 107,
		"./mi.js": 107,
		"./mk": 108,
		"./mk.js": 108,
		"./ml": 109,
		"./ml.js": 109,
		"./mn": 110,
		"./mn.js": 110,
		"./mr": 111,
		"./mr.js": 111,
		"./ms": 113,
		"./ms-my": 112,
		"./ms-my.js": 112,
		"./ms.js": 113,
		"./mt": 114,
		"./mt.js": 114,
		"./my": 115,
		"./my.js": 115,
		"./nb": 116,
		"./nb.js": 116,
		"./ne": 117,
		"./ne.js": 117,
		"./nl": 119,
		"./nl-be": 118,
		"./nl-be.js": 118,
		"./nl.js": 119,
		"./nn": 120,
		"./nn.js": 120,
		"./pa-in": 121,
		"./pa-in.js": 121,
		"./pl": 122,
		"./pl.js": 122,
		"./pt": 124,
		"./pt-br": 123,
		"./pt-br.js": 123,
		"./pt.js": 124,
		"./ro": 125,
		"./ro.js": 125,
		"./ru": 126,
		"./ru.js": 126,
		"./sd": 127,
		"./sd.js": 127,
		"./se": 128,
		"./se.js": 128,
		"./si": 129,
		"./si.js": 129,
		"./sk": 130,
		"./sk.js": 130,
		"./sl": 131,
		"./sl.js": 131,
		"./sq": 132,
		"./sq.js": 132,
		"./sr": 134,
		"./sr-cyrl": 133,
		"./sr-cyrl.js": 133,
		"./sr.js": 134,
		"./ss": 135,
		"./ss.js": 135,
		"./sv": 136,
		"./sv.js": 136,
		"./sw": 137,
		"./sw.js": 137,
		"./ta": 138,
		"./ta.js": 138,
		"./te": 139,
		"./te.js": 139,
		"./tet": 140,
		"./tet.js": 140,
		"./tg": 141,
		"./tg.js": 141,
		"./th": 142,
		"./th.js": 142,
		"./tl-ph": 143,
		"./tl-ph.js": 143,
		"./tlh": 144,
		"./tlh.js": 144,
		"./tr": 145,
		"./tr.js": 145,
		"./tzl": 146,
		"./tzl.js": 146,
		"./tzm": 148,
		"./tzm-latn": 147,
		"./tzm-latn.js": 147,
		"./tzm.js": 148,
		"./ug-cn": 149,
		"./ug-cn.js": 149,
		"./uk": 150,
		"./uk.js": 150,
		"./ur": 151,
		"./ur.js": 151,
		"./uz": 153,
		"./uz-latn": 152,
		"./uz-latn.js": 152,
		"./uz.js": 153,
		"./vi": 154,
		"./vi.js": 154,
		"./x-pseudo": 155,
		"./x-pseudo.js": 155,
		"./yo": 156,
		"./yo.js": 156,
		"./zh-cn": 157,
		"./zh-cn.js": 157,
		"./zh-hk": 158,
		"./zh-hk.js": 158,
		"./zh-tw": 159,
		"./zh-tw.js": 159
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 221;


/***/ }),
/* 222 */
/***/ (function(module, exports) {

	/*
	 * angular-auto-validate - v1.18.16 - 2015-09-21
	 * https://github.com/jonsamwell/angular-auto-validate
	 * Copyright (c) 2015 Jon Samwell (http://www.jonsamwell.com)
	 */
	"use strict";
	
	(function (String, angular) {
	  "use strict";
	
	  angular.module("jcs-autoValidate", []);
	
	  function ValidatorFn() {
	    var elementStateModifiers = {},
	        enableValidElementStyling = true,
	        enableInvalidElementStyling = true,
	        validationEnabled = true,
	        toBoolean = function toBoolean(value) {
	      var v;
	      if (value && value.length !== 0) {
	        v = value.toLowerCase();
	        value = !(v === "f" || v === "0" || v === "false");
	      } else {
	        value = false;
	      }
	
	      return value;
	    },
	        getAttributeValue = function getAttributeValue(el, attrName) {
	      var val;
	
	      if (el !== undefined) {
	        val = el.attr(attrName) || el.attr("data-" + attrName);
	      }
	
	      return val;
	    },
	        attributeExists = function attributeExists(el, attrName) {
	      var exists;
	
	      if (el !== undefined) {
	        exists = el.attr(attrName) !== undefined || el.attr("data-" + attrName) !== undefined;
	      }
	
	      return exists;
	    },
	        getBooleanAttributeValue = function getBooleanAttributeValue(el, attrName) {
	      return toBoolean(getAttributeValue(el, attrName));
	    },
	        validElementStylingEnabled = function validElementStylingEnabled(el) {
	      return enableValidElementStyling && !getBooleanAttributeValue(el, "disable-valid-styling");
	    },
	        invalidElementStylingEnabled = function invalidElementStylingEnabled(el) {
	      return enableInvalidElementStyling && !getBooleanAttributeValue(el, "disable-invalid-styling");
	    };
	
	    /**
	     * @ngdoc function
	     * @name validator#enable
	     * @methodOf validator
	     *
	     * @description
	     * By default auto validate will validate all forms and elements with an ngModel directive on.  By
	     * setting enabled to false you will explicitly have to opt in to enable validation on forms and child
	     * elements.
	     *
	     * Note: this can be overridden by add the 'auto-validate-enabled="true/false' attribute to a form.
	     *
	     * Example:
	     * <pre>
	     *  app.config(function (validator) {
	     *    validator.enable(false);
	     *  });
	     * </pre>
	     *
	     * @param {Boolean} isEnabled true to enable, false to disable.
	     */
	    this.enable = function (isEnabled) {
	      validationEnabled = isEnabled;
	    };
	
	    /**
	     * @ngdoc function
	     * @name validator#isEnabled
	     * @methodOf validator
	     *
	     * @description
	     * Returns true if the library is enabeld.
	     *
	     * @return {Boolean} true if enabled, otherwise false.
	     */
	    this.isEnabled = function () {
	      return validationEnabled;
	    };
	
	    /**
	     * @ngdoc function
	     * @name validator#setDefaultElementModifier
	     * @methodOf validator
	     *
	     * @description
	     * Sets the default element modifier that will be used by the validator
	     * to change an elements UI state.  Please ensure the modifier has been registered
	     * before setting it as default.
	     *
	     * Note: this can be changed by setting the
	     * element modifier attribute on the input element 'data-element-modifier="myCustomModifier"'
	     *
	     * Example:
	     * <pre>
	     *  app.config(function (validator) {
	     *    validator.setDefaultElementModifier('myCustomModifier');
	     *  });
	     * </pre>
	     *
	     * @param {string} key The key name of the modifier.
	     */
	    this.setDefaultElementModifier = function (key) {
	      if (elementStateModifiers[key] === undefined) {
	        throw new Error("Element modifier not registered: " + key);
	      }
	
	      this.defaultElementModifier = key;
	    };
	
	    /**
	     * @ngdoc function
	     * @name validator#registerDomModifier
	     * @methodOf validator
	     *
	     * @description
	     * Registers an object that adheres to the elementModifier interface and is
	     * able to modifier an elements dom so that appears valid / invalid for a specific
	     * scenario i.e. the Twitter Bootstrap css framework, Foundation CSS framework etc.
	     *
	     * Example:
	     * <pre>
	     *  app.config(function (validator) {
	     *    validator.registerDomModifier('customDomModifier', {
	     *      makeValid: function (el) {
	     *          el.removeClass(el, 'invalid');
	     *          el.addClass(el, 'valid');
	     *      },
	     *      makeInvalid: function (el, err, domManipulator) {
	     *          el.removeClass(el, 'valid');
	     *          el.addClass(el, 'invalid');
	     *      }
	     *    });
	     *  });
	     * </pre>
	     *
	     * @param {string} key The key name of the modifier
	     * @param {object} modifier An object which implements the elementModifier interface
	     */
	    this.registerDomModifier = function (key, modifier) {
	      elementStateModifiers[key] = modifier;
	    };
	
	    /**
	     * @ngdoc function
	     * @name validator#setErrorMessageResolver
	     * @methodOf validator
	     *
	     * @description
	     * Registers an object that adheres to the elementModifier interface and is
	     * able to modifier an elements dom so that appears valid / invalid for a specific
	     * scenario i.e. the Twitter Bootstrap css framework, Foundation CSS framework etc.
	     *
	     * Example:
	     * <pre>
	     *  app.config(function (validator) {
	     *    validator.setErrorMessageResolver(function (errorKey, el) {
	     *      var defer = $q.defer();
	     *      // resolve the correct error from the given key and resolve the returned promise.
	     *      return defer.promise();
	     *    });
	     *  });
	     * </pre>
	     *
	     * @param {function} resolver A method that returns a promise with the resolved error message in.
	     */
	    this.setErrorMessageResolver = function (resolver) {
	      this.errorMessageResolver = resolver;
	    };
	
	    /**
	     * @ngdoc function
	     * @name validator#getErrorMessage
	     * @methodOf validator
	     *
	     * @description
	     * Resolves the error message for the given error type.
	     *
	     * @param {String} errorKey The error type.
	     * @param {Element} el The UI element that is the focus of the error.
	     * It is provided as the error message may need information from the element i.e. ng-min (the min allowed value).
	     */
	    this.getErrorMessage = function (errorKey, el) {
	      var defer;
	      if (this.errorMessageResolver === undefined) {
	        throw new Error("Please set an error message resolver via the setErrorMessageResolver function before attempting to resolve an error message.");
	      }
	
	      if (attributeExists(el, "disable-validation-message")) {
	        defer = angular.injector(["ng"]).get("$q").defer();
	        defer.resolve("");
	        return defer.promise;
	      } else {
	        return this.errorMessageResolver(errorKey, el);
	      }
	    };
	
	    /**
	     * @ngdoc function
	     * @name validator#setValidElementStyling
	     * @methodOf validator
	     *
	     * @description
	     * Globally enables valid element visual styling.  This is enabled by default.
	     *
	     * @param {Boolean} enabled True to enable style otherwise false.
	     */
	    this.setValidElementStyling = function (enabled) {
	      enableValidElementStyling = enabled;
	    };
	
	    /**
	     * @ngdoc function
	     * @name validator#setInvalidElementStyling
	     * @methodOf validator
	     *
	     * @description
	     * Globally enables invalid element visual styling.  This is enabled by default.
	     *
	     * @param {Boolean} enabled True to enable style otherwise false.
	     */
	    this.setInvalidElementStyling = function (enabled) {
	      enableInvalidElementStyling = enabled;
	    };
	
	    this.getDomModifier = function (el) {
	      var modifierKey = (el !== undefined ? el.attr("element-modifier") : this.defaultElementModifier) || (el !== undefined ? el.attr("data-element-modifier") : this.defaultElementModifier) || this.defaultElementModifier;
	
	      if (modifierKey === undefined) {
	        throw new Error("Please set a default dom modifier via the setDefaultElementModifier method on the validator class.");
	      }
	
	      return elementStateModifiers[modifierKey];
	    };
	
	    this.makeValid = function (el) {
	      if (validElementStylingEnabled(el)) {
	        this.getDomModifier(el).makeValid(el);
	      } else {
	        this.makeDefault(el);
	      }
	    };
	
	    this.makeInvalid = function (el, errorMsg) {
	      if (invalidElementStylingEnabled(el)) {
	        this.getDomModifier(el).makeInvalid(el, errorMsg);
	      } else {
	        this.makeDefault(el);
	      }
	    };
	
	    this.makeDefault = function (el) {
	      var dm = this.getDomModifier(el);
	      if (dm.makeDefault) {
	        dm.makeDefault(el);
	      }
	    };
	
	    this.defaultFormValidationOptions = {
	      forceValidation: false,
	      disabled: false,
	      validateNonVisibleControls: false,
	      removeExternalValidationErrorsOnSubmit: true,
	      validateOnFormSubmit: false
	    };
	
	    this.$get = [function () {
	      return this;
	    }];
	  }
	
	  angular.module("jcs-autoValidate").provider("validator", ValidatorFn);
	
	  function Bootstrap3ElementModifierFn($log) {
	    var reset = function reset(el) {
	      angular.forEach(el.find("span"), function (spanEl) {
	        spanEl = angular.element(spanEl);
	        if (spanEl.hasClass("error-msg") || spanEl.hasClass("form-control-feedback") || spanEl.hasClass("control-feedback")) {
	          spanEl.remove();
	        }
	      });
	
	      el.removeClass("has-success has-error has-feedback");
	    },
	        findWithClassElementAsc = function findWithClassElementAsc(el, klass) {
	      var returnEl,
	          parent = el;
	      for (var i = 0; i <= 10; i += 1) {
	        if (parent !== undefined && parent.hasClass(klass)) {
	          returnEl = parent;
	          break;
	        } else if (parent !== undefined) {
	          parent = parent.parent();
	        }
	      }
	
	      return returnEl;
	    },
	        findWithClassElementDesc = (function (_findWithClassElementDesc) {
	      var _findWithClassElementDescWrapper = function findWithClassElementDesc(_x, _x2) {
	        return _findWithClassElementDesc.apply(this, arguments);
	      };
	
	      _findWithClassElementDescWrapper.toString = function () {
	        return _findWithClassElementDesc.toString();
	      };
	
	      return _findWithClassElementDescWrapper;
	    })(function (el, klass) {
	      var child;
	      for (var i = 0; i < el.children.length; i += 1) {
	        child = el.children[i];
	        if (child !== undefined && angular.element(child).hasClass(klass)) {
	          break;
	        } else if (child.children !== undefined) {
	          child = findWithClassElementDesc(child, klass);
	          if (child.length > 0) {
	            break;
	          }
	        }
	      }
	
	      return angular.element(child);
	    }),
	        findFormGroupElement = function findFormGroupElement(el) {
	      return findWithClassElementAsc(el, "form-group");
	    },
	        findInputGroupElement = function findInputGroupElement(el) {
	      return findWithClassElementDesc(el, "input-group");
	    },
	        insertAfter = function insertAfter(referenceNode, newNode) {
	      referenceNode[0].parentNode.insertBefore(newNode[0], referenceNode[0].nextSibling);
	    },
	
	    /**
	     * @ngdoc property
	     * @name bootstrap3ElementModifier#addValidationStateIcons
	     * @propertyOf bootstrap3ElementModifier
	     * @returns {bool} True if an state icon will be added to the element in the valid and invalid control
	     * states.  The default is false.
	     */
	    addValidationStateIcons = false,
	
	    /**
	     * @ngdoc function
	     * @name bootstrap3ElementModifier#enableValidationStateIcons
	     * @methodOf bootstrap3ElementModifier
	     *
	     * @description
	     * Makes an element appear invalid by apply an icon to the input element.
	     *
	     * @param {bool} enable - True to enable the icon otherwise false.
	     */
	    enableValidationStateIcons = function enableValidationStateIcons(enable) {
	      addValidationStateIcons = enable;
	    },
	
	    /**
	     * @ngdoc function
	     * @name bootstrap3ElementModifier#makeValid
	     * @methodOf bootstrap3ElementModifier
	     *
	     * @description
	     * Makes an element appear valid by apply bootstrap 3 specific styles and child elements. If the service
	     * property 'addValidationStateIcons' is true it will also append validation glyphicon to the element.
	     * See: http://getbootstrap.com/css/#forms-control-validation
	     *
	     * @param {Element} el - The input control element that is the target of the validation.
	     */
	    makeValid = function makeValid(el) {
	      var frmGroupEl = findFormGroupElement(el),
	          inputGroupEl;
	
	      if (frmGroupEl) {
	        reset(frmGroupEl);
	        inputGroupEl = findInputGroupElement(frmGroupEl[0]);
	        frmGroupEl.addClass("has-success " + (inputGroupEl.length > 0 ? "" : "has-feedback"));
	        if (addValidationStateIcons) {
	          var iconElText = "<span class=\"glyphicon glyphicon-ok form-control-feedback\"></span>";
	          if (inputGroupEl.length > 0) {
	            iconElText = iconElText.replace("form-", "");
	            iconElText = "<span class=\"input-group-addon control-feedback\">" + iconElText + "</span";
	          }
	
	          insertAfter(el, angular.element(iconElText));
	        }
	      } else {
	        $log.error("Angular-auto-validate: invalid bs3 form structure elements must be wrapped by a form-group class");
	      }
	    },
	
	    /**
	     * @ngdoc function
	     * @name bootstrap3ElementModifier#makeInvalid
	     * @methodOf bootstrap3ElementModifier
	     *
	     * @description
	     * Makes an element appear invalid by apply bootstrap 3 specific styles and child elements. If the service
	     * property 'addValidationStateIcons' is true it will also append validation glyphicon to the element.
	     * See: http://getbootstrap.com/css/#forms-control-validation
	     *
	     * @param {Element} el - The input control element that is the target of the validation.
	     */
	    makeInvalid = function makeInvalid(el, errorMsg) {
	      var frmGroupEl = findFormGroupElement(el),
	          helpTextEl = angular.element("<span class=\"help-block has-error error-msg\">" + errorMsg + "</span>"),
	          inputGroupEl;
	
	      if (frmGroupEl) {
	        reset(frmGroupEl);
	        inputGroupEl = findInputGroupElement(frmGroupEl[0]);
	        frmGroupEl.addClass("has-error " + (inputGroupEl.length > 0 ? "" : "has-feedback"));
	        insertAfter(inputGroupEl.length > 0 ? inputGroupEl : getCorrectElementToPlaceErrorElementAfter(el), helpTextEl);
	        if (addValidationStateIcons) {
	          var iconElText = "<span class=\"glyphicon glyphicon-remove form-control-feedback\"></span>";
	          if (inputGroupEl.length > 0) {
	            iconElText = iconElText.replace("form-", "");
	            iconElText = "<span class=\"input-group-addon control-feedback\">" + iconElText + "</span";
	          }
	
	          insertAfter(getCorrectElementToPlaceErrorElementAfter(el), angular.element(iconElText));
	        }
	      } else {
	        $log.error("Angular-auto-validate: invalid bs3 form structure elements must be wrapped by a form-group class");
	      }
	    },
	        getCorrectElementToPlaceErrorElementAfter = function getCorrectElementToPlaceErrorElementAfter(el) {
	      var correctEl = el,
	          elType = el[0].type ? el[0].type.toLowerCase() : "";
	
	      if ((elType === "checkbox" || elType === "radio") && el.parent()[0].nodeName.toLowerCase() === "label") {
	        correctEl = el.parent();
	      }
	
	      return correctEl;
	    },
	
	    /**
	     * @ngdoc function
	     * @name bootstrap3ElementModifier#makeDefault
	     * @methodOf bootstrap3ElementModifier
	     *
	     * @description
	     * Makes an element appear in its default visual state by apply bootstrap 3 specific styles and child elements.
	     *
	     * @param {Element} el - The input control element that is the target of the validation.
	     */
	    makeDefault = function makeDefault(el) {
	      var frmGroupEl = findFormGroupElement(el);
	      if (frmGroupEl) {
	        reset(frmGroupEl);
	      } else {
	        $log.error("Angular-auto-validate: invalid bs3 form structure elements must be wrapped by a form-group class");
	      }
	    };
	
	    return {
	      makeValid: makeValid,
	      makeInvalid: makeInvalid,
	      makeDefault: makeDefault,
	      enableValidationStateIcons: enableValidationStateIcons,
	      key: "bs3"
	    };
	  }
	
	  Bootstrap3ElementModifierFn.$inject = ["$log"];
	
	  angular.module("jcs-autoValidate").factory("bootstrap3ElementModifier", Bootstrap3ElementModifierFn);
	
	  /*
	   * Taken from https://github.com/angular/angular.js/issues/2690#issue-14462164 (with added tests of course!)
	   */
	  function JCSDebounceFn($timeout) {
	    var debounce = function debounce(fn, timeout, apply) {
	      timeout = angular.isUndefined(timeout) ? 0 : timeout;
	      apply = angular.isUndefined(apply) ? true : apply; // !!default is true! most suitable to my experience
	      var nthCall = 0;
	      return function () {
	        // intercepting fn
	        var that = this;
	        var argz = arguments;
	        nthCall += 1;
	        var later = (function (version) {
	          return function () {
	            if (version === nthCall) {
	              return fn.apply(that, argz);
	            }
	          };
	        })(nthCall);
	
	        return $timeout(later, timeout, apply);
	      };
	    };
	
	    return {
	      debounce: debounce
	    };
	  }
	
	  JCSDebounceFn.$inject = ["$timeout"];
	
	  angular.module("jcs-autoValidate").factory("jcs-debounce", JCSDebounceFn);
	
	  /**
	   * Replaces string placeholders with corresponding template string
	   */
	  if (!("format" in String.prototype)) {
	    String.prototype.format = function () {
	      var args = arguments;
	      return this.replace(/{(\d+)}/g, function (match, number) {
	        return typeof args[number] !== undefined ? args[number] : match;
	      });
	    };
	  }
	
	  angular.autoValidate = angular.autoValidate || {
	    errorMessages: {}
	  };
	
	  angular.autoValidate.errorMessages["en-us"] = angular.autoValidate.errorMessages["en-gb"] = {
	    defaultMsg: "Please add error message for {0}",
	    email: "Please enter a valid email address",
	    minlength: "Please enter at least {0} characters",
	    maxlength: "You have entered more than the maximum {0} characters",
	    min: "Please enter the minimum number of {0}",
	    max: "Please enter the maximum number of {0}",
	    required: "This field is required",
	    date: "Please enter a valid date",
	    pattern: "Please ensure the entered information adheres to this pattern {0}",
	    number: "Please enter a valid number",
	    url: "Please enter a valid URL in the format of http(s)://www.google.com"
	  };
	
	  function DefaultErrorMessageResolverFn($q, $http) {
	    var currentCulture = "en-gb",
	        i18nFileRootPath = "js/angular-auto-validate/dist/lang",
	        cultureRetrievalPromise,
	        loadRemoteCulture = function loadRemoteCulture(culture) {
	      cultureRetrievalPromise = $http.get("{0}/jcs-auto-validate_{1}.json".format(i18nFileRootPath, culture.toLowerCase()));
	      return cultureRetrievalPromise;
	    },
	
	    /**
	     * @ngdoc function
	     * @name defaultErrorMessageResolver#setI18nFileRootPath
	     * @methodOf defaultErrorMessageResolver
	     *
	     * @description
	     * Set the root path to the il8n files on the server
	     *
	     * @param {String} rootPath - The root path on the server to the il8n file - this defaults
	     * to 'js/angular-auto-validate/lang/'
	     */
	    setI18nFileRootPath = function setI18nFileRootPath(rootPath) {
	      i18nFileRootPath = rootPath;
	    },
	
	    /**
	     * @ngdoc function
	     * @name defaultErrorMessageResolver#setCulture
	     * @methodOf defaultErrorMessageResolver
	     *
	     * @description
	     * Set the culture for the error messages by loading an the correct culture resource file.
	     *
	     * @param {String} culture - The new culture in the format of 'en-gb' etc.
	     * @param {Function} cultureLoadingFn - A optional function to load the culture resolve which should
	     * return a promise which is resolved with the culture errorMessage object.  If a function is not specified
	     * the culture file is loaded from the **i18nFileRootPath**.
	     * @returns {Promise} - A promise which is resolved with the loaded culture error messages object.
	     */
	    setCulture = function setCulture(culture, cultureLoadingFn) {
	      var defer = $q.defer();
	      cultureLoadingFn = cultureLoadingFn || loadRemoteCulture;
	      currentCulture = culture.toLowerCase();
	      if (angular.autoValidate.errorMessages[currentCulture] === undefined) {
	        cultureRetrievalPromise = cultureLoadingFn(culture);
	        cultureRetrievalPromise.then(function (response) {
	          cultureRetrievalPromise = undefined;
	          angular.autoValidate.errorMessages[currentCulture] = response.data;
	          defer.resolve(angular.autoValidate.errorMessages[currentCulture]);
	        }, function (err) {
	          angular.autoValidate.errorMessages[currentCulture] = {
	            defaultMsg: "Loading culture failed!"
	          };
	          cultureRetrievalPromise = null;
	          defer.reject(err);
	        });
	      } else {
	        defer.resolve(angular.autoValidate.errorMessages[currentCulture]);
	      }
	
	      return defer.promise;
	    },
	        getErrorMessages = function getErrorMessages(culture) {
	      var defer = $q.defer();
	      culture = culture === undefined ? currentCulture : culture.toLowerCase();
	      if (cultureRetrievalPromise !== undefined) {
	        cultureRetrievalPromise.then(function () {
	          defer.resolve(angular.autoValidate.errorMessages[culture]);
	        }, function (err) {
	          defer.reject(err);
	        });
	      } else {
	        defer.resolve(angular.autoValidate.errorMessages[culture]);
	      }
	      return defer.promise;
	    },
	        getMessageTypeOverride = function getMessageTypeOverride(errorType, el) {
	      var overrideKey;
	
	      if (el) {
	        // try and find an attribute which overrides the given error type in the form of errorType-err-type="someMsgKey"
	        errorType += "-err-type";
	
	        overrideKey = el.attr("ng-" + errorType);
	        if (overrideKey === undefined) {
	          overrideKey = el.attr("data-ng-" + errorType) || el.attr(errorType);
	        }
	
	        if (overrideKey) {
	          overrideKey = overrideKey.replace(/[\W]/g, "");
	        }
	      }
	
	      return overrideKey;
	    },
	
	    /**
	     * @ngdoc function
	     * @name defaultErrorMessageResolver#resolve
	     * @methodOf defaultErrorMessageResolver
	     *
	     * @description
	     * Resolves a validate error type into a user validation error message
	     *
	     * @param {String} errorType - The type of validation error that has occurred.
	     * @param {Element} el - The input element that is the source of the validation error.
	     * @returns {Promise} A promise that is resolved when the validation message has been produced.
	     */
	    resolve = (function (_resolve) {
	      var _resolveWrapper = function resolve(_x, _x2) {
	        return _resolve.apply(this, arguments);
	      };
	
	      _resolveWrapper.toString = function () {
	        return _resolve.toString();
	      };
	
	      return _resolveWrapper;
	    })(function (errorType, el) {
	      var defer = $q.defer(),
	          errMsg,
	          parameters = [],
	          parameter,
	          messageTypeOverride;
	
	      if (cultureRetrievalPromise !== undefined) {
	        cultureRetrievalPromise.then(function () {
	          resolve(errorType, el).then(function (msg) {
	            defer.resolve(msg);
	          });
	        });
	      } else {
	        errMsg = angular.autoValidate.errorMessages[currentCulture][errorType];
	        messageTypeOverride = getMessageTypeOverride(errorType, el);
	        if (messageTypeOverride) {
	          errMsg = angular.autoValidate.errorMessages[currentCulture][messageTypeOverride];
	        }
	
	        if (errMsg === undefined) {
	          errMsg = angular.autoValidate.errorMessages[currentCulture].defaultMsg.format(errorType);
	        }
	
	        if (el && el.attr) {
	          try {
	            parameter = el.attr("ng-" + errorType);
	            if (parameter === undefined) {
	              parameter = el.attr("data-ng-" + errorType) || el.attr(errorType);
	            }
	
	            parameters.push(parameter || "");
	
	            errMsg = errMsg.format(parameters);
	          } catch (e) {}
	        }
	
	        defer.resolve(errMsg);
	      }
	
	      return defer.promise;
	    });
	
	    return {
	      setI18nFileRootPath: setI18nFileRootPath,
	      setCulture: setCulture,
	      getErrorMessages: getErrorMessages,
	      resolve: resolve
	    };
	  }
	
	  DefaultErrorMessageResolverFn.$inject = ["$q", "$http"];
	
	  angular.module("jcs-autoValidate").factory("defaultErrorMessageResolver", DefaultErrorMessageResolverFn);
	
	  function Foundation5ElementModifierFn() {
	    var reset = function reset(el, inputEl) {
	      angular.forEach(el.find("small"), function (smallEl) {
	        if (angular.element(smallEl).hasClass("error")) {
	          angular.element(smallEl).remove();
	        }
	      });
	
	      inputEl.removeClass("error");
	    },
	        findParentColumn = function findParentColumn(el) {
	      var parent = el;
	      for (var i = 0; i <= 3; i += 1) {
	        if (parent !== undefined && (parent.hasClass("columns") || parent.hasClass("column"))) {
	          break;
	        } else if (parent !== undefined) {
	          parent = parent.parent();
	        }
	      }
	
	      return parent;
	    },
	
	    /**
	     * @ngdoc function
	     * @name foundation5ElementModifier#makeValid
	     * @methodOf foundation5ElementModifier
	     *
	     * @description
	     * Makes an element appear valid by apply Foundation 5 specific styles and child elements.
	     * See: http://foundation.zurb.com/docs/components/forms.html
	     *
	     * @param {Element} el - The input control element that is the target of the validation.
	     */
	    makeValid = function makeValid(el) {
	      var parentColumn = findParentColumn(el);
	      reset(parentColumn && parentColumn.length > 0 ? parentColumn : el, el);
	    },
	
	    /**
	     * @ngdoc function
	     * @name foundation5ElementModifier#makeInvalid
	     * @methodOf foundation5ElementModifier
	     *
	     * @description
	     * Makes an element appear invalid by apply Foundation 5 specific styles and child elements.
	     * See: http://foundation.zurb.com/docs/components/forms.html
	     *
	     * @param {Element} el - The input control element that is the target of the validation.
	     */
	    makeInvalid = function makeInvalid(el, errorMsg) {
	      var parentColumn = findParentColumn(el),
	          helpTextEl;
	      reset(parentColumn || el, el);
	      el.addClass("error");
	      if (parentColumn) {
	        helpTextEl = angular.element("<small class=\"error\">" + errorMsg + "</small>");
	        parentColumn.append(helpTextEl);
	      }
	    },
	
	    /**
	     * @ngdoc function
	     * @name foundation5ElementModifier#makeDefault
	     * @methodOf foundation5ElementModifier
	     *
	     * @description
	     * Makes an element appear in its default visual state by apply foundation 5 specific styles and child elements.
	     *
	     * @param {Element} el - The input control element that is the target of the validation.
	     */
	    makeDefault = function makeDefault(el) {
	      makeValid(el);
	    };
	
	    return {
	      makeValid: makeValid,
	      makeInvalid: makeInvalid,
	      makeDefault: makeDefault,
	      key: "foundation5"
	    };
	  }
	
	  angular.module("jcs-autoValidate").factory("foundation5ElementModifier", Foundation5ElementModifierFn);
	
	  function ElementUtilsFn() {
	    var isElementVisible = function isElementVisible(el) {
	      return el[0].offsetWidth > 0 && el[0].offsetHeight > 0;
	    };
	
	    return {
	      isElementVisible: isElementVisible
	    };
	  }
	
	  function ValidationManagerFn(validator, elementUtils) {
	    var elementTypesToValidate = ["input", "textarea", "select", "form"],
	        elementIsVisible = function elementIsVisible(el) {
	      return elementUtils.isElementVisible(el);
	    },
	        getFormOptions = function getFormOptions(el) {
	      var frmCtrl = angular.element(el).controller("form"),
	          options;
	
	      if (frmCtrl !== undefined && frmCtrl !== null) {
	        options = frmCtrl.autoValidateFormOptions;
	      } else {
	        options = validator.defaultFormValidationOptions;
	      }
	
	      return options;
	    },
	
	    /**
	     * Only validate if the element is present, it is visible, if it is not a comment,
	     * it is either a valid user input control (input, select, textare, form) or
	     * it is a custom control register by the developer.
	     * @param el
	     * @param formOptions The validation options of the parent form
	     * @returns {boolean} true to indicate it should be validated
	     */
	    shouldValidateElement = function shouldValidateElement(el, formOptions, formSubmitted) {
	      var elementExists = el && el.length > 0,
	          isElementAComment = elementExists && el[0].nodeName.toLowerCase() === "#comment",
	          correctVisibilityToValidate,
	          correctTypeToValidate,
	          correctPhaseToValidate;
	
	      if (elementExists && isElementAComment === false) {
	        correctVisibilityToValidate = elementIsVisible(el) || formOptions.validateNonVisibleControls;
	        correctTypeToValidate = elementTypesToValidate.indexOf(el[0].nodeName.toLowerCase()) > -1 || el[0].hasAttribute("register-custom-form-control");
	        correctPhaseToValidate = formOptions.validateOnFormSubmit === false || formOptions.validateOnFormSubmit === true && formSubmitted === true;
	      }
	
	      return elementExists && !isElementAComment && correctVisibilityToValidate && correctTypeToValidate && correctPhaseToValidate;
	    },
	
	    /**
	     * @ngdoc validateElement
	     * @name validation#validateElement
	     * @param {object} modelCtrl holds the information about the element e.g. $invalid, $valid
	     * @param {options}
	     *  - forceValidation if set to true forces the validation even if the element is pristine
	     *  - disabled if set to true forces the validation is disabled and will return true
	     *  - validateNonVisibleControls if set to true forces the validation of non visible element i.e. display:block
	     * @description
	     * Validate the form element and make invalid/valid element model status.
	     *
	     * As of v1.17.22:
	     * BREAKING CHANGE to validateElement on the validationManger.  The third parameter is now the parent form's
	     * autoValidateFormOptions object on the form controller.  This can be left blank and will be found by the
	     * validationManager.
	     */
	    validateElement = function validateElement(modelCtrl, el, options) {
	      var isValid = true,
	          frmOptions = options || getFormOptions(el),
	          needsValidation = modelCtrl.$pristine === false || frmOptions.forceValidation,
	          errorType,
	          findErrorType = function findErrorType($errors) {
	        var keepGoing = true,
	            errorTypeToReturn;
	        angular.forEach($errors, function (status, errortype) {
	          if (keepGoing && status) {
	            keepGoing = false;
	            errorTypeToReturn = errortype;
	          }
	        });
	
	        return errorTypeToReturn;
	      };
	
	      if (frmOptions.disabled === false) {
	        if (frmOptions.forceValidation || shouldValidateElement(el, frmOptions, frmOptions.formController.$submitted) && modelCtrl && needsValidation) {
	          isValid = !modelCtrl.$invalid;
	
	          if (frmOptions.removeExternalValidationErrorsOnSubmit && modelCtrl.removeAllExternalValidation) {
	            modelCtrl.removeAllExternalValidation();
	          }
	
	          if (isValid) {
	            validator.makeValid(el);
	          } else {
	            errorType = findErrorType(modelCtrl.$errors || modelCtrl.$error);
	            if (errorType === undefined) {
	              // we have a weird situation some users are encountering where a custom control
	              // is valid but the ngModel is report it isn't and thus no valid error type can be found
	              isValid = true;
	            } else {
	              validator.getErrorMessage(errorType, el).then(function (errorMsg) {
	                validator.makeInvalid(el, errorMsg);
	              });
	            }
	          }
	        }
	      }
	
	      return isValid;
	    },
	        resetElement = function resetElement(element) {
	      validator.makeDefault(element);
	    },
	        resetForm = (function (_resetForm) {
	      var _resetFormWrapper = function resetForm(_x) {
	        return _resetForm.apply(this, arguments);
	      };
	
	      _resetFormWrapper.toString = function () {
	        return _resetForm.toString();
	      };
	
	      return _resetFormWrapper;
	    })(function (frmElement) {
	      angular.forEach(frmElement[0].all || frmElement[0].elements || frmElement[0], function (element) {
	        var controller,
	            ctrlElement = angular.element(element);
	        controller = ctrlElement.controller("ngModel");
	
	        if (controller !== undefined) {
	          if (ctrlElement[0].nodeName.toLowerCase() === "form") {
	            // we probably have a sub form
	            resetForm(ctrlElement);
	          } else {
	            controller.$setPristine();
	          }
	        }
	      });
	    }),
	        validateForm = (function (_validateForm) {
	      var _validateFormWrapper = function validateForm(_x) {
	        return _validateForm.apply(this, arguments);
	      };
	
	      _validateFormWrapper.toString = function () {
	        return _validateForm.toString();
	      };
	
	      return _validateFormWrapper;
	    })(function (frmElement) {
	      var frmValid = true,
	          frmCtrl = frmElement ? angular.element(frmElement).controller("form") : undefined,
	          processElement = function processElement(ctrlElement, force, formOptions) {
	        var controller, isValid, ctrlFormOptions, originalForceValue;
	
	        ctrlElement = angular.element(ctrlElement);
	        controller = ctrlElement.controller("ngModel");
	
	        if (controller !== undefined && (force || shouldValidateElement(ctrlElement, formOptions, frmCtrl.$submitted))) {
	          if (ctrlElement[0].nodeName.toLowerCase() === "form") {
	            // we probably have a sub form
	            validateForm(ctrlElement);
	          } else {
	            // we need to get the options for the element rather than use the passed in as the
	            // element could be an ng-form and have different options to the parent form.
	            ctrlFormOptions = getFormOptions(ctrlElement);
	            originalForceValue = ctrlFormOptions.forceValidation;
	            ctrlFormOptions.forceValidation = force;
	            try {
	              isValid = validateElement(controller, ctrlElement, ctrlFormOptions);
	              frmValid = frmValid && isValid;
	            } finally {
	              ctrlFormOptions.forceValidation = originalForceValue;
	            }
	          }
	        }
	      },
	          clonedOptions;
	
	      if (frmElement === undefined || frmCtrl !== undefined && frmCtrl.autoValidateFormOptions.disabled) {
	        return frmElement !== undefined;
	      }
	
	      //force the validation of controls
	      clonedOptions = angular.copy(frmCtrl.autoValidateFormOptions);
	      clonedOptions.forceValidation = true;
	
	      // IE8 holds the child controls collection in the all property
	      // Firefox in the elements and chrome as a child iterator
	      angular.forEach(frmElement[0].all || frmElement[0].elements || frmElement[0], function (ctrlElement) {
	        processElement(ctrlElement, true, clonedOptions);
	      });
	
	      // If you have a custom form control that should be validated i.e.
	      // <my-custom-element>...</my-custom-element> it will not be part of the forms
	      // HTMLFormControlsCollection and thus won't be included in the above element iteration although
	      // it will be on the Angular FormController (if it has a name attribute).  So adding the directive
	      // register-custom-form-control="" to the control root and autoValidate will include it in this
	      // iteration.
	      if (frmElement[0].customHTMLFormControlsCollection) {
	        angular.forEach(frmElement[0].customHTMLFormControlsCollection, function (ctrlElement) {
	          // need to force the validation as the element might not be a known form input type
	          // so the normal validation process will ignore it.
	          processElement(ctrlElement, true, clonedOptions);
	        });
	      }
	
	      return frmValid;
	    }),
	        setElementValidationError = function setElementValidationError(element, errorMsgKey, errorMsg) {
	      if (errorMsgKey) {
	        validator.getErrorMessage(errorMsgKey, element).then(function (msg) {
	          validator.makeInvalid(element, msg);
	        });
	      } else {
	        validator.makeInvalid(element, errorMsg);
	      }
	    };
	
	    return {
	      setElementValidationError: setElementValidationError,
	      validateElement: validateElement,
	      validateForm: validateForm,
	      resetElement: resetElement,
	      resetForm: resetForm
	    };
	  }
	
	  ValidationManagerFn.$inject = ["validator", "jcs-elementUtils"];
	
	  angular.module("jcs-autoValidate").factory("jcs-elementUtils", ElementUtilsFn);
	  angular.module("jcs-autoValidate").factory("validationManager", ValidationManagerFn);
	
	  function parseBooleanAttributeValue(val, defaultValue) {
	    if ((val === undefined || val === null) && defaultValue !== undefined) {
	      return defaultValue;
	    } else {
	      return val !== "false";
	    }
	  }
	
	  function parseOptions(ctrl, validator, attrs) {
	    var opts = ctrl.autoValidateFormOptions = ctrl.autoValidateFormOptions || angular.copy(validator.defaultFormValidationOptions);
	    opts.formController = ctrl;
	    opts.forceValidation = false;
	    opts.disabled = !validator.isEnabled() || parseBooleanAttributeValue(attrs.disableDynamicValidation, opts.disabled);
	    opts.validateNonVisibleControls = parseBooleanAttributeValue(attrs.validateNonVisibleControls, opts.validateNonVisibleControls);
	    opts.validateOnFormSubmit = parseBooleanAttributeValue(attrs.validateOnFormSubmit, opts.validateOnFormSubmit);
	    opts.removeExternalValidationErrorsOnSubmit = attrs.removeExternalValidationErrorsOnSubmit === undefined ? opts.removeExternalValidationErrorsOnSubmit : parseBooleanAttributeValue(attrs.removeExternalValidationErrorsOnSubmit, opts.removeExternalValidationErrorsOnSubmit);
	
	    // the library might be globally disabled but enabled on a particular form so check the
	    // disableDynamicValidation attribute is on the form
	    if (validator.isEnabled() === false && attrs.disableDynamicValidation === "false") {
	      opts.disabled = false;
	    }
	  }
	
	  angular.module("jcs-autoValidate").directive("form", ["validator", function (validator) {
	    return {
	      restrict: "E",
	      require: "form",
	      priority: 9999,
	      compile: function compile() {
	        return {
	          pre: function pre(scope, element, attrs, ctrl) {
	            parseOptions(ctrl, validator, attrs);
	          }
	        };
	      }
	    };
	  }]);
	
	  angular.module("jcs-autoValidate").directive("ngForm", ["validator", function (validator) {
	    return {
	      restrict: "EA",
	      require: "form",
	      priority: 9999,
	      compile: function compile() {
	        return {
	          pre: function pre(scope, element, attrs, ctrl) {
	            parseOptions(ctrl, validator, attrs);
	          }
	        };
	      }
	    };
	  }]);
	
	  function FormResetDirectiveFn(validationManager) {
	    return {
	      restrict: "E",
	      link: function link(scope, el) {
	        var formController = el.controller("form");
	
	        function resetFn() {
	          validationManager.resetForm(el);
	          if (formController.$setPristine) {
	            formController.$setPristine();
	          }
	
	          if (formController.$setUntouched) {
	            formController.$setUntouched();
	          }
	        }
	
	        if (formController !== undefined && formController.autoValidateFormOptions && formController.autoValidateFormOptions.disabled === false) {
	          el.on("reset", resetFn);
	
	          scope.$on("$destroy", function () {
	            el.off("reset", resetFn);
	          });
	        }
	      }
	    };
	  }
	
	  FormResetDirectiveFn.$inject = ["validationManager"];
	
	  angular.module("jcs-autoValidate").directive("form", FormResetDirectiveFn);
	
	  function RegisterCustomFormControlFn() {
	    var findParentForm = function findParentForm(el) {
	      var parent = el;
	      for (var i = 0; i <= 50; i += 1) {
	        if (parent !== undefined && parent.nodeName.toLowerCase() === "form") {
	          break;
	        } else if (parent !== undefined) {
	          parent = angular.element(parent).parent()[0];
	        }
	      }
	
	      return parent;
	    };
	
	    return {
	      restrict: "A",
	      link: function link(scope, element) {
	        var frmEl = findParentForm(element.parent()[0]);
	        if (frmEl) {
	          frmEl.customHTMLFormControlsCollection = frmEl.customHTMLFormControlsCollection || [];
	          frmEl.customHTMLFormControlsCollection.push(element[0]);
	        }
	      }
	    };
	  }
	
	  angular.module("jcs-autoValidate").directive("registerCustomFormControl", RegisterCustomFormControlFn);
	
	  function SubmitDecorator($delegate, $parse, validationManager) {
	    $delegate[0].compile = function ($element, attrs) {
	      var fn = $parse(attrs.ngSubmit),
	          force = attrs.ngSubmitForce === "true";
	
	      return function (scope, element) {
	        var formController = element.controller("form"),
	            resetListenerOffFn;
	
	        function handlerFn(event) {
	          scope.$apply(function () {
	            if (formController !== undefined && formController !== null && formController.autoValidateFormOptions && formController.autoValidateFormOptions.disabled === true) {
	              fn(scope, {
	                $event: event
	              });
	            } else {
	              if (formController.$setSubmitted === undefined) {
	                // we probably have angular <= 1.2
	                formController.$submitted = true;
	              }
	
	              if (validationManager.validateForm(element) || force === true) {
	                fn(scope, {
	                  $event: event
	                });
	              }
	            }
	          });
	        }
	
	        function resetFormFn() {
	          if (element[0].reset) {
	            element[0].reset();
	          } else {
	            validationManager.resetForm(element);
	          }
	        }
	
	        if (formController && formController.autoValidateFormOptions) {
	          // allow the form to be reset programatically or via raising the event
	          // form:formName:reset
	          formController.autoValidateFormOptions.resetForm = resetFormFn;
	          if (formController.$name !== undefined && formController.$name !== "") {
	            resetListenerOffFn = scope.$on("form:" + formController.$name + ":reset", resetFormFn);
	          }
	        }
	
	        element.on("submit", handlerFn);
	        scope.$on("$destroy", function () {
	          element.off("submit", handlerFn);
	          if (resetListenerOffFn) {
	            resetListenerOffFn();
	          }
	        });
	      };
	    };
	
	    return $delegate;
	  }
	
	  SubmitDecorator.$inject = ["$delegate", "$parse", "validationManager"];
	
	  function ProviderFn($provide) {
	    $provide.decorator("ngSubmitDirective", SubmitDecorator);
	  }
	
	  ProviderFn.$inject = ["$provide"];
	
	  angular.module("jcs-autoValidate").config(ProviderFn);
	
	  angular.module("jcs-autoValidate").config(["$provide", function ($provide) {
	    $provide.decorator("ngModelDirective", ["$timeout", "$delegate", "validationManager", "jcs-debounce", function ($timeout, $delegate, validationManager, debounce) {
	      var directive = $delegate[0],
	          link = directive.link || directive.compile;
	
	      directive.compile = function (el) {
	        var supportsNgModelOptions = angular.version.major >= 1 && angular.version.minor >= 3,
	            originalLink = link;
	
	        // in the RC of 1.3 there is no directive.link only the directive.compile which
	        // needs to be invoked to get at the link functions.
	        if (supportsNgModelOptions && angular.isFunction(link)) {
	          originalLink = link(el);
	        }
	
	        return {
	          pre: function pre(scope, element, attrs, ctrls) {
	            var ngModelCtrl = ctrls[0],
	                frmCtrl = ctrls[1],
	                ngModelOptions = attrs.ngModelOptions === undefined ? undefined : scope.$eval(attrs.ngModelOptions),
	                setValidity = ngModelCtrl.$setValidity,
	                setPristine = ngModelCtrl.$setPristine,
	                setValidationState = debounce.debounce(function () {
	              var validateOptions = frmCtrl !== undefined && frmCtrl !== null ? frmCtrl.autoValidateFormOptions : undefined;
	              validationManager.validateElement(ngModelCtrl, element, validateOptions);
	            }, 100);
	
	            if (attrs.formnovalidate === undefined && (frmCtrl !== undefined && frmCtrl !== null && frmCtrl.autoValidateFormOptions && frmCtrl.autoValidateFormOptions.disabled === false)) {
	              if (!supportsNgModelOptions || ngModelOptions === undefined || ngModelOptions.updateOn === undefined || ngModelOptions.updateOn === "") {
	                ngModelCtrl.$setValidity = function (validationErrorKey, isValid) {
	                  setValidity.call(ngModelCtrl, validationErrorKey, isValid);
	                  setValidationState();
	                };
	              } else {
	                element.on(ngModelOptions.updateOn, function () {
	                  setValidationState();
	                });
	
	                scope.$on("$destroy", function () {
	                  element.off(ngModelOptions.updateOn);
	                });
	              }
	
	              // We override this so we can reset the element state when it is called.
	              ngModelCtrl.$setPristine = function () {
	                setPristine.call(ngModelCtrl);
	                validationManager.resetElement(element);
	              };
	
	              ngModelCtrl.autoValidated = true;
	            }
	
	            ngModelCtrl.setExternalValidation = function (errorMsgKey, errorMessage, addToModelErrors) {
	              if (addToModelErrors) {
	                var collection = ngModelCtrl.$error || ngModelCtrl.$errors;
	                collection[errorMsgKey] = false;
	              }
	
	              ngModelCtrl.externalErrors = ngModelCtrl.externalErrors || {};
	              ngModelCtrl.externalErrors[errorMsgKey] = false;
	              validationManager.setElementValidationError(element, errorMsgKey, errorMessage);
	            };
	
	            ngModelCtrl.removeExternalValidation = function (errorMsgKey, addToModelErrors) {
	              if (addToModelErrors) {
	                var collection = ngModelCtrl.$error || ngModelCtrl.$errors;
	                delete collection[errorMsgKey];
	              }
	
	              if (ngModelCtrl.externalErrors) {
	                delete ngModelCtrl.externalErrors[errorMsgKey];
	              }
	
	              validationManager.resetElement(element);
	            };
	
	            ngModelCtrl.removeAllExternalValidation = function () {
	              if (ngModelCtrl.externalErrors) {
	                var errorCollection = ngModelCtrl.$error || ngModelCtrl.$errors;
	                angular.forEach(ngModelCtrl.externalErrors, function (value, key) {
	                  delete errorCollection[key];
	                });
	
	                ngModelCtrl.externalErrors = {};
	
	                validationManager.resetElement(element);
	              }
	            };
	
	            if (frmCtrl) {
	              frmCtrl.setExternalValidation = function (modelProperty, errorMsgKey, errorMessageOverride, addToModelErrors) {
	                var success = false;
	                if (frmCtrl[modelProperty]) {
	                  frmCtrl[modelProperty].setExternalValidation(errorMsgKey, errorMessageOverride, addToModelErrors);
	                  success = true;
	                }
	
	                return success;
	              };
	
	              frmCtrl.removeExternalValidation = function (modelProperty, errorMsgKey, errorMessageOverride, addToModelErrors) {
	                var success = false;
	                if (frmCtrl[modelProperty]) {
	                  frmCtrl[modelProperty].removeExternalValidation(errorMsgKey, addToModelErrors);
	                  success = true;
	                }
	
	                return success;
	              };
	            }
	
	            return originalLink.pre ? originalLink.pre.apply(this, arguments) : this;
	          },
	          post: function post(scope, element, attrs, ctrls) {
	            return originalLink.post ? originalLink.post.apply(this, arguments) : originalLink.apply(this, arguments);
	          }
	        };
	      };
	
	      return $delegate;
	    }]);
	  }]);
	
	  function AutoValidateRunFn(validator, defaultErrorMessageResolver, bootstrap3ElementModifier, foundation5ElementModifier) {
	    validator.setErrorMessageResolver(defaultErrorMessageResolver.resolve);
	    validator.registerDomModifier(bootstrap3ElementModifier.key, bootstrap3ElementModifier);
	    validator.registerDomModifier(foundation5ElementModifier.key, foundation5ElementModifier);
	    validator.setDefaultElementModifier(bootstrap3ElementModifier.key);
	  }
	
	  AutoValidateRunFn.$inject = ["validator", "defaultErrorMessageResolver", "bootstrap3ElementModifier", "foundation5ElementModifier"];
	
	  angular.module("jcs-autoValidate").run(AutoValidateRunFn);
	})(String, angular);

/***/ }),
/* 223 */
/***/ (function(module, exports) {

	"use strict";angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.transition", "ui.bootstrap.collapse", "ui.bootstrap.accordion", "ui.bootstrap.alert", "ui.bootstrap.bindHtml", "ui.bootstrap.buttons", "ui.bootstrap.carousel", "ui.bootstrap.dateparser", "ui.bootstrap.position", "ui.bootstrap.datepicker", "ui.bootstrap.dropdown", "ui.bootstrap.modal", "ui.bootstrap.pagination", "ui.bootstrap.tooltip", "ui.bootstrap.popover", "ui.bootstrap.progressbar", "ui.bootstrap.rating", "ui.bootstrap.tabs", "ui.bootstrap.timepicker", "ui.bootstrap.typeahead"]);angular.module("ui.bootstrap.tpls", ["template/accordion/accordion-group.html", "template/accordion/accordion.html", "template/alert/alert.html", "template/carousel/carousel.html", "template/carousel/slide.html", "template/datepicker/datepicker.html", "template/datepicker/day.html", "template/datepicker/month.html", "template/datepicker/popup.html", "template/datepicker/year.html", "template/modal/backdrop.html", "template/modal/window.html", "template/pagination/pager.html", "template/pagination/pagination.html", "template/tooltip/tooltip-html-unsafe-popup.html", "template/tooltip/tooltip-popup.html", "template/popover/popover.html", "template/progressbar/bar.html", "template/progressbar/progress.html", "template/progressbar/progressbar.html", "template/rating/rating.html", "template/tabs/tab.html", "template/tabs/tabset.html", "template/timepicker/timepicker.html", "template/typeahead/typeahead-match.html", "template/typeahead/typeahead-popup.html"]);angular.module("ui.bootstrap.transition", []).factory("$transition", ["$q", "$timeout", "$rootScope", function($q, $timeout, $rootScope){var $transition=(function(_$transition){var _$transitionWrapper=function $transition(_x, _x2, _x3){return _$transition.apply(this, arguments);};_$transitionWrapper.toString = function(){return _$transition.toString();};return _$transitionWrapper;})(function(element, trigger, options){options = options || {};var deferred=$q.defer();var endEventName=$transition[options.animation?"animationEndEventName":"transitionEndEventName"];var transitionEndHandler=(function(_transitionEndHandler){var _transitionEndHandlerWrapper=function transitionEndHandler(_x4){return _transitionEndHandler.apply(this, arguments);};_transitionEndHandlerWrapper.toString = function(){return _transitionEndHandler.toString();};return _transitionEndHandlerWrapper;})(function(event){$rootScope.$apply(function(){element.unbind(endEventName, transitionEndHandler);deferred.resolve(element);});});if(endEventName){element.bind(endEventName, transitionEndHandler);}$timeout(function(){if(angular.isString(trigger)){element.addClass(trigger);}else if(angular.isFunction(trigger)){trigger(element);}else if(angular.isObject(trigger)){element.css(trigger);}if(!endEventName){deferred.resolve(element);}});deferred.promise.cancel = function(){if(endEventName){element.unbind(endEventName, transitionEndHandler);}deferred.reject("Transition cancelled");};return deferred.promise;});var transElement=document.createElement("trans");var transitionEndEventNames={WebkitTransition:"webkitTransitionEnd", MozTransition:"transitionend", OTransition:"oTransitionEnd", transition:"transitionend"};var animationEndEventNames={WebkitTransition:"webkitAnimationEnd", MozTransition:"animationend", OTransition:"oAnimationEnd", transition:"animationend"};function findEndEventName(endEventNames){for(var name in endEventNames) {if(transElement.style[name] !== undefined){return endEventNames[name];}}}$transition.transitionEndEventName = findEndEventName(transitionEndEventNames);$transition.animationEndEventName = findEndEventName(animationEndEventNames);return $transition;}]);angular.module("ui.bootstrap.collapse", ["ui.bootstrap.transition"]).directive("collapse", ["$transition", function($transition){return {link:function link(scope, element, attrs){var initialAnimSkip=true;var currentTransition;function doTransition(change){var newTransition=$transition(element, change);if(currentTransition){currentTransition.cancel();}currentTransition = newTransition;newTransition.then(newTransitionDone, newTransitionDone);return newTransition;function newTransitionDone(){if(currentTransition === newTransition){currentTransition = undefined;}}}function expand(){if(initialAnimSkip){initialAnimSkip = false;expandDone();}else {element.removeClass("collapse").addClass("collapsing");doTransition({height:element[0].scrollHeight + "px"}).then(expandDone);}}function expandDone(){element.removeClass("collapsing");element.addClass("collapse in");element.css({height:"auto"});}function collapse(){if(initialAnimSkip){initialAnimSkip = false;collapseDone();element.css({height:0});}else {element.css({height:element[0].scrollHeight + "px"});var x=element[0].offsetWidth;element.removeClass("collapse in").addClass("collapsing");doTransition({height:0}).then(collapseDone);}}function collapseDone(){element.removeClass("collapsing");element.addClass("collapse");}scope.$watch(attrs.collapse, function(shouldCollapse){if(shouldCollapse){collapse();}else {expand();}});}};}]);angular.module("ui.bootstrap.accordion", ["ui.bootstrap.collapse"]).constant("accordionConfig", {closeOthers:true}).controller("AccordionController", ["$scope", "$attrs", "accordionConfig", function($scope, $attrs, accordionConfig){this.groups = [];this.closeOthers = function(openGroup){var closeOthers=angular.isDefined($attrs.closeOthers)?$scope.$eval($attrs.closeOthers):accordionConfig.closeOthers;if(closeOthers){angular.forEach(this.groups, function(group){if(group !== openGroup){group.isOpen = false;}});}};this.addGroup = function(groupScope){var that=this;this.groups.push(groupScope);groupScope.$on("$destroy", function(event){that.removeGroup(groupScope);});};this.removeGroup = function(group){var index=this.groups.indexOf(group);if(index !== -1){this.groups.splice(index, 1);}};}]).directive("accordion", function(){return {restrict:"EA", controller:"AccordionController", transclude:true, replace:false, templateUrl:"template/accordion/accordion.html"};}).directive("accordionGroup", function(){return {require:"^accordion", restrict:"EA", transclude:true, replace:true, templateUrl:"template/accordion/accordion-group.html", scope:{heading:"@", isOpen:"=?", isDisabled:"=?"}, controller:function controller(){this.setHeading = function(element){this.heading = element;};}, link:function link(scope, element, attrs, accordionCtrl){accordionCtrl.addGroup(scope);scope.$watch("isOpen", function(value){if(value){accordionCtrl.closeOthers(scope);}});scope.toggleOpen = function(){if(!scope.isDisabled){scope.isOpen = !scope.isOpen;}};}};}).directive("accordionHeading", function(){return {restrict:"EA", transclude:true, template:"", replace:true, require:"^accordionGroup", link:function link(scope, element, attr, accordionGroupCtrl, transclude){accordionGroupCtrl.setHeading(transclude(scope, function(){}));}};}).directive("accordionTransclude", function(){return {require:"^accordionGroup", link:function link(scope, element, attr, controller){scope.$watch(function(){return controller[attr.accordionTransclude];}, function(heading){if(heading){element.html("");element.append(heading);}});}};});angular.module("ui.bootstrap.alert", []).controller("AlertController", ["$scope", "$attrs", function($scope, $attrs){$scope.closeable = "close" in $attrs;this.close = $scope.close;}]).directive("alert", function(){return {restrict:"EA", controller:"AlertController", templateUrl:"template/alert/alert.html", transclude:true, replace:true, scope:{type:"@", close:"&"}};}).directive("dismissOnTimeout", ["$timeout", function($timeout){return {require:"alert", link:function link(scope, element, attrs, alertCtrl){$timeout(function(){alertCtrl.close();}, parseInt(attrs.dismissOnTimeout, 10));}};}]);angular.module("ui.bootstrap.bindHtml", []).directive("bindHtmlUnsafe", function(){return function(scope, element, attr){element.addClass("ng-binding").data("$binding", attr.bindHtmlUnsafe);scope.$watch(attr.bindHtmlUnsafe, function bindHtmlUnsafeWatchAction(value){element.html(value || "");});};});angular.module("ui.bootstrap.buttons", []).constant("buttonConfig", {activeClass:"active", toggleEvent:"click"}).controller("ButtonsController", ["buttonConfig", function(buttonConfig){this.activeClass = buttonConfig.activeClass || "active";this.toggleEvent = buttonConfig.toggleEvent || "click";}]).directive("btnRadio", function(){return {require:["btnRadio", "ngModel"], controller:"ButtonsController", link:function link(scope, element, attrs, ctrls){var buttonsCtrl=ctrls[0], ngModelCtrl=ctrls[1];ngModelCtrl.$render = function(){element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.btnRadio)));};element.bind(buttonsCtrl.toggleEvent, function(){var isActive=element.hasClass(buttonsCtrl.activeClass);if(!isActive || angular.isDefined(attrs.uncheckable)){scope.$apply(function(){ngModelCtrl.$setViewValue(isActive?null:scope.$eval(attrs.btnRadio));ngModelCtrl.$render();});}});}};}).directive("btnCheckbox", function(){return {require:["btnCheckbox", "ngModel"], controller:"ButtonsController", link:function link(scope, element, attrs, ctrls){var buttonsCtrl=ctrls[0], ngModelCtrl=ctrls[1];function getTrueValue(){return getCheckboxValue(attrs.btnCheckboxTrue, true);}function getFalseValue(){return getCheckboxValue(attrs.btnCheckboxFalse, false);}function getCheckboxValue(attributeValue, defaultValue){var val=scope.$eval(attributeValue);return angular.isDefined(val)?val:defaultValue;}ngModelCtrl.$render = function(){element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));};element.bind(buttonsCtrl.toggleEvent, function(){scope.$apply(function(){ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass)?getFalseValue():getTrueValue());ngModelCtrl.$render();});});}};});angular.module("ui.bootstrap.carousel", ["ui.bootstrap.transition"]).controller("CarouselController", ["$scope", "$timeout", "$interval", "$transition", function($scope, $timeout, $interval, $transition){var self=this, slides=self.slides = $scope.slides = [], currentIndex=-1, currentInterval, isPlaying;self.currentSlide = null;var destroyed=false;self.select = $scope.select = function(nextSlide, direction){var nextIndex=slides.indexOf(nextSlide);if(direction === undefined){direction = nextIndex > currentIndex?"next":"prev";}if(nextSlide && nextSlide !== self.currentSlide){if($scope.$currentTransition){$scope.$currentTransition.cancel();$timeout(goNext);}else {goNext();}}function goNext(){if(destroyed){return;}if(self.currentSlide && angular.isString(direction) && !$scope.noTransition && nextSlide.$element){nextSlide.$element.addClass(direction);var reflow=nextSlide.$element[0].offsetWidth;angular.forEach(slides, function(slide){angular.extend(slide, {direction:"", entering:false, leaving:false, active:false});});angular.extend(nextSlide, {direction:direction, active:true, entering:true});angular.extend(self.currentSlide || {}, {direction:direction, leaving:true});$scope.$currentTransition = $transition(nextSlide.$element, {});(function(next, current){$scope.$currentTransition.then(function(){transitionDone(next, current);}, function(){transitionDone(next, current);});})(nextSlide, self.currentSlide);}else {transitionDone(nextSlide, self.currentSlide);}self.currentSlide = nextSlide;currentIndex = nextIndex;restartTimer();}function transitionDone(next, current){angular.extend(next, {direction:"", active:true, leaving:false, entering:false});angular.extend(current || {}, {direction:"", active:false, leaving:false, entering:false});$scope.$currentTransition = null;}};$scope.$on("$destroy", function(){destroyed = true;});self.indexOfSlide = function(slide){return slides.indexOf(slide);};$scope.next = function(){var newIndex=(currentIndex + 1) % slides.length;if(!$scope.$currentTransition){return self.select(slides[newIndex], "next");}};$scope.prev = function(){var newIndex=currentIndex - 1 < 0?slides.length - 1:currentIndex - 1;if(!$scope.$currentTransition){return self.select(slides[newIndex], "prev");}};$scope.isActive = function(slide){return self.currentSlide === slide;};$scope.$watch("interval", restartTimer);$scope.$on("$destroy", resetTimer);function restartTimer(){resetTimer();var interval=+$scope.interval;if(!isNaN(interval) && interval > 0){currentInterval = $interval(timerFn, interval);}}function resetTimer(){if(currentInterval){$interval.cancel(currentInterval);currentInterval = null;}}function timerFn(){var interval=+$scope.interval;if(isPlaying && !isNaN(interval) && interval > 0){$scope.next();}else {$scope.pause();}}$scope.play = function(){if(!isPlaying){isPlaying = true;restartTimer();}};$scope.pause = function(){if(!$scope.noPause){isPlaying = false;resetTimer();}};self.addSlide = function(slide, element){slide.$element = element;slides.push(slide);if(slides.length === 1 || slide.active){self.select(slides[slides.length - 1]);if(slides.length == 1){$scope.play();}}else {slide.active = false;}};self.removeSlide = function(slide){var index=slides.indexOf(slide);slides.splice(index, 1);if(slides.length > 0 && slide.active){if(index >= slides.length){self.select(slides[index - 1]);}else {self.select(slides[index]);}}else if(currentIndex > index){currentIndex--;}};}]).directive("carousel", [function(){return {restrict:"EA", transclude:true, replace:true, controller:"CarouselController", require:"carousel", templateUrl:"template/carousel/carousel.html", scope:{interval:"=", noTransition:"=", noPause:"="}};}]).directive("slide", function(){return {require:"^carousel", restrict:"EA", transclude:true, replace:true, templateUrl:"template/carousel/slide.html", scope:{active:"=?"}, link:function link(scope, element, attrs, carouselCtrl){carouselCtrl.addSlide(scope, element);scope.$on("$destroy", function(){carouselCtrl.removeSlide(scope);});scope.$watch("active", function(active){if(active){carouselCtrl.select(scope);}});}};});angular.module("ui.bootstrap.dateparser", []).service("dateParser", ["$locale", "orderByFilter", function($locale, orderByFilter){this.parsers = {};var formatCodeToRegex={yyyy:{regex:"\\d{4}", apply:function apply(value){this.year = +value;}}, yy:{regex:"\\d{2}", apply:function apply(value){this.year = +value + 2000;}}, y:{regex:"\\d{1,4}", apply:function apply(value){this.year = +value;}}, MMMM:{regex:$locale.DATETIME_FORMATS.MONTH.join("|"), apply:function apply(value){this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value);}}, MMM:{regex:$locale.DATETIME_FORMATS.SHORTMONTH.join("|"), apply:function apply(value){this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value);}}, MM:{regex:"0[1-9]|1[0-2]", apply:function apply(value){this.month = value - 1;}}, M:{regex:"[1-9]|1[0-2]", apply:function apply(value){this.month = value - 1;}}, dd:{regex:"[0-2][0-9]{1}|3[0-1]{1}", apply:function apply(value){this.date = +value;}}, d:{regex:"[1-2]?[0-9]{1}|3[0-1]{1}", apply:function apply(value){this.date = +value;}}, EEEE:{regex:$locale.DATETIME_FORMATS.DAY.join("|")}, EEE:{regex:$locale.DATETIME_FORMATS.SHORTDAY.join("|")}};function createParser(format){var map=[], regex=format.split("");angular.forEach(formatCodeToRegex, function(data, code){var index=format.indexOf(code);if(index > -1){format = format.split("");regex[index] = "(" + data.regex + ")";format[index] = "$";for(var i=index + 1, n=index + code.length; i < n; i++) {regex[i] = "";format[i] = "$";}format = format.join("");map.push({index:index, apply:data.apply});}});return {regex:new RegExp("^" + regex.join("") + "$"), map:orderByFilter(map, "index")};}this.parse = function(input, format){if(!angular.isString(input) || !format){return input;}format = $locale.DATETIME_FORMATS[format] || format;if(!this.parsers[format]){this.parsers[format] = createParser(format);}var parser=this.parsers[format], regex=parser.regex, map=parser.map, results=input.match(regex);if(results && results.length){var fields={year:1900, month:0, date:1, hours:0}, dt;for(var i=1, n=results.length; i < n; i++) {var mapper=map[i - 1];if(mapper.apply){mapper.apply.call(fields, results[i]);}}if(isValid(fields.year, fields.month, fields.date)){dt = new Date(fields.year, fields.month, fields.date, fields.hours);}return dt;}};function isValid(year, month, date){if(month === 1 && date > 28){return date === 29 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);}if(month === 3 || month === 5 || month === 8 || month === 10){return date < 31;}return true;}}]);angular.module("ui.bootstrap.position", []).factory("$position", ["$document", "$window", function($document, $window){function getStyle(el, cssprop){if(el.currentStyle){return el.currentStyle[cssprop];}else if($window.getComputedStyle){return $window.getComputedStyle(el)[cssprop];}return el.style[cssprop];}function isStaticPositioned(element){return (getStyle(element, "position") || "static") === "static";}var parentOffsetEl=function parentOffsetEl(element){var docDomEl=$document[0];var offsetParent=element.offsetParent || docDomEl;while(offsetParent && offsetParent !== docDomEl && isStaticPositioned(offsetParent)) {offsetParent = offsetParent.offsetParent;}return offsetParent || docDomEl;};return {position:function position(element){var elBCR=this.offset(element);var offsetParentBCR={top:0, left:0};var offsetParentEl=parentOffsetEl(element[0]);if(offsetParentEl != $document[0]){offsetParentBCR = this.offset(angular.element(offsetParentEl));offsetParentBCR.top += offsetParentEl.clientTop - offsetParentEl.scrollTop;offsetParentBCR.left += offsetParentEl.clientLeft - offsetParentEl.scrollLeft;}var boundingClientRect=element[0].getBoundingClientRect();return {width:boundingClientRect.width || element.prop("offsetWidth"), height:boundingClientRect.height || element.prop("offsetHeight"), top:elBCR.top - offsetParentBCR.top, left:elBCR.left - offsetParentBCR.left};}, offset:function offset(element){var boundingClientRect=element[0].getBoundingClientRect();return {width:boundingClientRect.width || element.prop("offsetWidth"), height:boundingClientRect.height || element.prop("offsetHeight"), top:boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop), left:boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)};}, positionElements:function positionElements(hostEl, targetEl, positionStr, appendToBody){var positionStrParts=positionStr.split("-");var pos0=positionStrParts[0], pos1=positionStrParts[1] || "center";var hostElPos, targetElWidth, targetElHeight, targetElPos;hostElPos = appendToBody?this.offset(hostEl):this.position(hostEl);targetElWidth = targetEl.prop("offsetWidth");targetElHeight = targetEl.prop("offsetHeight");var shiftWidth={center:function center(){return hostElPos.left + hostElPos.width / 2 - targetElWidth / 2;}, left:function left(){return hostElPos.left;}, right:function right(){return hostElPos.left + hostElPos.width;}};var shiftHeight={center:function center(){return hostElPos.top + hostElPos.height / 2 - targetElHeight / 2;}, top:function top(){return hostElPos.top;}, bottom:function bottom(){return hostElPos.top + hostElPos.height;}};switch(pos0){case "right":targetElPos = {top:shiftHeight[pos1](), left:shiftWidth[pos0]()};break;case "left":targetElPos = {top:shiftHeight[pos1](), left:hostElPos.left - targetElWidth};break;case "bottom":targetElPos = {top:shiftHeight[pos0](), left:shiftWidth[pos1]()};break;default:targetElPos = {top:hostElPos.top - targetElHeight, left:shiftWidth[pos1]()};break;}return targetElPos;}};}]);angular.module("ui.bootstrap.datepicker", ["ui.bootstrap.dateparser", "ui.bootstrap.position"]).constant("datepickerConfig", {formatDay:"dd", formatMonth:"MMMM", formatYear:"yyyy", formatDayHeader:"EEE", formatDayTitle:"MMMM yyyy", formatMonthTitle:"yyyy", datepickerMode:"day", minMode:"day", maxMode:"year", showWeeks:true, startingDay:0, yearRange:20, minDate:null, maxDate:null}).controller("DatepickerController", ["$scope", "$attrs", "$parse", "$interpolate", "$timeout", "$log", "dateFilter", "datepickerConfig", function($scope, $attrs, $parse, $interpolate, $timeout, $log, dateFilter, datepickerConfig){var self=this, ngModelCtrl={$setViewValue:angular.noop};this.modes = ["day", "month", "year"];angular.forEach(["formatDay", "formatMonth", "formatYear", "formatDayHeader", "formatDayTitle", "formatMonthTitle", "minMode", "maxMode", "showWeeks", "startingDay", "yearRange"], function(key, index){self[key] = angular.isDefined($attrs[key])?index < 8?$interpolate($attrs[key])($scope.$parent):$scope.$parent.$eval($attrs[key]):datepickerConfig[key];});angular.forEach(["minDate", "maxDate"], function(key){if($attrs[key]){$scope.$parent.$watch($parse($attrs[key]), function(value){self[key] = value?new Date(value):null;self.refreshView();});}else {self[key] = datepickerConfig[key]?new Date(datepickerConfig[key]):null;}});$scope.datepickerMode = $scope.datepickerMode || datepickerConfig.datepickerMode;$scope.uniqueId = "datepicker-" + $scope.$id + "-" + Math.floor(Math.random() * 10000);this.activeDate = angular.isDefined($attrs.initDate)?$scope.$parent.$eval($attrs.initDate):new Date();$scope.isActive = function(dateObject){if(self.compare(dateObject.date, self.activeDate) === 0){$scope.activeDateId = dateObject.uid;return true;}return false;};this.init = function(ngModelCtrl_){ngModelCtrl = ngModelCtrl_;ngModelCtrl.$render = function(){self.render();};};this.render = function(){if(ngModelCtrl.$modelValue){var date=new Date(ngModelCtrl.$modelValue), isValid=!isNaN(date);if(isValid){this.activeDate = date;}else {$log.error("Datepicker directive: \"ng-model\" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.");}ngModelCtrl.$setValidity("date", isValid);}this.refreshView();};this.refreshView = function(){if(this.element){this._refreshView();var date=ngModelCtrl.$modelValue?new Date(ngModelCtrl.$modelValue):null;ngModelCtrl.$setValidity("date-disabled", !date || this.element && !this.isDisabled(date));}};this.createDateObject = function(date, format){var model=ngModelCtrl.$modelValue?new Date(ngModelCtrl.$modelValue):null;return {date:date, label:dateFilter(date, format), selected:model && this.compare(date, model) === 0, disabled:this.isDisabled(date), current:this.compare(date, new Date()) === 0};};this.isDisabled = function(date){return this.minDate && this.compare(date, this.minDate) < 0 || this.maxDate && this.compare(date, this.maxDate) > 0 || $attrs.dateDisabled && $scope.dateDisabled({date:date, mode:$scope.datepickerMode});};this.split = function(arr, size){var arrays=[];while(arr.length > 0) {arrays.push(arr.splice(0, size));}return arrays;};$scope.select = function(date){if($scope.datepickerMode === self.minMode){var dt=ngModelCtrl.$modelValue?new Date(ngModelCtrl.$modelValue):new Date(0, 0, 0, 0, 0, 0, 0);dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());ngModelCtrl.$setViewValue(dt);ngModelCtrl.$render();}else {self.activeDate = date;$scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) - 1];}};$scope.move = function(direction){var year=self.activeDate.getFullYear() + direction * (self.step.years || 0), month=self.activeDate.getMonth() + direction * (self.step.months || 0);self.activeDate.setFullYear(year, month, 1);self.refreshView();};$scope.toggleMode = function(direction){direction = direction || 1;if($scope.datepickerMode === self.maxMode && direction === 1 || $scope.datepickerMode === self.minMode && direction === -1){return;}$scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) + direction];};$scope.keys = {13:"enter", 32:"space", 33:"pageup", 34:"pagedown", 35:"end", 36:"home", 37:"left", 38:"up", 39:"right", 40:"down"};var focusElement=function focusElement(){$timeout(function(){self.element[0].focus();}, 0, false);};$scope.$on("datepicker.focus", focusElement);$scope.keydown = function(evt){var key=$scope.keys[evt.which];if(!key || evt.shiftKey || evt.altKey){return;}evt.preventDefault();evt.stopPropagation();if(key === "enter" || key === "space"){if(self.isDisabled(self.activeDate)){return;}$scope.select(self.activeDate);focusElement();}else if(evt.ctrlKey && (key === "up" || key === "down")){$scope.toggleMode(key === "up"?1:-1);focusElement();}else {self.handleKeyDown(key, evt);self.refreshView();}};}]).directive("datepicker", function(){return {restrict:"EA", replace:true, templateUrl:"template/datepicker/datepicker.html", scope:{datepickerMode:"=?", dateDisabled:"&"}, require:["datepicker", "?^ngModel"], controller:"DatepickerController", link:function link(scope, element, attrs, ctrls){var datepickerCtrl=ctrls[0], ngModelCtrl=ctrls[1];if(ngModelCtrl){datepickerCtrl.init(ngModelCtrl);}}};}).directive("daypicker", ["dateFilter", function(dateFilter){return {restrict:"EA", replace:true, templateUrl:"template/datepicker/day.html", require:"^datepicker", link:function link(scope, element, attrs, ctrl){scope.showWeeks = ctrl.showWeeks;ctrl.step = {months:1};ctrl.element = element;var DAYS_IN_MONTH=[31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];function getDaysInMonth(year, month){return month === 1 && year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)?29:DAYS_IN_MONTH[month];}function getDates(startDate, n){var dates=new Array(n), current=new Date(startDate), i=0;current.setHours(12);while(i < n) {dates[i++] = new Date(current);current.setDate(current.getDate() + 1);}return dates;}ctrl._refreshView = function(){var year=ctrl.activeDate.getFullYear(), month=ctrl.activeDate.getMonth(), firstDayOfMonth=new Date(year, month, 1), difference=ctrl.startingDay - firstDayOfMonth.getDay(), numDisplayedFromPreviousMonth=difference > 0?7 - difference:-difference, firstDate=new Date(firstDayOfMonth);if(numDisplayedFromPreviousMonth > 0){firstDate.setDate(-numDisplayedFromPreviousMonth + 1);}var days=getDates(firstDate, 42);for(var i=0; i < 42; i++) {days[i] = angular.extend(ctrl.createDateObject(days[i], ctrl.formatDay), {secondary:days[i].getMonth() !== month, uid:scope.uniqueId + "-" + i});}scope.labels = new Array(7);for(var j=0; j < 7; j++) {scope.labels[j] = {abbr:dateFilter(days[j].date, ctrl.formatDayHeader), full:dateFilter(days[j].date, "EEEE")};}scope.title = dateFilter(ctrl.activeDate, ctrl.formatDayTitle);scope.rows = ctrl.split(days, 7);if(scope.showWeeks){scope.weekNumbers = [];var weekNumber=getISO8601WeekNumber(scope.rows[0][0].date), numWeeks=scope.rows.length;while(scope.weekNumbers.push(weekNumber++) < numWeeks) {}}};ctrl.compare = function(date1, date2){return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());};function getISO8601WeekNumber(date){var checkDate=new Date(date);checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7));var time=checkDate.getTime();checkDate.setMonth(0);checkDate.setDate(1);return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;}ctrl.handleKeyDown = function(key, evt){var date=ctrl.activeDate.getDate();if(key === "left"){date = date - 1;}else if(key === "up"){date = date - 7;}else if(key === "right"){date = date + 1;}else if(key === "down"){date = date + 7;}else if(key === "pageup" || key === "pagedown"){var month=ctrl.activeDate.getMonth() + (key === "pageup"?-1:1);ctrl.activeDate.setMonth(month, 1);date = Math.min(getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth()), date);}else if(key === "home"){date = 1;}else if(key === "end"){date = getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth());}ctrl.activeDate.setDate(date);};ctrl.refreshView();}};}]).directive("monthpicker", ["dateFilter", function(dateFilter){return {restrict:"EA", replace:true, templateUrl:"template/datepicker/month.html", require:"^datepicker", link:function link(scope, element, attrs, ctrl){ctrl.step = {years:1};ctrl.element = element;ctrl._refreshView = function(){var months=new Array(12), year=ctrl.activeDate.getFullYear();for(var i=0; i < 12; i++) {months[i] = angular.extend(ctrl.createDateObject(new Date(year, i, 1), ctrl.formatMonth), {uid:scope.uniqueId + "-" + i});}scope.title = dateFilter(ctrl.activeDate, ctrl.formatMonthTitle);scope.rows = ctrl.split(months, 3);};ctrl.compare = function(date1, date2){return new Date(date1.getFullYear(), date1.getMonth()) - new Date(date2.getFullYear(), date2.getMonth());};ctrl.handleKeyDown = function(key, evt){var date=ctrl.activeDate.getMonth();if(key === "left"){date = date - 1;}else if(key === "up"){date = date - 3;}else if(key === "right"){date = date + 1;}else if(key === "down"){date = date + 3;}else if(key === "pageup" || key === "pagedown"){var year=ctrl.activeDate.getFullYear() + (key === "pageup"?-1:1);ctrl.activeDate.setFullYear(year);}else if(key === "home"){date = 0;}else if(key === "end"){date = 11;}ctrl.activeDate.setMonth(date);};ctrl.refreshView();}};}]).directive("yearpicker", ["dateFilter", function(dateFilter){return {restrict:"EA", replace:true, templateUrl:"template/datepicker/year.html", require:"^datepicker", link:function link(scope, element, attrs, ctrl){var range=ctrl.yearRange;ctrl.step = {years:range};ctrl.element = element;function getStartingYear(year){return parseInt((year - 1) / range, 10) * range + 1;}ctrl._refreshView = function(){var years=new Array(range);for(var i=0, start=getStartingYear(ctrl.activeDate.getFullYear()); i < range; i++) {years[i] = angular.extend(ctrl.createDateObject(new Date(start + i, 0, 1), ctrl.formatYear), {uid:scope.uniqueId + "-" + i});}scope.title = [years[0].label, years[range - 1].label].join(" - ");scope.rows = ctrl.split(years, 5);};ctrl.compare = function(date1, date2){return date1.getFullYear() - date2.getFullYear();};ctrl.handleKeyDown = function(key, evt){var date=ctrl.activeDate.getFullYear();if(key === "left"){date = date - 1;}else if(key === "up"){date = date - 5;}else if(key === "right"){date = date + 1;}else if(key === "down"){date = date + 5;}else if(key === "pageup" || key === "pagedown"){date += (key === "pageup"?-1:1) * ctrl.step.years;}else if(key === "home"){date = getStartingYear(ctrl.activeDate.getFullYear());}else if(key === "end"){date = getStartingYear(ctrl.activeDate.getFullYear()) + range - 1;}ctrl.activeDate.setFullYear(date);};ctrl.refreshView();}};}]).constant("datepickerPopupConfig", {datepickerPopup:"yyyy-MM-dd", currentText:"Today", clearText:"Clear", closeText:"Done", closeOnDateSelection:true, appendToBody:false, showButtonBar:true}).directive("datepickerPopup", ["$compile", "$parse", "$document", "$position", "dateFilter", "dateParser", "datepickerPopupConfig", function($compile, $parse, $document, $position, dateFilter, dateParser, datepickerPopupConfig){return {restrict:"EA", require:"ngModel", scope:{isOpen:"=?", currentText:"@", clearText:"@", closeText:"@", dateDisabled:"&"}, link:function link(scope, element, attrs, ngModel){var dateFormat, closeOnDateSelection=angular.isDefined(attrs.closeOnDateSelection)?scope.$parent.$eval(attrs.closeOnDateSelection):datepickerPopupConfig.closeOnDateSelection, appendToBody=angular.isDefined(attrs.datepickerAppendToBody)?scope.$parent.$eval(attrs.datepickerAppendToBody):datepickerPopupConfig.appendToBody;scope.showButtonBar = angular.isDefined(attrs.showButtonBar)?scope.$parent.$eval(attrs.showButtonBar):datepickerPopupConfig.showButtonBar;scope.getText = function(key){return scope[key + "Text"] || datepickerPopupConfig[key + "Text"];};attrs.$observe("datepickerPopup", function(value){dateFormat = value || datepickerPopupConfig.datepickerPopup;ngModel.$render();});var popupEl=angular.element("<div datepicker-popup-wrap><div datepicker></div></div>");popupEl.attr({"ng-model":"date", "ng-change":"dateSelection()"});function cameltoDash(string){return string.replace(/([A-Z])/g, function($1){return "-" + $1.toLowerCase();});}var datepickerEl=angular.element(popupEl.children()[0]);if(attrs.datepickerOptions){angular.forEach(scope.$parent.$eval(attrs.datepickerOptions), function(value, option){datepickerEl.attr(cameltoDash(option), value);});}scope.watchData = {};angular.forEach(["minDate", "maxDate", "datepickerMode"], function(key){if(attrs[key]){var getAttribute=$parse(attrs[key]);scope.$parent.$watch(getAttribute, function(value){scope.watchData[key] = value;});datepickerEl.attr(cameltoDash(key), "watchData." + key);if(key === "datepickerMode"){var setAttribute=getAttribute.assign;scope.$watch("watchData." + key, function(value, oldvalue){if(value !== oldvalue){setAttribute(scope.$parent, value);}});}}});if(attrs.dateDisabled){datepickerEl.attr("date-disabled", "dateDisabled({ date: date, mode: mode })");}function parseDate(viewValue){if(!viewValue){ngModel.$setValidity("date", true);return null;}else if(angular.isDate(viewValue) && !isNaN(viewValue)){ngModel.$setValidity("date", true);return viewValue;}else if(angular.isString(viewValue)){var date=dateParser.parse(viewValue, dateFormat) || new Date(viewValue);if(isNaN(date)){ngModel.$setValidity("date", false);return undefined;}else {ngModel.$setValidity("date", true);return date;}}else {ngModel.$setValidity("date", false);return undefined;}}ngModel.$parsers.unshift(parseDate);scope.dateSelection = function(dt){if(angular.isDefined(dt)){scope.date = dt;}ngModel.$setViewValue(scope.date);ngModel.$render();if(closeOnDateSelection){scope.isOpen = false;element[0].focus();}};element.bind("input change keyup", function(){scope.$apply(function(){scope.date = ngModel.$modelValue;});});ngModel.$render = function(){var date=ngModel.$viewValue?dateFilter(ngModel.$viewValue, dateFormat):"";element.val(date);scope.date = parseDate(ngModel.$modelValue);};var documentClickBind=function documentClickBind(event){if(scope.isOpen && event.target !== element[0]){scope.$apply(function(){scope.isOpen = false;});}};var keydown=function keydown(evt, noApply){scope.keydown(evt);};element.bind("keydown", keydown);scope.keydown = function(evt){if(evt.which === 27){evt.preventDefault();evt.stopPropagation();scope.close();}else if(evt.which === 40 && !scope.isOpen){scope.isOpen = true;}};scope.$watch("isOpen", function(value){if(value){scope.$broadcast("datepicker.focus");scope.position = appendToBody?$position.offset(element):$position.position(element);scope.position.top = scope.position.top + element.prop("offsetHeight");$document.bind("click", documentClickBind);}else {$document.unbind("click", documentClickBind);}});scope.select = function(date){if(date === "today"){var today=new Date();if(angular.isDate(ngModel.$modelValue)){date = new Date(ngModel.$modelValue);date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());}else {date = new Date(today.setHours(0, 0, 0, 0));}}scope.dateSelection(date);};scope.close = function(){scope.isOpen = false;element[0].focus();};var $popup=$compile(popupEl)(scope);popupEl.remove();if(appendToBody){$document.find("body").append($popup);}else {element.after($popup);}scope.$on("$destroy", function(){$popup.remove();element.unbind("keydown", keydown);$document.unbind("click", documentClickBind);});}};}]).directive("datepickerPopupWrap", function(){return {restrict:"EA", replace:true, transclude:true, templateUrl:"template/datepicker/popup.html", link:function link(scope, element, attrs){element.bind("click", function(event){event.preventDefault();event.stopPropagation();});}};});angular.module("ui.bootstrap.dropdown", []).constant("dropdownConfig", {openClass:"open"}).service("dropdownService", ["$document", function($document){var openScope=null;this.open = function(dropdownScope){if(!openScope){$document.bind("click", closeDropdown);$document.bind("keydown", escapeKeyBind);}if(openScope && openScope !== dropdownScope){openScope.isOpen = false;}openScope = dropdownScope;};this.close = function(dropdownScope){if(openScope === dropdownScope){openScope = null;$document.unbind("click", closeDropdown);$document.unbind("keydown", escapeKeyBind);}};var closeDropdown=function closeDropdown(evt){if(!openScope){return;}var toggleElement=openScope.getToggleElement();if(evt && toggleElement && toggleElement[0].contains(evt.target)){return;}openScope.$apply(function(){openScope.isOpen = false;});};var escapeKeyBind=function escapeKeyBind(evt){if(evt.which === 27){openScope.focusToggleElement();closeDropdown();}};}]).controller("DropdownController", ["$scope", "$attrs", "$parse", "dropdownConfig", "dropdownService", "$animate", function($scope, $attrs, $parse, dropdownConfig, dropdownService, $animate){var self=this, scope=$scope.$new(), openClass=dropdownConfig.openClass, getIsOpen, setIsOpen=angular.noop, toggleInvoker=$attrs.onToggle?$parse($attrs.onToggle):angular.noop;this.init = function(element){self.$element = element;if($attrs.isOpen){getIsOpen = $parse($attrs.isOpen);setIsOpen = getIsOpen.assign;$scope.$watch(getIsOpen, function(value){scope.isOpen = !!value;});}};this.toggle = function(open){return scope.isOpen = arguments.length?!!open:!scope.isOpen;};this.isOpen = function(){return scope.isOpen;};scope.getToggleElement = function(){return self.toggleElement;};scope.focusToggleElement = function(){if(self.toggleElement){self.toggleElement[0].focus();}};scope.$watch("isOpen", function(isOpen, wasOpen){$animate[isOpen?"addClass":"removeClass"](self.$element, openClass);if(isOpen){scope.focusToggleElement();dropdownService.open(scope);}else {dropdownService.close(scope);}setIsOpen($scope, isOpen);if(angular.isDefined(isOpen) && isOpen !== wasOpen){toggleInvoker($scope, {open:!!isOpen});}});$scope.$on("$locationChangeSuccess", function(){scope.isOpen = false;});$scope.$on("$destroy", function(){scope.$destroy();});}]).directive("dropdown", function(){return {controller:"DropdownController", link:function link(scope, element, attrs, dropdownCtrl){dropdownCtrl.init(element);}};}).directive("dropdownToggle", function(){return {require:"?^dropdown", link:function link(scope, element, attrs, dropdownCtrl){if(!dropdownCtrl){return;}dropdownCtrl.toggleElement = element;var toggleDropdown=function toggleDropdown(event){event.preventDefault();if(!element.hasClass("disabled") && !attrs.disabled){scope.$apply(function(){dropdownCtrl.toggle();});}};element.bind("click", toggleDropdown);element.attr({"aria-haspopup":true, "aria-expanded":false});scope.$watch(dropdownCtrl.isOpen, function(isOpen){element.attr("aria-expanded", !!isOpen);});scope.$on("$destroy", function(){element.unbind("click", toggleDropdown);});}};});angular.module("ui.bootstrap.modal", ["ui.bootstrap.transition"]).factory("$$stackedMap", function(){return {createNew:function createNew(){var stack=[];return {add:function add(key, value){stack.push({key:key, value:value});}, get:function get(key){for(var i=0; i < stack.length; i++) {if(key == stack[i].key){return stack[i];}}}, keys:(function(_keys){var _keysWrapper=function keys(){return _keys.apply(this, arguments);};_keysWrapper.toString = function(){return _keys.toString();};return _keysWrapper;})(function(){var keys=[];for(var i=0; i < stack.length; i++) {keys.push(stack[i].key);}return keys;}), top:function top(){return stack[stack.length - 1];}, remove:function remove(key){var idx=-1;for(var i=0; i < stack.length; i++) {if(key == stack[i].key){idx = i;break;}}return stack.splice(idx, 1)[0];}, removeTop:function removeTop(){return stack.splice(stack.length - 1, 1)[0];}, length:function length(){return stack.length;}};}};}).directive("modalBackdrop", ["$timeout", function($timeout){return {restrict:"EA", replace:true, templateUrl:"template/modal/backdrop.html", link:function link(scope, element, attrs){scope.backdropClass = attrs.backdropClass || "";scope.animate = false;$timeout(function(){scope.animate = true;});}};}]).directive("modalWindow", ["$modalStack", "$timeout", function($modalStack, $timeout){return {restrict:"EA", scope:{index:"@", animate:"="}, replace:true, transclude:true, templateUrl:function templateUrl(tElement, tAttrs){return tAttrs.templateUrl || "template/modal/window.html";}, link:function link(scope, element, attrs){element.addClass(attrs.windowClass || "");scope.size = attrs.size;$timeout(function(){scope.animate = true;if(!element[0].querySelectorAll("[autofocus]").length){element[0].focus();}});scope.close = function(evt){var modal=$modalStack.getTop();if(modal && modal.value.backdrop && modal.value.backdrop != "static" && evt.target === evt.currentTarget){evt.preventDefault();evt.stopPropagation();$modalStack.dismiss(modal.key, "backdrop click");}};}};}]).directive("modalTransclude", function(){return {link:function link($scope, $element, $attrs, controller, $transclude){$transclude($scope.$parent, function(clone){$element.empty();$element.append(clone);});}};}).factory("$modalStack", ["$transition", "$timeout", "$document", "$compile", "$rootScope", "$$stackedMap", function($transition, $timeout, $document, $compile, $rootScope, $$stackedMap){var OPENED_MODAL_CLASS="modal-open";var backdropDomEl, backdropScope;var openedWindows=$$stackedMap.createNew();var $modalStack={};function backdropIndex(){var topBackdropIndex=-1;var opened=openedWindows.keys();for(var i=0; i < opened.length; i++) {if(openedWindows.get(opened[i]).value.backdrop){topBackdropIndex = i;}}return topBackdropIndex;}$rootScope.$watch(backdropIndex, function(newBackdropIndex){if(backdropScope){backdropScope.index = newBackdropIndex;}});function removeModalWindow(modalInstance){var body=$document.find("body").eq(0);var modalWindow=openedWindows.get(modalInstance).value;openedWindows.remove(modalInstance);removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, 300, function(){modalWindow.modalScope.$destroy();body.toggleClass(OPENED_MODAL_CLASS, openedWindows.length() > 0);checkRemoveBackdrop();});}function checkRemoveBackdrop(){if(backdropDomEl && backdropIndex() == -1){var backdropScopeRef=backdropScope;removeAfterAnimate(backdropDomEl, backdropScope, 150, function(){backdropScopeRef.$destroy();backdropScopeRef = null;});backdropDomEl = undefined;backdropScope = undefined;}}function removeAfterAnimate(domEl, scope, emulateTime, done){scope.animate = false;var transitionEndEventName=$transition.transitionEndEventName;if(transitionEndEventName){var timeout=$timeout(afterAnimating, emulateTime);domEl.bind(transitionEndEventName, function(){$timeout.cancel(timeout);afterAnimating();scope.$apply();});}else {$timeout(afterAnimating);}function afterAnimating(){if(afterAnimating.done){return;}afterAnimating.done = true;domEl.remove();if(done){done();}}}$document.bind("keydown", function(evt){var modal;if(evt.which === 27){modal = openedWindows.top();if(modal && modal.value.keyboard){evt.preventDefault();$rootScope.$apply(function(){$modalStack.dismiss(modal.key, "escape key press");});}}});$modalStack.open = function(modalInstance, modal){openedWindows.add(modalInstance, {deferred:modal.deferred, modalScope:modal.scope, backdrop:modal.backdrop, keyboard:modal.keyboard});var body=$document.find("body").eq(0), currBackdropIndex=backdropIndex();if(currBackdropIndex >= 0 && !backdropDomEl){backdropScope = $rootScope.$new(true);backdropScope.index = currBackdropIndex;var angularBackgroundDomEl=angular.element("<div modal-backdrop></div>");angularBackgroundDomEl.attr("backdrop-class", modal.backdropClass);backdropDomEl = $compile(angularBackgroundDomEl)(backdropScope);body.append(backdropDomEl);}var angularDomEl=angular.element("<div modal-window></div>");angularDomEl.attr({"template-url":modal.windowTemplateUrl, "window-class":modal.windowClass, size:modal.size, index:openedWindows.length() - 1, animate:"animate"}).html(modal.content);var modalDomEl=$compile(angularDomEl)(modal.scope);openedWindows.top().value.modalDomEl = modalDomEl;body.append(modalDomEl);body.addClass(OPENED_MODAL_CLASS);};$modalStack.close = function(modalInstance, result){var modalWindow=openedWindows.get(modalInstance);if(modalWindow){modalWindow.value.deferred.resolve(result);removeModalWindow(modalInstance);}};$modalStack.dismiss = function(modalInstance, reason){var modalWindow=openedWindows.get(modalInstance);if(modalWindow){modalWindow.value.deferred.reject(reason);removeModalWindow(modalInstance);}};$modalStack.dismissAll = function(reason){var topModal=this.getTop();while(topModal) {this.dismiss(topModal.key, reason);topModal = this.getTop();}};$modalStack.getTop = function(){return openedWindows.top();};return $modalStack;}]).provider("$modal", function(){var $modalProvider={options:{backdrop:true, keyboard:true}, $get:["$injector", "$rootScope", "$q", "$http", "$templateCache", "$controller", "$modalStack", function($injector, $rootScope, $q, $http, $templateCache, $controller, $modalStack){var $modal={};function getTemplatePromise(options){return options.template?$q.when(options.template):$http.get(angular.isFunction(options.templateUrl)?options.templateUrl():options.templateUrl, {cache:$templateCache}).then(function(result){return result.data;});}function getResolvePromises(resolves){var promisesArr=[];angular.forEach(resolves, function(value){if(angular.isFunction(value) || angular.isArray(value)){promisesArr.push($q.when($injector.invoke(value)));}});return promisesArr;}$modal.open = function(modalOptions){var modalResultDeferred=$q.defer();var modalOpenedDeferred=$q.defer();var modalInstance={result:modalResultDeferred.promise, opened:modalOpenedDeferred.promise, close:function close(result){$modalStack.close(modalInstance, result);}, dismiss:function dismiss(reason){$modalStack.dismiss(modalInstance, reason);}};modalOptions = angular.extend({}, $modalProvider.options, modalOptions);modalOptions.resolve = modalOptions.resolve || {};if(!modalOptions.template && !modalOptions.templateUrl){throw new Error("One of template or templateUrl options is required.");}var templateAndResolvePromise=$q.all([getTemplatePromise(modalOptions)].concat(getResolvePromises(modalOptions.resolve)));templateAndResolvePromise.then(function resolveSuccess(tplAndVars){var modalScope=(modalOptions.scope || $rootScope).$new();modalScope.$close = modalInstance.close;modalScope.$dismiss = modalInstance.dismiss;var ctrlInstance, ctrlLocals={};var resolveIter=1;if(modalOptions.controller){ctrlLocals.$scope = modalScope;ctrlLocals.$modalInstance = modalInstance;angular.forEach(modalOptions.resolve, function(value, key){ctrlLocals[key] = tplAndVars[resolveIter++];});ctrlInstance = $controller(modalOptions.controller, ctrlLocals);if(modalOptions.controllerAs){modalScope[modalOptions.controllerAs] = ctrlInstance;}}$modalStack.open(modalInstance, {scope:modalScope, deferred:modalResultDeferred, content:tplAndVars[0], backdrop:modalOptions.backdrop, keyboard:modalOptions.keyboard, backdropClass:modalOptions.backdropClass, windowClass:modalOptions.windowClass, windowTemplateUrl:modalOptions.windowTemplateUrl, size:modalOptions.size});}, function resolveError(reason){modalResultDeferred.reject(reason);});templateAndResolvePromise.then(function(){modalOpenedDeferred.resolve(true);}, function(){modalOpenedDeferred.reject(false);});return modalInstance;};return $modal;}]};return $modalProvider;});angular.module("ui.bootstrap.pagination", []).controller("PaginationController", ["$scope", "$attrs", "$parse", function($scope, $attrs, $parse){var self=this, ngModelCtrl={$setViewValue:angular.noop}, setNumPages=$attrs.numPages?$parse($attrs.numPages).assign:angular.noop;this.init = function(ngModelCtrl_, config){ngModelCtrl = ngModelCtrl_;this.config = config;ngModelCtrl.$render = function(){self.render();};if($attrs.itemsPerPage){$scope.$parent.$watch($parse($attrs.itemsPerPage), function(value){self.itemsPerPage = parseInt(value, 10);$scope.totalPages = self.calculateTotalPages();});}else {this.itemsPerPage = config.itemsPerPage;}};this.calculateTotalPages = function(){var totalPages=this.itemsPerPage < 1?1:Math.ceil($scope.totalItems / this.itemsPerPage);return Math.max(totalPages || 0, 1);};this.render = function(){$scope.page = parseInt(ngModelCtrl.$viewValue, 10) || 1;};$scope.selectPage = function(page){if($scope.page !== page && page > 0 && page <= $scope.totalPages){ngModelCtrl.$setViewValue(page);ngModelCtrl.$render();}};$scope.getText = function(key){return $scope[key + "Text"] || self.config[key + "Text"];};$scope.noPrevious = function(){return $scope.page === 1;};$scope.noNext = function(){return $scope.page === $scope.totalPages;};$scope.$watch("totalItems", function(){$scope.totalPages = self.calculateTotalPages();});$scope.$watch("totalPages", function(value){setNumPages($scope.$parent, value);if($scope.page > value){$scope.selectPage(value);}else {ngModelCtrl.$render();}});}]).constant("paginationConfig", {itemsPerPage:10, boundaryLinks:false, directionLinks:true, firstText:"First", previousText:"Previous", nextText:"Next", lastText:"Last", rotate:true}).directive("pagination", ["$parse", "paginationConfig", function($parse, paginationConfig){return {restrict:"EA", scope:{totalItems:"=", firstText:"@", previousText:"@", nextText:"@", lastText:"@"}, require:["pagination", "?ngModel"], controller:"PaginationController", templateUrl:"template/pagination/pagination.html", replace:true, link:function link(scope, element, attrs, ctrls){var paginationCtrl=ctrls[0], ngModelCtrl=ctrls[1];if(!ngModelCtrl){return;}var maxSize=angular.isDefined(attrs.maxSize)?scope.$parent.$eval(attrs.maxSize):paginationConfig.maxSize, rotate=angular.isDefined(attrs.rotate)?scope.$parent.$eval(attrs.rotate):paginationConfig.rotate;scope.boundaryLinks = angular.isDefined(attrs.boundaryLinks)?scope.$parent.$eval(attrs.boundaryLinks):paginationConfig.boundaryLinks;scope.directionLinks = angular.isDefined(attrs.directionLinks)?scope.$parent.$eval(attrs.directionLinks):paginationConfig.directionLinks;paginationCtrl.init(ngModelCtrl, paginationConfig);if(attrs.maxSize){scope.$parent.$watch($parse(attrs.maxSize), function(value){maxSize = parseInt(value, 10);paginationCtrl.render();});}function makePage(number, text, isActive){return {number:number, text:text, active:isActive};}function getPages(currentPage, totalPages){var pages=[];var startPage=1, endPage=totalPages;var isMaxSized=angular.isDefined(maxSize) && maxSize < totalPages;if(isMaxSized){if(rotate){startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);endPage = startPage + maxSize - 1;if(endPage > totalPages){endPage = totalPages;startPage = endPage - maxSize + 1;}}else {startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;endPage = Math.min(startPage + maxSize - 1, totalPages);}}for(var number=startPage; number <= endPage; number++) {var page=makePage(number, number, number === currentPage);pages.push(page);}if(isMaxSized && !rotate){if(startPage > 1){var previousPageSet=makePage(startPage - 1, "...", false);pages.unshift(previousPageSet);}if(endPage < totalPages){var nextPageSet=makePage(endPage + 1, "...", false);pages.push(nextPageSet);}}return pages;}var originalRender=paginationCtrl.render;paginationCtrl.render = function(){originalRender();if(scope.page > 0 && scope.page <= scope.totalPages){scope.pages = getPages(scope.page, scope.totalPages);}};}};}]).constant("pagerConfig", {itemsPerPage:10, previousText:"« Previous", nextText:"Next »", align:true}).directive("pager", ["pagerConfig", function(pagerConfig){return {restrict:"EA", scope:{totalItems:"=", previousText:"@", nextText:"@"}, require:["pager", "?ngModel"], controller:"PaginationController", templateUrl:"template/pagination/pager.html", replace:true, link:function link(scope, element, attrs, ctrls){var paginationCtrl=ctrls[0], ngModelCtrl=ctrls[1];if(!ngModelCtrl){return;}scope.align = angular.isDefined(attrs.align)?scope.$parent.$eval(attrs.align):pagerConfig.align;paginationCtrl.init(ngModelCtrl, pagerConfig);}};}]);angular.module("ui.bootstrap.tooltip", ["ui.bootstrap.position", "ui.bootstrap.bindHtml"]).provider("$tooltip", function(){var defaultOptions={placement:"top", animation:true, popupDelay:0};var triggerMap={mouseenter:"mouseleave", click:"click", focus:"blur"};var globalOptions={};this.options = function(value){angular.extend(globalOptions, value);};this.setTriggers = function setTriggers(triggers){angular.extend(triggerMap, triggers);};function snake_case(name){var regexp=/[A-Z]/g;var separator="-";return name.replace(regexp, function(letter, pos){return (pos?separator:"") + letter.toLowerCase();});}this.$get = ["$window", "$compile", "$timeout", "$document", "$position", "$interpolate", function($window, $compile, $timeout, $document, $position, $interpolate){return function $tooltip(type, prefix, defaultTriggerShow){var options=angular.extend({}, defaultOptions, globalOptions);function getTriggers(trigger){var show=trigger || options.trigger || defaultTriggerShow;var hide=triggerMap[show] || show;return {show:show, hide:hide};}var directiveName=snake_case(type);var startSym=$interpolate.startSymbol();var endSym=$interpolate.endSymbol();var template="<div " + directiveName + "-popup " + "title=\"" + startSym + "title" + endSym + "\" " + "content=\"" + startSym + "content" + endSym + "\" " + "placement=\"" + startSym + "placement" + endSym + "\" " + "animation=\"animation\" " + "is-open=\"isOpen\"" + ">" + "</div>";return {restrict:"EA", compile:function compile(tElem, tAttrs){var tooltipLinker=$compile(template);return function link(scope, element, attrs){var tooltip;var tooltipLinkedScope;var transitionTimeout;var popupTimeout;var appendToBody=angular.isDefined(options.appendToBody)?options.appendToBody:false;var triggers=getTriggers(undefined);var hasEnableExp=angular.isDefined(attrs[prefix + "Enable"]);var ttScope=scope.$new(true);var positionTooltip=function positionTooltip(){var ttPosition=$position.positionElements(element, tooltip, ttScope.placement, appendToBody);ttPosition.top += "px";ttPosition.left += "px";tooltip.css(ttPosition);};ttScope.isOpen = false;function toggleTooltipBind(){if(!ttScope.isOpen){showTooltipBind();}else {hideTooltipBind();}}function showTooltipBind(){if(hasEnableExp && !scope.$eval(attrs[prefix + "Enable"])){return;}prepareTooltip();if(ttScope.popupDelay){if(!popupTimeout){popupTimeout = $timeout(show, ttScope.popupDelay, false);popupTimeout.then(function(reposition){reposition();});}}else {show()();}}function hideTooltipBind(){scope.$apply(function(){hide();});}function show(){popupTimeout = null;if(transitionTimeout){$timeout.cancel(transitionTimeout);transitionTimeout = null;}if(!ttScope.content){return angular.noop;}createTooltip();tooltip.css({top:0, left:0, display:"block"});if(appendToBody){$document.find("body").append(tooltip);}else {element.after(tooltip);}positionTooltip();ttScope.isOpen = true;ttScope.$digest();return positionTooltip;}function hide(){ttScope.isOpen = false;$timeout.cancel(popupTimeout);popupTimeout = null;if(ttScope.animation){if(!transitionTimeout){transitionTimeout = $timeout(removeTooltip, 500);}}else {removeTooltip();}}function createTooltip(){if(tooltip){removeTooltip();}tooltipLinkedScope = ttScope.$new();tooltip = tooltipLinker(tooltipLinkedScope, angular.noop);}function removeTooltip(){transitionTimeout = null;if(tooltip){tooltip.remove();tooltip = null;}if(tooltipLinkedScope){tooltipLinkedScope.$destroy();tooltipLinkedScope = null;}}function prepareTooltip(){prepPlacement();prepPopupDelay();}attrs.$observe(type, function(val){ttScope.content = val;if(!val && ttScope.isOpen){hide();}});attrs.$observe(prefix + "Title", function(val){ttScope.title = val;});function prepPlacement(){var val=attrs[prefix + "Placement"];ttScope.placement = angular.isDefined(val)?val:options.placement;}function prepPopupDelay(){var val=attrs[prefix + "PopupDelay"];var delay=parseInt(val, 10);ttScope.popupDelay = !isNaN(delay)?delay:options.popupDelay;}var unregisterTriggers=function unregisterTriggers(){element.unbind(triggers.show, showTooltipBind);element.unbind(triggers.hide, hideTooltipBind);};function prepTriggers(){var val=attrs[prefix + "Trigger"];unregisterTriggers();triggers = getTriggers(val);if(triggers.show === triggers.hide){element.bind(triggers.show, toggleTooltipBind);}else {element.bind(triggers.show, showTooltipBind);element.bind(triggers.hide, hideTooltipBind);}}prepTriggers();var animation=scope.$eval(attrs[prefix + "Animation"]);ttScope.animation = angular.isDefined(animation)?!!animation:options.animation;var appendToBodyVal=scope.$eval(attrs[prefix + "AppendToBody"]);appendToBody = angular.isDefined(appendToBodyVal)?appendToBodyVal:appendToBody;if(appendToBody){scope.$on("$locationChangeSuccess", function closeTooltipOnLocationChangeSuccess(){if(ttScope.isOpen){hide();}});}scope.$on("$destroy", function onDestroyTooltip(){$timeout.cancel(transitionTimeout);$timeout.cancel(popupTimeout);unregisterTriggers();removeTooltip();ttScope = null;});};}};};}];}).directive("tooltipPopup", function(){return {restrict:"EA", replace:true, scope:{content:"@", placement:"@", animation:"&", isOpen:"&"}, templateUrl:"template/tooltip/tooltip-popup.html"};}).directive("tooltip", ["$tooltip", function($tooltip){return $tooltip("tooltip", "tooltip", "mouseenter");}]).directive("tooltipHtmlUnsafePopup", function(){return {restrict:"EA", replace:true, scope:{content:"@", placement:"@", animation:"&", isOpen:"&"}, templateUrl:"template/tooltip/tooltip-html-unsafe-popup.html"};}).directive("tooltipHtmlUnsafe", ["$tooltip", function($tooltip){return $tooltip("tooltipHtmlUnsafe", "tooltip", "mouseenter");}]);angular.module("ui.bootstrap.popover", ["ui.bootstrap.tooltip"]).directive("popoverPopup", function(){return {restrict:"EA", replace:true, scope:{title:"@", content:"@", placement:"@", animation:"&", isOpen:"&"}, templateUrl:"template/popover/popover.html"};}).directive("popover", ["$tooltip", function($tooltip){return $tooltip("popover", "popover", "click");}]);angular.module("ui.bootstrap.progressbar", []).constant("progressConfig", {animate:true, max:100}).controller("ProgressController", ["$scope", "$attrs", "progressConfig", function($scope, $attrs, progressConfig){var self=this, animate=angular.isDefined($attrs.animate)?$scope.$parent.$eval($attrs.animate):progressConfig.animate;this.bars = [];$scope.max = angular.isDefined($attrs.max)?$scope.$parent.$eval($attrs.max):progressConfig.max;this.addBar = function(bar, element){if(!animate){element.css({transition:"none"});}this.bars.push(bar);bar.$watch("value", function(value){bar.percent = +(100 * value / $scope.max).toFixed(2);});bar.$on("$destroy", function(){element = null;self.removeBar(bar);});};this.removeBar = function(bar){this.bars.splice(this.bars.indexOf(bar), 1);};}]).directive("progress", function(){return {restrict:"EA", replace:true, transclude:true, controller:"ProgressController", require:"progress", scope:{}, templateUrl:"template/progressbar/progress.html"};}).directive("bar", function(){return {restrict:"EA", replace:true, transclude:true, require:"^progress", scope:{value:"=", type:"@"}, templateUrl:"template/progressbar/bar.html", link:function link(scope, element, attrs, progressCtrl){progressCtrl.addBar(scope, element);}};}).directive("progressbar", function(){return {restrict:"EA", replace:true, transclude:true, controller:"ProgressController", scope:{value:"=", type:"@"}, templateUrl:"template/progressbar/progressbar.html", link:function link(scope, element, attrs, progressCtrl){progressCtrl.addBar(scope, angular.element(element.children()[0]));}};});angular.module("ui.bootstrap.rating", []).constant("ratingConfig", {max:5, stateOn:null, stateOff:null}).controller("RatingController", ["$scope", "$attrs", "ratingConfig", function($scope, $attrs, ratingConfig){var ngModelCtrl={$setViewValue:angular.noop};this.init = function(ngModelCtrl_){ngModelCtrl = ngModelCtrl_;ngModelCtrl.$render = this.render;this.stateOn = angular.isDefined($attrs.stateOn)?$scope.$parent.$eval($attrs.stateOn):ratingConfig.stateOn;this.stateOff = angular.isDefined($attrs.stateOff)?$scope.$parent.$eval($attrs.stateOff):ratingConfig.stateOff;var ratingStates=angular.isDefined($attrs.ratingStates)?$scope.$parent.$eval($attrs.ratingStates):new Array(angular.isDefined($attrs.max)?$scope.$parent.$eval($attrs.max):ratingConfig.max);$scope.range = this.buildTemplateObjects(ratingStates);};this.buildTemplateObjects = function(states){for(var i=0, n=states.length; i < n; i++) {states[i] = angular.extend({index:i}, {stateOn:this.stateOn, stateOff:this.stateOff}, states[i]);}return states;};$scope.rate = function(value){if(!$scope.readonly && value >= 0 && value <= $scope.range.length){ngModelCtrl.$setViewValue(value);ngModelCtrl.$render();}};$scope.enter = function(value){if(!$scope.readonly){$scope.value = value;}$scope.onHover({value:value});};$scope.reset = function(){$scope.value = ngModelCtrl.$viewValue;$scope.onLeave();};$scope.onKeydown = function(evt){if(/(37|38|39|40)/.test(evt.which)){evt.preventDefault();evt.stopPropagation();$scope.rate($scope.value + (evt.which === 38 || evt.which === 39?1:-1));}};this.render = function(){$scope.value = ngModelCtrl.$viewValue;};}]).directive("rating", function(){return {restrict:"EA", require:["rating", "ngModel"], scope:{readonly:"=?", onHover:"&", onLeave:"&"}, controller:"RatingController", templateUrl:"template/rating/rating.html", replace:true, link:function link(scope, element, attrs, ctrls){var ratingCtrl=ctrls[0], ngModelCtrl=ctrls[1];if(ngModelCtrl){ratingCtrl.init(ngModelCtrl);}}};});angular.module("ui.bootstrap.tabs", []).controller("TabsetController", ["$scope", function TabsetCtrl($scope){var ctrl=this, tabs=ctrl.tabs = $scope.tabs = [];ctrl.select = function(selectedTab){angular.forEach(tabs, function(tab){if(tab.active && tab !== selectedTab){tab.active = false;tab.onDeselect();}});selectedTab.active = true;selectedTab.onSelect();};ctrl.addTab = function addTab(tab){tabs.push(tab);if(tabs.length === 1){tab.active = true;}else if(tab.active){ctrl.select(tab);}};ctrl.removeTab = function removeTab(tab){var index=tabs.indexOf(tab);if(tab.active && tabs.length > 1 && !destroyed){var newActiveIndex=index == tabs.length - 1?index - 1:index + 1;ctrl.select(tabs[newActiveIndex]);}tabs.splice(index, 1);};var destroyed;$scope.$on("$destroy", function(){destroyed = true;});}]).directive("tabset", function(){return {restrict:"EA", transclude:true, replace:true, scope:{type:"@"}, controller:"TabsetController", templateUrl:"template/tabs/tabset.html", link:function link(scope, element, attrs){scope.vertical = angular.isDefined(attrs.vertical)?scope.$parent.$eval(attrs.vertical):false;scope.justified = angular.isDefined(attrs.justified)?scope.$parent.$eval(attrs.justified):false;}};}).directive("tab", ["$parse", function($parse){return {require:"^tabset", restrict:"EA", replace:true, templateUrl:"template/tabs/tab.html", transclude:true, scope:{active:"=?", heading:"@", onSelect:"&select", onDeselect:"&deselect"}, controller:function controller(){}, compile:function compile(elm, attrs, transclude){return function postLink(scope, elm, attrs, tabsetCtrl){scope.$watch("active", function(active){if(active){tabsetCtrl.select(scope);}});scope.disabled = false;if(attrs.disabled){scope.$parent.$watch($parse(attrs.disabled), function(value){scope.disabled = !!value;});}scope.select = function(){if(!scope.disabled){scope.active = true;}};tabsetCtrl.addTab(scope);scope.$on("$destroy", function(){tabsetCtrl.removeTab(scope);});scope.$transcludeFn = transclude;};}};}]).directive("tabHeadingTransclude", [function(){return {restrict:"A", require:"^tab", link:function link(scope, elm, attrs, tabCtrl){scope.$watch("headingElement", function updateHeadingElement(heading){if(heading){elm.html("");elm.append(heading);}});}};}]).directive("tabContentTransclude", function(){return {restrict:"A", require:"^tabset", link:function link(scope, elm, attrs){var tab=scope.$eval(attrs.tabContentTransclude);tab.$transcludeFn(tab.$parent, function(contents){angular.forEach(contents, function(node){if(isTabHeading(node)){tab.headingElement = node;}else {elm.append(node);}});});}};function isTabHeading(node){return node.tagName && (node.hasAttribute("tab-heading") || node.hasAttribute("data-tab-heading") || node.tagName.toLowerCase() === "tab-heading" || node.tagName.toLowerCase() === "data-tab-heading");}});angular.module("ui.bootstrap.timepicker", []).constant("timepickerConfig", {hourStep:1, minuteStep:1, showMeridian:true, meridians:null, readonlyInput:false, mousewheel:true}).controller("TimepickerController", ["$scope", "$attrs", "$parse", "$log", "$locale", "timepickerConfig", function($scope, $attrs, $parse, $log, $locale, timepickerConfig){var selected=new Date(), ngModelCtrl={$setViewValue:angular.noop}, meridians=angular.isDefined($attrs.meridians)?$scope.$parent.$eval($attrs.meridians):timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS;this.init = function(ngModelCtrl_, inputs){ngModelCtrl = ngModelCtrl_;ngModelCtrl.$render = this.render;var hoursInputEl=inputs.eq(0), minutesInputEl=inputs.eq(1);var mousewheel=angular.isDefined($attrs.mousewheel)?$scope.$parent.$eval($attrs.mousewheel):timepickerConfig.mousewheel;if(mousewheel){this.setupMousewheelEvents(hoursInputEl, minutesInputEl);}$scope.readonlyInput = angular.isDefined($attrs.readonlyInput)?$scope.$parent.$eval($attrs.readonlyInput):timepickerConfig.readonlyInput;this.setupInputEvents(hoursInputEl, minutesInputEl);};var hourStep=timepickerConfig.hourStep;if($attrs.hourStep){$scope.$parent.$watch($parse($attrs.hourStep), function(value){hourStep = parseInt(value, 10);});}var minuteStep=timepickerConfig.minuteStep;if($attrs.minuteStep){$scope.$parent.$watch($parse($attrs.minuteStep), function(value){minuteStep = parseInt(value, 10);});}$scope.showMeridian = timepickerConfig.showMeridian;if($attrs.showMeridian){$scope.$parent.$watch($parse($attrs.showMeridian), function(value){$scope.showMeridian = !!value;if(ngModelCtrl.$error.time){var hours=getHoursFromTemplate(), minutes=getMinutesFromTemplate();if(angular.isDefined(hours) && angular.isDefined(minutes)){selected.setHours(hours);refresh();}}else {updateTemplate();}});}function getHoursFromTemplate(){var hours=parseInt($scope.hours, 10);var valid=$scope.showMeridian?hours > 0 && hours < 13:hours >= 0 && hours < 24;if(!valid){return undefined;}if($scope.showMeridian){if(hours === 12){hours = 0;}if($scope.meridian === meridians[1]){hours = hours + 12;}}return hours;}function getMinutesFromTemplate(){var minutes=parseInt($scope.minutes, 10);return minutes >= 0 && minutes < 60?minutes:undefined;}function pad(value){return angular.isDefined(value) && value.toString().length < 2?"0" + value:value;}this.setupMousewheelEvents = function(hoursInputEl, minutesInputEl){var isScrollingUp=function isScrollingUp(e){if(e.originalEvent){e = e.originalEvent;}var delta=e.wheelDelta?e.wheelDelta:-e.deltaY;return e.detail || delta > 0;};hoursInputEl.bind("mousewheel wheel", function(e){$scope.$apply(isScrollingUp(e)?$scope.incrementHours():$scope.decrementHours());e.preventDefault();});minutesInputEl.bind("mousewheel wheel", function(e){$scope.$apply(isScrollingUp(e)?$scope.incrementMinutes():$scope.decrementMinutes());e.preventDefault();});};this.setupInputEvents = function(hoursInputEl, minutesInputEl){if($scope.readonlyInput){$scope.updateHours = angular.noop;$scope.updateMinutes = angular.noop;return;}var invalidate=function invalidate(invalidHours, invalidMinutes){ngModelCtrl.$setViewValue(null);ngModelCtrl.$setValidity("time", false);if(angular.isDefined(invalidHours)){$scope.invalidHours = invalidHours;}if(angular.isDefined(invalidMinutes)){$scope.invalidMinutes = invalidMinutes;}};$scope.updateHours = function(){var hours=getHoursFromTemplate();if(angular.isDefined(hours)){selected.setHours(hours);refresh("h");}else {invalidate(true);}};hoursInputEl.bind("blur", function(e){if(!$scope.invalidHours && $scope.hours < 10){$scope.$apply(function(){$scope.hours = pad($scope.hours);});}});$scope.updateMinutes = function(){var minutes=getMinutesFromTemplate();if(angular.isDefined(minutes)){selected.setMinutes(minutes);refresh("m");}else {invalidate(undefined, true);}};minutesInputEl.bind("blur", function(e){if(!$scope.invalidMinutes && $scope.minutes < 10){$scope.$apply(function(){$scope.minutes = pad($scope.minutes);});}});};this.render = function(){var date=ngModelCtrl.$modelValue?new Date(ngModelCtrl.$modelValue):null;if(isNaN(date)){ngModelCtrl.$setValidity("time", false);$log.error("Timepicker directive: \"ng-model\" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.");}else {if(date){selected = date;}makeValid();updateTemplate();}};function refresh(keyboardChange){makeValid();ngModelCtrl.$setViewValue(new Date(selected));updateTemplate(keyboardChange);}function makeValid(){ngModelCtrl.$setValidity("time", true);$scope.invalidHours = false;$scope.invalidMinutes = false;}function updateTemplate(keyboardChange){var hours=selected.getHours(), minutes=selected.getMinutes();if($scope.showMeridian){hours = hours === 0 || hours === 12?12:hours % 12;}$scope.hours = keyboardChange === "h"?hours:pad(hours);$scope.minutes = keyboardChange === "m"?minutes:pad(minutes);$scope.meridian = selected.getHours() < 12?meridians[0]:meridians[1];}function addMinutes(minutes){var dt=new Date(selected.getTime() + minutes * 60000);selected.setHours(dt.getHours(), dt.getMinutes());refresh();}$scope.incrementHours = function(){addMinutes(hourStep * 60);};$scope.decrementHours = function(){addMinutes(-hourStep * 60);};$scope.incrementMinutes = function(){addMinutes(minuteStep);};$scope.decrementMinutes = function(){addMinutes(-minuteStep);};$scope.toggleMeridian = function(){addMinutes(12 * 60 * (selected.getHours() < 12?1:-1));};}]).directive("timepicker", function(){return {restrict:"EA", require:["timepicker", "?^ngModel"], controller:"TimepickerController", replace:true, scope:{}, templateUrl:"template/timepicker/timepicker.html", link:function link(scope, element, attrs, ctrls){var timepickerCtrl=ctrls[0], ngModelCtrl=ctrls[1];if(ngModelCtrl){timepickerCtrl.init(ngModelCtrl, element.find("input"));}}};});angular.module("ui.bootstrap.typeahead", ["ui.bootstrap.position", "ui.bootstrap.bindHtml"]).factory("typeaheadParser", ["$parse", function($parse){var TYPEAHEAD_REGEXP=/^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;return {parse:function parse(input){var match=input.match(TYPEAHEAD_REGEXP);if(!match){throw new Error("Expected typeahead specification in form of \"_modelValue_ (as _label_)? for _item_ in _collection_\"" + " but got \"" + input + "\".");}return {itemName:match[3], source:$parse(match[4]), viewMapper:$parse(match[2] || match[1]), modelMapper:$parse(match[1])};}};}]).directive("typeahead", ["$compile", "$parse", "$q", "$timeout", "$document", "$position", "typeaheadParser", function($compile, $parse, $q, $timeout, $document, $position, typeaheadParser){var HOT_KEYS=[9, 13, 27, 38, 40];return {require:"ngModel", link:function link(originalScope, element, attrs, modelCtrl){var minSearch=originalScope.$eval(attrs.typeaheadMinLength) || 1;var waitTime=originalScope.$eval(attrs.typeaheadWaitMs) || 0;var isEditable=originalScope.$eval(attrs.typeaheadEditable) !== false;var isLoadingSetter=$parse(attrs.typeaheadLoading).assign || angular.noop;var onSelectCallback=$parse(attrs.typeaheadOnSelect);var inputFormatter=attrs.typeaheadInputFormatter?$parse(attrs.typeaheadInputFormatter):undefined;var appendToBody=attrs.typeaheadAppendToBody?originalScope.$eval(attrs.typeaheadAppendToBody):false;var focusFirst=originalScope.$eval(attrs.typeaheadFocusFirst) !== false;var $setModelValue=$parse(attrs.ngModel).assign;var parserResult=typeaheadParser.parse(attrs.typeahead);var hasFocus;var scope=originalScope.$new();originalScope.$on("$destroy", function(){scope.$destroy();});var popupId="typeahead-" + scope.$id + "-" + Math.floor(Math.random() * 10000);element.attr({"aria-autocomplete":"list", "aria-expanded":false, "aria-owns":popupId});var popUpEl=angular.element("<div typeahead-popup></div>");popUpEl.attr({id:popupId, matches:"matches", active:"activeIdx", select:"select(activeIdx)", query:"query", position:"position"});if(angular.isDefined(attrs.typeaheadTemplateUrl)){popUpEl.attr("template-url", attrs.typeaheadTemplateUrl);}var resetMatches=function resetMatches(){scope.matches = [];scope.activeIdx = -1;element.attr("aria-expanded", false);};var getMatchId=function getMatchId(index){return popupId + "-option-" + index;};scope.$watch("activeIdx", function(index){if(index < 0){element.removeAttr("aria-activedescendant");}else {element.attr("aria-activedescendant", getMatchId(index));}});var getMatchesAsync=function getMatchesAsync(inputValue){var locals={$viewValue:inputValue};isLoadingSetter(originalScope, true);$q.when(parserResult.source(originalScope, locals)).then(function(matches){var onCurrentRequest=inputValue === modelCtrl.$viewValue;if(onCurrentRequest && hasFocus){if(matches.length > 0){scope.activeIdx = focusFirst?0:-1;scope.matches.length = 0;for(var i=0; i < matches.length; i++) {locals[parserResult.itemName] = matches[i];scope.matches.push({id:getMatchId(i), label:parserResult.viewMapper(scope, locals), model:matches[i]});}scope.query = inputValue;scope.position = appendToBody?$position.offset(element):$position.position(element);scope.position.top = scope.position.top + element.prop("offsetHeight");element.attr("aria-expanded", true);}else {resetMatches();}}if(onCurrentRequest){isLoadingSetter(originalScope, false);}}, function(){resetMatches();isLoadingSetter(originalScope, false);});};resetMatches();scope.query = undefined;var timeoutPromise;var scheduleSearchWithTimeout=function scheduleSearchWithTimeout(inputValue){timeoutPromise = $timeout(function(){getMatchesAsync(inputValue);}, waitTime);};var cancelPreviousTimeout=function cancelPreviousTimeout(){if(timeoutPromise){$timeout.cancel(timeoutPromise);}};modelCtrl.$parsers.unshift(function(inputValue){hasFocus = true;if(inputValue && inputValue.length >= minSearch){if(waitTime > 0){cancelPreviousTimeout();scheduleSearchWithTimeout(inputValue);}else {getMatchesAsync(inputValue);}}else {isLoadingSetter(originalScope, false);cancelPreviousTimeout();resetMatches();}if(isEditable){return inputValue;}else {if(!inputValue){modelCtrl.$setValidity("editable", true);return inputValue;}else {modelCtrl.$setValidity("editable", false);return undefined;}}});modelCtrl.$formatters.push(function(modelValue){var candidateViewValue, emptyViewValue;var locals={};if(inputFormatter){locals.$model = modelValue;return inputFormatter(originalScope, locals);}else {locals[parserResult.itemName] = modelValue;candidateViewValue = parserResult.viewMapper(originalScope, locals);locals[parserResult.itemName] = undefined;emptyViewValue = parserResult.viewMapper(originalScope, locals);return candidateViewValue !== emptyViewValue?candidateViewValue:modelValue;}});scope.select = function(activeIdx){var locals={};var model, item;locals[parserResult.itemName] = item = scope.matches[activeIdx].model;model = parserResult.modelMapper(originalScope, locals);$setModelValue(originalScope, model);modelCtrl.$setValidity("editable", true);onSelectCallback(originalScope, {$item:item, $model:model, $label:parserResult.viewMapper(originalScope, locals)});resetMatches();$timeout(function(){element[0].focus();}, 0, false);};element.bind("keydown", function(evt){if(scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1){return;}if(scope.activeIdx == -1 && (evt.which === 13 || evt.which === 9)){return;}evt.preventDefault();if(evt.which === 40){scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;scope.$digest();}else if(evt.which === 38){scope.activeIdx = (scope.activeIdx > 0?scope.activeIdx:scope.matches.length) - 1;scope.$digest();}else if(evt.which === 13 || evt.which === 9){scope.$apply(function(){scope.select(scope.activeIdx);});}else if(evt.which === 27){evt.stopPropagation();resetMatches();scope.$digest();}});element.bind("blur", function(evt){hasFocus = false;});var dismissClickHandler=function dismissClickHandler(evt){if(element[0] !== evt.target){resetMatches();scope.$digest();}};$document.bind("click", dismissClickHandler);originalScope.$on("$destroy", function(){$document.unbind("click", dismissClickHandler);if(appendToBody){$popup.remove();}});var $popup=$compile(popUpEl)(scope);if(appendToBody){$document.find("body").append($popup);}else {element.after($popup);}}};}]).directive("typeaheadPopup", function(){return {restrict:"EA", scope:{matches:"=", query:"=", active:"=", position:"=", select:"&"}, replace:true, templateUrl:"template/typeahead/typeahead-popup.html", link:function link(scope, element, attrs){scope.templateUrl = attrs.templateUrl;scope.isOpen = function(){return scope.matches.length > 0;};scope.isActive = function(matchIdx){return scope.active == matchIdx;};scope.selectActive = function(matchIdx){scope.active = matchIdx;};scope.selectMatch = function(activeIdx){scope.select({activeIdx:activeIdx});};}};}).directive("typeaheadMatch", ["$http", "$templateCache", "$compile", "$parse", function($http, $templateCache, $compile, $parse){return {restrict:"EA", scope:{index:"=", match:"=", query:"="}, link:function link(scope, element, attrs){var tplUrl=$parse(attrs.templateUrl)(scope.$parent) || "template/typeahead/typeahead-match.html";$http.get(tplUrl, {cache:$templateCache}).success(function(tplContent){element.replaceWith($compile(tplContent.trim())(scope));});}};}]).filter("typeaheadHighlight", function(){function escapeRegexp(queryToEscape){return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");}return function(matchItem, query){return query?("" + matchItem).replace(new RegExp(escapeRegexp(query), "gi"), "<strong>$&</strong>"):matchItem;};});angular.module("template/accordion/accordion-group.html", []).run(["$templateCache", function($templateCache){$templateCache.put("template/accordion/accordion-group.html", "<div class=\"panel panel-default\">\n" + "  <div class=\"panel-heading\">\n" + "    <h4 class=\"panel-title\">\n" + "      <a href class=\"accordion-toggle\" ng-click=\"toggleOpen()\" accordion-transclude=\"heading\"><span ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" + "    </h4>\n" + "  </div>\n" + "  <div class=\"panel-collapse\" collapse=\"!isOpen\">\n" + "\t  <div class=\"panel-body\" ng-transclude></div>\n" + "  </div>\n" + "</div>\n" + "");}]);angular.module("template/accordion/accordion.html", []).run(["$templateCache", function($templateCache){$templateCache.put("template/accordion/accordion.html", "<div class=\"panel-group\" ng-transclude></div>");}]);angular.module("template/alert/alert.html", []).run(["$templateCache", function($templateCache){$templateCache.put("template/alert/alert.html", "<div class=\"alert\" ng-class=\"['alert-' + (type || 'warning'), closeable ? 'alert-dismissable' : null]\" role=\"alert\">\n" + "    <button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close()\">\n" + "        <span aria-hidden=\"true\">&times;</span>\n" + "        <span class=\"sr-only\">Close</span>\n" + "    </button>\n" + "    <div ng-transclude></div>\n" + "</div>\n" + "");}]);angular.module("template/carousel/carousel.html", []).run(["$templateCache", function($templateCache){$templateCache.put("template/carousel/carousel.html", "<div ng-mouseenter=\"pause()\" ng-mouseleave=\"play()\" class=\"carousel\" ng-swipe-right=\"prev()\" ng-swipe-left=\"next()\">\n" + "    <ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\">\n" + "        <li ng-repeat=\"slide in slides track by $index\" ng-class=\"{active: isActive(slide)}\" ng-click=\"select(slide)\"></li>\n" + "    </ol>\n" + "    <div class=\"carousel-inner\" ng-transclude></div>\n" + "    <a class=\"left carousel-control\" ng-click=\"prev()\" ng-show=\"slides.length > 1\"><span class=\"glyphicon glyphicon-chevron-left\"></span></a>\n" + "    <a class=\"right carousel-control\" ng-click=\"next()\" ng-show=\"slides.length > 1\"><span class=\"glyphicon glyphicon-chevron-right\"></span></a>\n" + "</div>\n" + "");}]);angular.module("template/carousel/slide.html", []).run(["$templateCache", function($templateCache){$templateCache.put("template/carousel/slide.html", "<div ng-class=\"{\n" + "    'active': leaving || (active && !entering),\n" + "    'prev': (next || active) && direction=='prev',\n" + "    'next': (next || active) && direction=='next',\n" + "    'right': direction=='prev',\n" + "    'left': direction=='next'\n" + "  }\" class=\"item text-center\" ng-transclude></div>\n" + "");}]);angular.module("template/datepicker/datepicker.html", []).run(["$templateCache", function($templateCache){$templateCache.put("template/datepicker/datepicker.html", "<div ng-switch=\"datepickerMode\" role=\"application\" ng-keydown=\"keydown($event)\">\n" + "  <daypicker ng-switch-when=\"day\" tabindex=\"0\"></daypicker>\n" + "  <monthpicker ng-switch-when=\"month\" tabindex=\"0\"></monthpicker>\n" + "  <yearpicker ng-switch-when=\"year\" tabindex=\"0\"></yearpicker>\n" + "</div>");}]);angular.module("template/datepicker/day.html", []).run(["$templateCache", function($templateCache){$templateCache.put("template/datepicker/day.html", "<table role=\"grid\" aria-labelledby=\"{{uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" + "  <thead>\n" + "    <tr>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" + "      <th colspan=\"{{5 + showWeeks}}\"><button id=\"{{uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" + "    </tr>\n" + "    <tr>\n" + "      <th ng-show=\"showWeeks\" class=\"text-center\"></th>\n" + "      <th ng-repeat=\"label in labels track by $index\" class=\"text-center\"><small aria-label=\"{{label.full}}\">{{label.abbr}}</small></th>\n" + "    </tr>\n" + "  </thead>\n" + "  <tbody>\n" + "    <tr ng-repeat=\"row in rows track by $index\">\n" + "      <td ng-show=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" + "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{dt.uid}}\" aria-disabled=\"{{!!dt.disabled}}\">\n" + "        <button type=\"button\" style=\"width:100%;\" class=\"btn btn-default btn-sm\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"{'text-muted': dt.secondary, 'text-info': dt.current}\">{{dt.label}}</span></button>\n" + "      </td>\n" + "    </tr>\n" + "  </tbody>\n" + "</table>\n" + "");}]);angular.module("template/datepicker/month.html", []).run(["$templateCache", function($templateCache){$templateCache.put("template/datepicker/month.html", "<table role=\"grid\" aria-labelledby=\"{{uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" + "  <thead>\n" + "    <tr>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" + "      <th><button id=\"{{uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" + "    </tr>\n" + "  </thead>\n" + "  <tbody>\n" + "    <tr ng-repeat=\"row in rows track by $index\">\n" + "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{dt.uid}}\" aria-disabled=\"{{!!dt.disabled}}\">\n" + "        <button type=\"button\" style=\"width:100%;\" class=\"btn btn-default\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"{'text-info': dt.current}\">{{dt.label}}</span></button>\n" + "      </td>\n" + "    </tr>\n" + "  </tbody>\n" + "</table>\n" + "");}]);angular.module("template/datepicker/popup.html", []).run(["$templateCache", function($templateCache){$templateCache.put("template/datepicker/popup.html", "<ul class=\"dropdown-menu\" ng-style=\"{display: (isOpen && 'block') || 'none', top: position.top+'px', left: position.left+'px'}\" ng-keydown=\"keydown($event)\">\n" + "\t<li ng-transclude></li>\n" + "\t<li ng-if=\"showButtonBar\" style=\"padding:10px 9px 2px\">\n" + "\t\t<span class=\"btn-group pull-left\">\n" + "\t\t\t<button type=\"button\" class=\"btn btn-sm btn-info\" ng-click=\"select('today')\">{{ getText('current') }}</button>\n" + "\t\t\t<button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"select(null)\">{{ getText('clear') }}</button>\n" + "\t\t</span>\n" + "\t\t<button type=\"button\" class=\"btn btn-sm btn-success pull-right\" ng-click=\"close()\">{{ getText('close') }}</button>\n" + "\t</li>\n" + "</ul>\n" + "");}]);angular.module("template/datepicker/year.html", []).run(["$templateCache", function($templateCache){$templateCache.put("template/datepicker/year.html", "<table role=\"grid\" aria-labelledby=\"{{uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" + "  <thead>\n" + "    <tr>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" + "      <th colspan=\"3\"><button id=\"{{uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" + "    </tr>\n" + "  </thead>\n" + "  <tbody>\n" + "    <tr ng-repeat=\"row in rows track by $index\">\n" + "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{dt.uid}}\" aria-disabled=\"{{!!dt.disabled}}\">\n" + "        <button type=\"button\" style=\"width:100%;\" class=\"btn btn-default\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"{'text-info': dt.current}\">{{dt.label}}</span></button>\n" + "      </td>\n" + "    </tr>\n" + "  </tbody>\n" + "</table>\n" + "");}]);angular.module("template/modal/backdrop.html", []).run(["$templateCache", function($templateCache){$templateCache.put("template/modal/backdrop.html", "<div class=\"modal-backdrop fade {{ backdropClass }}\"\n" + "     ng-class=\"{in: animate}\"\n" + "     ng-style=\"{'z-index': 1040 + (index && 1 || 0) + index*10}\"\n" + "></div>\n" + "");}]);angular.module("template/modal/window.html", []).run(["$templateCache", function($templateCache){$templateCache.put("template/modal/window.html", "<div tabindex=\"-1\" role=\"dialog\" class=\"modal fade\" ng-class=\"{in: animate}\" ng-style=\"{'z-index': 1050 + index*10, display: 'block'}\" ng-click=\"close($event)\">\n" + "    <div class=\"modal-dialog\" ng-class=\"{'modal-sm': size == 'sm', 'modal-lg': size == 'lg'}\"><div class=\"modal-content\" modal-transclude></div></div>\n" + "</div>");}]);angular.module("template/pagination/pager.html", []).run(["$templateCache", function($templateCache){$templateCache.put("template/pagination/pager.html", "<ul class=\"pager\">\n" + "  <li ng-class=\"{disabled: noPrevious(), previous: align}\"><a href ng-click=\"selectPage(page - 1)\">{{getText('previous')}}</a></li>\n" + "  <li ng-class=\"{disabled: noNext(), next: align}\"><a href ng-click=\"selectPage(page + 1)\">{{getText('next')}}</a></li>\n" + "</ul>");}]);angular.module("template/pagination/pagination.html", []).run(["$templateCache", function($templateCache){$templateCache.put("template/pagination/pagination.html", "<ul class=\"pagination\">\n" + "  <li ng-if=\"boundaryLinks\" ng-class=\"{disabled: noPrevious()}\"><a href ng-click=\"selectPage(1)\">{{getText('first')}}</a></li>\n" + "  <li ng-if=\"directionLinks\" ng-class=\"{disabled: noPrevious()}\"><a href ng-click=\"selectPage(page - 1)\">{{getText('previous')}}</a></li>\n" + "  <li ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active}\"><a href ng-click=\"selectPage(page.number)\">{{page.text}}</a></li>\n" + "  <li ng-if=\"directionLinks\" ng-class=\"{disabled: noNext()}\"><a href ng-click=\"selectPage(page + 1)\">{{getText('next')}}</a></li>\n" + "  <li ng-if=\"boundaryLinks\" ng-class=\"{disabled: noNext()}\"><a href ng-click=\"selectPage(totalPages)\">{{getText('last')}}</a></li>\n" + "</ul>");}]);angular.module("template/tooltip/tooltip-html-unsafe-popup.html", []).run(["$templateCache", function($templateCache){$templateCache.put("template/tooltip/tooltip-html-unsafe-popup.html", "<div class=\"tooltip {{placement}}\" ng-class=\"{ in: isOpen(), fade: animation() }\">\n" + "  <div class=\"tooltip-arrow\"></div>\n" + "  <div class=\"tooltip-inner\" bind-html-unsafe=\"content\"></div>\n" + "</div>\n" + "");}]);angular.module("template/tooltip/tooltip-popup.html", []).run(["$templateCache", function($templateCache){$templateCache.put("template/tooltip/tooltip-popup.html", "<div class=\"tooltip {{placement}}\" ng-class=\"{ in: isOpen(), fade: animation() }\">\n" + "  <div class=\"tooltip-arrow\"></div>\n" + "  <div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" + "</div>\n" + "");}]);angular.module("template/popover/popover.html", []).run(["$templateCache", function($templateCache){$templateCache.put("template/popover/popover.html", "<div class=\"popover {{placement}}\" ng-class=\"{ in: isOpen(), fade: animation() }\">\n" + "  <div class=\"arrow\"></div>\n" + "\n" + "  <div class=\"popover-inner\">\n" + "      <h3 class=\"popover-title\" ng-bind=\"title\" ng-show=\"title\"></h3>\n" + "      <div class=\"popover-content\" ng-bind=\"content\"></div>\n" + "  </div>\n" + "</div>\n" + "");}]);angular.module("template/progressbar/bar.html", []).run(["$templateCache", function($templateCache){$templateCache.put("template/progressbar/bar.html", "<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: percent + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" ng-transclude></div>");}]);angular.module("template/progressbar/progress.html", []).run(["$templateCache", function($templateCache){$templateCache.put("template/progressbar/progress.html", "<div class=\"progress\" ng-transclude></div>");}]);angular.module("template/progressbar/progressbar.html", []).run(["$templateCache", function($templateCache){$templateCache.put("template/progressbar/progressbar.html", "<div class=\"progress\">\n" + "  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: percent + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" ng-transclude></div>\n" + "</div>");}]);angular.module("template/rating/rating.html", []).run(["$templateCache", function($templateCache){$templateCache.put("template/rating/rating.html", "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\">\n" + "    <i ng-repeat=\"r in range track by $index\" ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"glyphicon\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\">\n" + "        <span class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n" + "    </i>\n" + "</span>");}]);angular.module("template/tabs/tab.html", []).run(["$templateCache", function($templateCache){$templateCache.put("template/tabs/tab.html", "<li ng-class=\"{active: active, disabled: disabled}\">\n" + "  <a href ng-click=\"select()\" tab-heading-transclude>{{heading}}</a>\n" + "</li>\n" + "");}]);angular.module("template/tabs/tabset.html", []).run(["$templateCache", function($templateCache){$templateCache.put("template/tabs/tabset.html", "<div>\n" + "  <ul class=\"nav nav-{{type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" + "  <div class=\"tab-content\">\n" + "    <div class=\"tab-pane\" \n" + "         ng-repeat=\"tab in tabs\" \n" + "         ng-class=\"{active: tab.active}\"\n" + "         tab-content-transclude=\"tab\">\n" + "    </div>\n" + "  </div>\n" + "</div>\n" + "");}]);angular.module("template/timepicker/timepicker.html", []).run(["$templateCache", function($templateCache){$templateCache.put("template/timepicker/timepicker.html", "<table>\n" + "\t<tbody>\n" + "\t\t<tr class=\"text-center\">\n" + "\t\t\t<td><a ng-click=\"incrementHours()\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" + "\t\t\t<td>&nbsp;</td>\n" + "\t\t\t<td><a ng-click=\"incrementMinutes()\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" + "\t\t\t<td ng-show=\"showMeridian\"></td>\n" + "\t\t</tr>\n" + "\t\t<tr>\n" + "\t\t\t<td style=\"width:50px;\" class=\"form-group\" ng-class=\"{'has-error': invalidHours}\">\n" + "\t\t\t\t<input type=\"text\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-mousewheel=\"incrementHours()\" ng-readonly=\"readonlyInput\" maxlength=\"2\">\n" + "\t\t\t</td>\n" + "\t\t\t<td>:</td>\n" + "\t\t\t<td style=\"width:50px;\" class=\"form-group\" ng-class=\"{'has-error': invalidMinutes}\">\n" + "\t\t\t\t<input type=\"text\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\">\n" + "\t\t\t</td>\n" + "\t\t\t<td ng-show=\"showMeridian\"><button type=\"button\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\">{{meridian}}</button></td>\n" + "\t\t</tr>\n" + "\t\t<tr class=\"text-center\">\n" + "\t\t\t<td><a ng-click=\"decrementHours()\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" + "\t\t\t<td>&nbsp;</td>\n" + "\t\t\t<td><a ng-click=\"decrementMinutes()\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" + "\t\t\t<td ng-show=\"showMeridian\"></td>\n" + "\t\t</tr>\n" + "\t</tbody>\n" + "</table>\n" + "");}]);angular.module("template/typeahead/typeahead-match.html", []).run(["$templateCache", function($templateCache){$templateCache.put("template/typeahead/typeahead-match.html", "<a tabindex=\"-1\" bind-html-unsafe=\"match.label | typeaheadHighlight:query\"></a>");}]);angular.module("template/typeahead/typeahead-popup.html", []).run(["$templateCache", function($templateCache){$templateCache.put("template/typeahead/typeahead-popup.html", "<ul class=\"dropdown-menu\" ng-show=\"isOpen()\" ng-style=\"{top: position.top+'px', left: position.left+'px'}\" style=\"display: block;\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" + "    <li ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index)\" role=\"option\" id=\"{{match.id}}\">\n" + "        <div typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n" + "    </li>\n" + "</ul>\n" + "");}]);

/***/ }),
/* 224 */
/***/ (function(module, exports) {

	"use strict";angular.module("ui.bootstrap", ["ui.bootstrap.transition", "ui.bootstrap.collapse", "ui.bootstrap.accordion", "ui.bootstrap.alert", "ui.bootstrap.bindHtml", "ui.bootstrap.buttons", "ui.bootstrap.carousel", "ui.bootstrap.dateparser", "ui.bootstrap.position", "ui.bootstrap.datepicker", "ui.bootstrap.dropdown", "ui.bootstrap.modal", "ui.bootstrap.pagination", "ui.bootstrap.tooltip", "ui.bootstrap.popover", "ui.bootstrap.progressbar", "ui.bootstrap.rating", "ui.bootstrap.tabs", "ui.bootstrap.timepicker", "ui.bootstrap.typeahead"]);angular.module("ui.bootstrap.transition", []).factory("$transition", ["$q", "$timeout", "$rootScope", function($q, $timeout, $rootScope){var $transition=(function(_$transition){var _$transitionWrapper=function $transition(_x, _x2, _x3){return _$transition.apply(this, arguments);};_$transitionWrapper.toString = function(){return _$transition.toString();};return _$transitionWrapper;})(function(element, trigger, options){options = options || {};var deferred=$q.defer();var endEventName=$transition[options.animation?"animationEndEventName":"transitionEndEventName"];var transitionEndHandler=(function(_transitionEndHandler){var _transitionEndHandlerWrapper=function transitionEndHandler(_x4){return _transitionEndHandler.apply(this, arguments);};_transitionEndHandlerWrapper.toString = function(){return _transitionEndHandler.toString();};return _transitionEndHandlerWrapper;})(function(event){$rootScope.$apply(function(){element.unbind(endEventName, transitionEndHandler);deferred.resolve(element);});});if(endEventName){element.bind(endEventName, transitionEndHandler);}$timeout(function(){if(angular.isString(trigger)){element.addClass(trigger);}else if(angular.isFunction(trigger)){trigger(element);}else if(angular.isObject(trigger)){element.css(trigger);}if(!endEventName){deferred.resolve(element);}});deferred.promise.cancel = function(){if(endEventName){element.unbind(endEventName, transitionEndHandler);}deferred.reject("Transition cancelled");};return deferred.promise;});var transElement=document.createElement("trans");var transitionEndEventNames={WebkitTransition:"webkitTransitionEnd", MozTransition:"transitionend", OTransition:"oTransitionEnd", transition:"transitionend"};var animationEndEventNames={WebkitTransition:"webkitAnimationEnd", MozTransition:"animationend", OTransition:"oAnimationEnd", transition:"animationend"};function findEndEventName(endEventNames){for(var name in endEventNames) {if(transElement.style[name] !== undefined){return endEventNames[name];}}}$transition.transitionEndEventName = findEndEventName(transitionEndEventNames);$transition.animationEndEventName = findEndEventName(animationEndEventNames);return $transition;}]);angular.module("ui.bootstrap.collapse", ["ui.bootstrap.transition"]).directive("collapse", ["$transition", function($transition){return {link:function link(scope, element, attrs){var initialAnimSkip=true;var currentTransition;function doTransition(change){var newTransition=$transition(element, change);if(currentTransition){currentTransition.cancel();}currentTransition = newTransition;newTransition.then(newTransitionDone, newTransitionDone);return newTransition;function newTransitionDone(){if(currentTransition === newTransition){currentTransition = undefined;}}}function expand(){if(initialAnimSkip){initialAnimSkip = false;expandDone();}else {element.removeClass("collapse").addClass("collapsing");doTransition({height:element[0].scrollHeight + "px"}).then(expandDone);}}function expandDone(){element.removeClass("collapsing");element.addClass("collapse in");element.css({height:"auto"});}function collapse(){if(initialAnimSkip){initialAnimSkip = false;collapseDone();element.css({height:0});}else {element.css({height:element[0].scrollHeight + "px"});var x=element[0].offsetWidth;element.removeClass("collapse in").addClass("collapsing");doTransition({height:0}).then(collapseDone);}}function collapseDone(){element.removeClass("collapsing");element.addClass("collapse");}scope.$watch(attrs.collapse, function(shouldCollapse){if(shouldCollapse){collapse();}else {expand();}});}};}]);angular.module("ui.bootstrap.accordion", ["ui.bootstrap.collapse"]).constant("accordionConfig", {closeOthers:true}).controller("AccordionController", ["$scope", "$attrs", "accordionConfig", function($scope, $attrs, accordionConfig){this.groups = [];this.closeOthers = function(openGroup){var closeOthers=angular.isDefined($attrs.closeOthers)?$scope.$eval($attrs.closeOthers):accordionConfig.closeOthers;if(closeOthers){angular.forEach(this.groups, function(group){if(group !== openGroup){group.isOpen = false;}});}};this.addGroup = function(groupScope){var that=this;this.groups.push(groupScope);groupScope.$on("$destroy", function(event){that.removeGroup(groupScope);});};this.removeGroup = function(group){var index=this.groups.indexOf(group);if(index !== -1){this.groups.splice(index, 1);}};}]).directive("accordion", function(){return {restrict:"EA", controller:"AccordionController", transclude:true, replace:false, templateUrl:"template/accordion/accordion.html"};}).directive("accordionGroup", function(){return {require:"^accordion", restrict:"EA", transclude:true, replace:true, templateUrl:"template/accordion/accordion-group.html", scope:{heading:"@", isOpen:"=?", isDisabled:"=?"}, controller:function controller(){this.setHeading = function(element){this.heading = element;};}, link:function link(scope, element, attrs, accordionCtrl){accordionCtrl.addGroup(scope);scope.$watch("isOpen", function(value){if(value){accordionCtrl.closeOthers(scope);}});scope.toggleOpen = function(){if(!scope.isDisabled){scope.isOpen = !scope.isOpen;}};}};}).directive("accordionHeading", function(){return {restrict:"EA", transclude:true, template:"", replace:true, require:"^accordionGroup", link:function link(scope, element, attr, accordionGroupCtrl, transclude){accordionGroupCtrl.setHeading(transclude(scope, function(){}));}};}).directive("accordionTransclude", function(){return {require:"^accordionGroup", link:function link(scope, element, attr, controller){scope.$watch(function(){return controller[attr.accordionTransclude];}, function(heading){if(heading){element.html("");element.append(heading);}});}};});angular.module("ui.bootstrap.alert", []).controller("AlertController", ["$scope", "$attrs", function($scope, $attrs){$scope.closeable = "close" in $attrs;this.close = $scope.close;}]).directive("alert", function(){return {restrict:"EA", controller:"AlertController", templateUrl:"template/alert/alert.html", transclude:true, replace:true, scope:{type:"@", close:"&"}};}).directive("dismissOnTimeout", ["$timeout", function($timeout){return {require:"alert", link:function link(scope, element, attrs, alertCtrl){$timeout(function(){alertCtrl.close();}, parseInt(attrs.dismissOnTimeout, 10));}};}]);angular.module("ui.bootstrap.bindHtml", []).directive("bindHtmlUnsafe", function(){return function(scope, element, attr){element.addClass("ng-binding").data("$binding", attr.bindHtmlUnsafe);scope.$watch(attr.bindHtmlUnsafe, function bindHtmlUnsafeWatchAction(value){element.html(value || "");});};});angular.module("ui.bootstrap.buttons", []).constant("buttonConfig", {activeClass:"active", toggleEvent:"click"}).controller("ButtonsController", ["buttonConfig", function(buttonConfig){this.activeClass = buttonConfig.activeClass || "active";this.toggleEvent = buttonConfig.toggleEvent || "click";}]).directive("btnRadio", function(){return {require:["btnRadio", "ngModel"], controller:"ButtonsController", link:function link(scope, element, attrs, ctrls){var buttonsCtrl=ctrls[0], ngModelCtrl=ctrls[1];ngModelCtrl.$render = function(){element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.btnRadio)));};element.bind(buttonsCtrl.toggleEvent, function(){var isActive=element.hasClass(buttonsCtrl.activeClass);if(!isActive || angular.isDefined(attrs.uncheckable)){scope.$apply(function(){ngModelCtrl.$setViewValue(isActive?null:scope.$eval(attrs.btnRadio));ngModelCtrl.$render();});}});}};}).directive("btnCheckbox", function(){return {require:["btnCheckbox", "ngModel"], controller:"ButtonsController", link:function link(scope, element, attrs, ctrls){var buttonsCtrl=ctrls[0], ngModelCtrl=ctrls[1];function getTrueValue(){return getCheckboxValue(attrs.btnCheckboxTrue, true);}function getFalseValue(){return getCheckboxValue(attrs.btnCheckboxFalse, false);}function getCheckboxValue(attributeValue, defaultValue){var val=scope.$eval(attributeValue);return angular.isDefined(val)?val:defaultValue;}ngModelCtrl.$render = function(){element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));};element.bind(buttonsCtrl.toggleEvent, function(){scope.$apply(function(){ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass)?getFalseValue():getTrueValue());ngModelCtrl.$render();});});}};});angular.module("ui.bootstrap.carousel", ["ui.bootstrap.transition"]).controller("CarouselController", ["$scope", "$timeout", "$interval", "$transition", function($scope, $timeout, $interval, $transition){var self=this, slides=self.slides = $scope.slides = [], currentIndex=-1, currentInterval, isPlaying;self.currentSlide = null;var destroyed=false;self.select = $scope.select = function(nextSlide, direction){var nextIndex=slides.indexOf(nextSlide);if(direction === undefined){direction = nextIndex > currentIndex?"next":"prev";}if(nextSlide && nextSlide !== self.currentSlide){if($scope.$currentTransition){$scope.$currentTransition.cancel();$timeout(goNext);}else {goNext();}}function goNext(){if(destroyed){return;}if(self.currentSlide && angular.isString(direction) && !$scope.noTransition && nextSlide.$element){nextSlide.$element.addClass(direction);var reflow=nextSlide.$element[0].offsetWidth;angular.forEach(slides, function(slide){angular.extend(slide, {direction:"", entering:false, leaving:false, active:false});});angular.extend(nextSlide, {direction:direction, active:true, entering:true});angular.extend(self.currentSlide || {}, {direction:direction, leaving:true});$scope.$currentTransition = $transition(nextSlide.$element, {});(function(next, current){$scope.$currentTransition.then(function(){transitionDone(next, current);}, function(){transitionDone(next, current);});})(nextSlide, self.currentSlide);}else {transitionDone(nextSlide, self.currentSlide);}self.currentSlide = nextSlide;currentIndex = nextIndex;restartTimer();}function transitionDone(next, current){angular.extend(next, {direction:"", active:true, leaving:false, entering:false});angular.extend(current || {}, {direction:"", active:false, leaving:false, entering:false});$scope.$currentTransition = null;}};$scope.$on("$destroy", function(){destroyed = true;});self.indexOfSlide = function(slide){return slides.indexOf(slide);};$scope.next = function(){var newIndex=(currentIndex + 1) % slides.length;if(!$scope.$currentTransition){return self.select(slides[newIndex], "next");}};$scope.prev = function(){var newIndex=currentIndex - 1 < 0?slides.length - 1:currentIndex - 1;if(!$scope.$currentTransition){return self.select(slides[newIndex], "prev");}};$scope.isActive = function(slide){return self.currentSlide === slide;};$scope.$watch("interval", restartTimer);$scope.$on("$destroy", resetTimer);function restartTimer(){resetTimer();var interval=+$scope.interval;if(!isNaN(interval) && interval > 0){currentInterval = $interval(timerFn, interval);}}function resetTimer(){if(currentInterval){$interval.cancel(currentInterval);currentInterval = null;}}function timerFn(){var interval=+$scope.interval;if(isPlaying && !isNaN(interval) && interval > 0){$scope.next();}else {$scope.pause();}}$scope.play = function(){if(!isPlaying){isPlaying = true;restartTimer();}};$scope.pause = function(){if(!$scope.noPause){isPlaying = false;resetTimer();}};self.addSlide = function(slide, element){slide.$element = element;slides.push(slide);if(slides.length === 1 || slide.active){self.select(slides[slides.length - 1]);if(slides.length == 1){$scope.play();}}else {slide.active = false;}};self.removeSlide = function(slide){var index=slides.indexOf(slide);slides.splice(index, 1);if(slides.length > 0 && slide.active){if(index >= slides.length){self.select(slides[index - 1]);}else {self.select(slides[index]);}}else if(currentIndex > index){currentIndex--;}};}]).directive("carousel", [function(){return {restrict:"EA", transclude:true, replace:true, controller:"CarouselController", require:"carousel", templateUrl:"template/carousel/carousel.html", scope:{interval:"=", noTransition:"=", noPause:"="}};}]).directive("slide", function(){return {require:"^carousel", restrict:"EA", transclude:true, replace:true, templateUrl:"template/carousel/slide.html", scope:{active:"=?"}, link:function link(scope, element, attrs, carouselCtrl){carouselCtrl.addSlide(scope, element);scope.$on("$destroy", function(){carouselCtrl.removeSlide(scope);});scope.$watch("active", function(active){if(active){carouselCtrl.select(scope);}});}};});angular.module("ui.bootstrap.dateparser", []).service("dateParser", ["$locale", "orderByFilter", function($locale, orderByFilter){this.parsers = {};var formatCodeToRegex={yyyy:{regex:"\\d{4}", apply:function apply(value){this.year = +value;}}, yy:{regex:"\\d{2}", apply:function apply(value){this.year = +value + 2000;}}, y:{regex:"\\d{1,4}", apply:function apply(value){this.year = +value;}}, MMMM:{regex:$locale.DATETIME_FORMATS.MONTH.join("|"), apply:function apply(value){this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value);}}, MMM:{regex:$locale.DATETIME_FORMATS.SHORTMONTH.join("|"), apply:function apply(value){this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value);}}, MM:{regex:"0[1-9]|1[0-2]", apply:function apply(value){this.month = value - 1;}}, M:{regex:"[1-9]|1[0-2]", apply:function apply(value){this.month = value - 1;}}, dd:{regex:"[0-2][0-9]{1}|3[0-1]{1}", apply:function apply(value){this.date = +value;}}, d:{regex:"[1-2]?[0-9]{1}|3[0-1]{1}", apply:function apply(value){this.date = +value;}}, EEEE:{regex:$locale.DATETIME_FORMATS.DAY.join("|")}, EEE:{regex:$locale.DATETIME_FORMATS.SHORTDAY.join("|")}};function createParser(format){var map=[], regex=format.split("");angular.forEach(formatCodeToRegex, function(data, code){var index=format.indexOf(code);if(index > -1){format = format.split("");regex[index] = "(" + data.regex + ")";format[index] = "$";for(var i=index + 1, n=index + code.length; i < n; i++) {regex[i] = "";format[i] = "$";}format = format.join("");map.push({index:index, apply:data.apply});}});return {regex:new RegExp("^" + regex.join("") + "$"), map:orderByFilter(map, "index")};}this.parse = function(input, format){if(!angular.isString(input) || !format){return input;}format = $locale.DATETIME_FORMATS[format] || format;if(!this.parsers[format]){this.parsers[format] = createParser(format);}var parser=this.parsers[format], regex=parser.regex, map=parser.map, results=input.match(regex);if(results && results.length){var fields={year:1900, month:0, date:1, hours:0}, dt;for(var i=1, n=results.length; i < n; i++) {var mapper=map[i - 1];if(mapper.apply){mapper.apply.call(fields, results[i]);}}if(isValid(fields.year, fields.month, fields.date)){dt = new Date(fields.year, fields.month, fields.date, fields.hours);}return dt;}};function isValid(year, month, date){if(month === 1 && date > 28){return date === 29 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);}if(month === 3 || month === 5 || month === 8 || month === 10){return date < 31;}return true;}}]);angular.module("ui.bootstrap.position", []).factory("$position", ["$document", "$window", function($document, $window){function getStyle(el, cssprop){if(el.currentStyle){return el.currentStyle[cssprop];}else if($window.getComputedStyle){return $window.getComputedStyle(el)[cssprop];}return el.style[cssprop];}function isStaticPositioned(element){return (getStyle(element, "position") || "static") === "static";}var parentOffsetEl=function parentOffsetEl(element){var docDomEl=$document[0];var offsetParent=element.offsetParent || docDomEl;while(offsetParent && offsetParent !== docDomEl && isStaticPositioned(offsetParent)) {offsetParent = offsetParent.offsetParent;}return offsetParent || docDomEl;};return {position:function position(element){var elBCR=this.offset(element);var offsetParentBCR={top:0, left:0};var offsetParentEl=parentOffsetEl(element[0]);if(offsetParentEl != $document[0]){offsetParentBCR = this.offset(angular.element(offsetParentEl));offsetParentBCR.top += offsetParentEl.clientTop - offsetParentEl.scrollTop;offsetParentBCR.left += offsetParentEl.clientLeft - offsetParentEl.scrollLeft;}var boundingClientRect=element[0].getBoundingClientRect();return {width:boundingClientRect.width || element.prop("offsetWidth"), height:boundingClientRect.height || element.prop("offsetHeight"), top:elBCR.top - offsetParentBCR.top, left:elBCR.left - offsetParentBCR.left};}, offset:function offset(element){var boundingClientRect=element[0].getBoundingClientRect();return {width:boundingClientRect.width || element.prop("offsetWidth"), height:boundingClientRect.height || element.prop("offsetHeight"), top:boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop), left:boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)};}, positionElements:function positionElements(hostEl, targetEl, positionStr, appendToBody){var positionStrParts=positionStr.split("-");var pos0=positionStrParts[0], pos1=positionStrParts[1] || "center";var hostElPos, targetElWidth, targetElHeight, targetElPos;hostElPos = appendToBody?this.offset(hostEl):this.position(hostEl);targetElWidth = targetEl.prop("offsetWidth");targetElHeight = targetEl.prop("offsetHeight");var shiftWidth={center:function center(){return hostElPos.left + hostElPos.width / 2 - targetElWidth / 2;}, left:function left(){return hostElPos.left;}, right:function right(){return hostElPos.left + hostElPos.width;}};var shiftHeight={center:function center(){return hostElPos.top + hostElPos.height / 2 - targetElHeight / 2;}, top:function top(){return hostElPos.top;}, bottom:function bottom(){return hostElPos.top + hostElPos.height;}};switch(pos0){case "right":targetElPos = {top:shiftHeight[pos1](), left:shiftWidth[pos0]()};break;case "left":targetElPos = {top:shiftHeight[pos1](), left:hostElPos.left - targetElWidth};break;case "bottom":targetElPos = {top:shiftHeight[pos0](), left:shiftWidth[pos1]()};break;default:targetElPos = {top:hostElPos.top - targetElHeight, left:shiftWidth[pos1]()};break;}return targetElPos;}};}]);angular.module("ui.bootstrap.datepicker", ["ui.bootstrap.dateparser", "ui.bootstrap.position"]).constant("datepickerConfig", {formatDay:"dd", formatMonth:"MMMM", formatYear:"yyyy", formatDayHeader:"EEE", formatDayTitle:"MMMM yyyy", formatMonthTitle:"yyyy", datepickerMode:"day", minMode:"day", maxMode:"year", showWeeks:true, startingDay:0, yearRange:20, minDate:null, maxDate:null}).controller("DatepickerController", ["$scope", "$attrs", "$parse", "$interpolate", "$timeout", "$log", "dateFilter", "datepickerConfig", function($scope, $attrs, $parse, $interpolate, $timeout, $log, dateFilter, datepickerConfig){var self=this, ngModelCtrl={$setViewValue:angular.noop};this.modes = ["day", "month", "year"];angular.forEach(["formatDay", "formatMonth", "formatYear", "formatDayHeader", "formatDayTitle", "formatMonthTitle", "minMode", "maxMode", "showWeeks", "startingDay", "yearRange"], function(key, index){self[key] = angular.isDefined($attrs[key])?index < 8?$interpolate($attrs[key])($scope.$parent):$scope.$parent.$eval($attrs[key]):datepickerConfig[key];});angular.forEach(["minDate", "maxDate"], function(key){if($attrs[key]){$scope.$parent.$watch($parse($attrs[key]), function(value){self[key] = value?new Date(value):null;self.refreshView();});}else {self[key] = datepickerConfig[key]?new Date(datepickerConfig[key]):null;}});$scope.datepickerMode = $scope.datepickerMode || datepickerConfig.datepickerMode;$scope.uniqueId = "datepicker-" + $scope.$id + "-" + Math.floor(Math.random() * 10000);this.activeDate = angular.isDefined($attrs.initDate)?$scope.$parent.$eval($attrs.initDate):new Date();$scope.isActive = function(dateObject){if(self.compare(dateObject.date, self.activeDate) === 0){$scope.activeDateId = dateObject.uid;return true;}return false;};this.init = function(ngModelCtrl_){ngModelCtrl = ngModelCtrl_;ngModelCtrl.$render = function(){self.render();};};this.render = function(){if(ngModelCtrl.$modelValue){var date=new Date(ngModelCtrl.$modelValue), isValid=!isNaN(date);if(isValid){this.activeDate = date;}else {$log.error("Datepicker directive: \"ng-model\" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.");}ngModelCtrl.$setValidity("date", isValid);}this.refreshView();};this.refreshView = function(){if(this.element){this._refreshView();var date=ngModelCtrl.$modelValue?new Date(ngModelCtrl.$modelValue):null;ngModelCtrl.$setValidity("date-disabled", !date || this.element && !this.isDisabled(date));}};this.createDateObject = function(date, format){var model=ngModelCtrl.$modelValue?new Date(ngModelCtrl.$modelValue):null;return {date:date, label:dateFilter(date, format), selected:model && this.compare(date, model) === 0, disabled:this.isDisabled(date), current:this.compare(date, new Date()) === 0};};this.isDisabled = function(date){return this.minDate && this.compare(date, this.minDate) < 0 || this.maxDate && this.compare(date, this.maxDate) > 0 || $attrs.dateDisabled && $scope.dateDisabled({date:date, mode:$scope.datepickerMode});};this.split = function(arr, size){var arrays=[];while(arr.length > 0) {arrays.push(arr.splice(0, size));}return arrays;};$scope.select = function(date){if($scope.datepickerMode === self.minMode){var dt=ngModelCtrl.$modelValue?new Date(ngModelCtrl.$modelValue):new Date(0, 0, 0, 0, 0, 0, 0);dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());ngModelCtrl.$setViewValue(dt);ngModelCtrl.$render();}else {self.activeDate = date;$scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) - 1];}};$scope.move = function(direction){var year=self.activeDate.getFullYear() + direction * (self.step.years || 0), month=self.activeDate.getMonth() + direction * (self.step.months || 0);self.activeDate.setFullYear(year, month, 1);self.refreshView();};$scope.toggleMode = function(direction){direction = direction || 1;if($scope.datepickerMode === self.maxMode && direction === 1 || $scope.datepickerMode === self.minMode && direction === -1){return;}$scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) + direction];};$scope.keys = {13:"enter", 32:"space", 33:"pageup", 34:"pagedown", 35:"end", 36:"home", 37:"left", 38:"up", 39:"right", 40:"down"};var focusElement=function focusElement(){$timeout(function(){self.element[0].focus();}, 0, false);};$scope.$on("datepicker.focus", focusElement);$scope.keydown = function(evt){var key=$scope.keys[evt.which];if(!key || evt.shiftKey || evt.altKey){return;}evt.preventDefault();evt.stopPropagation();if(key === "enter" || key === "space"){if(self.isDisabled(self.activeDate)){return;}$scope.select(self.activeDate);focusElement();}else if(evt.ctrlKey && (key === "up" || key === "down")){$scope.toggleMode(key === "up"?1:-1);focusElement();}else {self.handleKeyDown(key, evt);self.refreshView();}};}]).directive("datepicker", function(){return {restrict:"EA", replace:true, templateUrl:"template/datepicker/datepicker.html", scope:{datepickerMode:"=?", dateDisabled:"&"}, require:["datepicker", "?^ngModel"], controller:"DatepickerController", link:function link(scope, element, attrs, ctrls){var datepickerCtrl=ctrls[0], ngModelCtrl=ctrls[1];if(ngModelCtrl){datepickerCtrl.init(ngModelCtrl);}}};}).directive("daypicker", ["dateFilter", function(dateFilter){return {restrict:"EA", replace:true, templateUrl:"template/datepicker/day.html", require:"^datepicker", link:function link(scope, element, attrs, ctrl){scope.showWeeks = ctrl.showWeeks;ctrl.step = {months:1};ctrl.element = element;var DAYS_IN_MONTH=[31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];function getDaysInMonth(year, month){return month === 1 && year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)?29:DAYS_IN_MONTH[month];}function getDates(startDate, n){var dates=new Array(n), current=new Date(startDate), i=0;current.setHours(12);while(i < n) {dates[i++] = new Date(current);current.setDate(current.getDate() + 1);}return dates;}ctrl._refreshView = function(){var year=ctrl.activeDate.getFullYear(), month=ctrl.activeDate.getMonth(), firstDayOfMonth=new Date(year, month, 1), difference=ctrl.startingDay - firstDayOfMonth.getDay(), numDisplayedFromPreviousMonth=difference > 0?7 - difference:-difference, firstDate=new Date(firstDayOfMonth);if(numDisplayedFromPreviousMonth > 0){firstDate.setDate(-numDisplayedFromPreviousMonth + 1);}var days=getDates(firstDate, 42);for(var i=0; i < 42; i++) {days[i] = angular.extend(ctrl.createDateObject(days[i], ctrl.formatDay), {secondary:days[i].getMonth() !== month, uid:scope.uniqueId + "-" + i});}scope.labels = new Array(7);for(var j=0; j < 7; j++) {scope.labels[j] = {abbr:dateFilter(days[j].date, ctrl.formatDayHeader), full:dateFilter(days[j].date, "EEEE")};}scope.title = dateFilter(ctrl.activeDate, ctrl.formatDayTitle);scope.rows = ctrl.split(days, 7);if(scope.showWeeks){scope.weekNumbers = [];var weekNumber=getISO8601WeekNumber(scope.rows[0][0].date), numWeeks=scope.rows.length;while(scope.weekNumbers.push(weekNumber++) < numWeeks) {}}};ctrl.compare = function(date1, date2){return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());};function getISO8601WeekNumber(date){var checkDate=new Date(date);checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7));var time=checkDate.getTime();checkDate.setMonth(0);checkDate.setDate(1);return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;}ctrl.handleKeyDown = function(key, evt){var date=ctrl.activeDate.getDate();if(key === "left"){date = date - 1;}else if(key === "up"){date = date - 7;}else if(key === "right"){date = date + 1;}else if(key === "down"){date = date + 7;}else if(key === "pageup" || key === "pagedown"){var month=ctrl.activeDate.getMonth() + (key === "pageup"?-1:1);ctrl.activeDate.setMonth(month, 1);date = Math.min(getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth()), date);}else if(key === "home"){date = 1;}else if(key === "end"){date = getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth());}ctrl.activeDate.setDate(date);};ctrl.refreshView();}};}]).directive("monthpicker", ["dateFilter", function(dateFilter){return {restrict:"EA", replace:true, templateUrl:"template/datepicker/month.html", require:"^datepicker", link:function link(scope, element, attrs, ctrl){ctrl.step = {years:1};ctrl.element = element;ctrl._refreshView = function(){var months=new Array(12), year=ctrl.activeDate.getFullYear();for(var i=0; i < 12; i++) {months[i] = angular.extend(ctrl.createDateObject(new Date(year, i, 1), ctrl.formatMonth), {uid:scope.uniqueId + "-" + i});}scope.title = dateFilter(ctrl.activeDate, ctrl.formatMonthTitle);scope.rows = ctrl.split(months, 3);};ctrl.compare = function(date1, date2){return new Date(date1.getFullYear(), date1.getMonth()) - new Date(date2.getFullYear(), date2.getMonth());};ctrl.handleKeyDown = function(key, evt){var date=ctrl.activeDate.getMonth();if(key === "left"){date = date - 1;}else if(key === "up"){date = date - 3;}else if(key === "right"){date = date + 1;}else if(key === "down"){date = date + 3;}else if(key === "pageup" || key === "pagedown"){var year=ctrl.activeDate.getFullYear() + (key === "pageup"?-1:1);ctrl.activeDate.setFullYear(year);}else if(key === "home"){date = 0;}else if(key === "end"){date = 11;}ctrl.activeDate.setMonth(date);};ctrl.refreshView();}};}]).directive("yearpicker", ["dateFilter", function(dateFilter){return {restrict:"EA", replace:true, templateUrl:"template/datepicker/year.html", require:"^datepicker", link:function link(scope, element, attrs, ctrl){var range=ctrl.yearRange;ctrl.step = {years:range};ctrl.element = element;function getStartingYear(year){return parseInt((year - 1) / range, 10) * range + 1;}ctrl._refreshView = function(){var years=new Array(range);for(var i=0, start=getStartingYear(ctrl.activeDate.getFullYear()); i < range; i++) {years[i] = angular.extend(ctrl.createDateObject(new Date(start + i, 0, 1), ctrl.formatYear), {uid:scope.uniqueId + "-" + i});}scope.title = [years[0].label, years[range - 1].label].join(" - ");scope.rows = ctrl.split(years, 5);};ctrl.compare = function(date1, date2){return date1.getFullYear() - date2.getFullYear();};ctrl.handleKeyDown = function(key, evt){var date=ctrl.activeDate.getFullYear();if(key === "left"){date = date - 1;}else if(key === "up"){date = date - 5;}else if(key === "right"){date = date + 1;}else if(key === "down"){date = date + 5;}else if(key === "pageup" || key === "pagedown"){date += (key === "pageup"?-1:1) * ctrl.step.years;}else if(key === "home"){date = getStartingYear(ctrl.activeDate.getFullYear());}else if(key === "end"){date = getStartingYear(ctrl.activeDate.getFullYear()) + range - 1;}ctrl.activeDate.setFullYear(date);};ctrl.refreshView();}};}]).constant("datepickerPopupConfig", {datepickerPopup:"yyyy-MM-dd", currentText:"Today", clearText:"Clear", closeText:"Done", closeOnDateSelection:true, appendToBody:false, showButtonBar:true}).directive("datepickerPopup", ["$compile", "$parse", "$document", "$position", "dateFilter", "dateParser", "datepickerPopupConfig", function($compile, $parse, $document, $position, dateFilter, dateParser, datepickerPopupConfig){return {restrict:"EA", require:"ngModel", scope:{isOpen:"=?", currentText:"@", clearText:"@", closeText:"@", dateDisabled:"&"}, link:function link(scope, element, attrs, ngModel){var dateFormat, closeOnDateSelection=angular.isDefined(attrs.closeOnDateSelection)?scope.$parent.$eval(attrs.closeOnDateSelection):datepickerPopupConfig.closeOnDateSelection, appendToBody=angular.isDefined(attrs.datepickerAppendToBody)?scope.$parent.$eval(attrs.datepickerAppendToBody):datepickerPopupConfig.appendToBody;scope.showButtonBar = angular.isDefined(attrs.showButtonBar)?scope.$parent.$eval(attrs.showButtonBar):datepickerPopupConfig.showButtonBar;scope.getText = function(key){return scope[key + "Text"] || datepickerPopupConfig[key + "Text"];};attrs.$observe("datepickerPopup", function(value){dateFormat = value || datepickerPopupConfig.datepickerPopup;ngModel.$render();});var popupEl=angular.element("<div datepicker-popup-wrap><div datepicker></div></div>");popupEl.attr({"ng-model":"date", "ng-change":"dateSelection()"});function cameltoDash(string){return string.replace(/([A-Z])/g, function($1){return "-" + $1.toLowerCase();});}var datepickerEl=angular.element(popupEl.children()[0]);if(attrs.datepickerOptions){angular.forEach(scope.$parent.$eval(attrs.datepickerOptions), function(value, option){datepickerEl.attr(cameltoDash(option), value);});}scope.watchData = {};angular.forEach(["minDate", "maxDate", "datepickerMode"], function(key){if(attrs[key]){var getAttribute=$parse(attrs[key]);scope.$parent.$watch(getAttribute, function(value){scope.watchData[key] = value;});datepickerEl.attr(cameltoDash(key), "watchData." + key);if(key === "datepickerMode"){var setAttribute=getAttribute.assign;scope.$watch("watchData." + key, function(value, oldvalue){if(value !== oldvalue){setAttribute(scope.$parent, value);}});}}});if(attrs.dateDisabled){datepickerEl.attr("date-disabled", "dateDisabled({ date: date, mode: mode })");}function parseDate(viewValue){if(!viewValue){ngModel.$setValidity("date", true);return null;}else if(angular.isDate(viewValue) && !isNaN(viewValue)){ngModel.$setValidity("date", true);return viewValue;}else if(angular.isString(viewValue)){var date=dateParser.parse(viewValue, dateFormat) || new Date(viewValue);if(isNaN(date)){ngModel.$setValidity("date", false);return undefined;}else {ngModel.$setValidity("date", true);return date;}}else {ngModel.$setValidity("date", false);return undefined;}}ngModel.$parsers.unshift(parseDate);scope.dateSelection = function(dt){if(angular.isDefined(dt)){scope.date = dt;}ngModel.$setViewValue(scope.date);ngModel.$render();if(closeOnDateSelection){scope.isOpen = false;element[0].focus();}};element.bind("input change keyup", function(){scope.$apply(function(){scope.date = ngModel.$modelValue;});});ngModel.$render = function(){var date=ngModel.$viewValue?dateFilter(ngModel.$viewValue, dateFormat):"";element.val(date);scope.date = parseDate(ngModel.$modelValue);};var documentClickBind=function documentClickBind(event){if(scope.isOpen && event.target !== element[0]){scope.$apply(function(){scope.isOpen = false;});}};var keydown=function keydown(evt, noApply){scope.keydown(evt);};element.bind("keydown", keydown);scope.keydown = function(evt){if(evt.which === 27){evt.preventDefault();evt.stopPropagation();scope.close();}else if(evt.which === 40 && !scope.isOpen){scope.isOpen = true;}};scope.$watch("isOpen", function(value){if(value){scope.$broadcast("datepicker.focus");scope.position = appendToBody?$position.offset(element):$position.position(element);scope.position.top = scope.position.top + element.prop("offsetHeight");$document.bind("click", documentClickBind);}else {$document.unbind("click", documentClickBind);}});scope.select = function(date){if(date === "today"){var today=new Date();if(angular.isDate(ngModel.$modelValue)){date = new Date(ngModel.$modelValue);date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());}else {date = new Date(today.setHours(0, 0, 0, 0));}}scope.dateSelection(date);};scope.close = function(){scope.isOpen = false;element[0].focus();};var $popup=$compile(popupEl)(scope);popupEl.remove();if(appendToBody){$document.find("body").append($popup);}else {element.after($popup);}scope.$on("$destroy", function(){$popup.remove();element.unbind("keydown", keydown);$document.unbind("click", documentClickBind);});}};}]).directive("datepickerPopupWrap", function(){return {restrict:"EA", replace:true, transclude:true, templateUrl:"template/datepicker/popup.html", link:function link(scope, element, attrs){element.bind("click", function(event){event.preventDefault();event.stopPropagation();});}};});angular.module("ui.bootstrap.dropdown", []).constant("dropdownConfig", {openClass:"open"}).service("dropdownService", ["$document", function($document){var openScope=null;this.open = function(dropdownScope){if(!openScope){$document.bind("click", closeDropdown);$document.bind("keydown", escapeKeyBind);}if(openScope && openScope !== dropdownScope){openScope.isOpen = false;}openScope = dropdownScope;};this.close = function(dropdownScope){if(openScope === dropdownScope){openScope = null;$document.unbind("click", closeDropdown);$document.unbind("keydown", escapeKeyBind);}};var closeDropdown=function closeDropdown(evt){if(!openScope){return;}var toggleElement=openScope.getToggleElement();if(evt && toggleElement && toggleElement[0].contains(evt.target)){return;}openScope.$apply(function(){openScope.isOpen = false;});};var escapeKeyBind=function escapeKeyBind(evt){if(evt.which === 27){openScope.focusToggleElement();closeDropdown();}};}]).controller("DropdownController", ["$scope", "$attrs", "$parse", "dropdownConfig", "dropdownService", "$animate", function($scope, $attrs, $parse, dropdownConfig, dropdownService, $animate){var self=this, scope=$scope.$new(), openClass=dropdownConfig.openClass, getIsOpen, setIsOpen=angular.noop, toggleInvoker=$attrs.onToggle?$parse($attrs.onToggle):angular.noop;this.init = function(element){self.$element = element;if($attrs.isOpen){getIsOpen = $parse($attrs.isOpen);setIsOpen = getIsOpen.assign;$scope.$watch(getIsOpen, function(value){scope.isOpen = !!value;});}};this.toggle = function(open){return scope.isOpen = arguments.length?!!open:!scope.isOpen;};this.isOpen = function(){return scope.isOpen;};scope.getToggleElement = function(){return self.toggleElement;};scope.focusToggleElement = function(){if(self.toggleElement){self.toggleElement[0].focus();}};scope.$watch("isOpen", function(isOpen, wasOpen){$animate[isOpen?"addClass":"removeClass"](self.$element, openClass);if(isOpen){scope.focusToggleElement();dropdownService.open(scope);}else {dropdownService.close(scope);}setIsOpen($scope, isOpen);if(angular.isDefined(isOpen) && isOpen !== wasOpen){toggleInvoker($scope, {open:!!isOpen});}});$scope.$on("$locationChangeSuccess", function(){scope.isOpen = false;});$scope.$on("$destroy", function(){scope.$destroy();});}]).directive("dropdown", function(){return {controller:"DropdownController", link:function link(scope, element, attrs, dropdownCtrl){dropdownCtrl.init(element);}};}).directive("dropdownToggle", function(){return {require:"?^dropdown", link:function link(scope, element, attrs, dropdownCtrl){if(!dropdownCtrl){return;}dropdownCtrl.toggleElement = element;var toggleDropdown=function toggleDropdown(event){event.preventDefault();if(!element.hasClass("disabled") && !attrs.disabled){scope.$apply(function(){dropdownCtrl.toggle();});}};element.bind("click", toggleDropdown);element.attr({"aria-haspopup":true, "aria-expanded":false});scope.$watch(dropdownCtrl.isOpen, function(isOpen){element.attr("aria-expanded", !!isOpen);});scope.$on("$destroy", function(){element.unbind("click", toggleDropdown);});}};});angular.module("ui.bootstrap.modal", ["ui.bootstrap.transition"]).factory("$$stackedMap", function(){return {createNew:function createNew(){var stack=[];return {add:function add(key, value){stack.push({key:key, value:value});}, get:function get(key){for(var i=0; i < stack.length; i++) {if(key == stack[i].key){return stack[i];}}}, keys:(function(_keys){var _keysWrapper=function keys(){return _keys.apply(this, arguments);};_keysWrapper.toString = function(){return _keys.toString();};return _keysWrapper;})(function(){var keys=[];for(var i=0; i < stack.length; i++) {keys.push(stack[i].key);}return keys;}), top:function top(){return stack[stack.length - 1];}, remove:function remove(key){var idx=-1;for(var i=0; i < stack.length; i++) {if(key == stack[i].key){idx = i;break;}}return stack.splice(idx, 1)[0];}, removeTop:function removeTop(){return stack.splice(stack.length - 1, 1)[0];}, length:function length(){return stack.length;}};}};}).directive("modalBackdrop", ["$timeout", function($timeout){return {restrict:"EA", replace:true, templateUrl:"template/modal/backdrop.html", link:function link(scope, element, attrs){scope.backdropClass = attrs.backdropClass || "";scope.animate = false;$timeout(function(){scope.animate = true;});}};}]).directive("modalWindow", ["$modalStack", "$timeout", function($modalStack, $timeout){return {restrict:"EA", scope:{index:"@", animate:"="}, replace:true, transclude:true, templateUrl:function templateUrl(tElement, tAttrs){return tAttrs.templateUrl || "template/modal/window.html";}, link:function link(scope, element, attrs){element.addClass(attrs.windowClass || "");scope.size = attrs.size;$timeout(function(){scope.animate = true;if(!element[0].querySelectorAll("[autofocus]").length){element[0].focus();}});scope.close = function(evt){var modal=$modalStack.getTop();if(modal && modal.value.backdrop && modal.value.backdrop != "static" && evt.target === evt.currentTarget){evt.preventDefault();evt.stopPropagation();$modalStack.dismiss(modal.key, "backdrop click");}};}};}]).directive("modalTransclude", function(){return {link:function link($scope, $element, $attrs, controller, $transclude){$transclude($scope.$parent, function(clone){$element.empty();$element.append(clone);});}};}).factory("$modalStack", ["$transition", "$timeout", "$document", "$compile", "$rootScope", "$$stackedMap", function($transition, $timeout, $document, $compile, $rootScope, $$stackedMap){var OPENED_MODAL_CLASS="modal-open";var backdropDomEl, backdropScope;var openedWindows=$$stackedMap.createNew();var $modalStack={};function backdropIndex(){var topBackdropIndex=-1;var opened=openedWindows.keys();for(var i=0; i < opened.length; i++) {if(openedWindows.get(opened[i]).value.backdrop){topBackdropIndex = i;}}return topBackdropIndex;}$rootScope.$watch(backdropIndex, function(newBackdropIndex){if(backdropScope){backdropScope.index = newBackdropIndex;}});function removeModalWindow(modalInstance){var body=$document.find("body").eq(0);var modalWindow=openedWindows.get(modalInstance).value;openedWindows.remove(modalInstance);removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, 300, function(){modalWindow.modalScope.$destroy();body.toggleClass(OPENED_MODAL_CLASS, openedWindows.length() > 0);checkRemoveBackdrop();});}function checkRemoveBackdrop(){if(backdropDomEl && backdropIndex() == -1){var backdropScopeRef=backdropScope;removeAfterAnimate(backdropDomEl, backdropScope, 150, function(){backdropScopeRef.$destroy();backdropScopeRef = null;});backdropDomEl = undefined;backdropScope = undefined;}}function removeAfterAnimate(domEl, scope, emulateTime, done){scope.animate = false;var transitionEndEventName=$transition.transitionEndEventName;if(transitionEndEventName){var timeout=$timeout(afterAnimating, emulateTime);domEl.bind(transitionEndEventName, function(){$timeout.cancel(timeout);afterAnimating();scope.$apply();});}else {$timeout(afterAnimating);}function afterAnimating(){if(afterAnimating.done){return;}afterAnimating.done = true;domEl.remove();if(done){done();}}}$document.bind("keydown", function(evt){var modal;if(evt.which === 27){modal = openedWindows.top();if(modal && modal.value.keyboard){evt.preventDefault();$rootScope.$apply(function(){$modalStack.dismiss(modal.key, "escape key press");});}}});$modalStack.open = function(modalInstance, modal){openedWindows.add(modalInstance, {deferred:modal.deferred, modalScope:modal.scope, backdrop:modal.backdrop, keyboard:modal.keyboard});var body=$document.find("body").eq(0), currBackdropIndex=backdropIndex();if(currBackdropIndex >= 0 && !backdropDomEl){backdropScope = $rootScope.$new(true);backdropScope.index = currBackdropIndex;var angularBackgroundDomEl=angular.element("<div modal-backdrop></div>");angularBackgroundDomEl.attr("backdrop-class", modal.backdropClass);backdropDomEl = $compile(angularBackgroundDomEl)(backdropScope);body.append(backdropDomEl);}var angularDomEl=angular.element("<div modal-window></div>");angularDomEl.attr({"template-url":modal.windowTemplateUrl, "window-class":modal.windowClass, size:modal.size, index:openedWindows.length() - 1, animate:"animate"}).html(modal.content);var modalDomEl=$compile(angularDomEl)(modal.scope);openedWindows.top().value.modalDomEl = modalDomEl;body.append(modalDomEl);body.addClass(OPENED_MODAL_CLASS);};$modalStack.close = function(modalInstance, result){var modalWindow=openedWindows.get(modalInstance);if(modalWindow){modalWindow.value.deferred.resolve(result);removeModalWindow(modalInstance);}};$modalStack.dismiss = function(modalInstance, reason){var modalWindow=openedWindows.get(modalInstance);if(modalWindow){modalWindow.value.deferred.reject(reason);removeModalWindow(modalInstance);}};$modalStack.dismissAll = function(reason){var topModal=this.getTop();while(topModal) {this.dismiss(topModal.key, reason);topModal = this.getTop();}};$modalStack.getTop = function(){return openedWindows.top();};return $modalStack;}]).provider("$modal", function(){var $modalProvider={options:{backdrop:true, keyboard:true}, $get:["$injector", "$rootScope", "$q", "$http", "$templateCache", "$controller", "$modalStack", function($injector, $rootScope, $q, $http, $templateCache, $controller, $modalStack){var $modal={};function getTemplatePromise(options){return options.template?$q.when(options.template):$http.get(angular.isFunction(options.templateUrl)?options.templateUrl():options.templateUrl, {cache:$templateCache}).then(function(result){return result.data;});}function getResolvePromises(resolves){var promisesArr=[];angular.forEach(resolves, function(value){if(angular.isFunction(value) || angular.isArray(value)){promisesArr.push($q.when($injector.invoke(value)));}});return promisesArr;}$modal.open = function(modalOptions){var modalResultDeferred=$q.defer();var modalOpenedDeferred=$q.defer();var modalInstance={result:modalResultDeferred.promise, opened:modalOpenedDeferred.promise, close:function close(result){$modalStack.close(modalInstance, result);}, dismiss:function dismiss(reason){$modalStack.dismiss(modalInstance, reason);}};modalOptions = angular.extend({}, $modalProvider.options, modalOptions);modalOptions.resolve = modalOptions.resolve || {};if(!modalOptions.template && !modalOptions.templateUrl){throw new Error("One of template or templateUrl options is required.");}var templateAndResolvePromise=$q.all([getTemplatePromise(modalOptions)].concat(getResolvePromises(modalOptions.resolve)));templateAndResolvePromise.then(function resolveSuccess(tplAndVars){var modalScope=(modalOptions.scope || $rootScope).$new();modalScope.$close = modalInstance.close;modalScope.$dismiss = modalInstance.dismiss;var ctrlInstance, ctrlLocals={};var resolveIter=1;if(modalOptions.controller){ctrlLocals.$scope = modalScope;ctrlLocals.$modalInstance = modalInstance;angular.forEach(modalOptions.resolve, function(value, key){ctrlLocals[key] = tplAndVars[resolveIter++];});ctrlInstance = $controller(modalOptions.controller, ctrlLocals);if(modalOptions.controllerAs){modalScope[modalOptions.controllerAs] = ctrlInstance;}}$modalStack.open(modalInstance, {scope:modalScope, deferred:modalResultDeferred, content:tplAndVars[0], backdrop:modalOptions.backdrop, keyboard:modalOptions.keyboard, backdropClass:modalOptions.backdropClass, windowClass:modalOptions.windowClass, windowTemplateUrl:modalOptions.windowTemplateUrl, size:modalOptions.size});}, function resolveError(reason){modalResultDeferred.reject(reason);});templateAndResolvePromise.then(function(){modalOpenedDeferred.resolve(true);}, function(){modalOpenedDeferred.reject(false);});return modalInstance;};return $modal;}]};return $modalProvider;});angular.module("ui.bootstrap.pagination", []).controller("PaginationController", ["$scope", "$attrs", "$parse", function($scope, $attrs, $parse){var self=this, ngModelCtrl={$setViewValue:angular.noop}, setNumPages=$attrs.numPages?$parse($attrs.numPages).assign:angular.noop;this.init = function(ngModelCtrl_, config){ngModelCtrl = ngModelCtrl_;this.config = config;ngModelCtrl.$render = function(){self.render();};if($attrs.itemsPerPage){$scope.$parent.$watch($parse($attrs.itemsPerPage), function(value){self.itemsPerPage = parseInt(value, 10);$scope.totalPages = self.calculateTotalPages();});}else {this.itemsPerPage = config.itemsPerPage;}};this.calculateTotalPages = function(){var totalPages=this.itemsPerPage < 1?1:Math.ceil($scope.totalItems / this.itemsPerPage);return Math.max(totalPages || 0, 1);};this.render = function(){$scope.page = parseInt(ngModelCtrl.$viewValue, 10) || 1;};$scope.selectPage = function(page){if($scope.page !== page && page > 0 && page <= $scope.totalPages){ngModelCtrl.$setViewValue(page);ngModelCtrl.$render();}};$scope.getText = function(key){return $scope[key + "Text"] || self.config[key + "Text"];};$scope.noPrevious = function(){return $scope.page === 1;};$scope.noNext = function(){return $scope.page === $scope.totalPages;};$scope.$watch("totalItems", function(){$scope.totalPages = self.calculateTotalPages();});$scope.$watch("totalPages", function(value){setNumPages($scope.$parent, value);if($scope.page > value){$scope.selectPage(value);}else {ngModelCtrl.$render();}});}]).constant("paginationConfig", {itemsPerPage:10, boundaryLinks:false, directionLinks:true, firstText:"First", previousText:"Previous", nextText:"Next", lastText:"Last", rotate:true}).directive("pagination", ["$parse", "paginationConfig", function($parse, paginationConfig){return {restrict:"EA", scope:{totalItems:"=", firstText:"@", previousText:"@", nextText:"@", lastText:"@"}, require:["pagination", "?ngModel"], controller:"PaginationController", templateUrl:"template/pagination/pagination.html", replace:true, link:function link(scope, element, attrs, ctrls){var paginationCtrl=ctrls[0], ngModelCtrl=ctrls[1];if(!ngModelCtrl){return;}var maxSize=angular.isDefined(attrs.maxSize)?scope.$parent.$eval(attrs.maxSize):paginationConfig.maxSize, rotate=angular.isDefined(attrs.rotate)?scope.$parent.$eval(attrs.rotate):paginationConfig.rotate;scope.boundaryLinks = angular.isDefined(attrs.boundaryLinks)?scope.$parent.$eval(attrs.boundaryLinks):paginationConfig.boundaryLinks;scope.directionLinks = angular.isDefined(attrs.directionLinks)?scope.$parent.$eval(attrs.directionLinks):paginationConfig.directionLinks;paginationCtrl.init(ngModelCtrl, paginationConfig);if(attrs.maxSize){scope.$parent.$watch($parse(attrs.maxSize), function(value){maxSize = parseInt(value, 10);paginationCtrl.render();});}function makePage(number, text, isActive){return {number:number, text:text, active:isActive};}function getPages(currentPage, totalPages){var pages=[];var startPage=1, endPage=totalPages;var isMaxSized=angular.isDefined(maxSize) && maxSize < totalPages;if(isMaxSized){if(rotate){startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);endPage = startPage + maxSize - 1;if(endPage > totalPages){endPage = totalPages;startPage = endPage - maxSize + 1;}}else {startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;endPage = Math.min(startPage + maxSize - 1, totalPages);}}for(var number=startPage; number <= endPage; number++) {var page=makePage(number, number, number === currentPage);pages.push(page);}if(isMaxSized && !rotate){if(startPage > 1){var previousPageSet=makePage(startPage - 1, "...", false);pages.unshift(previousPageSet);}if(endPage < totalPages){var nextPageSet=makePage(endPage + 1, "...", false);pages.push(nextPageSet);}}return pages;}var originalRender=paginationCtrl.render;paginationCtrl.render = function(){originalRender();if(scope.page > 0 && scope.page <= scope.totalPages){scope.pages = getPages(scope.page, scope.totalPages);}};}};}]).constant("pagerConfig", {itemsPerPage:10, previousText:"« Previous", nextText:"Next »", align:true}).directive("pager", ["pagerConfig", function(pagerConfig){return {restrict:"EA", scope:{totalItems:"=", previousText:"@", nextText:"@"}, require:["pager", "?ngModel"], controller:"PaginationController", templateUrl:"template/pagination/pager.html", replace:true, link:function link(scope, element, attrs, ctrls){var paginationCtrl=ctrls[0], ngModelCtrl=ctrls[1];if(!ngModelCtrl){return;}scope.align = angular.isDefined(attrs.align)?scope.$parent.$eval(attrs.align):pagerConfig.align;paginationCtrl.init(ngModelCtrl, pagerConfig);}};}]);angular.module("ui.bootstrap.tooltip", ["ui.bootstrap.position", "ui.bootstrap.bindHtml"]).provider("$tooltip", function(){var defaultOptions={placement:"top", animation:true, popupDelay:0};var triggerMap={mouseenter:"mouseleave", click:"click", focus:"blur"};var globalOptions={};this.options = function(value){angular.extend(globalOptions, value);};this.setTriggers = function setTriggers(triggers){angular.extend(triggerMap, triggers);};function snake_case(name){var regexp=/[A-Z]/g;var separator="-";return name.replace(regexp, function(letter, pos){return (pos?separator:"") + letter.toLowerCase();});}this.$get = ["$window", "$compile", "$timeout", "$document", "$position", "$interpolate", function($window, $compile, $timeout, $document, $position, $interpolate){return function $tooltip(type, prefix, defaultTriggerShow){var options=angular.extend({}, defaultOptions, globalOptions);function getTriggers(trigger){var show=trigger || options.trigger || defaultTriggerShow;var hide=triggerMap[show] || show;return {show:show, hide:hide};}var directiveName=snake_case(type);var startSym=$interpolate.startSymbol();var endSym=$interpolate.endSymbol();var template="<div " + directiveName + "-popup " + "title=\"" + startSym + "title" + endSym + "\" " + "content=\"" + startSym + "content" + endSym + "\" " + "placement=\"" + startSym + "placement" + endSym + "\" " + "animation=\"animation\" " + "is-open=\"isOpen\"" + ">" + "</div>";return {restrict:"EA", compile:function compile(tElem, tAttrs){var tooltipLinker=$compile(template);return function link(scope, element, attrs){var tooltip;var tooltipLinkedScope;var transitionTimeout;var popupTimeout;var appendToBody=angular.isDefined(options.appendToBody)?options.appendToBody:false;var triggers=getTriggers(undefined);var hasEnableExp=angular.isDefined(attrs[prefix + "Enable"]);var ttScope=scope.$new(true);var positionTooltip=function positionTooltip(){var ttPosition=$position.positionElements(element, tooltip, ttScope.placement, appendToBody);ttPosition.top += "px";ttPosition.left += "px";tooltip.css(ttPosition);};ttScope.isOpen = false;function toggleTooltipBind(){if(!ttScope.isOpen){showTooltipBind();}else {hideTooltipBind();}}function showTooltipBind(){if(hasEnableExp && !scope.$eval(attrs[prefix + "Enable"])){return;}prepareTooltip();if(ttScope.popupDelay){if(!popupTimeout){popupTimeout = $timeout(show, ttScope.popupDelay, false);popupTimeout.then(function(reposition){reposition();});}}else {show()();}}function hideTooltipBind(){scope.$apply(function(){hide();});}function show(){popupTimeout = null;if(transitionTimeout){$timeout.cancel(transitionTimeout);transitionTimeout = null;}if(!ttScope.content){return angular.noop;}createTooltip();tooltip.css({top:0, left:0, display:"block"});if(appendToBody){$document.find("body").append(tooltip);}else {element.after(tooltip);}positionTooltip();ttScope.isOpen = true;ttScope.$digest();return positionTooltip;}function hide(){ttScope.isOpen = false;$timeout.cancel(popupTimeout);popupTimeout = null;if(ttScope.animation){if(!transitionTimeout){transitionTimeout = $timeout(removeTooltip, 500);}}else {removeTooltip();}}function createTooltip(){if(tooltip){removeTooltip();}tooltipLinkedScope = ttScope.$new();tooltip = tooltipLinker(tooltipLinkedScope, angular.noop);}function removeTooltip(){transitionTimeout = null;if(tooltip){tooltip.remove();tooltip = null;}if(tooltipLinkedScope){tooltipLinkedScope.$destroy();tooltipLinkedScope = null;}}function prepareTooltip(){prepPlacement();prepPopupDelay();}attrs.$observe(type, function(val){ttScope.content = val;if(!val && ttScope.isOpen){hide();}});attrs.$observe(prefix + "Title", function(val){ttScope.title = val;});function prepPlacement(){var val=attrs[prefix + "Placement"];ttScope.placement = angular.isDefined(val)?val:options.placement;}function prepPopupDelay(){var val=attrs[prefix + "PopupDelay"];var delay=parseInt(val, 10);ttScope.popupDelay = !isNaN(delay)?delay:options.popupDelay;}var unregisterTriggers=function unregisterTriggers(){element.unbind(triggers.show, showTooltipBind);element.unbind(triggers.hide, hideTooltipBind);};function prepTriggers(){var val=attrs[prefix + "Trigger"];unregisterTriggers();triggers = getTriggers(val);if(triggers.show === triggers.hide){element.bind(triggers.show, toggleTooltipBind);}else {element.bind(triggers.show, showTooltipBind);element.bind(triggers.hide, hideTooltipBind);}}prepTriggers();var animation=scope.$eval(attrs[prefix + "Animation"]);ttScope.animation = angular.isDefined(animation)?!!animation:options.animation;var appendToBodyVal=scope.$eval(attrs[prefix + "AppendToBody"]);appendToBody = angular.isDefined(appendToBodyVal)?appendToBodyVal:appendToBody;if(appendToBody){scope.$on("$locationChangeSuccess", function closeTooltipOnLocationChangeSuccess(){if(ttScope.isOpen){hide();}});}scope.$on("$destroy", function onDestroyTooltip(){$timeout.cancel(transitionTimeout);$timeout.cancel(popupTimeout);unregisterTriggers();removeTooltip();ttScope = null;});};}};};}];}).directive("tooltipPopup", function(){return {restrict:"EA", replace:true, scope:{content:"@", placement:"@", animation:"&", isOpen:"&"}, templateUrl:"template/tooltip/tooltip-popup.html"};}).directive("tooltip", ["$tooltip", function($tooltip){return $tooltip("tooltip", "tooltip", "mouseenter");}]).directive("tooltipHtmlUnsafePopup", function(){return {restrict:"EA", replace:true, scope:{content:"@", placement:"@", animation:"&", isOpen:"&"}, templateUrl:"template/tooltip/tooltip-html-unsafe-popup.html"};}).directive("tooltipHtmlUnsafe", ["$tooltip", function($tooltip){return $tooltip("tooltipHtmlUnsafe", "tooltip", "mouseenter");}]);angular.module("ui.bootstrap.popover", ["ui.bootstrap.tooltip"]).directive("popoverPopup", function(){return {restrict:"EA", replace:true, scope:{title:"@", content:"@", placement:"@", animation:"&", isOpen:"&"}, templateUrl:"template/popover/popover.html"};}).directive("popover", ["$tooltip", function($tooltip){return $tooltip("popover", "popover", "click");}]);angular.module("ui.bootstrap.progressbar", []).constant("progressConfig", {animate:true, max:100}).controller("ProgressController", ["$scope", "$attrs", "progressConfig", function($scope, $attrs, progressConfig){var self=this, animate=angular.isDefined($attrs.animate)?$scope.$parent.$eval($attrs.animate):progressConfig.animate;this.bars = [];$scope.max = angular.isDefined($attrs.max)?$scope.$parent.$eval($attrs.max):progressConfig.max;this.addBar = function(bar, element){if(!animate){element.css({transition:"none"});}this.bars.push(bar);bar.$watch("value", function(value){bar.percent = +(100 * value / $scope.max).toFixed(2);});bar.$on("$destroy", function(){element = null;self.removeBar(bar);});};this.removeBar = function(bar){this.bars.splice(this.bars.indexOf(bar), 1);};}]).directive("progress", function(){return {restrict:"EA", replace:true, transclude:true, controller:"ProgressController", require:"progress", scope:{}, templateUrl:"template/progressbar/progress.html"};}).directive("bar", function(){return {restrict:"EA", replace:true, transclude:true, require:"^progress", scope:{value:"=", type:"@"}, templateUrl:"template/progressbar/bar.html", link:function link(scope, element, attrs, progressCtrl){progressCtrl.addBar(scope, element);}};}).directive("progressbar", function(){return {restrict:"EA", replace:true, transclude:true, controller:"ProgressController", scope:{value:"=", type:"@"}, templateUrl:"template/progressbar/progressbar.html", link:function link(scope, element, attrs, progressCtrl){progressCtrl.addBar(scope, angular.element(element.children()[0]));}};});angular.module("ui.bootstrap.rating", []).constant("ratingConfig", {max:5, stateOn:null, stateOff:null}).controller("RatingController", ["$scope", "$attrs", "ratingConfig", function($scope, $attrs, ratingConfig){var ngModelCtrl={$setViewValue:angular.noop};this.init = function(ngModelCtrl_){ngModelCtrl = ngModelCtrl_;ngModelCtrl.$render = this.render;this.stateOn = angular.isDefined($attrs.stateOn)?$scope.$parent.$eval($attrs.stateOn):ratingConfig.stateOn;this.stateOff = angular.isDefined($attrs.stateOff)?$scope.$parent.$eval($attrs.stateOff):ratingConfig.stateOff;var ratingStates=angular.isDefined($attrs.ratingStates)?$scope.$parent.$eval($attrs.ratingStates):new Array(angular.isDefined($attrs.max)?$scope.$parent.$eval($attrs.max):ratingConfig.max);$scope.range = this.buildTemplateObjects(ratingStates);};this.buildTemplateObjects = function(states){for(var i=0, n=states.length; i < n; i++) {states[i] = angular.extend({index:i}, {stateOn:this.stateOn, stateOff:this.stateOff}, states[i]);}return states;};$scope.rate = function(value){if(!$scope.readonly && value >= 0 && value <= $scope.range.length){ngModelCtrl.$setViewValue(value);ngModelCtrl.$render();}};$scope.enter = function(value){if(!$scope.readonly){$scope.value = value;}$scope.onHover({value:value});};$scope.reset = function(){$scope.value = ngModelCtrl.$viewValue;$scope.onLeave();};$scope.onKeydown = function(evt){if(/(37|38|39|40)/.test(evt.which)){evt.preventDefault();evt.stopPropagation();$scope.rate($scope.value + (evt.which === 38 || evt.which === 39?1:-1));}};this.render = function(){$scope.value = ngModelCtrl.$viewValue;};}]).directive("rating", function(){return {restrict:"EA", require:["rating", "ngModel"], scope:{readonly:"=?", onHover:"&", onLeave:"&"}, controller:"RatingController", templateUrl:"template/rating/rating.html", replace:true, link:function link(scope, element, attrs, ctrls){var ratingCtrl=ctrls[0], ngModelCtrl=ctrls[1];if(ngModelCtrl){ratingCtrl.init(ngModelCtrl);}}};});angular.module("ui.bootstrap.tabs", []).controller("TabsetController", ["$scope", function TabsetCtrl($scope){var ctrl=this, tabs=ctrl.tabs = $scope.tabs = [];ctrl.select = function(selectedTab){angular.forEach(tabs, function(tab){if(tab.active && tab !== selectedTab){tab.active = false;tab.onDeselect();}});selectedTab.active = true;selectedTab.onSelect();};ctrl.addTab = function addTab(tab){tabs.push(tab);if(tabs.length === 1){tab.active = true;}else if(tab.active){ctrl.select(tab);}};ctrl.removeTab = function removeTab(tab){var index=tabs.indexOf(tab);if(tab.active && tabs.length > 1 && !destroyed){var newActiveIndex=index == tabs.length - 1?index - 1:index + 1;ctrl.select(tabs[newActiveIndex]);}tabs.splice(index, 1);};var destroyed;$scope.$on("$destroy", function(){destroyed = true;});}]).directive("tabset", function(){return {restrict:"EA", transclude:true, replace:true, scope:{type:"@"}, controller:"TabsetController", templateUrl:"template/tabs/tabset.html", link:function link(scope, element, attrs){scope.vertical = angular.isDefined(attrs.vertical)?scope.$parent.$eval(attrs.vertical):false;scope.justified = angular.isDefined(attrs.justified)?scope.$parent.$eval(attrs.justified):false;}};}).directive("tab", ["$parse", function($parse){return {require:"^tabset", restrict:"EA", replace:true, templateUrl:"template/tabs/tab.html", transclude:true, scope:{active:"=?", heading:"@", onSelect:"&select", onDeselect:"&deselect"}, controller:function controller(){}, compile:function compile(elm, attrs, transclude){return function postLink(scope, elm, attrs, tabsetCtrl){scope.$watch("active", function(active){if(active){tabsetCtrl.select(scope);}});scope.disabled = false;if(attrs.disabled){scope.$parent.$watch($parse(attrs.disabled), function(value){scope.disabled = !!value;});}scope.select = function(){if(!scope.disabled){scope.active = true;}};tabsetCtrl.addTab(scope);scope.$on("$destroy", function(){tabsetCtrl.removeTab(scope);});scope.$transcludeFn = transclude;};}};}]).directive("tabHeadingTransclude", [function(){return {restrict:"A", require:"^tab", link:function link(scope, elm, attrs, tabCtrl){scope.$watch("headingElement", function updateHeadingElement(heading){if(heading){elm.html("");elm.append(heading);}});}};}]).directive("tabContentTransclude", function(){return {restrict:"A", require:"^tabset", link:function link(scope, elm, attrs){var tab=scope.$eval(attrs.tabContentTransclude);tab.$transcludeFn(tab.$parent, function(contents){angular.forEach(contents, function(node){if(isTabHeading(node)){tab.headingElement = node;}else {elm.append(node);}});});}};function isTabHeading(node){return node.tagName && (node.hasAttribute("tab-heading") || node.hasAttribute("data-tab-heading") || node.tagName.toLowerCase() === "tab-heading" || node.tagName.toLowerCase() === "data-tab-heading");}});angular.module("ui.bootstrap.timepicker", []).constant("timepickerConfig", {hourStep:1, minuteStep:1, showMeridian:true, meridians:null, readonlyInput:false, mousewheel:true}).controller("TimepickerController", ["$scope", "$attrs", "$parse", "$log", "$locale", "timepickerConfig", function($scope, $attrs, $parse, $log, $locale, timepickerConfig){var selected=new Date(), ngModelCtrl={$setViewValue:angular.noop}, meridians=angular.isDefined($attrs.meridians)?$scope.$parent.$eval($attrs.meridians):timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS;this.init = function(ngModelCtrl_, inputs){ngModelCtrl = ngModelCtrl_;ngModelCtrl.$render = this.render;var hoursInputEl=inputs.eq(0), minutesInputEl=inputs.eq(1);var mousewheel=angular.isDefined($attrs.mousewheel)?$scope.$parent.$eval($attrs.mousewheel):timepickerConfig.mousewheel;if(mousewheel){this.setupMousewheelEvents(hoursInputEl, minutesInputEl);}$scope.readonlyInput = angular.isDefined($attrs.readonlyInput)?$scope.$parent.$eval($attrs.readonlyInput):timepickerConfig.readonlyInput;this.setupInputEvents(hoursInputEl, minutesInputEl);};var hourStep=timepickerConfig.hourStep;if($attrs.hourStep){$scope.$parent.$watch($parse($attrs.hourStep), function(value){hourStep = parseInt(value, 10);});}var minuteStep=timepickerConfig.minuteStep;if($attrs.minuteStep){$scope.$parent.$watch($parse($attrs.minuteStep), function(value){minuteStep = parseInt(value, 10);});}$scope.showMeridian = timepickerConfig.showMeridian;if($attrs.showMeridian){$scope.$parent.$watch($parse($attrs.showMeridian), function(value){$scope.showMeridian = !!value;if(ngModelCtrl.$error.time){var hours=getHoursFromTemplate(), minutes=getMinutesFromTemplate();if(angular.isDefined(hours) && angular.isDefined(minutes)){selected.setHours(hours);refresh();}}else {updateTemplate();}});}function getHoursFromTemplate(){var hours=parseInt($scope.hours, 10);var valid=$scope.showMeridian?hours > 0 && hours < 13:hours >= 0 && hours < 24;if(!valid){return undefined;}if($scope.showMeridian){if(hours === 12){hours = 0;}if($scope.meridian === meridians[1]){hours = hours + 12;}}return hours;}function getMinutesFromTemplate(){var minutes=parseInt($scope.minutes, 10);return minutes >= 0 && minutes < 60?minutes:undefined;}function pad(value){return angular.isDefined(value) && value.toString().length < 2?"0" + value:value;}this.setupMousewheelEvents = function(hoursInputEl, minutesInputEl){var isScrollingUp=function isScrollingUp(e){if(e.originalEvent){e = e.originalEvent;}var delta=e.wheelDelta?e.wheelDelta:-e.deltaY;return e.detail || delta > 0;};hoursInputEl.bind("mousewheel wheel", function(e){$scope.$apply(isScrollingUp(e)?$scope.incrementHours():$scope.decrementHours());e.preventDefault();});minutesInputEl.bind("mousewheel wheel", function(e){$scope.$apply(isScrollingUp(e)?$scope.incrementMinutes():$scope.decrementMinutes());e.preventDefault();});};this.setupInputEvents = function(hoursInputEl, minutesInputEl){if($scope.readonlyInput){$scope.updateHours = angular.noop;$scope.updateMinutes = angular.noop;return;}var invalidate=function invalidate(invalidHours, invalidMinutes){ngModelCtrl.$setViewValue(null);ngModelCtrl.$setValidity("time", false);if(angular.isDefined(invalidHours)){$scope.invalidHours = invalidHours;}if(angular.isDefined(invalidMinutes)){$scope.invalidMinutes = invalidMinutes;}};$scope.updateHours = function(){var hours=getHoursFromTemplate();if(angular.isDefined(hours)){selected.setHours(hours);refresh("h");}else {invalidate(true);}};hoursInputEl.bind("blur", function(e){if(!$scope.invalidHours && $scope.hours < 10){$scope.$apply(function(){$scope.hours = pad($scope.hours);});}});$scope.updateMinutes = function(){var minutes=getMinutesFromTemplate();if(angular.isDefined(minutes)){selected.setMinutes(minutes);refresh("m");}else {invalidate(undefined, true);}};minutesInputEl.bind("blur", function(e){if(!$scope.invalidMinutes && $scope.minutes < 10){$scope.$apply(function(){$scope.minutes = pad($scope.minutes);});}});};this.render = function(){var date=ngModelCtrl.$modelValue?new Date(ngModelCtrl.$modelValue):null;if(isNaN(date)){ngModelCtrl.$setValidity("time", false);$log.error("Timepicker directive: \"ng-model\" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.");}else {if(date){selected = date;}makeValid();updateTemplate();}};function refresh(keyboardChange){makeValid();ngModelCtrl.$setViewValue(new Date(selected));updateTemplate(keyboardChange);}function makeValid(){ngModelCtrl.$setValidity("time", true);$scope.invalidHours = false;$scope.invalidMinutes = false;}function updateTemplate(keyboardChange){var hours=selected.getHours(), minutes=selected.getMinutes();if($scope.showMeridian){hours = hours === 0 || hours === 12?12:hours % 12;}$scope.hours = keyboardChange === "h"?hours:pad(hours);$scope.minutes = keyboardChange === "m"?minutes:pad(minutes);$scope.meridian = selected.getHours() < 12?meridians[0]:meridians[1];}function addMinutes(minutes){var dt=new Date(selected.getTime() + minutes * 60000);selected.setHours(dt.getHours(), dt.getMinutes());refresh();}$scope.incrementHours = function(){addMinutes(hourStep * 60);};$scope.decrementHours = function(){addMinutes(-hourStep * 60);};$scope.incrementMinutes = function(){addMinutes(minuteStep);};$scope.decrementMinutes = function(){addMinutes(-minuteStep);};$scope.toggleMeridian = function(){addMinutes(12 * 60 * (selected.getHours() < 12?1:-1));};}]).directive("timepicker", function(){return {restrict:"EA", require:["timepicker", "?^ngModel"], controller:"TimepickerController", replace:true, scope:{}, templateUrl:"template/timepicker/timepicker.html", link:function link(scope, element, attrs, ctrls){var timepickerCtrl=ctrls[0], ngModelCtrl=ctrls[1];if(ngModelCtrl){timepickerCtrl.init(ngModelCtrl, element.find("input"));}}};});angular.module("ui.bootstrap.typeahead", ["ui.bootstrap.position", "ui.bootstrap.bindHtml"]).factory("typeaheadParser", ["$parse", function($parse){var TYPEAHEAD_REGEXP=/^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;return {parse:function parse(input){var match=input.match(TYPEAHEAD_REGEXP);if(!match){throw new Error("Expected typeahead specification in form of \"_modelValue_ (as _label_)? for _item_ in _collection_\"" + " but got \"" + input + "\".");}return {itemName:match[3], source:$parse(match[4]), viewMapper:$parse(match[2] || match[1]), modelMapper:$parse(match[1])};}};}]).directive("typeahead", ["$compile", "$parse", "$q", "$timeout", "$document", "$position", "typeaheadParser", function($compile, $parse, $q, $timeout, $document, $position, typeaheadParser){var HOT_KEYS=[9, 13, 27, 38, 40];return {require:"ngModel", link:function link(originalScope, element, attrs, modelCtrl){var minSearch=originalScope.$eval(attrs.typeaheadMinLength) || 1;var waitTime=originalScope.$eval(attrs.typeaheadWaitMs) || 0;var isEditable=originalScope.$eval(attrs.typeaheadEditable) !== false;var isLoadingSetter=$parse(attrs.typeaheadLoading).assign || angular.noop;var onSelectCallback=$parse(attrs.typeaheadOnSelect);var inputFormatter=attrs.typeaheadInputFormatter?$parse(attrs.typeaheadInputFormatter):undefined;var appendToBody=attrs.typeaheadAppendToBody?originalScope.$eval(attrs.typeaheadAppendToBody):false;var focusFirst=originalScope.$eval(attrs.typeaheadFocusFirst) !== false;var $setModelValue=$parse(attrs.ngModel).assign;var parserResult=typeaheadParser.parse(attrs.typeahead);var hasFocus;var scope=originalScope.$new();originalScope.$on("$destroy", function(){scope.$destroy();});var popupId="typeahead-" + scope.$id + "-" + Math.floor(Math.random() * 10000);element.attr({"aria-autocomplete":"list", "aria-expanded":false, "aria-owns":popupId});var popUpEl=angular.element("<div typeahead-popup></div>");popUpEl.attr({id:popupId, matches:"matches", active:"activeIdx", select:"select(activeIdx)", query:"query", position:"position"});if(angular.isDefined(attrs.typeaheadTemplateUrl)){popUpEl.attr("template-url", attrs.typeaheadTemplateUrl);}var resetMatches=function resetMatches(){scope.matches = [];scope.activeIdx = -1;element.attr("aria-expanded", false);};var getMatchId=function getMatchId(index){return popupId + "-option-" + index;};scope.$watch("activeIdx", function(index){if(index < 0){element.removeAttr("aria-activedescendant");}else {element.attr("aria-activedescendant", getMatchId(index));}});var getMatchesAsync=function getMatchesAsync(inputValue){var locals={$viewValue:inputValue};isLoadingSetter(originalScope, true);$q.when(parserResult.source(originalScope, locals)).then(function(matches){var onCurrentRequest=inputValue === modelCtrl.$viewValue;if(onCurrentRequest && hasFocus){if(matches.length > 0){scope.activeIdx = focusFirst?0:-1;scope.matches.length = 0;for(var i=0; i < matches.length; i++) {locals[parserResult.itemName] = matches[i];scope.matches.push({id:getMatchId(i), label:parserResult.viewMapper(scope, locals), model:matches[i]});}scope.query = inputValue;scope.position = appendToBody?$position.offset(element):$position.position(element);scope.position.top = scope.position.top + element.prop("offsetHeight");element.attr("aria-expanded", true);}else {resetMatches();}}if(onCurrentRequest){isLoadingSetter(originalScope, false);}}, function(){resetMatches();isLoadingSetter(originalScope, false);});};resetMatches();scope.query = undefined;var timeoutPromise;var scheduleSearchWithTimeout=function scheduleSearchWithTimeout(inputValue){timeoutPromise = $timeout(function(){getMatchesAsync(inputValue);}, waitTime);};var cancelPreviousTimeout=function cancelPreviousTimeout(){if(timeoutPromise){$timeout.cancel(timeoutPromise);}};modelCtrl.$parsers.unshift(function(inputValue){hasFocus = true;if(inputValue && inputValue.length >= minSearch){if(waitTime > 0){cancelPreviousTimeout();scheduleSearchWithTimeout(inputValue);}else {getMatchesAsync(inputValue);}}else {isLoadingSetter(originalScope, false);cancelPreviousTimeout();resetMatches();}if(isEditable){return inputValue;}else {if(!inputValue){modelCtrl.$setValidity("editable", true);return inputValue;}else {modelCtrl.$setValidity("editable", false);return undefined;}}});modelCtrl.$formatters.push(function(modelValue){var candidateViewValue, emptyViewValue;var locals={};if(inputFormatter){locals.$model = modelValue;return inputFormatter(originalScope, locals);}else {locals[parserResult.itemName] = modelValue;candidateViewValue = parserResult.viewMapper(originalScope, locals);locals[parserResult.itemName] = undefined;emptyViewValue = parserResult.viewMapper(originalScope, locals);return candidateViewValue !== emptyViewValue?candidateViewValue:modelValue;}});scope.select = function(activeIdx){var locals={};var model, item;locals[parserResult.itemName] = item = scope.matches[activeIdx].model;model = parserResult.modelMapper(originalScope, locals);$setModelValue(originalScope, model);modelCtrl.$setValidity("editable", true);onSelectCallback(originalScope, {$item:item, $model:model, $label:parserResult.viewMapper(originalScope, locals)});resetMatches();$timeout(function(){element[0].focus();}, 0, false);};element.bind("keydown", function(evt){if(scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1){return;}if(scope.activeIdx == -1 && (evt.which === 13 || evt.which === 9)){return;}evt.preventDefault();if(evt.which === 40){scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;scope.$digest();}else if(evt.which === 38){scope.activeIdx = (scope.activeIdx > 0?scope.activeIdx:scope.matches.length) - 1;scope.$digest();}else if(evt.which === 13 || evt.which === 9){scope.$apply(function(){scope.select(scope.activeIdx);});}else if(evt.which === 27){evt.stopPropagation();resetMatches();scope.$digest();}});element.bind("blur", function(evt){hasFocus = false;});var dismissClickHandler=function dismissClickHandler(evt){if(element[0] !== evt.target){resetMatches();scope.$digest();}};$document.bind("click", dismissClickHandler);originalScope.$on("$destroy", function(){$document.unbind("click", dismissClickHandler);if(appendToBody){$popup.remove();}});var $popup=$compile(popUpEl)(scope);if(appendToBody){$document.find("body").append($popup);}else {element.after($popup);}}};}]).directive("typeaheadPopup", function(){return {restrict:"EA", scope:{matches:"=", query:"=", active:"=", position:"=", select:"&"}, replace:true, templateUrl:"template/typeahead/typeahead-popup.html", link:function link(scope, element, attrs){scope.templateUrl = attrs.templateUrl;scope.isOpen = function(){return scope.matches.length > 0;};scope.isActive = function(matchIdx){return scope.active == matchIdx;};scope.selectActive = function(matchIdx){scope.active = matchIdx;};scope.selectMatch = function(activeIdx){scope.select({activeIdx:activeIdx});};}};}).directive("typeaheadMatch", ["$http", "$templateCache", "$compile", "$parse", function($http, $templateCache, $compile, $parse){return {restrict:"EA", scope:{index:"=", match:"=", query:"="}, link:function link(scope, element, attrs){var tplUrl=$parse(attrs.templateUrl)(scope.$parent) || "template/typeahead/typeahead-match.html";$http.get(tplUrl, {cache:$templateCache}).success(function(tplContent){element.replaceWith($compile(tplContent.trim())(scope));});}};}]).filter("typeaheadHighlight", function(){function escapeRegexp(queryToEscape){return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");}return function(matchItem, query){return query?("" + matchItem).replace(new RegExp(escapeRegexp(query), "gi"), "<strong>$&</strong>"):matchItem;};});

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	var require;"use strict";(function(window, document, undefined){"use strict";function minErr(module){return function(){var code=arguments[0], prefix="[" + (module?module + ":":"") + code + "] ", template=arguments[1], templateArgs=arguments, stringify=function stringify(obj){if(typeof obj === "function"){return obj.toString().replace(/ \{[\s\S]*$/, "");}else if(typeof obj === "undefined"){return "undefined";}else if(typeof obj !== "string"){return JSON.stringify(obj);}return obj;}, message, i;message = prefix + template.replace(/\{\d+\}/g, function(match){var index=+match.slice(1, -1), arg;if(index + 2 < templateArgs.length){arg = templateArgs[index + 2];if(typeof arg === "function"){return arg.toString().replace(/ ?\{[\s\S]*$/, "");}else if(typeof arg === "undefined"){return "undefined";}else if(typeof arg !== "string"){return toJson(arg);}return arg;}return match;});message = message + "\nhttp://errors.angularjs.org/1.2.32/" + (module?module + "/":"") + code;for(i = 2; i < arguments.length; i++) {message = message + (i == 2?"?":"&") + "p" + (i - 2) + "=" + encodeURIComponent(stringify(arguments[i]));}return new Error(message);};}var VALIDITY_STATE_PROPERTY="validity";var lowercase=function lowercase(string){return isString(string)?string.toLowerCase():string;};var hasOwnProperty=Object.prototype.hasOwnProperty;var uppercase=function uppercase(string){return isString(string)?string.toUpperCase():string;};var manualLowercase=function manualLowercase(s){return isString(s)?s.replace(/[A-Z]/g, function(ch){return String.fromCharCode(ch.charCodeAt(0) | 32);}):s;};var manualUppercase=function manualUppercase(s){return isString(s)?s.replace(/[a-z]/g, function(ch){return String.fromCharCode(ch.charCodeAt(0) & ~32);}):s;};if("i" !== "I".toLowerCase()){lowercase = manualLowercase;uppercase = manualUppercase;}var msie, jqLite, jQuery, slice=[].slice, push=[].push, toString=Object.prototype.toString, ngMinErr=minErr("ng"), angular=window.angular || (window.angular = {}), angularModule, nodeName_, uid=["0", "0", "0"];msie = int((/msie (\d+)/.exec(lowercase(navigator.userAgent)) || [])[1]);if(isNaN(msie)){msie = int((/trident\/.*; rv:(\d+)/.exec(lowercase(navigator.userAgent)) || [])[1]);}function isArrayLike(obj){if(obj == null || isWindow(obj)){return false;}var length=obj.length;if(obj.nodeType === 1 && length){return true;}return isString(obj) || isArray(obj) || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;}function forEach(obj, iterator, context){var key;if(obj){if(isFunction(obj)){for(key in obj) {if(key != "prototype" && key != "length" && key != "name" && (!obj.hasOwnProperty || obj.hasOwnProperty(key))){iterator.call(context, obj[key], key);}}}else if(isArray(obj) || isArrayLike(obj)){for(key = 0; key < obj.length; key++) {iterator.call(context, obj[key], key);}}else if(obj.forEach && obj.forEach !== forEach){obj.forEach(iterator, context);}else {for(key in obj) {if(obj.hasOwnProperty(key)){iterator.call(context, obj[key], key);}}}}return obj;}function sortedKeys(obj){var keys=[];for(var key in obj) {if(obj.hasOwnProperty(key)){keys.push(key);}}return keys.sort();}function forEachSorted(obj, iterator, context){var keys=sortedKeys(obj);for(var i=0; i < keys.length; i++) {iterator.call(context, obj[keys[i]], keys[i]);}return keys;}function reverseParams(iteratorFn){return function(value, key){iteratorFn(key, value);};}function nextUid(){var index=uid.length;var digit;while(index) {index--;digit = uid[index].charCodeAt(0);if(digit == 57){uid[index] = "A";return uid.join("");}if(digit == 90){uid[index] = "0";}else {uid[index] = String.fromCharCode(digit + 1);return uid.join("");}}uid.unshift("0");return uid.join("");}function setHashKey(obj, h){if(h){obj.$$hashKey = h;}else {delete obj.$$hashKey;}}function extend(dst){var h=dst.$$hashKey;forEach(arguments, function(obj){if(obj !== dst){forEach(obj, function(value, key){dst[key] = value;});}});setHashKey(dst, h);return dst;}function int(str){return parseInt(str, 10);}function inherit(parent, extra){return extend(new (extend(function(){}, {prototype:parent}))(), extra);}function noop(){}noop.$inject = [];function identity($){return $;}identity.$inject = [];function valueFn(value){return function(){return value;};}function isUndefined(value){return typeof value === "undefined";}function isDefined(value){return typeof value !== "undefined";}function isObject(value){return value != null && typeof value === "object";}function isString(value){return typeof value === "string";}function isNumber(value){return typeof value === "number";}function isDate(value){return toString.call(value) === "[object Date]";}var isArray=(function(){if(!isFunction(Array.isArray)){return function(value){return toString.call(value) === "[object Array]";};}return Array.isArray;})();function isFunction(value){return typeof value === "function";}function isRegExp(value){return toString.call(value) === "[object RegExp]";}function isWindow(obj){return obj && obj.document && obj.location && obj.alert && obj.setInterval;}function isScope(obj){return obj && obj.$evalAsync && obj.$watch;}function isFile(obj){return toString.call(obj) === "[object File]";}function isBlob(obj){return toString.call(obj) === "[object Blob]";}function isBoolean(value){return typeof value === "boolean";}function isPromiseLike(obj){return obj && isFunction(obj.then);}var trim=(function(){if(!String.prototype.trim){return function(value){return isString(value)?value.replace(/^\s\s*/, "").replace(/\s\s*$/, ""):value;};}return function(value){return isString(value)?value.trim():value;};})();function isElement(node){return !!(node && (node.nodeName || node.prop && node.attr && node.find));}function makeMap(str){var obj={}, items=str.split(","), i;for(i = 0; i < items.length; i++) obj[items[i]] = true;return obj;}if(msie < 9){nodeName_ = function(element){element = element.nodeName?element:element[0];return element.scopeName && element.scopeName != "HTML"?uppercase(element.scopeName + ":" + element.nodeName):element.nodeName;};}else {nodeName_ = function(element){return element.nodeName?element.nodeName:element[0].nodeName;};}function map(obj, iterator, context){var results=[];forEach(obj, function(value, index, list){results.push(iterator.call(context, value, index, list));});return results;}function size(obj, ownPropsOnly){var count=0, key;if(isArray(obj) || isString(obj)){return obj.length;}else if(isObject(obj)){for(key in obj) if(!ownPropsOnly || obj.hasOwnProperty(key))count++;}return count;}function includes(array, obj){return indexOf(array, obj) != -1;}function indexOf(array, obj){if(array.indexOf){return array.indexOf(obj);}for(var i=0; i < array.length; i++) {if(obj === array[i]){return i;}}return -1;}function arrayRemove(array, value){var index=indexOf(array, value);if(index >= 0)array.splice(index, 1);return value;}function isLeafNode(node){if(node){switch(node.nodeName){case "OPTION":case "PRE":case "TITLE":return true;}}return false;}function copy(source, destination, stackSource, stackDest){if(isWindow(source) || isScope(source)){throw ngMinErr("cpws", "Can't copy! Making copies of Window or Scope instances is not supported.");}if(!destination){destination = source;if(source){if(isArray(source)){destination = copy(source, [], stackSource, stackDest);}else if(isDate(source)){destination = new Date(source.getTime());}else if(isRegExp(source)){destination = new RegExp(source.source, source.toString().match(/[^\/]*$/)[0]);destination.lastIndex = source.lastIndex;}else if(isObject(source)){destination = copy(source, {}, stackSource, stackDest);}}}else {if(source === destination)throw ngMinErr("cpi", "Can't copy! Source and destination are identical.");stackSource = stackSource || [];stackDest = stackDest || [];if(isObject(source)){var index=indexOf(stackSource, source);if(index !== -1){return stackDest[index];}stackSource.push(source);stackDest.push(destination);}var result;if(isArray(source)){destination.length = 0;for(var i=0; i < source.length; i++) {result = copy(source[i], null, stackSource, stackDest);if(isObject(source[i])){stackSource.push(source[i]);stackDest.push(result);}destination.push(result);}}else {var h=destination.$$hashKey;if(isArray(destination)){destination.length = 0;}else {forEach(destination, function(value, key){delete destination[key];});}for(var key in source) {result = copy(source[key], null, stackSource, stackDest);if(isObject(source[key])){stackSource.push(source[key]);stackDest.push(result);}destination[key] = result;}setHashKey(destination, h);}}return destination;}function shallowCopy(src, dst){if(isArray(src)){dst = dst || [];for(var i=0; i < src.length; i++) {dst[i] = src[i];}}else if(isObject(src)){dst = dst || {};for(var key in src) {if(hasOwnProperty.call(src, key) && !(key.charAt(0) === "$" && key.charAt(1) === "$")){dst[key] = src[key];}}}return dst || src;}function equals(o1, o2){if(o1 === o2){return true;}if(o1 === null || o2 === null){return false;}if(o1 !== o1 && o2 !== o2){return true;}var t1=typeof o1, t2=typeof o2, length, key, keySet;if(t1 == t2){if(t1 == "object"){if(isArray(o1)){if(!isArray(o2)){return false;}if((length = o1.length) == o2.length){for(key = 0; key < length; key++) {if(!equals(o1[key], o2[key])){return false;}}return true;}}else if(isDate(o1)){if(!isDate(o2)){return false;}return isNaN(o1.getTime()) && isNaN(o2.getTime()) || o1.getTime() === o2.getTime();}else if(isRegExp(o1) && isRegExp(o2)){return o1.toString() == o2.toString();}else {if(isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) || isArray(o2)){return false;}keySet = {};for(key in o1) {if(key.charAt(0) === "$" || isFunction(o1[key]))continue;if(!equals(o1[key], o2[key])){return false;}keySet[key] = true;}for(key in o2) {if(!keySet.hasOwnProperty(key) && key.charAt(0) !== "$" && o2[key] !== undefined && !isFunction(o2[key])){return false;}}return true;}}}return false;}var csp=(function(_csp){var _cspWrapper=function csp(){return _csp.apply(this, arguments);};_cspWrapper.toString = function(){return _csp.toString();};return _cspWrapper;})(function(){if(isDefined(csp.isActive_))return csp.isActive_;var active=!!(document.querySelector("[ng-csp]") || document.querySelector("[data-ng-csp]"));if(!active){try{new Function("");}catch(e) {active = true;}}return csp.isActive_ = active;});function concat(array1, array2, index){return array1.concat(slice.call(array2, index));}function sliceArgs(args, startIndex){return slice.call(args, startIndex || 0);}function bind(self, fn){var curryArgs=arguments.length > 2?sliceArgs(arguments, 2):[];if(isFunction(fn) && !(fn instanceof RegExp)){return curryArgs.length?function(){return arguments.length?fn.apply(self, curryArgs.concat(slice.call(arguments, 0))):fn.apply(self, curryArgs);}:function(){return arguments.length?fn.apply(self, arguments):fn.call(self);};}else {return fn;}}function toJsonReplacer(key, value){var val=value;if(typeof key === "string" && key.charAt(0) === "$"){val = undefined;}else if(isWindow(value)){val = "$WINDOW";}else if(value && document === value){val = "$DOCUMENT";}else if(isScope(value)){val = "$SCOPE";}return val;}function toJson(obj, pretty){if(typeof obj === "undefined"){return undefined;}return JSON.stringify(obj, toJsonReplacer, pretty?"  ":null);}function fromJson(json){return isString(json)?JSON.parse(json):json;}function toBoolean(value){if(typeof value === "function"){value = true;}else if(value && value.length !== 0){var v=lowercase("" + value);value = !(v == "f" || v == "0" || v == "false" || v == "no" || v == "n" || v == "[]");}else {value = false;}return value;}function startingTag(element){element = jqLite(element).clone();try{element.empty();}catch(e) {}var TEXT_NODE=3;var elemHtml=jqLite("<div>").append(element).html();try{return element[0].nodeType === TEXT_NODE?lowercase(elemHtml):elemHtml.match(/^(<[^>]+>)/)[1].replace(/^<([\w\-]+)/, function(match, nodeName){return "<" + lowercase(nodeName);});}catch(e) {return lowercase(elemHtml);}}function tryDecodeURIComponent(value){try{return decodeURIComponent(value);}catch(e) {}}function parseKeyValue(keyValue){var obj={}, key_value, key;forEach((keyValue || "").split("&"), function(keyValue){if(keyValue){key_value = keyValue.replace(/\+/g, "%20").split("=");key = tryDecodeURIComponent(key_value[0]);if(isDefined(key)){var val=isDefined(key_value[1])?tryDecodeURIComponent(key_value[1]):true;if(!hasOwnProperty.call(obj, key)){obj[key] = val;}else if(isArray(obj[key])){obj[key].push(val);}else {obj[key] = [obj[key], val];}}}});return obj;}function toKeyValue(obj){var parts=[];forEach(obj, function(value, key){if(isArray(value)){forEach(value, function(arrayValue){parts.push(encodeUriQuery(key, true) + (arrayValue === true?"":"=" + encodeUriQuery(arrayValue, true)));});}else {parts.push(encodeUriQuery(key, true) + (value === true?"":"=" + encodeUriQuery(value, true)));}});return parts.length?parts.join("&"):"";}function encodeUriSegment(val){return encodeUriQuery(val, true).replace(/%26/gi, "&").replace(/%3D/gi, "=").replace(/%2B/gi, "+");}function encodeUriQuery(val, pctEncodeSpaces){return encodeURIComponent(val).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, pctEncodeSpaces?"%20":"+");}function angularInit(element, bootstrap){var elements=[element], appElement, module, names=["ng:app", "ng-app", "x-ng-app", "data-ng-app"], NG_APP_CLASS_REGEXP=/\sng[:\-]app(:\s*([\w\d_]+);?)?\s/;function append(element){element && elements.push(element);}forEach(names, function(name){names[name] = true;append(document.getElementById(name));name = name.replace(":", "\\:");if(element.querySelectorAll){forEach(element.querySelectorAll("." + name), append);forEach(element.querySelectorAll("." + name + "\\:"), append);forEach(element.querySelectorAll("[" + name + "]"), append);}});forEach(elements, function(element){if(!appElement){var className=" " + element.className + " ";var match=NG_APP_CLASS_REGEXP.exec(className);if(match){appElement = element;module = (match[2] || "").replace(/\s+/g, ",");}else {forEach(element.attributes, function(attr){if(!appElement && names[attr.name]){appElement = element;module = attr.value;}});}}});if(appElement){bootstrap(appElement, module?[module]:[]);}}function bootstrap(element, modules){var doBootstrap=function doBootstrap(){element = jqLite(element);if(element.injector()){var tag=element[0] === document?"document":startingTag(element);throw ngMinErr("btstrpd", "App Already Bootstrapped with this Element '{0}'", tag.replace(/</, "&lt;").replace(/>/, "&gt;"));}modules = modules || [];modules.unshift(["$provide", function($provide){$provide.value("$rootElement", element);}]);modules.unshift("ng");var injector=createInjector(modules);injector.invoke(["$rootScope", "$rootElement", "$compile", "$injector", "$animate", function(scope, element, compile, injector, animate){scope.$apply(function(){element.data("$injector", injector);compile(element)(scope);});}]);return injector;};var NG_DEFER_BOOTSTRAP=/^NG_DEFER_BOOTSTRAP!/;if(window && !NG_DEFER_BOOTSTRAP.test(window.name)){return doBootstrap();}window.name = window.name.replace(NG_DEFER_BOOTSTRAP, "");angular.resumeBootstrap = function(extraModules){forEach(extraModules, function(module){modules.push(module);});doBootstrap();};}var SNAKE_CASE_REGEXP=/[A-Z]/g;function snake_case(name, separator){separator = separator || "_";return name.replace(SNAKE_CASE_REGEXP, function(letter, pos){return (pos?separator:"") + letter.toLowerCase();});}function bindJQuery(){jQuery = window.jQuery;if(jQuery && jQuery.fn.on){jqLite = jQuery;extend(jQuery.fn, {scope:JQLitePrototype.scope, isolateScope:JQLitePrototype.isolateScope, controller:JQLitePrototype.controller, injector:JQLitePrototype.injector, inheritedData:JQLitePrototype.inheritedData});jqLitePatchJQueryRemove("remove", true, true, false);jqLitePatchJQueryRemove("empty", false, false, false);jqLitePatchJQueryRemove("html", false, false, true);}else {jqLite = JQLite;}angular.element = jqLite;}function assertArg(arg, name, reason){if(!arg){throw ngMinErr("areq", "Argument '{0}' is {1}", name || "?", reason || "required");}return arg;}function assertArgFn(arg, name, acceptArrayAnnotation){if(acceptArrayAnnotation && isArray(arg)){arg = arg[arg.length - 1];}assertArg(isFunction(arg), name, "not a function, got " + (arg && typeof arg === "object"?arg.constructor.name || "Object":typeof arg));return arg;}function assertNotHasOwnProperty(name, context){if(name === "hasOwnProperty"){throw ngMinErr("badname", "hasOwnProperty is not a valid {0} name", context);}}function getter(obj, path, bindFnToScope){if(!path){return obj;}var keys=path.split(".");var key;var lastInstance=obj;var len=keys.length;for(var i=0; i < len; i++) {key = keys[i];if(obj){obj = (lastInstance = obj)[key];}}if(!bindFnToScope && isFunction(obj)){return bind(lastInstance, obj);}return obj;}function getBlockElements(nodes){var startNode=nodes[0], endNode=nodes[nodes.length - 1];if(startNode === endNode){return jqLite(startNode);}var element=startNode;var elements=[element];do{element = element.nextSibling;if(!element)break;elements.push(element);}while(element !== endNode);return jqLite(elements);}function setupModuleLoader(window){var $injectorMinErr=minErr("$injector");var ngMinErr=minErr("ng");function ensure(obj, name, factory){return obj[name] || (obj[name] = factory());}var angular=ensure(window, "angular", Object);angular.$$minErr = angular.$$minErr || minErr;return ensure(angular, "module", function(){var modules={};return function module(name, requires, configFn){var assertNotHasOwnProperty=function assertNotHasOwnProperty(name, context){if(name === "hasOwnProperty"){throw ngMinErr("badname", "hasOwnProperty is not a valid {0} name", context);}};assertNotHasOwnProperty(name, "module");if(requires && modules.hasOwnProperty(name)){modules[name] = null;}return ensure(modules, name, function(){if(!requires){throw $injectorMinErr("nomod", "Module '{0}' is not available! You either misspelled " + "the module name or forgot to load it. If registering a module ensure that you " + "specify the dependencies as the second argument.", name);}var invokeQueue=[];var runBlocks=[];var config=invokeLater("$injector", "invoke");var moduleInstance={_invokeQueue:invokeQueue, _runBlocks:runBlocks, requires:requires, name:name, provider:invokeLater("$provide", "provider"), factory:invokeLater("$provide", "factory"), service:invokeLater("$provide", "service"), value:invokeLater("$provide", "value"), constant:invokeLater("$provide", "constant", "unshift"), animation:invokeLater("$animateProvider", "register"), filter:invokeLater("$filterProvider", "register"), controller:invokeLater("$controllerProvider", "register"), directive:invokeLater("$compileProvider", "directive"), config:config, run:function run(block){runBlocks.push(block);return this;}};if(configFn){config(configFn);}return moduleInstance;function invokeLater(provider, method, insertMethod){return function(){invokeQueue[insertMethod || "push"]([provider, method, arguments]);return moduleInstance;};}});};});}var version={full:"1.2.32", major:1, minor:2, dot:32, codeName:"alternation-intention"};function publishExternalAPI(angular){extend(angular, {bootstrap:bootstrap, copy:copy, extend:extend, equals:equals, element:jqLite, forEach:forEach, injector:createInjector, noop:noop, bind:bind, toJson:toJson, fromJson:fromJson, identity:identity, isUndefined:isUndefined, isDefined:isDefined, isString:isString, isFunction:isFunction, isObject:isObject, isNumber:isNumber, isElement:isElement, isArray:isArray, version:version, isDate:isDate, lowercase:lowercase, uppercase:uppercase, callbacks:{counter:0}, $$minErr:minErr, $$csp:csp});angularModule = setupModuleLoader(window);try{angularModule("ngLocale");}catch(e) {angularModule("ngLocale", []).provider("$locale", $LocaleProvider);}angularModule("ng", ["ngLocale"], ["$provide", function ngModule($provide){$provide.provider({$$sanitizeUri:$$SanitizeUriProvider});$provide.provider("$compile", $CompileProvider).directive({a:htmlAnchorDirective, input:inputDirective, textarea:inputDirective, form:formDirective, script:scriptDirective, select:selectDirective, style:styleDirective, option:optionDirective, ngBind:ngBindDirective, ngBindHtml:ngBindHtmlDirective, ngBindTemplate:ngBindTemplateDirective, ngClass:ngClassDirective, ngClassEven:ngClassEvenDirective, ngClassOdd:ngClassOddDirective, ngCloak:ngCloakDirective, ngController:ngControllerDirective, ngForm:ngFormDirective, ngHide:ngHideDirective, ngIf:ngIfDirective, ngInclude:ngIncludeDirective, ngInit:ngInitDirective, ngNonBindable:ngNonBindableDirective, ngPluralize:ngPluralizeDirective, ngRepeat:ngRepeatDirective, ngShow:ngShowDirective, ngStyle:ngStyleDirective, ngSwitch:ngSwitchDirective, ngSwitchWhen:ngSwitchWhenDirective, ngSwitchDefault:ngSwitchDefaultDirective, ngOptions:ngOptionsDirective, ngTransclude:ngTranscludeDirective, ngModel:ngModelDirective, ngList:ngListDirective, ngChange:ngChangeDirective, required:requiredDirective, ngRequired:requiredDirective, ngValue:ngValueDirective}).directive({ngInclude:ngIncludeFillContentDirective}).directive(ngAttributeAliasDirectives).directive(ngEventDirectives);$provide.provider({$anchorScroll:$AnchorScrollProvider, $animate:$AnimateProvider, $browser:$BrowserProvider, $cacheFactory:$CacheFactoryProvider, $controller:$ControllerProvider, $document:$DocumentProvider, $exceptionHandler:$ExceptionHandlerProvider, $filter:$FilterProvider, $interpolate:$InterpolateProvider, $interval:$IntervalProvider, $http:$HttpProvider, $httpBackend:$HttpBackendProvider, $location:$LocationProvider, $log:$LogProvider, $parse:$ParseProvider, $rootScope:$RootScopeProvider, $q:$QProvider, $sce:$SceProvider, $sceDelegate:$SceDelegateProvider, $sniffer:$SnifferProvider, $templateCache:$TemplateCacheProvider, $timeout:$TimeoutProvider, $window:$WindowProvider, $$rAF:$$RAFProvider, $$asyncCallback:$$AsyncCallbackProvider});}]);}JQLite.expando = "ng339";var jqCache=JQLite.cache = {}, jqId=1, addEventListenerFn=window.document.addEventListener?function(element, type, fn){element.addEventListener(type, fn, false);}:function(element, type, fn){element.attachEvent("on" + type, fn);}, removeEventListenerFn=window.document.removeEventListener?function(element, type, fn){element.removeEventListener(type, fn, false);}:function(element, type, fn){element.detachEvent("on" + type, fn);};var jqData=JQLite._data = function(node){return this.cache[node[this.expando]] || {};};function jqNextId(){return ++jqId;}var SPECIAL_CHARS_REGEXP=/([\:\-\_]+(.))/g;var MOZ_HACK_REGEXP=/^moz([A-Z])/;var jqLiteMinErr=minErr("jqLite");function camelCase(name){return name.replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset){return offset?letter.toUpperCase():letter;}).replace(MOZ_HACK_REGEXP, "Moz$1");}function jqLitePatchJQueryRemove(name, dispatchThis, filterElems, getterIfNoArguments){var originalJqFn=jQuery.fn[name];originalJqFn = originalJqFn.$original || originalJqFn;removePatch.$original = originalJqFn;jQuery.fn[name] = removePatch;function removePatch(param){var list=filterElems && param?[this.filter(param)]:[this], fireEvent=dispatchThis, set, setIndex, setLength, element, childIndex, childLength, children;if(!getterIfNoArguments || param != null){while(list.length) {set = list.shift();for(setIndex = 0, setLength = set.length; setIndex < setLength; setIndex++) {element = jqLite(set[setIndex]);if(fireEvent){element.triggerHandler("$destroy");}else {fireEvent = !fireEvent;}for(childIndex = 0, childLength = (children = element.children()).length; childIndex < childLength; childIndex++) {list.push(jQuery(children[childIndex]));}}}}return originalJqFn.apply(this, arguments);}}var SINGLE_TAG_REGEXP=/^<(\w+)\s*\/?>(?:<\/\1>|)$/;var HTML_REGEXP=/<|&#?\w+;/;var TAG_NAME_REGEXP=/<([\w:]+)/;var XHTML_TAG_REGEXP=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi;var wrapMap={option:[1, "<select multiple=\"multiple\">", "</select>"], thead:[1, "<table>", "</table>"], col:[2, "<table><colgroup>", "</colgroup></table>"], tr:[2, "<table><tbody>", "</tbody></table>"], td:[3, "<table><tbody><tr>", "</tr></tbody></table>"], _default:[0, "", ""]};wrapMap.optgroup = wrapMap.option;wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;wrapMap.th = wrapMap.td;function jqLiteIsTextNode(html){return !HTML_REGEXP.test(html);}function jqLiteBuildFragment(html, context){var elem, tmp, tag, wrap, fragment=context.createDocumentFragment(), nodes=[], i, j, jj;if(jqLiteIsTextNode(html)){nodes.push(context.createTextNode(html));}else {tmp = fragment.appendChild(context.createElement("div"));tag = (TAG_NAME_REGEXP.exec(html) || ["", ""])[1].toLowerCase();wrap = wrapMap[tag] || wrapMap._default;tmp.innerHTML = "<div>&#160;</div>" + wrap[1] + html.replace(XHTML_TAG_REGEXP, "<$1></$2>") + wrap[2];tmp.removeChild(tmp.firstChild);i = wrap[0];while(i--) {tmp = tmp.lastChild;}for(j = 0, jj = tmp.childNodes.length; j < jj; ++j) nodes.push(tmp.childNodes[j]);tmp = fragment.firstChild;tmp.textContent = "";}fragment.textContent = "";fragment.innerHTML = "";return nodes;}function jqLiteParseHTML(html, context){context = context || document;var parsed;if(parsed = SINGLE_TAG_REGEXP.exec(html)){return [context.createElement(parsed[1])];}return jqLiteBuildFragment(html, context);}function JQLite(element){if(element instanceof JQLite){return element;}if(isString(element)){element = trim(element);}if(!(this instanceof JQLite)){if(isString(element) && element.charAt(0) != "<"){throw jqLiteMinErr("nosel", "Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element");}return new JQLite(element);}if(isString(element)){jqLiteAddNodes(this, jqLiteParseHTML(element));var fragment=jqLite(document.createDocumentFragment());fragment.append(this);}else {jqLiteAddNodes(this, element);}}function jqLiteClone(element){return element.cloneNode(true);}function jqLiteDealoc(element){jqLiteRemoveData(element);for(var i=0, children=element.childNodes || []; i < children.length; i++) {jqLiteDealoc(children[i]);}}function jqLiteOff(element, type, fn, unsupported){if(isDefined(unsupported))throw jqLiteMinErr("offargs", "jqLite#off() does not support the `selector` argument");var events=jqLiteExpandoStore(element, "events"), handle=jqLiteExpandoStore(element, "handle");if(!handle){return;}if(isUndefined(type)){forEach(events, function(eventHandler, type){removeEventListenerFn(element, type, eventHandler);delete events[type];});}else {forEach(type.split(" "), function(type){if(isUndefined(fn)){removeEventListenerFn(element, type, events[type]);delete events[type];}else {arrayRemove(events[type] || [], fn);}});}}function jqLiteRemoveData(element, name){var expandoId=element.ng339, expandoStore=jqCache[expandoId];if(expandoStore){if(name){delete jqCache[expandoId].data[name];return;}if(expandoStore.handle){expandoStore.events.$destroy && expandoStore.handle({}, "$destroy");jqLiteOff(element);}delete jqCache[expandoId];element.ng339 = undefined;}}function jqLiteExpandoStore(element, key, value){var expandoId=element.ng339, expandoStore=jqCache[expandoId || -1];if(isDefined(value)){if(!expandoStore){element.ng339 = expandoId = jqNextId();expandoStore = jqCache[expandoId] = {};}expandoStore[key] = value;}else {return expandoStore && expandoStore[key];}}function jqLiteData(element, key, value){var data=jqLiteExpandoStore(element, "data"), isSetter=isDefined(value), keyDefined=!isSetter && isDefined(key), isSimpleGetter=keyDefined && !isObject(key);if(!data && !isSimpleGetter){jqLiteExpandoStore(element, "data", data = {});}if(isSetter){data[key] = value;}else {if(keyDefined){if(isSimpleGetter){return data && data[key];}else {extend(data, key);}}else {return data;}}}function jqLiteHasClass(element, selector){if(!element.getAttribute){return false;}return (" " + (element.getAttribute("class") || "") + " ").replace(/[\n\t]/g, " ").indexOf(" " + selector + " ") > -1;}function jqLiteRemoveClass(element, cssClasses){if(cssClasses && element.setAttribute){forEach(cssClasses.split(" "), function(cssClass){element.setAttribute("class", trim((" " + (element.getAttribute("class") || "") + " ").replace(/[\n\t]/g, " ").replace(" " + trim(cssClass) + " ", " ")));});}}function jqLiteAddClass(element, cssClasses){if(cssClasses && element.setAttribute){var existingClasses=(" " + (element.getAttribute("class") || "") + " ").replace(/[\n\t]/g, " ");forEach(cssClasses.split(" "), function(cssClass){cssClass = trim(cssClass);if(existingClasses.indexOf(" " + cssClass + " ") === -1){existingClasses += cssClass + " ";}});element.setAttribute("class", trim(existingClasses));}}function jqLiteAddNodes(root, elements){if(elements){elements = !elements.nodeName && isDefined(elements.length) && !isWindow(elements)?elements:[elements];for(var i=0; i < elements.length; i++) {root.push(elements[i]);}}}function jqLiteController(element, name){return jqLiteInheritedData(element, "$" + (name || "ngController") + "Controller");}function jqLiteInheritedData(element, name, value){if(element.nodeType == 9){element = element.documentElement;}var names=isArray(name)?name:[name];while(element) {for(var i=0, ii=names.length; i < ii; i++) {if((value = jqLite.data(element, names[i])) !== undefined){return value;}}element = element.parentNode || element.nodeType === 11 && element.host;}}function jqLiteEmpty(element){for(var i=0, childNodes=element.childNodes; i < childNodes.length; i++) {jqLiteDealoc(childNodes[i]);}while(element.firstChild) {element.removeChild(element.firstChild);}}var JQLitePrototype=JQLite.prototype = {ready:function ready(fn){var fired=false;function trigger(){if(fired){return;}fired = true;fn();}if(document.readyState === "complete"){setTimeout(trigger);}else {this.on("DOMContentLoaded", trigger);JQLite(window).on("load", trigger);}}, toString:function toString(){var value=[];forEach(this, function(e){value.push("" + e);});return "[" + value.join(", ") + "]";}, eq:function eq(index){return index >= 0?jqLite(this[index]):jqLite(this[this.length + index]);}, length:0, push:push, sort:[].sort, splice:[].splice};var BOOLEAN_ATTR={};forEach("multiple,selected,checked,disabled,readOnly,required,open".split(","), function(value){BOOLEAN_ATTR[lowercase(value)] = value;});var BOOLEAN_ELEMENTS={};forEach("input,select,option,textarea,button,form,details".split(","), function(value){BOOLEAN_ELEMENTS[uppercase(value)] = true;});function getBooleanAttrName(element, name){var booleanAttr=BOOLEAN_ATTR[name.toLowerCase()];return booleanAttr && BOOLEAN_ELEMENTS[element.nodeName] && booleanAttr;}forEach({data:jqLiteData, removeData:jqLiteRemoveData}, function(fn, name){JQLite[name] = fn;});forEach({data:jqLiteData, inheritedData:jqLiteInheritedData, scope:function scope(element){return jqLite.data(element, "$scope") || jqLiteInheritedData(element.parentNode || element, ["$isolateScope", "$scope"]);}, isolateScope:function isolateScope(element){return jqLite.data(element, "$isolateScope") || jqLite.data(element, "$isolateScopeNoTemplate");}, controller:jqLiteController, injector:function injector(element){return jqLiteInheritedData(element, "$injector");}, removeAttr:function removeAttr(element, name){element.removeAttribute(name);}, hasClass:jqLiteHasClass, css:function css(element, name, value){name = camelCase(name);if(isDefined(value)){element.style[name] = value;}else {var val;if(msie <= 8){val = element.currentStyle && element.currentStyle[name];if(val === "")val = "auto";}val = val || element.style[name];if(msie <= 8){val = val === ""?undefined:val;}return val;}}, attr:function attr(element, name, value){var lowercasedName=lowercase(name);if(BOOLEAN_ATTR[lowercasedName]){if(isDefined(value)){if(!!value){element[name] = true;element.setAttribute(name, lowercasedName);}else {element[name] = false;element.removeAttribute(lowercasedName);}}else {return element[name] || (element.attributes.getNamedItem(name) || noop).specified?lowercasedName:undefined;}}else if(isDefined(value)){element.setAttribute(name, value);}else if(element.getAttribute){var ret=element.getAttribute(name, 2);return ret === null?undefined:ret;}}, prop:function prop(element, name, value){if(isDefined(value)){element[name] = value;}else {return element[name];}}, text:(function(){var NODE_TYPE_TEXT_PROPERTY=[];if(msie < 9){NODE_TYPE_TEXT_PROPERTY[1] = "innerText";NODE_TYPE_TEXT_PROPERTY[3] = "nodeValue";}else {NODE_TYPE_TEXT_PROPERTY[1] = NODE_TYPE_TEXT_PROPERTY[3] = "textContent";}getText.$dv = "";return getText;function getText(element, value){var textProp=NODE_TYPE_TEXT_PROPERTY[element.nodeType];if(isUndefined(value)){return textProp?element[textProp]:"";}element[textProp] = value;}})(), val:function val(element, value){if(isUndefined(value)){if(nodeName_(element) === "SELECT" && element.multiple){var result=[];forEach(element.options, function(option){if(option.selected){result.push(option.value || option.text);}});return result.length === 0?null:result;}return element.value;}element.value = value;}, html:function html(element, value){if(isUndefined(value)){return element.innerHTML;}for(var i=0, childNodes=element.childNodes; i < childNodes.length; i++) {jqLiteDealoc(childNodes[i]);}element.innerHTML = value;}, empty:jqLiteEmpty}, function(fn, name){JQLite.prototype[name] = function(arg1, arg2){var i, key;var nodeCount=this.length;if(fn !== jqLiteEmpty && (fn.length == 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)?arg1:arg2) === undefined){if(isObject(arg1)){for(i = 0; i < nodeCount; i++) {if(fn === jqLiteData){fn(this[i], arg1);}else {for(key in arg1) {fn(this[i], key, arg1[key]);}}}return this;}else {var value=fn.$dv;var jj=value === undefined?Math.min(nodeCount, 1):nodeCount;for(var j=0; j < jj; j++) {var nodeValue=fn(this[j], arg1, arg2);value = value?value + nodeValue:nodeValue;}return value;}}else {for(i = 0; i < nodeCount; i++) {fn(this[i], arg1, arg2);}return this;}};});function createEventHandler(element, events){var eventHandler=function eventHandler(event, type){if(!event.preventDefault){event.preventDefault = function(){event.returnValue = false;};}if(!event.stopPropagation){event.stopPropagation = function(){event.cancelBubble = true;};}if(!event.target){event.target = event.srcElement || document;}if(isUndefined(event.defaultPrevented)){var prevent=event.preventDefault;event.preventDefault = function(){event.defaultPrevented = true;prevent.call(event);};event.defaultPrevented = false;}event.isDefaultPrevented = function(){return event.defaultPrevented || event.returnValue === false;};var eventHandlersCopy=shallowCopy(events[type || event.type] || []);forEach(eventHandlersCopy, function(fn){fn.call(element, event);});if(msie <= 8){event.preventDefault = null;event.stopPropagation = null;event.isDefaultPrevented = null;}else {delete event.preventDefault;delete event.stopPropagation;delete event.isDefaultPrevented;}};eventHandler.elem = element;return eventHandler;}forEach({removeData:jqLiteRemoveData, dealoc:jqLiteDealoc, on:function onFn(element, type, fn, unsupported){if(isDefined(unsupported))throw jqLiteMinErr("onargs", "jqLite#on() does not support the `selector` or `eventData` parameters");var events=jqLiteExpandoStore(element, "events"), handle=jqLiteExpandoStore(element, "handle");if(!events)jqLiteExpandoStore(element, "events", events = {});if(!handle)jqLiteExpandoStore(element, "handle", handle = createEventHandler(element, events));forEach(type.split(" "), function(type){var eventFns=events[type];if(!eventFns){if(type == "mouseenter" || type == "mouseleave"){var contains=document.body.contains || document.body.compareDocumentPosition?function(a, b){var adown=a.nodeType === 9?a.documentElement:a, bup=b && b.parentNode;return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains?adown.contains(bup):a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));}:function(a, b){if(b){while(b = b.parentNode) {if(b === a){return true;}}}return false;};events[type] = [];var eventmap={mouseleave:"mouseout", mouseenter:"mouseover"};onFn(element, eventmap[type], function(event){var target=this, related=event.relatedTarget;if(!related || related !== target && !contains(target, related)){handle(event, type);}});}else {addEventListenerFn(element, type, handle);events[type] = [];}eventFns = events[type];}eventFns.push(fn);});}, off:jqLiteOff, one:function one(element, type, fn){element = jqLite(element);element.on(type, function onFn(){element.off(type, fn);element.off(type, onFn);});element.on(type, fn);}, replaceWith:function replaceWith(element, replaceNode){var index, parent=element.parentNode;jqLiteDealoc(element);forEach(new JQLite(replaceNode), function(node){if(index){parent.insertBefore(node, index.nextSibling);}else {parent.replaceChild(node, element);}index = node;});}, children:(function(_children){var _childrenWrapper=function children(_x){return _children.apply(this, arguments);};_childrenWrapper.toString = function(){return _children.toString();};return _childrenWrapper;})(function(element){var children=[];forEach(element.childNodes, function(element){if(element.nodeType === 1)children.push(element);});return children;}), contents:function contents(element){return element.contentDocument || element.childNodes || [];}, append:function append(element, node){forEach(new JQLite(node), function(child){if(element.nodeType === 1 || element.nodeType === 11){element.appendChild(child);}});}, prepend:function prepend(element, node){if(element.nodeType === 1){var index=element.firstChild;forEach(new JQLite(node), function(child){element.insertBefore(child, index);});}}, wrap:function wrap(element, wrapNode){wrapNode = jqLite(wrapNode)[0];var parent=element.parentNode;if(parent){parent.replaceChild(wrapNode, element);}wrapNode.appendChild(element);}, remove:function remove(element){jqLiteDealoc(element);var parent=element.parentNode;if(parent)parent.removeChild(element);}, after:function after(element, newElement){var index=element, parent=element.parentNode;forEach(new JQLite(newElement), function(node){parent.insertBefore(node, index.nextSibling);index = node;});}, addClass:jqLiteAddClass, removeClass:jqLiteRemoveClass, toggleClass:function toggleClass(element, selector, condition){if(selector){forEach(selector.split(" "), function(className){var classCondition=condition;if(isUndefined(classCondition)){classCondition = !jqLiteHasClass(element, className);}(classCondition?jqLiteAddClass:jqLiteRemoveClass)(element, className);});}}, parent:(function(_parent){var _parentWrapper=function parent(_x){return _parent.apply(this, arguments);};_parentWrapper.toString = function(){return _parent.toString();};return _parentWrapper;})(function(element){var parent=element.parentNode;return parent && parent.nodeType !== 11?parent:null;}), next:function next(element){if(element.nextElementSibling){return element.nextElementSibling;}var elm=element.nextSibling;while(elm != null && elm.nodeType !== 1) {elm = elm.nextSibling;}return elm;}, find:function find(element, selector){if(element.getElementsByTagName){return element.getElementsByTagName(selector);}else {return [];}}, clone:jqLiteClone, triggerHandler:function triggerHandler(element, event, extraParameters){var dummyEvent, eventFnsCopy, handlerArgs;var eventName=event.type || event;var eventFns=(jqLiteExpandoStore(element, "events") || {})[eventName];if(eventFns){dummyEvent = {preventDefault:function preventDefault(){this.defaultPrevented = true;}, isDefaultPrevented:function isDefaultPrevented(){return this.defaultPrevented === true;}, stopPropagation:noop, type:eventName, target:element};if(event.type){dummyEvent = extend(dummyEvent, event);}eventFnsCopy = shallowCopy(eventFns);handlerArgs = extraParameters?[dummyEvent].concat(extraParameters):[dummyEvent];forEach(eventFnsCopy, function(fn){fn.apply(element, handlerArgs);});}}}, function(fn, name){JQLite.prototype[name] = function(arg1, arg2, arg3){var value;for(var i=0; i < this.length; i++) {if(isUndefined(value)){value = fn(this[i], arg1, arg2, arg3);if(isDefined(value)){value = jqLite(value);}}else {jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));}}return isDefined(value)?value:this;};JQLite.prototype.bind = JQLite.prototype.on;JQLite.prototype.unbind = JQLite.prototype.off;});function hashKey(obj, nextUidFn){var objType=typeof obj, key;if(objType == "function" || objType == "object" && obj !== null){if(typeof (key = obj.$$hashKey) == "function"){key = obj.$$hashKey();}else if(key === undefined){key = obj.$$hashKey = (nextUidFn || nextUid)();}}else {key = obj;}return objType + ":" + key;}function HashMap(array, isolatedUid){if(isolatedUid){var uid=0;this.nextUid = function(){return ++uid;};}forEach(array, this.put, this);}HashMap.prototype = {put:function put(key, value){this[hashKey(key, this.nextUid)] = value;}, get:function get(key){return this[hashKey(key, this.nextUid)];}, remove:function remove(key){var value=this[key = hashKey(key, this.nextUid)];delete this[key];return value;}};var FN_ARGS=/^function\s*[^\(]*\(\s*([^\)]*)\)/m;var FN_ARG_SPLIT=/,/;var FN_ARG=/^\s*(_?)(\S+?)\1\s*$/;var STRIP_COMMENTS=/((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;var $injectorMinErr=minErr("$injector");function annotate(fn){var $inject, fnText, argDecl, last;if(typeof fn === "function"){if(!($inject = fn.$inject)){$inject = [];if(fn.length){fnText = fn.toString().replace(STRIP_COMMENTS, "");argDecl = fnText.match(FN_ARGS);forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg){arg.replace(FN_ARG, function(all, underscore, name){$inject.push(name);});});}fn.$inject = $inject;}}else if(isArray(fn)){last = fn.length - 1;assertArgFn(fn[last], "fn");$inject = fn.slice(0, last);}else {assertArgFn(fn, "fn", true);}return $inject;}function createInjector(modulesToLoad){var INSTANTIATING={}, providerSuffix="Provider", path=[], loadedModules=new HashMap([], true), providerCache={$provide:{provider:supportObject(provider), factory:supportObject(factory), service:supportObject(service), value:supportObject(value), constant:supportObject(constant), decorator:decorator}}, providerInjector=providerCache.$injector = createInternalInjector(providerCache, function(){throw $injectorMinErr("unpr", "Unknown provider: {0}", path.join(" <- "));}), instanceCache={}, instanceInjector=instanceCache.$injector = createInternalInjector(instanceCache, function(servicename){var provider=providerInjector.get(servicename + providerSuffix);return instanceInjector.invoke(provider.$get, provider);});forEach(loadModules(modulesToLoad), function(fn){instanceInjector.invoke(fn || noop);});return instanceInjector;function supportObject(delegate){return function(key, value){if(isObject(key)){forEach(key, reverseParams(delegate));}else {return delegate(key, value);}};}function provider(name, provider_){assertNotHasOwnProperty(name, "service");if(isFunction(provider_) || isArray(provider_)){provider_ = providerInjector.instantiate(provider_);}if(!provider_.$get){throw $injectorMinErr("pget", "Provider '{0}' must define $get factory method.", name);}return providerCache[name + providerSuffix] = provider_;}function factory(name, factoryFn){return provider(name, {$get:factoryFn});}function service(name, constructor){return factory(name, ["$injector", function($injector){return $injector.instantiate(constructor);}]);}function value(name, val){return factory(name, valueFn(val));}function constant(name, value){assertNotHasOwnProperty(name, "constant");providerCache[name] = value;instanceCache[name] = value;}function decorator(serviceName, decorFn){var origProvider=providerInjector.get(serviceName + providerSuffix), orig$get=origProvider.$get;origProvider.$get = function(){var origInstance=instanceInjector.invoke(orig$get, origProvider);return instanceInjector.invoke(decorFn, null, {$delegate:origInstance});};}function loadModules(modulesToLoad){var runBlocks=[], moduleFn, invokeQueue, i, ii;forEach(modulesToLoad, function(module){if(loadedModules.get(module))return;loadedModules.put(module, true);try{if(isString(module)){moduleFn = angularModule(module);runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);for(invokeQueue = moduleFn._invokeQueue, i = 0, ii = invokeQueue.length; i < ii; i++) {var invokeArgs=invokeQueue[i], provider=providerInjector.get(invokeArgs[0]);provider[invokeArgs[1]].apply(provider, invokeArgs[2]);}}else if(isFunction(module)){runBlocks.push(providerInjector.invoke(module));}else if(isArray(module)){runBlocks.push(providerInjector.invoke(module));}else {assertArgFn(module, "module");}}catch(e) {if(isArray(module)){module = module[module.length - 1];}if(e.message && e.stack && e.stack.indexOf(e.message) == -1){e = e.message + "\n" + e.stack;}throw $injectorMinErr("modulerr", "Failed to instantiate module {0} due to:\n{1}", module, e.stack || e.message || e);}});return runBlocks;}function createInternalInjector(cache, factory){function getService(serviceName){if(cache.hasOwnProperty(serviceName)){if(cache[serviceName] === INSTANTIATING){throw $injectorMinErr("cdep", "Circular dependency found: {0}", serviceName + " <- " + path.join(" <- "));}return cache[serviceName];}else {try{path.unshift(serviceName);cache[serviceName] = INSTANTIATING;return cache[serviceName] = factory(serviceName);}catch(err) {if(cache[serviceName] === INSTANTIATING){delete cache[serviceName];}throw err;}finally {path.shift();}}}function invoke(fn, self, locals){var args=[], $inject=annotate(fn), length, i, key;for(i = 0, length = $inject.length; i < length; i++) {key = $inject[i];if(typeof key !== "string"){throw $injectorMinErr("itkn", "Incorrect injection token! Expected service name as string, got {0}", key);}args.push(locals && locals.hasOwnProperty(key)?locals[key]:getService(key));}if(isArray(fn)){fn = fn[length];}return fn.apply(self, args);}function instantiate(Type, locals){var Constructor=function Constructor(){}, instance, returnedValue;Constructor.prototype = (isArray(Type)?Type[Type.length - 1]:Type).prototype;instance = new Constructor();returnedValue = invoke(Type, instance, locals);return isObject(returnedValue) || isFunction(returnedValue)?returnedValue:instance;}return {invoke:invoke, instantiate:instantiate, get:getService, annotate:annotate, has:function has(name){return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);}};}}function $AnchorScrollProvider(){var autoScrollingEnabled=true;this.disableAutoScrolling = function(){autoScrollingEnabled = false;};this.$get = ["$window", "$location", "$rootScope", function($window, $location, $rootScope){var document=$window.document;function getFirstAnchor(list){var result=null;forEach(list, function(element){if(!result && lowercase(element.nodeName) === "a")result = element;});return result;}function scroll(){var hash=$location.hash(), elm;if(!hash)$window.scrollTo(0, 0);else if(elm = document.getElementById(hash))elm.scrollIntoView();else if(elm = getFirstAnchor(document.getElementsByName(hash)))elm.scrollIntoView();else if(hash === "top")$window.scrollTo(0, 0);}if(autoScrollingEnabled){$rootScope.$watch(function autoScrollWatch(){return $location.hash();}, function autoScrollWatchAction(){$rootScope.$evalAsync(scroll);});}return scroll;}];}var $animateMinErr=minErr("$animate");var $AnimateProvider=["$provide", function($provide){this.$$selectors = {};this.register = function(name, factory){var key=name + "-animation";if(name && name.charAt(0) != ".")throw $animateMinErr("notcsel", "Expecting class selector starting with '.' got '{0}'.", name);this.$$selectors[name.substr(1)] = key;$provide.factory(key, factory);};this.classNameFilter = function(expression){if(arguments.length === 1){this.$$classNameFilter = expression instanceof RegExp?expression:null;}return this.$$classNameFilter;};this.$get = ["$timeout", "$$asyncCallback", function($timeout, $$asyncCallback){function async(fn){fn && $$asyncCallback(fn);}return {enter:function enter(element, parent, after, done){if(after){after.after(element);}else {if(!parent || !parent[0]){parent = after.parent();}parent.append(element);}async(done);}, leave:function leave(element, done){element.remove();async(done);}, move:function move(element, parent, after, done){this.enter(element, parent, after, done);}, addClass:function addClass(element, className, done){className = isString(className)?className:isArray(className)?className.join(" "):"";forEach(element, function(element){jqLiteAddClass(element, className);});async(done);}, removeClass:function removeClass(element, className, done){className = isString(className)?className:isArray(className)?className.join(" "):"";forEach(element, function(element){jqLiteRemoveClass(element, className);});async(done);}, setClass:function setClass(element, add, remove, done){forEach(element, function(element){jqLiteAddClass(element, add);jqLiteRemoveClass(element, remove);});async(done);}, enabled:noop};}];}];function $$AsyncCallbackProvider(){this.$get = ["$$rAF", "$timeout", function($$rAF, $timeout){return $$rAF.supported?function(fn){return $$rAF(fn);}:function(fn){return $timeout(fn, 0, false);};}];}function Browser(window, document, $log, $sniffer){var self=this, rawDocument=document[0], location=window.location, history=window.history, setTimeout=window.setTimeout, clearTimeout=window.clearTimeout, pendingDeferIds={};self.isMock = false;var outstandingRequestCount=0;var outstandingRequestCallbacks=[];self.$$completeOutstandingRequest = completeOutstandingRequest;self.$$incOutstandingRequestCount = function(){outstandingRequestCount++;};function completeOutstandingRequest(fn){try{fn.apply(null, sliceArgs(arguments, 1));}finally {outstandingRequestCount--;if(outstandingRequestCount === 0){while(outstandingRequestCallbacks.length) {try{outstandingRequestCallbacks.pop()();}catch(e) {$log.error(e);}}}}}function getHash(url){var index=url.indexOf("#");return index === -1?"":url.substr(index + 1);}self.notifyWhenNoOutstandingRequests = function(callback){forEach(pollFns, function(pollFn){pollFn();});if(outstandingRequestCount === 0){callback();}else {outstandingRequestCallbacks.push(callback);}};var pollFns=[], pollTimeout;self.addPollFn = function(fn){if(isUndefined(pollTimeout))startPoller(100, setTimeout);pollFns.push(fn);return fn;};function startPoller(interval, setTimeout){(function check(){forEach(pollFns, function(pollFn){pollFn();});pollTimeout = setTimeout(check, interval);})();}var lastBrowserUrl=location.href, baseElement=document.find("base"), reloadLocation=null;self.url = function(url, replace){if(location !== window.location)location = window.location;if(history !== window.history)history = window.history;if(url){if(lastBrowserUrl == url)return;var sameBase=lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);lastBrowserUrl = url;if(!sameBase && $sniffer.history){if(replace)history.replaceState(null, "", url);else {history.pushState(null, "", url);baseElement.attr("href", baseElement.attr("href"));}}else {if(!sameBase){reloadLocation = url;}if(replace){location.replace(url);}else if(!sameBase){location.href = url;}else {location.hash = getHash(url);}}return self;}else {return reloadLocation || location.href.replace(/%27/g, "'");}};var urlChangeListeners=[], urlChangeInit=false;function fireUrlChange(){if(lastBrowserUrl == self.url()){return;}lastBrowserUrl = self.url();forEach(urlChangeListeners, function(listener){listener(self.url());});}self.onUrlChange = function(callback){if(!urlChangeInit){if($sniffer.history)jqLite(window).on("popstate", fireUrlChange);if($sniffer.hashchange)jqLite(window).on("hashchange", fireUrlChange);else self.addPollFn(fireUrlChange);urlChangeInit = true;}urlChangeListeners.push(callback);return callback;};self.$$checkUrlChange = fireUrlChange;self.baseHref = function(){var href=baseElement.attr("href");return href?href.replace(/^(https?\:)?\/\/[^\/]*/, ""):"";};var lastCookies={};var lastCookieString="";var cookiePath=self.baseHref();self.cookies = function(name, value){var cookieLength, cookieArray, cookie, i, index;if(name){if(value === undefined){rawDocument.cookie = escape(name) + "=;path=" + cookiePath + ";expires=Thu, 01 Jan 1970 00:00:00 GMT";}else {if(isString(value)){cookieLength = (rawDocument.cookie = escape(name) + "=" + escape(value) + ";path=" + cookiePath).length + 1;if(cookieLength > 4096){$log.warn("Cookie '" + name + "' possibly not set or overflowed because it was too large (" + cookieLength + " > 4096 bytes)!");}}}}else {if(rawDocument.cookie !== lastCookieString){lastCookieString = rawDocument.cookie;cookieArray = lastCookieString.split("; ");lastCookies = {};for(i = 0; i < cookieArray.length; i++) {cookie = cookieArray[i];index = cookie.indexOf("=");if(index > 0){name = unescape(cookie.substring(0, index));if(lastCookies[name] === undefined){lastCookies[name] = unescape(cookie.substring(index + 1));}}}}return lastCookies;}};self.defer = function(fn, delay){var timeoutId;outstandingRequestCount++;timeoutId = setTimeout(function(){delete pendingDeferIds[timeoutId];completeOutstandingRequest(fn);}, delay || 0);pendingDeferIds[timeoutId] = true;return timeoutId;};self.defer.cancel = function(deferId){if(pendingDeferIds[deferId]){delete pendingDeferIds[deferId];clearTimeout(deferId);completeOutstandingRequest(noop);return true;}return false;};}function $BrowserProvider(){this.$get = ["$window", "$log", "$sniffer", "$document", function($window, $log, $sniffer, $document){return new Browser($window, $document, $log, $sniffer);}];}function $CacheFactoryProvider(){this.$get = function(){var caches={};function cacheFactory(cacheId, options){if(cacheId in caches){throw minErr("$cacheFactory")("iid", "CacheId '{0}' is already taken!", cacheId);}var size=0, stats=extend({}, options, {id:cacheId}), data={}, capacity=options && options.capacity || Number.MAX_VALUE, lruHash={}, freshEnd=null, staleEnd=null;return caches[cacheId] = {put:function put(key, value){if(capacity < Number.MAX_VALUE){var lruEntry=lruHash[key] || (lruHash[key] = {key:key});refresh(lruEntry);}if(isUndefined(value)){return;}if(!(key in data))size++;data[key] = value;if(size > capacity){this.remove(staleEnd.key);}return value;}, get:function get(key){if(capacity < Number.MAX_VALUE){var lruEntry=lruHash[key];if(!lruEntry){return;}refresh(lruEntry);}return data[key];}, remove:function remove(key){if(capacity < Number.MAX_VALUE){var lruEntry=lruHash[key];if(!lruEntry){return;}if(lruEntry == freshEnd)freshEnd = lruEntry.p;if(lruEntry == staleEnd)staleEnd = lruEntry.n;link(lruEntry.n, lruEntry.p);delete lruHash[key];}delete data[key];size--;}, removeAll:function removeAll(){data = {};size = 0;lruHash = {};freshEnd = staleEnd = null;}, destroy:function destroy(){data = null;stats = null;lruHash = null;delete caches[cacheId];}, info:function info(){return extend({}, stats, {size:size});}};function refresh(entry){if(entry != freshEnd){if(!staleEnd){staleEnd = entry;}else if(staleEnd == entry){staleEnd = entry.n;}link(entry.n, entry.p);link(entry, freshEnd);freshEnd = entry;freshEnd.n = null;}}function link(nextEntry, prevEntry){if(nextEntry != prevEntry){if(nextEntry)nextEntry.p = prevEntry;if(prevEntry)prevEntry.n = nextEntry;}}}cacheFactory.info = function(){var info={};forEach(caches, function(cache, cacheId){info[cacheId] = cache.info();});return info;};cacheFactory.get = function(cacheId){return caches[cacheId];};return cacheFactory;};}function $TemplateCacheProvider(){this.$get = ["$cacheFactory", function($cacheFactory){return $cacheFactory("templates");}];}var $compileMinErr=minErr("$compile");$CompileProvider.$inject = ["$provide", "$$sanitizeUriProvider"];function $CompileProvider($provide, $$sanitizeUriProvider){var hasDirectives={}, Suffix="Directive", COMMENT_DIRECTIVE_REGEXP=/^\s*directive\:\s*([\d\w_\-]+)\s+(.*)$/, CLASS_DIRECTIVE_REGEXP=/(([\d\w_\-]+)(?:\:([^;]+))?;?)/;var EVENT_HANDLER_ATTR_REGEXP=/^(on[a-z]+|formaction)$/;this.directive = function registerDirective(name, directiveFactory){assertNotHasOwnProperty(name, "directive");if(isString(name)){assertArg(directiveFactory, "directiveFactory");if(!hasDirectives.hasOwnProperty(name)){hasDirectives[name] = [];$provide.factory(name + Suffix, ["$injector", "$exceptionHandler", function($injector, $exceptionHandler){var directives=[];forEach(hasDirectives[name], function(directiveFactory, index){try{var directive=$injector.invoke(directiveFactory);if(isFunction(directive)){directive = {compile:valueFn(directive)};}else if(!directive.compile && directive.link){directive.compile = valueFn(directive.link);}directive.priority = directive.priority || 0;directive.index = index;directive.name = directive.name || name;directive.require = directive.require || directive.controller && directive.name;directive.restrict = directive.restrict || "A";directives.push(directive);}catch(e) {$exceptionHandler(e);}});return directives;}]);}hasDirectives[name].push(directiveFactory);}else {forEach(name, reverseParams(registerDirective));}return this;};this.aHrefSanitizationWhitelist = function(regexp){if(isDefined(regexp)){$$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);return this;}else {return $$sanitizeUriProvider.aHrefSanitizationWhitelist();}};this.imgSrcSanitizationWhitelist = function(regexp){if(isDefined(regexp)){$$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);return this;}else {return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();}};this.$get = ["$injector", "$interpolate", "$exceptionHandler", "$http", "$templateCache", "$parse", "$controller", "$rootScope", "$document", "$sce", "$animate", "$$sanitizeUri", function($injector, $interpolate, $exceptionHandler, $http, $templateCache, $parse, $controller, $rootScope, $document, $sce, $animate, $$sanitizeUri){var Attributes=function Attributes(element, attr){this.$$element = element;this.$attr = attr || {};};Attributes.prototype = {$normalize:directiveNormalize, $addClass:function $addClass(classVal){if(classVal && classVal.length > 0){$animate.addClass(this.$$element, classVal);}}, $removeClass:function $removeClass(classVal){if(classVal && classVal.length > 0){$animate.removeClass(this.$$element, classVal);}}, $updateClass:function $updateClass(newClasses, oldClasses){var toAdd=tokenDifference(newClasses, oldClasses);var toRemove=tokenDifference(oldClasses, newClasses);if(toAdd.length === 0){$animate.removeClass(this.$$element, toRemove);}else if(toRemove.length === 0){$animate.addClass(this.$$element, toAdd);}else {$animate.setClass(this.$$element, toAdd, toRemove);}}, $set:function $set(key, value, writeAttr, attrName){var booleanKey=getBooleanAttrName(this.$$element[0], key), normalizedVal, nodeName;if(booleanKey){this.$$element.prop(key, value);attrName = booleanKey;}this[key] = value;if(attrName){this.$attr[key] = attrName;}else {attrName = this.$attr[key];if(!attrName){this.$attr[key] = attrName = snake_case(key, "-");}}nodeName = nodeName_(this.$$element).toUpperCase();if(nodeName === "A" && (key === "href" || key === "xlinkHref") || nodeName === "IMG" && key === "src"){this[key] = value = $$sanitizeUri(value, key === "src");}if(writeAttr !== false){if(value === null || value === undefined){this.$$element.removeAttr(attrName);}else {this.$$element.attr(attrName, value);}}var $$observers=this.$$observers;$$observers && forEach($$observers[key], function(fn){try{fn(value);}catch(e) {$exceptionHandler(e);}});}, $observe:function $observe(key, fn){var attrs=this, $$observers=attrs.$$observers || (attrs.$$observers = {}), listeners=$$observers[key] || ($$observers[key] = []);listeners.push(fn);$rootScope.$evalAsync(function(){if(!listeners.$$inter){fn(attrs[key]);}});return fn;}};var startSymbol=$interpolate.startSymbol(), endSymbol=$interpolate.endSymbol(), denormalizeTemplate=startSymbol == "{{" || endSymbol == "}}"?identity:function denormalizeTemplate(template){return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);}, NG_ATTR_BINDING=/^ngAttr[A-Z]/;return compile;function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext){if(!($compileNodes instanceof jqLite)){$compileNodes = jqLite($compileNodes);}forEach($compileNodes, function(node, index){if(node.nodeType == 3 && node.nodeValue.match(/\S+/)){$compileNodes[index] = node = jqLite(node).wrap("<span></span>").parent()[0];}});var compositeLinkFn=compileNodes($compileNodes, transcludeFn, $compileNodes, maxPriority, ignoreDirective, previousCompileContext);safeAddClass($compileNodes, "ng-scope");return function publicLinkFn(scope, cloneConnectFn, transcludeControllers, parentBoundTranscludeFn){assertArg(scope, "scope");var $linkNode=cloneConnectFn?JQLitePrototype.clone.call($compileNodes):$compileNodes;forEach(transcludeControllers, function(instance, name){$linkNode.data("$" + name + "Controller", instance);});for(var i=0, ii=$linkNode.length; i < ii; i++) {var node=$linkNode[i], nodeType=node.nodeType;if(nodeType === 1 || nodeType === 9){$linkNode.eq(i).data("$scope", scope);}}if(cloneConnectFn)cloneConnectFn($linkNode, scope);if(compositeLinkFn)compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);return $linkNode;};}function safeAddClass($element, className){try{$element.addClass(className);}catch(e) {}}function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective, previousCompileContext){var linkFns=[], attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound;for(var i=0; i < nodeList.length; i++) {attrs = new Attributes();directives = collectDirectives(nodeList[i], [], attrs, i === 0?maxPriority:undefined, ignoreDirective);nodeLinkFn = directives.length?applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement, null, [], [], previousCompileContext):null;if(nodeLinkFn && nodeLinkFn.scope){safeAddClass(attrs.$$element, "ng-scope");}childLinkFn = nodeLinkFn && nodeLinkFn.terminal || !(childNodes = nodeList[i].childNodes) || !childNodes.length?null:compileNodes(childNodes, nodeLinkFn?(nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement) && nodeLinkFn.transclude:transcludeFn);linkFns.push(nodeLinkFn, childLinkFn);linkFnFound = linkFnFound || nodeLinkFn || childLinkFn;previousCompileContext = null;}return linkFnFound?compositeLinkFn:null;function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn){var nodeLinkFn, childLinkFn, node, childScope, i, ii, n, childBoundTranscludeFn;var nodeListLength=nodeList.length, stableNodeList=new Array(nodeListLength);for(i = 0; i < nodeListLength; i++) {stableNodeList[i] = nodeList[i];}for(i = 0, n = 0, ii = linkFns.length; i < ii; n++) {node = stableNodeList[n];nodeLinkFn = linkFns[i++];childLinkFn = linkFns[i++];if(nodeLinkFn){if(nodeLinkFn.scope){childScope = scope.$new();jqLite.data(node, "$scope", childScope);}else {childScope = scope;}if(nodeLinkFn.transcludeOnThisElement){childBoundTranscludeFn = createBoundTranscludeFn(scope, nodeLinkFn.transclude, parentBoundTranscludeFn);}else if(!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn){childBoundTranscludeFn = parentBoundTranscludeFn;}else if(!parentBoundTranscludeFn && transcludeFn){childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);}else {childBoundTranscludeFn = null;}nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);}else if(childLinkFn){childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);}}}}function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn){var boundTranscludeFn=function boundTranscludeFn(transcludedScope, cloneFn, controllers){var scopeCreated=false;if(!transcludedScope){transcludedScope = scope.$new();transcludedScope.$$transcluded = true;scopeCreated = true;}var clone=transcludeFn(transcludedScope, cloneFn, controllers, previousBoundTranscludeFn);if(scopeCreated){clone.on("$destroy", function(){transcludedScope.$destroy();});}return clone;};return boundTranscludeFn;}function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective){var nodeType=node.nodeType, attrsMap=attrs.$attr, match, nodeName, className;switch(nodeType){case 1:nodeName = nodeName_(node).toLowerCase();addDirective(directives, directiveNormalize(nodeName), "E", maxPriority, ignoreDirective);for(var attr, name, nName, ngAttrName, value, isNgAttr, nAttrs=node.attributes, j=0, jj=nAttrs && nAttrs.length; j < jj; j++) {var attrStartName=false;var attrEndName=false;attr = nAttrs[j];if(!msie || msie >= 8 || attr.specified){name = attr.name;value = trim(attr.value);ngAttrName = directiveNormalize(name);if(isNgAttr = NG_ATTR_BINDING.test(ngAttrName)){name = snake_case(ngAttrName.substr(6), "-");}var directiveNName=ngAttrName.replace(/(Start|End)$/, "");if(ngAttrName === directiveNName + "Start"){attrStartName = name;attrEndName = name.substr(0, name.length - 5) + "end";name = name.substr(0, name.length - 6);}nName = directiveNormalize(name.toLowerCase());attrsMap[nName] = name;if(isNgAttr || !attrs.hasOwnProperty(nName)){attrs[nName] = value;if(getBooleanAttrName(node, nName)){attrs[nName] = true;}}addAttrInterpolateDirective(node, directives, value, nName);addDirective(directives, nName, "A", maxPriority, ignoreDirective, attrStartName, attrEndName);}}if(nodeName === "input" && node.getAttribute("type") === "hidden"){node.setAttribute("autocomplete", "off");}className = node.className;if(isString(className) && className !== ""){while(match = CLASS_DIRECTIVE_REGEXP.exec(className)) {nName = directiveNormalize(match[2]);if(addDirective(directives, nName, "C", maxPriority, ignoreDirective)){attrs[nName] = trim(match[3]);}className = className.substr(match.index + match[0].length);}}break;case 3:if(msie === 11){while(node.parentNode && node.nextSibling && node.nextSibling.nodeType === 3) {node.nodeValue = node.nodeValue + node.nextSibling.nodeValue;node.parentNode.removeChild(node.nextSibling);}}addTextInterpolateDirective(directives, node.nodeValue);break;case 8:try{match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);if(match){nName = directiveNormalize(match[1]);if(addDirective(directives, nName, "M", maxPriority, ignoreDirective)){attrs[nName] = trim(match[2]);}}}catch(e) {}break;}directives.sort(byPriority);return directives;}function groupScan(node, attrStart, attrEnd){var nodes=[];var depth=0;if(attrStart && node.hasAttribute && node.hasAttribute(attrStart)){var startNode=node;do{if(!node){throw $compileMinErr("uterdir", "Unterminated attribute, found '{0}' but no matching '{1}' found.", attrStart, attrEnd);}if(node.nodeType == 1){if(node.hasAttribute(attrStart))depth++;if(node.hasAttribute(attrEnd))depth--;}nodes.push(node);node = node.nextSibling;}while(depth > 0);}else {nodes.push(node);}return jqLite(nodes);}function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd){return function(scope, element, attrs, controllers, transcludeFn){element = groupScan(element[0], attrStart, attrEnd);return linkFn(scope, element, attrs, controllers, transcludeFn);};}function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn, jqCollection, originalReplaceDirective, preLinkFns, postLinkFns, previousCompileContext){previousCompileContext = previousCompileContext || {};var terminalPriority=-Number.MAX_VALUE, newScopeDirective, controllerDirectives=previousCompileContext.controllerDirectives, newIsolateScopeDirective=previousCompileContext.newIsolateScopeDirective, templateDirective=previousCompileContext.templateDirective, nonTlbTranscludeDirective=previousCompileContext.nonTlbTranscludeDirective, hasTranscludeDirective=false, hasTemplate=false, hasElementTranscludeDirective=previousCompileContext.hasElementTranscludeDirective, $compileNode=templateAttrs.$$element = jqLite(compileNode), directive, directiveName, $template, replaceDirective=originalReplaceDirective, childTranscludeFn=transcludeFn, linkFn, directiveValue;for(var i=0, ii=directives.length; i < ii; i++) {directive = directives[i];var attrStart=directive.$$start;var attrEnd=directive.$$end;if(attrStart){$compileNode = groupScan(compileNode, attrStart, attrEnd);}$template = undefined;if(terminalPriority > directive.priority){break;}if(directiveValue = directive.scope){newScopeDirective = newScopeDirective || directive;if(!directive.templateUrl){assertNoDuplicate("new/isolated scope", newIsolateScopeDirective, directive, $compileNode);if(isObject(directiveValue)){newIsolateScopeDirective = directive;}}}directiveName = directive.name;if(!directive.templateUrl && directive.controller){directiveValue = directive.controller;controllerDirectives = controllerDirectives || {};assertNoDuplicate("'" + directiveName + "' controller", controllerDirectives[directiveName], directive, $compileNode);controllerDirectives[directiveName] = directive;}if(directiveValue = directive.transclude){hasTranscludeDirective = true;if(!directive.$$tlb){assertNoDuplicate("transclusion", nonTlbTranscludeDirective, directive, $compileNode);nonTlbTranscludeDirective = directive;}if(directiveValue == "element"){hasElementTranscludeDirective = true;terminalPriority = directive.priority;$template = $compileNode;$compileNode = templateAttrs.$$element = jqLite(document.createComment(" " + directiveName + ": " + templateAttrs[directiveName] + " "));compileNode = $compileNode[0];replaceWith(jqCollection, sliceArgs($template), compileNode);childTranscludeFn = compile($template, transcludeFn, terminalPriority, replaceDirective && replaceDirective.name, {nonTlbTranscludeDirective:nonTlbTranscludeDirective});}else {$template = jqLite(jqLiteClone(compileNode)).contents();$compileNode.empty();childTranscludeFn = compile($template, transcludeFn);}}if(directive.template){hasTemplate = true;assertNoDuplicate("template", templateDirective, directive, $compileNode);templateDirective = directive;directiveValue = isFunction(directive.template)?directive.template($compileNode, templateAttrs):directive.template;directiveValue = denormalizeTemplate(directiveValue);if(directive.replace){replaceDirective = directive;if(jqLiteIsTextNode(directiveValue)){$template = [];}else {$template = jqLite(trim(directiveValue));}compileNode = $template[0];if($template.length != 1 || compileNode.nodeType !== 1){throw $compileMinErr("tplrt", "Template for directive '{0}' must have exactly one root element. {1}", directiveName, "");}replaceWith(jqCollection, $compileNode, compileNode);var newTemplateAttrs={$attr:{}};var templateDirectives=collectDirectives(compileNode, [], newTemplateAttrs);var unprocessedDirectives=directives.splice(i + 1, directives.length - (i + 1));if(newIsolateScopeDirective){markDirectivesAsIsolate(templateDirectives);}directives = directives.concat(templateDirectives).concat(unprocessedDirectives);mergeTemplateAttributes(templateAttrs, newTemplateAttrs);ii = directives.length;}else {$compileNode.html(directiveValue);}}if(directive.templateUrl){hasTemplate = true;assertNoDuplicate("template", templateDirective, directive, $compileNode);templateDirective = directive;if(directive.replace){replaceDirective = directive;}nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode, templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {controllerDirectives:controllerDirectives, newIsolateScopeDirective:newIsolateScopeDirective, templateDirective:templateDirective, nonTlbTranscludeDirective:nonTlbTranscludeDirective});ii = directives.length;}else if(directive.compile){try{linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);if(isFunction(linkFn)){addLinkFns(null, linkFn, attrStart, attrEnd);}else if(linkFn){addLinkFns(linkFn.pre, linkFn.post, attrStart, attrEnd);}}catch(e) {$exceptionHandler(e, startingTag($compileNode));}}if(directive.terminal){nodeLinkFn.terminal = true;terminalPriority = Math.max(terminalPriority, directive.priority);}}nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;nodeLinkFn.templateOnThisElement = hasTemplate;nodeLinkFn.transclude = childTranscludeFn;previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;return nodeLinkFn;function addLinkFns(pre, post, attrStart, attrEnd){if(pre){if(attrStart)pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);pre.require = directive.require;pre.directiveName = directiveName;if(newIsolateScopeDirective === directive || directive.$$isolateScope){pre = cloneAndAnnotateFn(pre, {isolateScope:true});}preLinkFns.push(pre);}if(post){if(attrStart)post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);post.require = directive.require;post.directiveName = directiveName;if(newIsolateScopeDirective === directive || directive.$$isolateScope){post = cloneAndAnnotateFn(post, {isolateScope:true});}postLinkFns.push(post);}}function getControllers(directiveName, require, $element, elementControllers){var value, retrievalMethod="data", optional=false;if(isString(require)){while((value = require.charAt(0)) == "^" || value == "?") {require = require.substr(1);if(value == "^"){retrievalMethod = "inheritedData";}optional = optional || value == "?";}value = null;if(elementControllers && retrievalMethod === "data"){value = elementControllers[require];}value = value || $element[retrievalMethod]("$" + require + "Controller");if(!value && !optional){throw $compileMinErr("ctreq", "Controller '{0}', required by directive '{1}', can't be found!", require, directiveName);}return value;}else if(isArray(require)){value = [];forEach(require, function(require){value.push(getControllers(directiveName, require, $element, elementControllers));});}return value;}function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn){var attrs, $element, i, ii, linkFn, controller, isolateScope, elementControllers={}, transcludeFn;attrs = compileNode === linkNode?templateAttrs:shallowCopy(templateAttrs, new Attributes(jqLite(linkNode), templateAttrs.$attr));$element = attrs.$$element;if(newIsolateScopeDirective){var LOCAL_REGEXP=/^\s*([@=&])(\??)\s*(\w*)\s*$/;isolateScope = scope.$new(true);if(templateDirective && (templateDirective === newIsolateScopeDirective || templateDirective === newIsolateScopeDirective.$$originalDirective)){$element.data("$isolateScope", isolateScope);}else {$element.data("$isolateScopeNoTemplate", isolateScope);}safeAddClass($element, "ng-isolate-scope");forEach(newIsolateScopeDirective.scope, function(definition, scopeName){var match=definition.match(LOCAL_REGEXP) || [], attrName=match[3] || scopeName, optional=match[2] == "?", mode=match[1], lastValue, parentGet, parentSet, compare;isolateScope.$$isolateBindings[scopeName] = mode + attrName;switch(mode){case "@":attrs.$observe(attrName, function(value){isolateScope[scopeName] = value;});attrs.$$observers[attrName].$$scope = scope;if(attrs[attrName]){isolateScope[scopeName] = $interpolate(attrs[attrName])(scope);}break;case "=":if(optional && !attrs[attrName]){return;}parentGet = $parse(attrs[attrName]);if(parentGet.literal){compare = equals;}else {compare = function(a, b){return a === b || a !== a && b !== b;};}parentSet = parentGet.assign || function(){lastValue = isolateScope[scopeName] = parentGet(scope);throw $compileMinErr("nonassign", "Expression '{0}' used with directive '{1}' is non-assignable!", attrs[attrName], newIsolateScopeDirective.name);};lastValue = isolateScope[scopeName] = parentGet(scope);isolateScope.$watch(function parentValueWatch(){var parentValue=parentGet(scope);if(!compare(parentValue, isolateScope[scopeName])){if(!compare(parentValue, lastValue)){isolateScope[scopeName] = parentValue;}else {parentSet(scope, parentValue = isolateScope[scopeName]);}}return lastValue = parentValue;}, null, parentGet.literal);break;case "&":parentGet = $parse(attrs[attrName]);isolateScope[scopeName] = function(locals){return parentGet(scope, locals);};break;default:throw $compileMinErr("iscp", "Invalid isolate scope definition for directive '{0}'." + " Definition: {... {1}: '{2}' ...}", newIsolateScopeDirective.name, scopeName, definition);}});}transcludeFn = boundTranscludeFn && controllersBoundTransclude;if(controllerDirectives){forEach(controllerDirectives, function(directive){var locals={$scope:directive === newIsolateScopeDirective || directive.$$isolateScope?isolateScope:scope, $element:$element, $attrs:attrs, $transclude:transcludeFn}, controllerInstance;controller = directive.controller;if(controller == "@"){controller = attrs[directive.name];}controllerInstance = $controller(controller, locals);elementControllers[directive.name] = controllerInstance;if(!hasElementTranscludeDirective){$element.data("$" + directive.name + "Controller", controllerInstance);}if(directive.controllerAs){locals.$scope[directive.controllerAs] = controllerInstance;}});}for(i = 0, ii = preLinkFns.length; i < ii; i++) {try{linkFn = preLinkFns[i];linkFn(linkFn.isolateScope?isolateScope:scope, $element, attrs, linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers), transcludeFn);}catch(e) {$exceptionHandler(e, startingTag($element));}}var scopeToChild=scope;if(newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)){scopeToChild = isolateScope;}childLinkFn && childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);for(i = postLinkFns.length - 1; i >= 0; i--) {try{linkFn = postLinkFns[i];linkFn(linkFn.isolateScope?isolateScope:scope, $element, attrs, linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers), transcludeFn);}catch(e) {$exceptionHandler(e, startingTag($element));}}function controllersBoundTransclude(scope, cloneAttachFn){var transcludeControllers;if(arguments.length < 2){cloneAttachFn = scope;scope = undefined;}if(hasElementTranscludeDirective){transcludeControllers = elementControllers;}return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers);}}}function markDirectivesAsIsolate(directives){for(var j=0, jj=directives.length; j < jj; j++) {directives[j] = inherit(directives[j], {$$isolateScope:true});}}function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName, endAttrName){if(name === ignoreDirective){return null;}var match=null;if(hasDirectives.hasOwnProperty(name)){for(var directive, directives=$injector.get(name + Suffix), i=0, ii=directives.length; i < ii; i++) {try{directive = directives[i];if((maxPriority === undefined || maxPriority > directive.priority) && directive.restrict.indexOf(location) != -1){if(startAttrName){directive = inherit(directive, {$$start:startAttrName, $$end:endAttrName});}tDirectives.push(directive);match = directive;}}catch(e) {$exceptionHandler(e);}}}return match;}function mergeTemplateAttributes(dst, src){var srcAttr=src.$attr, dstAttr=dst.$attr, $element=dst.$$element;forEach(dst, function(value, key){if(key.charAt(0) != "$"){if(src[key] && src[key] !== value){value += (key === "style"?";":" ") + src[key];}dst.$set(key, value, true, srcAttr[key]);}});forEach(src, function(value, key){if(key == "class"){safeAddClass($element, value);dst["class"] = (dst["class"]?dst["class"] + " ":"") + value;}else if(key == "style"){$element.attr("style", $element.attr("style") + ";" + value);dst.style = (dst.style?dst.style + ";":"") + value;}else if(key.charAt(0) != "$" && !dst.hasOwnProperty(key)){dst[key] = value;dstAttr[key] = srcAttr[key];}});}function compileTemplateUrl(directives, $compileNode, tAttrs, $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext){var linkQueue=[], afterTemplateNodeLinkFn, afterTemplateChildLinkFn, beforeTemplateCompileNode=$compileNode[0], origAsyncDirective=directives.shift(), derivedSyncDirective=extend({}, origAsyncDirective, {templateUrl:null, transclude:null, replace:null, $$originalDirective:origAsyncDirective}), templateUrl=isFunction(origAsyncDirective.templateUrl)?origAsyncDirective.templateUrl($compileNode, tAttrs):origAsyncDirective.templateUrl;$compileNode.empty();$http.get($sce.getTrustedResourceUrl(templateUrl), {cache:$templateCache}).success(function(content){var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;content = denormalizeTemplate(content);if(origAsyncDirective.replace){if(jqLiteIsTextNode(content)){$template = [];}else {$template = jqLite(trim(content));}compileNode = $template[0];if($template.length != 1 || compileNode.nodeType !== 1){throw $compileMinErr("tplrt", "Template for directive '{0}' must have exactly one root element. {1}", origAsyncDirective.name, templateUrl);}tempTemplateAttrs = {$attr:{}};replaceWith($rootElement, $compileNode, compileNode);var templateDirectives=collectDirectives(compileNode, [], tempTemplateAttrs);if(isObject(origAsyncDirective.scope)){markDirectivesAsIsolate(templateDirectives);}directives = templateDirectives.concat(directives);mergeTemplateAttributes(tAttrs, tempTemplateAttrs);}else {compileNode = beforeTemplateCompileNode;$compileNode.html(content);}directives.unshift(derivedSyncDirective);afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs, childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns, previousCompileContext);forEach($rootElement, function(node, i){if(node == compileNode){$rootElement[i] = $compileNode[0];}});afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);while(linkQueue.length) {var scope=linkQueue.shift(), beforeTemplateLinkNode=linkQueue.shift(), linkRootElement=linkQueue.shift(), boundTranscludeFn=linkQueue.shift(), linkNode=$compileNode[0];if(beforeTemplateLinkNode !== beforeTemplateCompileNode){var oldClasses=beforeTemplateLinkNode.className;if(!(previousCompileContext.hasElementTranscludeDirective && origAsyncDirective.replace)){linkNode = jqLiteClone(compileNode);}replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);safeAddClass(jqLite(linkNode), oldClasses);}if(afterTemplateNodeLinkFn.transcludeOnThisElement){childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);}else {childBoundTranscludeFn = boundTranscludeFn;}afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement, childBoundTranscludeFn);}linkQueue = null;}).error(function(response, code, headers, config){throw $compileMinErr("tpload", "Failed to load template: {0}", config.url);});return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn){var childBoundTranscludeFn=boundTranscludeFn;if(linkQueue){linkQueue.push(scope);linkQueue.push(node);linkQueue.push(rootElement);linkQueue.push(childBoundTranscludeFn);}else {if(afterTemplateNodeLinkFn.transcludeOnThisElement){childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);}afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);}};}function byPriority(a, b){var diff=b.priority - a.priority;if(diff !== 0){return diff;}if(a.name !== b.name){return a.name < b.name?-1:1;}return a.index - b.index;}function assertNoDuplicate(what, previousDirective, directive, element){if(previousDirective){throw $compileMinErr("multidir", "Multiple directives [{0}, {1}] asking for {2} on: {3}", previousDirective.name, directive.name, what, startingTag(element));}}function addTextInterpolateDirective(directives, text){var interpolateFn=$interpolate(text, true);if(interpolateFn){directives.push({priority:0, compile:function textInterpolateCompileFn(templateNode){var parent=templateNode.parent(), hasCompileParent=parent.length;if(hasCompileParent)safeAddClass(templateNode.parent(), "ng-binding");return function textInterpolateLinkFn(scope, node){var parent=node.parent(), bindings=parent.data("$binding") || [];bindings.push(interpolateFn);parent.data("$binding", bindings);if(!hasCompileParent)safeAddClass(parent, "ng-binding");scope.$watch(interpolateFn, function interpolateFnWatchAction(value){node[0].nodeValue = value;});};}});}}function getTrustedContext(node, attrNormalizedName){if(attrNormalizedName == "srcdoc"){return $sce.HTML;}var tag=nodeName_(node);if(attrNormalizedName == "xlinkHref" || tag == "FORM" && attrNormalizedName == "action" || tag == "LINK" && attrNormalizedName == "href" || tag != "IMG" && (attrNormalizedName == "src" || attrNormalizedName == "ngSrc")){return $sce.RESOURCE_URL;}}function addAttrInterpolateDirective(node, directives, value, name){var interpolateFn=$interpolate(value, true);if(!interpolateFn){return;}if(name === "multiple" && nodeName_(node) === "SELECT"){throw $compileMinErr("selmulti", "Binding to the 'multiple' attribute is not supported. Element: {0}", startingTag(node));}directives.push({priority:100, compile:function compile(){return {pre:function attrInterpolatePreLinkFn(scope, element, attr){var $$observers=attr.$$observers || (attr.$$observers = {});if(EVENT_HANDLER_ATTR_REGEXP.test(name)){throw $compileMinErr("nodomevents", "Interpolations for HTML DOM event attributes are disallowed.  Please use the " + "ng- versions (such as ng-click instead of onclick) instead.");}interpolateFn = $interpolate(attr[name], true, getTrustedContext(node, name));if(!interpolateFn){return;}attr[name] = interpolateFn(scope);($$observers[name] || ($$observers[name] = [])).$$inter = true;(attr.$$observers && attr.$$observers[name].$$scope || scope).$watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue){if(name === "class" && newValue != oldValue){attr.$updateClass(newValue, oldValue);}else {attr.$set(name, newValue);}});}};}});}function replaceWith($rootElement, elementsToRemove, newNode){var firstElementToRemove=elementsToRemove[0], removeCount=elementsToRemove.length, parent=firstElementToRemove.parentNode, i, ii;if($rootElement){for(i = 0, ii = $rootElement.length; i < ii; i++) {if($rootElement[i] == firstElementToRemove){$rootElement[i++] = newNode;for(var j=i, j2=j + removeCount - 1, jj=$rootElement.length; j < jj; j++, j2++) {if(j2 < jj){$rootElement[j] = $rootElement[j2];}else {delete $rootElement[j];}}$rootElement.length -= removeCount - 1;break;}}}if(parent){parent.replaceChild(newNode, firstElementToRemove);}var fragment=document.createDocumentFragment();fragment.appendChild(firstElementToRemove);newNode[jqLite.expando] = firstElementToRemove[jqLite.expando];for(var k=1, kk=elementsToRemove.length; k < kk; k++) {var element=elementsToRemove[k];jqLite(element).remove();fragment.appendChild(element);delete elementsToRemove[k];}elementsToRemove[0] = newNode;elementsToRemove.length = 1;}function cloneAndAnnotateFn(fn, annotation){return extend(function(){return fn.apply(null, arguments);}, fn, annotation);}}];}var PREFIX_REGEXP=/^(x[\:\-_]|data[\:\-_])/i;function directiveNormalize(name){return camelCase(name.replace(PREFIX_REGEXP, ""));}function nodesetLinkingFn(scope, nodeList, rootElement, boundTranscludeFn){}function directiveLinkingFn(nodesetLinkingFn, scope, node, rootElement, boundTranscludeFn){}function tokenDifference(str1, str2){var values="", tokens1=str1.split(/\s+/), tokens2=str2.split(/\s+/);outer: for(var i=0; i < tokens1.length; i++) {var token=tokens1[i];for(var j=0; j < tokens2.length; j++) {if(token == tokens2[j])continue outer;}values += (values.length > 0?" ":"") + token;}return values;}function $ControllerProvider(){var controllers={}, CNTRL_REG=/^(\S+)(\s+as\s+(\w+))?$/;this.register = function(name, constructor){assertNotHasOwnProperty(name, "controller");if(isObject(name)){extend(controllers, name);}else {controllers[name] = constructor;}};this.$get = ["$injector", "$window", function($injector, $window){return function(expression, locals){var instance, match, constructor, identifier;if(isString(expression)){match = expression.match(CNTRL_REG), constructor = match[1], identifier = match[3];expression = controllers.hasOwnProperty(constructor)?controllers[constructor]:getter(locals.$scope, constructor, true) || getter($window, constructor, true);assertArgFn(expression, constructor, true);}instance = $injector.instantiate(expression, locals);if(identifier){if(!(locals && typeof locals.$scope === "object")){throw minErr("$controller")("noscp", "Cannot export controller '{0}' as '{1}'! No $scope object provided via `locals`.", constructor || expression.name, identifier);}locals.$scope[identifier] = instance;}return instance;};}];}function $DocumentProvider(){this.$get = ["$window", function(window){return jqLite(window.document);}];}function $ExceptionHandlerProvider(){this.$get = ["$log", function($log){return function(exception, cause){$log.error.apply($log, arguments);};}];}function parseHeaders(headers){var parsed={}, key, val, i;if(!headers){return parsed;}forEach(headers.split("\n"), function(line){i = line.indexOf(":");key = lowercase(trim(line.substr(0, i)));val = trim(line.substr(i + 1));if(key){parsed[key] = parsed[key]?parsed[key] + ", " + val:val;}});return parsed;}function headersGetter(headers){var headersObj=isObject(headers)?headers:undefined;return function(name){if(!headersObj)headersObj = parseHeaders(headers);if(name){return headersObj[lowercase(name)] || null;}return headersObj;};}function transformData(data, headers, fns){if(isFunction(fns)){return fns(data, headers);}forEach(fns, function(fn){data = fn(data, headers);});return data;}function isSuccess(status){return 200 <= status && status < 300;}function $HttpProvider(){var JSON_START=/^\s*(\[|\{[^\{])/, JSON_END=/[\}\]]\s*$/, PROTECTION_PREFIX=/^\)\]\}',?\n/, CONTENT_TYPE_APPLICATION_JSON={"Content-Type":"application/json;charset=utf-8"};var defaults=this.defaults = {transformResponse:[function(data){if(isString(data)){data = data.replace(PROTECTION_PREFIX, "");if(JSON_START.test(data) && JSON_END.test(data))data = fromJson(data);}return data;}], transformRequest:[function(d){return isObject(d) && !isFile(d) && !isBlob(d)?toJson(d):d;}], headers:{common:{Accept:"application/json, text/plain, */*"}, post:shallowCopy(CONTENT_TYPE_APPLICATION_JSON), put:shallowCopy(CONTENT_TYPE_APPLICATION_JSON), patch:shallowCopy(CONTENT_TYPE_APPLICATION_JSON)}, xsrfCookieName:"XSRF-TOKEN", xsrfHeaderName:"X-XSRF-TOKEN"};var interceptorFactories=this.interceptors = [];var responseInterceptorFactories=this.responseInterceptors = [];this.$get = ["$httpBackend", "$browser", "$cacheFactory", "$rootScope", "$q", "$injector", function($httpBackend, $browser, $cacheFactory, $rootScope, $q, $injector){var defaultCache=$cacheFactory("$http");var reversedInterceptors=[];forEach(interceptorFactories, function(interceptorFactory){reversedInterceptors.unshift(isString(interceptorFactory)?$injector.get(interceptorFactory):$injector.invoke(interceptorFactory));});forEach(responseInterceptorFactories, function(interceptorFactory, index){var responseFn=isString(interceptorFactory)?$injector.get(interceptorFactory):$injector.invoke(interceptorFactory);reversedInterceptors.splice(index, 0, {response:(function(_response){var _responseWrapper=function response(_x){return _response.apply(this, arguments);};_responseWrapper.toString = function(){return _response.toString();};return _responseWrapper;})(function(response){return responseFn($q.when(response));}), responseError:function responseError(response){return responseFn($q.reject(response));}});});function $http(requestConfig){var config={method:"get", transformRequest:defaults.transformRequest, transformResponse:defaults.transformResponse};var headers=mergeHeaders(requestConfig);extend(config, requestConfig);config.headers = headers;config.method = uppercase(config.method);var serverRequest=function serverRequest(config){headers = config.headers;var reqData=transformData(config.data, headersGetter(headers), config.transformRequest);if(isUndefined(reqData)){forEach(headers, function(value, header){if(lowercase(header) === "content-type"){delete headers[header];}});}if(isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)){config.withCredentials = defaults.withCredentials;}return sendReq(config, reqData, headers).then(transformResponse, transformResponse);};var chain=[serverRequest, undefined];var promise=$q.when(config);forEach(reversedInterceptors, function(interceptor){if(interceptor.request || interceptor.requestError){chain.unshift(interceptor.request, interceptor.requestError);}if(interceptor.response || interceptor.responseError){chain.push(interceptor.response, interceptor.responseError);}});while(chain.length) {var thenFn=chain.shift();var rejectFn=chain.shift();promise = promise.then(thenFn, rejectFn);}promise.success = function(fn){promise.then(function(response){fn(response.data, response.status, response.headers, config);});return promise;};promise.error = function(fn){promise.then(null, function(response){fn(response.data, response.status, response.headers, config);});return promise;};return promise;function transformResponse(response){var resp=extend({}, response, {data:transformData(response.data, response.headers, config.transformResponse)});return isSuccess(response.status)?resp:$q.reject(resp);}function mergeHeaders(config){var defHeaders=defaults.headers, reqHeaders=extend({}, config.headers), defHeaderName, lowercaseDefHeaderName, reqHeaderName;defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);defaultHeadersIteration: for(defHeaderName in defHeaders) {lowercaseDefHeaderName = lowercase(defHeaderName);for(reqHeaderName in reqHeaders) {if(lowercase(reqHeaderName) === lowercaseDefHeaderName){continue defaultHeadersIteration;}}reqHeaders[defHeaderName] = defHeaders[defHeaderName];}execHeaders(reqHeaders);return reqHeaders;function execHeaders(headers){var headerContent;forEach(headers, function(headerFn, header){if(isFunction(headerFn)){headerContent = headerFn();if(headerContent != null){headers[header] = headerContent;}else {delete headers[header];}}});}}}$http.pendingRequests = [];createShortMethods("get", "delete", "head", "jsonp");createShortMethodsWithData("post", "put", "patch");$http.defaults = defaults;return $http;function createShortMethods(names){forEach(arguments, function(name){$http[name] = function(url, config){return $http(extend(config || {}, {method:name, url:url}));};});}function createShortMethodsWithData(name){forEach(arguments, function(name){$http[name] = function(url, data, config){return $http(extend(config || {}, {method:name, url:url, data:data}));};});}function sendReq(config, reqData, reqHeaders){var deferred=$q.defer(), promise=deferred.promise, cache, cachedResp, url=buildUrl(config.url, config.params);$http.pendingRequests.push(config);promise.then(removePendingReq, removePendingReq);if((config.cache || defaults.cache) && config.cache !== false && (config.method === "GET" || config.method === "JSONP")){cache = isObject(config.cache)?config.cache:isObject(defaults.cache)?defaults.cache:defaultCache;}if(cache){cachedResp = cache.get(url);if(isDefined(cachedResp)){if(isPromiseLike(cachedResp)){cachedResp.then(removePendingReq, removePendingReq);return cachedResp;}else {if(isArray(cachedResp)){resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3]);}else {resolvePromise(cachedResp, 200, {}, "OK");}}}else {cache.put(url, promise);}}if(isUndefined(cachedResp)){var xsrfValue=urlIsSameOrigin(config.url)?$browser.cookies()[config.xsrfCookieName || defaults.xsrfCookieName]:undefined;if(xsrfValue){reqHeaders[config.xsrfHeaderName || defaults.xsrfHeaderName] = xsrfValue;}$httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout, config.withCredentials, config.responseType);}return promise;function done(status, response, headersString, statusText){if(cache){if(isSuccess(status)){cache.put(url, [status, response, parseHeaders(headersString), statusText]);}else {cache.remove(url);}}resolvePromise(response, status, headersString, statusText);if(!$rootScope.$$phase)$rootScope.$apply();}function resolvePromise(response, status, headers, statusText){status = Math.max(status, 0);(isSuccess(status)?deferred.resolve:deferred.reject)({data:response, status:status, headers:headersGetter(headers), config:config, statusText:statusText});}function removePendingReq(){var idx=indexOf($http.pendingRequests, config);if(idx !== -1)$http.pendingRequests.splice(idx, 1);}}function buildUrl(url, params){if(!params){return url;}var parts=[];forEachSorted(params, function(value, key){if(value === null || isUndefined(value))return;if(!isArray(value))value = [value];forEach(value, function(v){if(isObject(v)){if(isDate(v)){v = v.toISOString();}else {v = toJson(v);}}parts.push(encodeUriQuery(key) + "=" + encodeUriQuery(v));});});if(parts.length > 0){url += (url.indexOf("?") == -1?"?":"&") + parts.join("&");}return url;}}];}function createXhr(method){if(msie <= 8 && (!method.match(/^(get|post|head|put|delete|options)$/i) || !window.XMLHttpRequest)){return new window.ActiveXObject("Microsoft.XMLHTTP");}else if(window.XMLHttpRequest){return new window.XMLHttpRequest();}throw minErr("$httpBackend")("noxhr", "This browser does not support XMLHttpRequest.");}function $HttpBackendProvider(){this.$get = ["$browser", "$window", "$document", function($browser, $window, $document){return createHttpBackend($browser, createXhr, $browser.defer, $window.angular.callbacks, $document[0]);}];}function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument){var ABORTED=-1;return function(method, url, post, callback, headers, timeout, withCredentials, responseType){var status;$browser.$$incOutstandingRequestCount();url = url || $browser.url();if(lowercase(method) == "jsonp"){var callbackId="_" + (callbacks.counter++).toString(36);callbacks[callbackId] = function(data){callbacks[callbackId].data = data;callbacks[callbackId].called = true;};var jsonpDone=jsonpReq(url.replace("JSON_CALLBACK", "angular.callbacks." + callbackId), callbackId, function(status, text){completeRequest(callback, status, callbacks[callbackId].data, "", text);callbacks[callbackId] = noop;});}else {var xhr=createXhr(method);xhr.open(method, url, true);forEach(headers, function(value, key){if(isDefined(value)){xhr.setRequestHeader(key, value);}});xhr.onreadystatechange = function(){if(xhr && xhr.readyState == 4){var responseHeaders=null, response=null, statusText="";if(status !== ABORTED){responseHeaders = xhr.getAllResponseHeaders();response = "response" in xhr?xhr.response:xhr.responseText;}if(!(status === ABORTED && msie < 10)){statusText = xhr.statusText;}completeRequest(callback, status || xhr.status, response, responseHeaders, statusText);}};if(withCredentials){xhr.withCredentials = true;}if(responseType){try{xhr.responseType = responseType;}catch(e) {if(responseType !== "json"){throw e;}}}xhr.send(post || null);}if(timeout > 0){var timeoutId=$browserDefer(timeoutRequest, timeout);}else if(isPromiseLike(timeout)){timeout.then(timeoutRequest);}function timeoutRequest(){status = ABORTED;jsonpDone && jsonpDone();xhr && xhr.abort();}function completeRequest(callback, status, response, headersString, statusText){timeoutId && $browserDefer.cancel(timeoutId);jsonpDone = xhr = null;if(status === 0){status = response?200:urlResolve(url).protocol == "file"?404:0;}status = status === 1223?204:status;statusText = statusText || "";callback(status, response, headersString, statusText);$browser.$$completeOutstandingRequest(noop);}};function jsonpReq(url, callbackId, done){var script=rawDocument.createElement("script"), callback=null;script.type = "text/javascript";script.src = url;script.async = true;callback = function(event){removeEventListenerFn(script, "load", callback);removeEventListenerFn(script, "error", callback);rawDocument.body.removeChild(script);script = null;var status=-1;var text="unknown";if(event){if(event.type === "load" && !callbacks[callbackId].called){event = {type:"error"};}text = event.type;status = event.type === "error"?404:200;}if(done){done(status, text);}};addEventListenerFn(script, "load", callback);addEventListenerFn(script, "error", callback);if(msie <= 8){script.onreadystatechange = function(){if(isString(script.readyState) && /loaded|complete/.test(script.readyState)){script.onreadystatechange = null;callback({type:"load"});}};}rawDocument.body.appendChild(script);return callback;}}var $interpolateMinErr=minErr("$interpolate");function $InterpolateProvider(){var startSymbol="{{";var endSymbol="}}";this.startSymbol = function(value){if(value){startSymbol = value;return this;}else {return startSymbol;}};this.endSymbol = function(value){if(value){endSymbol = value;return this;}else {return endSymbol;}};this.$get = ["$parse", "$exceptionHandler", "$sce", function($parse, $exceptionHandler, $sce){var startSymbolLength=startSymbol.length, endSymbolLength=endSymbol.length;function $interpolate(text, mustHaveExpression, trustedContext){var startIndex, endIndex, index=0, parts=[], length=text.length, hasInterpolation=false, fn, exp, concat=[];while(index < length) {if((startIndex = text.indexOf(startSymbol, index)) != -1 && (endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) != -1){index != startIndex && parts.push(text.substring(index, startIndex));parts.push(fn = $parse(exp = text.substring(startIndex + startSymbolLength, endIndex)));fn.exp = exp;index = endIndex + endSymbolLength;hasInterpolation = true;}else {index != length && parts.push(text.substring(index));index = length;}}if(!(length = parts.length)){parts.push("");length = 1;}if(trustedContext && parts.length > 1){throw $interpolateMinErr("noconcat", "Error while interpolating: {0}\nStrict Contextual Escaping disallows " + "interpolations that concatenate multiple expressions when a trusted value is " + "required.  See http://docs.angularjs.org/api/ng.$sce", text);}if(!mustHaveExpression || hasInterpolation){concat.length = length;fn = function(context){try{for(var i=0, ii=length, part; i < ii; i++) {if(typeof (part = parts[i]) == "function"){part = part(context);if(trustedContext){part = $sce.getTrusted(trustedContext, part);}else {part = $sce.valueOf(part);}if(part == null){part = "";}else {switch(typeof part){case "string":{break;}case "number":{part = "" + part;break;}default:{part = toJson(part);}}}}concat[i] = part;}return concat.join("");}catch(err) {var newErr=$interpolateMinErr("interr", "Can't interpolate: {0}\n{1}", text, err.toString());$exceptionHandler(newErr);}};fn.exp = text;fn.parts = parts;return fn;}}$interpolate.startSymbol = function(){return startSymbol;};$interpolate.endSymbol = function(){return endSymbol;};return $interpolate;}];}function $IntervalProvider(){this.$get = ["$rootScope", "$window", "$q", function($rootScope, $window, $q){var intervals={};function interval(fn, delay, count, invokeApply){var setInterval=$window.setInterval, clearInterval=$window.clearInterval, deferred=$q.defer(), promise=deferred.promise, iteration=0, skipApply=isDefined(invokeApply) && !invokeApply;count = isDefined(count)?count:0;promise.then(null, null, fn);promise.$$intervalId = setInterval(function tick(){deferred.notify(iteration++);if(count > 0 && iteration >= count){deferred.resolve(iteration);clearInterval(promise.$$intervalId);delete intervals[promise.$$intervalId];}if(!skipApply)$rootScope.$apply();}, delay);intervals[promise.$$intervalId] = deferred;return promise;}interval.cancel = function(promise){if(promise && promise.$$intervalId in intervals){intervals[promise.$$intervalId].reject("canceled");$window.clearInterval(promise.$$intervalId);delete intervals[promise.$$intervalId];return true;}return false;};return interval;}];}function $LocaleProvider(){this.$get = function(){return {id:"en-us", NUMBER_FORMATS:{DECIMAL_SEP:".", GROUP_SEP:",", PATTERNS:[{minInt:1, minFrac:0, maxFrac:3, posPre:"", posSuf:"", negPre:"-", negSuf:"", gSize:3, lgSize:3}, {minInt:1, minFrac:2, maxFrac:2, posPre:"¤", posSuf:"", negPre:"(¤", negSuf:")", gSize:3, lgSize:3}], CURRENCY_SYM:"$"}, DATETIME_FORMATS:{MONTH:"January,February,March,April,May,June,July,August,September,October,November,December".split(","), SHORTMONTH:"Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec".split(","), DAY:"Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday".split(","), SHORTDAY:"Sun,Mon,Tue,Wed,Thu,Fri,Sat".split(","), AMPMS:["AM", "PM"], medium:"MMM d, y h:mm:ss a", short:"M/d/yy h:mm a", fullDate:"EEEE, MMMM d, y", longDate:"MMMM d, y", mediumDate:"MMM d, y", shortDate:"M/d/yy", mediumTime:"h:mm:ss a", shortTime:"h:mm a"}, pluralCat:function pluralCat(num){if(num === 1){return "one";}return "other";}};};}var PATH_MATCH=/^([^\?#]*)(\?([^#]*))?(#(.*))?$/, DEFAULT_PORTS={http:80, https:443, ftp:21};var $locationMinErr=minErr("$location");function encodePath(path){var segments=path.split("/"), i=segments.length;while(i--) {segments[i] = encodeUriSegment(segments[i]);}return segments.join("/");}function parseAbsoluteUrl(absoluteUrl, locationObj, appBase){var parsedUrl=urlResolve(absoluteUrl, appBase);locationObj.$$protocol = parsedUrl.protocol;locationObj.$$host = parsedUrl.hostname;locationObj.$$port = int(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;}function parseAppUrl(relativeUrl, locationObj, appBase){var prefixed=relativeUrl.charAt(0) !== "/";if(prefixed){relativeUrl = "/" + relativeUrl;}var match=urlResolve(relativeUrl, appBase);locationObj.$$path = decodeURIComponent(prefixed && match.pathname.charAt(0) === "/"?match.pathname.substring(1):match.pathname);locationObj.$$search = parseKeyValue(match.search);locationObj.$$hash = decodeURIComponent(match.hash);if(locationObj.$$path && locationObj.$$path.charAt(0) != "/"){locationObj.$$path = "/" + locationObj.$$path;}}function beginsWith(begin, whole){if(whole.indexOf(begin) === 0){return whole.substr(begin.length);}}function stripHash(url){var index=url.indexOf("#");return index == -1?url:url.substr(0, index);}function trimEmptyHash(url){return url.replace(/(#.+)|#$/, "$1");}function stripFile(url){return url.substr(0, stripHash(url).lastIndexOf("/") + 1);}function serverBase(url){return url.substring(0, url.indexOf("/", url.indexOf("//") + 2));}function LocationHtml5Url(appBase, basePrefix){this.$$html5 = true;basePrefix = basePrefix || "";var appBaseNoFile=stripFile(appBase);parseAbsoluteUrl(appBase, this, appBase);this.$$parse = function(url){var pathUrl=beginsWith(appBaseNoFile, url);if(!isString(pathUrl)){throw $locationMinErr("ipthprfx", "Invalid url \"{0}\", missing path prefix \"{1}\".", url, appBaseNoFile);}parseAppUrl(pathUrl, this, appBase);if(!this.$$path){this.$$path = "/";}this.$$compose();};this.$$compose = function(){var search=toKeyValue(this.$$search), hash=this.$$hash?"#" + encodeUriSegment(this.$$hash):"";this.$$url = encodePath(this.$$path) + (search?"?" + search:"") + hash;this.$$absUrl = appBaseNoFile + this.$$url.substr(1);};this.$$parseLinkUrl = function(url, relHref){var appUrl, prevAppUrl;var rewrittenUrl;if((appUrl = beginsWith(appBase, url)) !== undefined){prevAppUrl = appUrl;if((appUrl = beginsWith(basePrefix, appUrl)) !== undefined){rewrittenUrl = appBaseNoFile + (beginsWith("/", appUrl) || appUrl);}else {rewrittenUrl = appBase + prevAppUrl;}}else if((appUrl = beginsWith(appBaseNoFile, url)) !== undefined){rewrittenUrl = appBaseNoFile + appUrl;}else if(appBaseNoFile == url + "/"){rewrittenUrl = appBaseNoFile;}if(rewrittenUrl){this.$$parse(rewrittenUrl);}return !!rewrittenUrl;};}function LocationHashbangUrl(appBase, hashPrefix){var appBaseNoFile=stripFile(appBase);parseAbsoluteUrl(appBase, this, appBase);this.$$parse = function(url){var withoutBaseUrl=beginsWith(appBase, url) || beginsWith(appBaseNoFile, url);var withoutHashUrl=withoutBaseUrl.charAt(0) == "#"?beginsWith(hashPrefix, withoutBaseUrl):this.$$html5?withoutBaseUrl:"";if(!isString(withoutHashUrl)){throw $locationMinErr("ihshprfx", "Invalid url \"{0}\", missing hash prefix \"{1}\".", url, hashPrefix);}parseAppUrl(withoutHashUrl, this, appBase);this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);this.$$compose();function removeWindowsDriveName(path, url, base){var windowsFilePathExp=/^\/[A-Z]:(\/.*)/;var firstPathSegmentMatch;if(url.indexOf(base) === 0){url = url.replace(base, "");}if(windowsFilePathExp.exec(url)){return path;}firstPathSegmentMatch = windowsFilePathExp.exec(path);return firstPathSegmentMatch?firstPathSegmentMatch[1]:path;}};this.$$compose = function(){var search=toKeyValue(this.$$search), hash=this.$$hash?"#" + encodeUriSegment(this.$$hash):"";this.$$url = encodePath(this.$$path) + (search?"?" + search:"") + hash;this.$$absUrl = appBase + (this.$$url?hashPrefix + this.$$url:"");};this.$$parseLinkUrl = function(url, relHref){if(stripHash(appBase) == stripHash(url)){this.$$parse(url);return true;}return false;};}function LocationHashbangInHtml5Url(appBase, hashPrefix){this.$$html5 = true;LocationHashbangUrl.apply(this, arguments);var appBaseNoFile=stripFile(appBase);this.$$parseLinkUrl = function(url, relHref){var rewrittenUrl;var appUrl;if(appBase == stripHash(url)){rewrittenUrl = url;}else if(appUrl = beginsWith(appBaseNoFile, url)){rewrittenUrl = appBase + hashPrefix + appUrl;}else if(appBaseNoFile === url + "/"){rewrittenUrl = appBaseNoFile;}if(rewrittenUrl){this.$$parse(rewrittenUrl);}return !!rewrittenUrl;};this.$$compose = function(){var search=toKeyValue(this.$$search), hash=this.$$hash?"#" + encodeUriSegment(this.$$hash):"";this.$$url = encodePath(this.$$path) + (search?"?" + search:"") + hash;this.$$absUrl = appBase + hashPrefix + this.$$url;};}LocationHashbangInHtml5Url.prototype = LocationHashbangUrl.prototype = LocationHtml5Url.prototype = {$$html5:false, $$replace:false, absUrl:locationGetter("$$absUrl"), url:(function(_url){var _urlWrapper=function url(_x){return _url.apply(this, arguments);};_urlWrapper.toString = function(){return _url.toString();};return _urlWrapper;})(function(url){if(isUndefined(url))return this.$$url;var match=PATH_MATCH.exec(url);if(match[1])this.path(decodeURIComponent(match[1]));if(match[2] || match[1])this.search(match[3] || "");this.hash(match[5] || "");return this;}), protocol:locationGetter("$$protocol"), host:locationGetter("$$host"), port:locationGetter("$$port"), path:locationGetterSetter("$$path", function(path){path = path !== null?path.toString():"";return path.charAt(0) == "/"?path:"/" + path;}), search:(function(_search){var _searchWrapper=function search(_x, _x2){return _search.apply(this, arguments);};_searchWrapper.toString = function(){return _search.toString();};return _searchWrapper;})(function(search, paramValue){switch(arguments.length){case 0:return this.$$search;case 1:if(isString(search) || isNumber(search)){search = search.toString();this.$$search = parseKeyValue(search);}else if(isObject(search)){forEach(search, function(value, key){if(value == null)delete search[key];});this.$$search = search;}else {throw $locationMinErr("isrcharg", "The first argument of the `$location#search()` call must be a string or an object.");}break;default:if(isUndefined(paramValue) || paramValue === null){delete this.$$search[search];}else {this.$$search[search] = paramValue;}}this.$$compose();return this;}), hash:locationGetterSetter("$$hash", function(hash){return hash !== null?hash.toString():"";}), replace:function replace(){this.$$replace = true;return this;}};function locationGetter(property){return function(){return this[property];};}function locationGetterSetter(property, preprocess){return function(value){if(isUndefined(value))return this[property];this[property] = preprocess(value);this.$$compose();return this;};}function $LocationProvider(){var hashPrefix="", html5Mode=false;this.hashPrefix = function(prefix){if(isDefined(prefix)){hashPrefix = prefix;return this;}else {return hashPrefix;}};this.html5Mode = function(mode){if(isDefined(mode)){html5Mode = mode;return this;}else {return html5Mode;}};this.$get = ["$rootScope", "$browser", "$sniffer", "$rootElement", function($rootScope, $browser, $sniffer, $rootElement){var $location, LocationMode, baseHref=$browser.baseHref(), initialUrl=$browser.url(), appBase;if(html5Mode){appBase = serverBase(initialUrl) + (baseHref || "/");LocationMode = $sniffer.history?LocationHtml5Url:LocationHashbangInHtml5Url;}else {appBase = stripHash(initialUrl);LocationMode = LocationHashbangUrl;}$location = new LocationMode(appBase, "#" + hashPrefix);$location.$$parseLinkUrl(initialUrl, initialUrl);var IGNORE_URI_REGEXP=/^\s*(javascript|mailto):/i;$rootElement.on("click", function(event){if(event.ctrlKey || event.metaKey || event.which == 2)return;var elm=jqLite(event.target);while(lowercase(elm[0].nodeName) !== "a") {if(elm[0] === $rootElement[0] || !(elm = elm.parent())[0])return;}var absHref=elm.prop("href");var relHref=elm.attr("href") || elm.attr("xlink:href");if(isObject(absHref) && absHref.toString() === "[object SVGAnimatedString]"){absHref = urlResolve(absHref.animVal).href;}if(IGNORE_URI_REGEXP.test(absHref))return;if(absHref && !elm.attr("target") && !event.isDefaultPrevented()){if($location.$$parseLinkUrl(absHref, relHref)){event.preventDefault();if($location.absUrl() != $browser.url()){$rootScope.$apply();window.angular["ff-684208-preventDefault"] = true;}}}});if($location.absUrl() != initialUrl){$browser.url($location.absUrl(), true);}$browser.onUrlChange(function(newUrl){if($location.absUrl() != newUrl){$rootScope.$evalAsync(function(){var oldUrl=$location.absUrl();$location.$$parse(newUrl);if($rootScope.$broadcast("$locationChangeStart", newUrl, oldUrl).defaultPrevented){$location.$$parse(oldUrl);$browser.url(oldUrl);}else {afterLocationChange(oldUrl);}});if(!$rootScope.$$phase)$rootScope.$digest();}});var changeCounter=0;$rootScope.$watch(function $locationWatch(){var oldUrl=trimEmptyHash($browser.url());var newUrl=trimEmptyHash($location.absUrl());var currentReplace=$location.$$replace;if(!changeCounter || oldUrl != newUrl){changeCounter++;$rootScope.$evalAsync(function(){if($rootScope.$broadcast("$locationChangeStart", $location.absUrl(), oldUrl).defaultPrevented){$location.$$parse(oldUrl);}else {$browser.url($location.absUrl(), currentReplace);afterLocationChange(oldUrl);}});}$location.$$replace = false;return changeCounter;});return $location;function afterLocationChange(oldUrl){$rootScope.$broadcast("$locationChangeSuccess", $location.absUrl(), oldUrl);}}];}function $LogProvider(){var debug=true, self=this;this.debugEnabled = function(flag){if(isDefined(flag)){debug = flag;return this;}else {return debug;}};this.$get = ["$window", function($window){return {log:consoleLog("log"), info:consoleLog("info"), warn:consoleLog("warn"), error:consoleLog("error"), debug:(function(){var fn=consoleLog("debug");return function(){if(debug){fn.apply(self, arguments);}};})()};function formatError(arg){if(arg instanceof Error){if(arg.stack){arg = arg.message && arg.stack.indexOf(arg.message) === -1?"Error: " + arg.message + "\n" + arg.stack:arg.stack;}else if(arg.sourceURL){arg = arg.message + "\n" + arg.sourceURL + ":" + arg.line;}}return arg;}function consoleLog(type){var console=$window.console || {}, logFn=console[type] || console.log || noop, hasApply=false;try{hasApply = !!logFn.apply;}catch(e) {}if(hasApply){return function(){var args=[];forEach(arguments, function(arg){args.push(formatError(arg));});return logFn.apply(console, args);};}return function(arg1, arg2){logFn(arg1, arg2 == null?"":arg2);};}}];}var $parseMinErr=minErr("$parse");var promiseWarningCache={};var promiseWarning;function ensureSafeMemberName(name, fullExpression){if(name === "__defineGetter__" || name === "__defineSetter__" || name === "__lookupGetter__" || name === "__lookupSetter__" || name === "__proto__"){throw $parseMinErr("isecfld", "Attempting to access a disallowed field in Angular expressions! " + "Expression: {0}", fullExpression);}return name;}function getStringValue(name, fullExpression){name = name + "";if(!isString(name)){throw $parseMinErr("iseccst", "Cannot convert object to primitive value! " + "Expression: {0}", fullExpression);}return name;}function ensureSafeObject(obj, fullExpression){if(obj){if(obj.constructor === obj){throw $parseMinErr("isecfn", "Referencing Function in Angular expressions is disallowed! Expression: {0}", fullExpression);}else if(obj.document && obj.location && obj.alert && obj.setInterval){throw $parseMinErr("isecwindow", "Referencing the Window in Angular expressions is disallowed! Expression: {0}", fullExpression);}else if(obj.children && (obj.nodeName || obj.prop && obj.attr && obj.find)){throw $parseMinErr("isecdom", "Referencing DOM nodes in Angular expressions is disallowed! Expression: {0}", fullExpression);}else if(obj === Object){throw $parseMinErr("isecobj", "Referencing Object in Angular expressions is disallowed! Expression: {0}", fullExpression);}}return obj;}var CALL=Function.prototype.call;var APPLY=Function.prototype.apply;var BIND=Function.prototype.bind;function ensureSafeFunction(obj, fullExpression){if(obj){if(obj.constructor === obj){throw $parseMinErr("isecfn", "Referencing Function in Angular expressions is disallowed! Expression: {0}", fullExpression);}else if(obj === CALL || obj === APPLY || BIND && obj === BIND){throw $parseMinErr("isecff", "Referencing call, apply or bind in Angular expressions is disallowed! Expression: {0}", fullExpression);}}}var OPERATORS={"null":function _null(){return null;}, "true":function _true(){return true;}, "false":function _false(){return false;}, undefined:noop, "+":function _(self, locals, a, b){a = a(self, locals);b = b(self, locals);if(isDefined(a)){if(isDefined(b)){return a + b;}return a;}return isDefined(b)?b:undefined;}, "-":function _(self, locals, a, b){a = a(self, locals);b = b(self, locals);return (isDefined(a)?a:0) - (isDefined(b)?b:0);}, "*":function _(self, locals, a, b){return a(self, locals) * b(self, locals);}, "/":function _(self, locals, a, b){return a(self, locals) / b(self, locals);}, "%":function _(self, locals, a, b){return a(self, locals) % b(self, locals);}, "^":function _(self, locals, a, b){return a(self, locals) ^ b(self, locals);}, "=":noop, "===":function _(self, locals, a, b){return a(self, locals) === b(self, locals);}, "!==":function _(self, locals, a, b){return a(self, locals) !== b(self, locals);}, "==":function _(self, locals, a, b){return a(self, locals) == b(self, locals);}, "!=":function _(self, locals, a, b){return a(self, locals) != b(self, locals);}, "<":function _(self, locals, a, b){return a(self, locals) < b(self, locals);}, ">":function _(self, locals, a, b){return a(self, locals) > b(self, locals);}, "<=":function _(self, locals, a, b){return a(self, locals) <= b(self, locals);}, ">=":function _(self, locals, a, b){return a(self, locals) >= b(self, locals);}, "&&":function _(self, locals, a, b){return a(self, locals) && b(self, locals);}, "||":function _(self, locals, a, b){return a(self, locals) || b(self, locals);}, "&":function _(self, locals, a, b){return a(self, locals) & b(self, locals);}, "|":function _(self, locals, a, b){return b(self, locals)(self, locals, a(self, locals));}, "!":function _(self, locals, a){return !a(self, locals);}};var ESCAPE={n:"\n", f:"\f", r:"\r", t:"\t", v:"\u000b", "'":"'", "\"":"\""};var Lexer=function Lexer(options){this.options = options;};Lexer.prototype = {constructor:Lexer, lex:function lex(text){this.text = text;this.index = 0;this.ch = undefined;this.lastCh = ":";this.tokens = [];while(this.index < this.text.length) {this.ch = this.text.charAt(this.index);if(this.is("\"'")){this.readString(this.ch);}else if(this.isNumber(this.ch) || this.is(".") && this.isNumber(this.peek())){this.readNumber();}else if(this.isIdent(this.ch)){this.readIdent();}else if(this.is("(){}[].,;:?")){this.tokens.push({index:this.index, text:this.ch});this.index++;}else if(this.isWhitespace(this.ch)){this.index++;continue;}else {var ch2=this.ch + this.peek();var ch3=ch2 + this.peek(2);var fn=OPERATORS[this.ch];var fn2=OPERATORS[ch2];var fn3=OPERATORS[ch3];if(fn3){this.tokens.push({index:this.index, text:ch3, fn:fn3});this.index += 3;}else if(fn2){this.tokens.push({index:this.index, text:ch2, fn:fn2});this.index += 2;}else if(fn){this.tokens.push({index:this.index, text:this.ch, fn:fn});this.index += 1;}else {this.throwError("Unexpected next character ", this.index, this.index + 1);}}this.lastCh = this.ch;}return this.tokens;}, is:function is(chars){return chars.indexOf(this.ch) !== -1;}, was:function was(chars){return chars.indexOf(this.lastCh) !== -1;}, peek:function peek(i){var num=i || 1;return this.index + num < this.text.length?this.text.charAt(this.index + num):false;}, isNumber:function isNumber(ch){return "0" <= ch && ch <= "9";}, isWhitespace:function isWhitespace(ch){return ch === " " || ch === "\r" || ch === "\t" || ch === "\n" || ch === "\u000b" || ch === " ";}, isIdent:function isIdent(ch){return "a" <= ch && ch <= "z" || "A" <= ch && ch <= "Z" || "_" === ch || ch === "$";}, isExpOperator:function isExpOperator(ch){return ch === "-" || ch === "+" || this.isNumber(ch);}, throwError:function throwError(error, start, end){end = end || this.index;var colStr=isDefined(start)?"s " + start + "-" + this.index + " [" + this.text.substring(start, end) + "]":" " + end;throw $parseMinErr("lexerr", "Lexer Error: {0} at column{1} in expression [{2}].", error, colStr, this.text);}, readNumber:function readNumber(){var number="";var start=this.index;while(this.index < this.text.length) {var ch=lowercase(this.text.charAt(this.index));if(ch == "." || this.isNumber(ch)){number += ch;}else {var peekCh=this.peek();if(ch == "e" && this.isExpOperator(peekCh)){number += ch;}else if(this.isExpOperator(ch) && peekCh && this.isNumber(peekCh) && number.charAt(number.length - 1) == "e"){number += ch;}else if(this.isExpOperator(ch) && (!peekCh || !this.isNumber(peekCh)) && number.charAt(number.length - 1) == "e"){this.throwError("Invalid exponent");}else {break;}}this.index++;}number = 1 * number;this.tokens.push({index:start, text:number, literal:true, constant:true, fn:function fn(){return number;}});}, readIdent:function readIdent(){var parser=this;var ident="";var start=this.index;var lastDot, peekIndex, methodName, ch;while(this.index < this.text.length) {ch = this.text.charAt(this.index);if(ch === "." || this.isIdent(ch) || this.isNumber(ch)){if(ch === ".")lastDot = this.index;ident += ch;}else {break;}this.index++;}if(lastDot){peekIndex = this.index;while(peekIndex < this.text.length) {ch = this.text.charAt(peekIndex);if(ch === "("){methodName = ident.substr(lastDot - start + 1);ident = ident.substr(0, lastDot - start);this.index = peekIndex;break;}if(this.isWhitespace(ch)){peekIndex++;}else {break;}}}var token={index:start, text:ident};if(OPERATORS.hasOwnProperty(ident)){token.fn = OPERATORS[ident];token.literal = true;token.constant = true;}else {var getter=getterFn(ident, this.options, this.text);token.fn = extend(function(self, locals){return getter(self, locals);}, {assign:function assign(self, value){return setter(self, ident, value, parser.text, parser.options);}});}this.tokens.push(token);if(methodName){this.tokens.push({index:lastDot, text:"."});this.tokens.push({index:lastDot + 1, text:methodName});}}, readString:function readString(quote){var start=this.index;this.index++;var string="";var rawString=quote;var escape=false;while(this.index < this.text.length) {var ch=this.text.charAt(this.index);rawString += ch;if(escape){if(ch === "u"){var hex=this.text.substring(this.index + 1, this.index + 5);if(!hex.match(/[\da-f]{4}/i))this.throwError("Invalid unicode escape [\\u" + hex + "]");this.index += 4;string += String.fromCharCode(parseInt(hex, 16));}else {var rep=ESCAPE[ch];string = string + (rep || ch);}escape = false;}else if(ch === "\\"){escape = true;}else if(ch === quote){this.index++;this.tokens.push({index:start, text:rawString, string:string, literal:true, constant:true, fn:function fn(){return string;}});return;}else {string += ch;}this.index++;}this.throwError("Unterminated quote", start);}};var Parser=function Parser(lexer, $filter, options){this.lexer = lexer;this.$filter = $filter;this.options = options;};Parser.ZERO = extend(function(){return 0;}, {constant:true});Parser.prototype = {constructor:Parser, parse:function parse(text){this.text = text;this.tokens = this.lexer.lex(text);var value=this.statements();if(this.tokens.length !== 0){this.throwError("is an unexpected token", this.tokens[0]);}value.literal = !!value.literal;value.constant = !!value.constant;return value;}, primary:(function(_primary){var _primaryWrapper=function primary(){return _primary.apply(this, arguments);};_primaryWrapper.toString = function(){return _primary.toString();};return _primaryWrapper;})(function(){var primary;if(this.expect("(")){primary = this.filterChain();this.consume(")");}else if(this.expect("[")){primary = this.arrayDeclaration();}else if(this.expect("{")){primary = this.object();}else {var token=this.expect();primary = token.fn;if(!primary){this.throwError("not a primary expression", token);}primary.literal = !!token.literal;primary.constant = !!token.constant;}var next, context;while(next = this.expect("(", "[", ".")) {if(next.text === "("){primary = this.functionCall(primary, context);context = null;}else if(next.text === "["){context = primary;primary = this.objectIndex(primary);}else if(next.text === "."){context = primary;primary = this.fieldAccess(primary);}else {this.throwError("IMPOSSIBLE");}}return primary;}), throwError:function throwError(msg, token){throw $parseMinErr("syntax", "Syntax Error: Token '{0}' {1} at column {2} of the expression [{3}] starting at [{4}].", token.text, msg, token.index + 1, this.text, this.text.substring(token.index));}, peekToken:function peekToken(){if(this.tokens.length === 0)throw $parseMinErr("ueoe", "Unexpected end of expression: {0}", this.text);return this.tokens[0];}, peek:function peek(e1, e2, e3, e4){if(this.tokens.length > 0){var token=this.tokens[0];var t=token.text;if(t === e1 || t === e2 || t === e3 || t === e4 || !e1 && !e2 && !e3 && !e4){return token;}}return false;}, expect:function expect(e1, e2, e3, e4){var token=this.peek(e1, e2, e3, e4);if(token){this.tokens.shift();return token;}return false;}, consume:function consume(e1){if(!this.expect(e1)){this.throwError("is unexpected, expecting [" + e1 + "]", this.peek());}}, unaryFn:function unaryFn(fn, right){return extend(function(self, locals){return fn(self, locals, right);}, {constant:right.constant});}, ternaryFn:function ternaryFn(left, middle, right){return extend(function(self, locals){return left(self, locals)?middle(self, locals):right(self, locals);}, {constant:left.constant && middle.constant && right.constant});}, binaryFn:function binaryFn(left, fn, right){return extend(function(self, locals){return fn(self, locals, left, right);}, {constant:left.constant && right.constant});}, statements:(function(_statements){var _statementsWrapper=function statements(){return _statements.apply(this, arguments);};_statementsWrapper.toString = function(){return _statements.toString();};return _statementsWrapper;})(function(){var statements=[];while(true) {if(this.tokens.length > 0 && !this.peek("}", ")", ";", "]"))statements.push(this.filterChain());if(!this.expect(";")){return statements.length === 1?statements[0]:function(self, locals){var value;for(var i=0; i < statements.length; i++) {var statement=statements[i];if(statement){value = statement(self, locals);}}return value;};}}}), filterChain:function filterChain(){var left=this.expression();var token;while(true) {if(token = this.expect("|")){left = this.binaryFn(left, token.fn, this.filter());}else {return left;}}}, filter:function filter(){var token=this.expect();var fn=this.$filter(token.text);var argsFn=[];while(true) {if(token = this.expect(":")){argsFn.push(this.expression());}else {var fnInvoke=function fnInvoke(self, locals, input){var args=[input];for(var i=0; i < argsFn.length; i++) {args.push(argsFn[i](self, locals));}return fn.apply(self, args);};return function(){return fnInvoke;};}}}, expression:function expression(){return this.assignment();}, assignment:function assignment(){var left=this.ternary();var right;var token;if(token = this.expect("=")){if(!left.assign){this.throwError("implies assignment but [" + this.text.substring(0, token.index) + "] can not be assigned to", token);}right = this.ternary();return function(scope, locals){return left.assign(scope, right(scope, locals), locals);};}return left;}, ternary:function ternary(){var left=this.logicalOR();var middle;var token;if(token = this.expect("?")){middle = this.assignment();if(token = this.expect(":")){return this.ternaryFn(left, middle, this.assignment());}else {this.throwError("expected :", token);}}else {return left;}}, logicalOR:function logicalOR(){var left=this.logicalAND();var token;while(true) {if(token = this.expect("||")){left = this.binaryFn(left, token.fn, this.logicalAND());}else {return left;}}}, logicalAND:function logicalAND(){var left=this.equality();var token;if(token = this.expect("&&")){left = this.binaryFn(left, token.fn, this.logicalAND());}return left;}, equality:function equality(){var left=this.relational();var token;if(token = this.expect("==", "!=", "===", "!==")){left = this.binaryFn(left, token.fn, this.equality());}return left;}, relational:function relational(){var left=this.additive();var token;if(token = this.expect("<", ">", "<=", ">=")){left = this.binaryFn(left, token.fn, this.relational());}return left;}, additive:function additive(){var left=this.multiplicative();var token;while(token = this.expect("+", "-")) {left = this.binaryFn(left, token.fn, this.multiplicative());}return left;}, multiplicative:function multiplicative(){var left=this.unary();var token;while(token = this.expect("*", "/", "%")) {left = this.binaryFn(left, token.fn, this.unary());}return left;}, unary:function unary(){var token;if(this.expect("+")){return this.primary();}else if(token = this.expect("-")){return this.binaryFn(Parser.ZERO, token.fn, this.unary());}else if(token = this.expect("!")){return this.unaryFn(token.fn, this.unary());}else {return this.primary();}}, fieldAccess:function fieldAccess(object){var parser=this;var field=this.expect().text;var getter=getterFn(field, this.options, this.text);return extend(function(scope, locals, self){return getter(self || object(scope, locals));}, {assign:function assign(scope, value, locals){var o=object(scope, locals);if(!o)object.assign(scope, o = {});return setter(o, field, value, parser.text, parser.options);}});}, objectIndex:function objectIndex(obj){var parser=this;var indexFn=this.expression();this.consume("]");return extend(function(self, locals){var o=obj(self, locals), i=getStringValue(indexFn(self, locals), parser.text), v, p;ensureSafeMemberName(i, parser.text);if(!o)return undefined;v = ensureSafeObject(o[i], parser.text);if(v && v.then && parser.options.unwrapPromises){p = v;if(!("$$v" in v)){p.$$v = undefined;p.then(function(val){p.$$v = val;});}v = v.$$v;}return v;}, {assign:function assign(self, value, locals){var key=ensureSafeMemberName(getStringValue(indexFn(self, locals), parser.text), parser.text);var o=ensureSafeObject(obj(self, locals), parser.text);if(!o)obj.assign(self, o = {});return o[key] = value;}});}, functionCall:function functionCall(fn, contextGetter){var argsFn=[];if(this.peekToken().text !== ")"){do{argsFn.push(this.expression());}while(this.expect(","));}this.consume(")");var parser=this;return function(scope, locals){var args=[];var context=contextGetter?contextGetter(scope, locals):scope;for(var i=0; i < argsFn.length; i++) {args.push(ensureSafeObject(argsFn[i](scope, locals), parser.text));}var fnPtr=fn(scope, locals, context) || noop;ensureSafeObject(context, parser.text);ensureSafeFunction(fnPtr, parser.text);var v=fnPtr.apply?fnPtr.apply(context, args):fnPtr(args[0], args[1], args[2], args[3], args[4]);return ensureSafeObject(v, parser.text);};}, arrayDeclaration:function arrayDeclaration(){var elementFns=[];var allConstant=true;if(this.peekToken().text !== "]"){do{if(this.peek("]")){break;}var elementFn=this.expression();elementFns.push(elementFn);if(!elementFn.constant){allConstant = false;}}while(this.expect(","));}this.consume("]");return extend(function(self, locals){var array=[];for(var i=0; i < elementFns.length; i++) {array.push(elementFns[i](self, locals));}return array;}, {literal:true, constant:allConstant});}, object:function object(){var keyValues=[];var allConstant=true;if(this.peekToken().text !== "}"){do{if(this.peek("}")){break;}var token=this.expect(), key=token.string || token.text;this.consume(":");var value=this.expression();keyValues.push({key:key, value:value});if(!value.constant){allConstant = false;}}while(this.expect(","));}this.consume("}");return extend(function(self, locals){var object={};for(var i=0; i < keyValues.length; i++) {var keyValue=keyValues[i];object[keyValue.key] = keyValue.value(self, locals);}return object;}, {literal:true, constant:allConstant});}};function setter(obj, path, setValue, fullExp, options){ensureSafeObject(obj, fullExp);options = options || {};var element=path.split("."), key;for(var i=0; element.length > 1; i++) {key = ensureSafeMemberName(element.shift(), fullExp);var propertyObj=ensureSafeObject(obj[key], fullExp);if(!propertyObj){propertyObj = {};obj[key] = propertyObj;}obj = propertyObj;if(obj.then && options.unwrapPromises){promiseWarning(fullExp);if(!("$$v" in obj)){(function(promise){promise.then(function(val){promise.$$v = val;});})(obj);}if(obj.$$v === undefined){obj.$$v = {};}obj = obj.$$v;}}key = ensureSafeMemberName(element.shift(), fullExp);ensureSafeObject(obj[key], fullExp);obj[key] = setValue;return setValue;}var getterFnCacheDefault={};var getterFnCacheExpensive={};function isPossiblyDangerousMemberName(name){return name == "constructor";}function cspSafeGetterFn(key0, key1, key2, key3, key4, fullExp, options){ensureSafeMemberName(key0, fullExp);ensureSafeMemberName(key1, fullExp);ensureSafeMemberName(key2, fullExp);ensureSafeMemberName(key3, fullExp);ensureSafeMemberName(key4, fullExp);var eso=function eso(o){return ensureSafeObject(o, fullExp);};var expensiveChecks=options.expensiveChecks;var eso0=expensiveChecks || isPossiblyDangerousMemberName(key0)?eso:identity;var eso1=expensiveChecks || isPossiblyDangerousMemberName(key1)?eso:identity;var eso2=expensiveChecks || isPossiblyDangerousMemberName(key2)?eso:identity;var eso3=expensiveChecks || isPossiblyDangerousMemberName(key3)?eso:identity;var eso4=expensiveChecks || isPossiblyDangerousMemberName(key4)?eso:identity;return !options.unwrapPromises?function cspSafeGetter(scope, locals){var pathVal=locals && locals.hasOwnProperty(key0)?locals:scope;if(pathVal == null){return pathVal;}pathVal = eso0(pathVal[key0]);if(!key1){return pathVal;}if(pathVal == null){return undefined;}pathVal = eso1(pathVal[key1]);if(!key2){return pathVal;}if(pathVal == null){return undefined;}pathVal = eso2(pathVal[key2]);if(!key3){return pathVal;}if(pathVal == null){return undefined;}pathVal = eso3(pathVal[key3]);if(!key4){return pathVal;}if(pathVal == null){return undefined;}pathVal = eso4(pathVal[key4]);return pathVal;}:function cspSafePromiseEnabledGetter(scope, locals){var pathVal=locals && locals.hasOwnProperty(key0)?locals:scope, promise;if(pathVal == null){return pathVal;}pathVal = eso0(pathVal[key0]);if(pathVal && pathVal.then){promiseWarning(fullExp);if(!("$$v" in pathVal)){promise = pathVal;promise.$$v = undefined;promise.then(function(val){promise.$$v = eso0(val);});}pathVal = eso0(pathVal.$$v);}if(!key1){return pathVal;}if(pathVal == null){return undefined;}pathVal = eso1(pathVal[key1]);if(pathVal && pathVal.then){promiseWarning(fullExp);if(!("$$v" in pathVal)){promise = pathVal;promise.$$v = undefined;promise.then(function(val){promise.$$v = eso1(val);});}pathVal = eso1(pathVal.$$v);}if(!key2){return pathVal;}if(pathVal == null){return undefined;}pathVal = eso2(pathVal[key2]);if(pathVal && pathVal.then){promiseWarning(fullExp);if(!("$$v" in pathVal)){promise = pathVal;promise.$$v = undefined;promise.then(function(val){promise.$$v = eso2(val);});}pathVal = eso2(pathVal.$$v);}if(!key3){return pathVal;}if(pathVal == null){return undefined;}pathVal = eso3(pathVal[key3]);if(pathVal && pathVal.then){promiseWarning(fullExp);if(!("$$v" in pathVal)){promise = pathVal;promise.$$v = undefined;promise.then(function(val){promise.$$v = eso3(val);});}pathVal = eso3(pathVal.$$v);}if(!key4){return pathVal;}if(pathVal == null){return undefined;}pathVal = eso4(pathVal[key4]);if(pathVal && pathVal.then){promiseWarning(fullExp);if(!("$$v" in pathVal)){promise = pathVal;promise.$$v = undefined;promise.then(function(val){promise.$$v = eso4(val);});}pathVal = eso4(pathVal.$$v);}return pathVal;};}function getterFnWithExtraArgs(fn, fullExpression){return function(s, l){return fn(s, l, promiseWarning, ensureSafeObject, fullExpression);};}function getterFn(path, options, fullExp){var expensiveChecks=options.expensiveChecks;var getterFnCache=expensiveChecks?getterFnCacheExpensive:getterFnCacheDefault;if(getterFnCache.hasOwnProperty(path)){return getterFnCache[path];}var pathKeys=path.split("."), pathKeysLength=pathKeys.length, fn;if(options.csp){if(pathKeysLength < 6){fn = cspSafeGetterFn(pathKeys[0], pathKeys[1], pathKeys[2], pathKeys[3], pathKeys[4], fullExp, options);}else {fn = function(scope, locals){var i=0, val;do{val = cspSafeGetterFn(pathKeys[i++], pathKeys[i++], pathKeys[i++], pathKeys[i++], pathKeys[i++], fullExp, options)(scope, locals);locals = undefined;scope = val;}while(i < pathKeysLength);return val;};}}else {var code="var p;\n";if(expensiveChecks){code += "s = eso(s, fe);\nl = eso(l, fe);\n";}var needsEnsureSafeObject=expensiveChecks;forEach(pathKeys, function(key, index){ensureSafeMemberName(key, fullExp);var lookupJs=(index?"s":"((l&&l.hasOwnProperty(\"" + key + "\"))?l:s)") + "[\"" + key + "\"]";var wrapWithEso=expensiveChecks || isPossiblyDangerousMemberName(key);if(wrapWithEso){lookupJs = "eso(" + lookupJs + ", fe)";needsEnsureSafeObject = true;}code += "if(s == null) return undefined;\n" + "s=" + lookupJs + ";\n";if(options.unwrapPromises){code += "if (s && s.then) {\n" + " pw(\"" + fullExp.replace(/(["\r\n])/g, "\\$1") + "\");\n" + " if (!(\"$$v\" in s)) {\n" + " p=s;\n" + " p.$$v = undefined;\n" + " p.then(function(v) {p.$$v=" + (wrapWithEso?"eso(v)":"v") + ";});\n" + "}\n" + " s=" + (wrapWithEso?"eso(s.$$v)":"s.$$v") + "\n" + "}\n";}});code += "return s;";var evaledFnGetter=new Function("s", "l", "pw", "eso", "fe", code);evaledFnGetter.toString = valueFn(code);if(needsEnsureSafeObject || options.unwrapPromises){evaledFnGetter = getterFnWithExtraArgs(evaledFnGetter, fullExp);}fn = evaledFnGetter;}if(path !== "hasOwnProperty"){getterFnCache[path] = fn;}return fn;}function $ParseProvider(){var cacheDefault={};var cacheExpensive={};var $parseOptions={csp:false, unwrapPromises:false, logPromiseWarnings:true, expensiveChecks:false};this.unwrapPromises = function(value){if(isDefined(value)){$parseOptions.unwrapPromises = !!value;return this;}else {return $parseOptions.unwrapPromises;}};this.logPromiseWarnings = function(value){if(isDefined(value)){$parseOptions.logPromiseWarnings = value;return this;}else {return $parseOptions.logPromiseWarnings;}};this.$get = ["$filter", "$sniffer", "$log", function($filter, $sniffer, $log){$parseOptions.csp = $sniffer.csp;var $parseOptionsExpensive={csp:$parseOptions.csp, unwrapPromises:$parseOptions.unwrapPromises, logPromiseWarnings:$parseOptions.logPromiseWarnings, expensiveChecks:true};promiseWarning = function promiseWarningFn(fullExp){if(!$parseOptions.logPromiseWarnings || promiseWarningCache.hasOwnProperty(fullExp)){return;}promiseWarningCache[fullExp] = true;$log.warn("[$parse] Promise found in the expression `" + fullExp + "`. " + "Automatic unwrapping of promises in Angular expressions is deprecated.");};return function(exp, expensiveChecks){var parsedExpression;switch(typeof exp){case "string":var cache=expensiveChecks?cacheExpensive:cacheDefault;if(cache.hasOwnProperty(exp)){return cache[exp];}var parseOptions=expensiveChecks?$parseOptionsExpensive:$parseOptions;var lexer=new Lexer(parseOptions);var parser=new Parser(lexer, $filter, parseOptions);parsedExpression = parser.parse(exp);if(exp !== "hasOwnProperty"){cache[exp] = parsedExpression;}return parsedExpression;case "function":return exp;default:return noop;}};}];}function $QProvider(){this.$get = ["$rootScope", "$exceptionHandler", function($rootScope, $exceptionHandler){return qFactory(function(callback){$rootScope.$evalAsync(callback);}, $exceptionHandler);}];}function qFactory(nextTick, exceptionHandler){var defer=(function(_defer){var _deferWrapper=function defer(){return _defer.apply(this, arguments);};_deferWrapper.toString = function(){return _defer.toString();};return _deferWrapper;})(function(){var pending=[], value, deferred;deferred = {resolve:function resolve(val){if(pending){var callbacks=pending;pending = undefined;value = ref(val);if(callbacks.length){nextTick(function(){var callback;for(var i=0, ii=callbacks.length; i < ii; i++) {callback = callbacks[i];value.then(callback[0], callback[1], callback[2]);}});}}}, reject:function reject(reason){deferred.resolve(createInternalRejectedPromise(reason));}, notify:function notify(progress){if(pending){var callbacks=pending;if(pending.length){nextTick(function(){var callback;for(var i=0, ii=callbacks.length; i < ii; i++) {callback = callbacks[i];callback[2](progress);}});}}}, promise:{then:function then(callback, errback, progressback){var result=defer();var wrappedCallback=function wrappedCallback(value){try{result.resolve((isFunction(callback)?callback:defaultCallback)(value));}catch(e) {result.reject(e);exceptionHandler(e);}};var wrappedErrback=function wrappedErrback(reason){try{result.resolve((isFunction(errback)?errback:defaultErrback)(reason));}catch(e) {result.reject(e);exceptionHandler(e);}};var wrappedProgressback=function wrappedProgressback(progress){try{result.notify((isFunction(progressback)?progressback:defaultCallback)(progress));}catch(e) {exceptionHandler(e);}};if(pending){pending.push([wrappedCallback, wrappedErrback, wrappedProgressback]);}else {value.then(wrappedCallback, wrappedErrback, wrappedProgressback);}return result.promise;}, "catch":function _catch(callback){return this.then(null, callback);}, "finally":function _finally(callback){function makePromise(value, resolved){var result=defer();if(resolved){result.resolve(value);}else {result.reject(value);}return result.promise;}function handleCallback(value, isResolved){var callbackOutput=null;try{callbackOutput = (callback || defaultCallback)();}catch(e) {return makePromise(e, false);}if(isPromiseLike(callbackOutput)){return callbackOutput.then(function(){return makePromise(value, isResolved);}, function(error){return makePromise(error, false);});}else {return makePromise(value, isResolved);}}return this.then(function(value){return handleCallback(value, true);}, function(error){return handleCallback(error, false);});}}};return deferred;});var ref=function ref(value){if(isPromiseLike(value)){return value;}return {then:function then(callback){var result=defer();nextTick(function(){result.resolve(callback(value));});return result.promise;}};};var reject=function reject(reason){var result=defer();result.reject(reason);return result.promise;};var createInternalRejectedPromise=function createInternalRejectedPromise(reason){return {then:function then(callback, errback){var result=defer();nextTick(function(){try{result.resolve((isFunction(errback)?errback:defaultErrback)(reason));}catch(e) {result.reject(e);exceptionHandler(e);}});return result.promise;}};};var when=function when(value, callback, errback, progressback){var result=defer(), done;var wrappedCallback=function wrappedCallback(value){try{return (isFunction(callback)?callback:defaultCallback)(value);}catch(e) {exceptionHandler(e);return reject(e);}};var wrappedErrback=function wrappedErrback(reason){try{return (isFunction(errback)?errback:defaultErrback)(reason);}catch(e) {exceptionHandler(e);return reject(e);}};var wrappedProgressback=function wrappedProgressback(progress){try{return (isFunction(progressback)?progressback:defaultCallback)(progress);}catch(e) {exceptionHandler(e);}};nextTick(function(){ref(value).then(function(value){if(done)return;done = true;result.resolve(ref(value).then(wrappedCallback, wrappedErrback, wrappedProgressback));}, function(reason){if(done)return;done = true;result.resolve(wrappedErrback(reason));}, function(progress){if(done)return;result.notify(wrappedProgressback(progress));});});return result.promise;};function defaultCallback(value){return value;}function defaultErrback(reason){return reject(reason);}function all(promises){var deferred=defer(), counter=0, results=isArray(promises)?[]:{};forEach(promises, function(promise, key){counter++;ref(promise).then(function(value){if(results.hasOwnProperty(key))return;results[key] = value;if(! --counter)deferred.resolve(results);}, function(reason){if(results.hasOwnProperty(key))return;deferred.reject(reason);});});if(counter === 0){deferred.resolve(results);}return deferred.promise;}return {defer:defer, reject:reject, when:when, all:all};}function $$RAFProvider(){this.$get = ["$window", "$timeout", function($window, $timeout){var requestAnimationFrame=$window.requestAnimationFrame || $window.webkitRequestAnimationFrame || $window.mozRequestAnimationFrame;var cancelAnimationFrame=$window.cancelAnimationFrame || $window.webkitCancelAnimationFrame || $window.mozCancelAnimationFrame || $window.webkitCancelRequestAnimationFrame;var rafSupported=!!requestAnimationFrame;var raf=rafSupported?function(fn){var id=requestAnimationFrame(fn);return function(){cancelAnimationFrame(id);};}:function(fn){var timer=$timeout(fn, 16.66, false);return function(){$timeout.cancel(timer);};};raf.supported = rafSupported;return raf;}];}function $RootScopeProvider(){var TTL=10;var $rootScopeMinErr=minErr("$rootScope");var lastDirtyWatch=null;this.digestTtl = function(value){if(arguments.length){TTL = value;}return TTL;};this.$get = ["$injector", "$exceptionHandler", "$parse", "$browser", function($injector, $exceptionHandler, $parse, $browser){function Scope(){this.$id = nextUid();this.$$phase = this.$parent = this.$$watchers = this.$$nextSibling = this.$$prevSibling = this.$$childHead = this.$$childTail = null;this["this"] = this.$root = this;this.$$destroyed = false;this.$$asyncQueue = [];this.$$postDigestQueue = [];this.$$listeners = {};this.$$listenerCount = {};this.$$isolateBindings = {};}Scope.prototype = {constructor:Scope, $new:function $new(isolate){var ChildScope, child;if(isolate){child = new Scope();child.$root = this.$root;child.$$asyncQueue = this.$$asyncQueue;child.$$postDigestQueue = this.$$postDigestQueue;}else {if(!this.$$childScopeClass){this.$$childScopeClass = function(){this.$$watchers = this.$$nextSibling = this.$$childHead = this.$$childTail = null;this.$$listeners = {};this.$$listenerCount = {};this.$id = nextUid();this.$$childScopeClass = null;};this.$$childScopeClass.prototype = this;}child = new this.$$childScopeClass();}child["this"] = child;child.$parent = this;child.$$prevSibling = this.$$childTail;if(this.$$childHead){this.$$childTail.$$nextSibling = child;this.$$childTail = child;}else {this.$$childHead = this.$$childTail = child;}return child;}, $watch:function $watch(watchExp, listener, objectEquality){var scope=this, get=compileToFn(watchExp, "watch"), array=scope.$$watchers, watcher={fn:listener, last:initWatchVal, get:get, exp:watchExp, eq:!!objectEquality};lastDirtyWatch = null;if(!isFunction(listener)){var listenFn=compileToFn(listener || noop, "listener");watcher.fn = function(newVal, oldVal, scope){listenFn(scope);};}if(typeof watchExp == "string" && get.constant){var originalFn=watcher.fn;watcher.fn = function(newVal, oldVal, scope){originalFn.call(this, newVal, oldVal, scope);arrayRemove(array, watcher);};}if(!array){array = scope.$$watchers = [];}array.unshift(watcher);return function deregisterWatch(){arrayRemove(array, watcher);lastDirtyWatch = null;};}, $watchCollection:function $watchCollection(obj, listener){var self=this;var newValue;var oldValue;var veryOldValue;var trackVeryOldValue=listener.length > 1;var changeDetected=0;var objGetter=$parse(obj);var internalArray=[];var internalObject={};var initRun=true;var oldLength=0;function $watchCollectionWatch(){newValue = objGetter(self);var newLength, key, bothNaN;if(!isObject(newValue)){if(oldValue !== newValue){oldValue = newValue;changeDetected++;}}else if(isArrayLike(newValue)){if(oldValue !== internalArray){oldValue = internalArray;oldLength = oldValue.length = 0;changeDetected++;}newLength = newValue.length;if(oldLength !== newLength){changeDetected++;oldValue.length = oldLength = newLength;}for(var i=0; i < newLength; i++) {bothNaN = oldValue[i] !== oldValue[i] && newValue[i] !== newValue[i];if(!bothNaN && oldValue[i] !== newValue[i]){changeDetected++;oldValue[i] = newValue[i];}}}else {if(oldValue !== internalObject){oldValue = internalObject = {};oldLength = 0;changeDetected++;}newLength = 0;for(key in newValue) {if(newValue.hasOwnProperty(key)){newLength++;if(oldValue.hasOwnProperty(key)){bothNaN = oldValue[key] !== oldValue[key] && newValue[key] !== newValue[key];if(!bothNaN && oldValue[key] !== newValue[key]){changeDetected++;oldValue[key] = newValue[key];}}else {oldLength++;oldValue[key] = newValue[key];changeDetected++;}}}if(oldLength > newLength){changeDetected++;for(key in oldValue) {if(oldValue.hasOwnProperty(key) && !newValue.hasOwnProperty(key)){oldLength--;delete oldValue[key];}}}}return changeDetected;}function $watchCollectionAction(){if(initRun){initRun = false;listener(newValue, newValue, self);}else {listener(newValue, veryOldValue, self);}if(trackVeryOldValue){if(!isObject(newValue)){veryOldValue = newValue;}else if(isArrayLike(newValue)){veryOldValue = new Array(newValue.length);for(var i=0; i < newValue.length; i++) {veryOldValue[i] = newValue[i];}}else {veryOldValue = {};for(var key in newValue) {if(hasOwnProperty.call(newValue, key)){veryOldValue[key] = newValue[key];}}}}}return this.$watch($watchCollectionWatch, $watchCollectionAction);}, $digest:function $digest(){var watch, value, last, watchers, asyncQueue=this.$$asyncQueue, postDigestQueue=this.$$postDigestQueue, length, dirty, ttl=TTL, next, current, target=this, watchLog=[], logIdx, logMsg, asyncTask;beginPhase("$digest");$browser.$$checkUrlChange();lastDirtyWatch = null;do{dirty = false;current = target;while(asyncQueue.length) {try{asyncTask = asyncQueue.shift();asyncTask.scope.$eval(asyncTask.expression);}catch(e) {clearPhase();$exceptionHandler(e);}lastDirtyWatch = null;}traverseScopesLoop: do{if(watchers = current.$$watchers){length = watchers.length;while(length--) {try{watch = watchers[length];if(watch){if((value = watch.get(current)) !== (last = watch.last) && !(watch.eq?equals(value, last):typeof value === "number" && typeof last === "number" && isNaN(value) && isNaN(last))){dirty = true;lastDirtyWatch = watch;watch.last = watch.eq?copy(value, null):value;watch.fn(value, last === initWatchVal?value:last, current);if(ttl < 5){logIdx = 4 - ttl;if(!watchLog[logIdx])watchLog[logIdx] = [];logMsg = isFunction(watch.exp)?"fn: " + (watch.exp.name || watch.exp.toString()):watch.exp;logMsg += "; newVal: " + toJson(value) + "; oldVal: " + toJson(last);watchLog[logIdx].push(logMsg);}}else if(watch === lastDirtyWatch){dirty = false;break traverseScopesLoop;}}}catch(e) {clearPhase();$exceptionHandler(e);}}}if(!(next = current.$$childHead || current !== target && current.$$nextSibling)){while(current !== target && !(next = current.$$nextSibling)) {current = current.$parent;}}}while(current = next);if((dirty || asyncQueue.length) && ! ttl--){clearPhase();throw $rootScopeMinErr("infdig", "{0} $digest() iterations reached. Aborting!\n" + "Watchers fired in the last 5 iterations: {1}", TTL, toJson(watchLog));}}while(dirty || asyncQueue.length);clearPhase();while(postDigestQueue.length) {try{postDigestQueue.shift()();}catch(e) {$exceptionHandler(e);}}}, $destroy:function $destroy(){if(this.$$destroyed){return;}var parent=this.$parent;this.$broadcast("$destroy");this.$$destroyed = true;if(this === $rootScope){return;}forEach(this.$$listenerCount, bind(null, decrementListenerCount, this));if(parent.$$childHead == this)parent.$$childHead = this.$$nextSibling;if(parent.$$childTail == this)parent.$$childTail = this.$$prevSibling;if(this.$$prevSibling)this.$$prevSibling.$$nextSibling = this.$$nextSibling;if(this.$$nextSibling)this.$$nextSibling.$$prevSibling = this.$$prevSibling;this.$parent = this.$$nextSibling = this.$$prevSibling = this.$$childHead = this.$$childTail = this.$root = null;this.$$listeners = {};this.$$watchers = this.$$asyncQueue = this.$$postDigestQueue = [];this.$destroy = this.$digest = this.$apply = noop;this.$on = this.$watch = function(){return noop;};}, $eval:function $eval(expr, locals){return $parse(expr)(this, locals);}, $evalAsync:function $evalAsync(expr){if(!$rootScope.$$phase && !$rootScope.$$asyncQueue.length){$browser.defer(function(){if($rootScope.$$asyncQueue.length){$rootScope.$digest();}});}this.$$asyncQueue.push({scope:this, expression:expr});}, $$postDigest:function $$postDigest(fn){this.$$postDigestQueue.push(fn);}, $apply:function $apply(expr){try{beginPhase("$apply");return this.$eval(expr);}catch(e) {$exceptionHandler(e);}finally {clearPhase();try{$rootScope.$digest();}catch(e) {$exceptionHandler(e);throw e;}}}, $on:function $on(name, listener){var namedListeners=this.$$listeners[name];if(!namedListeners){this.$$listeners[name] = namedListeners = [];}namedListeners.push(listener);var current=this;do{if(!current.$$listenerCount[name]){current.$$listenerCount[name] = 0;}current.$$listenerCount[name]++;}while(current = current.$parent);var self=this;return function(){var indexOfListener=indexOf(namedListeners, listener);if(indexOfListener !== -1){namedListeners[indexOfListener] = null;decrementListenerCount(self, 1, name);}};}, $emit:function $emit(name, args){var empty=[], namedListeners, scope=this, stopPropagation=false, event={name:name, targetScope:scope, stopPropagation:(function(_stopPropagation){var _stopPropagationWrapper=function stopPropagation(){return _stopPropagation.apply(this, arguments);};_stopPropagationWrapper.toString = function(){return _stopPropagation.toString();};return _stopPropagationWrapper;})(function(){stopPropagation = true;}), preventDefault:function preventDefault(){event.defaultPrevented = true;}, defaultPrevented:false}, listenerArgs=concat([event], arguments, 1), i, length;do{namedListeners = scope.$$listeners[name] || empty;event.currentScope = scope;for(i = 0, length = namedListeners.length; i < length; i++) {if(!namedListeners[i]){namedListeners.splice(i, 1);i--;length--;continue;}try{namedListeners[i].apply(null, listenerArgs);}catch(e) {$exceptionHandler(e);}}if(stopPropagation){return event;}scope = scope.$parent;}while(scope);return event;}, $broadcast:function $broadcast(name, args){var target=this, current=target, next=target, event={name:name, targetScope:target, preventDefault:function preventDefault(){event.defaultPrevented = true;}, defaultPrevented:false}, listenerArgs=concat([event], arguments, 1), listeners, i, length;while(current = next) {event.currentScope = current;listeners = current.$$listeners[name] || [];for(i = 0, length = listeners.length; i < length; i++) {if(!listeners[i]){listeners.splice(i, 1);i--;length--;continue;}try{listeners[i].apply(null, listenerArgs);}catch(e) {$exceptionHandler(e);}}if(!(next = current.$$listenerCount[name] && current.$$childHead || current !== target && current.$$nextSibling)){while(current !== target && !(next = current.$$nextSibling)) {current = current.$parent;}}}return event;}};var $rootScope=new Scope();return $rootScope;function beginPhase(phase){if($rootScope.$$phase){throw $rootScopeMinErr("inprog", "{0} already in progress", $rootScope.$$phase);}$rootScope.$$phase = phase;}function clearPhase(){$rootScope.$$phase = null;}function compileToFn(exp, name){var fn=$parse(exp);assertArgFn(fn, name);return fn;}function decrementListenerCount(current, count, name){do{current.$$listenerCount[name] -= count;if(current.$$listenerCount[name] === 0){delete current.$$listenerCount[name];}}while(current = current.$parent);}function initWatchVal(){}}];}function $$SanitizeUriProvider(){var aHrefSanitizationWhitelist=/^\s*(https?|ftp|mailto|tel|file):/, imgSrcSanitizationWhitelist=/^\s*((https?|ftp|file):|data:image\/)/;this.aHrefSanitizationWhitelist = function(regexp){if(isDefined(regexp)){aHrefSanitizationWhitelist = regexp;return this;}return aHrefSanitizationWhitelist;};this.imgSrcSanitizationWhitelist = function(regexp){if(isDefined(regexp)){imgSrcSanitizationWhitelist = regexp;return this;}return imgSrcSanitizationWhitelist;};this.$get = function(){return function sanitizeUri(uri, isImage){var regex=isImage?imgSrcSanitizationWhitelist:aHrefSanitizationWhitelist;var normalizedVal;if(!msie || msie >= 8){normalizedVal = urlResolve(uri).href;if(normalizedVal !== "" && !normalizedVal.match(regex)){return "unsafe:" + normalizedVal;}}return uri;};};}var $sceMinErr=minErr("$sce");var SCE_CONTEXTS={HTML:"html", CSS:"css", URL:"url", RESOURCE_URL:"resourceUrl", JS:"js"};function escapeForRegexp(s){return s.replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08");}function adjustMatcher(matcher){if(matcher === "self"){return matcher;}else if(isString(matcher)){if(matcher.indexOf("***") > -1){throw $sceMinErr("iwcard", "Illegal sequence *** in string matcher.  String: {0}", matcher);}matcher = escapeForRegexp(matcher).replace("\\*\\*", ".*").replace("\\*", "[^:/.?&;]*");return new RegExp("^" + matcher + "$");}else if(isRegExp(matcher)){return new RegExp("^" + matcher.source + "$");}else {throw $sceMinErr("imatcher", "Matchers may only be \"self\", string patterns or RegExp objects");}}function adjustMatchers(matchers){var adjustedMatchers=[];if(isDefined(matchers)){forEach(matchers, function(matcher){adjustedMatchers.push(adjustMatcher(matcher));});}return adjustedMatchers;}function $SceDelegateProvider(){this.SCE_CONTEXTS = SCE_CONTEXTS;var resourceUrlWhitelist=["self"], resourceUrlBlacklist=[];this.resourceUrlWhitelist = function(value){if(arguments.length){resourceUrlWhitelist = adjustMatchers(value);}return resourceUrlWhitelist;};this.resourceUrlBlacklist = function(value){if(arguments.length){resourceUrlBlacklist = adjustMatchers(value);}return resourceUrlBlacklist;};this.$get = ["$injector", function($injector){var htmlSanitizer=function htmlSanitizer(html){throw $sceMinErr("unsafe", "Attempting to use an unsafe value in a safe context.");};if($injector.has("$sanitize")){htmlSanitizer = $injector.get("$sanitize");}function matchUrl(matcher, parsedUrl){if(matcher === "self"){return urlIsSameOrigin(parsedUrl);}else {return !!matcher.exec(parsedUrl.href);}}function isResourceUrlAllowedByPolicy(url){var parsedUrl=urlResolve(url.toString());var i, n, allowed=false;for(i = 0, n = resourceUrlWhitelist.length; i < n; i++) {if(matchUrl(resourceUrlWhitelist[i], parsedUrl)){allowed = true;break;}}if(allowed){for(i = 0, n = resourceUrlBlacklist.length; i < n; i++) {if(matchUrl(resourceUrlBlacklist[i], parsedUrl)){allowed = false;break;}}}return allowed;}function generateHolderType(Base){var holderType=function TrustedValueHolderType(trustedValue){this.$$unwrapTrustedValue = function(){return trustedValue;};};if(Base){holderType.prototype = new Base();}holderType.prototype.valueOf = function sceValueOf(){return this.$$unwrapTrustedValue();};holderType.prototype.toString = function sceToString(){return this.$$unwrapTrustedValue().toString();};return holderType;}var trustedValueHolderBase=generateHolderType(), byType={};byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);byType[SCE_CONTEXTS.URL] = generateHolderType(trustedValueHolderBase);byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);function trustAs(type, trustedValue){var Constructor=byType.hasOwnProperty(type)?byType[type]:null;if(!Constructor){throw $sceMinErr("icontext", "Attempted to trust a value in invalid context. Context: {0}; Value: {1}", type, trustedValue);}if(trustedValue === null || trustedValue === undefined || trustedValue === ""){return trustedValue;}if(typeof trustedValue !== "string"){throw $sceMinErr("itype", "Attempted to trust a non-string value in a content requiring a string: Context: {0}", type);}return new Constructor(trustedValue);}function valueOf(maybeTrusted){if(maybeTrusted instanceof trustedValueHolderBase){return maybeTrusted.$$unwrapTrustedValue();}else {return maybeTrusted;}}function getTrusted(type, maybeTrusted){if(maybeTrusted === null || maybeTrusted === undefined || maybeTrusted === ""){return maybeTrusted;}var constructor=byType.hasOwnProperty(type)?byType[type]:null;if(constructor && maybeTrusted instanceof constructor){return maybeTrusted.$$unwrapTrustedValue();}if(type === SCE_CONTEXTS.RESOURCE_URL){if(isResourceUrlAllowedByPolicy(maybeTrusted)){return maybeTrusted;}else {throw $sceMinErr("insecurl", "Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}", maybeTrusted.toString());}}else if(type === SCE_CONTEXTS.HTML){return htmlSanitizer(maybeTrusted);}throw $sceMinErr("unsafe", "Attempting to use an unsafe value in a safe context.");}return {trustAs:trustAs, getTrusted:getTrusted, valueOf:valueOf};}];}function $SceProvider(){var enabled=true;this.enabled = function(value){if(arguments.length){enabled = !!value;}return enabled;};this.$get = ["$parse", "$sniffer", "$sceDelegate", function($parse, $sniffer, $sceDelegate){if(enabled && $sniffer.msie && $sniffer.msieDocumentMode < 8){throw $sceMinErr("iequirks", "Strict Contextual Escaping does not support Internet Explorer version < 9 in quirks " + "mode.  You can fix this by adding the text <!doctype html> to the top of your HTML " + "document.  See http://docs.angularjs.org/api/ng.$sce for more information.");}var sce=shallowCopy(SCE_CONTEXTS);sce.isEnabled = function(){return enabled;};sce.trustAs = $sceDelegate.trustAs;sce.getTrusted = $sceDelegate.getTrusted;sce.valueOf = $sceDelegate.valueOf;if(!enabled){sce.trustAs = sce.getTrusted = function(type, value){return value;};sce.valueOf = identity;}sce.parseAs = function sceParseAs(type, expr){var parsed=$parse(expr);if(parsed.literal && parsed.constant){return parsed;}else {return function sceParseAsTrusted(self, locals){return sce.getTrusted(type, parsed(self, locals));};}};var parse=sce.parseAs, getTrusted=sce.getTrusted, trustAs=sce.trustAs;forEach(SCE_CONTEXTS, function(enumValue, name){var lName=lowercase(name);sce[camelCase("parse_as_" + lName)] = function(expr){return parse(enumValue, expr);};sce[camelCase("get_trusted_" + lName)] = function(value){return getTrusted(enumValue, value);};sce[camelCase("trust_as_" + lName)] = function(value){return trustAs(enumValue, value);};});return sce;}];}function $SnifferProvider(){this.$get = ["$window", "$document", function($window, $document){var eventSupport={}, android=int((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]), boxee=/Boxee/i.test(($window.navigator || {}).userAgent), document=$document[0] || {}, documentMode=document.documentMode, vendorPrefix, vendorRegex=/^(Moz|webkit|O|ms)(?=[A-Z])/, bodyStyle=document.body && document.body.style, transitions=false, animations=false, match;if(bodyStyle){for(var prop in bodyStyle) {if(match = vendorRegex.exec(prop)){vendorPrefix = match[0];vendorPrefix = vendorPrefix.substr(0, 1).toUpperCase() + vendorPrefix.substr(1);break;}}if(!vendorPrefix){vendorPrefix = "WebkitOpacity" in bodyStyle && "webkit";}transitions = !!("transition" in bodyStyle || vendorPrefix + "Transition" in bodyStyle);animations = !!("animation" in bodyStyle || vendorPrefix + "Animation" in bodyStyle);if(android && (!transitions || !animations)){transitions = isString(document.body.style.webkitTransition);animations = isString(document.body.style.webkitAnimation);}}return {history:!!($window.history && $window.history.pushState && !(android < 4) && !boxee), hashchange:"onhashchange" in $window && (!documentMode || documentMode > 7), hasEvent:function hasEvent(event){if(event == "input" && msie == 9){return false;}if(isUndefined(eventSupport[event])){var divElm=document.createElement("div");eventSupport[event] = "on" + event in divElm;}return eventSupport[event];}, csp:csp(), vendorPrefix:vendorPrefix, transitions:transitions, animations:animations, android:android, msie:msie, msieDocumentMode:documentMode};}];}function $TimeoutProvider(){this.$get = ["$rootScope", "$browser", "$q", "$exceptionHandler", function($rootScope, $browser, $q, $exceptionHandler){var deferreds={};function timeout(fn, delay, invokeApply){var deferred=$q.defer(), promise=deferred.promise, skipApply=isDefined(invokeApply) && !invokeApply, timeoutId;timeoutId = $browser.defer(function(){try{deferred.resolve(fn());}catch(e) {deferred.reject(e);$exceptionHandler(e);}finally {delete deferreds[promise.$$timeoutId];}if(!skipApply)$rootScope.$apply();}, delay);promise.$$timeoutId = timeoutId;deferreds[timeoutId] = deferred;return promise;}timeout.cancel = function(promise){if(promise && promise.$$timeoutId in deferreds){deferreds[promise.$$timeoutId].reject("canceled");delete deferreds[promise.$$timeoutId];return $browser.defer.cancel(promise.$$timeoutId);}return false;};return timeout;}];}var urlParsingNode=document.createElement("a");var originUrl=urlResolve(window.location.href, true);function urlResolve(url, base){var href=url;if(msie){urlParsingNode.setAttribute("href", href);href = urlParsingNode.href;}urlParsingNode.setAttribute("href", href);return {href:urlParsingNode.href, protocol:urlParsingNode.protocol?urlParsingNode.protocol.replace(/:$/, ""):"", host:urlParsingNode.host, search:urlParsingNode.search?urlParsingNode.search.replace(/^\?/, ""):"", hash:urlParsingNode.hash?urlParsingNode.hash.replace(/^#/, ""):"", hostname:urlParsingNode.hostname, port:urlParsingNode.port, pathname:urlParsingNode.pathname.charAt(0) === "/"?urlParsingNode.pathname:"/" + urlParsingNode.pathname};}function urlIsSameOrigin(requestUrl){var parsed=isString(requestUrl)?urlResolve(requestUrl):requestUrl;return parsed.protocol === originUrl.protocol && parsed.host === originUrl.host;}function $WindowProvider(){this.$get = valueFn(window);}$FilterProvider.$inject = ["$provide"];function $FilterProvider($provide){var suffix="Filter";function register(name, factory){if(isObject(name)){var filters={};forEach(name, function(filter, key){filters[key] = register(key, filter);});return filters;}else {return $provide.factory(name + suffix, factory);}}this.register = register;this.$get = ["$injector", function($injector){return function(name){return $injector.get(name + suffix);};}];register("currency", currencyFilter);register("date", dateFilter);register("filter", filterFilter);register("json", jsonFilter);register("limitTo", limitToFilter);register("lowercase", lowercaseFilter);register("number", numberFilter);register("orderBy", orderByFilter);register("uppercase", uppercaseFilter);}function filterFilter(){return function(array, expression, comparator){if(!isArray(array))return array;var comparatorType=typeof comparator, predicates=[];predicates.check = function(value){for(var j=0; j < predicates.length; j++) {if(!predicates[j](value)){return false;}}return true;};if(comparatorType !== "function"){if(comparatorType === "boolean" && comparator){comparator = function(obj, text){return angular.equals(obj, text);};}else {comparator = function(obj, text){if(obj && text && typeof obj === "object" && typeof text === "object"){for(var objKey in obj) {if(objKey.charAt(0) !== "$" && hasOwnProperty.call(obj, objKey) && comparator(obj[objKey], text[objKey])){return true;}}return false;}text = ("" + text).toLowerCase();return ("" + obj).toLowerCase().indexOf(text) > -1;};}}var search=(function(_search){var _searchWrapper=function search(_x, _x2){return _search.apply(this, arguments);};_searchWrapper.toString = function(){return _search.toString();};return _searchWrapper;})(function(obj, text){if(typeof text === "string" && text.charAt(0) === "!"){return !search(obj, text.substr(1));}switch(typeof obj){case "boolean":case "number":case "string":return comparator(obj, text);case "object":switch(typeof text){case "object":return comparator(obj, text);default:for(var objKey in obj) {if(objKey.charAt(0) !== "$" && search(obj[objKey], text)){return true;}}break;}return false;case "array":for(var i=0; i < obj.length; i++) {if(search(obj[i], text)){return true;}}return false;default:return false;}});switch(typeof expression){case "boolean":case "number":case "string":expression = {$:expression};case "object":for(var key in expression) {(function(path){if(typeof expression[path] === "undefined")return;predicates.push(function(value){return search(path == "$"?value:value && value[path], expression[path]);});})(key);}break;case "function":predicates.push(expression);break;default:return array;}var filtered=[];for(var j=0; j < array.length; j++) {var value=array[j];if(predicates.check(value)){filtered.push(value);}}return filtered;};}currencyFilter.$inject = ["$locale"];function currencyFilter($locale){var formats=$locale.NUMBER_FORMATS;return function(amount, currencySymbol){if(isUndefined(currencySymbol))currencySymbol = formats.CURRENCY_SYM;return formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, 2).replace(/\u00A4/g, currencySymbol);};}numberFilter.$inject = ["$locale"];function numberFilter($locale){var formats=$locale.NUMBER_FORMATS;return function(number, fractionSize){return formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize);};}var DECIMAL_SEP=".";function formatNumber(number, pattern, groupSep, decimalSep, fractionSize){if(number == null || !isFinite(number) || isObject(number)){return "";}var isNegative=number < 0;number = Math.abs(number);var numStr=number + "", formatedText="", parts=[];var hasExponent=false;if(numStr.indexOf("e") !== -1){var match=numStr.match(/([\d\.]+)e(-?)(\d+)/);if(match && match[2] == "-" && match[3] > fractionSize + 1){numStr = "0";number = 0;}else {formatedText = numStr;hasExponent = true;}}if(!hasExponent){var fractionLen=(numStr.split(DECIMAL_SEP)[1] || "").length;if(isUndefined(fractionSize)){fractionSize = Math.min(Math.max(pattern.minFrac, fractionLen), pattern.maxFrac);}number = +(Math.round(+(number.toString() + "e" + fractionSize)).toString() + "e" + -fractionSize);if(number === 0){isNegative = false;}var fraction=("" + number).split(DECIMAL_SEP);var whole=fraction[0];fraction = fraction[1] || "";var i, pos=0, lgroup=pattern.lgSize, group=pattern.gSize;if(whole.length >= lgroup + group){pos = whole.length - lgroup;for(i = 0; i < pos; i++) {if((pos - i) % group === 0 && i !== 0){formatedText += groupSep;}formatedText += whole.charAt(i);}}for(i = pos; i < whole.length; i++) {if((whole.length - i) % lgroup === 0 && i !== 0){formatedText += groupSep;}formatedText += whole.charAt(i);}while(fraction.length < fractionSize) {fraction += "0";}if(fractionSize && fractionSize !== "0")formatedText += decimalSep + fraction.substr(0, fractionSize);}else {if(fractionSize > 0 && number > -1 && number < 1){formatedText = number.toFixed(fractionSize);}}parts.push(isNegative?pattern.negPre:pattern.posPre);parts.push(formatedText);parts.push(isNegative?pattern.negSuf:pattern.posSuf);return parts.join("");}function padNumber(num, digits, trim){var neg="";if(num < 0){neg = "-";num = -num;}num = "" + num;while(num.length < digits) num = "0" + num;if(trim)num = num.substr(num.length - digits);return neg + num;}function dateGetter(name, size, offset, trim){offset = offset || 0;return function(date){var value=date["get" + name]();if(offset > 0 || value > -offset)value += offset;if(value === 0 && offset == -12)value = 12;return padNumber(value, size, trim);};}function dateStrGetter(name, shortForm){return function(date, formats){var value=date["get" + name]();var get=uppercase(shortForm?"SHORT" + name:name);return formats[get][value];};}function timeZoneGetter(date){var zone=-1 * date.getTimezoneOffset();var paddedZone=zone >= 0?"+":"";paddedZone += padNumber(Math[zone > 0?"floor":"ceil"](zone / 60), 2) + padNumber(Math.abs(zone % 60), 2);return paddedZone;}function ampmGetter(date, formats){return date.getHours() < 12?formats.AMPMS[0]:formats.AMPMS[1];}var DATE_FORMATS={yyyy:dateGetter("FullYear", 4), yy:dateGetter("FullYear", 2, 0, true), y:dateGetter("FullYear", 1), MMMM:dateStrGetter("Month"), MMM:dateStrGetter("Month", true), MM:dateGetter("Month", 2, 1), M:dateGetter("Month", 1, 1), dd:dateGetter("Date", 2), d:dateGetter("Date", 1), HH:dateGetter("Hours", 2), H:dateGetter("Hours", 1), hh:dateGetter("Hours", 2, -12), h:dateGetter("Hours", 1, -12), mm:dateGetter("Minutes", 2), m:dateGetter("Minutes", 1), ss:dateGetter("Seconds", 2), s:dateGetter("Seconds", 1), sss:dateGetter("Milliseconds", 3), EEEE:dateStrGetter("Day"), EEE:dateStrGetter("Day", true), a:ampmGetter, Z:timeZoneGetter};var DATE_FORMATS_SPLIT=/((?:[^yMdHhmsaZE']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|d+|H+|h+|m+|s+|a|Z))(.*)/, NUMBER_STRING=/^\-?\d+$/;dateFilter.$inject = ["$locale"];function dateFilter($locale){var R_ISO8601_STR=/^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;function jsonStringToDate(string){var match;if(match = string.match(R_ISO8601_STR)){var date=new Date(0), tzHour=0, tzMin=0, dateSetter=match[8]?date.setUTCFullYear:date.setFullYear, timeSetter=match[8]?date.setUTCHours:date.setHours;if(match[9]){tzHour = int(match[9] + match[10]);tzMin = int(match[9] + match[11]);}dateSetter.call(date, int(match[1]), int(match[2]) - 1, int(match[3]));var h=int(match[4] || 0) - tzHour;var m=int(match[5] || 0) - tzMin;var s=int(match[6] || 0);var ms=Math.round(parseFloat("0." + (match[7] || 0)) * 1000);timeSetter.call(date, h, m, s, ms);return date;}return string;}return function(date, format){var text="", parts=[], fn, match;format = format || "mediumDate";format = $locale.DATETIME_FORMATS[format] || format;if(isString(date)){date = NUMBER_STRING.test(date)?int(date):jsonStringToDate(date);}if(isNumber(date)){date = new Date(date);}if(!isDate(date)){return date;}while(format) {match = DATE_FORMATS_SPLIT.exec(format);if(match){parts = concat(parts, match, 1);format = parts.pop();}else {parts.push(format);format = null;}}forEach(parts, function(value){fn = DATE_FORMATS[value];text += fn?fn(date, $locale.DATETIME_FORMATS):value.replace(/(^'|'$)/g, "").replace(/''/g, "'");});return text;};}function jsonFilter(){return function(object){return toJson(object, true);};}var lowercaseFilter=valueFn(lowercase);var uppercaseFilter=valueFn(uppercase);function limitToFilter(){return function(input, limit){if(!isArray(input) && !isString(input))return input;if(Math.abs(Number(limit)) === Infinity){limit = Number(limit);}else {limit = int(limit);}if(limit){return limit > 0?input.slice(0, limit):input.slice(limit);}else {return isString(input)?"":[];}};}orderByFilter.$inject = ["$parse"];function orderByFilter($parse){return function(array, sortPredicate, reverseOrder){if(!isArrayLike(array))return array;sortPredicate = isArray(sortPredicate)?sortPredicate:[sortPredicate];if(sortPredicate.length === 0){sortPredicate = ["+"];}sortPredicate = map(sortPredicate, function(predicate){var descending=false, get=predicate || identity;if(isString(predicate)){if(predicate.charAt(0) == "+" || predicate.charAt(0) == "-"){descending = predicate.charAt(0) == "-";predicate = predicate.substring(1);}if(predicate === ""){return reverseComparator(function(a, b){return compare(a, b);}, descending);}get = $parse(predicate);if(get.constant){var key=get();return reverseComparator(function(a, b){return compare(a[key], b[key]);}, descending);}}return reverseComparator(function(a, b){return compare(get(a), get(b));}, descending);});return slice.call(array).sort(reverseComparator(comparator, reverseOrder));function comparator(o1, o2){for(var i=0; i < sortPredicate.length; i++) {var comp=sortPredicate[i](o1, o2);if(comp !== 0){return comp;}}return 0;}function reverseComparator(comp, descending){return toBoolean(descending)?function(a, b){return comp(b, a);}:comp;}function compare(v1, v2){var t1=typeof v1;var t2=typeof v2;if(t1 == t2){if(isDate(v1) && isDate(v2)){v1 = v1.valueOf();v2 = v2.valueOf();}if(t1 == "string"){v1 = v1.toLowerCase();v2 = v2.toLowerCase();}if(v1 === v2){return 0;}return v1 < v2?-1:1;}else {return t1 < t2?-1:1;}}};}function ngDirective(directive){if(isFunction(directive)){directive = {link:directive};}directive.restrict = directive.restrict || "AC";return valueFn(directive);}var htmlAnchorDirective=valueFn({restrict:"E", compile:function compile(element, attr){if(msie <= 8){if(!attr.href && !attr.name){attr.$set("href", "");}element.append(document.createComment("IE fix"));}if(!attr.href && !attr.xlinkHref && !attr.name){return function(scope, element){var href=toString.call(element.prop("href")) === "[object SVGAnimatedString]"?"xlink:href":"href";element.on("click", function(event){if(!element.attr(href)){event.preventDefault();}});};}}});var ngAttributeAliasDirectives={};forEach(BOOLEAN_ATTR, function(propName, attrName){if(propName == "multiple")return;var normalized=directiveNormalize("ng-" + attrName);ngAttributeAliasDirectives[normalized] = function(){return {priority:100, link:function link(scope, element, attr){scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value){attr.$set(attrName, !!value);});}};};});forEach(["src", "srcset", "href"], function(attrName){var normalized=directiveNormalize("ng-" + attrName);ngAttributeAliasDirectives[normalized] = function(){return {priority:99, link:function link(scope, element, attr){var propName=attrName, name=attrName;if(attrName === "href" && toString.call(element.prop("href")) === "[object SVGAnimatedString]"){name = "xlinkHref";attr.$attr[name] = "xlink:href";propName = null;}attr.$observe(normalized, function(value){if(!value){if(attrName === "href"){attr.$set(name, null);}return;}attr.$set(name, value);if(msie && propName)element.prop(propName, attr[name]);});}};};});var nullFormCtrl={$addControl:noop, $removeControl:noop, $setValidity:noop, $setDirty:noop, $setPristine:noop};FormController.$inject = ["$element", "$attrs", "$scope", "$animate"];function FormController(element, attrs, $scope, $animate){var form=this, parentForm=element.parent().controller("form") || nullFormCtrl, invalidCount=0, errors=form.$error = {}, controls=[];form.$name = attrs.name || attrs.ngForm;form.$dirty = false;form.$pristine = true;form.$valid = true;form.$invalid = false;parentForm.$addControl(form);element.addClass(PRISTINE_CLASS);toggleValidCss(true);function toggleValidCss(isValid, validationErrorKey){validationErrorKey = validationErrorKey?"-" + snake_case(validationErrorKey, "-"):"";$animate.setClass(element, (isValid?VALID_CLASS:INVALID_CLASS) + validationErrorKey, (isValid?INVALID_CLASS:VALID_CLASS) + validationErrorKey);}form.$addControl = function(control){assertNotHasOwnProperty(control.$name, "input");controls.push(control);if(control.$name){form[control.$name] = control;}};form.$removeControl = function(control){if(control.$name && form[control.$name] === control){delete form[control.$name];}forEach(errors, function(queue, validationToken){form.$setValidity(validationToken, true, control);});arrayRemove(controls, control);};form.$setValidity = function(validationToken, isValid, control){var queue=errors[validationToken];if(isValid){if(queue){arrayRemove(queue, control);if(!queue.length){invalidCount--;if(!invalidCount){toggleValidCss(isValid);form.$valid = true;form.$invalid = false;}errors[validationToken] = false;toggleValidCss(true, validationToken);parentForm.$setValidity(validationToken, true, form);}}}else {if(!invalidCount){toggleValidCss(isValid);}if(queue){if(includes(queue, control))return;}else {errors[validationToken] = queue = [];invalidCount++;toggleValidCss(false, validationToken);parentForm.$setValidity(validationToken, false, form);}queue.push(control);form.$valid = false;form.$invalid = true;}};form.$setDirty = function(){$animate.removeClass(element, PRISTINE_CLASS);$animate.addClass(element, DIRTY_CLASS);form.$dirty = true;form.$pristine = false;parentForm.$setDirty();};form.$setPristine = function(){$animate.removeClass(element, DIRTY_CLASS);$animate.addClass(element, PRISTINE_CLASS);form.$dirty = false;form.$pristine = true;forEach(controls, function(control){control.$setPristine();});};}var formDirectiveFactory=function formDirectiveFactory(isNgForm){return ["$timeout", function($timeout){var formDirective={name:"form", restrict:isNgForm?"EAC":"E", controller:FormController, compile:function compile(){return {pre:function pre(scope, formElement, attr, controller){if(!attr.action){var preventDefaultListener=function preventDefaultListener(event){event.preventDefault?event.preventDefault():event.returnValue = false;};addEventListenerFn(formElement[0], "submit", preventDefaultListener);formElement.on("$destroy", function(){$timeout(function(){removeEventListenerFn(formElement[0], "submit", preventDefaultListener);}, 0, false);});}var parentFormCtrl=formElement.parent().controller("form"), alias=attr.name || attr.ngForm;if(alias){setter(scope, alias, controller, alias);}if(parentFormCtrl){formElement.on("$destroy", function(){parentFormCtrl.$removeControl(controller);if(alias){setter(scope, alias, undefined, alias);}extend(controller, nullFormCtrl);});}}};}};return formDirective;}];};var formDirective=formDirectiveFactory();var ngFormDirective=formDirectiveFactory(true);var URL_REGEXP=/^(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?$/;var EMAIL_REGEXP=/^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;var NUMBER_REGEXP=/^\s*(\-|\+)?(\d+|(\d*(\.\d*)))\s*$/;var inputType={text:textInputType, number:numberInputType, url:urlInputType, email:emailInputType, radio:radioInputType, checkbox:checkboxInputType, hidden:noop, button:noop, submit:noop, reset:noop, file:noop};function validate(ctrl, validatorName, validity, value){ctrl.$setValidity(validatorName, validity);return validity?value:undefined;}function testFlags(validity, flags){var i, flag;if(flags){for(i = 0; i < flags.length; ++i) {flag = flags[i];if(validity[flag]){return true;}}}return false;}function addNativeHtml5Validators(ctrl, validatorName, badFlags, ignoreFlags, validity){if(isObject(validity)){ctrl.$$hasNativeValidators = true;var validator=function validator(value){if(!ctrl.$error[validatorName] && !testFlags(validity, ignoreFlags) && testFlags(validity, badFlags)){ctrl.$setValidity(validatorName, false);return;}return value;};ctrl.$parsers.push(validator);}}function textInputType(scope, element, attr, ctrl, $sniffer, $browser){var validity=element.prop(VALIDITY_STATE_PROPERTY);var placeholder=element[0].placeholder, noevent={};var type=lowercase(element[0].type);ctrl.$$validityState = validity;if(!$sniffer.android){var composing=false;element.on("compositionstart", function(data){composing = true;});element.on("compositionend", function(){composing = false;listener();});}var listener=function listener(ev){if(composing){return;}var value=element.val();if(msie && (ev || noevent).type === "input" && element[0].placeholder !== placeholder){placeholder = element[0].placeholder;return;}if(type !== "password" && toBoolean(attr.ngTrim || "T")){value = trim(value);}var revalidate=validity && ctrl.$$hasNativeValidators;if(ctrl.$viewValue !== value || value === "" && revalidate){if(scope.$root.$$phase){ctrl.$setViewValue(value);}else {scope.$apply(function(){ctrl.$setViewValue(value);});}}};if($sniffer.hasEvent("input")){element.on("input", listener);}else {var timeout;var deferListener=function deferListener(){if(!timeout){timeout = $browser.defer(function(){listener();timeout = null;});}};element.on("keydown", function(event){var key=event.keyCode;if(key === 91 || 15 < key && key < 19 || 37 <= key && key <= 40)return;deferListener();});if($sniffer.hasEvent("paste")){element.on("paste cut", deferListener);}}element.on("change", listener);ctrl.$render = function(){element.val(ctrl.$isEmpty(ctrl.$viewValue)?"":ctrl.$viewValue);};var pattern=attr.ngPattern, patternValidator, match;if(pattern){var validateRegex=function validateRegex(regexp, value){return validate(ctrl, "pattern", ctrl.$isEmpty(value) || regexp.test(value), value);};match = pattern.match(/^\/(.*)\/([gim]*)$/);if(match){pattern = new RegExp(match[1], match[2]);patternValidator = function(value){return validateRegex(pattern, value);};}else {patternValidator = function(value){var patternObj=scope.$eval(pattern);if(!patternObj || !patternObj.test){throw minErr("ngPattern")("noregexp", "Expected {0} to be a RegExp but was {1}. Element: {2}", pattern, patternObj, startingTag(element));}return validateRegex(patternObj, value);};}ctrl.$formatters.push(patternValidator);ctrl.$parsers.push(patternValidator);}if(attr.ngMinlength){var minlength=int(attr.ngMinlength);var minLengthValidator=function minLengthValidator(value){return validate(ctrl, "minlength", ctrl.$isEmpty(value) || value.length >= minlength, value);};ctrl.$parsers.push(minLengthValidator);ctrl.$formatters.push(minLengthValidator);}if(attr.ngMaxlength){var maxlength=int(attr.ngMaxlength);var maxLengthValidator=function maxLengthValidator(value){return validate(ctrl, "maxlength", ctrl.$isEmpty(value) || value.length <= maxlength, value);};ctrl.$parsers.push(maxLengthValidator);ctrl.$formatters.push(maxLengthValidator);}}var numberBadFlags=["badInput"];function numberInputType(scope, element, attr, ctrl, $sniffer, $browser){textInputType(scope, element, attr, ctrl, $sniffer, $browser);ctrl.$parsers.push(function(value){var empty=ctrl.$isEmpty(value);if(empty || NUMBER_REGEXP.test(value)){ctrl.$setValidity("number", true);return value === ""?null:empty?value:parseFloat(value);}else {ctrl.$setValidity("number", false);return undefined;}});addNativeHtml5Validators(ctrl, "number", numberBadFlags, null, ctrl.$$validityState);ctrl.$formatters.push(function(value){return ctrl.$isEmpty(value)?"":"" + value;});if(attr.min){var minValidator=function minValidator(value){var min=parseFloat(attr.min);return validate(ctrl, "min", ctrl.$isEmpty(value) || value >= min, value);};ctrl.$parsers.push(minValidator);ctrl.$formatters.push(minValidator);}if(attr.max){var maxValidator=function maxValidator(value){var max=parseFloat(attr.max);return validate(ctrl, "max", ctrl.$isEmpty(value) || value <= max, value);};ctrl.$parsers.push(maxValidator);ctrl.$formatters.push(maxValidator);}ctrl.$formatters.push(function(value){return validate(ctrl, "number", ctrl.$isEmpty(value) || isNumber(value), value);});}function urlInputType(scope, element, attr, ctrl, $sniffer, $browser){textInputType(scope, element, attr, ctrl, $sniffer, $browser);var urlValidator=function urlValidator(value){return validate(ctrl, "url", ctrl.$isEmpty(value) || URL_REGEXP.test(value), value);};ctrl.$formatters.push(urlValidator);ctrl.$parsers.push(urlValidator);}function emailInputType(scope, element, attr, ctrl, $sniffer, $browser){textInputType(scope, element, attr, ctrl, $sniffer, $browser);var emailValidator=function emailValidator(value){return validate(ctrl, "email", ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value), value);};ctrl.$formatters.push(emailValidator);ctrl.$parsers.push(emailValidator);}function radioInputType(scope, element, attr, ctrl){if(isUndefined(attr.name)){element.attr("name", nextUid());}element.on("click", function(){if(element[0].checked){scope.$apply(function(){ctrl.$setViewValue(attr.value);});}});ctrl.$render = function(){var value=attr.value;element[0].checked = value == ctrl.$viewValue;};attr.$observe("value", ctrl.$render);}function checkboxInputType(scope, element, attr, ctrl){var trueValue=attr.ngTrueValue, falseValue=attr.ngFalseValue;if(!isString(trueValue))trueValue = true;if(!isString(falseValue))falseValue = false;element.on("click", function(){scope.$apply(function(){ctrl.$setViewValue(element[0].checked);});});ctrl.$render = function(){element[0].checked = ctrl.$viewValue;};ctrl.$isEmpty = function(value){return value !== trueValue;};ctrl.$formatters.push(function(value){return value === trueValue;});ctrl.$parsers.push(function(value){return value?trueValue:falseValue;});}var inputDirective=["$browser", "$sniffer", function($browser, $sniffer){return {restrict:"E", require:"?ngModel", link:function link(scope, element, attr, ctrl){if(ctrl){(inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrl, $sniffer, $browser);}}};}];var VALID_CLASS="ng-valid", INVALID_CLASS="ng-invalid", PRISTINE_CLASS="ng-pristine", DIRTY_CLASS="ng-dirty";var NgModelController=["$scope", "$exceptionHandler", "$attrs", "$element", "$parse", "$animate", function($scope, $exceptionHandler, $attr, $element, $parse, $animate){this.$viewValue = Number.NaN;this.$modelValue = Number.NaN;this.$parsers = [];this.$formatters = [];this.$viewChangeListeners = [];this.$pristine = true;this.$dirty = false;this.$valid = true;this.$invalid = false;this.$name = $attr.name;var ngModelGet=$parse($attr.ngModel), ngModelSet=ngModelGet.assign;if(!ngModelSet){throw minErr("ngModel")("nonassign", "Expression '{0}' is non-assignable. Element: {1}", $attr.ngModel, startingTag($element));}this.$render = noop;this.$isEmpty = function(value){return isUndefined(value) || value === "" || value === null || value !== value;};var parentForm=$element.inheritedData("$formController") || nullFormCtrl, invalidCount=0, $error=this.$error = {};$element.addClass(PRISTINE_CLASS);toggleValidCss(true);function toggleValidCss(isValid, validationErrorKey){validationErrorKey = validationErrorKey?"-" + snake_case(validationErrorKey, "-"):"";$animate.removeClass($element, (isValid?INVALID_CLASS:VALID_CLASS) + validationErrorKey);$animate.addClass($element, (isValid?VALID_CLASS:INVALID_CLASS) + validationErrorKey);}this.$setValidity = function(validationErrorKey, isValid){if($error[validationErrorKey] === !isValid)return;if(isValid){if($error[validationErrorKey])invalidCount--;if(!invalidCount){toggleValidCss(true);this.$valid = true;this.$invalid = false;}}else {toggleValidCss(false);this.$invalid = true;this.$valid = false;invalidCount++;}$error[validationErrorKey] = !isValid;toggleValidCss(isValid, validationErrorKey);parentForm.$setValidity(validationErrorKey, isValid, this);};this.$setPristine = function(){this.$dirty = false;this.$pristine = true;$animate.removeClass($element, DIRTY_CLASS);$animate.addClass($element, PRISTINE_CLASS);};this.$setViewValue = function(value){this.$viewValue = value;if(this.$pristine){this.$dirty = true;this.$pristine = false;$animate.removeClass($element, PRISTINE_CLASS);$animate.addClass($element, DIRTY_CLASS);parentForm.$setDirty();}forEach(this.$parsers, function(fn){value = fn(value);});if(this.$modelValue !== value){this.$modelValue = value;ngModelSet($scope, value);forEach(this.$viewChangeListeners, function(listener){try{listener();}catch(e) {$exceptionHandler(e);}});}};var ctrl=this;$scope.$watch(function ngModelWatch(){var value=ngModelGet($scope);if(ctrl.$modelValue !== value){var formatters=ctrl.$formatters, idx=formatters.length;ctrl.$modelValue = value;while(idx--) {value = formatters[idx](value);}if(ctrl.$viewValue !== value){ctrl.$viewValue = value;ctrl.$render();}}return value;});}];var ngModelDirective=function ngModelDirective(){return {require:["ngModel", "^?form"], controller:NgModelController, link:function link(scope, element, attr, ctrls){var modelCtrl=ctrls[0], formCtrl=ctrls[1] || nullFormCtrl;formCtrl.$addControl(modelCtrl);scope.$on("$destroy", function(){formCtrl.$removeControl(modelCtrl);});}};};var ngChangeDirective=valueFn({require:"ngModel", link:function link(scope, element, attr, ctrl){ctrl.$viewChangeListeners.push(function(){scope.$eval(attr.ngChange);});}});var requiredDirective=function requiredDirective(){return {require:"?ngModel", link:function link(scope, elm, attr, ctrl){if(!ctrl){return;}attr.required = true;var validator=function validator(value){if(attr.required && ctrl.$isEmpty(value)){ctrl.$setValidity("required", false);return;}else {ctrl.$setValidity("required", true);return value;}};ctrl.$formatters.push(validator);ctrl.$parsers.unshift(validator);attr.$observe("required", function(){validator(ctrl.$viewValue);});}};};var ngListDirective=function ngListDirective(){return {require:"ngModel", link:function link(scope, element, attr, ctrl){var match=/\/(.*)\//.exec(attr.ngList), separator=match && new RegExp(match[1]) || attr.ngList || ",";var parse=function parse(viewValue){if(isUndefined(viewValue)){return;}var list=[];if(viewValue){forEach(viewValue.split(separator), function(value){if(value)list.push(trim(value));});}return list;};ctrl.$parsers.push(parse);ctrl.$formatters.push(function(value){if(isArray(value)){return value.join(", ");}return undefined;});ctrl.$isEmpty = function(value){return !value || !value.length;};}};};var CONSTANT_VALUE_REGEXP=/^(true|false|\d+)$/;var ngValueDirective=function ngValueDirective(){return {priority:100, compile:function compile(tpl, tplAttr){if(CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)){return function ngValueConstantLink(scope, elm, attr){attr.$set("value", scope.$eval(attr.ngValue));};}else {return function ngValueLink(scope, elm, attr){scope.$watch(attr.ngValue, function valueWatchAction(value){attr.$set("value", value);});};}}};};var ngBindDirective=ngDirective({compile:function compile(templateElement){templateElement.addClass("ng-binding");return function(scope, element, attr){element.data("$binding", attr.ngBind);scope.$watch(attr.ngBind, function ngBindWatchAction(value){element.text(value == undefined?"":value);});};}});var ngBindTemplateDirective=["$interpolate", function($interpolate){return function(scope, element, attr){var interpolateFn=$interpolate(element.attr(attr.$attr.ngBindTemplate));element.addClass("ng-binding").data("$binding", interpolateFn);attr.$observe("ngBindTemplate", function(value){element.text(value);});};}];var ngBindHtmlDirective=["$sce", "$parse", function($sce, $parse){return {compile:function compile(tElement){tElement.addClass("ng-binding");return function(scope, element, attr){element.data("$binding", attr.ngBindHtml);var parsed=$parse(attr.ngBindHtml);function getStringValue(){return (parsed(scope) || "").toString();}scope.$watch(getStringValue, function ngBindHtmlWatchAction(value){element.html($sce.getTrustedHtml(parsed(scope)) || "");});};}};}];function classDirective(name, selector){name = "ngClass" + name;return ["$animate", function($animate){return {restrict:"AC", link:function link(scope, element, attr){var oldVal;scope.$watch(attr[name], ngClassWatchAction, true);attr.$observe("class", function(value){ngClassWatchAction(scope.$eval(attr[name]));});if(name !== "ngClass"){scope.$watch("$index", function($index, old$index){var mod=$index & 1;if(mod !== (old$index & 1)){var classes=arrayClasses(scope.$eval(attr[name]));mod === selector?addClasses(classes):removeClasses(classes);}});}function addClasses(classes){var newClasses=digestClassCounts(classes, 1);attr.$addClass(newClasses);}function removeClasses(classes){var newClasses=digestClassCounts(classes, -1);attr.$removeClass(newClasses);}function digestClassCounts(classes, count){var classCounts=element.data("$classCounts") || {};var classesToUpdate=[];forEach(classes, function(className){if(count > 0 || classCounts[className]){classCounts[className] = (classCounts[className] || 0) + count;if(classCounts[className] === +(count > 0)){classesToUpdate.push(className);}}});element.data("$classCounts", classCounts);return classesToUpdate.join(" ");}function updateClasses(oldClasses, newClasses){var toAdd=arrayDifference(newClasses, oldClasses);var toRemove=arrayDifference(oldClasses, newClasses);toRemove = digestClassCounts(toRemove, -1);toAdd = digestClassCounts(toAdd, 1);if(toAdd.length === 0){$animate.removeClass(element, toRemove);}else if(toRemove.length === 0){$animate.addClass(element, toAdd);}else {$animate.setClass(element, toAdd, toRemove);}}function ngClassWatchAction(newVal){if(selector === true || scope.$index % 2 === selector){var newClasses=arrayClasses(newVal || []);if(!oldVal){addClasses(newClasses);}else if(!equals(newVal, oldVal)){var oldClasses=arrayClasses(oldVal);updateClasses(oldClasses, newClasses);}}oldVal = shallowCopy(newVal);}}};function arrayDifference(tokens1, tokens2){var values=[];outer: for(var i=0; i < tokens1.length; i++) {var token=tokens1[i];for(var j=0; j < tokens2.length; j++) {if(token == tokens2[j])continue outer;}values.push(token);}return values;}function arrayClasses(classVal){if(isArray(classVal)){return classVal;}else if(isString(classVal)){return classVal.split(" ");}else if(isObject(classVal)){var classes=[], i=0;forEach(classVal, function(v, k){if(v){classes = classes.concat(k.split(" "));}});return classes;}return classVal;}}];}var ngClassDirective=classDirective("", true);var ngClassOddDirective=classDirective("Odd", 0);var ngClassEvenDirective=classDirective("Even", 1);var ngCloakDirective=ngDirective({compile:function compile(element, attr){attr.$set("ngCloak", undefined);element.removeClass("ng-cloak");}});var ngControllerDirective=[function(){return {scope:true, controller:"@", priority:500};}];var ngEventDirectives={};var forceAsyncEvents={blur:true, focus:true};forEach("click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste".split(" "), function(eventName){var directiveName=directiveNormalize("ng-" + eventName);ngEventDirectives[directiveName] = ["$parse", "$rootScope", function($parse, $rootScope){return {compile:function compile($element, attr){var fn=$parse(attr[directiveName], true);return function ngEventHandler(scope, element){element.on(eventName, function(event){var callback=function callback(){fn(scope, {$event:event});};if(forceAsyncEvents[eventName] && $rootScope.$$phase){scope.$evalAsync(callback);}else {scope.$apply(callback);}});};}};}];});var ngIfDirective=["$animate", function($animate){return {transclude:"element", priority:600, terminal:true, restrict:"A", $$tlb:true, link:function link($scope, $element, $attr, ctrl, $transclude){var block, childScope, previousElements;$scope.$watch($attr.ngIf, function ngIfWatchAction(value){if(toBoolean(value)){if(!childScope){childScope = $scope.$new();$transclude(childScope, function(clone){clone[clone.length++] = document.createComment(" end ngIf: " + $attr.ngIf + " ");block = {clone:clone};$animate.enter(clone, $element.parent(), $element);});}}else {if(previousElements){previousElements.remove();previousElements = null;}if(childScope){childScope.$destroy();childScope = null;}if(block){previousElements = getBlockElements(block.clone);$animate.leave(previousElements, function(){previousElements = null;});block = null;}}});}};}];var ngIncludeDirective=["$http", "$templateCache", "$anchorScroll", "$animate", "$sce", function($http, $templateCache, $anchorScroll, $animate, $sce){return {restrict:"ECA", priority:400, terminal:true, transclude:"element", controller:angular.noop, compile:function compile(element, attr){var srcExp=attr.ngInclude || attr.src, onloadExp=attr.onload || "", autoScrollExp=attr.autoscroll;return function(scope, $element, $attr, ctrl, $transclude){var changeCounter=0, currentScope, previousElement, currentElement;var cleanupLastIncludeContent=function cleanupLastIncludeContent(){if(previousElement){previousElement.remove();previousElement = null;}if(currentScope){currentScope.$destroy();currentScope = null;}if(currentElement){$animate.leave(currentElement, function(){previousElement = null;});previousElement = currentElement;currentElement = null;}};scope.$watch($sce.parseAsResourceUrl(srcExp), function ngIncludeWatchAction(src){var afterAnimation=function afterAnimation(){if(isDefined(autoScrollExp) && (!autoScrollExp || scope.$eval(autoScrollExp))){$anchorScroll();}};var thisChangeId=++changeCounter;if(src){$http.get(src, {cache:$templateCache}).success(function(response){if(thisChangeId !== changeCounter)return;var newScope=scope.$new();ctrl.template = response;var clone=$transclude(newScope, function(clone){cleanupLastIncludeContent();$animate.enter(clone, null, $element, afterAnimation);});currentScope = newScope;currentElement = clone;currentScope.$emit("$includeContentLoaded");scope.$eval(onloadExp);}).error(function(){if(thisChangeId === changeCounter)cleanupLastIncludeContent();});scope.$emit("$includeContentRequested");}else {cleanupLastIncludeContent();ctrl.template = null;}});};}};}];var ngIncludeFillContentDirective=["$compile", function($compile){return {restrict:"ECA", priority:-400, require:"ngInclude", link:function link(scope, $element, $attr, ctrl){$element.html(ctrl.template);$compile($element.contents())(scope);}};}];var ngInitDirective=ngDirective({priority:450, compile:function compile(){return {pre:function pre(scope, element, attrs){scope.$eval(attrs.ngInit);}};}});var ngNonBindableDirective=ngDirective({terminal:true, priority:1000});var ngPluralizeDirective=["$locale", "$interpolate", function($locale, $interpolate){var BRACE=/{}/g;return {restrict:"EA", link:function link(scope, element, attr){var numberExp=attr.count, whenExp=attr.$attr.when && element.attr(attr.$attr.when), offset=attr.offset || 0, whens=scope.$eval(whenExp) || {}, whensExpFns={}, startSymbol=$interpolate.startSymbol(), endSymbol=$interpolate.endSymbol(), isWhen=/^when(Minus)?(.+)$/;forEach(attr, function(expression, attributeName){if(isWhen.test(attributeName)){whens[lowercase(attributeName.replace("when", "").replace("Minus", "-"))] = element.attr(attr.$attr[attributeName]);}});forEach(whens, function(expression, key){whensExpFns[key] = $interpolate(expression.replace(BRACE, startSymbol + numberExp + "-" + offset + endSymbol));});scope.$watch(function ngPluralizeWatch(){var value=parseFloat(scope.$eval(numberExp));if(!isNaN(value)){if(!(value in whens))value = $locale.pluralCat(value - offset);return whensExpFns[value](scope, element, true);}else {return "";}}, function ngPluralizeWatchAction(newVal){element.text(newVal);});}};}];var ngRepeatDirective=["$parse", "$animate", function($parse, $animate){var NG_REMOVED="$$NG_REMOVED";var ngRepeatMinErr=minErr("ngRepeat");return {transclude:"element", priority:1000, terminal:true, $$tlb:true, link:function link($scope, $element, $attr, ctrl, $transclude){var expression=$attr.ngRepeat;var match=expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?\s*$/), trackByExp, trackByExpGetter, trackByIdExpFn, trackByIdArrayFn, trackByIdObjFn, lhs, rhs, valueIdentifier, keyIdentifier, hashFnLocals={$id:hashKey};if(!match){throw ngRepeatMinErr("iexp", "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.", expression);}lhs = match[1];rhs = match[2];trackByExp = match[3];if(trackByExp){trackByExpGetter = $parse(trackByExp);trackByIdExpFn = function(key, value, index){if(keyIdentifier)hashFnLocals[keyIdentifier] = key;hashFnLocals[valueIdentifier] = value;hashFnLocals.$index = index;return trackByExpGetter($scope, hashFnLocals);};}else {trackByIdArrayFn = function(key, value){return hashKey(value);};trackByIdObjFn = function(key){return key;};}match = lhs.match(/^(?:([\$\w]+)|\(([\$\w]+)\s*,\s*([\$\w]+)\))$/);if(!match){throw ngRepeatMinErr("iidexp", "'_item_' in '_item_ in _collection_' should be an identifier or '(_key_, _value_)' expression, but got '{0}'.", lhs);}valueIdentifier = match[3] || match[1];keyIdentifier = match[2];var lastBlockMap={};$scope.$watchCollection(rhs, function ngRepeatAction(collection){var index, length, previousNode=$element[0], nextNode, nextBlockMap={}, arrayLength, childScope, key, value, trackById, trackByIdFn, collectionKeys, block, nextBlockOrder=[], elementsToRemove;if(isArrayLike(collection)){collectionKeys = collection;trackByIdFn = trackByIdExpFn || trackByIdArrayFn;}else {trackByIdFn = trackByIdExpFn || trackByIdObjFn;collectionKeys = [];for(key in collection) {if(collection.hasOwnProperty(key) && key.charAt(0) != "$"){collectionKeys.push(key);}}collectionKeys.sort();}arrayLength = collectionKeys.length;length = nextBlockOrder.length = collectionKeys.length;for(index = 0; index < length; index++) {key = collection === collectionKeys?index:collectionKeys[index];value = collection[key];trackById = trackByIdFn(key, value, index);assertNotHasOwnProperty(trackById, "`track by` id");if(lastBlockMap.hasOwnProperty(trackById)){block = lastBlockMap[trackById];delete lastBlockMap[trackById];nextBlockMap[trackById] = block;nextBlockOrder[index] = block;}else if(nextBlockMap.hasOwnProperty(trackById)){forEach(nextBlockOrder, function(block){if(block && block.scope)lastBlockMap[block.id] = block;});throw ngRepeatMinErr("dupes", "Duplicates in a repeater are not allowed. Use 'track by' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}", expression, trackById, toJson(value));}else {nextBlockOrder[index] = {id:trackById};nextBlockMap[trackById] = false;}}for(key in lastBlockMap) {if(lastBlockMap.hasOwnProperty(key)){block = lastBlockMap[key];elementsToRemove = getBlockElements(block.clone);$animate.leave(elementsToRemove);forEach(elementsToRemove, function(element){element[NG_REMOVED] = true;});block.scope.$destroy();}}for(index = 0, length = collectionKeys.length; index < length; index++) {key = collection === collectionKeys?index:collectionKeys[index];value = collection[key];block = nextBlockOrder[index];if(nextBlockOrder[index - 1])previousNode = getBlockEnd(nextBlockOrder[index - 1]);if(block.scope){childScope = block.scope;nextNode = previousNode;do{nextNode = nextNode.nextSibling;}while(nextNode && nextNode[NG_REMOVED]);if(getBlockStart(block) != nextNode){$animate.move(getBlockElements(block.clone), null, jqLite(previousNode));}previousNode = getBlockEnd(block);}else {childScope = $scope.$new();}childScope[valueIdentifier] = value;if(keyIdentifier)childScope[keyIdentifier] = key;childScope.$index = index;childScope.$first = index === 0;childScope.$last = index === arrayLength - 1;childScope.$middle = !(childScope.$first || childScope.$last);childScope.$odd = !(childScope.$even = (index & 1) === 0);if(!block.scope){$transclude(childScope, function(clone){clone[clone.length++] = document.createComment(" end ngRepeat: " + expression + " ");$animate.enter(clone, null, jqLite(previousNode));previousNode = clone;block.scope = childScope;block.clone = clone;nextBlockMap[block.id] = block;});}}lastBlockMap = nextBlockMap;});}};function getBlockStart(block){return block.clone[0];}function getBlockEnd(block){return block.clone[block.clone.length - 1];}}];var ngShowDirective=["$animate", function($animate){return function(scope, element, attr){scope.$watch(attr.ngShow, function ngShowWatchAction(value){$animate[toBoolean(value)?"removeClass":"addClass"](element, "ng-hide");});};}];var ngHideDirective=["$animate", function($animate){return function(scope, element, attr){scope.$watch(attr.ngHide, function ngHideWatchAction(value){$animate[toBoolean(value)?"addClass":"removeClass"](element, "ng-hide");});};}];var ngStyleDirective=ngDirective(function(scope, element, attr){scope.$watch(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles){if(oldStyles && newStyles !== oldStyles){forEach(oldStyles, function(val, style){element.css(style, "");});}if(newStyles)element.css(newStyles);}, true);});var ngSwitchDirective=["$animate", function($animate){return {restrict:"EA", require:"ngSwitch", controller:["$scope", function ngSwitchController(){this.cases = {};}], link:function link(scope, element, attr, ngSwitchController){var watchExpr=attr.ngSwitch || attr.on, selectedTranscludes=[], selectedElements=[], previousElements=[], selectedScopes=[];scope.$watch(watchExpr, function ngSwitchWatchAction(value){var i, ii;for(i = 0, ii = previousElements.length; i < ii; ++i) {previousElements[i].remove();}previousElements.length = 0;for(i = 0, ii = selectedScopes.length; i < ii; ++i) {var selected=selectedElements[i];selectedScopes[i].$destroy();previousElements[i] = selected;$animate.leave(selected, function(){previousElements.splice(i, 1);});}selectedElements.length = 0;selectedScopes.length = 0;if(selectedTranscludes = ngSwitchController.cases["!" + value] || ngSwitchController.cases["?"]){scope.$eval(attr.change);forEach(selectedTranscludes, function(selectedTransclude){var selectedScope=scope.$new();selectedScopes.push(selectedScope);selectedTransclude.transclude(selectedScope, function(caseElement){var anchor=selectedTransclude.element;selectedElements.push(caseElement);$animate.enter(caseElement, anchor.parent(), anchor);});});}});}};}];var ngSwitchWhenDirective=ngDirective({transclude:"element", priority:800, require:"^ngSwitch", link:function link(scope, element, attrs, ctrl, $transclude){ctrl.cases["!" + attrs.ngSwitchWhen] = ctrl.cases["!" + attrs.ngSwitchWhen] || [];ctrl.cases["!" + attrs.ngSwitchWhen].push({transclude:$transclude, element:element});}});var ngSwitchDefaultDirective=ngDirective({transclude:"element", priority:800, require:"^ngSwitch", link:function link(scope, element, attr, ctrl, $transclude){ctrl.cases["?"] = ctrl.cases["?"] || [];ctrl.cases["?"].push({transclude:$transclude, element:element});}});var ngTranscludeDirective=ngDirective({link:function link($scope, $element, $attrs, controller, $transclude){if(!$transclude){throw minErr("ngTransclude")("orphan", "Illegal use of ngTransclude directive in the template! " + "No parent directive that requires a transclusion found. " + "Element: {0}", startingTag($element));}$transclude(function(clone){$element.empty();$element.append(clone);});}});var scriptDirective=["$templateCache", function($templateCache){return {restrict:"E", terminal:true, compile:function compile(element, attr){if(attr.type == "text/ng-template"){var templateUrl=attr.id, text=element[0].text;$templateCache.put(templateUrl, text);}}};}];var ngOptionsMinErr=minErr("ngOptions");var ngOptionsDirective=valueFn({terminal:true});var selectDirective=["$compile", "$parse", function($compile, $parse){var NG_OPTIONS_REGEXP=/^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/, nullModelCtrl={$setViewValue:noop};return {restrict:"E", require:["select", "?ngModel"], controller:["$element", "$scope", "$attrs", function($element, $scope, $attrs){var self=this, optionsMap={}, ngModelCtrl=nullModelCtrl, nullOption, unknownOption;self.databound = $attrs.ngModel;self.init = function(ngModelCtrl_, nullOption_, unknownOption_){ngModelCtrl = ngModelCtrl_;nullOption = nullOption_;unknownOption = unknownOption_;};self.addOption = function(value){assertNotHasOwnProperty(value, "\"option value\"");optionsMap[value] = true;if(ngModelCtrl.$viewValue == value){$element.val(value);if(unknownOption.parent())unknownOption.remove();}};self.removeOption = function(value){if(this.hasOption(value)){delete optionsMap[value];if(ngModelCtrl.$viewValue == value){this.renderUnknownOption(value);}}};self.renderUnknownOption = function(val){var unknownVal="? " + hashKey(val) + " ?";unknownOption.val(unknownVal);$element.prepend(unknownOption);$element.val(unknownVal);unknownOption.prop("selected", true);};self.hasOption = function(value){return optionsMap.hasOwnProperty(value);};$scope.$on("$destroy", function(){self.renderUnknownOption = noop;});}], link:function link(scope, element, attr, ctrls){if(!ctrls[1]){return;}var selectCtrl=ctrls[0], ngModelCtrl=ctrls[1], multiple=attr.multiple, optionsExp=attr.ngOptions, nullOption=false, emptyOption, optionTemplate=jqLite(document.createElement("option")), optGroupTemplate=jqLite(document.createElement("optgroup")), unknownOption=optionTemplate.clone();for(var i=0, children=element.children(), ii=children.length; i < ii; i++) {if(children[i].value === ""){emptyOption = nullOption = children.eq(i);break;}}selectCtrl.init(ngModelCtrl, nullOption, unknownOption);if(multiple){ngModelCtrl.$isEmpty = function(value){return !value || value.length === 0;};}if(optionsExp)setupAsOptions(scope, element, ngModelCtrl);else if(multiple)setupAsMultiple(scope, element, ngModelCtrl);else setupAsSingle(scope, element, ngModelCtrl, selectCtrl);function setupAsSingle(scope, selectElement, ngModelCtrl, selectCtrl){ngModelCtrl.$render = function(){var viewValue=ngModelCtrl.$viewValue;if(selectCtrl.hasOption(viewValue)){if(unknownOption.parent())unknownOption.remove();selectElement.val(viewValue);if(viewValue === "")emptyOption.prop("selected", true);}else {if(isUndefined(viewValue) && emptyOption){selectElement.val("");}else {selectCtrl.renderUnknownOption(viewValue);}}};selectElement.on("change", function(){scope.$apply(function(){if(unknownOption.parent())unknownOption.remove();ngModelCtrl.$setViewValue(selectElement.val());});});}function setupAsMultiple(scope, selectElement, ctrl){var lastView;ctrl.$render = function(){var items=new HashMap(ctrl.$viewValue);forEach(selectElement.find("option"), function(option){option.selected = isDefined(items.get(option.value));});};scope.$watch(function selectMultipleWatch(){if(!equals(lastView, ctrl.$viewValue)){lastView = shallowCopy(ctrl.$viewValue);ctrl.$render();}});selectElement.on("change", function(){scope.$apply(function(){var array=[];forEach(selectElement.find("option"), function(option){if(option.selected){array.push(option.value);}});ctrl.$setViewValue(array);});});}function setupAsOptions(scope, selectElement, ctrl){var match;if(!(match = optionsExp.match(NG_OPTIONS_REGEXP))){throw ngOptionsMinErr("iexp", "Expected expression in form of " + "'_select_ (as _label_)? for (_key_,)?_value_ in _collection_'" + " but got '{0}'. Element: {1}", optionsExp, startingTag(selectElement));}var displayFn=$parse(match[2] || match[1]), valueName=match[4] || match[6], keyName=match[5], groupByFn=$parse(match[3] || ""), valueFn=$parse(match[2]?match[1]:valueName), valuesFn=$parse(match[7]), track=match[8], trackFn=track?$parse(match[8]):null, optionGroupsCache=[[{element:selectElement, label:""}]];if(nullOption){$compile(nullOption)(scope);nullOption.removeClass("ng-scope");nullOption.remove();}selectElement.empty();selectElement.on("change", function(){scope.$apply(function(){var optionGroup, collection=valuesFn(scope) || [], locals={}, key, value, optionElement, index, groupIndex, length, groupLength, trackIndex;if(multiple){value = [];for(groupIndex = 0, groupLength = optionGroupsCache.length; groupIndex < groupLength; groupIndex++) {optionGroup = optionGroupsCache[groupIndex];for(index = 1, length = optionGroup.length; index < length; index++) {if((optionElement = optionGroup[index].element)[0].selected){key = optionElement.val();if(keyName)locals[keyName] = key;if(trackFn){for(trackIndex = 0; trackIndex < collection.length; trackIndex++) {locals[valueName] = collection[trackIndex];if(trackFn(scope, locals) == key)break;}}else {locals[valueName] = collection[key];}value.push(valueFn(scope, locals));}}}}else {key = selectElement.val();if(key == "?"){value = undefined;}else if(key === ""){value = null;}else {if(trackFn){for(trackIndex = 0; trackIndex < collection.length; trackIndex++) {locals[valueName] = collection[trackIndex];if(trackFn(scope, locals) == key){value = valueFn(scope, locals);break;}}}else {locals[valueName] = collection[key];if(keyName)locals[keyName] = key;value = valueFn(scope, locals);}}}ctrl.$setViewValue(value);render();});});ctrl.$render = render;scope.$watchCollection(valuesFn, render);scope.$watchCollection(function(){var locals={}, values=valuesFn(scope);if(values){var toDisplay=new Array(values.length);for(var i=0, ii=values.length; i < ii; i++) {locals[valueName] = values[i];toDisplay[i] = displayFn(scope, locals);}return toDisplay;}}, render);if(multiple){scope.$watchCollection(function(){return ctrl.$modelValue;}, render);}function getSelectedSet(){var selectedSet=false;if(multiple){var modelValue=ctrl.$modelValue;if(trackFn && isArray(modelValue)){selectedSet = new HashMap([]);var locals={};for(var trackIndex=0; trackIndex < modelValue.length; trackIndex++) {locals[valueName] = modelValue[trackIndex];selectedSet.put(trackFn(scope, locals), modelValue[trackIndex]);}}else {selectedSet = new HashMap(modelValue);}}return selectedSet;}function render(){var optionGroups={"":[]}, optionGroupNames=[""], optionGroupName, optionGroup, option, existingParent, existingOptions, existingOption, modelValue=ctrl.$modelValue, values=valuesFn(scope) || [], keys=keyName?sortedKeys(values):values, key, groupLength, length, groupIndex, index, locals={}, selected, selectedSet=getSelectedSet(), lastElement, element, label;for(index = 0; length = keys.length, index < length; index++) {key = index;if(keyName){key = keys[index];if(key.charAt(0) === "$")continue;locals[keyName] = key;}locals[valueName] = values[key];optionGroupName = groupByFn(scope, locals) || "";if(!(optionGroup = optionGroups[optionGroupName])){optionGroup = optionGroups[optionGroupName] = [];optionGroupNames.push(optionGroupName);}if(multiple){selected = isDefined(selectedSet.remove(trackFn?trackFn(scope, locals):valueFn(scope, locals)));}else {if(trackFn){var modelCast={};modelCast[valueName] = modelValue;selected = trackFn(scope, modelCast) === trackFn(scope, locals);}else {selected = modelValue === valueFn(scope, locals);}selectedSet = selectedSet || selected;}label = displayFn(scope, locals);label = isDefined(label)?label:"";optionGroup.push({id:trackFn?trackFn(scope, locals):keyName?keys[index]:index, label:label, selected:selected});}if(!multiple){if(nullOption || modelValue === null){optionGroups[""].unshift({id:"", label:"", selected:!selectedSet});}else if(!selectedSet){optionGroups[""].unshift({id:"?", label:"", selected:true});}}for(groupIndex = 0, groupLength = optionGroupNames.length; groupIndex < groupLength; groupIndex++) {optionGroupName = optionGroupNames[groupIndex];optionGroup = optionGroups[optionGroupName];if(optionGroupsCache.length <= groupIndex){existingParent = {element:optGroupTemplate.clone().attr("label", optionGroupName), label:optionGroup.label};existingOptions = [existingParent];optionGroupsCache.push(existingOptions);selectElement.append(existingParent.element);}else {existingOptions = optionGroupsCache[groupIndex];existingParent = existingOptions[0];if(existingParent.label != optionGroupName){existingParent.element.attr("label", existingParent.label = optionGroupName);}}lastElement = null;for(index = 0, length = optionGroup.length; index < length; index++) {option = optionGroup[index];if(existingOption = existingOptions[index + 1]){lastElement = existingOption.element;if(existingOption.label !== option.label){lastElement.text(existingOption.label = option.label);lastElement.prop("label", existingOption.label);}if(existingOption.id !== option.id){lastElement.val(existingOption.id = option.id);}if(lastElement[0].selected !== option.selected){lastElement.prop("selected", existingOption.selected = option.selected);if(msie){lastElement.prop("selected", existingOption.selected);}}}else {if(option.id === "" && nullOption){element = nullOption;}else {(element = optionTemplate.clone()).val(option.id).prop("selected", option.selected).attr("selected", option.selected).prop("label", option.label).text(option.label);}existingOptions.push(existingOption = {element:element, label:option.label, id:option.id, selected:option.selected});selectCtrl.addOption(option.label, element);if(lastElement){lastElement.after(element);}else {existingParent.element.append(element);}lastElement = element;}}index++;while(existingOptions.length > index) {option = existingOptions.pop();selectCtrl.removeOption(option.label);option.element.remove();}}while(optionGroupsCache.length > groupIndex) {optionGroupsCache.pop()[0].element.remove();}}}}};}];var optionDirective=["$interpolate", function($interpolate){var nullSelectCtrl={addOption:noop, removeOption:noop};return {restrict:"E", priority:100, compile:function compile(element, attr){if(isUndefined(attr.value)){var interpolateFn=$interpolate(element.text(), true);if(!interpolateFn){attr.$set("value", element.text());}}return function(scope, element, attr){var selectCtrlName="$selectController", parent=element.parent(), selectCtrl=parent.data(selectCtrlName) || parent.parent().data(selectCtrlName);if(selectCtrl && selectCtrl.databound){element.prop("selected", false);}else {selectCtrl = nullSelectCtrl;}if(interpolateFn){scope.$watch(interpolateFn, function interpolateWatchAction(newVal, oldVal){attr.$set("value", newVal);if(newVal !== oldVal)selectCtrl.removeOption(oldVal);selectCtrl.addOption(newVal);});}else {selectCtrl.addOption(attr.value);}element.on("$destroy", function(){selectCtrl.removeOption(attr.value);});};}};}];var styleDirective=valueFn({restrict:"E", terminal:true});if(window.angular.bootstrap){console.log("WARNING: Tried to load angular more than once.");return;}bindJQuery();publishExternalAPI(angular);jqLite(document).ready(function(){angularInit(document, bootstrap);});})(window, document);!window.angular.$$csp() && window.angular.element(document).find("head").prepend("<style type=\"text/css\">@charset \"UTF-8\";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide{display:none !important;}ng\\:form{display:block;}.ng-animate-block-transitions{transition:0s all!important;-webkit-transition:0s all!important;}.ng-hide-add-active,.ng-hide-remove{display:block!important;}</style>");

/***/ }),
/* 226 */
/***/ (function(module, exports) {

	/*
	 * matchmedia-ng (c) 2014 Jason Kulatunga, Inc. | http://analogj.mit-license.org/
	 */
	"use strict";
	
	(function (window, angular, undefined) {
	    "use strict";
	
	    angular.module("matchmedia-ng", []).provider("matchmedia", function () {
	
	        ///////////////////////////////////////////////////////////////////////
	        // Configuration
	        ///////////////////////////////////////////////////////////////////////
	        /**
	         *
	         * these settings can be changed by injecting matchmediaProvider into
	         * the config function of your module and
	         * changing the matchmediaProvider.rules with your own rule key value
	         * pairs E.G.
	          *  angular.module('app').config(['matchmediaProvider', function (matchmediaProvider) {
	         *      matchmediaProvider.rules.phone = "(max-width: 500px)";
	         *      matchmediaProvider.rules.desktop: = "(max-width: 1500px)";
	         *  }]);
	         *
	         * default values taken from twitter bootstrap :
	         * https://github.com/twitter/bootstrap/blob/master/less/responsive-utilities.less
	         */
	        var matchmedia = {
	            rules: {
	                print: "print",
	                screen: "screen",
	                phone: "(max-width: 767px)",
	                tablet: "(min-width: 768px) and (max-width: 979px)",
	                desktop: "(min-width: 980px)",
	                portrait: "(orientation: portrait)",
	                landscape: "(orientation: landscape)"
	            }
	        };
	        matchmedia.$get = ["$window", "safeApply", "logger", function ($window, safeApply, logger) {
	
	            logger.log("Creating matchmedia");
	
	            ///////////////////////////////////////////////////////////////////////
	            // Private Methods
	            ///////////////////////////////////////////////////////////////////////
	            function createSafeListener(cb, $scope) {
	                return function (mediaQueryList) {
	                    safeApply(function () {
	                        cb(mediaQueryList);
	                    }, $scope);
	                };
	            }
	
	            ///////////////////////////////////////////////////////////////////////
	            // Public Methods
	            ///////////////////////////////////////////////////////////////////////
	            //should never be called directly, but is available for custom calls.
	            var matchmediaService = {};
	
	            /**
	             * @param {string} query media query to listen on.
	             * @param {function(mediaQueryList)} listener Function to call when the media query is matched.
	             * @returns {function()} Returns a deregistration function for this listener.
	             */
	            matchmediaService.on = function (query, listener, $scope) {
	                var supportsMatchMedia = $window.matchMedia !== undefined && !!$window.matchMedia("all").addListener;
	                if (supportsMatchMedia) {
	                    logger.log("adding listener for query: " + query);
	                    var mediaQueryList = $window.matchMedia(query);
	                    var handler = createSafeListener(listener, $scope);
	                    mediaQueryList.addListener(handler);
	                    //immediately return the current mediaQueryList;
	                    handler(mediaQueryList);
	
	                    return function () {
	                        logger.log("removing listener from query: " + query);
	                        mediaQueryList.removeListener(handler);
	                    };
	                }
	            };
	            /**
	             * @param {string} query media query to test.
	             * @returns {mediaQueryList} Returns a boolean.
	             */
	            matchmediaService.is = function (query) {
	                logger.log("test query: " + query);
	                return $window.matchMedia(query).matches;
	            };
	
	            ///////////////////////////////////////////////////////////////////////
	            // Aliased Methods
	            ///////////////////////////////////////////////////////////////////////
	            matchmediaService.onPrint = function (listener, $scope) {
	                return matchmediaService.on(matchmedia.rules.print, listener, $scope);
	            };
	            matchmediaService.onScreen = function (listener, $scope) {
	                return matchmediaService.on(matchmedia.rules.screen, listener, $scope);
	            };
	            matchmediaService.onPhone = function (listener, $scope) {
	                return matchmediaService.on(matchmedia.rules.phone, listener, $scope);
	            };
	            matchmediaService.onTablet = function (listener, $scope) {
	                return matchmediaService.on(matchmedia.rules.tablet, listener, $scope);
	            };
	            matchmediaService.onDesktop = function (listener, $scope) {
	                return matchmediaService.on(matchmedia.rules.desktop, listener, $scope);
	            };
	            matchmediaService.onPortrait = function (listener, $scope) {
	                return matchmediaService.on(matchmedia.rules.portrait, listener, $scope);
	            };
	            matchmediaService.onLandscape = function (listener, $scope) {
	                return matchmediaService.on(matchmedia.rules.landscape, listener, $scope);
	            };
	
	            matchmediaService.isPrint = function () {
	                return matchmediaService.is(matchmedia.rules.print);
	            };
	            matchmediaService.isScreen = function () {
	                return matchmediaService.is(matchmedia.rules.screen);
	            };
	            matchmediaService.isPhone = function () {
	                return matchmediaService.is(matchmedia.rules.phone);
	            };
	            matchmediaService.isTablet = function () {
	                return matchmediaService.is(matchmedia.rules.tablet);
	            };
	            matchmediaService.isDesktop = function () {
	                return matchmediaService.is(matchmedia.rules.desktop);
	            };
	            matchmediaService.isPortrait = function () {
	                return matchmediaService.is(matchmedia.rules.portrait);
	            };
	            matchmediaService.isLandscape = function () {
	                return matchmediaService.is(matchmedia.rules.landscape);
	            };
	            return matchmediaService;
	        }];
	        return matchmedia;
	    }).directive("ajMatchmedia", ["matchmedia", function (matchmedia) {
	        return {
	            restrict: "E",
	            scope: {
	                queryListener: "&",
	                queryMatches: "="
	            },
	            link: function link(scope, element, attrs, controllers) {
	                var deregister;
	
	                if (attrs.on && attrs.queryListener) {
	                    if (attrs.on.slice(0, 2) === "on" && matchmedia[attrs.on] !== "undefined") {
	                        deregister = matchmedia[attrs.on](function (mediaQueryList) {
	                            scope.queryListener({ mediaQueryList: mediaQueryList });
	                        });
	                    } else {
	                        deregister = matchmedia.on(attrs.on, function (mediaQueryList) {
	                            scope.queryListener({ mediaQueryList: mediaQueryList });
	                        });
	                    }
	                    scope.$on("$destroy", deregister);
	                } else if (attrs.is && attrs.queryMatches) {
	                    if (attrs.is.slice(0, 2) === "is" && matchmedia[attrs.is] !== "undefined") {
	                        scope.queryMatches = matchmedia[attrs.is]();
	                    } else {
	                        scope.queryMatches = matchmedia.is(attrs.is);
	                    }
	                }
	            }
	        };
	    }]).factory("safeApply", ["$rootScope", function ($rootScope) {
	        return function (fn, $scope) {
	            $scope = $scope || $rootScope;
	            var phase = $scope.$root.$$phase;
	            if (phase == "$apply" || phase == "$digest") {
	                if (fn) {
	                    $scope.$eval(fn);
	                }
	            } else {
	                if (fn) {
	                    $scope.$apply(fn);
	                } else {
	                    $scope.$apply();
	                }
	            }
	        };
	    }]).provider("logger", function () {
	        this.DEVMODE = false;
	
	        this.setDEVMODE = function (devmode) {
	            this.DEVMODE = devmode;
	        };
	
	        this.$get = ["$window", "$log", function ($window, $log) {
	            var DEVMODE = this.DEVMODE;
	            var logger = {};
	            logger.log = function () {
	                if (DEVMODE) $log.info(arguments);
	            };
	            logger.always = function () {
	                $log.info(arguments);
	            };
	            return logger;
	        }];
	    });
	})(window, window.angular);

/***/ }),
/* 227 */
/***/ (function(module, exports) {

	/* =============================================================
	/*
	/*	 Angular Smooth Scroll 1.7.1
	/*	 Animates scrolling to elements, by David Oliveros.
	/*
	/*   Callback hooks contributed by Ben Armston
	/*   https://github.com/benarmston
	/*
	/*	 Easing support contributed by Willem Liu.
	/*	 https://github.com/willemliu
	/*
	/*	 Easing functions forked from Gaëtan Renaudeau.
	/*	 https://gist.github.com/gre/1650294
	/*
	/*	 Infinite loop bugs in iOS and Chrome (when zoomed) by Alex Guzman.
	/*	 https://github.com/alexguzman
	/*
	/*	 Influenced by Chris Ferdinandi
	/*	 https://github.com/cferdinandi
	/*
	/*
	/*	 Free to use under the MIT License.
	/*
	/* ============================================================= */
	
	"use strict";
	
	(function () {
		"use strict";
	
		var module = angular.module("smoothScroll", []);
	
		// Smooth scrolls the window to the provided element.
		//
		var smoothScroll = function smoothScroll(element, options) {
			options = options || {};
	
			// Options
			var duration = options.duration || 800,
			    offset = options.offset || 0,
			    easing = options.easing || "easeInOutQuart",
			    callbackBefore = options.callbackBefore || function () {},
			    callbackAfter = options.callbackAfter || function () {};
	
			var getScrollLocation = function getScrollLocation() {
				return window.pageYOffset ? window.pageYOffset : document.documentElement.scrollTop;
			};
	
			setTimeout(function () {
				var startLocation = getScrollLocation(),
				    timeLapsed = 0,
				    percentage,
				    position;
	
				// Calculate the easing pattern
				var easingPattern = function easingPattern(type, time) {
					if (type == "easeInQuad") {
						return time * time;
					} // accelerating from zero velocity
					if (type == "easeOutQuad") {
						return time * (2 - time);
					} // decelerating to zero velocity
					if (type == "easeInOutQuad") {
						return time < 0.5 ? 2 * time * time : -1 + (4 - 2 * time) * time;
					} // acceleration until halfway, then deceleration
					if (type == "easeInCubic") {
						return time * time * time;
					} // accelerating from zero velocity
					if (type == "easeOutCubic") {
						return --time * time * time + 1;
					} // decelerating to zero velocity
					if (type == "easeInOutCubic") {
						return time < 0.5 ? 4 * time * time * time : (time - 1) * (2 * time - 2) * (2 * time - 2) + 1;
					} // acceleration until halfway, then deceleration
					if (type == "easeInQuart") {
						return time * time * time * time;
					} // accelerating from zero velocity
					if (type == "easeOutQuart") {
						return 1 - --time * time * time * time;
					} // decelerating to zero velocity
					if (type == "easeInOutQuart") {
						return time < 0.5 ? 8 * time * time * time * time : 1 - 8 * --time * time * time * time;
					} // acceleration until halfway, then deceleration
					if (type == "easeInQuint") {
						return time * time * time * time * time;
					} // accelerating from zero velocity
					if (type == "easeOutQuint") {
						return 1 + --time * time * time * time * time;
					} // decelerating to zero velocity
					if (type == "easeInOutQuint") {
						return time < 0.5 ? 16 * time * time * time * time * time : 1 + 16 * --time * time * time * time * time;
					} // acceleration until halfway, then deceleration
					return time; // no easing, no acceleration
				};
	
				// Calculate how far to scroll
				var getEndLocation = function getEndLocation(element) {
					var location = 0;
					if (element.offsetParent) {
						do {
							location += element.offsetTop;
							element = element.offsetParent;
						} while (element);
					}
					location = Math.max(location - offset, 0);
					return location;
				};
	
				var endLocation = getEndLocation(element);
				var distance = endLocation - startLocation;
	
				// Stop the scrolling animation when the anchor is reached (or at the top/bottom of the page)
				var stopAnimation = function stopAnimation() {
					var currentLocation = getScrollLocation();
					if (position == endLocation || currentLocation == endLocation || window.innerHeight + currentLocation >= document.body.scrollHeight) {
						clearInterval(runAnimation);
						callbackAfter(element);
					}
				};
	
				// Scroll the page by an increment, and check if it's time to stop
				var animateScroll = function animateScroll() {
					timeLapsed += 16;
					percentage = timeLapsed / duration;
					percentage = percentage > 1 ? 1 : percentage;
					position = startLocation + distance * easingPattern(easing, percentage);
					window.scrollTo(0, position);
					stopAnimation();
				};
	
				// Init
				callbackBefore(element);
				var runAnimation = setInterval(animateScroll, 16);
			}, 0);
		};
	
		// Expose the library in a factory
		//
		module.factory("smoothScroll", function () {
			return smoothScroll;
		});
	
		// Scrolls the window to this element, optionally validating an expression
		//
		module.directive("smoothScroll", ["smoothScroll", function (smoothScroll) {
			return {
				restrict: "A",
				scope: {
					callbackBefore: "&",
					callbackAfter: "&" },
				link: function link($scope, $elem, $attrs) {
					if (typeof $attrs.scrollIf === "undefined" || $attrs.scrollIf === "true") {
						setTimeout(function () {
	
							var callbackBefore = function callbackBefore(element) {
								if ($attrs.callbackBefore) {
									var exprHandler = $scope.callbackBefore({ element: element });
									if (typeof exprHandler === "function") {
										exprHandler(element);
									}
								}
							};
	
							var callbackAfter = function callbackAfter(element) {
								if ($attrs.callbackAfter) {
									var exprHandler = $scope.callbackAfter({ element: element });
									if (typeof exprHandler === "function") {
										exprHandler(element);
									}
								}
							};
	
							smoothScroll($elem[0], {
								duration: $attrs.duration,
								offset: $attrs.offset,
								easing: $attrs.easing,
								callbackBefore: callbackBefore,
								callbackAfter: callbackAfter
							});
						}, 0);
					}
				}
			};
		}]);
	
		// Scrolls to a specified element ID when this element is clicked
		//
		module.directive("scrollTo", ["smoothScroll", function (smoothScroll) {
			return {
				restrict: "A",
				scope: {
					callbackBefore: "&",
					callbackAfter: "&" },
				link: function link($scope, $elem, $attrs) {
					var targetElement;
	
					$elem.on("click", function (e) {
						e.preventDefault();
	
						targetElement = document.getElementById($attrs.scrollTo);
						if (!targetElement) return;
	
						var callbackBefore = function callbackBefore(element) {
							if ($attrs.callbackBefore) {
								var exprHandler = $scope.callbackBefore({ element: element });
								if (typeof exprHandler === "function") {
									exprHandler(element);
								}
							}
						};
	
						var callbackAfter = function callbackAfter(element) {
							if ($attrs.callbackAfter) {
								var exprHandler = $scope.callbackAfter({ element: element });
								if (typeof exprHandler === "function") {
									exprHandler(element);
								}
							}
						};
	
						smoothScroll(targetElement, {
							duration: $attrs.duration,
							offset: $attrs.offset,
							easing: $attrs.easing,
							callbackBefore: callbackBefore,
							callbackAfter: callbackAfter
						});
	
						return false;
					});
				}
			};
		}]);
	})();

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function (ngModule) {
	  ngModule.run(["$rootScope", "$state", "$stateParams", "Auth", "$log", "$location", "AonApplicationService", "AonConfig", function ($rootScope, $state, $stateParams, Auth, $log, $location, AonApplicationService, AonConfig) {
	    /**
	     * Get a field of the state object. Inherits values from parent states - child states take precedence.
	     * @param stateName
	     * @param fieldName
	     * @returns {Object}
	     */
	    function getStateFieldInherited(stateName, fieldName) {
	      var data = {};
	      var parts = stateName.split(".");
	      while (parts.length) {
	        var stateData = $state.get(parts.join("."));
	        if (stateData && stateData[fieldName]) {
	          data = angular.extend(angular.copy(stateData[fieldName]), data);
	        }
	        parts.pop();
	      }
	      return data;
	    }
	
	    // References to state variables so templates can easily use them, eg. add class based on active route
	    $rootScope.$state = $state;
	    $rootScope.$stateParams = $stateParams;
	    $rootScope.$on("$stateChangeError", function (event, toState, toParams, fromState, fromParams, error) {
	      if (_.isObject(error) && error.code === 401) {
	        $state.go("welcome");
	      } else {
	        $log.debug(arguments);
	      }
	    });
	
	    // Check for an operator query string and override AonConfig entry with it if present
	    var checkOperator = function () {
	      if ($location.search().hasOwnProperty("operator")) {
	        AonConfig.operator.operator_type = $location.search().operator;
	      }
	    };
	
	    // Handling authorisation on routes
	    // NOTE: This won't stop route transitions. If this becomes problematic then move to a solution that always
	    // calls event.preventDefault(), checks auth and then if valid re-fires $state.go without firing event
	    $rootScope.$on("$stateChangeStart", function (event, toState) {
	      checkOperator();
	      var applyFromApplicationId = !!$location.search().applicationId;
	      var require = applyFromApplicationId ? {} : getStateFieldInherited(toState.name, "require");
	      var baseRoute = AonConfig.corporate.is_operator ? "operator" : "comparator";
	
	      if (require.auth) {
	        Auth.check()["catch"](function () {
	          if ($location.search().hasOwnProperty("code")) {
	            var success = function () {};
	            var error = function () {
	              $state.go("welcome");
	            };
	            Auth.login($location.search().code).then(success, error);
	          } else {
	            $state.go("welcome");
	          }
	        });
	      }
	
	      if (require.price && !AonApplicationService.hasPrice()) {
	        if (toState.name === "" + baseRoute + ".step2") {
	          console.error("Route loop detected; step 2 should not require price!");
	        } else {
	          event.preventDefault();
	          $state.go("" + baseRoute + ".step2");
	        }
	      }
	
	      if (require.applicant && !AonApplicationService.hasAddressAndState() && !/[?&]quote=/.test(location.href)) {
	        if (toState.name === "" + baseRoute + ".step1") {
	          console.error("Route loop detected; step 1 should not require state!");
	        } else {
	          event.preventDefault();
	          $state.go("" + baseRoute + ".step1");
	        }
	      }
	
	      if (require.passwordRetrieval) {
	        if (!AonConfig.corporate.allow_code_email_retrieval) {
	          event.preventDefault();
	          $state.go("welcome");
	        }
	      }
	    });
	  }]);
	
	  ngModule.config(["$stateProvider", "$urlRouterProvider", "AonConfig", function ($stateProvider, $urlRouterProvider, AonConfig) {
	    $urlRouterProvider.otherwise("/welcome");
	
	    // Allow a per-corporate override on the application page template url
	    var templateUrlCorporateOverride = function (defaultName) {
	      return function () {
	        var templateName = AonConfig.corporate.apply_page_template || defaultName;
	        return "/static/partials/" + templateName + ".html?d=201506051053";
	      };
	    };
	
	    $stateProvider.state("welcome", {
	      url: "/welcome",
	      template: __webpack_require__(311),
	      controller: "WelcomeCtrl",
	      controllerAs: "ctrl" }).state("retrievepassword", {
	      url: "/retrievepassword",
	      template: __webpack_require__(320),
	      controller: "RetrievePasswordCtrl",
	      controllerAs: "ctrl",
	      require: {
	        passwordRetrieval: true } }).state("faq", {
	      url: "/faq",
	      template: __webpack_require__(309),
	      controllerAs: "ctrl",
	      controller: ["AonConfig", function (AonConfig) {
	        this.deployment = AonConfig.deployment;
	      }] }).state("cookies", {
	      url: "/cookies",
	      template: __webpack_require__(307),
	      controllerAs: "ctrl",
	      controller: ["AonConfig", function (AonConfig) {
	        this.deployment = AonConfig.deployment;
	      }] }).state("legal", {
	      url: "/legal",
	      template: __webpack_require__(312),
	      controllerAs: "ctrl",
	      controller: ["AonConfig", function (AonConfig) {
	        this.deployment = AonConfig.deployment;
	        this.corporate = AonConfig.corporate;
	      }] }).state("privacy", {
	      url: "/privacy",
	      template: __webpack_require__(317),
	      controllerAs: "ctrl",
	      controller: ["AonConfig", function (AonConfig) {
	        this.deployment = AonConfig.deployment;
	      }] }).state("contact", {
	      url: "/contact",
	      template: __webpack_require__(306),
	      controllerAs: "ctrl",
	      controller: ["AonConfig", function (AonConfig) {
	        this.content = AonConfig.corporate.contact_html;
	      }] }).state("operator", {
	      template: __webpack_require__(313),
	      url: "/operator",
	      controller: "RootCtrl",
	      controllerAs: "ctrl",
	      require: {
	        auth: true },
	      resolve: {
	        // This call is to fetch the initial, pre-selected services, either using
	        // data from zoho or the regular service pre-selection. It is not used in
	        // this controller, but is a dependency of steps 1 and 2.
	        preselectedServices: ["AonApplicationService", "AonProducts", function (AonApplicationService, AonProducts) {
	          return AonApplicationService.getApplication().then(function (applicant) {
	            return AonProducts.getPreselectedServices(applicant).then(function (services) {
	              AonProducts.saveServices(services);
	            });
	          });
	        }] } }).state("operator.step1", {
	      url: "/about",
	      template: __webpack_require__(314),
	      controller: "OperatorStep1Ctrl",
	      controllerAs: "ctrl",
	      resolve: {
	        application: ["AonApplicationService", function (AonApplicationService) {
	          return AonApplicationService.getApplication();
	        }],
	        // Note: we need to include preselectedServices as a parameter so that angular
	        // knows to wait for the parent state to resolve that promise before fetching
	        // the services again. See also step 2 where this is used.
	        services: ["AonApplicationService", "AonProducts", "preselectedServices", function (AonApplicationService, AonProducts, preselectedServices) {
	          return AonApplicationService.getApplication().then(function (applicant) {
	            return AonProducts.getServices(applicant);
	          });
	        }] } }).state("operator.step2", {
	      url: "/compare",
	      template: __webpack_require__(315),
	      resolve: {
	        application: ["AonApplicationService", function (AonApplicationService) {
	          return AonApplicationService.getApplication();
	        }],
	        services: ["AonApplicationService", "AonProducts", "preselectedServices", function (AonApplicationService, AonProducts, preselectedServices) {
	          return AonApplicationService.getApplication().then(function (applicant) {
	            return AonProducts.getServices(applicant);
	          });
	        }] },
	      controller: "OperatorStep2Ctrl",
	      controllerAs: "ctrl" }).state("comparator", {
	      template: __webpack_require__(300),
	      controller: "RootCtrl",
	      controllerAs: "ctrl",
	      require: {
	        auth: true } }).state("comparator.step1", {
	      url: "/about",
	      template: __webpack_require__(301),
	      controller: "ComparatorStep1Ctrl",
	      controllerAs: "ctrl",
	      resolve: {
	        application: ["AonApplicationService", function (AonApplicationService) {
	          return AonApplicationService.getApplication();
	        }] } }).state("comparator.step2", {
	      url: "/compare?quote",
	      template: __webpack_require__(302),
	      require: {
	        applicant: true },
	      resolve: {
	        services: ["AonApplicationService", "AonProducts", function (AonApplicationService, AonProducts) {
	          return AonApplicationService.getApplication().then(function (applicant) {
	            return AonProducts.getPreselectedServices(applicant);
	          });
	        }] },
	      controller: "ComparatorStep2Ctrl",
	      controllerAs: "ctrl" }).state("comparator.retention", {
	      url: "/apply",
	      template: __webpack_require__(319),
	      require: {
	        price: true },
	      controller: "ComparatorRetentionCtrl",
	      controllerAs: "ctrl",
	      resolve: {
	        application: ["AonApplicationService", function (AonApplicationService) {
	          return AonApplicationService.getApplication();
	        }] } }).state("comparator.step3", {
	      url: "/apply?applicationId&priceId",
	      template: __webpack_require__(304),
	      require: {
	        price: true },
	      controller: "ComparatorStep3Ctrl",
	      controllerAs: "ctrl",
	      resolve: {
	        loadFromApplication: ["AonApplicationService", "AonApi", "$location", "Auth", "$state", function (AonApplicationService, AonApi, $location, Auth, $state) {
	          if (false) {
	            var _ret = (function () {
	              // In local dev, allow loading the application page directly by appending
	              // a query param: applicationId=1234
	              var applicationId = $location.search().applicationId;
	              var priceId = $location.search().priceId;
	              if (applicationId) {
	                Auth.zohoLogin();
	
	                return {
	                  v: AonApi.get("load-application-json/" + applicationId).then(function (response) {
	                    var json = response.data;
	                    AonApplicationService.getApplication().then(function (applicant) {
	                      AonApplicationService.saveApplication(json);
	                      AonApi.fetchPrice(applicant, priceId || json.product.price.id).then(function (_ref) {
	                        var pkg = _ref.data;
	
	                        var price = pkg.price;
	                        pkg.selectedPrice = price;
	                        AonApplicationService.setProduct(pkg);
	                        AonApplicationService.setPrice(price);
	                        if (!$location.path().split("/").includes("rebate")) {
	                          $state.go("comparator.step3." + price.fund.code, {
	                            applicationId: applicationId,
	                            priceId: priceId });
	                        }
	                      });
	                    });
	                  })
	                };
	              }
	            })();
	
	            if (typeof _ret === "object") return _ret.v;
	          } else {
	            return Promise.resolve();
	          }
	        }],
	        // The following resolves need to include loadFromApplication, so that they wait for the
	        // above promise to resolve before doing their own things.
	        fieldsets: ["AonApplicationService", "loadFromApplication", function (AonApplicationService, loadFromApplication) {
	          return AonApplicationService.getFieldSets();
	        }],
	        application: ["AonApplicationService", "loadFromApplication", function (AonApplicationService, loadFromApplication) {
	          return AonApplicationService.getApplication();
	        }],
	        zohoStage: ["AonApplicationService", "ZohoService", "loadFromApplication", function (AonApplicationService, ZohoService, loadFromApplication) {
	          return AonApplicationService.getApplication().then(function (applicant) {
	            if (applicant.zoho_id) {
	              return ZohoService.getStage(applicant.zoho_id);
	            } else {
	              return null;
	            }
	          });
	        }] } })
	
	    // -- Per-fund application routes --//
	    // ACA (non-gateway fund)
	    .state("comparator.step3.aca", {
	      url: "/aca",
	      controller: "ComparatorStep3CtrlHAMBS",
	      controllerAs: "hambsCtrl",
	      templateUrl: "/static/partials/apply.hambs.html?d=201506051053" }).state("comparator.step3.ahb", {
	      url: "/ahb",
	      controller: "ComparatorStep3CtrlHAMBS",
	      controllerAs: "hambsCtrl",
	      templateUrl: "/static/partials/apply.ahb.html?d=201510200651" }).state("comparator.step3.ahm", {
	      url: "/ahm",
	      controller: "ComparatorStep3CtrlAHM",
	      controllerAs: "ahmctrl",
	      templateUrl: "/static/partials/apply.ahm.html" })
	    // Australian Unity
	    .state("comparator.step3.auf", {
	      url: "/auf",
	      controller: "ComparatorStep3CtrlAUF",
	      controllerAs: "aufctrl",
	      templateUrl: "/static/partials/apply.auf.html?d=201506051053" })
	    // HUNTER HEALTH (non-gateway fund)
	    .state("comparator.step3.cdh", {
	      url: "/cdh",
	      controller: "ComparatorStep3CtrlNoGateway",
	      controllerAs: "nogatewayCtrl",
	      templateUrl: "/static/partials/apply.nogateway.html?d=201506051053" })
	    // EMERGENCY SERVICES HEALTH (non-gateway fund)
	    .state("comparator.step3.esh", {
	      url: "/esh",
	      controller: "ComparatorStep3CtrlHAMBS",
	      controllerAs: "hambsCtrl",
	      templateUrl: "/static/partials/apply.hambs.html?d=201506051053" }).state("comparator.step3.gmh02", {
	      url: "/frank",
	      templateUrl: "/static/partials/apply.gmh.html?d=201506051053" })
	    // GMHBA
	    .state("comparator.step3.gmh", {
	      url: "/gmh",
	      templateUrl: "/static/partials/apply.gmh.html?d=201506051053" }).state("comparator.step3.hbf", {
	      url: "/hbf",
	      controller: "ComparatorStep3CtrlHBF",
	      controllerAs: "hbfctrl",
	      templateUrl: "/static/partials/apply.hbf.html?d=201511241532" }).state("comparator.step3.hcf", {
	      url: "/hcf",
	      controller: "ComparatorStep3CtrlHCF",
	      controllerAs: "hcfctrl",
	      templateUrl: "/static/partials/apply.hcf.html?d=201506051053" }).state("comparator.step3.hcfcorp", {
	      url: "/hcf",
	      controller: "ComparatorStep3CtrlHCF",
	      controllerAs: "hcfctrl",
	      templateUrl: "/static/partials/apply.hcf.html?d=201506051053" })
	    // HIF
	    .state("comparator.step3.hif", {
	      url: "/hif",
	      controller: "ComparatorStep3CtrlHIF",
	      controllerAs: "hambsCtrl",
	      templateUrl: "/static/partials/apply.hambs.html?d=201506051053" })
	    // PEOPLECARE
	    .state("comparator.step3.lhm", {
	      url: "/lhm",
	      controller: "ComparatorStep3CtrlHAMBS",
	      controllerAs: "hambsCtrl",
	      templateUrl: "/static/partials/apply.hambs.html?d=201506051053" })
	    // MYOWN
	    .state("comparator.step3.myo", {
	      url: "/myo",
	      controller: "ComparatorStep3CtrlHAMBS",
	      controllerAs: "hambsCtrl",
	      templateUrl: "/static/partials/apply.hambs.html?d=201506051053" })
	    // AIA (re-branding of MYOWN)
	    .state("comparator.step3.aia", {
	      url: "/aia",
	      controller: "ComparatorStep3CtrlHAMBS",
	      controllerAs: "hambsCtrl",
	      templateUrl: "/static/partials/apply.aia.html?d=201506051053" })
	    // NAVY HEALTH
	    .state("comparator.step3.nhb", {
	      url: "/nhb",
	      controller: "ComparatorStep3CtrlNHB",
	      controllerAs: "hambsCtrl",
	      templateUrl: "/static/partials/apply.nhb.html?d=201506051053" }).state("comparator.step3.nib", {
	      url: "/nib",
	      controller: "ComparatorStep3CtrlNIB",
	      controllerAs: "nibctrl",
	      templateUrl: "/static/partials/apply.nib.html?d=201506051053" })
	    // NURSES + MIDWIVES HEALTH
	    .state("comparator.step3.nmw", {
	      url: "/nmw",
	      templateUrl: "/static/partials/apply.ntf.html?d=201506051053" })
	    // TEACHERS HEALTH
	    .state("comparator.step3.ntf", {
	      url: "/ntf",
	      templateUrl: "/static/partials/apply.ntf.html?d=201506051053" })
	    // PHOENIX
	    .state("comparator.step3.pwa", {
	      url: "/pwa",
	      controller: "ComparatorStep3CtrlHAMBS",
	      controllerAs: "hambsCtrl",
	      templateUrl: "/static/partials/apply.pwa.html?d=201506051053" })
	    // HCI
	    .state("comparator.step3.hci", {
	      url: "/hci",
	      controller: "ComparatorStep3CtrlHCI",
	      controllerAs: "hambsCtrl",
	      templateUrl: "/static/partials/apply.hci.html?d=201506051053" })
	    // TUH
	    .state("comparator.step3.qtu", {
	      url: "/tuh",
	      controller: "ComparatorStep3CtrlHAMBS",
	      controllerAs: "hambsCtrl",
	      templateUrl: "/static/partials/apply.hambs.html?d=201506051053" })
	    // Union HEALTH
	    .state("comparator.step3.qtu01", {
	      url: "/uhf",
	      controller: "ComparatorStep3CtrlHAMBS",
	      controllerAs: "hambsCtrl",
	      templateUrl: "/static/partials/apply.hambs.html?d=201506051053" })
	    // RT HEALTH
	    .state("comparator.step3.rte", {
	      url: "/rte",
	      controller: "ComparatorStep3CtrlRTE",
	      controllerAs: "rtectrl",
	      templateUrl: "/static/partials/apply.rte.html?d=201506051053" })
	    // POLICE HEALTH (non-gateway fund)
	    .state("comparator.step3.spe", {
	      url: "/spe",
	      controller: "ComparatorStep3CtrlNoGateway",
	      controllerAs: "nogatewayCtrl",
	      templateUrl: "/static/partials/apply.nogateway.html?d=201506051053" })
	    // HEALTH PARTNERS (based on RT health application)
	    .state("comparator.step3.sps", {
	      url: "/sps",
	      controller: "ComparatorStep3CtrlSPS",
	      controllerAs: "subCtrl",
	      templateUrl: templateUrlCorporateOverride("apply.sps") })
	    // TRANSPORT HEALTH (non-gateway fund)
	    .state("comparator.step3.tfs", {
	      url: "/tfs",
	      controller: "ComparatorStep3CtrlHAMBS",
	      controllerAs: "hambsCtrl",
	      templateUrl: "/static/partials/apply.hambs.html?d=201506051053" })
	    // UNIHEALTH
	    .state("comparator.step3.uni", {
	      url: "/uni",
	      templateUrl: "/static/partials/apply.ntf.html?d=201506051053" })
	    // MEDIBANK
	    .state("comparator.step3.mbp", {
	      /*
	        Medibank does not transition to step 3. On application submission, the
	        backend generates a redirect url to Medibank's site, and we redirect there.
	        */
	      url: "/mbp",
	      resolve: {
	        GenerateReference: ["AonApplicationService", "AonConfig", "$q", "$state", "$log", function (AonApplicationService, AonConfig, $q, $state, $log) {
	          AonApplicationService.getApplication().then(function (app) {
	            var onError = function () {
	              AonApplicationService.product.isTransitioningToApply = false;
	              $state.go("comparator.error", {
	                message: "This product is currently unavailable through this service. You can use the contact details to advise this error." });
	            };
	            var onSuccess = function (response) {
	              if (AonApplicationService.isDebug()) {
	                AonApplicationService.product.isTransitioningToApply = false;
	                $log.info(response.redirect_to);
	              } else {
	                AonApplicationService.trackEvent(AonConfig.jsConstants.TrackingEvents.Application, AonApplicationService.product.fund.id);
	                window.location.href = response.redirect_to;
	              }
	            };
	            AonApplicationService.submitApplication(app).then(onSuccess, onError);
	          });
	          return $q.reject();
	        }] } }).state("comparator.step3.rebate", {
	      url: "/rebate",
	      template: __webpack_require__(303),
	      resolve: {
	        application: ["AonApplicationService", function (AonApplicationService) {
	          return AonApplicationService.getApplication();
	        }] } }).state("comparator.step4", {
	      url: "/success",
	      template: __webpack_require__(305),
	      controller: "ComparatorStep4Ctrl",
	      controllerAs: "ctrl",
	      resolve: {
	        response: ["AonApplicationService", function (AonApplicationService) {
	          return AonApplicationService.getResponse();
	        }],
	        application: ["AonApplicationService", function (AonApplicationService) {
	          return AonApplicationService.getApplication();
	        }] } }).state("comparator.error", {
	      url: "/error",
	      template: __webpack_require__(299),
	      controllerAs: "ctrl",
	      controller: ["$stateParams", function controller($stateParams) {
	        this.message = $stateParams.message;
	      }],
	      params: {
	        message: null } }).state("comparator.zoho", {
	      url: "/zoho/:leadId?price&operator",
	      template: __webpack_require__(323),
	      controller: "ZohoCtrl",
	      controllerAs: "ctrl",
	      require: {
	        auth: false } }).state("quote", {
	      url: "/quote/:leadId/:priceId?phone",
	      template: __webpack_require__(318),
	      controller: "QuoteCtrl",
	      controllerAs: "ctrl",
	      require: {
	        auth: false } }).state("price-summary", {
	      url: "/price-summary/:priceId",
	      template: __webpack_require__(316),
	      controller: "PriceSummaryCtrl",
	      controllerAs: "ctrl",
	      require: {
	        auth: false } });
	  }]);
	};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { "default": obj }; };
	
	var comparatorUtilities = _interopRequireWildcard(__webpack_require__(2));
	
	module.exports = function (ngModule) {
	
	  ngModule.controller("OperatorStep1Ctrl", ["AonConfig", "AonApplicationService", "AonProducts", "application", "OperatorService", "services", "$scope", "$state", "ZohoService", function (AonConfig, AonApplicationService, AonProducts, application, OperatorService, services, $scope, $state, ZohoService) {
	    var _this = this;
	
	    this.formChoices = AonConfig.formChoices;
	    this.corporate = AonConfig.corporate;
	    this.deployment = AonConfig.deployment;
	    this.application = application;
	    this.rebate_tier_choices = AonApplicationService.getRebateTierChoices(application);
	    this.services = services;
	    this.operatorFilters = OperatorService.filters;
	
	    this.is_service_comparison_tool = this.corporate.is_service_comparison_tool;
	
	    $scope.$parent.ctrl.scrollToId(["active-quote-banner", "ui-view"]);
	
	    this.lhc_age_validator = {
	      error_messages: {
	        percentage: "Please enter an even percentage between 0% and 70%",
	        number: "Please enter an age between 30 and 110" } };
	
	    // Ensure age is integral
	    this.onAgeChange = function (model) {
	      if (model.age) {
	        model.age = parseInt(model.age);
	      }
	    };
	
	    var youth_discount_age_validation_message = "Please enter an age between 18 and 30";
	    this.youth_discount_age_validator = {
	      error_messages: {
	        min: youth_discount_age_validation_message,
	        max: youth_discount_age_validation_message }
	    };
	
	    // Ensure youth discount age is integral
	    this.onYouthDiscountAgeChange = function (model) {
	      if (model.primary_youth_discount_age) {
	        model.primary_youth_discount_age = parseInt(model.primary_youth_discount_age);
	      }
	      if (model.partner_youth_discount_age) {
	        model.partner_youth_discount_age = parseInt(model.partner_youth_discount_age);
	      }
	    };
	
	    this.onDOBChanged = function () {
	      var isPageLoad = arguments[0] === undefined ? false : arguments[0];
	
	      // If we are coming back here from the comparison screen, don't trigger
	      // the update to youth discount ages
	      var comingFromComparison = $scope.lastRoute === "/compare";
	
	      var setYouthDiscountAge = function (field, age) {
	        if (comingFromComparison) {
	          return;
	        }
	        if (age >= 18 && age <= 29) {
	          // If this is change was triggered by the page load, only set a value if there is not already one set
	          // If triggered by an actual change on DOB, always update the age
	          var doUpdate = !isPageLoad || !_.get(_this.application, field);
	          if (doUpdate) {
	            _.set(_this.application, field, age);
	          }
	        } else if (age < 18 || age > 44) {
	          _.set(_this.application, field, null);
	        }
	      };
	      var dob = _.get(_this.application, "personal.dob");
	      var primaryAge = comparatorUtilities.calculateLHCAge(dob, { financialYear: false });
	      setYouthDiscountAge("policy.primary_youth_discount_age", primaryAge);
	      if (_this.application.hasPartner()) {
	        if (primaryAge >= 30) {
	          // Youth discount is only applicable where primary policy holder is under 30
	          // (but an age could still be manually entered for the partner)
	          _.set(_this.application, "policy.partner_youth_discount_age", null);
	        } else {
	          var partnerDob = _.get(_this.application, "partner.dob");
	          var partnerAge = comparatorUtilities.calculateLHCAge(partnerDob, { financialYear: false });
	          setYouthDiscountAge("policy.partner_youth_discount_age", partnerAge);
	        }
	      }
	      if (!_this.showContinuousCoverQuestion()) {
	        _.set(_this.application, "policy.held_continuous_hospital_cover", null);
	      }
	      _this.onChangeHasContinuousCover(isPageLoad);
	    };
	
	    this.showYouthDiscountAge = function (person) {
	      if (_this.is_service_comparison_tool || !_this.formChoices.is_youth_discount_available) {
	        return false;
	      }
	      var age = comparatorUtilities.calculateAge(person.dob);
	      return age >= 18 && age <= 44;
	    };
	
	    this.servicesInColumns = comparatorUtilities.splitServicesIntoColumns(services);
	
	    var getContinuousCover = function () {
	      return _.get(_this.application, "policy.held_continuous_hospital_cover", null);
	    };
	
	    this.continuousCoverQuestionLabel = function () {
	      return _this.application.hasPartner() ? "Have you and your partner held continuous hospital cover for the last 10 consecutive years or since your 31st birthday?" : "Have you held continuous hospital cover for the last 10 consecutive years or since your 31st birthday?";
	    };
	
	    this.showContinuousCoverQuestion = function () {
	      return comparatorUtilities.calculateCombinedRebateAge(application) > 30;
	    };
	    this.showLHCAgeQuestions = function () {
	      return _this.corporate.capture_lhc_age && getContinuousCover() === false;
	    };
	
	    // When continuous cover yes/no changes, pre-fill the LHC ages
	    this.onChangeHasContinuousCover = function () {
	      var isPageLoad = arguments[0] === undefined ? false : arguments[0];
	
	      var primaryDob = _.get(_this.application, "personal.dob");
	      var setAgePrimary = getContinuousCover() ? 30 : comparatorUtilities.calculateAge(primaryDob);
	      // const setAgePrimary = getContinuousCover() ? 30 : comparatorUtilities.calculateAge(primaryDob, { financialYear: true });
	      // If this is change was triggered by the page load, only set a value if there is not already one set
	      var doUpdate = !isPageLoad || !_.get(_this.application, "policy.lhc_age");
	      if (doUpdate) {
	        _.set(_this.application, "policy.lhc_age", setAgePrimary);
	      }
	
	      if (_this.application.hasPartner()) {
	        var partnerDob = _.get(_this.application, "partner.dob");
	        var setAgePartner = getContinuousCover() ? 30 : comparatorUtilities.calculateAge(partnerDob);
	        // const setAgePartner = getContinuousCover() ? 30 : comparatorUtilities.calculateAge(partnerDob, { financialYear: true });
	        var _doUpdate = !isPageLoad || !_.get(_this.application, "policy.lhc_age_partner");
	        if (_doUpdate) {
	          _.set(_this.application, "policy.lhc_age_partner", setAgePartner);
	        }
	      }
	    };
	
	    this.onMembershipTypeChange = function () {
	      _this.rebate_tier_choices = AonApplicationService.getRebateTierChoices(application);
	      var text = AonApplicationService.getRebateTierText(application);
	      _this.rebate_tier_caption = text.caption;
	      _this.rebate_tier_description = text.description;
	
	      _this.rebate_tier_matrix_choices = [];
	      var rebateAge = comparatorUtilities.calculateCombinedRebateAge(application);
	      var groups = [{ groupLabel: "Age < 65", range: [0, 65] }, { groupLabel: "Age 65-70", range: [65, 70] }, { groupLabel: "Age >= 70", range: [70, 200] }];
	      for (var i = 0; i < 3; i++) {
	        var _groups$i = groups[i];
	        var groupLabel = _groups$i.groupLabel;
	        var range = _groups$i.range;
	
	        var ageInRange = rebateAge >= range[0] && rebateAge < range[1];
	        if (!rebateAge || ageInRange) {
	          for (var j = 0; j < _this.rebate_tier_choices.length; j++) {
	            _this.rebate_tier_matrix_choices.push({
	              group: groupLabel,
	              value: i.toString() + "," + j.toString(),
	              tier: _this.rebate_tier_choices[j][1] });
	          }
	        }
	      }
	
	      // Update the previous health fund membership type if applicable and not already set
	      var policyMembership = _.get(_this.application, "policy.membership_type", null);
	      var hasPreviousFund = _.get(_this.application, "personal.previous_fund.has_previous_fund", false);
	      var currentHealthFundMembership = _.get(_this.application, "personal.previous_fund.membership", null);
	      if (policyMembership !== null && currentHealthFundMembership === null && hasPreviousFund) {
	        _.set(_this.application, "personal.previous_fund.membership", policyMembership);
	      }
	
	      if (!_this.application.hasPartner()) {
	        _.set(_this.application, "policy.lhc_age_partner", null);
	        _.set(_this.application, "policy.partner_youth_discount_age", null);
	      }
	    };
	
	    AonApplicationService.getApplication().then(function (applicant) {
	      _this.applicant = applicant;
	      if (_.get(_this.application, "policy.cover_type", null) === null) {
	        _.set(_this.application, "policy.cover_type", 2);
	      }
	    });
	
	    /**
	     * Save the applicant changes
	     */
	    this.onSubmit = function (form) {
	
	      // If this applicant has a zoho id, save the selected services to zoho
	      if (_this.application.zoho_id) {
	        var selectedServices = function (services) {
	          return services.filter(function (s) {
	            return s.selected;
	          }).map(function (s) {
	            return s.id;
	          });
	        };
	        var applicantData = comparatorUtilities.applicantWithDOB(_this.application);
	        ZohoService.sendNeedsAnalysisToZoho(_this.applicant.zoho_id, applicantData);
	        ZohoService.saveServicesToZoho(_this.application.zoho_id, {
	          hospital: selectedServices(services.hospital),
	          ancillary: selectedServices(services.ancillary) });
	      }
	
	      _this.hasSubmitted = false;
	
	      if (form.$valid) {
	        AonProducts.saveServices(services);
	        AonApplicationService.saveApplication(_this.application);
	        if (_this.offerCompetition) {
	          if (_this.application.enter_competition) {
	            // TODO(cal): send comp info to aon
	            AonApplicationService.setCompetitionOptIn(); // flag as opted in, to avoid re-showing
	          } else {
	            AonApplicationService.setCompetitionOptOut(); // flag as opted out, to avoid re-showing
	          }
	        }
	        $state.transitionTo("operator.step2");
	      } else {
	        if (form.focusInvalid) {
	          form.focusInvalid();
	        }
	        _this.hasSubmitted = true;
	      }
	    };
	
	    var fundFromId = function (id) {
	      var fund = _this.formChoices.previous_fund.filter(function (e) {
	        return e.id == id;
	      });
	      if (fund.length) {
	        return fund[0];
	      } else {
	        return null;
	      }
	    };
	
	    this.selectPreviousFund = function () {
	      var fund = fundFromId(_this.application.personal.previous_fund.fund_id);
	      _this.application.personal.previous_fund.fund_name = fund ? fund.title : "Unknown";
	    };
	
	    // When selecting a state, update the previous fund state as well, if it is not already set to a value
	    this.selectState = function () {
	      var state = _.get(_this.application, "primary_address.state", null);
	      var hasPreviousFund = _.get(_this.application, "personal.previous_fund.has_previous_fund", false);
	      var currentHealthFundState = _.get(_this.application, "personal.previous_fund.state", null);
	      if (state !== null && currentHealthFundState === null && hasPreviousFund) {
	        _.set(_this.application, "personal.previous_fund.state", state);
	      }
	    };
	
	    // If previous fund state changes, set previous fund state (if not already set) to personal state (f set),
	    // same for membership type
	    this.changeHasPreviousFund = function () {
	      _this.selectState();
	      _this.onMembershipTypeChange();
	    };
	
	    this.updateRebateTier = function () {
	      var tier = _this.application.policy.rebate_tier_matrix.split(",");
	      _this.application.policy.rebate_tier_age_index = parseInt(tier[0]);
	      _this.application.policy.rebate_tier = parseInt(tier[1]);
	    };
	
	    this.hasAnsweredCurrentFund = function () {
	      var has_previous_fund = _.get(_this.application, "personal.previous_fund.has_previous_fund");
	      return has_previous_fund === true || has_previous_fund === false;
	    };
	
	    // If coming from a Zoho quote, previous fund and state may already be set,
	    // so check and trigger the onChange handlers if required
	    if (_.get(this.application, "personal.previous_fund.fund_id")) {
	      this.selectPreviousFund();
	    }
	    if (_.get(this.application, "primary_address.state")) {
	      this.selectState();
	    }
	    this.onMembershipTypeChange();
	    this.onDOBChanged(true);
	
	    // This one needs to come after onMembershipTypeChange has set up the rebate tier choices
	    var rebateTier = _.get(this.application, "policy.rebate_tier", null);
	    if (rebateTier !== null) {
	      var rebateTierChoice = this.rebate_tier_matrix_choices[rebateTier];
	      if (rebateTierChoice) {
	        _.set(this.application, "policy.rebate_tier_matrix", rebateTierChoice.value);
	        this.updateRebateTier();
	      }
	    }
	
	    var onCoverTypeChange = function () {
	      var requiresHospital = _this.application.requiresHospitalProducts();
	      var requiresAncillary = _this.application.requiresAncillaryProducts();
	      if (!requiresHospital) {
	        services.hospital.forEach(function (service) {
	          service.selected = false;
	        });
	      }
	      if (!requiresAncillary) {
	        services.ancillary.forEach(function (service) {
	          service.selected = false;
	        });
	      }
	    };
	
	    $scope.$watch("ctrl.application.personal.dob", this.onMembershipTypeChange);
	    $scope.$watch("ctrl.application.personal.age", this.onMembershipTypeChange);
	    $scope.$watch("ctrl.application.partner.dob", this.onMembershipTypeChange);
	    $scope.$watch("ctrl.application.partner.age", this.onMembershipTypeChange);
	    $scope.$watch("ctrl.application.policy.cover_type", onCoverTypeChange);
	
	    this.rebateAge = function () {
	      var age = comparatorUtilities.calculateRebateAge(_this.application.personal);
	      var endDate = comparatorUtilities.getLastFinancialYearEndDate();
	      return age ? "Age " + age + " as at 1 July " + endDate.getFullYear() : null;
	    };
	
	    this.rebateAgePartner = function () {
	      if (_this.application.hasPartner()) {
	        var age = comparatorUtilities.calculateRebateAge(_this.application.partner);
	        var endDate = comparatorUtilities.getLastFinancialYearEndDate();
	        return age ? "Partner age " + age + " as at 1 July " + endDate.getFullYear() : null;
	      }
	    };
	  }]);
	};

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { "default": obj }; };
	
	var _utilityComparator = __webpack_require__(2);
	
	var comparatorUtilities = _interopRequireWildcard(_utilityComparator);
	
	var savePriceSummaryLinkInformation = _utilityComparator.savePriceSummaryLinkInformation;
	
	module.exports = function (ngModule) {
	
	    ngModule.controller("OperatorStep2Ctrl", ["AonApi", "AonApplicationService", "AonConfig", "AonProducts", "application", "matchmedia", "OperatorService", "services", "$scope", "$state", "$stateParams", "$window", "ZohoService", function (AonApi, AonApplicationService, AonConfig, AonProducts, application, matchmedia, OperatorService, services, $scope, $state, $stateParams, $window, ZohoService) {
	        var _this = this;
	
	        this.corporate = AonConfig.corporate;
	        this.formChoices = AonConfig.formChoices;
	        this.paymentFrequencies = AonConfig.jsConstants.PaymentFrequencies;
	        this.isLoadingResults = false;
	        this.debugOverlay = AonApplicationService.isDebug();
	        this.services = services;
	
	        this.getPricing = $scope.$parent.ctrl.getPricing;
	        this.currentPrice = $scope.$parent.ctrl.currentPrice;
	        this.currentPriceForDD = $scope.$parent.ctrl.currentPriceForDD;
	        this.futurePrice = $scope.$parent.ctrl.futurePrice;
	        this.futurePriceDifference = $scope.$parent.ctrl.futurePriceDifference;
	        this.paymentFrequencyLabel = $scope.$parent.ctrl.paymentFrequencyLabel;
	
	        this.operatorFilterControl = OperatorService.controls;
	        this.operatorFilters = OperatorService.filters;
	        this.paymentFrequencyChoices = OperatorService.paymentFrequencyChoices();
	        this.hasDefaultDiscount = OperatorService.hasDefaultDiscount();
	        this.operatorFilters.offset = 0;
	        this.detailsPaneOpen = true;
	
	        this.showDirectDebitDiscountLines = this.formChoices.direct_debit_discount_available;
	
	        // Based on configuration, optionally show a link next to each price
	        // that opens a new tab and fetches a detailed summary of the pricing for
	        // a given price id. We store the applicant data into local storage and
	        // retrieve it in the price summary controller.
	        this.showPriceSummaryLink = AonConfig.deployment.show_price_summary_link;
	        if (this.showPriceSummaryLink) {
	            savePriceSummaryLinkInformation(application);
	        }
	        this.generatePriceSummaryLink = function (priceId) {
	            return "" + window.location.pathname + "#/price-summary/" + priceId;
	        };
	
	        var generateCompareLink = function () {
	            var previous_fund = _.get(_this.applicant, "personal.previous_fund", {});
	            var comparison_product = _.get(_this.applicant, "comparison_product", {});
	            var args = [previous_fund.hospital_product ? "current-hospital=" + previous_fund.hospital_product.id : null, previous_fund.ancillary_product ? "current-ancillary=" + previous_fund.ancillary_product.id : null, comparison_product.hospital_product ? "new-hospital=" + comparison_product.hospital_product.id : null, comparison_product.ancillary_product ? "new-ancillary=" + comparison_product.ancillary_product.id : null].filter(Boolean).join("&");
	            return "/api/compare-product-services?" + args;
	        };
	
	        var resetScrollPosition = function () {
	            $scope.$parent.ctrl.scrollToId(["active-quote-banner", "ui-view"]);
	        };
	
	        window.scrollTo(0, 0);
	        resetScrollPosition();
	
	        this.hasActiveQuote = function () {
	            return _.get(_this.applicant, "zoho.has_quote");
	        };
	
	        var priceIsQuotedPrice = function (price) {
	            var rateCode = _.get(_this.applicant, "zoho.rate_code");
	            return rateCode === String(price.id);
	        };
	
	        this.refine = function () {
	            var leavePaneOpen = arguments[0] === undefined ? false : arguments[0];
	
	            var excess_field = "excess";
	
	            var ancillary = _.filter(services.ancillary, "selected");
	
	            var hospital = _.filter(services.hospital, "selected");
	
	            _this.isLoadingResults = true;
	            var success = function (response) {
	                var hasQuote = _this.hasActiveQuote();
	                var rebatePercentage = comparatorUtilities.calcRebate(_this.applicant, AonApplicationService);
	                var healthCoverLoading = comparatorUtilities.calcLHC(_this.applicant, AonApplicationService);
	                _this.applicant.policy.healthCoverLoading = healthCoverLoading;
	                _this.applicant.policy.rebatePercentage = response.data.applicant.rebate_percent;
	                var packages = response.data.packages,
	
	                // Get max number of excess options for a package
	                maxExcessCount = _(packages).pluck("prices").map("length").max();
	                _this.responsive = packages.length < 4;
	
	                // Map over each package to perform price calculations, sort prices, format excess, etc.
	                _this.packages = _.map(response.data.packages, function (pricePackage) {
	
	                    pricePackage.prices = _.map(pricePackage.prices, function (p) {
	                        p[excess_field] = p[excess_field].split(".")[0];
	                        p.phioUrls = p.phio_product_sheet_links;
	                        return p;
	                    });
	                    if (pricePackage.fund.code === "ahb") {
	                        (function () {
	                            // Sort by fund product code, then excess
	                            var codeMap = { C: "a", R: "b", A: "c" };
	                            pricePackage.prices = pricePackage.prices.sort(function (a, b) {
	                                var stringComp = codeMap[a.fund_product_code.slice(-1)].localeCompare(codeMap[b.fund_product_code.slice(-1)]);
	                                if (stringComp != 0) {
	                                    return stringComp;
	                                } else {
	                                    return b[excess_field] - a[excess_field];
	                                }
	                            });
	                        })();
	                    } else {
	                        pricePackage.prices = pricePackage.prices.sort(function (a, b) {
	                            return b[excess_field] - a[excess_field];
	                        });
	                    }
	
	                    comparatorUtilities.applyDirectDebitDiscount(pricePackage);
	                    comparatorUtilities.priceCalculations(pricePackage, rebatePercentage, healthCoverLoading, _this.operatorFilters.payment_frequency);
	
	                    // If a $500 excess product is available, select it as the default
	                    var excess_500_index = pricePackage.prices.findIndex(function (price) {
	                        return price[excess_field] == 500;
	                    });
	                    var defaultSelectedPriceIndex = excess_500_index > -1 ? excess_500_index : 0;
	                    pricePackage.selectedPrice = pricePackage.prices[defaultSelectedPriceIndex];
	
	                    // If the applicant has an active quote, and it is in this package, select it
	                    if (hasQuote) {
	                        var quotedPriceIndex = pricePackage.prices.findIndex(priceIsQuotedPrice);
	                        if (quotedPriceIndex > -1) {
	                            pricePackage.selectedPrice = pricePackage.prices[quotedPriceIndex];
	                        }
	                    }
	
	                    pricePackage.features = {
	                        hospital: comparatorUtilities.getProductFeatures(pricePackage, _this.services.hospital, pricePackage.hospital_product.product_hospital_services),
	                        ancillary: comparatorUtilities.getProductFeatures(pricePackage, _this.services.ancillary, pricePackage.ancillary_product.product_ancillary_services) };
	                    pricePackage.showUnselectedServices = {
	                        hospital: false,
	                        ancillary: false
	                    };
	
	                    // Calculate how many prices this package is short by. This is purely so we can add empty dom elements
	                    // so that heights match up across columns in the HTML. Not very elegant, but easiest solution while
	                    // maintaining responsive flow of columns.
	                    var shortBy = maxExcessCount - pricePackage.prices.length;
	                    if (shortBy > 0) {
	                        pricePackage.fillerPrices = _.range(0, shortBy);
	                    }
	                    return pricePackage;
	                });
	
	                // Build a list of applicable fund-level offers
	                var offered_funds = _.map(packages, function (p) {
	                    return p.fund.id;
	                });
	                _this.fund_offers = _.filter(_this.corporate.fund_offers, function (o) {
	                    return (o.cover == _this.applicant.policy.cover_type || o.cover == -1) && _.contains(offered_funds, o.fund_id);
	                });
	                _this.fund_offers = _.map(_this.fund_offers, function (o) {
	                    return {
	                        fund_name: o.fund_name,
	                        offer: o.offer };
	                });
	            },
	                error = function (err) {
	                console.log(err);
	            },
	                fin = function () {
	                _this.isLoadingResults = false;
	                resetScrollPosition();
	            };
	
	            AonApplicationService.getApplication().then(function (applicant) {
	                var applicantData = comparatorUtilities.applicantWithDOB(applicant);
	
	                AonProducts.searchPackages(applicantData, {
	                    hospital: hospital,
	                    ancillary: ancillary }, _this.operatorFilters).then(success, error)["finally"](fin);
	            });
	        };
	
	        this.toggleUnselectedServiceSummary = function (pkg, type) {
	            if (matchmedia.isPhone()) {
	                pkg.showUnselectedServices[type] = !pkg.showUnselectedServices[type];
	            } else {
	                var _status = !pkg.showUnselectedServices[type];
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = _this.packages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var p = _step.value;
	
	                        p.showUnselectedServices[type] = _status;
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator["return"]) {
	                            _iterator["return"]();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	            }
	        };
	
	        this.checkedPrices = {};
	        this.checkPriceLoading = {};
	        /**
	         * Check prices with the fund
	         * @param pkg
	         */
	        this.checkPrice = function (pkg) {
	            var applicant = _this.applicant;
	            var price = pkg.selectedPrice;
	            _this.checkPriceLoading[pkg.id] = true;
	            AonApi.post("funds/" + pkg.fund.id + "/pricecheck", { applicant: applicant, price: price }).then(function (result) {
	                _this.checkedPricesProduct = price;
	                _this.checkedPrices = _.assign(_this.checkedPrices, result.data);
	                $("#check-price.modal").modal();
	            })["finally"](function () {
	                return _this.checkPriceLoading[pkg.id] = false;
	            });
	        };
	
	        var isRetention = function (fund) {
	            if (!fund || !fund.code) {
	                return false;
	            }
	            if (!_.get(_this.applicant, "personal.previous_fund.has_previous_fund", false)) {
	                return false;
	            }
	            return _.get(_this.applicant, "personal.previous_fund.fund_id", "").toLowerCase() === fund.code.toLowerCase();
	        };
	
	        var saveQuoteAndContinue = function (saleType, nextUrl) {
	            // If we have a Zoho id, update applicant record in Zoho when operator clicks 'Apply'
	            if (_this.applicant.zoho_id) {
	                try {
	                    // Don't wait for this to finish or anything, just fire off the save quote and carry on
	                    _this.saveZohoQuote();
	                } catch (error) {
	                    console.warn("Error saving quote - ", error);
	                }
	            }
	            AonApplicationService.getApplication().then(function (applicant) {
	                _.set(applicant, "sale.type", saleType);
	                AonApplicationService.saveApplication(applicant);
	                $state.transitionTo(nextUrl);
	            });
	        };
	
	        this.apply = function (price, pkg) {
	            AonApplicationService.setProduct(pkg);
	            AonApplicationService.setPrice(price);
	            var applicationLink = _.get(_this.applicant, "quote_details.application_link");
	            if (applicationLink && !applicationLink.split("://")[1].startsWith(window.location.hostname)) {
	                window.open(applicationLink, "_blank");
	            } else {
	                var code = price.fund.code.split(".")[0];
	                saveQuoteAndContinue("distribution", "comparator.step3." + code);
	            }
	        };
	
	        AonApplicationService.getApplication().then(function (applicant) {
	            _this.applicant = applicant;
	            if (_this.corporate.is_service_comparison_tool) {
	                _this.serviceComparisonLink = generateCompareLink();
	            }
	
	            _this.refine(true);
	        });
	
	        this.countServices = function (pkg) {
	            var n_ancillary = pkg.ancillary_product.product_ancillary_services ? pkg.ancillary_product.product_ancillary_services.length : 0;
	            var n_hospital = pkg.hospital_product.product_hospital_services ? pkg.hospital_product.product_hospital_services.filter(function (e) {
	                return !e.excluded;
	            }).length : 0;
	            return {
	                ancillary: n_ancillary,
	                hospital: n_hospital };
	        };
	
	        this.limitTotals = function (pkg) {
	            var limits = pkg.selectedPrice.productpriceancillaryservicelimit_set;
	            var groups = {};
	            for (var i = 0; i < limits.length; i++) {
	                groups[limits[i].limit_group] = limits[i];
	            }
	            var totals = { person: 0, policy: 0, service: 0 };
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = Object.keys(groups)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var key = _step.value;
	
	                    totals.person += groups[key].limit_per_person ? parseFloat(groups[key].limit_per_person) : 0;
	                    totals.policy += groups[key].limit_per_policy ? parseFloat(groups[key].limit_per_policy) : 0;
	                    totals.service += groups[key].limit_per_service ? parseFloat(groups[key].limit_per_service) : 0;
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator["return"]) {
	                        _iterator["return"]();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            return totals;
	        };
	
	        this.toggleFundFilterOpen = function () {
	            _this.operatorFilterControl.showFundFilter = !_this.operatorFilterControl.showFundFilter;
	        };
	
	        this.toggleFundFilterOpenNonPanel = function () {
	            _this.operatorFilterControl.showFundFilterNonPanel = !_this.operatorFilterControl.showFundFilterNonPanel;
	        };
	
	        this.toggleFundFilterAll = function () {
	            _this.operatorFilters.funds = _this.operatorFilters.funds.map(function (f) {
	                f.selected = _this.operatorFilterControl.allFundsSelected;
	                return f;
	            });
	        };
	
	        this.toggleFundFilterAllNonPanel = function () {
	            _this.operatorFilters.non_panel_funds = _this.operatorFilters.non_panel_funds.map(function (f) {
	                f.selected = _this.operatorFilterControl.allFundsSelectedNonPanel;
	                return f;
	            });
	        };
	
	        this.toggleAllTierFilter = function () {
	            _this.operatorFilters.hospital_classifications = _this.operatorFilters.hospital_classifications.map(function (classification) {
	                classification.selected = _this.operatorFilterControl.allTiersSelected;
	                return classification;
	            });
	        };
	
	        this.showHospitalTiersFilter = function () {
	            return _this.formChoices.hospital_classification_filter_options && _this.applicant.requiresHospitalProducts();
	        };
	
	        this.emailQuote = function (form) {
	            if (!form.$valid) {
	                return;
	            }
	        };
	
	        this.updatePriceCalculations = function (pkg, paymentFrequency) {
	            var rebatePercentage = comparatorUtilities.calcRebate(_this.applicant, AonApplicationService);
	            var healthCoverLoading = comparatorUtilities.calcLHC(_this.applicant, AonApplicationService);
	            comparatorUtilities.priceCalculations(pkg, rebatePercentage, healthCoverLoading, paymentFrequency);
	        };
	
	        this.onSaveZohoQuote = function (pkg) {
	            AonApplicationService.setProduct(pkg);
	            _this.saveZohoQuote({
	                sendEmail: false,
	                sendSMS: false }, !AonConfig.corporate.disable_save_quote_workflow);
	        };
	
	        this.onCloseSaveQuote = function () {
	            _this.saveQuoteVisible = false;
	        };
	
	        this.saveZohoQuote = function () {
	            var form = arguments[0] === undefined ? {} : arguments[0];
	            var showQuoteWorkflow = arguments[1] === undefined ? false : arguments[1];
	
	            AonApplicationService.getApplication().then(function (applicant) {
	                _this.saveQuoteVisible = showQuoteWorkflow;
	                var sendEmail = form.sendEmail;
	                var sendSMS = form.sendSMS;
	                var expectedYearlySavings = form.expectedYearlySavings;
	                var improvedBenefit1 = form.improvedBenefit1;
	                var improvedBenefit2 = form.improvedBenefit2;
	                var improvedBenefit3 = form.improvedBenefit3;
	
	                var pkg = AonApplicationService.getProduct(false);
	                var applicantData = comparatorUtilities.applicantWithDOB(applicant);
	                applicantData.zoho = {
	                    send_email: !!sendEmail,
	                    send_sms: !!sendSMS,
	                    expected_yearly_savings: parseInt(expectedYearlySavings),
	                    improved_benefit_1: improvedBenefit1,
	                    improved_benefit_2: improvedBenefit2,
	                    improved_benefit_3: improvedBenefit3 };
	                pkg.isSavingZohoQuote = true;
	                var suppressOpportunityNote = Object.keys(form).length === 0;
	                ZohoService.sendQuoteToZoho(applicant.zoho_id, applicantData, pkg, suppressOpportunityNote).then(function (response) {
	                    var applicant = response.data.applicant;
	
	                    pkg.saveZohoQuoteFailed = false;
	                    _this.applicant.zoho = applicant.zoho;
	                    _this.applicant.quote_details = applicant.quote_details;
	                    AonApplicationService.saveApplication(applicant);
	                })["catch"](function () {
	                    pkg.saveZohoQuoteFailed = true;
	                })["finally"](function () {
	                    pkg.isSavingZohoQuote = false;
	                });
	            });
	        };
	
	        this.defenceLabel = function (code) {
	            switch (code.slice(-1)) {
	                case "C":
	                    return "All";
	                case "A":
	                    return "Permanent";
	                case "R":
	                    return "Reserve";
	            }
	        };
	
	        this.prevResultPage = function () {
	            _this.operatorFilters.offset -= 1;
	            if (_this.operatorFilters.offset < 0) {
	                _this.operatorFilters.offset = 0;
	            }
	            _this.refine();
	        };
	
	        this.nextResultPage = function () {
	            _this.operatorFilters.offset += 1;
	            _this.refine();
	        };
	
	        this.filterUpdate = function (clear_offset) {
	            if (clear_offset) {
	                _this.operatorFilters.offset = 0;
	            }
	            OperatorService.updateDiscountDependantFilters();
	            setTimeout(_this.refine, 0);
	        };
	
	        this.discounts = function (pkg) {
	            var pricing = _this.getPricing(pkg, "available", pkg.apply_direct_debit_discount, false);
	            return pricing ? pricing.discounts : [];
	        };
	
	        this.isProductClosed = function (price) {
	            return price.product_status === AonConfig.jsConstants.ProductPriceStatus.CLOSED;
	        };
	
	        this.previousProductDisplay = function (product) {
	            return "" + product.name + "" + (product.monthly_premium ? " (Premium: $" + product.monthly_premium + ", Excess: $" + Math.round(product.excess) + ", " + product.product_status + ")" : "");
	        };
	
	        this.fundGeneralOffer = function (fundCode) {
	            return _this.corporate.general_offers[fundCode];
	        };
	
	        this.showServiceFilters = function () {
	            // We clone the service filters here so that we only apply the new filters if the
	            // user clicks the 'Apply' button
	            _this.application = application;
	            _this.serviceFilters = _.cloneDeep(services);
	            _this.servicesInColumns = comparatorUtilities.splitServicesIntoColumns(_this.serviceFilters);
	            $("#service-filters.modal").modal();
	        };
	
	        this.applyServiceFilters = function () {
	            var updateServices = function (key) {
	                return _this.services[key].forEach(function (service, index) {
	                    service.selected = _this.serviceFilters[key][index].selected;
	                });
	            };
	            updateServices("hospital");
	            updateServices("ancillary");
	            if (_this.application.zoho_id) {
	                var selectedServices = function (services) {
	                    return services.filter(function (s) {
	                        return s.selected;
	                    }).map(function (s) {
	                        return s.id;
	                    });
	                };
	                ZohoService.saveServicesToZoho(_this.application.zoho_id, {
	                    hospital: selectedServices(_this.services.hospital),
	                    ancillary: selectedServices(_this.services.ancillary) });
	            }
	            _this.refine();
	        };
	
	        this.toggleDetailsPane = function () {
	            _this.detailsPaneOpen = !_this.detailsPaneOpen;
	        };
	
	        this.canApply = function (pkg) {
	            if (_this.corporate.disable_apply_button) {
	                return false;
	            }
	            var RetentionProcessingLookup = AonConfig.jsConstants.RetentionProcessingLookup;
	            var allow_retention_processing = AonConfig.corporate.allow_retention_processing;
	
	            var retentionApplicationNotAllowed = allow_retention_processing !== RetentionProcessingLookup.APPLICATION;
	            if (isRetention(pkg.fund) && retentionApplicationNotAllowed && !AonConfig.corporate.enable_member_transfers) {
	                return false;
	            }
	            if (_this.applicant.zoho_id) {
	                return _this.hasActiveQuote() && priceIsQuotedPrice(pkg.selectedPrice);
	            }
	            return true;
	        };
	
	        this.canSaveQuote = function (pkg) {
	            if (_this.corporate.disable_apply_button) {
	                return false;
	            }
	            if (!_this.applicant.zoho_id) {
	                return false;
	            }
	            var RetentionProcessingLookup = AonConfig.jsConstants.RetentionProcessingLookup;
	            var allow_retention_processing = AonConfig.corporate.allow_retention_processing;
	
	            var retentionSaveQuoteNotAllowed = allow_retention_processing === RetentionProcessingLookup.DISALLOW;
	            if (isRetention(pkg.fund) && retentionSaveQuoteNotAllowed && !AonConfig.corporate.enable_member_transfers) {
	                return false;
	            }
	            return true;
	        };
	
	        // Return the css class for a column, based on price package in that column
	        this.columnClass = function (pkg) {
	            return {
	                "current-policy": pkg.is_current_policy };
	        };
	
	        /**
	         * Whether to show a warning/notice about the price being calculated from a monthly price
	         * @param pkg The price package to check
	         * @param which 'future' or 'available'
	         */
	        this.showPaymentFrequencyEstimatedNotice = function (pkg, which) {
	            if (_this.operatorFilters.payment_frequency === "fortnightly") {
	                return pkg.selectedPrice.pricing[which].fortnightly_price_calculated;
	            }
	            return _this.operatorFilters.payment_frequency !== "monthly";
	        };
	    }]);
	};

/***/ }),
/* 231 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (ngModule) {
	
	    ngModule.controller("PriceSummaryCtrl", ["AonApi", "$state", "$stateParams", function (AonApi, $state, $stateParams) {
	        var _this = this;
	
	        var priceId = $stateParams.priceId;
	
	        this.priceId = priceId;
	        this.applicant = JSON.parse(window.localStorage.getItem("price-summary-application") || "{}");
	        this.loading = true;
	        this.error = false;
	
	        if (!Object.keys(this.applicant)) {
	            this.error = "Unable to retrieve applicant data from local storage";
	        }
	        if (!priceId) {
	            this.error = "No price id supplied";
	        }
	
	        this.value = function (val, prefix, suffix) {
	            return val === undefined || val === null ? "" : "" + prefix + "" + val + "" + suffix;
	        };
	
	        AonApi.fetchPrice(this.applicant, priceId).then(function (_ref) {
	            var pkg = _ref.data;
	
	            _this.price = pkg.price;
	            var priceField = "monthly_adjusted_price_dd_discount";
	            _this.current = (_this.price.pricing.available || {})[priceField];
	            _this.future = (_this.price.pricing.future || {})[priceField];
	            // Some fields can be extracted from either price struct (discounts tho??)
	
	            var _ref2 = _this.current || _this.future || {};
	
	            var lhc_percent = _ref2.lhc_percent;
	            var rebate_percent = _ref2.rebate_percent;
	
	            _this.lhc_percent = lhc_percent.toFixed(2);
	            _this.rebate_percent = rebate_percent.toFixed(3);
	            _this.loading = false;
	        })["catch"](function (error) {
	            _this.error = error;
	            _this.loading = false;
	        });
	    }]);
	};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };
	
	var moment = _interopRequire(__webpack_require__(1));
	
	var _utilityComparator = __webpack_require__(2);
	
	var getPricingForFrequency = _utilityComparator.getPricingForFrequency;
	var getPaymentFrequencyKey = _utilityComparator.getPaymentFrequencyKey;
	
	module.exports = function (ngModule) {
	
	    ngModule.controller("QuoteCtrl", ["AonApi", "AonApplicationService", "AonConfig", "$state", "$stateParams", "ZohoService", function (AonApi, AonApplicationService, AonConfig, $state, $stateParams, ZohoService) {
	        var _this = this;
	
	        var leadId = $stateParams.leadId;
	        var priceId = $stateParams.priceId;
	        var phone = $stateParams.phone;
	
	        //Giveback Initiative required check
	        var currentDate = new Date();
	        var DateUpper = new Date(2023, 3, 31);
	        var DateLower = new Date(2022, 10, 1);
	
	        if (currentDate <= DateUpper && currentDate >= DateLower) {
	            this.GBICheck = true;
	        } else {
	            this.GBICheck = false;
	        }
	
	        this.loading = true;
	        this.error = false;
	        this.template = null;
	        this.leadId = leadId;
	
	        this.formatNumber = function (val, numDecimals) {
	            return Number(val).toLocaleString([], {
	                maximumFractionDigits: numDecimals });
	        };
	
	        if (!priceId) {
	            this.error = true;
	        }
	
	        this.onApply = function () {
	            var applyCorporate = _this.applicant.zoho.apply_corporate;
	            var applicationLink = _.get(_this.applicant, "quote_details.application_link");
	            if (applicationLink && !applicationLink.split("://")[1].startsWith(window.location.hostname)) {
	                var publicDomain = _.get(_this.applicant, "application_domains.public");
	                var agentDomain = _.get(_this.applicant, "application_domains.agent");
	                applicationLink = applicationLink.replace(agentDomain, publicDomain);
	                window.location.href = applicationLink;
	            } else if (applyCorporate) {
	                window.location.href = "/" + applyCorporate + "/#/zoho/" + leadId + "?price=" + priceId;
	            } else {
	                $state.go("comparator.step3." + _this.pkg.fund.code);
	            }
	        };
	
	        this.onShowTerms = function () {
	            $("#fund-offer-terms").modal();
	        };
	
	        // Get current or future prices at the applicants selected payment frequency
	        var frequencyPrices = function (pkg, which) {
	            var frequencyPrice = null;
	            var frequencyPriceDD = null;
	            var frequencyLHCPercent = null;
	            var frequencyLHCAmount = null;
	            var frequencyLabel = null;
	            var paymentFrequency = _.get(_this.applicant, "payment.frequency", null);
	            if (paymentFrequency === null || paymentFrequency === undefined) {
	                // Default to monthly if no payment frequency is set
	                paymentFrequency = AonConfig.jsConstants.PaymentFrequencies.Monthly;
	            }
	            var frequencyPricingDD = getPricingForFrequency(pkg, which, paymentFrequency, true, false);
	            frequencyPrice = getPricingForFrequency(pkg, which, paymentFrequency, false, false).premium.toFixed(2);
	            frequencyPriceDD = frequencyPricingDD.premium.toFixed(2);
	            frequencyLabel = getPaymentFrequencyKey(paymentFrequency);
	            frequencyLHCPercent = frequencyPricingDD.lhc_percent;
	            frequencyLHCAmount = frequencyPricingDD.lhc_amount;
	            return {
	                frequencyPrice: frequencyPrice,
	                frequencyPriceDD: frequencyPriceDD,
	                frequencyLabel: frequencyLabel,
	                frequencyLHCPercent: frequencyLHCPercent,
	                frequencyLHCAmount: frequencyLHCAmount };
	        };
	
	        var setPricingOnScope = function (pkg) {
	            var pricing = pkg.price.pricing.available;
	            var discounts = pricing.monthly_adjusted_price.discounts;
	            var rebatePercent = pricing.monthly_adjusted_price.rebate_percent.toFixed(3);
	            var monthlyPrice = pricing.monthly_adjusted_price.premium.toFixed(2);
	            var monthlyPriceDD = pricing.monthly_adjusted_price_dd_discount.premium.toFixed(2);
	            var fortnightlyPrice = pricing.fortnightly_adjusted_price.premium.toFixed(2);
	            var fortnightlyPriceDD = pricing.fortnightly_adjusted_price_dd_discount.premium.toFixed(2);
	
	            var hasDiscount = monthlyPrice != monthlyPriceDD;
	            var showExcess = pkg.price.type !== AonConfig.jsConstants.ProductPriceType.ANCILLARY;
	
	            var _frequencyPrices = frequencyPrices(pkg, "available");
	
	            var frequencyPrice = _frequencyPrices.frequencyPrice;
	            var frequencyPriceDD = _frequencyPrices.frequencyPriceDD;
	            var frequencyLHCPercent = _frequencyPrices.frequencyLHCPercent;
	            var frequencyLHCAmount = _frequencyPrices.frequencyLHCAmount;
	            var frequencyLabel = _frequencyPrices.frequencyLabel;
	
	            var currentAvailableTo = moment(pricing.available_to);
	
	            _this.pricing = {
	                rebatePercent: rebatePercent,
	                monthlyPrice: monthlyPrice,
	                fortnightlyPrice: fortnightlyPrice,
	                monthlyPriceDD: monthlyPriceDD,
	                fortnightlyPriceDD: fortnightlyPriceDD,
	                frequencyPrice: frequencyPrice,
	                frequencyPriceDD: frequencyPriceDD,
	                frequencyLHCPercent: frequencyLHCPercent,
	                frequencyLHCAmount: frequencyLHCAmount,
	                frequencyLabel: frequencyLabel,
	                hasDiscount: hasDiscount,
	                discounts: discounts,
	                showExcess: showExcess };
	
	            _this.pricing.currentAvailableTo = currentAvailableTo.format("MMMM Do YYYY");
	
	            if (pkg.price.pricing.future) {
	                var availableFrom = moment(pkg.price.pricing.future.available_from);
	                var monthlyFuturePrice = pkg.price.pricing.future.monthly_adjusted_price.premium.toFixed(2);
	                var monthlyFuturePriceDD = pkg.price.pricing.future.monthly_adjusted_price_dd_discount.premium.toFixed(2);
	                var fortnightlyFuturePrice = pkg.price.pricing.future.fortnightly_adjusted_price.premium.toFixed(2);
	                var fortnightlyFuturePriceDD = pkg.price.pricing.future.fortnightly_adjusted_price_dd_discount.premium.toFixed(2);
	
	                var _frequencyPrices2 = frequencyPrices(pkg, "future");
	
	                var _frequencyPrice = _frequencyPrices2.frequencyPrice;
	                var _frequencyPriceDD = _frequencyPrices2.frequencyPriceDD;
	                var _frequencyLabel = _frequencyPrices2.frequencyLabel;
	
	                var hasFutureDiscount = monthlyFuturePrice != monthlyFuturePriceDD;
	                _this.pricing.availableFrom = availableFrom.format("MMMM Do YYYY");
	                _this.pricing.futurePremium = hasFutureDiscount ? monthlyFuturePriceDD : monthlyFuturePrice;
	                _this.pricing.futureDiscount = hasFutureDiscount;
	                _this.pricing.futureFortnightlyPremium = hasFutureDiscount ? fortnightlyFuturePriceDD : fortnightlyFuturePrice;
	                _this.pricing.futureFrequencyPremium = hasFutureDiscount ? _frequencyPriceDD : _frequencyPrice;
	                _this.pricing.futureFrequencyLabel = _frequencyLabel;
	            }
	        };
	
	        ZohoService.getZohoApplicant(leadId, null, "Trigger: View Quote").then(function () {
	            return AonApplicationService.getApplication();
	        }).then(function (applicant) {
	            _this.applicant = applicant;
	            _this.quoteClass = applicant.zoho.company_id.replace(/[^a-zA-Z]/, "");
	            _this.disableApply = applicant.zoho.stage_is_closed;
	            var template = applicant.zoho.company_template;
	            var errorTemplate = applicant.zoho.company_error_template;
	            _this.template = "/static/partials/quote/" + template;
	            _this.errorTemplate = "/static/partials/quote/" + errorTemplate;
	            if (_this.applicant.zoho.company_contact_number) {
	                _this.contact_number = _this.applicant.zoho.company_contact_number;
	            }
	            if (phone) {
	                // Override with operator phone number if it was passed as a url parameter
	                _this.contact_number = phone;
	            }
	            if (_this.contact_number) {
	                _this.contact_number_tel_link = _this.contact_number.replace(/\s/g, "");
	            }
	            if (_this.applicant.fund_specific_data.quote_entry_date) {
	                // display as DD MM YYYY
	                _this.quote_entry_date = moment(_this.applicant.fund_specific_data.quote_entry_date).format("DD MMM YYYY");
	            }
	            return AonApi.fetchPrice(applicant, priceId);
	        }).then(function (_ref) {
	            var pkg = _ref.data;
	
	            _this.pkg = pkg;
	            _this.fundOffer = AonConfig.corporate.general_offers[pkg.fund.code];
	            var price = pkg.price;
	            pkg.selectedPrice = price;
	            AonApplicationService.setProduct(pkg);
	            AonApplicationService.setPrice(price);
	            _.set(_this.applicant, "policy.membership_type", price.membership_type);
	            _.set(_this.applicant, "primary_address.state", price.state);
	            AonApplicationService.saveApplication(_this.applicant);
	            setPricingOnScope(pkg);
	
	            var zoho = _.get(_this.applicant, "zoho", {});
	            _this.isNewToPHI = !_.get(_this.applicant, "personal.previous_fund.has_previous_fund", false);
	            _this.showImprovedBenefitsExpectedSavings = Number(zoho.expected_yearly_savings) > 0;
	            _this.hasImprovedBenefits = zoho.improved_benefit_1 || zoho.improved_benefit_2 || zoho.improved_benefit_3;
	            _this.showImprovedBenefitsTable = AonConfig.corporate.show_additional_details_on_quote && (_this.showImprovedBenefitsExpectedSavings || _this.hasImprovedBenefits);
	            _this.loading = false;
	        })["catch"](function (error) {
	            _this.error = true;
	            _this.loading = false;
	        });
	    }]);
	};

/***/ }),
/* 233 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (ngModule) {
	  ngModule.controller("ComparatorRetentionCtrl", ["AonConfig", "$state", "application", "AonApplicationService", "AonApi", "ZohoService", function (AonConfig, $state, application, AonApplicationService, AonApi, ZohoService) {
	    var _this = this;
	
	    this.formChoices = AonConfig.formChoices;
	    this.corporate = AonConfig.corporate;
	    this.deployment = AonConfig.deployment;
	    this.application = application;
	    this.product = AonApplicationService.product.selectedPrice;
	    this.fund_email = _.get(this.product, "fund.email", "");
	    var lead_id = _.get(this.application, "zoho_id", false);
	    this.resultMessage = null;
	
	    this.emailValidatorPattern = {
	      required: true,
	      pattern: "[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*",
	      error_messages: {
	        pattern: "Please provide a valid email address" } };
	
	    this.mobileValidatorPattern = {
	      required: true,
	      pattern: "^04[0-9]{8}$",
	      error_messages: {
	        pattern: "Please provide a valid mobile phone number" } };
	
	    var d = new Date();
	    this.email_data = {
	      note_title: [d.getDate(), d.getMonth() + 1, d.getFullYear()].join("/") + " " + d.toTimeString().split(" ")[0]
	    };
	
	    this.submit = function () {
	      var form = _this.retentionForm;
	
	      if (!lead_id) {
	        return;
	      }
	
	      if (!form.$valid) {
	        form.focusInvalid();
	        return;
	      }
	
	      _this.resultMessage = null;
	      _this.isSaving = true;
	      var retention_data = {
	        current_product: _this.email_data.current_product,
	        address: _this.email_data.address,
	        notes: _this.email_data.notes,
	        note_title: _this.email_data.note_title };
	      var onError = function (response) {
	        _this.isSaving = false;
	        if (response.status === 400 && response.data) {
	          (function () {
	            var nonFormErrors = [];
	            Object.keys(response.data).forEach(function (key) {
	              if (form[key]) {
	                form[key].setExternalValidation(null, response.data[key]);
	              } else {
	                nonFormErrors.push("" + key + ": " + response.data[key]);
	              }
	            });
	            form.focusInvalid();
	            if (nonFormErrors.length) {
	              _this.resultMessage = "There was an error saving this application to Zoho: " + nonFormErrors.join(", ");
	            }
	          })();
	        } else {
	          var error = response.error;
	          _this.resultMessage = "There was an error saving this application to Zoho: " + error;
	        }
	      };
	      var onSuccess = function () {
	        _this.isSaving = false;
	        _this.resultMessage = "Zoho data successfully submitted.";
	      };
	      ZohoService.sendRetentionToZoho(lead_id, retention_data, _this.application, _this.product).then(onSuccess, onError);
	    };
	  }]);
	};

/***/ }),
/* 234 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (ngModule) {
	  ngModule.controller("RetrievePasswordCtrl", ["AonConfig", "$http", "$interpolate", function (AonConfig, $http, $interpolate) {
	    var _this = this;
	
	    this.messages = {
	      success: null,
	      failure: null,
	      loading: null };
	    this.corporateConfig = AonConfig.corporate;
	    this.submit = function (form) {
	      _this.messages.success = null;
	      _this.messages.failure = null;
	      _this.messages.loading = true;
	      var email = _this.email_address;
	      var context = {
	        email: _this.email_address };
	      var success = function (r) {
	        _this.messages.success = $interpolate(_this.corporateConfig.code_email_retrieval_success)(context);
	      };
	      var failure = function (r) {
	        _this.messages.failure = $interpolate(_this.corporateConfig.code_email_retrieval_failure)(context);
	      };
	      var then = function () {
	        _this.messages.loading = false;
	      };
	      $http.post("/corporate/" + AonConfig.corporate.id + "/retrieve-password", { email: email }).then(success, failure)["finally"](then);
	    };
	  }]);
	};

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var getPricingForFrequency = __webpack_require__(2).getPricingForFrequency;
	
	module.exports = function (ngModule) {
	    ngModule.controller("RootCtrl", ["AonApplicationService", "AonConfig", "OperatorService", "smoothScroll", "$scope", "$state", "$timeout", "ZohoService", "VERSION", function (AonApplicationService, AonConfig, OperatorService, smoothScroll, $scope, $state, $timeout, ZohoService, VERSION) {
	        var _this = this;
	
	        this.version = VERSION.id;
	        this.corporate = AonConfig.corporate;
	        this.deployment = AonConfig.deployment;
	        this.operator = AonConfig.operator;
	        this.refine_pane_open = false;
	        this.zohoApiError = ZohoService.apiError;
	
	        // Track the last route, so that child controllers can access it
	        $scope.lastRoute = null;
	        $scope.$on("$stateChangeSuccess", function (event, toState, ignore, fromState) {
	            $scope.lastRoute = fromState.url;
	        });
	
	        this.application = AonApplicationService.application;
	        this.applicantHasActiveQuote = function () {
	            return _this.application && _.get(_this.application, "zoho.has_quote");
	        };
	
	        // Map payment frequency string options to the key into PaymentFrequencies consts, and a display label
	        var paymentFrequencyMap = {
	            weekly: ["Weekly", "week"],
	            fortnightly: ["Fortnightly", "fortnight"],
	            monthly: ["Monthly", "month"],
	            quarterly: ["Quarterly", "quarter"],
	            halfyearly: ["Half Yearly", "half-year"],
	            yearly: ["Yearly", "year"] };
	
	        // Get the "per XXX" label for a payment frequency
	        this.paymentFrequencyLabel = function () {
	            return paymentFrequencyMap[OperatorService.filters.payment_frequency][1];
	        };
	
	        // When the operator filter payment frequency changes, update the application
	        $scope.$watch(function () {
	            return OperatorService.filters.payment_frequency;
	        }, function (newFreq, oldFreq) {
	            var paymentFrequency = AonConfig.jsConstants.PaymentFrequencies[paymentFrequencyMap[newFreq][0]];
	            _.set(_this.application, "payment.frequency", paymentFrequency);
	            AonApplicationService.saveApplication(_this.application);
	        });
	
	        // When the operator filter discount code changes, and update the application
	        $scope.$watch(function () {
	            return OperatorService.filters.discount_code;
	        }, function (newCode) {
	            _.set(_this.application, "policy.discount_code", newCode);
	            AonApplicationService.saveApplication(_this.application);
	        });
	
	        this.getPricing = function (pkg, which, directDebitDiscount, noDiscounts) {
	            var paymentFrequency = paymentFrequencyMap[OperatorService.filters.payment_frequency][0];
	            return getPricingForFrequency(pkg, which, AonConfig.jsConstants.PaymentFrequencies[paymentFrequency], directDebitDiscount, noDiscounts);
	        };
	
	        this.currentPriceForDD = function (pkg, applyDirectDebitDiscount) {
	            return _this.getPricing(pkg, "available", applyDirectDebitDiscount, false).premium;
	        };
	
	        this.currentPriceForRetention = function (pkg) {
	            return _this.getPricing(pkg, "available", false, true).premium;
	        };
	
	        this.currentPrice = function (pkg) {
	            return _this.currentPriceForDD(pkg, pkg.apply_direct_debit_discount);
	        };
	
	        this.currentPricing = function (pkg) {
	            return _this.getPricing(pkg, "available", pkg.apply_direct_debit_discount, false);
	        };
	
	        this.futurePrice = function (pkg) {
	            return _this.getPricing(pkg, "future", pkg.apply_direct_debit_discount, false).premium;
	        };
	
	        this.futurePriceDifference = function (pkg) {
	            if (!pkg.selectedPrice.pricing.hasOwnProperty("available")) return null;
	            var futurePrice = _this.futurePrice(pkg);
	            var currentPrice = _this.currentPrice(pkg);
	            return 100 * (futurePrice - currentPrice) / currentPrice;
	        };
	
	        /**
	         * Scroll to the location of an element given by dom node id
	         * @param id: String|[String] This can be an array of ids, or a single id
	         * @param delay: delay in milliseconds before setting scroll position
	         */
	        this.scrollToId = function (id) {
	            var delay = arguments[1] === undefined ? 0 : arguments[1];
	
	            var ids = Array.isArray(id) ? id : [id];
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = ids[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var _ret = (function () {
	                        var _id = _step.value;
	
	                        var matchingElements = window.angular.element("#" + _id);
	                        if (matchingElements.length) {
	                            $timeout(function () {
	                                smoothScroll(matchingElements[0], { stopOnUserScroll: true });
	                            }, delay);
	                            return {
	                                v: undefined
	                            };
	                        }
	                    })();
	
	                    if (typeof _ret === "object") return _ret.v;
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator["return"]) {
	                        _iterator["return"]();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	        };
	    }]);
	};

/***/ }),
/* 236 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (ngModule) {
	
	  ngModule.controller("ComparatorStep1Ctrl", ["AonApplicationService", "AonConfig", "application", "$state", "$scope", function (AonApplicationService, AonConfig, application, $state, $scope) {
	    var _this = this;
	
	    // Track page navigation
	    AonApplicationService.trackEvent(AonConfig.jsConstants.TrackingEvents.NeedsAnalysis);
	
	    this.formChoices = AonConfig.formChoices;
	    this.corporate = AonConfig.corporate;
	    this.deployment = AonConfig.deployment;
	    this.application = application;
	
	    // Ensure age is integral
	    this.onAgeChange = function (model) {
	      if (model.age) {
	        model.age = parseInt(model.age);
	      }
	    };
	
	    // If only one option for cover type, select it by default
	    if (this.formChoices.cover_type.length == 1) {
	      this.application.policy.cover_type = this.formChoices.cover_type[0][0];
	    }
	
	    this.rebate_tier_choices = AonApplicationService.getRebateTierChoices(application);
	
	    // Only offer to enter the competition first time through, as user can go back
	    // from step 2 and change their details
	    this.offerCompetition = this.corporate.competition_is_active && !AonApplicationService.getCompetitionHasOpted();
	
	    this.onMembershipTypeChange = function () {
	      _this.rebate_tier_choices = AonApplicationService.getRebateTierChoices(application);
	      var text = AonApplicationService.getRebateTierText(application);
	      _this.rebate_tier_caption = text.caption;
	      _this.rebate_tier_description = text.description;
	    };
	
	    this.onMembershipTypeChange();
	
	    $scope.$parent.ctrl.scrollToId("step-progress-header", 100);
	
	    /**
	     * Save the applicant changes
	     */
	    this.onSubmit = function (form) {
	      this.hasSubmitted = false;
	      if (form.$valid) {
	        // TODO: Server side validation
	        AonApplicationService.saveApplication(this.application);
	
	        if (this.offerCompetition) {
	          if (this.application.enter_competition) {
	            // TODO(cal): send comp info to aon
	            AonApplicationService.setCompetitionOptIn(); // flag as opted in, to avoid re-showing
	          } else {
	            AonApplicationService.setCompetitionOptOut(); // flag as opted out, to avoid re-showing
	          }
	        }
	        $state.transitionTo("comparator.step2");
	      } else {
	        if (form.focusInvalid) {
	          form.focusInvalid();
	        }
	        this.hasSubmitted = true;
	      }
	    };
	
	    // Should be a better way
	    var tcs = $("<span>" + this.corporate.terms_and_conditions_brief + "</span>");
	    tcs.find("a").click(function () {
	      $("div.modal").modal("show");
	    });
	    $("span#terms_and_conditions").html(tcs);
	
	    this.hasAnsweredCurrentFund = function () {
	      var has_previous_fund = _.get(_this.application, "personal.previous_fund.has_previous_fund");
	      return has_previous_fund === true || has_previous_fund === false;
	    };
	  }]);
	};

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { "default": obj }; };
	
	var comparatorUtilities = _interopRequireWildcard(__webpack_require__(2));
	
	module.exports = function (ngModule) {
	
	  /**
	   * Helper to create object with specified keys each containing approximately the same number of values from col
	   * @param col
	   * @param keys
	   * @returns {Object}
	   */
	  function splitToKeys(col, keys) {
	    var parts = _.chunk(col, Math.ceil(col.length / keys.length));
	    return _.zipObject(keys, parts);
	  }
	
	  function getProductFeatures(services, productServices) {
	    var benefits = arguments[2] === undefined ? false : arguments[2];
	
	    var productFeatures = {};
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = services[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        (function () {
	          var feature = _step.value;
	
	          productFeatures[feature.id] = _(productServices).filter(function (productService) {
	            return productService.service === feature.id;
	          }).first();
	        })();
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator["return"]) {
	          _iterator["return"]();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    return productFeatures;
	  }
	
	  ngModule.controller("ComparatorStep2Ctrl", ["AonApi", "AonApplicationService", "AonConfig", "AonProducts", "matchmedia", "$sce", "$scope", "services", "$state", "$stateParams", function (AonApi, AonApplicationService, AonConfig, AonProducts, matchmedia, $sce, $scope, services, $state, $stateParams) {
	    var _this = this;
	
	    this.corporate = AonConfig.corporate;
	
	    $scope.$parent.ctrl.scrollToId("step-progress-header", 100);
	
	    this.isRefinePaneOpen = true;
	    $scope.$parent.ctrl.refine_pane_open = this.isRefinePaneOpen;
	    this.isLoadingResults = false;
	    this.isFetchingPage = false;
	    this.debugOverlay = AonApplicationService.isDebug();
	    this.debugToggled = false;
	
	    this.displayState = {
	      resultOffset: 0,
	      totalResults: 0,
	      priceLimit: 0 };
	
	    this.onScrollRight = function () {
	      _this.displayState.resultOffset = Math.min(_this.displayState.resultOffset + 1, _this.displayState.totalResults - _this.displayState.priceLimit);
	      _this.displayState.resultOffset = Math.max(_this.displayState.resultOffset, 0);
	      _this.isFetchingPage = true;
	      _this.refine(true);
	    };
	
	    this.onScrollLeft = function () {
	      _this.displayState.resultOffset = Math.max(_this.displayState.resultOffset - 1, 0);
	      _this.isFetchingPage = true;
	      _this.refine(true);
	    };
	
	    this.canScrollLeft = function () {
	      return _this.displayState.resultOffset > 0;
	    };
	    this.canScrollRight = function () {
	      return _this.displayState.priceLimit * (_this.displayState.resultOffset + 1) < _this.displayState.totalResults;
	    };
	
	    this.viewingPackages = function () {
	      if (_this.packages.length) {
	        var minProd = _this.displayState.resultOffset * _this.displayState.priceLimit + 1;
	        var maxProd = Math.min(minProd + _this.displayState.priceLimit - 1, _this.displayState.totalResults);
	        var totalProd = _this.displayState.totalResults;
	        if (totalProd == 1) {
	          _this.displayState.viewingText = "Showing 1 policy";
	        } else {
	          _this.displayState.viewingText = "Showing " + minProd + " to " + maxProd + " of " + totalProd + " policies";
	        }
	      }
	      //return this.packages.slice(this.displayState.resultOffset, this.displayState.resultOffset + 3);
	      return _this.packages;
	    };
	
	    this.servicesInColumns = {
	      hospital: splitToKeys(services.hospital.sort(function (a, b) {
	        return b.sort_order - a.sort_order;
	      }), ["left", "right"]),
	      ancillary: splitToKeys(services.ancillary.sort(function (a, b) {
	        return b.sort_order - a.sort_order;
	      }), ["left", "right"])
	    };
	
	    this.services = services;
	
	    this.openRefinePane = function () {
	      $scope.$parent.ctrl.scrollToId("step-progress-header");
	      _this.isRefinePaneOpen = true;
	      $scope.$parent.ctrl.refine_pane_open = true;
	    };
	
	    this.closeRefinePane = function () {
	      _this.isRefinePaneOpen = false;
	      $scope.$parent.ctrl.refine_pane_open = false;
	    };
	
	    this.refine = function () {
	      var leavePaneOpen = arguments[0] === undefined ? false : arguments[0];
	
	      var excess_field = "excess";
	
	      _this.results_pane_continue_text = _this.corporate.refine_results_execute_text;
	
	      var ancillary = _.filter(services.ancillary, "selected");
	
	      var hospital = _.filter(services.hospital, "selected");
	
	      _this.isLoadingResults = true;
	
	      var success = function (response) {
	        _this.displayState.totalResults = response.data.total;
	        _this.displayState.priceLimit = response.data.limit;
	
	        var rebatePercentage = comparatorUtilities.calcRebate(_this.applicant, AonApplicationService);
	        var healthCoverLoading = comparatorUtilities.calcLHC(_this.applicant, AonApplicationService);
	        _this.applicant.policy.healthCoverLoading = healthCoverLoading;
	        _this.applicant.policy.rebatePercentage = response.data.applicant.rebate_percent;
	
	        var packages = response.data.packages,
	
	        // Get max number of excess options for a package
	        maxExcessCount = _(packages).pluck("prices").map("length").max();
	
	        _this.responsive = packages.length < 4;
	
	        _this.packages = _.map(response.data.packages, function (pricePackage) {
	
	          pricePackage.prices = _.map(pricePackage.prices, function (p) {
	            p[excess_field] = p[excess_field].split(".")[0];
	            return p;
	          });
	          pricePackage.prices = pricePackage.prices.sort(function (a, b) {
	            return b[excess_field] - a[excess_field];
	          });
	
	          comparatorUtilities.priceCalculations(pricePackage, rebatePercentage, healthCoverLoading);
	
	          pricePackage.selectedPrice = pricePackage.prices[0];
	          pricePackage.features = {
	            hospital: getProductFeatures(_this.services.hospital, pricePackage.hospital_product.product_hospital_services),
	            ancillary: getProductFeatures(_this.services.ancillary, pricePackage.ancillary_product.product_ancillary_services)
	          };
	          pricePackage.showUnselectedServices = {
	            hospital: false,
	            ancillary: false
	          };
	
	          // Calculate how many prices this package is short by. This is purely so we can add empty dom elements
	          // so that heights match up across columns in the HTML. Not very elegant, but easiest solution while
	          // maintaining responsive flow of columns.
	          var shortBy = maxExcessCount - pricePackage.prices.length;
	          if (shortBy > 0) {
	            pricePackage.fillerPrices = _.range(0, shortBy);
	          }
	          return pricePackage;
	        });
	
	        if (!leavePaneOpen) {
	          _this.displayState.resultOffset = 0;
	          _this.closeRefinePane();
	          $scope.$parent.ctrl.scrollToId("step-progress-header", 100);
	        }
	      },
	          error = function (err) {
	        console.log(err);
	      },
	          fin = function () {
	        _this.isLoadingResults = false;
	        _this.isFetchingPage = false;
	      };
	
	      var filters = { offset: _this.displayState.resultOffset };
	      AonProducts.searchPackages(_this.applicant, { hospital: hospital, ancillary: ancillary }, filters).then(success, error)["finally"](fin);
	    };
	
	    // Build a list of applicable fund-level offers
	    this.packageFundOffers = function (fund) {
	      return _this.corporate.fund_offers.filter(function (o) {
	        return o.cover == _this.applicant.policy.cover_type && fund.id == o.fund_id;
	      });
	    };
	
	    this.toggleUnselectedServiceSummary = function (pkg, type) {
	      if (matchmedia.isPhone()) {
	        pkg.showUnselectedServices[type] = !pkg.showUnselectedServices[type];
	      } else {
	        var _status = !pkg.showUnselectedServices[type];
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = _this.packages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var p = _step.value;
	
	            p.showUnselectedServices[type] = _status;
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator["return"]) {
	              _iterator["return"]();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	    };
	
	    this.apply = function (price, pkg) {
	      pkg.isTransitioningToApply = true;
	      AonApplicationService.saveApplication(_this.applicant);
	      AonApplicationService.setProduct(pkg);
	      AonApplicationService.setPrice(price);
	      var applicationLink = _.get(_this.applicant, "quote_details.application_link");
	      if (applicationLink && !applicationLink.split("://")[1].startsWith(window.location.hostname)) {
	        window.open(applicationLink, "_blank");
	      } else {
	        var code = price.fund.code.split(".")[0];
	        saveQuoteAndContinue("distribution", "comparator.step3." + code);
	      }
	    };
	
	    AonApplicationService.getApplication().then(function (applicant) {
	      _this.applicant = applicant;
	
	      // Emailed quote returning
	      if ($stateParams.quote) {
	        var quote = JSON.parse($stateParams.quote);
	
	        // Set selected services from the email info
	        _.forEach(_this.services.hospital, function (obj) {
	          obj.selected = _.includes(_.map(quote.hospital, function (x) {
	            return x.id;
	          }), obj.id);
	        });
	        _.forEach(_this.services.ancillary, function (obj) {
	          obj.selected = _.includes(_.map(quote.ancillary, function (x) {
	            return x.id;
	          }), obj.id);
	        });
	
	        _this.applicant.policy.cover_type = quote.cover;
	        _this.applicant.policy.membership_type = quote.membership;
	        _this.applicant.policy.federal_rebate = quote.federal_rebate;
	        _this.applicant.policy.rebate_tier = quote.rebate_tier;
	        _this.applicant.primary_address.state = quote.state;
	
	        _this.applicant.personal = {
	          dob: quote.dob,
	          previous_fund: {
	            has_previous_fund: quote.has_previous_fund }
	        };
	
	        _this.applicant.displayValues = _this.applicant.getSummaryDetails();
	
	        // Notify the backend for reporting
	        AonApi.post("quotes/email/returning", { tracking: quote.tracking });
	      }
	
	      _this.requiresAncillaryProducts = _this.applicant.requiresAncillaryProducts();
	      _this.requiresHospitalProducts = _this.applicant.requiresHospitalProducts();
	      _this.results_pane_continue_text = _this.corporate.refine_results_continue_text;
	    });
	
	    this.emailQuoteSendResult = {
	      attempted: false,
	      error: false
	    };
	
	    this.emailQuote = function (form) {
	      var _this2 = this;
	
	      if (!form.$valid) {
	        return;
	      }
	      // Get the selected ancillary and hospital ids for inclusion in the email link
	
	      var ancillary = _.map(_.filter(services.ancillary, "selected"), function (obj) {
	        return { id: obj.id, name: obj.name };
	      });
	
	      var hospital = _.map(_.filter(services.hospital, "selected"), function (obj) {
	        return { id: obj.id, name: obj.name };
	      });
	
	      var success = function (response) {
	        _this2.emailQuoteSendResult.attempted = true;
	        _this2.emailQuoteSendResult.error = !response.data.sent;
	      };
	      var failure = function (response) {
	        _this2.emailQuoteSendResult.attempted = true;
	        _this2.emailQuoteSendResult.error = true;
	      };
	
	      AonApi.post("quotes/email", {
	        applicant: {
	          email: this.applicant.contact.email_address,
	          cover: this.applicant.policy.cover_type,
	          dob: this.applicant.personal.dob,
	          federal_rebate: this.applicant.policy.federal_rebate,
	          rebate_tier: this.applicant.policy.rebate_tier,
	          has_previous_fund: this.applicant.personal.previous_fund.has_previous_fund,
	          membership: this.applicant.policy.membership_type,
	          state: this.applicant.primary_address.state,
	          hospital: hospital,
	          ancillary: ancillary },
	        packages: this.packages
	      }).then(success, failure);
	    };
	
	    // Get any general offers from the fund, to display in a modal
	    this.fundPopupOffers = function () {
	      return _this.corporate.fund_offers.filter(function (o) {
	        return o.cover == -1;
	      }).map(function (o) {
	        return $sce.trustAsHtml(o.offer);
	      });
	    };
	
	    // TODO: remember when shown at least once? Could get annoying...
	    if (this.fundPopupOffers().length) {
	      $("div#fund-offers-modal").modal("show");
	    }
	
	    this.isProductClosed = function (price) {
	      return price.product_status === AonConfig.jsConstants.ProductPriceStatus.CLOSED;
	    };
	  }]);
	};

/***/ }),
/* 238 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (ngModule) {
	  ngModule.controller("ComparatorStep3CtrlAHB", ["AonApplicationService", "$log", "$sce", "$scope", function (AonApplicationService, $log, $sce, $scope) {
	
	    var ctrl = $scope.$parent.ctrl;
	
	    // utility functino to check if "Credit Card" option has been selected
	    ctrl.isCredit = function () {
	      var currentTypes = ctrl.fieldsets.payment.type.choices;
	      for (var t = 0; t < currentTypes.length; ++t) {
	        if (currentTypes[t][0] == ctrl.application.payment.type && currentTypes[t][1].match(/credit/i)) {
	          return true;
	        }
	      }
	      return false;
	    };
	
	    // track original set of payment frequency choices (dynamically change based on payment type)
	    if (typeof ctrl.fieldsets.payment.frequency.originalchoices == "undefined") {
	      ctrl.fieldsets.payment.frequency.originalchoices = ctrl.fieldsets.payment.frequency.choices;
	    }
	
	    $scope.$watch("ctrl.application.payment.type", function () {
	
	      // force datepicker onto 15th of the month
	      var current = new Date(ctrl.application.payment.debit_date.getTime());
	      var joinDate = new Date(ctrl.application.payment.join_date.getTime());
	      var today = new Date();
	
	      if (ctrl.isCredit()) {
	        // if the current month, and we've pass the 15th, increment the month
	        if (current.getMonth() <= today.getMonth() && today.getDate() > 15) {
	          current.setMonth(current.getMonth() + 1);
	        }
	        // otherwise force current date to be the 15th
	        current.setDate(15);
	      } else {
	        // TODO: better way to force calendar redraw
	        current.setSeconds(joinDate.getSeconds() - 1);
	      }
	
	      ctrl.application.payment.debit_date = current;
	
	      // also drop Weekly or Fornightly options if credit card payment type
	      if (!ctrl.isCredit()) {
	        ctrl.fieldsets.payment.frequency.choices = ctrl.fieldsets.payment.frequency.originalchoices;
	      } else {
	        var currentChoices = ctrl.fieldsets.payment.frequency.originalchoices;
	        var adjustedChoices = [];
	        for (var f = 0; f < currentChoices.length; ++f) {
	          if (!currentChoices[f][1].match(/(Week|Fortnight)/)) {
	            adjustedChoices.push(currentChoices[f]);
	          }
	        }
	        ctrl.fieldsets.payment.frequency.choices = adjustedChoices;
	      }
	    });
	
	    ctrl.debit_date_filter = function (date, mode) {
	      // if day mode select AND credit card option selected
	      return mode == "day" && ctrl.isCredit() ? 15 != date.getDate() : false;
	    };
	  }]);
	};

/***/ }),
/* 239 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (ngModule) {
	  ngModule.controller("ComparatorStep3CtrlAHM", ["$scope", function ($scope) {
	    var _this = this;
	
	    this.resetPaymentDateRange = function () {
	      var payment = $scope.ctrl.application.payment;
	      _this.minJoinDate = new Date();
	      _this.minDebitDate = payment.join_date;
	      payment.debit_date = _this.minDebitDate > payment.debit_date ? _this.minDebitDate : payment.debit_date;
	    };
	    this.resetPaymentDateRange();
	
	    $scope.$watch("ctrl.application.payment.join_date", function () {
	      _this.resetPaymentDateRange();
	    });
	
	    $scope.$watch("ahmctrl.application.dependants", function () {
	      if (_.get(_this.application, "dependants", []).length) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = _this.application.dependants[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var d = _step.value;
	
	            if (_this.isBabyPending(_.get(d, "relationship"))) {
	              _.set(d, "title", "");
	              _.set(d, "first_name", "");
	              _.set(d, "gender", "");
	              _.set(d, "dob", "");
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator["return"]) {
	              _iterator["return"]();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	    }, true);
	  }]);
	};

/***/ }),
/* 240 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (ngModule) {
	  ngModule.controller("ComparatorStep3CtrlAUF", ["$scope", "AonConfig", function ($scope, AonConfig) {
	    var _this = this;
	
	    var ctrl = $scope.$parent.ctrl;
	    var isOperator = ctrl.corporate.is_operator;
	
	    if (isOperator) {
	      var disclaimer = _.get(ctrl.fieldsets, "config.operator_disclaimer", null);
	      if (disclaimer) {
	        this.disclaimer = disclaimer;
	        this.disclaimerPosition = "bottom";
	      }
	    } else {
	      var disclaimer = _.get(ctrl.fieldsets, "config.online_disclaimer", null);
	      if (disclaimer) {
	        this.disclaimer = disclaimer;
	        this.disclaimerPosition = "top";
	      }
	    }
	
	    this.resetPaymentDateRange = function () {
	      var aufMinDate = new Date(Math.max(new Date(), $scope.ctrl.application.payment.join_date));
	      _this.minDate = aufMinDate > ctrl.join_date_minimum ? aufMinDate : ctrl.join_date_minimum;
	      _this.maxDate = new Date(_this.minDate);
	      _this.maxDate.setMonth(_this.minDate.getMonth() + 1);
	      _this.payment = $scope.$parent.ctrl.application.payment;
	      _this.payment.debit_date = _this.minDate;
	    };
	    this.resetPaymentDateRange();
	
	    $scope.$watch("ctrl.application.payment.join_date", function () {
	      _this.resetPaymentDateRange();
	    });
	
	    // If any of the dependants on the application are DEPENDANT_STUDENT's, we need to show
	    // some scripting in the form.
	    this.showDependantStudentScripting = function () {
	      var studentCode = AonConfig.jsConstants.RelationshipsLookup.DEPENDANT_STUDENT;
	      var dependantStudents = _.get(ctrl.application, "dependants", []).filter(function (dependant) {
	        return _.get(dependant, "relationship", null) === studentCode;
	      });
	      return dependantStudents.length > 0;
	    };
	  }]);
	};

/***/ }),
/* 241 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (ngModule) {
	  ngModule.controller("ComparatorStep3CtrlHAMBS", ["AonApplicationService", "AonConfig", "$log", "$sce", "$scope", function (AonApplicationService, AonConfig, $log, $sce, $scope) {
	    var _this = this;
	
	    var ctrl = $scope.$parent.ctrl;
	    var iframe = _.get(AonApplicationService.product.fund, "api.iframe", "");
	    this.nab_iframe_source = $sce.trustAsResourceUrl(iframe);
	    this.creditCardScript = AonConfig.corporate.hambs_credit_card_script;
	
	    this.loading = { iframe: false };
	
	    var onNABIframeMessage = function (e) {
	      console.log(e);
	      $scope.$apply(function () {
	        processNABIframeResponse(e.data);
	      });
	    };
	
	    var processNABIframeResponse = function (data) {
	      var json = JSON.parse(data);
	      if (json.hasOwnProperty("CRN")) {
	        var result = {
	          crn: json.CRN,
	          pan: json.pan,
	          rescode: json.rescode,
	          restext: json.restext,
	          expMonth: json.expMonth,
	          expYear: json.expYear,
	          cardType: json.cardType,
	          cardName: _.get(ctrl.application, "payment.nab.cardName", undefined) };
	
	        if (json.hasOwnProperty("CRN") && json.CRN.length && json.hasOwnProperty("pan") && json.pan.length) {
	          ctrl.application.payment.nab = result;
	        } else {
	          ctrl.application.payment.nab = null;
	        }
	      }
	    };
	
	    var realSubmit = ctrl.onSubmit;
	
	    var haveCreditCardDetails = function () {
	      var result = _.get(ctrl.application, "payment.nab.crn", "");
	      return result.length;
	    };
	
	    var isPaymentTypeDirectDebit = function () {
	      return ctrl.application.payment.type == 0;
	    };
	    var isPaymentTypeRenewal = function () {
	      return ctrl.application.payment.type == 2;
	    };
	
	    this.isPaymentTypeDirectDebit = isPaymentTypeDirectDebit;
	    this.isPaymentTypeRenewal = isPaymentTypeRenewal;
	
	    ctrl.onSubmit = function (form) {
	      var forceNoValidation = arguments[1] === undefined ? false : arguments[1];
	
	      ctrl.debugTrace += "\nHAMBS on submit, forceNoValidate: " + forceNoValidation;
	      ctrl.debugTrace += "\n" + new Error().stack;
	      $log.warn("HAMBS on submit, forceNoValidate:", forceNoValidation);
	      if (ctrl.application.payment.type == 1 && haveCreditCardDetails()) {
	        realSubmit.call(ctrl, form, forceNoValidation);
	      } else if (isPaymentTypeDirectDebit() || isPaymentTypeRenewal()) {
	        realSubmit.call(ctrl, form, forceNoValidation);
	      } else {
	        console.log("Error", form);
	      }
	    };
	
	    this.iframeLoaded = function () {
	      $scope.$apply(function () {
	        _this.loading.iframe = false;
	      });
	
	      // Check for hambs iframe
	      var hambs_iframe = $(".hambs-payment-iframe");
	
	      // It seems that we need to explicitly set the iframe height on load, else
	      // the content inside the iframe is not showing correctly.
	      setTimeout(function () {
	        // We need to set the height to something other than it's current value, to
	        // trigger the inner content to display
	        var initialHeight = hambs_iframe.height() || 210;
	        hambs_iframe.height(initialHeight + 1);
	      }, 0);
	
	      if (hambs_iframe.length) {
	        // Need to trigger Iframe submission here
	        //hambs_iframe.get(0).contentWindow.postMessage("POST", iframe_host);
	        if (window.addEventListener) {
	          window.addEventListener("message", onNABIframeMessage, false);
	        } else if (window.attachEvent) {
	          // IE8
	          window.attachEvent("onmessage", onNABIframeMessage);
	        }
	      }
	    };
	
	    this.changePaymentMethod = function () {
	      _this.loading.iframe = true;
	    };
	
	    this.showVitality = function () {
	      var vitality = _.get(ctrl.fieldsets, "personal.vitality", null);
	      return vitality && ctrl.application.zoho && vitality.channel === ctrl.application.zoho.channel && vitality.lead_category === ctrl.application.zoho.lead_category;
	    };
	
	    this.medicareExpiryNoDaysRequired = ctrl.medicareExpiryNoDaysRequired;
	  }]);
	};

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };
	
	var assign = _interopRequire(__webpack_require__(14));
	
	module.exports = function (ngModule) {
	  /**
	   * Make a function that we can resolve from preSubmitFunction to modify the application object
	   * The idea is preSubmitFunctions run async and then can resolve a function which will get
	   * called and passed in the application object so can modify it as required (eg. scrub
	   * sensitive credit card details, replace with token etc)
	   * @param application
	   */
	  function makeApplicationTransformFunction(tokeniseResult) {
	    return function (application) {
	      application.payment.credit_card = {};
	      application.payment.bpointResultKey = tokeniseResult.ResultKey;
	      return application;
	    };
	  }
	  ngModule.controller("ComparatorStep3CtrlHBF", ["$scope", "$q", "BPointApi", "AonApplicationService", function ($scope, $q, BPointApi, AonApplicationService) {
	    this.ctrl = $scope.$parent.ctrl;
	    var _ctrl$fieldsets$payment$type$constants = this.ctrl.fieldsets.payment.type.constants;
	    var BANK_ACCOUNT = _ctrl$fieldsets$payment$type$constants.BANK_ACCOUNT;
	    var CREDIT_CARD = _ctrl$fieldsets$payment$type$constants.CREDIT_CARD;
	
	    this.ctrl.application.service_selection = this.ctrl.application.service_selection || [];
	    this.ctrl.preSubmitFunctions.push(function (application) {
	      var email_address = application.contact.email_address;
	      var payment = application.payment;
	
	      var deferred = $q.defer();
	      switch (payment.type) {
	        /*
	         * Bank account is supported by bpoint but looks like HBF don't use it
	        case BANK_ACCOUNT:
	           BPointApi.tokeniseBankAccount(payment.bank_account, {email_address, reference}).then(
	            result => deferred.resolve(makeApplicationTransformFunction(result)),
	            errors => deferred.reject({'payment.bank_account': errors})
	          );
	          break;
	          */
	        case CREDIT_CARD:
	          var tokenise = function (crn) {
	            BPointApi.tokeniseCreditCard(payment.credit_card, { email_address: email_address, reference: crn }).then(function (result) {
	              return deferred.resolve(makeApplicationTransformFunction(result));
	            }, function (errors) {
	              return deferred.reject({ payment: { credit_card: errors } });
	            });
	          };
	          AonApplicationService.generateCustomerReference().then(function (reference) {
	            return tokenise(reference);
	          },
	          // If fail to generate one from server fallback to this
	          function (error) {
	            return tokenise("TS" + new Date().time);
	          });
	          break;
	        default:
	          // Unless it's credit card we we don't need to do anything else so we can resolve straight away
	          deferred.resolve();
	      }
	
	      return deferred.promise;
	    });
	  }]);
	};

/***/ }),
/* 243 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (ngModule) {
	  ngModule.controller("ComparatorStep3CtrlHCF", ["AonConfig", "$scope", function (AonConfig, $scope) {
	    var _this = this;
	
	    var ctrl = $scope.$parent.ctrl;
	
	    // Default these to 'Yes'
	    _.set(ctrl.application, "personal.previous_fund.continuous_cover", "Y");
	    if (Object.keys(ctrl.application.partner)) {
	      _.set(ctrl.application, "partner.previous_fund.continuous_cover", "Y");
	    }
	
	    _.set(ctrl.application, "payment.join_date", new Date());
	    this.joinMinDate = ctrl.join_date_minimum;
	    this.joinMaxDate = new Date();
	    // 2017-06-019 terry: HCF allows up to 30 days in the past. covermenow doesn't. limit to "today"
	    //this.joinMinDate.setDate(this.joinMinDate.getDate() - 30);
	    this.joinMaxDate.setDate(this.joinMaxDate.getDate() + 90);
	
	    // Return true if one of the applicants has a previous fund
	    this.isSwitchingFunds = function () {
	      var primaryApplicantSwitching = _.get(ctrl.application, "personal.previous_fund.has_previous_fund", false);
	      var partnerApplicantSwitching = _.get(ctrl.application, "partner.previous_fund.has_previous_fund", false);
	      return primaryApplicantSwitching || partnerApplicantSwitching;
	    };
	
	    // Text for the authority transfer checkbox is different for public vs operator
	    this.fundTransferAuthorityText = function () {
	      return AonConfig.corporate.is_operator ? "Have asked customer if they consent to HCF contacting their current fund to arrange the clearance certificate" : "Do you consent for HCF to contact your previous fund to arrange your transfer?";
	    };
	
	    this.updateDebitDayOptions = function () {
	      // HCF docs:
	      // Fortnightly = 1-31
	      // All other = 1-27
	      //this.debitDayOptions = _.range(1, ctrl.application.payment.frequency == 1 ? 32 : 28);
	
	      // NOTE: temporarily restricting to just 1-27
	      _this.debitDayOptions = _.range(1, 28);
	    };
	    this.updateDebitDayOptions();
	
	    this.updateDebitDate = function () {
	      var debitDay = _.get(ctrl.application, "payment.debit_day");
	      if (debitDay) {
	        var joinDate = _.get(ctrl.application, "payment.join_date");
	        var debitDate = new Date(joinDate);
	        var today = new Date();
	        debitDate.setDate(debitDay);
	        while (today >= debitDate || joinDate > debitDate) {
	          debitDate.setMonth(debitDate.getMonth() + 1);
	        }
	        _.set(ctrl.application, "payment.debit_date", debitDate);
	      }
	    };
	
	    var benefitPaymentChoices = ctrl.fieldsets.payment.benefit_payment.type.options;
	    this.paymentIsBankAccount = function () {
	      return _.get(ctrl.application, "payment.type") == 1;
	    };
	    this.showBenefitAccountDetails = function () {
	      return _.get(ctrl.application, "payment.benefit_payment.type") === benefitPaymentChoices.OTHER;
	    };
	    var updateBenefitAccountOptions = function () {
	      if (_this.paymentIsBankAccount()) {
	        _this.benefitAccountOptions = [["Bank account - same details as payment account", benefitPaymentChoices.SAME], ["Bank account - different account", benefitPaymentChoices.OTHER]];
	      } else {
	        _this.benefitAccountOptions = [["Bank account", benefitPaymentChoices.OTHER]];
	      }
	    };
	    updateBenefitAccountOptions();
	    $scope.$watch("ctrl.application.payment.type", updateBenefitAccountOptions);
	    console.log(benefitPaymentChoices, this.benefitAccountOptions);
	  }]);
	};

/***/ }),
/* 244 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (ngModule) {
	  ngModule.controller("ComparatorStep3CtrlHCI", ["AonApplicationService", "AonConfig", "$log", "$sce", "$scope", function (AonApplicationService, AonConfig, $log, $sce, $scope) {
	    var _this = this;
	
	    var ctrl = $scope.$parent.ctrl;
	    var iframe = _.get(AonApplicationService.product.fund, "api.iframe", "");
	    this.nab_iframe_source = $sce.trustAsResourceUrl(iframe);
	    this.creditCardScript = AonConfig.corporate.hambs_credit_card_script;
	
	    this.loading = { iframe: false };
	
	    var onNABIframeMessage = function (e) {
	      console.log(e);
	      $scope.$apply(function () {
	        processNABIframeResponse(e.data);
	      });
	    };
	
	    var processNABIframeResponse = function (data) {
	      var json = JSON.parse(data);
	      if (json.hasOwnProperty("CRN")) {
	        var result = {
	          crn: json.CRN,
	          pan: json.pan,
	          rescode: json.rescode,
	          restext: json.restext,
	          expMonth: json.expMonth,
	          expYear: json.expYear,
	          cardType: json.cardType,
	          cardName: _.get(ctrl.application, "payment.nab.cardName", undefined) };
	
	        if (json.hasOwnProperty("CRN") && json.CRN.length && json.hasOwnProperty("pan") && json.pan.length) {
	          ctrl.application.payment.nab = result;
	        } else {
	          ctrl.application.payment.nab = null;
	        }
	      }
	    };
	
	    var realSubmit = ctrl.onSubmit;
	
	    var haveCreditCardDetails = function () {
	      var result = _.get(ctrl.application, "payment.nab.crn", "");
	      return result.length;
	    };
	
	    var isPaymentTypeDirectDebit = function () {
	      return ctrl.application.payment.type == 0;
	    };
	    var isPaymentTypeRenewal = function () {
	      return ctrl.application.payment.type == 2;
	    };
	
	    this.isPaymentTypeDirectDebit = isPaymentTypeDirectDebit;
	    this.isPaymentTypeRenewal = isPaymentTypeRenewal;
	
	    ctrl.onSubmit = function (form) {
	      var forceNoValidation = arguments[1] === undefined ? false : arguments[1];
	
	      ctrl.debugTrace += "\nHAMBS on submit, forceNoValidate: " + forceNoValidation;
	      ctrl.debugTrace += "\n" + new Error().stack;
	      $log.warn("HAMBS on submit, forceNoValidate:", forceNoValidation);
	      if (ctrl.application.payment.type == 1 && haveCreditCardDetails()) {
	        realSubmit.call(ctrl, form, forceNoValidation);
	      } else if (isPaymentTypeDirectDebit() || isPaymentTypeRenewal()) {
	        realSubmit.call(ctrl, form, forceNoValidation);
	      } else if (ctrl.application.payment.type == 3) {
	        realSubmit.call(ctrl, form, forceNoValidation);
	      } else {
	        console.log("Error", form);
	      }
	    };
	
	    this.iframeLoaded = function () {
	      $scope.$apply(function () {
	        _this.loading.iframe = false;
	      });
	
	      // Check for hambs iframe
	      var hambs_iframe = $(".hambs-payment-iframe");
	
	      // It seems that we need to explicitly set the iframe height on load, else
	      // the content inside the iframe is not showing correctly.
	      setTimeout(function () {
	        // We need to set the height to something other than it's current value, to
	        // trigger the inner content to display
	        var initialHeight = hambs_iframe.height() || 210;
	        hambs_iframe.height(initialHeight + 1);
	      }, 0);
	
	      if (hambs_iframe.length) {
	        // Need to trigger Iframe submission here
	        //hambs_iframe.get(0).contentWindow.postMessage("POST", iframe_host);
	        if (window.addEventListener) {
	          window.addEventListener("message", onNABIframeMessage, false);
	        } else if (window.attachEvent) {
	          // IE8
	          window.attachEvent("onmessage", onNABIframeMessage);
	        }
	      }
	    };
	
	    this.changePaymentMethod = function () {
	      _this.loading.iframe = true;
	
	      if (ctrl.application.payment.type == 3) {
	        ctrl.application.payment.benefits_same_account = false;
	      }
	    };
	
	    this.showVitality = function () {
	      var vitality = _.get(ctrl.fieldsets, "personal.vitality", null);
	      return vitality && ctrl.application.zoho && vitality.channel === ctrl.application.zoho.channel && vitality.lead_category === ctrl.application.zoho.lead_category;
	    };
	
	    this.medicareExpiryNoDaysRequired = function (cardColor) {
	      var daysRequired = false;
	      var colorsRequiringDays = [AonConfig.jsConstants.MedicareCardColors.Blue, AonConfig.jsConstants.MedicareCardColors.Yellow];
	      if (cardColor !== null && colorsRequiringDays.includes(cardColor)) {
	        daysRequired = true;
	      }
	      // The aon-date component is taking this as a literal string, and checking truthiness on it
	      return daysRequired ? "" : "true";
	    };
	  }]);
	};

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };
	
	var moment = _interopRequire(__webpack_require__(1));
	
	var isWeekday = function (date) {
	    return date.isoWeekday() <= 5;
	};
	
	function nextWeekday(date) {
	    var _date = moment(date);
	    while (!isWeekday(_date)) {
	        _date = _date.add(1, "days");
	    }
	    return _date;
	}
	
	function addWeekdays(date, days) {
	    date = moment(date);
	    while (days > 0) {
	        date = date.add(1, "days");
	        if (isWeekday(date)) {
	            days -= 1;
	        }
	    }
	    return date;
	}
	
	module.exports = function (ngModule) {
	    ngModule.controller("ComparatorStep3CtrlHIF", ["$scope", "$controller", "AonConfig", function ($scope, $controller, AonConfig) {
	        // This is black magic that allows us to use another controller (Hambs) as a parent of
	        // this one, without having to nest with routing or templates...
	        // Taken from:
	        // https://stackoverflow.com/questions/18461263/can-an-angularjs-controller-inherit-from-another-controller-in-the-same-module
	        var hambs = $controller("ComparatorStep3CtrlHAMBS as hambsCtrl", { $scope: $scope });
	        angular.extend(this, hambs);
	
	        var ctrl = $scope.$parent.$parent.ctrl;
	
	        var originalDebitDateDisabled = ctrl.debitDateDisabled;
	        ctrl.debitDateDisabled = function (date, mode) {
	            // Disable weekends
	            if (date.getDay() == 0 || date.getDay() == 6) {
	                return true;
	            }
	            // Disable 29, 30, 31 for some payment frequencies
	            var frequencies = AonConfig.jsConstants.PaymentFrequencies;
	            var constrainFrequencies = [frequencies.Monthly, frequencies.Quarterly, frequencies["Half Yearly"]];
	            var paymentFreq = _.get(ctrl.application, "payment.frequency");
	            var isLast3Days = [29, 30, 31].includes(date.getDate());
	            if (constrainFrequencies.includes(paymentFreq) && isLast3Days) {
	                return true;
	            }
	            return originalDebitDateDisabled(date, mode);
	        };
	
	        ctrl.updateDebitDate = function () {
	            var today = moment();
	            var joinDate = moment(_.get(ctrl.application, "payment.join_date", moment()));
	            var joinDateDiff = Math.round(joinDate.diff(today, "days", true));
	            var minDebitDate = nextWeekday(joinDateDiff <= 3 ? addWeekdays(joinDate, 3) : moment(joinDate));
	            var maxDebitDate = addWeekdays(joinDate, 20);
	
	            var payment = $scope.$parent.ctrl.application.payment;
	            payment.debit_date = minDebitDate;
	            ctrl.debit_date_minimum = minDebitDate;
	            ctrl.debit_date_maximum = maxDebitDate;
	        };
	        ctrl.updateDebitDate();
	    }]);
	};

/***/ }),
/* 246 */
/***/ (function(module, exports) {

	"use strict";
	
	var _slicedToArray = function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { var _arr = []; for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) { _arr.push(_step.value); if (i && _arr.length === i) break; } return _arr; } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } };
	
	var _toConsumableArray = function (arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } };
	
	module.exports = function (ngModule) {
	  ngModule.controller("ComparatorStep3CtrlNHB", ["$controller", "$scope", function ($controller, $scope) {
	    // Extend the base hambs controller
	    var hambs = $controller("ComparatorStep3CtrlHAMBS as hambsCtrl", { $scope: $scope });
	    angular.extend(this, hambs);
	    var ctrl = $scope.$parent.ctrl;
	
	    var setIfHasKeyAndEmpty = function (_dest, _source) {
	      var fieldSetPath = _dest.replace(/^dependants\.(\d+)/, "dependant.");
	      var fieldSet = _.get(ctrl.fieldsets, fieldSetPath);
	      if (!!fieldSet && _.isEmpty(_.get(ctrl.application, _dest))) {
	        _.set(ctrl.application, _dest, _.get(ctrl.application, _source));
	      }
	    };
	
	    var expandToDependants = function (path) {
	      return new Array(ctrl.application.number_of_dependants).fill(0).map(function (_, index) {
	        return "dependants." + index + "." + path;
	      });
	    };
	
	    // A list of [changed field name pattern, function to generate target prefills]
	    // When an input is blurred, the name of the field that is changing
	    // will be matched against the pattern, and if it matches, the function
	    // will be called with the regex match, and the resulting field names
	    // will be pre-filled with the value coming from the blurred field.
	    var preFills = [["personal\\.first_name", function () {
	      return "policy.medicare.first_name";
	    }], ["personal\\.middle_name", function () {
	      return "policy.medicare.middle_name";
	    }], ["personal\\.previous_fund\\.has_previous_fund", function () {
	      return ["partner.previous_fund.has_previous_fund"];
	    }], ["personal\\.previous_fund\\.fund_id", function () {
	      return ["partner.previous_fund.fund_id"];
	    }], ["personal\\.previous_fund\\.member_number", function () {
	      return ["partner.previous_fund.member_number"];
	    }], ["personal\\.previous_fund\\.cover", function () {
	      return ["partner.previous_fund.cover"];
	    }], ["personal\\.previous_fund\\.date_joined", function () {
	      return ["partner.previous_fund.date_joined"];
	    }], ["personal\\.previous_fund\\.date_ceased", function () {
	      return ["partner.previous_fund.date_ceased"];
	    }], ["personal\\.previous_fund\\.transfer_authority", function () {
	      return ["partner.previous_fund.transfer_authority"];
	    }], ["personal\\.previous_fund\\.cover_to_be_transferred", function () {
	      return ["partner.previous_fund.cover_to_be_transferred"];
	    }], ["policy\\.medicare\\.number", function () {
	      return ["partner.medicare.number"].concat(_toConsumableArray(expandToDependants("medicare.number")));
	    }], ["policy\\.medicare\\.last_name", function () {
	      return ["partner.medicare.last_name"].concat(_toConsumableArray(expandToDependants("medicare.last_name")));
	    }], ["policy\\.medicare\\.expiry", function () {
	      return ["partner.medicare.expiry"].concat(_toConsumableArray(expandToDependants("medicare.expiry")));
	    }], ["partner\\.first_name", function () {
	      return "partner.medicare.first_name";
	    }], ["partner\\.middle_name", function () {
	      return "partner.medicare.middle_name";
	    }], ["(dependants\\.\\d+)\\.first_name", function (match) {
	      return "" + match[1] + ".medicare.first_name";
	    }], ["(dependants\\.\\d+)\\.middle_name", function (match) {
	      return "" + match[1] + ".medicare.middle_name";
	    }]];
	
	    this.prefillOnChange = function (key) {
	      var scope = this;
	      var pathChanged = "" + scope.modelPath + "." + key;
	
	      preFills.forEach(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2);
	
	        var pattern = _ref2[0];
	        var handler = _ref2[1];
	
	        var match = pathChanged.match(new RegExp(pattern));
	        if (match) {
	          var destinations = handler(match);
	          (Array.isArray(destinations) ? destinations : [destinations]).forEach(function (dest) {
	            return setIfHasKeyAndEmpty(dest, pathChanged);
	          });
	        }
	      });
	    };
	
	    $scope.$watch("ctrl.application.number_of_dependants", function () {
	      // Trigger pre-fill on any new dependants that are created
	      // This assumes a lot of knowledge about the preFills array.
	      preFills.forEach(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2);
	
	        var pattern = _ref2[0];
	        var handler = _ref2[1];
	
	        var unRegex = pattern.replace(/[\\()]/g, "");
	        if (!unRegex.match(/^dependants.*/)) {
	          var destinations = handler();
	          (Array.isArray(destinations) ? destinations : [destinations]).forEach(function (dest) {
	            return setIfHasKeyAndEmpty(dest, unRegex);
	          });
	        }
	      });
	    });
	
	    // Only show the corporate name question if the applicant's eligibility is
	    // Contractor, and selected contractor is Other
	    this.showCorporateName = function () {
	      // These codes come from the NHB fund handler (EligibilityReason and sub_reasons)
	      var EligibilityContractor = 0;
	      var EligibilityContractorOther = "005";
	      var eligibilityReason = _.get(ctrl.application, "eligibility_reason");
	      var eligibilityDetail = _.get(ctrl.application, "eligibility_subreason");
	      return eligibilityReason === EligibilityContractor && eligibilityDetail === EligibilityContractorOther;
	    };
	  }]);
	};

/***/ }),
/* 247 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (ngModule) {
	  ngModule.controller("ComparatorStep3CtrlNIB", ["NIBApi", "$q", "$scope", function (NIBApi, $q, $scope) {
	    var _this = this;
	
	    var ctrl = $scope.$parent.ctrl;
	
	    var isWeekend = function (date) {
	      return date.getDay() == 6 || date.getDay() == 0;
	    };
	
	    ctrl.debitDateDisabled = function (date, mode) {
	      return mode === "day" && (_.includes(ctrl.excluded_debit_days, date.getDate()) || isWeekend(date));
	    };
	
	    this.joinMinDate = new Date();
	    this.joinMaxDate = new Date();
	    this.joinMaxDate.setDate(this.joinMaxDate.getDate() + 60);
	
	    $scope.$watch("nibctrl.debit_date", function () {
	      if (typeof $scope.nibctrl.debit_date === "object") {
	        ctrl.application.payment.debit_date = _this.debit_date;
	      }
	    });
	
	    var CREDIT_CARD = ctrl.fieldsets.payment.type.constants.CREDIT_CARD;
	
	    ctrl.preSubmitFunctions.push(function (application) {
	      var payment = application.payment;
	
	      var deferred = $q.defer();
	
	      if (payment.type === CREDIT_CARD) {
	        NIBApi.encryptCCNumber(payment.credit_card.number).then(function (encryptedCC) {
	          deferred.resolve(function (application) {
	            _.set(application, "payment.credit_card.number", "");
	            _.set(application, "payment.credit_card.encrypted_number", encryptedCC);
	            return application;
	          });
	        })["catch"](function (error) {
	          return deferred.reject({
	            payment: {
	              credit_card: {
	                number: [error.data && error.data.message || "Error tokenizing credit card"] } } });
	        });
	        return deferred.promise;
	      }
	
	      // Unless it's credit card we we don't need to do anything else so we can resolve straight away
	      deferred.resolve();
	    });
	  }]);
	};

/***/ }),
/* 248 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (ngModule) {
	  ngModule.controller("ComparatorStep3CtrlNoGateway", ["AonApplicationService", "$log", "$sce", "$scope", function (AonApplicationService, $log, $sce, $scope) {
	
	    var ctrl = $scope.$parent.ctrl;
	    var currentTypes = ctrl.fieldsets.payment.type.choices;
	
	    $scope.$watch("ctrl.application.payment.type", function () {
	      ctrl.application.payment.credit_card.deferred = false;
	      for (var t = 0; t < currentTypes.length; ++t) {
	        if (currentTypes[t][0] == ctrl.application.payment.type && currentTypes[t][1].match(/credit.*deferred/i)) {
	          ctrl.application.payment.credit_card.deferred = true;
	        }
	      }
	    });
	  }]);
	};

/***/ }),
/* 249 */
/***/ (function(module, exports) {

	"use strict";
	
	var _slicedToArray = function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { var _arr = []; for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) { _arr.push(_step.value); if (i && _arr.length === i) break; } return _arr; } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } };
	
	module.exports = function (ngModule) {
	  ngModule.controller("ComparatorStep3CtrlRTE", ["AonConfig", "OperatorService", "$scope", function (AonConfig, OperatorService, $scope) {
	    var _this = this;
	
	    var ctrl = $scope.$parent.ctrl;
	    var _AonConfig$jsConstants = AonConfig.jsConstants;
	    var PaymentFrequenciesLookup = _AonConfig$jsConstants.PaymentFrequenciesLookup;
	    var PaymentMethodsLookup = _AonConfig$jsConstants.PaymentMethodsLookup;
	
	    this.isCreditCardPayment = function () {
	      return _.get(ctrl.application, "payment.type") === PaymentMethodsLookup.CREDIT_CARD;
	    };
	
	    this.requiresBenefitsAccount = function () {
	      return _.get(ctrl.application, "payment.type") !== PaymentMethodsLookup.BANK_ACCOUNT || !_.get(ctrl.application, "payment.benefits_same_account");
	    };
	
	    this.updatePaymentFrequencyOptions = function () {
	      if (ctrl.application.payment.type === PaymentMethodsLookup.INVOICE) {
	        (function () {
	          // invoice payment - limited set of options
	          var allowedFrequencies = [PaymentFrequenciesLookup.MONTHLY, PaymentFrequenciesLookup.QUARTERLY, PaymentFrequenciesLookup.HALF_YEARLY, PaymentFrequenciesLookup.YEARLY];
	
	          _this.paymentFrequencyOptions = ctrl.fieldsets.payment.frequency.choices.filter(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 1);
	
	            var code = _ref2[0];
	            return allowedFrequencies.includes(code);
	          });
	
	          // If the frequency selected is no longer valid, clear it
	          if (!allowedFrequencies.includes(ctrl.application.payment.frequency)) {
	            _.set(ctrl.application, "payment.frequency", undefined);
	          }
	        })();
	      } else {
	        // Reset to the full list of choices from the fieldsets
	        _this.paymentFrequencyOptions = ctrl.fieldsets.payment.frequency.choices;
	      }
	    };
	    this.updatePaymentFrequencyOptions();
	
	    $scope.$watch("ctrl.application.payment.type", this.updatePaymentFrequencyOptions);
	
	    $scope.$watch("ctrl.application.policy.discount_code",
	    // When employment group/discount code is changed, update pricing and sync with the operator filter
	    function () {
	      OperatorService.updateApplicantDependantFilters();
	      ctrl.refetchPricing();
	    });
	    this.debitDateDisabled = function (date, mode) {
	      var dayOfWeek = date.getDay();
	      var frequency = ctrl.application.payment.frequency;
	      var isDirectDebit = ctrl.application.payment.type === PaymentMethodsLookup.BANK_ACCOUNT;
	      if (frequency === PaymentFrequenciesLookup.FORTNIGHTLY && isDirectDebit) {
	        return dayOfWeek !== 5;
	      }
	      return ctrl.debitDateDisabled(date, mode);
	    };
	    // ensure that available debit dates are updated when payment type is changed - parent
	    // controller already watches payment frequency
	    $scope.$watch("ctrl.application.payment.type", function () {
	      ctrl.updateDebitDate();
	    });
	  }]);
	};

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };
	
	var moment = _interopRequire(__webpack_require__(1));
	
	var getDiscountCodeRestrictions = __webpack_require__(2).getDiscountCodeRestrictions;
	
	module.exports = function (ngModule) {
	  ngModule.controller("ComparatorStep3CtrlSPS", ["AonApplicationService", "AonConfig", "$log", "$sce", "$scope", function (AonApplicationService, AonConfig, $log, $sce, $scope) {
	    var _this = this;
	
	    var ctrl = $scope.$parent.ctrl;
	    var iframe = _.get(AonApplicationService.product.fund, "api.iframe", "");
	    this.iframeSource = $sce.trustAsResourceUrl(iframe);
	    this.iframeMessage = null;
	    this.iframeError = null;
	    this.iframeLastResponse = null;
	    this.iframeLoading = false;
	
	    this.changePaymentMethod = function () {
	      _this.iframeLoading = true;
	    };
	
	    var onIframeMessage = function (event) {
	      var iframeOrigin = iframe.match(/(https?:\/\/.*?)\//)[1];
	      if (event.origin === iframeOrigin) {
	        $scope.$apply(function () {
	          processIframeResponse(JSON.parse(event.data));
	        });
	      }
	    };
	
	    var haveCreditCardDetails = function () {
	      var token = _.get(ctrl.application, "payment.credit_card.token");
	      var number = _.get(ctrl.application, "payment.credit_card.number");
	      var expiry = _.get(ctrl.application, "payment.credit_card.expiry");
	      return !!token && !!number && !!expiry;
	    };
	
	    var processIframeResponse = function (data) {
	      _this.iframeLastResponse = data;
	      var success = data.Status === "Success";
	      if (!success) {
	        _this.iframeMessage = data.Message;
	        _this.iframeError = true;
	        return;
	      }
	
	      var token = _.get(data, "CardInfo.Token");
	      var number = _.get(data, "CardInfo.CardNo");
	      var expiry = _.get(data, "CardInfo.ExpiryDate");
	      _.set(ctrl.application, "payment.credit_card.token", token);
	      _.set(ctrl.application, "payment.credit_card.number", number);
	      _.set(ctrl.application, "payment.credit_card.expiry", expiry);
	
	      if (haveCreditCardDetails()) {
	        _this.iframeMessage = "Success: credit card was processed successfully.";
	        _this.iframeError = false;
	      } else {
	        _this.iframeMessage = "Error: credit card was not processed successfully.";
	        _this.iframeError = true;
	      }
	    };
	
	    var realSubmit = ctrl.onSubmit;
	
	    var isPaymentTypeDirectDebit = function () {
	      return ctrl.application.payment.type == 2;
	    };
	    this.isPaymentTypeDirectDebit = isPaymentTypeDirectDebit;
	
	    ctrl.onSubmit = function (form) {
	      var forceNoValidation = arguments[1] === undefined ? false : arguments[1];
	
	      if (ctrl.application.payment.type == 0 && haveCreditCardDetails()) {
	        realSubmit.call(ctrl, form, forceNoValidation);
	      } else if (isPaymentTypeDirectDebit()) {
	        realSubmit.call(ctrl, form, forceNoValidation);
	      } else {
	        console.log("Error", form);
	      }
	    };
	
	    this.iframeLoaded = function () {
	      $scope.$apply(function () {
	        _this.iframeLoading = false;
	      });
	
	      var iframe = $(".payment-iframe");
	      if (iframe.length) {
	        if (window.addEventListener) {
	          window.addEventListener("message", onIframeMessage, false);
	        } else if (window.attachEvent) {
	          // IE8
	          window.attachEvent("onmessage", onIframeMessage);
	        }
	      }
	    };
	
	    var isFriday = function (date) {
	      return date.getDay() == 5;
	    };
	    var originalDebitDateDisabled = ctrl.debitDateDisabled;
	    ctrl.debitDateDisabled = function (date, mode) {
	      if (ctrl.application.payment.frequency == AonConfig.jsConstants.PaymentFrequencies.Fortnightly) {
	        return !isFriday(date);
	      }
	      return originalDebitDateDisabled(date, mode);
	    };
	
	    this.debitDayOptions = _.range(1, 29);
	    this.showDebitDaySelect = function () {
	      return ctrl.fieldsets.payment.debit_day_frequencies.includes(ctrl.application.payment.frequency);
	    };
	
	    this.updateDebitDateOptions = function () {
	      // Payment should be the next two fridays on or after the join date, so long as
	      // the first of those fridays is at least 1 day after the current date (e.g. its
	      // fine to have payment on the friday if joining on the thursday, but joining on
	      // friday means first payment is the next friday).
	      var today = moment();
	      var joinDate = moment(_.get(ctrl.application, "payment.join_date", moment()));
	      var firstFriday = moment(joinDate).isoWeekday("Friday");
	      if (firstFriday.isBefore(joinDate)) {
	        firstFriday.add(1, "weeks");
	      }
	      // The Math.round is needed as moment truncates e.g. 1.9999 to 1. The current version
	      // of moment js doesn't seem to have this issue, but our version will truncate.
	      if (Math.round(firstFriday.diff(today, "days", true)) < 1) {
	        firstFriday.add(1, "weeks");
	      }
	      var secondFriday = moment(firstFriday);
	      secondFriday.add(1, "weeks");
	
	      _this.debitDateOptions = [firstFriday, secondFriday].map(function (date) {
	        return [date, date.format("ddd DD/MM/YYYY")];
	      });
	    };
	    this.updateDebitDateOptions();
	
	    $scope.$watch("ctrl.application.payment.join_date", this.updateDebitDateOptions);
	
	    // If a discount code has been selected, and the code restricts the payment frequencies
	    // allowed, then limit the debit day options
	    $scope.$watch("ctrl.application.policy.discount_code", function (code) {
	      var restrictions = getDiscountCodeRestrictions(code);
	      if (restrictions) {
	        _this.debitDayOptions = [1];
	      }
	    });
	
	    this.showConditionalFields = function (section) {
	      var checkValid = arguments[1] === undefined ? false : arguments[1];
	
	      var isCovered = _.get(ctrl.application, "policy.is_covered_by_policy");
	      var medicareCardType = _.get(ctrl.application, "policy.medicare.card_type");
	      var isRebate = _.get(ctrl.application, "policy.federal_rebate");
	      var allEligible = _.get(ctrl.application, "policy.medicare.all_members_eligible");
	
	      var isCoveredValid = !isRebate || isCovered === true;
	      var medicateCardTypeValid = !isRebate || ["green", "blue"].includes(medicareCardType);
	      // For all-eligible, we want to show the remaining form sections, but not allow
	      // them to click 'Next' (it's not a valid state if they haven't answered the
	      // question, but the remaining form items should still show)
	      var allEligibleValid = checkValid ? !isRebate || allEligible === true : allEligible !== false;
	
	      return ({
	        rebate: isCoveredValid,
	        medicare: isCoveredValid && medicateCardTypeValid,
	        payment: isCoveredValid && medicateCardTypeValid && allEligibleValid })[section];
	    };
	
	    // If the corporate has defined it's own application page, set some default values
	    if (AonConfig.corporate.apply_page_template === "apply.sps.corporate") {
	      var isRebate = _.get(ctrl.application, "policy.federal_rebate");
	      if (isRebate) {
	        _.set(ctrl.application, "policy.is_covered_by_policy", true);
	        _.set(ctrl.application, "policy.medicare.card_type", "green");
	      }
	
	      _.set(ctrl.application, "payment.type", 2);
	      _.set(ctrl.application, "payment.benefits_same_account", true);
	      _.set(ctrl.application, "contact.phone", _.get(ctrl.application, "contact.phone_mobile"));
	
	      // Override the default application valid check to disable the next button
	      ctrl.applicationValid = function () {
	        return _this.showConditionalFields("payment", true);
	      };
	    }
	  }]);
	};

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { "default": obj }; };
	
	var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };
	
	var _slicedToArray = function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { var _arr = []; for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) { _arr.push(_step.value); if (i && _arr.length === i) break; } return _arr; } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } };
	
	var filter = _interopRequire(__webpack_require__(180));
	
	var map = _interopRequire(__webpack_require__(15));
	
	var isFunction = _interopRequire(__webpack_require__(31));
	
	var assign = _interopRequire(__webpack_require__(14));
	
	var _utilityComparator = __webpack_require__(2);
	
	var comparatorUtilities = _interopRequireWildcard(_utilityComparator);
	
	var _utilityRebateScript = __webpack_require__(290);
	
	var formatDate = _utilityRebateScript.formatDate;
	var formatJoinDate = _utilityRebateScript.formatJoinDate;
	var getRebateScriptConfig = _utilityRebateScript.getRebateScriptConfig;
	var getRebateTierIncome = _utilityRebateScript.getRebateTierIncome;
	var isRebateScriptValid = _utilityRebateScript.isRebateScriptValid;
	var rebateScriptMedicareColorOptions = _utilityRebateScript.rebateScriptMedicareColorOptions;
	var restrictFieldSets = _utilityComparator.restrictFieldSets;
	
	module.exports = function (ngModule) {
	
	  ngModule.controller("ComparatorStep3Ctrl", ["AonApi", "AonApplicationService", "AonConfig", "application", "fieldsets", "$log", "OperatorService", "$q", "$sce", "$scope", "$state", "ZohoService", "zohoStage", function (AonApi, AonApplicationService, AonConfig, application, fieldsets, $log, OperatorService, $q, $sce, $scope, $state, ZohoService, zohoStage) {
	    var _this = this;
	
	    var zohoStageIsClosed = zohoStage && zohoStage.is_closed;
	
	    // Track the number of submissions so that we can set a hard limit
	    // on how many times we update Zoho
	    var submissionCount = 0;
	
	    // Limit on the number of submissions before we bail out
	    var maxApplicationSubmissions = 10;
	
	    //
	    this.debugTrace = "";
	    this.bailedOut = false;
	
	    // used to track when multiple requests to the application endpoint
	    // are submitted within one application session
	    this.applicationId = Math.random().toString() + new Date().getTime();
	
	    // Track the application event
	    AonApplicationService.trackEvent(AonConfig.jsConstants.TrackingEvents.Application, AonApplicationService.product.fund.id);
	
	    this.fieldsets = fieldsets;
	    this.corporate = $scope.$parent.ctrl.corporate;
	    this.application = application;
	    this.application.corporate_script_responses = {};
	    this.product = AonApplicationService.product.selectedPrice;
	    this["package"] = AonApplicationService.product;
	    this.rebate_tier_choices = AonApplicationService.getRebateTierChoices(application);
	    var text = AonApplicationService.getRebateTierText(application);
	    this.rebate_tier_caption = text.caption;
	    this.rebate_tier_description = text.description;
	    this.hasPartner = application.hasPartner();
	
	    this.showEndOfApplicationScript = !!this.corporate.end_of_application_script;
	    this.fundScript = fieldsets.end_of_application_script;
	    this.applicationDisabledStageIsClosed = zohoStageIsClosed;
	    this.applicationDisabledPriceNotAvailable = !this.product.is_available_for_purchase;
	    this.applicationDisabledFundPublicJoins = !this.corporate.is_operator && this.product.fund.disable_public_joins;
	    this.showApplicationForm = !(this.applicationDisabledPriceNotAvailable || this.applicationDisabledFundPublicJoins || this.applicationDisabledStageIsClosed);
	
	    var updatePricing = function () {
	      _this.quoted_premium_freq = $scope.$parent.ctrl.paymentFrequencyLabel();
	      _this.quoted_premium = $scope.$parent.ctrl.currentPrice(AonApplicationService.product);
	      _this.current_pricing = $scope.$parent.ctrl.currentPricing(AonApplicationService.product);
	    };
	    updatePricing();
	
	    // Scroll the window depending on operator mode
	    if (this.corporate.is_operator) {
	      $scope.$parent.ctrl.scrollToId("ui-view");
	    } else {
	      $scope.$parent.ctrl.scrollToId("step-progress-header", 100);
	    }
	
	    // Return early if we are not showing the application form, to prevent any side-effects from running
	    // (e.g. updated zoho stage)
	    if (!this.showApplicationForm) {
	      return;
	    }
	
	    // If a Zoho applicant, update the 'Stage' on the opportunity
	    if (application.zoho_id !== undefined) {
	      ZohoService.setStage(application.zoho_id, "application");
	    }
	
	    // If the fund chosen in step 1 is not present as an option for the specific fund, force new selection.
	    // This does not seem to be happening automatically as it should for angular-driven select list.
	    var current_fund = _.get(this.application, "personal.previous_fund.fund_id");
	    var fund_choices = _.get(this.fieldsets, "personal.previous_fund.fund_id.grouped_choices");
	    if (fund_choices && current_fund) {
	      var valid_fund = false;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = fund_choices[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var check_fund = _step.value;
	
	          if (check_fund.id == current_fund) {
	            valid_fund = true;
	            break;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator["return"]) {
	            _iterator["return"]();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      if (!valid_fund) {
	        _.set(this.application, "personal.previous_fund.fund_id", null);
	      }
	    }
	
	    var lhc_age_validation_message = "Please enter an age between 30 and 110";
	    _.set(this.fieldsets, "dependant.lhc_age_validator", {
	      error_messages: {
	        min: lhc_age_validation_message,
	        max: lhc_age_validation_message }
	    });
	
	    /**
	     * Configure join and debit date validation
	     * Join date minimum is usually current date, unless fund has specified
	     * minimum_join_date_relative_to_today != 0, in which case add this number of
	     * days to the current date
	     * Debit date minimum is usually current date, unless fund has specified
	     * minimum_debit_date_relative_to_today != 0, in which case add this number of
	     * days to the current date
	     */
	    var today = new Date();
	    var cooling_off_period_applies = _.get(this.application, "zoho.cooling_off_applies");
	    var cooling_off_period = _.get(this.application, "zoho.cooling_off_period");
	
	    this.join_date_minimum = new Date();
	    this.join_date_maximum = null;
	    this.debit_date_minimum = new Date();
	    var minimum_cooloff_date = new Date();
	    var fund_join_date_minimum = new Date();
	
	    if (cooling_off_period_applies) {
	      minimum_cooloff_date.setDate(minimum_cooloff_date.getDate() + cooling_off_period);
	    }
	
	    var join_date_offset = _.get(this.product, "fund.minimum_join_date_relative_to_today", 0);
	    fund_join_date_minimum.setDate(fund_join_date_minimum.getDate() + join_date_offset);
	
	    this.join_date_minimum = minimum_cooloff_date > fund_join_date_minimum ? minimum_cooloff_date : fund_join_date_minimum;
	
	    var max_join_date_offset = _.get(this.fieldsets, "payment.maximum_join_date_relative_to_today", null);
	    if (max_join_date_offset !== null) {
	      this.join_date_maximum = new Date();
	      this.join_date_maximum.setDate(this.join_date_maximum.getDate() + max_join_date_offset);
	    }
	
	    var debit_date_offset_from_today = _.get(this.fieldsets, "payment.minimum_debit_date_relative_to_today", 0);
	    this.debit_date_minimum.setDate(this.debit_date_minimum.getDate() + debit_date_offset_from_today);
	    var debit_date_min_value_from_today = this.debit_date_minimum;
	
	    _.set(this.application, "payment.join_date", this.join_date_minimum);
	    _.set(this.application, "payment.debit_date", this.debit_date_minimum);
	
	    // This fieldset is a mapping of payment_frequency -> maximum_offset_days_relative_to_join_date
	    var debit_date_maximum_offset_mapping = _.get(this.fieldsets, "payment.debit_date_maximum_offset_mapping");
	    // This fieldset is a mapping of payment_frequency -> minimum_offset_days_relative_to_debit_date
	    var debit_date_minimum_offset_mapping = _.get(this.fieldsets, "payment.minimum_debit_date_offset_mapping");
	
	    // Fund handler can provide an array of days (integers) to disable in the date picker
	    var excluded_debit_days = _.get(this.fieldsets, "payment.exclude_days", []);
	    this.excluded_debit_days = excluded_debit_days;
	    this.debitDateDisabled = function (date, mode) {
	      return mode === "day" && _.includes(excluded_debit_days, date.getDate());
	    };
	
	    this.updateDebitDate = function () {
	      var minimum = new Date(_this.application.payment.join_date.getTime());
	
	      var debit_date_minimum_offset = _.get(debit_date_minimum_offset_mapping, _this.application.payment.frequency);
	      if (debit_date_minimum_offset) {
	        minimum.setDate(minimum.getDate() + debit_date_minimum_offset);
	      }
	
	      if (minimum < debit_date_min_value_from_today) {
	        minimum = debit_date_min_value_from_today;
	      }
	
	      _this.debit_date_minimum = minimum;
	      var new_debit_date = minimum < _this.application.payment.debit_date ? _this.application.payment.debit_date : minimum;
	      // While the new_debit_date is in the excluded days list, increment the day
	      while (_.includes(excluded_debit_days, new_debit_date.getDate())) {
	        new_debit_date.setDate(new_debit_date.getDate() + 1);
	      }
	
	      var debit_date_maximum_offset = _.get(debit_date_maximum_offset_mapping, _this.application.payment.frequency);
	      if (debit_date_maximum_offset) {
	        var maximum = new Date(_this.application.payment.join_date.getTime());
	        maximum.setDate(maximum.getDate() + debit_date_maximum_offset);
	
	        maximum = maximum || _this.application.payment.debit_date; // When frequency is not yet selected
	        _this.debit_date_maximum = maximum;
	        new_debit_date = maximum > new_debit_date ? new_debit_date : maximum;
	        // While the new_debit_date is in the excluded days list, decrement the day (so that we don' go over the max)
	        while (_.includes(excluded_debit_days, new_debit_date.getDate())) {
	          new_debit_date.setDate(new_debit_date.getDate() - 1);
	        }
	      }
	
	      _this.application.payment.debit_date = new_debit_date;
	    };
	
	    var updateOperatorPaymentFrequency = function (newFrequency) {
	      if (newFrequency !== undefined) {
	        // Update the operator filter payment frequency to match the application
	        OperatorService.filters.payment_frequency = comparatorUtilities.getPaymentFrequencyOptionFromKey(comparatorUtilities.getPaymentFrequencyKey(newFrequency));
	        updatePricing();
	      }
	    };
	
	    $scope.$watch("ctrl.application.payment.frequency", function (newVal) {
	      _this.updateDebitDate();
	      updateOperatorPaymentFrequency(newVal);
	    });
	
	    this.updateDebitDate();
	    // End join and debit date configuration
	
	    // If the current selected frequency is not available as an option, clear it
	    var payment_freq = _.get(this.application, "payment.frequency", null);
	    var payment_freq_options = _.get(this.fieldsets, "payment.frequency.choices", []).map(function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 2);
	
	      var val = _ref2[0];
	      var _ = _ref2[1];
	      return val;
	    });
	    if (payment_freq !== null && !payment_freq_options.includes(payment_freq)) {
	      _.set(this.application, "payment.frequency", undefined);
	    }
	
	    if (typeof this.application.payment === "undefined") {
	      this.application.payment = {
	        frequency: 0,
	        debit_day: 1,
	        one_off: false
	      };
	    }
	
	    // If only one option for payment type, default to that choice
	    if (_.get(this.fieldsets, "payment.type.choices", []).length == 1) {
	      this.application.payment.type = this.fieldsets.payment.type.choices[0][0];
	    }
	
	    // Update medicare details with info from primary applicant
	    this.prepopulateField = function (key) {
	      if (_.get(_this.fieldsets, "policy.medicare")) {
	        if (_.isEmpty(_.get(_this.application, "policy.medicare." + key))) {
	          _.set(_this.application, "policy.medicare." + key, _.get(_this.application, "personal." + key));
	        }
	      }
	      // Update partner and dependants last name, and payment account names
	      if (key == "last_name") {
	        // Partner
	        if (_this.application.hasPartner() && _.isEmpty(_.get(_this.application, "partner.last_name"))) {
	          _.set(_this.application, "partner.last_name", _.get(_this.application, "personal.last_name"));
	        }
	        // Dependants
	        if (_.get(_this.application, "dependants", []).length) {
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = _this.application.dependants[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var d = _step2.value;
	
	              if (_.isEmpty(_.get(d, "last_name"))) {
	                _.set(d, "last_name", _.get(_this.application, "personal.last_name"));
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2["return"]) {
	                _iterator2["return"]();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	        }
	        // Update account names
	        var account_fields = [
	        // [fieldset to check, field to update]
	        ["payment.bank_account.account_name", "payment.bank_account.account_name"], ["payment.credit_card.name", "payment.credit_card.name"], ["payment.ezipay.account_name", "payment.ezipay.account_name"], ["payment.bank_account.account_name", "benefit_payment.bank_account.account_name"]];
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	          for (var _iterator3 = account_fields[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var field = _step3.value;
	
	            if (_.get(_this.fieldsets, field[0]) && _.isEmpty(_.get(_this.application, field[1]))) {
	              var first = _.get(_this.application, "personal.first_name", "");
	              var last = _.get(_this.application, "personal.last_name", "");
	              var _name = first.length && last.length ? first + " " + last : first || last;
	              _.set(_this.application, field[1], _name);
	            }
	          }
	        } catch (err) {
	          _didIteratorError3 = true;
	          _iteratorError3 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion3 && _iterator3["return"]) {
	              _iterator3["return"]();
	            }
	          } finally {
	            if (_didIteratorError3) {
	              throw _iteratorError3;
	            }
	          }
	        }
	      }
	    };
	
	    // If coming from Zoho, then a number of fields will already be populated
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	      for (var _iterator2 = ["first_name", "last_name", "dob", "gender"][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	        var key = _step2.value;
	
	        this.prepopulateField(key);
	      }
	    } catch (err) {
	      _didIteratorError2 = true;
	      _iteratorError2 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion2 && _iterator2["return"]) {
	          _iterator2["return"]();
	        }
	      } finally {
	        if (_didIteratorError2) {
	          throw _iteratorError2;
	        }
	      }
	    }
	
	    // Used to generate number of dependants drop down
	    this.dependantsOptions = _.range(1, 20);
	
	    // Allow child controllers to add functions to run before we submit. They should
	    // return a promise; rejections will prevent submission from happening. Current
	    // use case is BPoint integration where we need to tokenise credit card. Can
	    // resolve to a function which can be used to transform the post data before it
	    // is sent to the server. See usage below and AonApplicationService.submitApplication()
	    // For example implementation look at step3-ctrl-hbf.js
	    this.preSubmitFunctions = [];
	
	    var rebatePageShowing = function () {
	      var currentStateName = $state.current.name.split(".").slice(-1)[0];
	      return currentStateName === "rebate";
	    };
	
	    this.onSubmit = function (form) {
	      var _this2 = this;
	
	      var forceNoValidation = arguments[1] === undefined ? false : arguments[1];
	
	      // If we are not on the '.rebate' route, then let the backend know that
	      // we are pending on the rebate script. The backenrd will tell us whether
	      // we then need to show the rebate script or not.
	      var pendingAGR = !rebatePageShowing();
	
	      if (submissionCount > maxApplicationSubmissions) {
	        this.debugTrace += "\nToo many submissions, aborting";
	        this.debugTrace += "\n" + new Error().stack;
	        $log.warn("Too many submissions, aborting");
	        this.bailedOut = true;
	        return;
	      }
	
	      this.debugTrace += "\nStep3 on submit, forceNoValidate: " + forceNoValidation;
	      this.debugTrace += "\n" + new Error().stack;
	      $log.warn("Step3 on submit, forceNoValidate:", forceNoValidation);
	
	      // We hide the 'submit' button for preview anyway, but add a check here as well
	      if (this.corporate.is_preview) return;
	
	      // If response is an xml preview, store it here on the scope
	      this.previewXML = null;
	
	      // Save new value for rebate-related fields
	      _.set(this.application, "logging.submission.policy.lhc_age", this.application.policy.lhc_age);
	      _.set(this.application, "logging.submission.policy.lhc_age_partner", this.application.policy.lhc_age_partner);
	      _.set(this.application, "logging.submission.policy.federal_rebate", this.application.policy.federal_rebate);
	      _.set(this.application, "logging.submission.policy.rebate_tier", this.application.policy.rebate_tier);
	
	      var onSuccess = function (response) {
	        _this2.isLoading = false;
	        console.log(_.get(response, "show_rebate_script"));
	        if (_.has(response, "preview")) {
	          _this2.previewXML = _this2.corporate.is_operator ? response.preview : "This fund is in preview mode.";
	        } else if (_.get(response, "show_rebate_script")) {
	          $state.transitionTo("comparator.step3.rebate");
	        } else {
	          $state.transitionTo("comparator.step4");
	        }
	      };
	
	      /**
	       * Map validation errors to fields in the form. If we only find errors that
	       * we don't know how to map, return true to indicate a force resubmit is required.
	       * @param errors
	       * @returns {boolean} true if a forced resubmit (no validation) is required, else false
	       */
	      var handleErrors = function (errors) {
	        var mappedErrors = 0; // number of errors we were ABLE to map to form fields
	        var unmappedErrors = 0; // number of errors we were UNABLE to map to form fields
	
	        if (_.isObject(errors)) {
	          (function () {
	            var recurse = function (root, path) {
	              _.forEach(root, function (val, key) {
	                if (Array.isArray(val)) {
	                  // Leaf
	
	                  // Dependants are handled specially, convert dependant.0 -> dependant0
	                  if (path[0] == "dependant") {
	                    path = [path.slice(0, 2).join("")];
	                  }
	
	                  // Radio buttons repeated across different forms are special, since
	                  // name needs to be unique for each button group, handle that here
	                  if (key == "gender") {
	                    var formObject = _.get(form, path.join("."));
	                    if (formObject) {
	                      var possibleKeys = Object.keys(formObject).filter(function (k) {
	                        return k.split("-").slice(-1)[0] == "gender";
	                      });
	                      if (possibleKeys.length) {
	                        key = possibleKeys[0];
	                      }
	                    }
	                  }
	
	                  // The form structure is totally whack at this point - some form keys have periods
	                  // in them, so e.g. personal['application.number_of_dependants'] will work, but
	                  // personal.application.number_of_dependants won't. For now, we try grouping the last
	                  // two path components, in addition to trying the normal path access
	                  var fieldName = path.concat(key).join(".");
	                  var pathComponents = fieldName.split(".");
	
	                  // normal path access
	                  var field = _.get(form, fieldName);
	                  if (!field && pathComponents.length >= 2) {
	                    // try with the last two path components grouped
	                    var parentKey = pathComponents.slice(0, pathComponents.length - 2).join(".");
	                    var fieldKey = pathComponents.slice(pathComponents.length - 2).join(".");
	                    var parentObj = parentKey.length ? _.get(form, parentKey) : form;
	                    if (parentObj) {
	                      field = parentObj[fieldKey];
	                    }
	                  }
	
	                  if (field) {
	                    $log.error("Setting msg:", val, "on", field);
	                    field.setExternalValidation(null, val);
	                    mappedErrors++;
	                  } else {
	                    $log.error("Cannot find form key " + fieldName + " to set error '" + val + "'");
	                    unmappedErrors++;
	                  }
	                } else if (typeof val === "object") {
	                  recurse(val, path.concat(key));
	                }
	              });
	            };
	
	            try {
	              recurse(errors, []);
	            } catch (exception) {
	              unmappedErrors++;
	              $log.error(exception);
	            }
	          })();
	        } else {
	          unmappedErrors++;
	        }
	
	        if (mappedErrors === 0 && unmappedErrors > 0) {
	          // The backend has told us there is an error in a form field that we don't know
	          // about, so re-submit it and force no validation
	          return true;
	        } else if (mappedErrors > 0) {
	          form.focusInvalid();
	          return false;
	        }
	      };
	
	      var onError = function (result) {
	        _this2.debugTrace += "\nStep3 on error: " + JSON.stringify(result);
	        _this2.debugTrace += "\n" + new Error().stack;
	
	        _this2.isLoading = false;
	        var data = result.data;
	        if (data.customer_reference) {
	          // If we receive a reference back store it so next request uses same reference
	          AonApplicationService.setCustomerReference(data.customer_reference);
	        }
	        if (result.status == 400) {
	          // Normal validation errors - handle these, returns true if we need to force
	          // a resubmit without validation
	          var resubmitNoValidation = handleErrors(data.errors || {});
	          if (resubmitNoValidation) {
	            // We should never need to force a resubmit twice - enforce that here
	            if (!forceNoValidation) {
	              // First force resubmission, OK
	              _this2.debugTrace += "\nStep3 forcing resubmit, forceNoValidation: " + forceNoValidation;
	              _this2.onSubmit(form, true);
	            } else {
	              // We need to do _something_ - move to step 4
	              $state.transitionTo("comparator.step4");
	            }
	          }
	        } else {
	          // Other errors - maybe internal, maybe gateway
	          $state.transitionTo("comparator.step4");
	        }
	      };
	
	      this.hasSubmitted = false;
	      if (form.$valid) {
	        this.isLoading = true;
	        // Run any presubmit functions
	        var preSubmitPromises = _.map(this.preSubmitFunctions, function (fn) {
	          return fn(_this2.application);
	        });
	        // Once all resolved...
	        $q.all(preSubmitPromises).then(function (results) {
	          // The results from preSubmitFunctions can be a data transform function which applies to the post data
	          // we send to the server. This gives the opportunity for individual controllers to do things like
	          // replace credit card details with a token etc.
	          var transformFunctions = filter(results, isFunction);
	
	          application.force_no_validate = forceNoValidation;
	          application.pending_agr = pendingAGR;
	
	          // Continue with submission if no rejections
	          submissionCount++;
	          _this2.debugTrace += "\nSubmission, app force no validate: " + (application.force_no_validate = forceNoValidation);
	          AonApplicationService.submitApplication(application, transformFunctions, _this2.applicationId).then(onSuccess, onError);
	        }, function (errors) {
	          _this2.isLoading = false;
	          // Otherwise handle errors.
	          onError({ status: 400, data: { errors: errors } });
	        });
	      } else {
	        if (form.focusInvalid) {
	          form.focusInvalid();
	        }
	        this.hasSubmitted = true;
	      }
	    };
	
	    this.saveApplicationState = function () {
	      _this.isLoading = true;
	      _this.resultMessage = "";
	      AonApplicationService.saveApplicationInZoho(application).then(function (response) {
	        _this.resultMessageClass = "alert-success";
	        return response;
	      }, function (response) {
	        _this.resultMessageClass = "alert-danger";
	        return response;
	      }).then(function (response) {
	        _this.resultMessage = response.message;
	        _this.isLoading = false;
	      });
	    };
	
	    this.updateDependants = function (count) {
	      if (_this.application.dependants.length > count) {
	        _this.application.dependants.splice(count);
	      } else {
	        var diff = count - _this.application.dependants.length;
	        for (var i = 0; i < diff; i++) {
	          _this.application.dependants.push({});
	        }
	      }
	      _this.prepopulateField("last_name");
	    };
	
	    if (!application.requiresDependants()) {
	      this.application.number_of_dependants = 0;
	    }
	
	    this.updateDependants(this.application.number_of_dependants);
	
	    var getPaymentTypeLabel = function () {
	      return _this.fieldsets.payment.type.choices.filter(function (x) {
	        return x[0] == _this.application.payment.type;
	      })[0][1];
	    };
	
	    // Watch for changes to payment type:
	    // - if selecting credit card, pop up a warning in operator mode
	    // - when changing Direct Debit, update price info and direct debit flag
	    if (this.corporate.is_operator) {
	      (function () {
	        _this.resume_recording_message_count = 0;
	        $scope.$watch("ctrl.application.payment.type", function () {
	          try {
	            var payment_type_name = getPaymentTypeLabel();
	            if (payment_type_name.search(/credit/i) !== -1 && payment_type_name.search(/deferred/i) === -1) {
	              _this.operator_warning = "Please PAUSE CALL RECORDING while you get credit card details";
	              $("#operator-warning").modal();
	              _this.resume_recording_message_count = 0;
	            }
	
	            var isBank = payment_type_name.search(/bank/i) !== -1;
	            var hasDD = AonApplicationService.product.hasDirectDebitDiscount;
	            AonApplicationService.product.apply_direct_debit_discount = isBank && hasDD;
	            updatePricing();
	          } catch (err) {
	            $log.warn("Can't find payment type label, needed to warn operator about call recording during credit card details.");
	          }
	        });
	
	        var resume_call = function () {
	          _this.operator_warning = "Please RESUME CALL RECORDING";
	          $("#operator-warning").modal();
	          _this.resume_recording_message_count += 1;
	        };
	
	        $scope.$watch("ctrl.application.payment.credit_card.expiry", function () {
	          if (_.has(_this.application, "payment.credit_card.expiry") && _this.resume_recording_message_count == 0 && typeof _this.application.payment.credit_card.expiry !== "undefined") {
	            resume_call();
	          }
	        });
	
	        $scope.$watch("ctrl.application.payment.nab.crn", function () {
	          if (_.has(_this.application, "payment.nab.crn") && _this.resume_recording_message_count == 0 && _this.application.payment.nab.crn.length > 0) {
	            resume_call();
	          }
	        });
	      })();
	    }
	
	    this.isFullTimeStudentAge = function (dependant) {
	      try {
	        var age = comparatorUtilities.calculateAge(dependant.dob);
	        if (age >= _this.fieldsets.dependant.full_time_student.minage && age <= _this.fieldsets.dependant.full_time_student.maxage) {
	          return true;
	        } else {
	          return false;
	        }
	      } catch (err) {
	        console.log(err);
	        return false;
	      }
	    };
	
	    this.fieldsetValidClass = function (formKey) {
	      var form = _this.step3Form[formKey] || {};
	      return {
	        "fieldset-invalid": form.$invalid && _this.hasSubmitted,
	        "fieldset-valid": form.$valid };
	    };
	
	    this.refetchPricing = function () {
	      AonApi.fetchPrice(_this.application, _this.product.id).then(function (_ref) {
	        var pkg = _ref.data;
	
	        var price = pkg.price;
	        pkg.selectedPrice = price;
	        comparatorUtilities.applyDirectDebitDiscount(pkg);
	        AonApplicationService.setProduct(pkg);
	        AonApplicationService.setPrice(price);
	        AonApplicationService.saveApplication(_this.application);
	        _this.product = AonApplicationService.product.selectedPrice;
	        _this["package"] = AonApplicationService.product;
	        updatePricing();
	      });
	    };
	
	    // If the rebate tier is changed, we need to re-fetch the price for updated pricing
	    // information
	    $scope.$watch("ctrl.application.policy.rebate_tier", this.refetchPricing);
	
	    // If a discount code has been selected, and the code restricts the payment frequencies
	    // allowed, then disable the frequency selection here
	    $scope.$watch("ctrl.application.policy.discount_code", function () {
	      restrictFieldSets(_this.application, _this.fieldsets);
	    });
	
	    // Start Rebate Scripting Page -----
	
	    $scope.$watch(function () {
	      return $state.$current.name;
	    }, function () {
	      // We use rebate_script in the backend to determine if the script has been completed.
	      // Clear it on route change, to handle the case where operator clicks 'Yes', then
	      // uses browser back button to go back to application, but does not go back to rebate
	      // script page (maybe applicant changes their mind or something)
	      _.set(_this.application, "rebate_script", {});
	    });
	
	    $scope.$watch("ctrl.application.policy.rebate_tier_confirmation", function () {
	      // If the rebate tier is changed in the verbal rebate script, we need to show
	      // a warning.
	      var initial = _.get(_this.application, "policy.rebate_tier");
	      var confirm = _.get(_this.application, "policy.rebate_tier_confirmation");
	      _.set(_this, "verbal_rebate.errors.rebate_tier", initial !== confirm);
	    });
	
	    // Defualt the confirmed rebate tier to the selected rebate tier
	    _.set(this.application, "policy.rebate_tier_confirmation", _.get(this.application, "policy.rebate_tier"));
	
	    // Options for the rebate script
	
	    var _getRebateScriptConfig = getRebateScriptConfig(AonConfig);
	
	    var validationType = _getRebateScriptConfig.validationType;
	    var rebateScript = _getRebateScriptConfig.rebateScript;
	
	    this.rebateScript = rebateScript;
	    this.rebateScriptMedicareColorOptions = rebateScriptMedicareColorOptions;
	    this.getJoinDateFormatted = function () {
	      return formatJoinDate(_this.application);
	    };
	    this.getDeclarationDateFormatted = function () {
	      return formatDate(new Date());
	    };
	    this.rebateScriptValid = function () {
	      return isRebateScriptValid(_this.application, validationType);
	    };
	    this.getRebateTierIncome = function () {
	      return getRebateTierIncome(_this.application, AonApplicationService);
	    };
	
	    // End Rebate Scripting Page -----
	
	    // Sub-controllers should override this to provide custom logic for disabling the
	    // next button
	    this.applicationValid = function () {
	      return rebatePageShowing() ? _this.rebateScriptValid() : true;
	    };
	
	    this.medicareExpiryNoDaysRequired = function (cardColor) {
	      var daysRequired = false;
	      var colorsRequiringDays = [AonConfig.jsConstants.MedicareCardColors.Blue, AonConfig.jsConstants.MedicareCardColors.Yellow];
	      if (cardColor !== null && colorsRequiringDays.includes(cardColor)) {
	        daysRequired = true;
	      }
	      // The aon-date component is taking this as a literal string, and checking truthiness on it
	      return daysRequired ? "" : "true";
	    };
	  }]);
	};

/***/ }),
/* 252 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (ngModule) {
	    ngModule.controller("ComparatorStep4Ctrl", ["response", "ZohoService", "application", "AonConfig", "$interpolate", "CorporateService", "$sce", function (response, ZohoService, application, AonConfig, $interpolate, CorporateService, $sce) {
	        var _this = this;
	
	        this.corporateConfig = AonConfig.corporate;
	        var status = response.status;
	        var responseData = response.data;
	
	        // Set up available variables
	        var _AonConfig$corporate = AonConfig.corporate;
	        var is_operator = _AonConfig$corporate.is_operator;
	        var success_page_script = _AonConfig$corporate.success_page_script;
	
	        this.showCorporateSuccessPageScript = is_operator && success_page_script;
	        this.application = application;
	
	        // An application can be successful and still be pending (if the fund does not support
	        // straight through processing for example)
	        this.was_successful = status === 200;
	        this.reference_number = responseData.customer_id || responseData.internal_reference;
	        this.is_pending = _.get(responseData, "pending", false);
	        this.transaction_id = _.get(responseData, "transaction_id", false);
	        this.success_html = $sce.trustAsHtml($interpolate(this.corporateConfig.success_page_message)(this));
	        this.failure_html = $interpolate(this.corporateConfig.failure_page_message)(this);
	
	        if (is_operator) {
	            this.submitCorporateScriptResponses = function () {
	                _this.isSavingResponses = true;
	                _this.savedScriptResponseError = false;
	                _this.savedCorporateScriptResponse = false;
	                var postData = _.cloneDeep(_this.application.corporate_script_responses);
	                return CorporateService.saveCorporateScriptResponse(responseData.internal_reference, postData).then(function () {
	                    _this.isSavingResponses = false;
	                    _this.savedCorporateScriptResponse = true;
	                })["catch"](function () {
	                    _this.isSavingResponses = false;
	                    _this.savedScriptResponseError = true;
	                });
	            };
	        }
	    }]);
	};

/***/ }),
/* 253 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (ngModule) {
	
	  ngModule.controller("WelcomeCtrl", ["$state", "AonConfig", "Auth", "$location", function ($state, AonConfig, Auth, $location) {
	    var _this = this;
	
	    // Check for a querystring containing the auth code, and suppress the login box if
	    // present and correct
	    this.suppress_login = false;
	    if ($location.search().hasOwnProperty("net")) {
	      this.password = $location.search().net;
	      var success = function () {
	        _this.suppress_login = true;
	      };
	      var error = function () {};
	      Auth.login(this.password).then(success, error);
	    }
	
	    this.corporate = AonConfig.corporate;
	    this.deployment = AonConfig.deployment;
	    this.submit = function (code) {
	      _this.loginFailed = false;
	      var success = function () {
	        if (AonConfig.corporate.redirect_url) {
	          window.location = AonConfig.corporate.redirect_url;
	          return;
	        }
	        if (AonConfig.corporate.is_operator) {
	          $state.transitionTo("operator.step1");
	        } else {
	          $state.transitionTo("comparator.step1");
	        }
	      },
	          error = function () {
	        _this.loginFailed = true;
	      };
	      Auth.login(code).then(success, error);
	    };
	  }]);
	};

/***/ }),
/* 254 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (ngModule) {
	
	    ngModule.controller("ZohoCtrl", ["AonApi", "AonApplicationService", "OperatorService", "$state", "$stateParams", "ZohoService", function (AonApi, AonApplicationService, OperatorService, $state, $stateParams, ZohoService) {
	        var _this = this;
	
	        this.status = "Retrieving your details...";
	
	        var fetchPriceInfo = function (applicant, priceId) {
	            _this.status = "Retrieving product information...";
	
	            return AonApi.fetchPrice(applicant, priceId).then(function (response) {
	                var pkg = response.data;
	                var price = pkg.price;
	                pkg.selectedPrice = price;
	                AonApplicationService.setProduct(pkg);
	                AonApplicationService.setPrice(price);
	                _.set(applicant, "policy.membership_type", price.membership_type);
	                _.set(applicant, "primary_address.state", price.state);
	                AonApplicationService.saveApplication(applicant);
	                var fund_code = price.fund.code.split(".")[0];
	                $state.go("comparator.step3." + fund_code);
	            });
	        };
	
	        var onZohoApplicant = function (zohoApp) {
	            OperatorService.updateApplicantDependantFilters();
	            if ($stateParams.price) {
	                return AonApplicationService.getApplication().then(function (applicant) {
	                    return fetchPriceInfo(applicant, $stateParams.price);
	                });
	            } else {
	                $state.go("operator.step1");
	            }
	        };
	
	        ZohoService.getZohoApplicant($stateParams.leadId, $stateParams.operator).then(onZohoApplicant)["catch"](function () {
	            return $state.go("operator.step1");
	        });
	    }]);
	};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function (ngModule) {
	  __webpack_require__(253)(ngModule);
	  __webpack_require__(235)(ngModule);
	  __webpack_require__(236)(ngModule);
	  __webpack_require__(237)(ngModule);
	  __webpack_require__(251)(ngModule);
	  __webpack_require__(238)(ngModule);
	  __webpack_require__(239)(ngModule);
	  __webpack_require__(240)(ngModule);
	  __webpack_require__(241)(ngModule);
	  __webpack_require__(244)(ngModule);
	  __webpack_require__(242)(ngModule);
	  __webpack_require__(243)(ngModule);
	  __webpack_require__(247)(ngModule);
	  __webpack_require__(246)(ngModule);
	  __webpack_require__(248)(ngModule);
	  __webpack_require__(250)(ngModule);
	  __webpack_require__(245)(ngModule);
	  __webpack_require__(249)(ngModule);
	  __webpack_require__(252)(ngModule);
	  __webpack_require__(233)(ngModule);
	  __webpack_require__(229)(ngModule);
	  __webpack_require__(230)(ngModule);
	  __webpack_require__(234)(ngModule);
	  __webpack_require__(254)(ngModule);
	  __webpack_require__(232)(ngModule);
	  __webpack_require__(231)(ngModule);
	};

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function (ngModule) {
	
	    ngModule.directive("activeQuoteBanner", function () {
	        return {
	            restrict: "E",
	            template: __webpack_require__(291),
	            scope: {
	                application: "=" } };
	    });
	};

/***/ }),
/* 257 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (ngModule) {
	
	    ngModule.directive("appScaffold", ["AonConfig", function (AonConfig) {
	        return {
	            restrict: "E",
	            transclude: true,
	            template: "\n            <div>\n              <ng-include src=\"'/static/app-header.html'\"></ng-include>\n                <div ng-transclude></div>\n              <ng-include src=\"'/static/app-footer.html'\"></ng-include>\n            </div>\n            ",
	            link: function (scope) {
	                scope.corporate = AonConfig.corporate;
	                scope.deployment = AonConfig.deployment;
	            } };
	    }]);
	};

/***/ }),
/* 258 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (ngModule) {
	
	    ngModule.directive("basicPageHeader", ["AonConfig", function (AonConfig) {
	        return {
	            restrict: "E",
	            scope: {
	                title: "@" },
	            template: "\n            <div class=\"step-progress basic-page\">\n            <ul>\n                <li></li>\n                <li><div class=\"step-content\"><span class=\"step-title\">{{title}}</span></div></li>\n                <li></li>\n            </ul>\n            </div>\n            ",
	            link: function (scope, element, attrs, ngModel) {}
	        };
	    }]);
	
	    /*
	    Directive to allow basic page content to contain javascript-y things, add here as required.
	    */
	    ngModule.directive("basicPageContent", ["AonConfig", "$interpolate", "$sce", "$timeout", function (AonConfig, $interpolate, $sce, $timeout) {
	        return {
	            restrict: "E",
	            scope: {
	                content: "=" },
	            template: "<section ng-bind-html=\"trustedContent\"></section>",
	            link: function (scope) {
	                scope.corporate = AonConfig.corporate;
	                scope.trustedContent = scope.content && $sce.trustAsHtml($interpolate(scope.content)(scope));
	                $timeout(function () {
	                    $("ol > li").each(function (i) {
	                        var heading = $(this).find("h2");
	                        var content = $(this).find("div.collapse").remove();
	                        heading.wrapInner("<a/>").find("a").attr("href", "").click(function (ev) {
	                            content.slideToggle();
	                            $("div.collapse:not(#" + content.attr("id") + ")").slideUp();
	                            ev.preventDefault();
	                        });
	                        $(this).append(content);
	                    });
	                    $("div.collapse").hide();
	                });
	            }
	        };
	    }]);
	};

/***/ }),
/* 259 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (ngModule) {
	
	    ngModule.directive("chatWidget", ["AonConfig", function (AonConfig) {
	        return {
	            restrict: "E",
	            template: "<div class=\"chat-widget\"><div id=\"zsiqwidget\"></div></div>",
	            link: function (scope) {
	                var code = AonConfig.deployment.chat_widget_code;
	                var src = AonConfig.deployment.chat_widget_src;
	                scope.code = code;
	                if (code) {
	                    var configData = {
	                        values: {},
	                        ready: function ready() {}
	                    };
	                    if (code) {
	                        configData.widgetcode = code;
	                    }
	                    window.$zoho = window.$zoho || {};
	                    window.$zoho.salesiq = $zoho.salesiq || configData;
	                    var d = document;
	                    var s = d.createElement("script");
	                    s.type = "text/javascript";
	                    s.id = "zsiqscript";
	                    s.defer = true;
	                    s.src = src || "https://salesiq.zoho.com/widget";
	                    var t = d.getElementsByTagName("script")[0];
	                    t.parentNode.insertBefore(s, t);
	                }
	            } };
	    }]);
	};

/***/ }),
/* 260 */
/***/ (function(module, exports) {

	// Render the html of a corporate question config option
	"use strict";
	
	module.exports = function (ngModule) {
	
	    ngModule.directive("corporateQuestionLabel", ["AonConfig", function (AonConfig) {
	        return {
	            restrict: "E",
	            scope: {
	                // The name of a caption field on the CorporateQUestionConfig model, e.g. "step_1_who_caption"
	                question: "@"
	            },
	            template: "<span ng-bind-html=\"questionHTML\"></span>",
	            link: function (scope) {
	                scope.questionHTML = AonConfig.corporate.questionConfig[scope.question];
	            } };
	    }]);
	};

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var linkDynamicHTML = __webpack_require__(160).linkDynamicHTML;
	
	module.exports = function (ngModule) {
	    ngModule.directive("corporateScript", ["AonConfig", function (AonConfig) {
	        return {
	            restrict: "E",
	            scope: {
	                model: "=" },
	            template: function () {
	                return "<div>" + AonConfig.corporate.end_of_application_script + "</div>";
	            },
	            link: function (scope) {
	                linkDynamicHTML(scope, AonConfig.corporate.end_of_application_script);
	            }
	        };
	    }]);
	};

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var linkDynamicHTML = __webpack_require__(160).linkDynamicHTML;
	
	module.exports = function (ngModule) {
	    ngModule.directive("corporateSuccessScript", ["AonConfig", function (AonConfig) {
	        return {
	            restrict: "E",
	            scope: {
	                model: "=" },
	            template: function () {
	                return "<div>" + AonConfig.corporate.success_page_script + "</div>";
	            },
	            link: function (scope) {
	                linkDynamicHTML(scope, AonConfig.corporate.success_page_script);
	            }
	        };
	    }]);
	};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };
	
	var _slicedToArray = function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { var _arr = []; for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) { _arr.push(_step.value); if (i && _arr.length === i) break; } return _arr; } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } };
	
	var moment = _interopRequire(__webpack_require__(1));
	
	module.exports = function (ngModule) {
	
	  /**
	   **/
	  ngModule.directive("aonDate", ["AonConfig", function (AonConfig) {
	    return {
	      restrict: "A",
	      require: "ngModel",
	      replace: true,
	      scope: {
	        model: "=ngModel",
	        futureOnly: "=",
	        noDays: "=",
	        minAge: "@",
	        maxAge: "@",
	        underThirty: "@",
	        allowEmpty: "=",
	        allowFuture: "=",
	        minDate: "=" },
	      template: __webpack_require__(292),
	      link: function (scope, element, attrs, ngModel) {
	        var noDays = scope.noDays;
	        var is_required = scope.allowEmpty !== true;
	
	        var minAge = 0;
	        if (scope.overEighteen && scope.overEighteen !== "false") {
	          minAge = 18;
	        } else if (scope.minAge) {
	          minAge = Number(scope.minAge);
	        }
	
	        // Set max age, transform the value to a number
	        var maxAge = 0;
	        if (scope.maxAge) {
	          maxAge = Number(scope.maxAge);
	        }
	
	        var splitDate = function (modelValue) {
	          var _split = (modelValue || "").split("-");
	
	          var _split2 = _slicedToArray(_split, 3);
	
	          var year = _split2[0];
	          var month = _split2[1];
	          var day = _split2[2];
	
	          if (noDays) day = 1;
	          return {
	            day: parseInt(day),
	            month: parseInt(month),
	            year: parseInt(year)
	          };
	        };
	
	        var formatValue = function (modelValue) {
	          var date = splitDate(modelValue);
	          var isValid = validateDate(date);
	          if (!isValid && is_required) {
	            if (isUnderAge(date)) {
	              ngModel.$setValidity("underage", false);
	            } else {
	              ngModel.$setValidity("date", isValid);
	            }
	            if (isOverAge(date)) {
	              ngModel.$setValidity("overage", false);
	            } else {
	              ngModel.$setValidity("date", isValid);
	            }
	          }
	          return date;
	        };
	
	        scope.formChoices = AonConfig.formChoices;
	        scope.$watch("model", function (value) {
	          if (value) {
	            var _scope$model$split = scope.model.split("-");
	
	            var _scope$model$split2 = _slicedToArray(_scope$model$split, 3);
	
	            var year = _scope$model$split2[0];
	            var month = _scope$model$split2[1];
	            var day = _scope$model$split2[2];
	
	            scope.day = parseInt(day);
	            scope.month = parseInt(month);
	            scope.year = parseInt(year);
	
	            // This is to support programmatic updates to the model value that are likely
	            // already valid (e.g. driven by a pre-fill from another field). This will
	            // make sure angular things the field is valid, if the value is a valid date.
	            if (validateDate(splitDate(value))) {
	              scope.onDateChange();
	            }
	          }
	        });
	
	        var yearsChoices = AonConfig.formChoices.date[scope.futureOnly ? "future_years" : "years"];
	        if (!scope.futureOnly && scope.allowFuture) {
	          yearsChoices = yearsChoices.concat(AonConfig.formChoices.date.future_years);
	        }
	        var sortedYears = yearsChoices.slice().sort();
	
	        scope.yearsChoices = yearsChoices;
	
	        var isUnderAge = function (viewValue) {
	          if (minAge <= 0) {
	            return false;
	          }
	
	          var dob = moment();
	          dob.set("year", viewValue.year);
	          dob.set("month", viewValue.month - 1);
	          dob.set("date", viewValue.day);
	          var age = moment().diff(dob, "years", false);
	          return age < minAge;
	        };
	
	        var isOverAge = function (viewValue) {
	
	          if (maxAge <= 0) {
	            return false;
	          }
	
	          var dob = moment();
	          dob.set("year", viewValue.year);
	          dob.set("month", viewValue.month - 1);
	          dob.set("date", viewValue.day);
	          var age = moment().diff(dob, "years", false);
	          return age > maxAge;
	        };
	
	        var zeroTime = function (date) {
	          date.setHours(0);
	          date.setMinutes(0);
	          date.setSeconds(0);
	          date.setMilliseconds(0);
	          return date;
	        };
	
	        var isFuture = function (viewValue) {
	          var now = zeroTime(new Date());
	          var val = new Date(viewValue.year, viewValue.month - 1, viewValue.day);
	          if (scope.noDays) {
	            now.setDate(1);
	            val.setDate(1);
	          }
	          return val >= now;
	        };
	
	        var isGreaterThanOrEqualToMinDate = function (viewValue) {
	          var viewDate = zeroTime(new Date(viewValue.year, viewValue.month - 1, viewValue.day));
	          var minDate = zeroTime(scope.minDate);
	          return viewDate >= minDate;
	        };
	
	        var validateDate = function (viewValue) {
	          var isValidDay = scope.noDays ? true : _.isNumber(viewValue.day) && viewValue.day >= 1 && viewValue.day <= 31,
	              isValidMonth = _.isNumber(viewValue.month) && viewValue.month >= 1 && viewValue.month <= 12,
	              isValidYear = _.isNumber(viewValue.year) && viewValue.year >= _.first(sortedYears) && viewValue.year <= _.last(sortedYears);
	          var valid = isValidDay && isValidMonth && isValidYear && !isUnderAge(viewValue) && !isOverAge(viewValue);
	          var reassertDate = new Date(viewValue.year, viewValue.month - 1, viewValue.day);
	          if (valid) {
	            valid = reassertDate.getFullYear() == viewValue.year && reassertDate.getMonth() == viewValue.month - 1 && reassertDate.getDate() == viewValue.day;
	          }
	
	          if (valid && scope.minDate && !isGreaterThanOrEqualToMinDate(viewValue)) {
	            return false;
	          }
	
	          return scope.futureOnly ? valid && isFuture(viewValue) : valid;
	        };
	        //ngModel.$validators = ngModel.$validators || {};
	        //ngModel.$validators.date = validateDate;
	
	        ngModel.$formatters.push(formatValue);
	
	        /**
	         * Including this cause angular-auto-validate to run *extremely* slow. No idea what's going on - I expect
	         * a cascade of calls and digests. Workaround is the scope.$watch ('model'...) above
	        ngModel.$render = () => {
	          let {day, month, year} = ngModel.$viewValue;
	          scope.day = parseInt(day);
	          scope.month = parseInt(month);
	          scope.year = parseInt(year);
	          //scope.dateParts = {day, month, year};
	        };*/
	
	        ngModel.$parsers.push(function (viewValue) {
	          // If any part of the date is filled, the whole date must be valid
	          var hasValue = function (v) {
	            return typeof v !== "undefined" && (v.length > 0 || typeof v === "number");
	          };
	          var must_be_valid = hasValue(viewValue.day) || hasValue(viewValue.month) || hasValue(viewValue.year);
	          var digitsOnlyRegex = /^[0-9]*$/;
	          if (scope.noDays) {
	            viewValue.day = 1;
	          } else {
	            viewValue.day = digitsOnlyRegex.test(viewValue.day) ? parseInt(viewValue.day) : NaN;
	          }
	          viewValue.month = digitsOnlyRegex.test(viewValue.month) ? parseInt(viewValue.month) : NaN;
	          viewValue.year = digitsOnlyRegex.test(viewValue.year) ? parseInt(viewValue.year) : NaN;
	          var isValid = validateDate(viewValue);
	
	          if (!is_required && !must_be_valid) {
	            ngModel.$setValidity("date", true);
	            ngModel.$setValidity("underage", true);
	            ngModel.$setValidity("overage", true);
	          }
	
	          if (is_required || must_be_valid) {
	            ngModel.$setValidity("date", isValid);
	            ngModel.$setValidity("underage", !isUnderAge(viewValue));
	            ngModel.$setValidity("overage", !isOverAge(viewValue));
	            if (!isValid && isUnderAge(viewValue)) {
	              ngModel.$setValidity("date", true);
	            }
	            if (!isValid && isOverAge(viewValue)) {
	              ngModel.$setValidity("date", true);
	            }
	          }
	
	          return isValid ? "" + viewValue.year + "-" + viewValue.month + "-" + viewValue.day : undefined;
	        });
	
	        scope.onDateChange = function () {
	          var day = scope.day;
	          var month = scope.month;
	          var year = scope.year;
	
	          ngModel.$setViewValue({ day: day, month: month, year: year });
	          if (day && month && year) {
	            // Trigger blur so we can do things like validate on blur, eg.
	            // <div aon-date ng-model="model.dob" ng-model-options="{updateOn: 'blur'}">
	            element.trigger("blur");
	          }
	        };
	      }
	    };
	  }]);
	};

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function (ngModule) {
	
	  ngModule.directive("debugOverlay", function () {
	    return {
	      restrict: "E",
	      transclude: true,
	      scope: {
	        packages: "=" },
	      template: __webpack_require__(308),
	      link: function (scope, element, attrs) {
	        $(element).addClass("debug-overlay");
	        $(element).click(function () {
	          $(element).find(".debug-inner").toggleClass("open");
	        });
	      }
	    };
	  });
	};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function (ngModule) {
	
	  /**
	   * Directive to handle magic on feature labels on comparator page.
	   *
	   * We want to offset the label when not on mobile so it sits to the left of the first column
	   *
	   * We also want to adjust padding based on wrapping - if text goes across multilines get rid of padding, otherwise
	   * retain it. This gives the effect of vertically centering.
	   **/
	  ngModule.directive("featureLabel", ["$log", "matchmedia", "$timeout", function ($log, matchmedia, $timeout) {
	    return {
	      restrict: "A",
	      link: function (scope, element, attrs) {
	        var parent = element.parent(),
	            padding = parseInt(parent.css("padding-right").replace("px", "")),
	            width = parent.width();
	
	        var hasApplied = false;
	
	        // Don't apply to phone's
	        matchmedia.onPhone(function (mediaQueryList) {
	          if (mediaQueryList.matches && hasApplied) {
	            element.css({
	              width: "90%",
	              left: "auto",
	              "padding-top": "initial",
	              "padding-bottom": "initial"
	            });
	            hasApplied = false;
	          } else if (!mediaQueryList.matches && !hasApplied) {
	            element.css({
	              width: width - padding + "px",
	              left: -width + "px"
	            });
	            hasApplied = true;
	            $timeout(function () {
	              if (element[0].scrollWidth > element.outerWidth()) {
	                element.css({
	                  "padding-top": 0,
	                  "padding-bottom": 0,
	                  "white-space": "normal"
	                });
	              }
	            });
	          }
	        });
	      }
	    };
	  }]);
	
	  ngModule.directive("servicesFeatureList", function () {
	    return {
	      restrict: "A",
	      scope: {
	        servicesSelected: "=",
	        servicesList: "=",
	        featuresList: "=",
	        featureHeading: "@",
	        corporate: "=" },
	      template: __webpack_require__(297),
	      link: function (scope, element, attrs) {}
	    };
	  });
	
	  ngModule.directive("servicesFeatureListTable", ["AonConfig", function (AonConfig) {
	    return {
	      restrict: "A",
	      scope: {
	        servicesSelected: "=",
	        services: "=",
	        benefits: "=",
	        packages: "=",
	        features: "@",
	        servicesLabel: "@",
	        startOpen: "=",
	        corporate: "=" },
	      template: __webpack_require__(296),
	      link: function (scope, element, attrs) {
	        scope.open = scope.startOpen == true;
	        scope.toggleShowing = function () {
	          scope.open = !scope.open;
	        };
	
	        scope.showPerPerson = AonConfig.corporate.benefit_limits_show_per_person;
	        scope.showPerPolicy = AonConfig.corporate.benefit_limits_show_per_policy;
	        scope.showPerService = AonConfig.corporate.benefit_limits_show_per_service;
	
	        scope.visibleServices = scope.services.filter(function (service) {
	          return Boolean(service.selected) === scope.servicesSelected;
	        });
	
	        var filterByService = function (list, service) {
	          return list.filter(function (el) {
	            return service.id === el.ancillary_service_id;
	          });
	        };
	
	        scope.getBenefits = function (pkg, service) {
	          if (scope.features !== "ancillary") {
	            return "";
	          }
	
	          var value_rep = function (b) {
	            return (b.benefit_type == "$" ? "$" : "") + b.benefit_payable + (b.benefit_type == "%" ? "%" : "");
	          };
	
	          var benefits = filterByService(pkg.selectedPrice.productpriceancillaryservicebenefit_set, service);
	          if (benefits.length) {
	            return benefits.map(function (b) {
	              return b.service_benefit + ":&nbsp;" + value_rep(b);
	            }).join("<br>").replace(/\s/g, "&nbsp;");
	          } else {
	            return "";
	          }
	        };
	        scope.getLimits = function (pkg, service) {
	          if (scope.features !== "ancillary") {
	            return "";
	          }
	
	          var limits = filterByService(pkg.selectedPrice.productpriceancillaryservicelimit_set, service);
	          if (limits.length == 0) {
	            return null;
	          }
	          limits = limits[0];
	          if (limits && limits.limit_per_person === null && limits.limit_per_policy === null && limits.limit_per_admission === null) {
	            return null;
	          }
	          if (limits.limit_per_person != null) {
	            limits.limit_per_person = parseInt(limits.limit_per_person);
	          }
	          if (limits.limit_per_policy != null) {
	            limits.limit_per_policy = parseInt(limits.limit_per_policy);
	          }
	          if (limits.limit_per_service != null) {
	            limits.limit_per_service = parseInt(limits.limit_per_service);
	          }
	          return limits;
	        };
	      }
	    };
	  }]);
	};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray = function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { var _arr = []; for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) { _arr.push(_step.value); if (i && _arr.length === i) break; } return _arr; } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } };
	
	module.exports = function (ngModule) {
	
	  /**
	   * Apply validators defined in an object to a field
	   *
	   * See backend fund handlers for examples of what is returned, eg.
	   * {
	   *  fieldName: {
	   *    pattern: "[A-Za-z]*",
	   *    required: true,
	   *    minlength: 5,
	   *    error_messages: {
	   *      pattern: "Please enter only alphabetic characters"
	   *    }
	   *   }
	   * }
	   *
	   * Adds a custom validator that does all the necessary validation. We don't use
	   * the built in angular ones as I couldn't get it to work dynamically adding
	   * attributes (eg. adding ng-pattern for example).
	   *
	   * This also allows easy custom messages
	   */
	  ngModule.directive("applyValidators", ["$parse", "$log", function ($parse, $log) {
	    return {
	      restrict: "A",
	      require: "ngModel",
	      link: function compile(scope, element, attrs, ctrl) {
	        var validators = scope.$eval(attrs.applyValidators);
	
	        if (!validators) {
	          $log.error("Expected validators object but got nothing", attrs);
	          return;
	        }
	
	        element.data("validation", validators);
	        if (validators.error_messages) {
	          element.data("validation-messages", validators.error_messages);
	        }
	
	        var addValidator = function (fieldName, fn) {
	          var validator = function (viewValue) {
	            var isValid = fn(viewValue);
	            ctrl.$setValidity(fieldName, isValid);
	            return isValid ? viewValue : undefined;
	          };
	          ctrl.$parsers.push(validator);
	          ctrl.$formatters.push(validator);
	        };
	
	        // Required
	        function validateRequired(viewValue) {
	          return !validators.required || !ctrl.$isEmpty(viewValue);
	        }
	        addValidator("required", validateRequired);
	
	        // Regex
	        if (validators.pattern) {
	          (function () {
	            var validateRegex = function (value) {
	              return ctrl.$isEmpty(value) || _.isUndefined(regexp) || regexp.test(value);
	            };
	
	            var regexp = new RegExp("^" + validators.pattern + "$");
	
	            addValidator("pattern", validateRegex);
	          })();
	        }
	
	        // Max Length
	        if (validators.maxlength) {
	          (function () {
	            var validateMaxlength = function (viewValue) {
	              return maxlength < 0 || ctrl.$isEmpty(viewValue) || viewValue.toString().length <= maxlength;
	            };
	
	            var maxlength = validators.maxlength;
	
	            addValidator("maxlength", validateMaxlength);
	          })();
	        }
	
	        // Min Length
	        if (validators.minlength) {
	          (function () {
	            var validateMinlength = function (viewValue) {
	              return ctrl.$isEmpty(viewValue) || viewValue.toString().length >= minlength;
	            };
	
	            var minlength = validators.minlength;
	
	            addValidator("minlength", validateMinlength);
	          })();
	        }
	
	        // Medicare number
	        // Medicare card number is 10 digits.
	        // Rule for Medicare Card validation:
	        // 1. For each number starting from the 1st digit to the 8th digit, multiply that number with
	        //  a multiplier as specified below in the table and gets the total.
	        // 2. Divide the total by 10 and get the remainder.
	        // 3. If the remainder is equal to the 9th digit of the Medicare Number and the 1st digit of
	        // the Medicare Number is between 2 and 6, then the Medicare Number is valid.
	        if (validators.medicare_number) {
	          var validateMedicare = function (viewValue) {
	            var n = ctrl.$isEmpty(viewValue) ? "" : viewValue.replace(/[^\d]/, "");
	            if (!validators.required && n.length === 0) {
	              return true;
	            }
	
	            if (n.length !== 10) {
	              return false;
	            }
	
	            var multipliers = [1, 3, 7, 9, 1, 3, 7, 9],
	                check_digit = _.reduce(multipliers, function (total, mult, index) {
	              return total + parseInt(n[index]) * mult;
	            }, 0) % 10,
	                digit_1 = parseInt(n[0]);
	
	            return check_digit === parseInt(n[8]) && digit_1 >= 2 && digit_1 <= 6;
	          };
	
	          addValidator("medicare_number", validateMedicare);
	        }
	      }
	    };
	  }]);
	
	  /**
	   * This is just a helper so you don't need to duplicate template content. eg. Personal details are repeated for
	   * partner and main contact. Same for contact details etc. Split it out into a partial and load it with
	   * <field-group template="hcf/contact.html" model="ctrl.application.contact" fieldset="ctrl.fieldsets.personal>
	   * </field-group>
	   */
	  ngModule.directive("fieldGroup", ["$http", "$compile", function ($http, $compile) {
	    return {
	      restrict: "EA",
	      require: "^form",
	      scope: {
	        template: "@",
	        model: "=",
	        fieldset: "=",
	        prefix: "@",
	        userData: "@",
	        dependantType: "@",
	        onPrepopulate: "=",
	        modelPath: "@",
	        // allow caller to pass through a controller
	        ctrl: "=" },
	      templateUrl: function (tElement, tAttrs) {
	        return "/static/partials/" + tAttrs.template;
	      },
	      link: function (scope, element, attrs, ngModel) {
	        scope.prefix = attrs.prefix || attrs.model;
	        // give elements access to the model
	        scope.modelVal = ngModel;
	      }
	    };
	  }]);
	
	  /**
	   * Angular 1.2 seems to have issues with using expressions in a form name attribute. This directive resolves this,
	   *
	   * eg. <input dynamic-name="{{prefix}}first_name" />
	   */
	  ngModule.directive("dynamicName", ["$compile", "$interpolate", function ($compile, $interpolate) {
	    return {
	      restrict: "A",
	      terminal: true,
	      priority: 1000000,
	      link: function (scope, element, attrs) {
	        var name = $interpolate(attrs.dynamicName)(scope);
	        element.removeAttr("dynamic-name").attr("name", name);
	        $compile(element)(scope);
	      }
	    };
	  }]);
	
	  /**
	   * Like dynamicName, but for ng-form attribute interpolation
	   */
	  ngModule.directive("ngformNameInterpol", ["$compile", "$interpolate", function ($compile, $interpolate) {
	    return {
	      restrict: "A",
	      terminal: true,
	      priority: 1000000,
	      link: function (scope, element, attrs) {
	        var name = $interpolate(attrs.ngformNameInterpol)(scope);
	        element.removeAttr("ngform-name-interpol").attr("ng-form", name);
	        $compile(element)(scope);
	      }
	    };
	  }]);
	
	  ngModule.directive("focusInvalid", ["$timeout", "smoothScroll", function ($timeout, smoothScroll) {
	    return {
	      restrict: "A",
	      require: "form",
	      link: function (scope, element, attrs, form) {
	        form.focusInvalid = function () {
	          $timeout(function () {
	            var hasErrorEl = element.find(".has-error input, .has-error select").get(0);
	            if (hasErrorEl) {
	              smoothScroll(hasErrorEl, { callbackAfter: function () {
	                  return hasErrorEl.focus();
	                }, offset: 50 });
	            }
	            var invalidEl = element.find("input.ng-invalid , select.ng-invalid").get(0);
	            if (invalidEl) {
	              smoothScroll(invalidEl, { callbackAfter: function () {
	                  return invalidEl.focus();
	                }, offset: 50 });
	            }
	          });
	        };
	      }
	    };
	  }]);
	
	  ngModule.directive("buttonLoadingIndicator", function () {
	    return {
	      restrict: "A",
	      transclude: true,
	      scope: {
	        buttonLoadingIndicator: "="
	      },
	      template: "\n        <span ng-show=\"buttonLoadingIndicator\"><i class=\"fa fa-spinner fa-spin\"></i> Please wait...</span>\n        <span ng-show=\"!buttonLoadingIndicator\" ng-transclude></span>\n      ",
	      link: function (scope, element, attrs, form) {
	        scope.$watch("buttonLoadingIndicator", function (isLoading) {
	          if (isLoading) {
	            element.attr("disabled", true);
	            element.addClass("btn--disabled");
	          } else {
	            element.removeAttr("disabled");
	            element.removeClass("btn--disabled");
	          }
	        });
	      }
	    };
	  });
	
	  ngModule.directive("iframeOnload", function () {
	    return {
	      scope: {
	        callBack: "&iframeOnload"
	      },
	      link: function link(scope, element, attrs) {
	        element.on("load", function () {
	          return scope.callBack();
	        });
	      }
	    };
	  });
	
	  /**
	   * This is used to fix-up tooltip box positioning when they would otherwise overflow the left
	   * viewport edge.
	   */
	  ngModule.directive("positionTooltip", ["$timeout", function ($timeout) {
	    return {
	      restrict: "A",
	      scope: false,
	      link: function link(scope, element, attrs) {
	        var el = undefined,
	            arrow = undefined;
	        element.bind("mouseenter", function () {
	          $timeout(function () {
	            el = element.next();
	            if (el.length && el[0].getBoundingClientRect().left < 0) {
	              el.addClass("reposition-left");
	            }
	            if (el.length && el[0].getBoundingClientRect().right > (window.innerWidth || document.documentElement.clientWidth)) {
	              el.addClass("reposition-right");
	            }
	            // Reposition the arrow location
	            var iRect = element[0].getBoundingClientRect();
	            var iRectCenter = iRect.left + (iRect.right - iRect.left) / 2;
	            var tooltipRect = el[0].getBoundingClientRect();
	            var position = iRectCenter - tooltipRect.left;
	            arrow = el.find(".tooltip-arrow").css("left", position + "px");
	          });
	        });
	      }
	    };
	  }]);
	
	  /**
	   * Element that provides progressive lookup on suburb names and postcodes
	   */
	  ngModule.directive("suburbLookup", ["AonApi", "$timeout", "$http", function (AonApi, $timeout, $http) {
	    return {
	      restrict: "E",
	      scope: {
	        model: "=",
	        state: "=" },
	      template: __webpack_require__(298),
	      link: function link(scope, element, attrs) {
	        var titleCase = function (str) {
	          return str.replace(/\w\S*/g, function (txt) {
	            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	          });
	        };
	        scope.displayResult = function (result, type) {
	          if (typeof result === "string") return result;
	          if (result) return "" + result.suburb + " " + result.postcode;
	          return scope.model[type];
	        };
	        scope.resultSelect = function (suburb) {
	          scope.model.suburb = titleCase(suburb.suburb);
	          scope.model.postcode = suburb.postcode;
	        };
	        scope.suburbLookup = function (which, value) {
	          scope.loading = true;
	          scope.noResults = false;
	          var state_filter = scope.state ? "&state=" + scope.state : "";
	          var endpoint = "/api/suburb?" + which + "=" + value + state_filter;
	          return $http.get(endpoint).then(function (response) {
	            scope.loading = false;
	            scope.noResults = response.data.length == 0;
	            return response.data;
	          });
	        };
	      } };
	  }]);
	
	  /**
	   * Get extra product information based on display location/placement
	   */
	  ngModule.directive("productExtraInformation", ["AonApi", "AonConfig", "$timeout", "$http", function (AonApi, AonConfig, $timeout, $http) {
	    return {
	      restrict: "E",
	      scope: {
	        "package": "=",
	        placement: "@" },
	      template: "<i ng-if=\"info\" tooltip-html-unsafe=\"{{ info }}\" position-tooltip class=\"glyphicon glyphicon-info-sign\"></i>",
	      link: function link(scope) {
	        var pkg = scope["package"];
	        var placement = scope.placement;
	        var placement_code = AonConfig.jsConstants.ProductExtraInformation.placement[placement];
	
	        var list = _.get(pkg, "hospital_product.product_information", []).concat(_.get(pkg, "ancillary_product.product_information", [])).filter(function (x) {
	          return x.information_placement == placement_code;
	        });
	
	        if (!list.length) {
	          return null;
	        } // Get unique entries (lodash function for this is in 4.0.0, we are on 3.7.ish, 4.0.0 not compatible?)
	        var seenIDs = [];
	        var uniqueList = [];
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var l = _step.value;
	
	            if (!_.includes(seenIDs, l.id)) {
	              seenIDs.push(l.id);
	              uniqueList.push(l);
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator["return"]) {
	              _iterator["return"]();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        scope.info = uniqueList.map(function (x) {
	          return "" + x.information_type_label + ": " + x.information;
	        }).join("<br>");
	      }
	    };
	  }]);
	
	  /**
	   * Element that provides progressive lookup on health cover products, e.g.
	   * for selecting a current health cover product.
	   */
	  ngModule.directive("productLookup", ["AonApi", "AonConfig", "$timeout", "$http", function (AonApi, AonConfig, $timeout, $http) {
	    return {
	      // Access the form controller in this directive
	      require: "^form",
	      restrict: "E",
	      scope: {
	        model: "=",
	        fund: "@",
	        state: "@",
	        membership: "@",
	        corporateSearch: "=" },
	      template: __webpack_require__(294),
	      link: function link(scope, element, attrs, form) {
	        scope.formChoices = AonConfig.formChoices;
	        scope.isBrokerCorporate = AonConfig.corporate.distribution_type === AonConfig.jsConstants.DistributionTypeLookup.BROKER;
	        var corporateId = AonConfig.corporate.id;
	        var _AonConfig$jsConstants$ProductPriceType = AonConfig.jsConstants.ProductPriceType;
	        var HOSPITAL = _AonConfig$jsConstants$ProductPriceType.HOSPITAL;
	        var ANCILLARY = _AonConfig$jsConstants$ProductPriceType.ANCILLARY;
	        var BOTH = _AonConfig$jsConstants$ProductPriceType.BOTH;
	
	        if (scope.corporateSearch) {
	          scope.prefix = "comparison";
	          scope.hospitalLabel = "Comparison Hosp/Combined Cover";
	          scope.ancillaryLabel = "Comparison Extras Cover";
	        } else {
	          scope.prefix = "current";
	          scope.hospitalLabel = "Current Hosp/Combined Cover";
	          scope.ancillaryLabel = "Current Extras Cover";
	        }
	
	        var getParams = function () {
	          var name = arguments[0] === undefined ? null : arguments[0];
	          var which = arguments[1] === undefined ? null : arguments[1];
	          var fund = scope.fund;
	          var _scope$model = scope.model;
	          var _scope$model$state = _scope$model.state;
	          var state = _scope$model$state === undefined ? scope.state : _scope$model$state;
	          var _scope$model$membership = _scope$model.membership;
	          var membership = _scope$model$membership === undefined ? scope.membership : _scope$model$membership;
	
	          var params = { state: state, membership: membership, corporate: corporateId };
	          if (name) {
	            params.name = name;
	          }
	          if (which) {
	            var policy = which === "ancillary" ? ANCILLARY : [HOSPITAL, BOTH];
	            params.policy = policy;
	          }
	          if (fund) {
	            params.fund = fund;
	          }
	          return params;
	        };
	
	        scope.validators = {
	          error_messages: {
	            product: "At least one product must be selected",
	            editable: "Please select a valid product" } };
	
	        var checkValidity = function () {
	          if (form["" + scope.prefix + "_hospital_product"]) {
	            var _scope$model = scope.model;
	            var hospital_product = _scope$model.hospital_product;
	            var ancillary_product = _scope$model.ancillary_product;
	
	            if (!hospital_product && !ancillary_product) {
	              form["" + scope.prefix + "_hospital_product"].$setValidity("product", false);
	              form["" + scope.prefix + "_ancillary_product"].$setValidity("product", false);
	              form["" + scope.prefix + "_hospital_product"].$pristine = false;
	              form["" + scope.prefix + "_ancillary_product"].$pristine = false;
	            } else {
	              form["" + scope.prefix + "_hospital_product"].$setValidity("product", true);
	              form["" + scope.prefix + "_ancillary_product"].$setValidity("product", true);
	            }
	          }
	        };
	
	        scope.$watch("model.hospital_product", checkValidity);
	        scope.$watch("model.ancillary_product", checkValidity);
	
	        scope.loading = {
	          hospital: false,
	          ancillary: false };
	
	        scope.showProductLookup = function () {
	          var isSet = function (val) {
	            var notEmpty = val !== null && val !== undefined;
	            if (typeof val === "string") {
	              return val !== "" && notEmpty;
	            } else {
	              return notEmpty;
	            }
	          };
	
	          var _getParams = getParams();
	
	          var fund = _getParams.fund;
	          var state = _getParams.state;
	          var membership = _getParams.membership;
	
	          return (isSet(fund) || scope.corporateSearch) && isSet(state) && isSet(membership);
	        };
	
	        scope.showAncillaryLookup = function () {
	          var hasAncillary = scope.model.hospital_product && scope.model.hospital_product.type === BOTH;
	          return !hasAncillary;
	        };
	
	        scope.selectHospital = function (item) {
	          scope.model.hospital_product = item;
	          if (item.type === BOTH) {
	            scope.model.ancillary_product = null;
	          }
	        };
	
	        scope.selectAncillary = function (item) {
	          scope.model.ancillary_product = item;
	        };
	
	        scope.displayResult = function (result) {
	          if (typeof result === "string") return result;
	          if (result) {
	            var _name = result.name;
	            if (result.monthly_premium) {
	              _name += " (Premium: $" + result.monthly_premium + ", Excess: $" + Math.round(result.excess) + ", " + result.product_status + ")";
	            }
	            return _name;
	          }
	        };
	
	        scope.productLookup = function (name, which) {
	          scope.loading.hospital = false;
	          scope.loading.ancillary = false;
	          scope.loading[which] = true;
	          var endpoint = "/api/previous-fund-products/";
	          var params = getParams(name, which);
	          return $http.get(endpoint, { params: params }).then(function (response) {
	            scope.loading[which] = false;
	            return response.data.concat({
	              name: "Other (no matching product found)",
	              type: which === "ancillary" ? ANCILLARY : HOSPITAL,
	              excess: 0 });
	          });
	        };
	
	        scope.clearCurrentHealthFundProducts = function () {
	          scope.model.hospital_product = null;
	          scope.model.ancillary_product = null;
	        };
	
	        scope.$watch("model.fund_id", function (newVal, oldVal) {
	          if (!oldVal && !newVal && scope.corporateSearch) {
	            return;
	          }
	          if (!newVal || !oldVal || newVal && oldVal && newVal !== oldVal) {
	            scope.clearCurrentHealthFundProducts();
	          }
	        });
	      } };
	  }]);
	
	  /**
	   * Element that provides an input for entering LHC age either as an integer 30-110
	   * or as a percentage, an even number 2%, 4%, 8%, between 0% and 70%
	   */
	  ngModule.directive("lhcAgeEntry", function () {
	    return {
	      // We need to access both the form controller and the ngmodel controller
	      require: ["^form", "ngModel"],
	      restrict: "A",
	      scope: {
	        model: "=ngModel",
	        name: "@" },
	      link: function link(scope, element, attrs, _ref) {
	        var _ref2 = _slicedToArray(_ref, 2);
	
	        var form = _ref2[0];
	        var model = _ref2[1];
	
	        var checkValidity = function () {
	          if (form[scope.name]) {
	            var sanitizedValue = String(scope.model || "").replace(/[^\d%]/, "");
	            model.$setViewValue(sanitizedValue);
	            model.$render();
	
	            var percentageInput = String(scope.model).match(/^(\d+)%$/);
	            var numberInput = String(scope.model).match(/^(\d+)$/);
	            if (percentageInput) {
	              var percent = percentageInput[1];
	              var valid = true;
	              if (percent % 2 || percent < 0 || percent > 70) {
	                valid = false;
	              } else {
	                model.$setViewValue(30 + parseInt(percent) / 2);
	                model.$render();
	              }
	              form[scope.name].$setValidity("number", true);
	              form[scope.name].$setValidity("percentage", valid);
	            } else if (numberInput) {
	              var number = numberInput[1];
	              var valid = true;
	              if (number < 30 || number > 110) {
	                valid = false;
	              }
	              form[scope.name].$setValidity("percentage", true);
	              form[scope.name].$setValidity("number", valid);
	            } else {
	              form[scope.name].$setValidity("number", false);
	            }
	          }
	        };
	
	        scope.$watch("model", checkValidity);
	      } };
	  });
	
	  /**
	   * Element that provides an input for Monthly amount you currently pay
	   * range from 0 - 999 and is required
	   */
	
	  ngModule.directive("currentMonthlyPremium", function () {
	    return {
	      // We need to access both the form controller and the ngmodel controller
	      require: ["^form", "ngModel"],
	      restrict: "A",
	      scope: {
	        model: "=ngModel",
	        name: "@" },
	      link: function link(scope, element, attrs, _ref) {
	        var _ref2 = _slicedToArray(_ref, 2);
	
	        var form = _ref2[0];
	        var model = _ref2[1];
	
	        var checkValidity = function () {
	
	          if (form[scope.name]) {
	
	            if (scope.model !== null && scope.model !== undefined) {
	
	              if (scope.model >= 0 && scope.model <= 999.99) {
	
	                form[scope.name].$setValidity("range", true);
	              } else {
	
	                form[scope.name].$setValidity("range", false);
	              }
	
	              form[scope.name].$setValidity("premium", true);
	            } else {
	
	              form[scope.name].$setValidity("premium", false);
	            }
	          }
	        };
	
	        scope.$watch("model", checkValidity);
	      }
	    };
	  });
	
	  ngModule.directive("radioOptions", function () {
	    return {
	      restrict: "E",
	      scope: {
	        model: "=",
	        name: "@",
	        options: "=?",
	        onChange: "=?" },
	      template: "\n      <div class=\"radio-group\">\n        <label class=\"radio-inline\" ng-repeat=\"option in options\" >\n            <input\n                type=\"radio\"\n                dynamic-name=\"{{ $parent.name }}\"\n                ng-model=\"$parent.model\"\n                ng-value=\"option[1]\"\n                required\n                ng-change=\"onChange\"\n            /> {{ option[0] }}\n        </label>\n      </div>\n      ",
	      link: function link($scope) {
	        if (!$scope.options) {
	          $scope.options = [["Yes", true], ["No", false]];
	        }
	      } };
	  });
	};

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function (ngModule) {
	
	  ngModule.directive("fundFilters", ["AonConfig", function (AonConfig) {
	    return {
	      restrict: "E",
	      scope: {
	        title: "@",
	        isExpanded: "=",
	        onToggleOpen: "=",
	        onToggleAll: "=",
	        filterModel: "=",
	        modelField: "@",
	        funds: "=",
	        onRefresh: "=",
	        splitOpenRestricted: "="
	      },
	      template: __webpack_require__(310),
	      link: function (scope) {}
	    };
	  }]);
	};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function (ngModule) {
	  __webpack_require__(266)(ngModule);
	  __webpack_require__(265)(ngModule);
	  __webpack_require__(263)(ngModule);
	  __webpack_require__(264)(ngModule);
	  __webpack_require__(258)(ngModule);
	  __webpack_require__(269)(ngModule);
	  __webpack_require__(257)(ngModule);
	  __webpack_require__(259)(ngModule);
	  __webpack_require__(272)(ngModule);
	  __webpack_require__(267)(ngModule);
	  __webpack_require__(273)(ngModule);
	  __webpack_require__(261)(ngModule);
	  __webpack_require__(262)(ngModule);
	  __webpack_require__(260)(ngModule);
	  __webpack_require__(256)(ngModule);
	  __webpack_require__(271)(ngModule);
	  __webpack_require__(270)(ngModule);
	};

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };
	
	var without = _interopRequire(__webpack_require__(178));
	
	var unique = _interopRequire(__webpack_require__(177));
	
	module.exports = function (ngModule) {
	
	  /**
	   * Multiselect checkbox view.
	   **/
	  ngModule.directive("multiSelect", function () {
	    return {
	      restrict: "A",
	      require: "ngModel",
	      replace: true,
	      scope: {
	        model: "=ngModel",
	        choices: "=",
	        // Min number of choices that have to be selected
	        minSelection: "=",
	        // Max number of choices that have to be selected
	        maxSelection: "="
	      },
	      template: __webpack_require__(293),
	      link: function (scope, element, attrs, ngModel) {
	        var validate = function (value) {
	          if (scope.minSelection === scope.maxSelection) {
	            ngModel.$setValidity("exactSelectionCount", scope.minSelection && value.length === scope.minSelection);
	          } else {
	            ngModel.$setValidity("minSelectionCount", scope.minSelection && value.length < scope.minSelection);
	            ngModel.$setValidity("minSelectionCount", scope.maxSelection && value.length > scope.maxSelection);
	          }
	        };
	        ngModel.$formatters.push(function (modelValue) {
	          validate(modelValue);
	        });
	
	        element.data("validation-messages", {
	          minSelectionCount: "Please select at least " + scope.minSelection + " items",
	          maxSelectionCount: "Please select at most " + scope.minSelection + " items",
	          exactSelectionCount: "Please select exactly " + scope.minSelection + " items"
	        });
	
	        ngModel.$parsers.push(function (viewValue) {
	          validate(viewValue);
	          return viewValue;
	        });
	
	        scope.onChange = function (service, checked) {
	          var currentSelection = ngModel.$modelValue;
	          if (!checked) {
	            ngModel.$setViewValue(unique(without(currentSelection, service)));
	          } else {
	            currentSelection.push(service);
	            ngModel.$setViewValue(unique(currentSelection));
	          }
	        };
	      }
	    };
	  });
	};

/***/ }),
/* 270 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (ngModule) {
	    ngModule.directive("operatorFieldNote", ["AonConfig", function (AonConfig) {
	        return {
	            restrict: "E",
	            transclude: true,
	            template: "\n                <div ng-if=\"corporate.is_operator\">\n                    <div ng-transclude></div>\n                </div>\n            ",
	            link: function (scope) {
	                scope.corporate = AonConfig.corporate;
	            } };
	    }]);
	};

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function (ngModule) {
	    ngModule.directive("saveQuote", ["AonConfig", function (AonConfig) {
	        return {
	            restrict: "E",
	            scope: {
	                visible: "=",
	                onClose: "=",
	                applicant: "=",
	                onSave: "=" },
	            template: __webpack_require__(295),
	            link: function (scope) {
	                scope.showAdditionDetails = AonConfig.corporate.show_additional_details_on_quote === true;
	                scope.emailAndSMSRequired = !AonConfig.corporate.quote_sms_and_email_optional;
	
	                scope.$watch("visible", function () {
	                    if (scope.visible) {
	                        $("#save-quote.modal").modal();
	                    } else {
	                        $("#save-quote.modal").modal("hide");
	                    }
	
	                    if (scope.visible && scope.saveQuoteForm) {
	                        var email = _.get(scope.applicant, "contact.email_address", null);
	                        var mobile = _.get(scope.applicant, "contact.phone_mobile", null);
	                        var expectedYearlySavings = _.get(scope.applicant, "zoho.expected_yearly_savings", 0);
	                        scope.saveQuoteForm.sendSMS = !!mobile;
	                        scope.saveQuoteForm.sendEmail = !!email;
	                        scope.saveQuoteForm.expectedYearlySavings = expectedYearlySavings;
	                        scope.saveQuoteForm.improvedBenefit1 = "";
	                        scope.saveQuoteForm.improvedBenefit2 = "";
	                        scope.saveQuoteForm.improvedBenefit3 = "";
	                    }
	                });
	
	                scope.saveQuoteFormValid = function (form) {
	                    // Since fields are not editable, the selections should match what data we have for the opportunity
	                    var email = _.get(scope.applicant, "contact.email_address", null);
	                    var mobile = _.get(scope.applicant, "contact.phone_mobile", null);
	                    var sendOptionsValid = scope.emailAndSMSRequired ? !!email == form.sendEmail && !!mobile == form.sendSMS : (!form.sendEmail || !!email) && (!form.sendSMS || !!mobile);
	                    var expectedSavingsValid = !scope.showAdditionDetails || !isNaN(parseInt(scope.saveQuoteForm.expectedYearlySavings));
	                    var improvedBenefitValid = !scope.showAdditionDetails || (!!scope.saveQuoteForm.improvedBenefit1 || !!scope.saveQuoteForm.improvedBenefit2 || !!scope.saveQuoteForm.improvedBenefit3);
	                    return sendOptionsValid && expectedSavingsValid && improvedBenefitValid;
	                };
	            }
	        };
	    }]);
	};

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _toConsumableArray = function (arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } };
	
	var getProductFeatures = __webpack_require__(2).getProductFeatures;
	
	module.exports = function (ngModule) {
	
	    ngModule.directive("serviceFilters", ["AonApi", "AonConfig", "OperatorService", function (AonApi, AonConfig, OperatorService) {
	        return {
	            restrict: "E",
	            scope: {
	                requiresHospital: "=",
	                requiresAncillary: "=",
	                servicesInColumns: "=",
	                primaryServiceNeed: "=",
	                // We use the previous fund to access the current policy, to allow
	                // looking up the services that policy in order to automatically
	                // select those same services
	                previousFund: "=" },
	            template: __webpack_require__(321),
	            link: function (scope) {
	                var service_label_highlight_css = AonConfig.corporate.service_label_highlight_css;
	
	                scope.primaryServiceNeeds = AonConfig.formChoices.primary_service_needs;
	
	                var getServices = function (which) {
	                    var columns = (scope.servicesInColumns || {})[which] || {};
	                    return [].concat(_toConsumableArray(columns.left || []), _toConsumableArray(columns.right || []));
	                };
	
	                var getPrimaryNeed = function () {
	                    return scope.primaryServiceNeeds.find(function (_need) {
	                        return _need.code === scope.primaryServiceNeed;
	                    }) || { hospital_services: [] };
	                };
	
	                // Given a service (hospital or ancillary) return a string containing inline styles
	                scope.getStyle = function (service) {
	                    return service.highlight ? service_label_highlight_css : "";
	                };
	
	                scope.onSelectPrimaryServiceNeed = function () {
	                    var need = getPrimaryNeed();
	                    getServices("hospital").forEach(function (hospitalService) {
	                        hospitalService.selected = need.hospital_services.includes(hospitalService.id);
	                        hospitalService.changed_from_primary_need = false;
	                    });
	                    OperatorService.setSelectedTiers(need.hospital_tiers);
	                };
	
	                scope.getServiceCSSClass = function (service) {
	                    return {
	                        checked: service.selected,
	                        "changed-from-primary-need": service.changed_from_primary_need };
	                };
	
	                // Check if they have a current policy, and if it is one that
	                // we know about
	                var getCurrentPolicies = function () {
	                    var products = [];
	                    var previousFund = scope.previousFund || {};
	                    if (previousFund.hospital_product && previousFund.hospital_product.id) {
	                        products.push(previousFund.hospital_product);
	                    }
	                    if (previousFund.ancillary_product && previousFund.ancillary_product.id) {
	                        products.push(previousFund.ancillary_product);
	                    }
	                    return products;
	                };
	
	                scope.hasCurrentPolicy = function () {
	                    return getCurrentPolicies().length > 0;
	                };
	
	                // Using the applicants current policy, get the services that policy covers
	                // and select those same services
	                scope.selectCurrentProductServices = function () {
	                    // Clear all the current selections
	                    ["hospital", "ancillary"].map(function (which) {
	                        return getServices(which).forEach(function (service) {
	                            return service.selected = false;
	                        });
	                    });
	
	                    var selectServices = function (which, dict) {
	                        Object.keys(dict).forEach(function (id) {
	                            return getServices(which).forEach(function (service) {
	                                if (String(service.id) === id) {
	                                    var selected = dict[id] && !dict[id].excluded && !dict[id].unknown;
	
	                                    // Run a check for hospital restrict
	                                    // Hospital services "always" has sis_cover
	                                    if (which === "hospital") {
	
	                                        // If it is Restricted, don't select this service
	                                        if (dict[id].sis_cover === "Restricted") {
	
	                                            selected = false;
	                                        }
	                                    }
	
	                                    service.selected = selected;
	                                }
	                            });
	                        });
	                    };
	
	                    getCurrentPolicies().forEach(function (product) {
	                        scope.isLoadingCurrentPolicyServices = true;
	                        AonApi.fetchPrice({}, product.id).then(function (response) {
	                            var pricePackage = response.data;
	                            if (pricePackage) {
	                                if (scope.requiresHospital && pricePackage.price.hospital_product) {
	                                    selectServices("hospital", getProductFeatures(pricePackage, getServices("hospital"), pricePackage.hospital_product.product_hospital_services));
	                                }
	                                if (scope.requiresAncillary && pricePackage.price.ancillary_product) {
	                                    selectServices("ancillary", getProductFeatures(pricePackage, getServices("ancillary"), pricePackage.ancillary_product.product_ancillary_services));
	                                }
	                            }
	                        })["finally"](function () {
	                            scope.isLoadingCurrentPolicyServices = false;
	                        });
	                    });
	                };
	
	                scope.$watch("servicesInColumns", function () {
	                    var need = getPrimaryNeed();
	                    getServices("hospital").forEach(function (service) {
	                        var isNeedService = need.hospital_services.includes(service.id);
	                        service.changed_from_primary_need = isNeedService && !service.selected || !isNeedService && service.selected;
	                    });
	                }, true);
	            }
	        };
	    }]);
	};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function (ngModule) {
	
	    ngModule.directive("zohoError", ["AonConfig", function (AonConfig) {
	        return {
	            restrict: "E",
	            template: __webpack_require__(322),
	            scope: {
	                error: "=" },
	            link: function (scope) {
	                var modal = $(".modal#zoho-api-error");
	                // No idea why this is required, but multiple backdrop's are getting created.
	                // This will remove all but one, so that the modal dismiss will return the
	                // screen to normal state.
	                modal.on("shown.bs.modal", function () {
	                    $(".modal-backdrop").not(":first").remove();
	                });
	                scope.$watch("error", function (error) {
	                    if (error) {
	                        modal.modal("show");
	                    }
	                });
	            } };
	    }]);
	};

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { "default": obj }; };
	
	var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };
	
	if (!Modernizr.mq("only all")) {
	  __webpack_require__(173);
	} else {
	  __webpack_require__(172);
	}
	
	__webpack_require__(167);
	
	// Dependencies
	
	var _ = _interopRequire(__webpack_require__(181));
	
	var ng = _interopRequireWildcard(__webpack_require__(225));
	
	var uiRouter = _interopRequire(__webpack_require__(165));
	
	var ngSanitize = _interopRequire(__webpack_require__(164));
	
	var ngAnimate = _interopRequire(__webpack_require__(162));
	
	var ngCookies = _interopRequire(__webpack_require__(163));
	
	var matchmedia = _interopRequire(__webpack_require__(226));
	
	var ngautovalidate = _interopRequire(__webpack_require__(222));
	
	var smoothScroll = _interopRequire(__webpack_require__(227));
	
	var aui = _interopRequire(__webpack_require__(224));
	
	var auitpl = _interopRequire(__webpack_require__(223));
	
	// Aon
	
	var loadControllers = _interopRequire(__webpack_require__(255));
	
	var loadDirectives = _interopRequire(__webpack_require__(268));
	
	var loadServices = _interopRequire(__webpack_require__(284));
	
	var loadFilters = _interopRequire(__webpack_require__(276));
	
	var loadRoutes = _interopRequire(__webpack_require__(228));
	
	var dependencies = [uiRouter, "ngSanitize", "ngCookies", "matchmedia-ng", "jcs-autoValidate", "smoothScroll", "ui.bootstrap", "ui.bootstrap.tpls"];
	if (Modernizr.csstransitions) {
	  // ngAnimate broke <= IE7 - as it doesn't do anything for them anyway conditionally include it
	  dependencies.push("ngAnimate");
	}
	var aon = angular.module("aon.comparator", dependencies);
	
	loadControllers(aon);
	loadDirectives(aon);
	loadServices(aon);
	loadFilters(aon);
	loadRoutes(aon);
	
	aon.constant("VERSION", {
	  id: ("19.9.2024 16:50") });
	
	aon.config(["$httpProvider", "$stateProvider", "$urlRouterProvider", "matchmediaProvider", "$tooltipProvider", function ($httpProvider, $stateProvider, $urlRouterProvider, matchmediaProvider, $tooltipProvider) {
	  // Setup responsive breakpoints to match our css
	  matchmediaProvider.rules.phone = "(max-width: 480px)";
	  matchmediaProvider.rules.tablet = "(max-width: 768px)";
	  matchmediaProvider.rules.desktop = "(max-width: 990px)";
	
	  $tooltipProvider.options({ appendToBody: false, placement: "bottom" });
	
	  if (!$httpProvider.defaults.headers.get) {
	    $httpProvider.defaults.headers.get = {};
	  }
	  $httpProvider.defaults.headers.get["Cache-Control"] = "no-cache";
	  $httpProvider.defaults.headers.get.Pragma = "no-cache";
	}]);
	
	// NOTE: AonConfig is created in HTML with content passed from django directly. See comparator/index.html.
	aon.run(["AonConfig", "validator", "ErrorMessageResolver", "defaultErrorMessageResolver", "$sce", function (AonConfig, validator, ErrorMessageResolver, defaultErrorMessageResolver, $sce) {
	  defaultErrorMessageResolver.getErrorMessages().then(function (messages) {
	    ErrorMessageResolver.setDefaultMessages(messages);
	  });
	  validator.setErrorMessageResolver(ErrorMessageResolver.resolve);
	
	  // These fields need to be displayed as HTML
	  var trustAsHtmlFields = ["aboutyou_blurb", "compare_blurb", "apply_blurb", "landing_intro_text"],
	      htmlValues = _(AonConfig.corporate).pick(trustAsHtmlFields).mapValues($sce.trustAsHtml).value();
	  _.merge(AonConfig.corporate, htmlValues);
	}]);

/***/ }),
/* 275 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (ngModule) {
	    ngModule.filter("nocents", ["$filter", "$locale", function ($filter, $locale) {
	        var currency = $filter("currency"),
	            formats = $locale.NUMBER_FORMATS;
	        return function (amount, symbol) {
	            var value = currency(amount, symbol);
	            return value.replace(new RegExp("\\" + formats.DECIMAL_SEP + "\\d{2}"), "");
	        };
	    }]);
	};

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function (ngModule) {
	  __webpack_require__(275)(ngModule);
	  __webpack_require__(277)(ngModule);
	};

/***/ }),
/* 277 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (ngModule) {
	    ngModule.filter("titlecase", function () {
	        return function (s) {
	            s = s === undefined || s === null ? "" : s;
	            return s.toString().toLowerCase().replace(/\b([a-z])/g, function (ch) {
	                return ch.toUpperCase();
	            });
	        };
	    });
	
	    ngModule.filter("to_trusted", ["$sce", function ($sce) {
	        return function (text) {
	            return $sce.trustAsHtml(text);
	        };
	    }]);
	};

/***/ }),
/* 278 */
/***/ (function(module, exports) {

	"use strict";
	
	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	module.exports = function (ngModule) {
	
	  ngModule.factory("AonApi", ["AonConfig", "$http", function (AonConfig, $http) {
	    var AonApi = (function () {
	      function AonApi() {
	        _classCallCheck(this, AonApi);
	      }
	
	      _createClass(AonApi, {
	        post: {
	          value: function post(endpoint, data) {
	            var postData = _.extend({ corporate_id: AonConfig.corporate.id }, data);
	            return $http.post("/api/" + endpoint, postData);
	          }
	        },
	        get: {
	          value: function get(endpoint) {
	            var data = arguments[1] === undefined ? {} : arguments[1];
	
	            var params = _.extend({ corporate_id: AonConfig.corporate.id }, data);
	            return $http.get("/api/" + endpoint, {
	              params: params
	            });
	          }
	        },
	        fetchPrice: {
	          value: function fetchPrice(applicant, priceId) {
	            var params = {
	              primary_dob: _.get(applicant, "personal.dob"),
	              partner_dob: _.get(applicant, "partner.dob"),
	              primary_lhc_age: _.get(applicant, "policy.lhc_age"),
	              partner_lhc_age: _.get(applicant, "policy.lhc_age_partner"),
	              primary_youth_discount_age: _.get(applicant, "policy.primary_youth_discount_age"),
	              partner_youth_discount_age: _.get(applicant, "policy.partner_youth_discount_age"),
	              has_primary_previous_fund: _.get(applicant, "personal.previous_fund.has_previous_fund") };
	
	            if (_.get(applicant, "policy.federal_rebate")) {
	              params.rebate_tier = _.get(applicant, "policy.rebate_tier");
	            }
	
	            if (_.get(applicant, "zoho.rebate_percent")) {
	              params.rebate_percent = _.get(applicant, "zoho.rebate_percent");
	            }
	
	            if (_.get(applicant, "policy.discount_code")) {
	              params.discount_code = _.get(applicant, "policy.discount_code");
	            }
	
	            return this.get("prices/" + priceId + "/", params);
	          }
	        }
	      });
	
	      return AonApi;
	    })();
	
	    return new AonApi();
	  }]);
	};

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };
	
	var _slicedToArray = function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { var _arr = []; for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) { _arr.push(_step.value); if (i && _arr.length === i) break; } return _arr; } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	/* @flow */
	
	var moment = _interopRequire(__webpack_require__(1));
	
	var savePriceSummaryLinkInformation = __webpack_require__(2).savePriceSummaryLinkInformation;
	
	module.exports = function (ngModule) {
	
	  ngModule.factory("AonApplicationService", ["$q", "AonConfig", "AonApi", "PrimaryServiceNeeds", "$state", "$log", "$location", function ($q, AonConfig, AonApi, PrimaryServiceNeeds, $state, $log, $location) {
	
	    /**
	     * Get value from list of key, value pairs given a key
	     * @param key
	     * @param pairs
	     * @returns {*}
	     */
	    function getPairValue(key, pairs) {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = pairs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var _step$value = _slicedToArray(_step.value, 2);
	
	          var k = _step$value[0];
	          var v = _step$value[1];
	
	          if (k === key) {
	            return v;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator["return"]) {
	            _iterator["return"]();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return undefined;
	    }
	
	    /**
	     * Get age based on date of birth
	     *
	     * Approximate, assumes 365 days per year
	     *
	     * @param dob
	     * @returns {number}
	     */
	    function getAge(dob) {
	      if (!dob) {
	        return null;
	      }
	      var now = new Date();
	      var _dob$split = dob.split("-");
	
	      var _dob$split2 = _slicedToArray(_dob$split, 3);
	
	      var year = _dob$split2[0];
	      var month = _dob$split2[1];
	
	      var day = _dob$split2[2];
	      var bday = new Date(year, month - 1, day);
	
	      return Math.floor((now - bday) / 1000 / 60 / 60 / 24 / 365);
	    }
	
	    function getRebateTierChoices(application) {
	      var key = application.policy.membership_type === 0 ? "singles" : "family";
	      return AonConfig.formChoices.rebate_tiers[key];
	    }
	
	    var AonApplication = (function () {
	      function AonApplication(data) {
	        _classCallCheck(this, AonApplication);
	
	        _.extend(this, data);
	        this.displayValues = this.getSummaryDetails();
	      }
	
	      _createClass(AonApplication, {
	        getSummaryDetails: {
	          value: function getSummaryDetails() {
	            var details = {};
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	              for (var _iterator = ["policy.cover_type", "policy.membership_type", "primary_address.state"][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var field = _step.value;
	
	                var _field$split = field.split(".");
	
	                var _field$split2 = _slicedToArray(_field$split, 2);
	
	                var key1 = _field$split2[0];
	                var key2 = _field$split2[1];
	
	                details[key2] = getPairValue(this[key1][key2], AonConfig.formChoices[key2]);
	              }
	            } catch (err) {
	              _didIteratorError = true;
	              _iteratorError = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion && _iterator["return"]) {
	                  _iterator["return"]();
	                }
	              } finally {
	                if (_didIteratorError) {
	                  throw _iteratorError;
	                }
	              }
	            }
	
	            details.age = this.personal.age || getAge(this.personal.dob);
	
	            if (this.policy.federal_rebate) {
	              var _getRebateTierChoices$policy$rebate_tier = _slicedToArray(getRebateTierChoices(this)[this.policy.rebate_tier], 2);
	
	              var rebateText = _getRebateTierChoices$policy$rebate_tier[1];
	
	              details.apply_for_rebate = "Govt. Rebate Applied (" + rebateText + ")";
	            } else {
	              details.apply_for_rebate = "No Govt. Rebate Applied";
	            }
	
	            return details;
	          }
	        },
	        requiresAncillaryProducts: {
	
	          /**
	           * Does this applicant want packages that include ancillary products?
	           * @returns {boolean}
	           */
	
	          value: function requiresAncillaryProducts() {
	            return this.policy.cover_type === 1 || this.policy.cover_type === 2;
	          }
	        },
	        requiresHospitalProducts: {
	
	          /**
	           * Does this applicant want packages that include hospital products?
	           * @returns {boolean}
	           */
	
	          value: function requiresHospitalProducts() {
	            return this.policy.cover_type === 0 || this.policy.cover_type === 2;
	          }
	        },
	        hasPartner: {
	
	          /*
	          SINGLE = 0
	          COUPLE = 1
	          FAMILY = 2
	          FAMILY_SINGLE_PARENT = 3
	          CHILDREN_ONLY = 4
	          EXTENDED_FAMILY = 5
	          SINGLE_ANY_DEPENDANTS = 6
	          COUPLE_ANY_DEPENDANTS = 7
	          */
	
	          value: function hasPartner() {
	            return this.policy.membership_type === 1 || this.policy.membership_type === 2 || this.policy.membership_type === 5 || this.policy.membership_type === 7;
	          }
	        },
	        isSingle: {
	          value: function isSingle() {
	            return this.policy.membership_type === 0;
	          }
	        },
	        requiresDependants: {
	
	          /**
	           * Return true if membership type indicates the applicant should have dependants
	           */
	
	          value: function requiresDependants() {
	            return this.policy.membership_type > 1;
	          }
	        },
	        motivationChoices: {
	          value: function motivationChoices() {
	            var isCovered = _.get(this, "personal.previous_fund.has_previous_fund", false);
	            return AonConfig.formChoices.motivation[isCovered ? "covered" : "not_covered"];
	          }
	        },
	        motivationSubChoices: {
	          value: function motivationSubChoices() {
	            var primaryMotivation = _.get(this, "policy.motivation");
	            var primaryReason = this.motivationChoices().filter(function (option) {
	              return option[0] === primaryMotivation;
	            });
	            if (primaryReason.length) {
	              var subReasons = primaryReason[0][2];
	              return subReasons && subReasons.length ? subReasons : null;
	            }
	            return null;
	          }
	        }
	      });
	
	      return AonApplication;
	    })();
	
	    var AonApplicationService = (function () {
	      function AonApplicationService() {
	        _classCallCheck(this, AonApplicationService);
	
	        var defaultPrimaryServiceNeed = PrimaryServiceNeeds.getDefaultPrimaryNeed();
	
	        this.application = {
	          source: AonConfig.jsConstants.sourceOfApplication,
	          personal: {},
	          contact: {},
	          partner: {},
	          primary_address: {},
	          has_secondary_address: false,
	          secondary_address: {},
	          number_of_dependants: null,
	          dependants: [],
	          policy: {
	            primary_service_need: defaultPrimaryServiceNeed ? defaultPrimaryServiceNeed.code : null },
	          comparison_product: {},
	          payment: {
	            benefits_same_account: true } };
	        this.price = {};
	        this.product = {};
	        this.submitResponse = {};
	        this.competition = {
	          optIn: false,
	          optOut: false
	        };
	        this.debug = $location.search().hasOwnProperty("debug");
	      }
	
	      _createClass(AonApplicationService, {
	        setDebug: {
	
	          /**
	           * Set to true to allow debug overlay of price calculations
	           * @param debugOn
	           */
	
	          value: function setDebug(debugOn) {
	            this.debug = debugOn;
	          }
	        },
	        isDebug: {
	
	          /**
	           * Return true if debug mode is on
	           */
	
	          value: function isDebug() {
	            return this.debug;
	          }
	        },
	        calculateAge: {
	
	          /**
	           * Expose the getAge function, for use in calculating partner age
	           * @param dob (string) date of birth
	           * @returns {number} age
	           */
	
	          value: function calculateAge(dob) {
	            return getAge(dob);
	          }
	        },
	        getApplication: {
	
	          /**
	           * Get the applicant. Note that to save any changes you must call saveApplication()
	           *
	           * @returns {Object}
	           */
	
	          value: function getApplication() {
	            var deferred = $q.defer();
	
	            // Don't pass reference through; copy it. This stops changes being propogated when we don't want it. All changes
	            // must go through saveApplication
	            var copy = new AonApplication(_.cloneDeep(this.application));
	            deferred.resolve(copy);
	
	            return deferred.promise;
	          }
	        },
	        getProduct: {
	          value: function getProduct() {
	            var clone = arguments[0] === undefined ? true : arguments[0];
	
	            return clone ? _.cloneDeep(this.product) : this.product;
	          }
	        },
	        saveApplication: {
	
	          /**
	           * Save changes to the application on the client side. For server side see submitApplication
	           * @param applicant
	           */
	
	          value: function saveApplication(application) {
	            _.assign(this.application, application);
	            savePriceSummaryLinkInformation(application);
	          }
	        },
	        saveResponse: {
	
	          /**
	           * Save the response object returned after submission to gateway
	           * @param response
	           */
	
	          value: function saveResponse(response) {
	            this.submitResponse = response;
	          }
	        },
	        getResponse: {
	
	          /**
	           * Get the application submission response object
	           */
	
	          value: function getResponse() {
	            return this.submitResponse;
	          }
	        },
	        setPrice: {
	
	          /**
	           * Set the price to chosen
	           *
	           * @param {Object} price
	           */
	
	          value: function setPrice(price) {
	            this.price = price;
	          }
	        },
	        setProduct: {
	          value: function setProduct(product) {
	            this.product = product;
	          }
	        },
	        hasPrice: {
	
	          /**
	           * Has a price been set for this application?
	           * @returns {boolean}
	           */
	
	          value: function hasPrice() {
	            return this.price && this.price.id !== undefined;
	          }
	        },
	        hasAddressAndState: {
	
	          /**
	           * Has a state (i.e. VIC) been set for this application (use to test if step 1 completed)
	           * @returns {boolean}
	           */
	
	          value: function hasAddressAndState() {
	            return this.application.primary_address && this.application.primary_address.state !== undefined;
	          }
	        },
	        setCompetitionOptIn: {
	
	          /**
	           * Set the competition entry as opted-in
	           */
	
	          value: function setCompetitionOptIn() {
	            this.competition.optIn = true;
	            trackEvent("COMPARATOR_COMPETITION_ENTRY", 0);
	          }
	        },
	        setCompetitionOptOut: {
	
	          /**
	           * Set the competition entry as opted-out
	           */
	
	          value: function setCompetitionOptOut() {
	            this.competition.optOut = true;
	          }
	        },
	        setCustomerReference: {
	          value: function setCustomerReference(ref) {
	            this.application.customer_reference = ref;
	          }
	        },
	        generateCustomerReference: {
	          value: function generateCustomerReference() {
	            var _this = this;
	
	            var forceRegenerate = arguments[0] === undefined ? false : arguments[0];
	
	            var deferred = $q.defer();
	            if (!forceRegenerate && this.application.customer_reference) {
	              deferred.resolve(this.application.customer_reference);
	            } else {
	              var url = "funds/customerreference";
	              if (this.application.zoho_id) {
	                url = "" + url + "?zoho_id=" + this.application.zoho_id;
	              }
	              AonApi.get(url).then(function (result) {
	                _this.setCustomerReference(result.data.customer_reference);
	                deferred.resolve(result.data.customer_reference);
	              }, function (error) {
	                return deferred.reject(error);
	              });
	            }
	            return deferred.promise;
	          }
	        },
	        getCompetitionHasOpted: {
	
	          /**
	           * Return true if the applicant has opted in or out
	           * to entering the competition
	           */
	
	          value: function getCompetitionHasOpted() {
	            return this.competition.optIn || this.competition.optOut;
	          }
	        },
	        getFieldSets: {
	          value: function getFieldSets() {
	            if (!this.hasPrice()) {
	              $state.transitionTo("comparator.step2");
	              $log.debug("Expected a price, found none. Redirecting.");
	              return;
	            }
	            var deferred = $q.defer();
	            var success = function (response) {
	              deferred.resolve(response.data);
	            },
	                error = function (data) {
	              deferred.reject();
	            };
	            AonApi.get("funds/" + this.price.fund.id + "/fieldsets?price_id=" + this.price.id).then(success, error);
	
	            return deferred.promise;
	          }
	        },
	        submitApplication: {
	          value: function submitApplication(application) {
	            var _this = this;
	
	            var postDataTransformers = arguments[1] === undefined ? [] : arguments[1];
	            var applicationId = arguments[2] === undefined ? undefined : arguments[2];
	
	            this.submitResponse = null;
	            var deferred = $q.defer();
	
	            var success = function (response) {
	              _this.saveResponse(response);
	              deferred.resolve(response.data);
	            };
	
	            var error = function (response) {
	              _this.saveResponse(response);
	              deferred.reject(response);
	              if (response.status !== 400) {
	                $log.error("Unexpected response from server", response);
	              }
	            };
	
	            var postData = _.cloneDeep(application);
	            postData.source = AonConfig.jsConstants.sourceOfApplication;
	
	            var dateToString = function (date) {
	              var nativeDate = moment.isMoment(date) ? moment(date).toDate() : date;
	              return [nativeDate.getFullYear(), nativeDate.getMonth() + 1, nativeDate.getDate()].join("-");
	            };
	
	            var convertDateFields = ["payment.debit_date", "payment.join_date"];
	            for (var i = 0; i < convertDateFields.length; i++) {
	              var date = _.get(postData, convertDateFields[i], false);
	              if (date !== false) {
	                _.set(postData, convertDateFields[i], dateToString(date));
	              }
	            }
	
	            postData.direct_debit_discount = _.get(this.product, "apply_direct_debit_discount", false);
	
	            postData.product = {
	              corporate: AonConfig.corporate,
	              total_premium: _.get(this.product, "selectedPrice.pricing.available.monthly_adjusted_price_dd_discount.premium") };
	
	            postData.application_id = applicationId;
	
	            var corporate_id = encodeURIComponent(AonConfig.corporate.id),
	                price_id = encodeURIComponent(this.product.selectedPrice.id);
	
	            delete postData.displayValues;
	            if (!postData.has_secondary_address) {
	              delete postData.secondary_address;
	            }
	            // Apply any other data transformations
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	              for (var _iterator = postDataTransformers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var fn = _step.value;
	
	                postData = fn(_.assign({}, postData));
	              }
	            } catch (err) {
	              _didIteratorError = true;
	              _iteratorError = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion && _iterator["return"]) {
	                  _iterator["return"]();
	                }
	              } finally {
	                if (_didIteratorError) {
	                  throw _iteratorError;
	                }
	              }
	            }
	
	            this.saveApplication(application);
	            // Now attempt the gateway submission
	
	            // Testing - this should NOT be cached anyway - but
	            var cacheBuster = Math.random().toString() + new Date().getTime();
	            AonApi.post("application?price_id=" + price_id + "&corporate_id=" + corporate_id + "&bust=" + cacheBuster, postData).then(success, error);
	
	            return deferred.promise;
	          }
	        },
	        saveApplicationInZoho: {
	          value: function saveApplicationInZoho(application) {
	            var deferred = $q.defer();
	
	            var success = function (response) {
	              deferred.resolve(response.data);
	            };
	
	            var error = function (response) {
	              deferred.reject(response);
	              if (response.status !== 400) {
	                $log.error("Unexpected response from server", response);
	              }
	            };
	
	            var postData = _.cloneDeep(application);
	            postData.source = AonConfig.jsConstants.sourceOfApplication;
	
	            var dateToString = function (date) {
	              return [date.getFullYear(), date.getMonth() + 1, date.getDate()].join("-");
	            };
	            var convertDateFields = ["payment.debit_date", "payment.join_date"];
	
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	              for (var _iterator = convertDateFields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var dateField = _step.value;
	
	                var date = postData[dateField];
	                if (date !== undefined) {
	                  postData[dateField] = dateToString(date);
	                }
	              }
	            } catch (err) {
	              _didIteratorError = true;
	              _iteratorError = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion && _iterator["return"]) {
	                  _iterator["return"]();
	                }
	              } finally {
	                if (_didIteratorError) {
	                  throw _iteratorError;
	                }
	              }
	            }
	
	            postData.direct_debit_discount = _.get(this.product, "apply_direct_debit_discount", false);
	
	            postData.product = {
	              corporate: AonConfig.corporate,
	              total_premium: _.get(this.product, "selectedPrice.pricing.available.monthly_adjusted_price_dd_discount.premium") };
	
	            var price_id = encodeURIComponent(this.product.selectedPrice.id);
	
	            delete postData.displayValues;
	            if (!postData.has_secondary_address) {
	              delete postData.secondary_address;
	            }
	
	            this.saveApplication(application);
	
	            // Testing - this should NOT be cached anyway - but
	            var cacheBuster = Math.random().toString() + new Date().getTime();
	            return AonApi.post("save_application?price_id=" + price_id + "&bust=" + cacheBuster, postData).then(function (response) {
	              return response.data;
	            })["catch"](function (response) {
	              if (response.status !== 400) {
	                $log.error("Unexpected response from server", response);
	              }
	              return response;
	            });
	          }
	        },
	        getRebateTierChoices: {
	          value: (function (_getRebateTierChoices) {
	            var _getRebateTierChoicesWrapper = function getRebateTierChoices(_x) {
	              return _getRebateTierChoices.apply(this, arguments);
	            };
	
	            _getRebateTierChoicesWrapper.toString = function () {
	              return _getRebateTierChoices.toString();
	            };
	
	            return _getRebateTierChoicesWrapper;
	          })(function (application) {
	            return getRebateTierChoices(application);
	          })
	        },
	        getRebateTierText: {
	          value: function getRebateTierText(application) {
	            var caption = AonConfig.corporate.questionConfig.step_1_rebate_tier_caption;
	            var description = AonConfig.corporate.questionConfig.step_1_rebate_tier_description;
	            if (typeof application.policy !== "undefined" && typeof application.policy.membership_type !== "undefined" && application.policy.membership_type > 0) {
	              caption = AonConfig.corporate.questionConfig.step_1_rebate_tier_combined_caption;
	              description = AonConfig.corporate.questionConfig.step_1_rebate_tier_combined_description;
	            }
	            return {
	              caption: caption,
	              description: description
	            };
	          }
	        },
	        trackEvent: {
	          value: function trackEvent(event) {
	            var fund_id = arguments[1] === undefined ? null : arguments[1];
	
	            AonApi.post("tracking", { event: event, fund_id: fund_id });
	          }
	        }
	      });
	
	      return AonApplicationService;
	    })();
	
	    return new AonApplicationService();
	  }]);
	};

/***/ }),
/* 280 */
/***/ (function(module, exports) {

	"use strict";
	
	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	module.exports = function (ngModule) {
	
	  ngModule.factory("Auth", ["AonApi", "$q", "$http", "$cookies", function (AonApi, $q, $http, $cookies) {
	    // We aren't currently concerned about properly authenticating users so doing simplistic once of login on a code
	    // and then storing cookies saying they are authorised. Easily bypassed (ie. manually set cookie).
	
	    // Everything is promised based in case we need to swap this out for some real auth.
	    var authCheckCookieName = "aoncompare.authorised";
	
	    var Auth = (function () {
	      function Auth() {
	        _classCallCheck(this, Auth);
	      }
	
	      _createClass(Auth, {
	        check: {
	
	          /**
	           * Check if current session is authorised. Simply checks for presence of cookie.
	           *
	           * @returns {Promise}
	           */
	
	          value: function check() {
	            var deferred = $q.defer();
	            if ($cookies[authCheckCookieName]) {
	              deferred.resolve();
	            } else {
	              deferred.reject({ code: 401 });
	            }
	            return deferred.promise;
	          }
	        },
	        login: {
	
	          /**
	           * Login with specified code
	           *
	           * @param code
	           * @returns {Promise}
	           */
	
	          value: function login(code) {
	            var deferred = $q.defer(),
	                success = function () {
	              $cookies[authCheckCookieName] = true;
	              deferred.resolve();
	            },
	                error = function () {
	              $cookies[authCheckCookieName] = false;
	              deferred.reject();
	            };
	            AonApi.post("authorise", { code: code }).then(success, error);
	            return deferred.promise;
	          }
	        },
	        zohoLogin: {
	          value: function zohoLogin() {
	            $cookies[authCheckCookieName] = true;
	          }
	        }
	      });
	
	      return Auth;
	    })();
	
	    return new Auth();
	  }]);
	};

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };
	
	var _slicedToArray = function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { var _arr = []; for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) { _arr.push(_step.value); if (i && _arr.length === i) break; } return _arr; } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	var assign = _interopRequire(__webpack_require__(14));
	
	var zipObject = _interopRequire(__webpack_require__(179));
	
	var map = _interopRequire(__webpack_require__(15));
	
	var padLeft = _interopRequire(__webpack_require__(218));
	
	var propertyNameMap = {
	  ExpiryYear: "expiry",
	  ExpiryMonth: "expiry",
	  CardNumber: "number",
	  AcceptBankAccountTerms: "accepted_terms",
	  BSBNumber: "bsb_number",
	  BankAccountNumber: "account_number",
	  BankAccountName: "account_name"
	};
	
	/**
	 * Translate bpoint property names to internal names
	 * @param propertyName
	 * @returns {*}
	 */
	function transformPropertyName(propertyName) {
	  if (propertyName in propertyNameMap) {
	    return propertyNameMap[propertyName];
	  }
	  return propertyName;
	}
	
	module.exports = function (ngModule) {
	
	  /**
	   * BPointApi
	   *
	   * Provides a wrapper around the BPoint API javascript code and creates
	   * the necessary authKey for you before tokenising cards.
	   *
	   * Only the processAddToken for data vault is implemented.
	   */
	  ngModule.factory("BPointApi", ["$http", "$q", function ($http, $q) {
	
	    /**
	     * Create an authkey for use with other API calls
	     */
	    function getAuthKey() {
	      var deferred = $q.defer();
	      $http.post("/bpoint/datavaultauth").then(function (response) {
	        console.log("response", response);
	        if (response.status == 200) {
	          deferred.resolve(response.data.authKey);
	          return;
	        }
	        deferred.reject(response.data.message || response.data);
	      });
	      return deferred.promise;
	    }
	
	    /**
	     * Process add token call with BPoint. This depends upon the bpoint javascript
	     * being available which is included manually as a script tag.
	     * @param {Object} details as per documentation; either bank account or credit card details
	     * @returns {deferred.promise|{then, catch, finally}|{then}|{then, always}}
	     */
	    function processAddToken(details) {
	      console.log("process add token", details);
	
	      var deferred = $q.defer();
	
	      // Handles response from bpoint
	      var processAddTokenCallback = function (result) {
	        console.log(result);
	        if (result.AjaxResponseType == 0 && result.ApiResponseCode == 0) {
	          //AJAX call was successful
	          deferred.resolve(result);
	        } else {
	          var errors = zipObject(map(result.Errors, function (error) {
	            return [transformPropertyName(error.PropertyName), [error.Message]];
	          }));
	          deferred.reject(errors);
	        }
	      };
	
	      var onAuthKeySuccess = function (authKey) {
	        console.log("got key", authKey);
	        // AuthKey generated, can now attempt to process token
	        CBA.ProcessAddToken(assign(details, {
	          AuthKey: authKey,
	          CallbackFunction: processAddTokenCallback
	        }));
	      };
	      var onAuthKeyError = function (error) {
	        deferred.reject(error);
	      };
	      // Need an auth key before we can attempt to process with bpoint
	      getAuthKey().then(onAuthKeySuccess, onAuthKeyError);
	
	      return deferred.promise;
	    }
	
	    var BPointApi = (function () {
	      function BPointApi() {
	        _classCallCheck(this, BPointApi);
	      }
	
	      _createClass(BPointApi, {
	        tokeniseCreditCard: {
	          value: function tokeniseCreditCard(card_details) {
	            var customer_details = arguments[1] === undefined ? {} : arguments[1];
	            var expiry = card_details.expiry;
	            var name = card_details.name;
	            var number = card_details.number;var email_address = customer_details.email_address;
	            var reference = customer_details.reference;
	
	            var _expiry$split = expiry.split("-");
	
	            var _expiry$split2 = _slicedToArray(_expiry$split, 2);
	
	            var year = _expiry$split2[0];
	            var month = _expiry$split2[1];
	
	            var data = {
	              Type: "CREDITCARD",
	              CardHolderName: name,
	              CardNumber: number,
	              // According to CBA support this should be a string padded with 0's rather than a Number which is what
	              // the documentation says
	              ExpiryMonth: padLeft(month, 2, "0"),
	              // As above, leave as string rather than Number. Only pass through last 2 digits (eg. 17 for 2017)
	              ExpiryYear: year.substr(2),
	              Crn1: reference,
	              EmailAddress: email_address
	            };
	            return processAddToken(data);
	          }
	        },
	        tokeniseBankAccount: {
	          value: function tokeniseBankAccount(account_details) {
	            var customer_details = arguments[1] === undefined ? {} : arguments[1];
	            var account_name = account_details.account_name;
	            var account_number = account_details.account_number;
	            var bsb_number = account_details.bsb_number;
	            var accepted_terms = account_details.accepted_terms;var email_address = customer_details.email_address;
	            var reference = customer_details.reference;
	
	            return processAddToken({
	              Type: "BANKACCOUNT",
	              BSBNumber: bsb_number,
	              BankAccountNumber: account_number,
	              BankAccountName: account_name,
	              AcceptBankAccountTerms: accepted_terms,
	              Crn1: reference,
	              EmailAddress: email_address
	            });
	          }
	        }
	      });
	
	      return BPointApi;
	    })();
	
	    return new BPointApi();
	  }]);
	};

/***/ }),
/* 282 */
/***/ (function(module, exports) {

	"use strict";
	
	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	/* @flow */
	
	module.exports = function (ngModule) {
	    ngModule.factory("CorporateService", ["AonApi", function (AonApi) {
	        var CorporateService = (function () {
	            function CorporateService() {
	                _classCallCheck(this, CorporateService);
	            }
	
	            _createClass(CorporateService, {
	                saveCorporateScriptResponse: {
	
	                    /**
	                     * After the application has been submitted, operators can save checklist
	                     * responses which are stored in the applicant's json data.
	                     * @param reference: reference number used to identify a FundApplication on the backend
	                     * @param applicationData: updated application data to save
	                     * @return {*} Promise
	                     */
	
	                    value: function saveCorporateScriptResponse(reference, script_responses) {
	                        return AonApi.post("corporate-script-response", { reference: reference, script_responses: script_responses });
	                    }
	                }
	            });
	
	            return CorporateService;
	        })();
	
	        return new CorporateService();
	    }]);
	};

/***/ }),
/* 283 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (ngModule) {
	
	  /**
	   * Add a custom error message resolver so we can customise error messages easily.
	   *
	   * Use in coordination with the applyValidators directive (see form-directives.js)
	   */
	  ngModule.factory("ErrorMessageResolver", ["$q", function ($q) {
	
	    var defaultMessages = {};
	    var resolve = function (errorType, el) {
	      var defer = $q.defer();
	      var elementMessages = el.data("validation-messages") || {},
	          validation = el.data("validation") || {},
	          validator_details = validation[errorType],
	          result = elementMessages[errorType] || defaultMessages[errorType] || defaultMessages["default"];
	      if (result) {
	        defer.resolve(result.replace("{0}", validator_details));
	      } else {
	        defer.resolve("Set error message for " + errorType);
	      }
	      return defer.promise;
	    };
	
	    return {
	      resolve: resolve,
	      setDefaultMessages: function (messages) {
	        defaultMessages = messages;
	        defaultMessages.date = "That is not a valid date";
	        defaultMessages.medicare_number = "That is not a valid medicare number.";
	      }
	    };
	  }]);
	};

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function (ngModule) {
	  __webpack_require__(281)(ngModule);
	  __webpack_require__(280)(ngModule);
	  __webpack_require__(279)(ngModule);
	  __webpack_require__(278)(ngModule);
	  __webpack_require__(288)(ngModule);
	  __webpack_require__(283)(ngModule);
	  __webpack_require__(289)(ngModule);
	  __webpack_require__(286)(ngModule);
	  __webpack_require__(285)(ngModule);
	  __webpack_require__(282)(ngModule);
	  __webpack_require__(287)(ngModule);
	};

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	
	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	module.exports = function (ngModule) {
	
	  ngModule.factory("NIBApi", ["$http", "$q", function ($http, $q) {
	    var NIBApi = (function () {
	      function NIBApi() {
	        _classCallCheck(this, NIBApi);
	      }
	
	      _createClass(NIBApi, {
	        getPublicKey: {
	          value: function getPublicKey() {
	            return $http.get("/nib/public-key").then(function (response) {
	              return response.data;
	            });
	          }
	        },
	        encryptCCNumber: {
	          value: function encryptCCNumber(cardNumber) {
	            return this.getPublicKey().then(function (_ref) {
	              var PublicKey = _ref.PublicKey;
	
	              var keyData = new Buffer(PublicKey, "base64");
	              var publicKey = new nodeRsa(keyData, "pkcs1-public-der", {});
	              var encryptedData = publicKey.encrypt(cardNumber, "base64");
	              return encryptedData;
	            });
	          }
	        }
	      });
	
	      return NIBApi;
	    })();
	
	    return new NIBApi();
	  }]);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(169).Buffer))

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray = function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { var _arr = []; for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) { _arr.push(_step.value); if (i && _arr.length === i) break; } return _arr; } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	/* @flow */
	
	var _utilityComparator = __webpack_require__(2);
	
	var getDiscountCodeRestrictions = _utilityComparator.getDiscountCodeRestrictions;
	var getPaymentFrequencyKey = _utilityComparator.getPaymentFrequencyKey;
	var getPaymentFrequencyOptionFromKey = _utilityComparator.getPaymentFrequencyOptionFromKey;
	
	module.exports = function (ngModule) {
	    ngModule.factory("OperatorService", ["AonConfig", "AonApplicationService", function (AonConfig, AonApplicationService) {
	        var OperatorService = (function () {
	            function OperatorService() {
	                _classCallCheck(this, OperatorService);
	
	                this.filters = {
	                    offset: 0,
	                    referral_fund: false,
	                    include_future_pricing: true,
	                    display_order: "price_lowhi",
	                    payment_frequency: "monthly",
	                    // If a discount code is selected that limits e.g. the payment frequency, we need to
	                    // indicate that the frequency filter is disabled
	                    payment_frequency_disabled: false,
	                    hospital_classifications: AonConfig.formChoices.hospital_classification_filter_options.map(function (classification) {
	                        return {
	                            code: classification[0],
	                            name: classification[1],
	                            selected: true };
	                    }),
	                    show_current_policy: AonConfig.corporate.display_current_policy_on_comparison_page,
	                    show_comparison_policy: AonConfig.corporate.is_service_comparison_tool,
	                    show_products_from_current_fund: true,
	                    funds: AonConfig.formChoices.known_funds.map(function (f) {
	                        return {
	                            code: f[0],
	                            name: f[1],
	                            restricted: f[2],
	                            selected: true };
	                    }),
	                    non_panel_funds: AonConfig.formChoices.non_panel_funds.map(function (f) {
	                        return {
	                            code: f[0],
	                            name: f[1],
	                            // We default the non-panel funds to NOT selected
	                            selected: false };
	                    }) };
	
	                this.updateApplicantDependantFilters();
	
	                if (AonConfig.formChoices.discount_code_choices.length) {
	                    this.filters.discount_code_choices = AonConfig.formChoices.discount_code_choices;
	                }
	
	                this.controls = {
	                    allFundsSelected: true,
	                    allTiersSelected: true,
	                    allFundsSelectedNonPanel: false };
	            }
	
	            _createClass(OperatorService, {
	                hasDefaultDiscount: {
	                    value: function hasDefaultDiscount() {
	                        return !!AonConfig.formChoices.discount_code_default;
	                    }
	                },
	                updateApplicantDependantFilters: {
	
	                    // Update the payment frequency filter to match the applicant's data (likely retrieved from zoho)
	                    // Defaults to 'monthly'
	
	                    value: function updateApplicantDependantFilters() {
	                        var _this = this;
	
	                        AonApplicationService.getApplication().then(function (applicant) {
	                            var paymentFrequency = _.get(applicant, "payment.frequency", AonConfig.jsConstants.PaymentFrequencies.Monthly);
	                            _this.filters.payment_frequency = getPaymentFrequencyOptionFromKey(getPaymentFrequencyKey(paymentFrequency));
	                            _this.filters.discount_code = _.get(applicant, "policy.discount_code", AonConfig.formChoices.discount_code_default);
	                            _this.updateDiscountDependantFilters();
	                        });
	                    }
	                },
	                updateDiscountDependantFilters: {
	
	                    // If a discount can be selected and changed, we may need to force a particular payment frequency,
	                    // depending on the configuration of the discount. Perform that update here.
	
	                    value: function updateDiscountDependantFilters() {
	                        var _this = this;
	
	                        AonApplicationService.getApplication().then(function (applicant) {
	                            var disable_payment_frequency = false;
	                            if (_this.filters.discount_code) {
	                                var discountRestrictions = getDiscountCodeRestrictions(_this.filters.discount_code);
	                                if (discountRestrictions && Number.isFinite(discountRestrictions.payment_frequency)) {
	                                    // Update the payment frequency on the applicant
	                                    _.set(applicant, "payment.frequency", discountRestrictions.payment_frequency);
	                                    // Update the operator filter
	                                    _this.filters.payment_frequency = getPaymentFrequencyOptionFromKey(getPaymentFrequencyKey(discountRestrictions.payment_frequency));
	                                    // Disable select of other payment frequencies
	                                    disable_payment_frequency = true;
	                                }
	                            }
	                            _this.filters.payment_frequency_disabled = disable_payment_frequency;
	                        });
	                    }
	                },
	                setSelectedTiers: {
	                    value: function setSelectedTiers(tiers) {
	                        var allSelected = !tiers || !tiers.length;
	                        this.filters.hospital_classifications.forEach(function (tierFilter) {
	                            tierFilter.selected = allSelected ? true : tiers.includes(tierFilter.code);
	                        });
	                        this.controls.allTiersSelected = this.filters.hospital_classifications.every(function (tierFilter) {
	                            return tierFilter.selected;
	                        });
	                    }
	                },
	                paymentFrequencyChoices: {
	                    value: function paymentFrequencyChoices() {
	                        // Convert the list that we get from the backend [(numeric frequency code, label)] into
	                        // [(string frequency code, label)] that is expected in order to extract payment frequency
	                        // values from the api response.
	                        return AonConfig.formChoices.payment_frequency_filter_choices.map(function (_ref) {
	                            var _ref2 = _slicedToArray(_ref, 2);
	
	                            var code = _ref2[0];
	                            var label = _ref2[1];
	                            return [getPaymentFrequencyOptionFromKey(getPaymentFrequencyKey(code)), label];
	                        });
	                    }
	                }
	            });
	
	            return OperatorService;
	        })();
	
	        return new OperatorService();
	    }]);
	};

/***/ }),
/* 287 */
/***/ (function(module, exports) {

	"use strict";
	
	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	module.exports = function (ngModule) {
	
	  ngModule.factory("PrimaryServiceNeeds", ["AonConfig", function (AonConfig) {
	
	    var needs = AonConfig.formChoices.primary_service_needs || [];
	
	    var PrimaryNeeds = (function () {
	      function PrimaryNeeds() {
	        _classCallCheck(this, PrimaryNeeds);
	      }
	
	      _createClass(PrimaryNeeds, {
	        getDefaultPrimaryNeed: {
	          value: function getDefaultPrimaryNeed() {
	            return null;
	          }
	        },
	        needFromCode: {
	          value: function needFromCode(need) {
	            return needs.find(function (_need) {
	              return _need.code === need;
	            });
	          }
	        },
	        selectPrimaryNeedServices: {
	
	          /**
	           * Given services, set selected/unselected based on whether they are included
	           * in the given need's service set
	           * @param services: {ancillary:[], hospital:[]}
	           * @param primaryNeed: str Code for the primary need
	           * @return: a new copy of the services, with selection status updated
	           */
	
	          value: function selectPrimaryNeedServices(services, primaryNeed) {
	            var updatedServices = _.cloneDeep(services);
	            var need = this.needFromCode(primaryNeed);
	            if (!need) {
	              return updatedServices;
	            }
	            (updatedServices.hospital || []).forEach(function (_service) {
	              _service.selected = need.hospital_services.includes(_service.id);
	            });
	            return updatedServices;
	          }
	        }
	      });
	
	      return PrimaryNeeds;
	    })();
	
	    return new PrimaryNeeds();
	  }]);
	};

/***/ }),
/* 288 */
/***/ (function(module, exports) {

	"use strict";
	
	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	module.exports = function (ngModule) {
	
	  ngModule.factory("AonProducts", ["AonApi", "OperatorService", "PrimaryServiceNeeds", "$q", function (AonApi, OperatorService, PrimaryServiceNeeds, $q) {
	    var AonProducts = (function () {
	      function AonProducts() {
	        _classCallCheck(this, AonProducts);
	
	        this.services = null;
	
	        // Cached applicant used for fetching preselect services. Used to track changes to see if we need to refetch.
	        this.cachedApplicant = {};
	      }
	
	      _createClass(AonProducts, {
	        saveServices: {
	          value: function saveServices(services) {
	            this.services = _.cloneDeep(services);
	          }
	        },
	        getServices: {
	
	          /**
	           * Get full list of services
	           * @returns {*}
	           */
	
	          value: function getServices() {
	            var _this = this;
	
	            var deferred = $q.defer();
	            if (this.services === null) {
	              var success = function (response) {
	                _this.services = response.data;
	                _this.services.hospital = _this.services.hospital.map(function (s) {
	                  s.selected = false;return s;
	                });
	                _this.services.ancillary = _this.services.ancillary.map(function (s) {
	                  s.selected = false;return s;
	                });
	                deferred.resolve(_this.services);
	              },
	                  error = function (data) {
	                deferred.reject();
	              };
	              AonApi.get("services").then(success, error);
	            } else {
	              deferred.resolve(this.services);
	            }
	            return deferred.promise;
	          }
	        },
	        getPreselectedServices: {
	
	          /**
	           * Get full list of services with selected ones flagged with 'selected' key
	           *
	           * @param applicant
	           * @returns {*}
	           */
	
	          value: function getPreselectedServices(applicant) {
	            var _this = this;
	
	            var deferred = $q.defer();
	            var zohoServices = _.get(applicant, "zoho.services", null);
	
	            this.getServices().then(function (services) {
	
	              var setServices = function (data) {
	                _this.cachedApplicant = applicant;
	                var updated_services = {};
	
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                  for (var _iterator = ["ancillary", "hospital"][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    (function () {
	                      var type = _step.value;
	
	                      var ids = _.map(data[type], "id");
	                      updated_services[type] = _(services[type]).map(function (service) {
	                        service.selected = ids.indexOf(service.id) !== -1;
	                        return service;
	                      }).value();
	                    })();
	                  }
	                } catch (err) {
	                  _didIteratorError = true;
	                  _iteratorError = err;
	                } finally {
	                  try {
	                    if (!_iteratorNormalCompletion && _iterator["return"]) {
	                      _iterator["return"]();
	                    }
	                  } finally {
	                    if (_didIteratorError) {
	                      throw _iteratorError;
	                    }
	                  }
	                }
	
	                _this.services = updated_services;
	              };
	
	              if (_.isEqual(applicant, _this.cachedApplicant)) {
	                deferred.resolve(_this.services);
	              } else {
	                var primaryNeed = _.get(applicant, "policy.primary_service_need", null);
	
	                if (primaryNeed) {
	                  _this.services = PrimaryServiceNeeds.selectPrimaryNeedServices(_this.services, primaryNeed);
	                  var need = PrimaryServiceNeeds.needFromCode(primaryNeed);
	                  OperatorService.setSelectedTiers(need.hospital_tiers);
	                }
	
	                // If we have selected services from a saved quote in zoho, overwrite whatever
	                // was selected (or not) from the primary service need (has to come after the
	                // primaryNeed block above)
	                if (zohoServices !== null) {
	                  setServices(zohoServices);
	                }
	
	                deferred.resolve(_this.services);
	              }
	            });
	
	            return deferred.promise;
	          }
	        },
	        searchPackages: {
	
	          /**
	           * Search for pricing packages
	           *
	           * @param application AonApplication
	           * @param selectedServices
	           * @returns {*}
	           */
	
	          value: function searchPackages(application, selectedServices, filters) {
	            var ancillary = _.pluck(selectedServices.ancillary, "id"),
	                hospital = _.pluck(selectedServices.hospital, "id");
	            return AonApi.post("packages/search", {
	              application: application,
	              services: {
	                ancillary: ancillary,
	                hospital: hospital },
	              current_fund_id: _.get(application, "personal.previous_fund.fund_id", ""),
	              filters: filters
	            });
	          }
	        }
	      });
	
	      return AonProducts;
	    })();
	
	    return new AonProducts();
	  }]);
	};

/***/ }),
/* 289 */
/***/ (function(module, exports) {

	"use strict";
	
	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	/* @flow */
	
	module.exports = function (ngModule) {
	    ngModule.factory("ZohoService", ["$q", "$state", "$log", "$http", "AonApi", "AonApplicationService", "Auth", function ($q, $state, $log, $http, AonApi, AonApplicationService, Auth) {
	
	        var sanitizeApplicantData = function (applicant) {
	            var sanitizedData = _.cloneDeep(applicant);
	
	            // Check current products. When user clears a product field that previously contained a value,
	            // the model gets set to the value of "" (empty string). Backend expects an object|null, so
	            // convert it here.
	            var hasEmptyCurrentHospital = _.get(sanitizedData, "personal.previous_fund.hospital_product", null) === "";
	            var hasEmptyCurrentAncillary = _.get(sanitizedData, "personal.previous_fund.ancillary_product", null) === "";
	            if (hasEmptyCurrentHospital) {
	                _.set(sanitizedData, "personal.previous_fund.hospital_product", null);
	            }
	            if (hasEmptyCurrentAncillary) {
	                _.set(sanitizedData, "personal.previous_fund.ancillary_product", null);
	            }
	            return sanitizedData;
	        };
	
	        var ZohoService = (function () {
	            function ZohoService() {
	                _classCallCheck(this, ZohoService);
	
	                this.apiError = null;
	            }
	
	            _createClass(ZohoService, {
	                wrapApiCall: {
	                    value: function wrapApiCall(promise) {
	                        var _this = this;
	
	                        this.apiError = null;
	                        return promise["catch"](function (error) {
	                            var data = error.data;
	
	                            console.error("Zoho API error:", error);
	                            _this.apiError = data;
	                            throw error;
	                        });
	                    }
	                },
	                getZohoApplicant: {
	                    value: function getZohoApplicant(leadId) {
	                        var _this = this;
	
	                        var operatorName = arguments[1] === undefined ? null : arguments[1];
	                        var add_note = arguments[2] === undefined ? null : arguments[2];
	
	                        var payload = { type: "get_lead" };
	                        if (add_note) {
	                            payload.add_opportunity_note = add_note;
	                        }
	                        return this.wrapApiCall(AonApi.post("zoho/" + leadId, payload).then(function (response) {
	                            if (response.data.valid) {
	                                return AonApplicationService.getApplication().then(function (applicant) {
	                                    var data = response.data;
	                                    var keys = ["personal.first_name", "personal.last_name", "personal.gender", "personal.dob", "personal.dob", "personal.previous_fund", "personal.vitality", "partner.title", "partner.first_name", "partner.last_name", "partner.gender", "partner.dob", "primary_address.state", "primary_address.address1", "contact.phone_mobile", "contact.email_address", "policy.lhc_age", "policy.held_continuous_hospital_cover", "policy.medicare.number", "policy.medicare.expiry", "policy.medicare.first_name", "policy.medicare.last_name", "policy.lhc_age_partner", "policy.federal_rebate", "policy.rebate_tier", "policy.motivation", "policy.motivation2", "policy.membership_type", "policy.primary_service_need", "policy.primary_youth_discount_age", "policy.partner_youth_discount_age", "policy.discount_code", "payment.frequency", "number_of_dependants", "dependants", "zoho.owner_name", "zoho.owner_first_name", "zoho.owner_email", "zoho.company", "zoho.company_id", "zoho.company_logo", "zoho.company_contact_number", "zoho.company_template", "zoho.company_error_template", "zoho.apply_corporate", "zoho.motivation", "zoho.motivation2", "zoho.has_quote", "zoho.rate_code", "zoho.quoted_product", "zoho.quoted_product_fund", "zoho.stage_is_closed", "zoho.advisor", "zoho.licensee", "zoho.expected_yearly_savings", "zoho.improved_benefit_1", "zoho.improved_benefit_2", "zoho.improved_benefit_3", "zoho.rebate_percent", "zoho.channel", "zoho.lead_category", "zoho.team_signature", "zoho.consultant_signature_line_1", "zoho.consultant_signature_line_2", "zoho.company_data", "zoho.promo_code", "zoho.cooling_off_applies", "zoho.cooling_off_period", "fund_specific_data", "quote_details.application_link", "quote_details.quote_link", "application_domains.public", "application_domains.agent"];
	
	                                    if (data.is_internal_record) {
	                                        applicant = data;
	                                    } else {
	                                        var _iteratorNormalCompletion = true;
	                                        var _didIteratorError = false;
	                                        var _iteratorError = undefined;
	
	                                        try {
	                                            for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                                                var key = _step.value;
	
	                                                _.set(applicant, key, _.get(data, key));
	                                            }
	                                        } catch (err) {
	                                            _didIteratorError = true;
	                                            _iteratorError = err;
	                                        } finally {
	                                            try {
	                                                if (!_iteratorNormalCompletion && _iterator["return"]) {
	                                                    _iterator["return"]();
	                                                }
	                                            } finally {
	                                                if (_didIteratorError) {
	                                                    throw _iteratorError;
	                                                }
	                                            }
	                                        }
	                                    }applicant.zoho_id = leadId;
	                                    applicant.cmn_id = data.cmn_id;
	
	                                    // Save initial value for rebate-related fields
	                                    _.set(applicant, "logging.initial.policy.lhc_age", data.policy.lhc_age);
	                                    _.set(applicant, "logging.initial.policy.lhc_age_partner", data.policy.lhc_age_partner);
	                                    _.set(applicant, "logging.initial.policy.federal_rebate", data.policy.federal_rebate);
	                                    _.set(applicant, "logging.initial.policy.rebate_tier", data.policy.rebate_tier);
	
	                                    // If an operator name was passed in, store it
	                                    _.set(applicant, "zoho.operator", operatorName);
	
	                                    if (_.get(data, "zoho.services", null) !== null) {
	                                        _.set(applicant, "zoho.services", _.get(data, "zoho.services"));
	                                    }
	
	                                    Auth.zohoLogin();
	                                    AonApplicationService.saveApplication(applicant);
	
	                                    return _this;
	                                });
	                            }
	                        }));
	                    }
	                },
	                sendRetentionToZoho: {
	                    value: function sendRetentionToZoho(leadId, retention_data, applicant, product) {
	                        return this.wrapApiCall(AonApi.post("zoho/" + leadId, {
	                            type: "retention_to_zoho",
	                            retention_data: retention_data,
	                            applicant: sanitizeApplicantData(applicant),
	                            product: product
	                        }));
	                    }
	                },
	                sendNeedsAnalysisToZoho: {
	                    value: function sendNeedsAnalysisToZoho(leadId, applicant) {
	                        return this.wrapApiCall(AonApi.post("zoho/" + leadId, {
	                            type: "send_to_zoho",
	                            is_compare: true,
	                            applicant: sanitizeApplicantData(applicant) }));
	                    }
	                },
	                sendQuoteToZoho: {
	                    value: function sendQuoteToZoho(leadId, applicant, product) {
	                        var suppress_opportunity_note = arguments[3] === undefined ? true : arguments[3];
	
	                        return this.wrapApiCall(AonApi.post("zoho/" + leadId, {
	                            type: "send_to_zoho",
	                            is_quote: true,
	                            suppress_opportunity_note: suppress_opportunity_note,
	                            applicant: sanitizeApplicantData(applicant),
	                            product: product.selectedPrice,
	                            direct_debit_discount: _.get(product, "apply_direct_debit_discount", false) }));
	                    }
	                },
	                saveServicesToZoho: {
	                    value: function saveServicesToZoho(leadId, selectedServices) {
	                        return this.wrapApiCall(AonApi.post("zoho/" + leadId + "/services", selectedServices));
	                    }
	                },
	                setStage: {
	                    value: function setStage(leadId, stage) {
	                        return this.wrapApiCall(AonApi.post("zoho/" + leadId + "/stage", { stage: stage }));
	                    }
	                },
	                getStage: {
	                    value: function getStage(leadId) {
	                        return this.wrapApiCall(AonApi.get("zoho/" + leadId + "/stage").then(function (response) {
	                            return response.data;
	                        }));
	                    }
	                }
	            });
	
	            return ZohoService;
	        })();
	
	        return new ZohoService();
	    }]);
	};

/***/ }),
/* 290 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.getRebateScriptConfig = getRebateScriptConfig;
	exports.formatDate = formatDate;
	exports.formatJoinDate = formatJoinDate;
	exports.getRebateTierIncome = getRebateTierIncome;
	exports.isRebateScriptValid = isRebateScriptValid;
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var VALIDATION_MOHF = "VALIDATION_MOHF";
	exports.VALIDATION_MOHF = VALIDATION_MOHF;
	var VALIDATION_ITSMY = "VALIDATION_ITSMY";
	exports.VALIDATION_ITSMY = VALIDATION_ITSMY;
	var VALIDATION_HEALTH_PARTNERS = "VALIDATION_HEALTH_PARTNERS";
	exports.VALIDATION_HEALTH_PARTNERS = VALIDATION_HEALTH_PARTNERS;
	var VALIDATION_FRANK = "VALIDATION_FRANK";
	exports.VALIDATION_FRANK = VALIDATION_FRANK;
	var VALIDATION_PHOENIX_PUBLIC = "VALIDATION_PHOENIX_PUBLIC";
	exports.VALIDATION_PHOENIX_PUBLIC = VALIDATION_PHOENIX_PUBLIC;
	var VALIDATION_HUNTER_PUBLIC = "VALIDATION_HUNTER_PUBLIC";
	
	exports.VALIDATION_HUNTER_PUBLIC = VALIDATION_HUNTER_PUBLIC;
	var rebateScriptMedicareColorOptions = [["Green", true], ["Yellow", false], ["Other", true]];
	
	exports.rebateScriptMedicareColorOptions = rebateScriptMedicareColorOptions;
	
	function getRebateScriptConfig(AonConfig) {
	    var _AonConfig$deployment = AonConfig.deployment;
	    var ENVIRONMENT_ID = _AonConfig$deployment.ENVIRONMENT_ID;
	    var ENVIRONMENT_ID_MOHF = _AonConfig$deployment.ENVIRONMENT_ID_MOHF;
	    var ENVIRONMENT_ID_ITSMY = _AonConfig$deployment.ENVIRONMENT_ID_ITSMY;
	
	    var validationType = "";
	    var rebateScript = "";
	    var rebate_script_template = AonConfig.corporate.rebate_script_template;
	
	    if (rebate_script_template === "health_partners") {
	        rebateScript = "/static/partials/rebate/script_health_partners.html";
	        validationType = VALIDATION_HEALTH_PARTNERS;
	    } else if (rebate_script_template === "frank") {
	        rebateScript = "/static/partials/rebate/script_frank.html";
	        validationType = VALIDATION_MOHF;
	    } else if (rebate_script_template === "phoenix") {
	        rebateScript = "/static/partials/rebate/script_phoenix_operator.html";
	        validationType = VALIDATION_ITSMY;
	    } else if (rebate_script_template === "hunter") {
	        rebateScript = "/static/partials/rebate/script_hunter_operator.html";
	        validationType = VALIDATION_ITSMY;
	    } else if (rebate_script_template === "hunter_public") {
	        rebateScript = "/static/partials/rebate/script_hunter_public.html";
	        validationType = VALIDATION_HUNTER_PUBLIC;
	    } else if (rebate_script_template === "phoenix_public") {
	        rebateScript = "/static/partials/rebate/script_phoenix_public.html";
	        validationType = VALIDATION_PHOENIX_PUBLIC;
	    } else if (ENVIRONMENT_ID === ENVIRONMENT_ID_ITSMY) {
	        rebateScript = "/static/partials/rebate/script_itsmy.html";
	        validationType = VALIDATION_ITSMY;
	    } else if (ENVIRONMENT_ID === ENVIRONMENT_ID_MOHF) {
	        rebateScript = "/static/partials/rebate/script_mohf.html";
	        validationType = VALIDATION_MOHF;
	    }
	
	    return {
	        rebateScript: rebateScript,
	        validationType: validationType };
	}
	
	function formatDate(date) {
	    return [date.getDate(), date.getMonth() + 1, date.getFullYear()].join("/");
	}
	
	function formatJoinDate(application) {
	    var date = _.get(application, "payment.join_date");
	    if (!date) {
	        return "N/A";
	    }
	    return formatDate(date);
	}
	
	function getRebateTierIncome(application, AonApplicationService) {
	    var choices = AonApplicationService.getRebateTierChoices(application);
	    return choices[_.get(application, "policy.rebate_tier")][1];
	}
	
	function validateMohf(application) {
	    var covered = _.get(application, "rebate_script.applicant_covered_by_policy", null);
	    var child_only = _.get(application, "rebate_script.child_only_policy", null);
	    if (covered === false && child_only === false) {
	        return false;
	    }
	
	    var declaration_correct = _.get(application, "rebate_script.declare_correct", null);
	    if (declaration_correct === false) {
	        return false;
	    }
	
	    return true;
	}
	
	function validateItsmy(application) {
	    var covered = _.get(application, "rebate_script.applicant_covered_by_policy", null);
	    if (covered === false) {
	        return false;
	    }
	
	    var declaration_correct = _.get(application, "rebate_script.declare_correct", null);
	    if (declaration_correct === false) {
	        return false;
	    }
	
	    return true;
	}
	
	function validateHealthPartners(application) {
	    var others_on_policy = _.get(application, "rebate_script.other_people_on_policy", null);
	    if (others_on_policy === null) {
	        return true;
	    } else if (others_on_policy === true) {
	        return false;
	    }
	
	    var agree_to_answer_questions = _.get(application, "rebate_script.agree_to_answer_questions", null);
	    if (agree_to_answer_questions === false) {
	        return false;
	    }
	
	    var medicare_card_green = _.get(application, "rebate_script.medicare_card_green", null);
	    if (medicare_card_green === false) {
	        return false;
	    }
	
	    var rebate_tier_correct = _.get(application, "rebate_script.rebate_tier_correct", null);
	    if (rebate_tier_correct === false) {
	        return false;
	    }
	
	    var reduced_premium_on_start_date = _.get(application, "rebate_script.reduced_premium_on_start_date", null);
	    if (reduced_premium_on_start_date === false) {
	        return false;
	    }
	
	    var declaration_correct = _.get(application, "rebate_script.declare_correct", null);
	    if (declaration_correct === false) {
	        return false;
	    }
	
	    var played_recording = _.get(application, "rebate_script.played_new_member_declaration_recording", null);
	    var read_recording = _.get(application, "rebate_script.read_new_member_declaration", null);
	    if (played_recording !== true && read_recording !== true) {
	        return false;
	    }
	
	    return true;
	}
	
	function validateFrank(application) {
	    var covered = _.get(application, "rebate_script.applicant_covered_by_policy", null);
	    var child_only = _.get(application, "rebate_script.child_only_policy", null);
	    if (covered === false && child_only === false) {
	        return false;
	    }
	
	    var others_on_policy = _.get(application, "rebate_script.other_people_on_policy", null);
	    if (others_on_policy === null) {
	        return true;
	    } else if (others_on_policy === true) {
	        return false;
	    }
	
	    var declaration_correct = _.get(application, "rebate_script.declare_correct", null);
	    if (declaration_correct === false) {
	        return false;
	    }
	
	    if (_.get(this, "verbal_rebate.errors.rebate_tier")) {
	        return false;
	    }
	
	    return true;
	}
	
	function validatePhoenixPublic(application) {
	    // If they select no to either of these questions, the form is 'valid' in the sense that
	    // we need to let them submit, but they will not actually have filled out the verbal rebate,
	    // so the backend will not regard them as having completed the rebate script
	    var collect = _.get(application, "rebate_script.agree_to_information_collection", null);
	    if (collect === null) {
	        return true;
	    } else if (collect === false) {
	        return true;
	    }
	
	    var covered = _.get(application, "rebate_script.applicant_covered_by_policy", null);
	    if (covered === false) {
	        return true;
	    }
	
	    var medicare = _.get(application, "rebate_script.all_eligible_for_medicare", null);
	    if (medicare === false) {
	        return false;
	    }
	
	    return validateItsmy(application);
	}
	
	function isRebateScriptValid(application, validationType) {
	    if ([VALIDATION_MOHF, VALIDATION_ITSMY, VALIDATION_FRANK].includes(validationType)) {
	        var collect = _.get(application, "rebate_script.agree_to_information_collection", null);
	        if (collect === null) {
	            return true;
	        } else if (collect === false) {
	            return false;
	        }
	
	        var medicare = _.get(application, "rebate_script.all_eligible_for_medicare", null);
	        if (medicare === false) {
	            return false;
	        }
	    }
	
	    switch (validationType) {
	        case VALIDATION_MOHF:
	            return validateMohf(application);
	        case VALIDATION_ITSMY:
	            return validateItsmy(application);
	        case VALIDATION_HEALTH_PARTNERS:
	            return validateHealthPartners(application);
	        case VALIDATION_FRANK:
	            return validateFrank(application);
	        case VALIDATION_PHOENIX_PUBLIC:
	            return validatePhoenixPublic(application);
	        case VALIDATION_HUNTER_PUBLIC:
	            // Todo: We will need to change this to Hunter validation later
	            return validatePhoenixPublic(application);
	        default:
	            return true;
	    }
	}

/***/ }),
/* 291 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"active-quote-banner\" class=\"active-quote-section\">\n    <div class=\"container\">\n        <div class=\"row--narrow\">\n            <div><b>This applicant has an existing active quote:</b></div>\n            <div>{{ application.zoho.quoted_product.banner_summary }}</div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 292 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"aon-date--wrapper\" register-custom-form-control=\"\">\n  <div ng-if=\"!noDays\" class=\"aon-date--day\">\n    <label for=\"aon-date-day-{{ $id }}\" class=\"visually-hidden\">Day of birth</label>\n    <input type=\"text\" id=\"aon-date-day-{{ $id }}\" class=\"form-control\" ng-change=\"onDateChange()\" ng-model=\"$parent.day\" placeholder=\"DD\" />\n    <!--<select id=\"aon-date-day-{{ $id }}\" class=\"form-control\"\n      disable-validation-message=\"\"\n      name=\"day_{{ $id }}\"\n      ng-change=\"onDateChange()\"\n      ng-model=\"$parent.day\" ng-options=\"day for day in formChoices.date.days\">\n      <option value=\"\">Day</option>\n    </select>-->\n  </div>\n  <div class=\"aon-date--month\">\n    <label for=\"aon-date-month-{{ $id }}\" class=\"visually-hidden\">Month of birth</label>\n    <input type=\"text\" id=\"aon-date-month-{{ $id }}\" class=\"form-control\" ng-change=\"onDateChange()\" ng-model=\"month\" placeholder=\"MM\" />\n    <!--<select id=\"aon-date-month-{{ $id }}\" class=\"form-control\"\n      ng-model=\"month\"\n      name=\"month_{{ $id }}\"\n      ng-change=\"onDateChange()\"\n      disable-validation-message=\"\"\n      ng-options=\"item[0] as item[1] for item in formChoices.date.months\">\n      <option value=\"\">Month</option>\n    </select>-->\n  </div>\n\n  <div class=\"aon-date--year\">\n    <label for=\"aon-date-year-{{ $id }}\" class=\"visually-hidden\">Year of birth</label>\n    <input type=\"text\" id=\"aon-date-year-{{ $id }}\" class=\"form-control\" ng-change=\"onDateChange()\" ng-model=\"year\" placeholder=\"YYYY\" />\n    <!--<select id=\"aon-date-year-{{ $id }}\" class=\"form-control\"\n      ng-model=\"year\"\n      disable-validation-message=\"\"\n      ng-change=\"onDateChange()\"\n      ng-options=\"year for year in yearsChoices\">\n      <option value=\"\">Year</option>\n    </select>-->\n  </div>\n</div>\n"

/***/ }),
/* 293 */
/***/ (function(module, exports) {

	module.exports = "<div register-custom-form-control=\"\">\n  <div class=\"form-value checkbox\"  ng-repeat=\"item in choices\" >\n    <label>\n      <input type=\"checkbox\" value=\"item[0]\" ng-model=\"selected_items[item[0]]\" ng-change=\"onChange(item[0], selected_items[item[0]])\"/>\n      {{ item[1] }}\n    </label>\n  </div>\n</div>"

/***/ }),
/* 294 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"form-group\" ng-if=\"!corporateSearch\">\n  <label class=\"control-label\">Current Health Fund State</label>\n\n  <div class=\"form-value\">\n    <select\n      id=\"step1-state\"\n      class=\"form-control\"\n      ng-model=\"model.state\"\n      ng-options=\"item[0] as item[1] for item in formChoices.state\"\n      ng-change=\"clearCurrentHealthFundProducts()\"\n      required\n    >\n      <option value=\"\">-- Please select --</option>\n    </select>\n  </div>\n</div>\n\n<div class=\"form-group\" ng-if=\"!corporateSearch\">\n  <label class=\"control-label\">Current Membership Type</label>\n\n  <div class=\"form-value\">\n    <select\n      class=\"form-control\"\n      ng-model=\"model.membership\"\n      ng-options=\"item[0] as item[1] for item in formChoices.membership_type\"\n      ng-change=\"clearCurrentHealthFundProducts()\"\n      required\n    >\n      <option value=\"\">-- Please Select --</option>\n    </select>\n  </div>\n</div>\n\n\n\n<div ng-if=\"showProductLookup()\">\n\n  <div class=\"form-group\">\n    <label class=\"control-label\">{{ hospitalLabel }}</label>\n    <div class=\"form-value\">\n      <input placeholder=\"Hospital or Combined\"\n             dynamic-name=\"{{ prefix }}_hospital_product\"\n             type=\"text\"\n             class=\"form-control\"\n             ng-model=\"model.hospital_product\"\n             typeahead=\"displayResult(product) for product in productLookup($viewValue, 'hospital')\"\n             typeahead-on-select=\"selectHospital($item)\"\n             typeahead-editable=\"false\"\n             apply-validators=\"validators\"\n             autocomplete=\"off\"\n      />\n      <div ng-if=\"loading.hospital\">Searching...</div>\n    </div>\n  </div>\n\n  <div class=\"form-group\">\n    <label class=\"control-label\">{{ ancillaryLabel }}</label>\n    <div class=\"form-value\">\n      <input placeholder=\"Ancillary\"\n             ng-disabled=\"!showAncillaryLookup()\"\n             dynamic-name=\"{{ prefix }}_ancillary_product\"\n             type=\"text\"\n             class=\"form-control\"\n             ng-model=\"model.ancillary_product\"\n             typeahead=\"displayResult(product) for product in productLookup($viewValue, 'ancillary')\"\n             typeahead-on-select=\"selectAncillary($item)\"\n             typeahead-editable=\"false\"\n             apply-validators=\"validators\"\n             autocomplete=\"off\"\n      />\n      <div ng-if=\"loading.ancillary\">Searching...</div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 295 */
/***/ (function(module, exports) {

	module.exports = "<div\n    class=\"modal fade save-quote\"\n    id=\"save-quote\"\n    tabindex=\"-1\"\n    role=\"dialog\"\n    aria-labelledby=\"save-quote-label\"\n    data-backdrop=\"false\"\n>\n    <div class=\"modal-dialog\" role=\"document\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h1 class=\"modal-title\" id=\"save-quote-label\">Save Quote</h1>\n            </div>\n            <div class=\"modal-body\">\n                <form\n                    name=\"saveQuoteForm\"\n                    ng-submit=\"onSave(saveQuoteForm)\"\n                >\n                    <fieldset class=\"save-quote__fieldset\" ng-disabled=\"!!emailAndSMSRequired\">\n                        <table>\n                            <tbody>\n                            <tr>\n                                <td>Email:</td>\n                                <td>{{ applicant.contact.email_address || 'None' }}</td>\n                            </tr>\n                            <tr>\n                                <td>Mobile:</td>\n                                <td>{{ applicant.contact.phone_mobile || 'None' }}</td>\n                            </tr>\n                            </tbody>\n                        </table>\n\n                        <p ng-if=\"emailAndSMSRequired\">\n                            At least one of the options below must be selected before saving this quote:\n                        </p>\n\n                        <div class=\"form-group\">\n                            <div class=\"form-value\">\n                                <label class=\"control-label\">\n                                    <input type=\"checkbox\" ng-model=\"saveQuoteForm.sendEmail\" /> Send Email\n                                </label>\n                            </div>\n                            <div class=\"form-value\">\n                                <label class=\"control-label\">\n                                    <input type=\"checkbox\" ng-model=\"saveQuoteForm.sendSMS\" /> Send SMS\n                                </label>\n                            </div>\n                        </div>\n                    </fieldset>\n\n                    <fieldset ng-if=\"showAdditionDetails\" class=\"save-quote__fieldset\">\n                        <div class=\"form-group\">\n                            <div class=\"form-value\">\n                                <label class=\"control-label\" for=\"save-quote-yearly-saving\">\n                                    Expected yearly savings\n                                </label>\n                                <input\n                                    step=\"1\"\n                                    type=\"number\"\n                                    id=\"save-quote-yearly-saving\"\n                                    ng-model=\"saveQuoteForm.expectedYearlySavings\"\n                                    class=\"form-control\"\n                                />\n                            </div>\n                        </div>\n\n                        <p>\n                            At least one improved benefit must be supplied:\n                        </p>\n\n                        <div class=\"form-group\">\n                            <div class=\"form-value\">\n                                <label class=\"control-label\">Improved benefit 1</label>\n                                <input type=\"text\" class=\"form-control\" ng-model=\"saveQuoteForm.improvedBenefit1\" />\n                            </div>\n                        </div>\n\n                        <div class=\"form-group\">\n                            <div class=\"form-value\">\n                                <label class=\"control-label\">Improved benefit 2</label>\n                                <input type=\"text\" class=\"form-control\" ng-model=\"saveQuoteForm.improvedBenefit2\" />\n                            </div>\n                        </div>\n\n                        <div class=\"form-group\">\n                            <div class=\"form-value\">\n                                <label class=\"control-label\">Improved benefit 3</label>\n                                <input type=\"text\" class=\"form-control\" ng-model=\"saveQuoteForm.improvedBenefit3\" />\n                            </div>\n                        </div>\n\n                    </fieldset>\n\n                    <div class=\"save-quote__submit\">\n                        <button\n                            class=\"btn btn--secondary\"\n                            ng-disabled=\"!saveQuoteFormValid(saveQuoteForm)\">\n                            Save Quote\n                        </button>\n                    </div>\n                </form>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-default\" ng-click=\"onClose()\">\n                    Cancel\n                </button>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 296 */
/***/ (function(module, exports) {

	module.exports = "<tr ng-if=\"visibleServices.length\" class=\"header-row\">\n    <td>\n        <div class=\"product-result\">\n            <span ng-if=\"servicesSelected\">Selected</span><span\n                ng-if=\"!servicesSelected\">Unselected</span> {{ servicesLabel }}\n        </div>\n    </td>\n    <td ng-repeat=\"package in packages track by $id(package)\">\n        <div class=\"product-result\">\n            <div class=\"service-summary\">\n                <div class=\"service-summary--feature on-off\">\n                    <button class=\"btn btn--link\" ng-click=\"toggleShowing()\">\n                        <span ng-show=\"!open\">\n                            <i class=\"fa fa-caret-down\"></i>\n                            Show <span ng-if=\"servicesSelected\">selected</span><span\n                                ng-if=\"!servicesSelected\">unselected</span> {{ servicesLabel }}\n                        </span>\n                        <span ng-show=\"open\">\n                            <i class=\"fa fa-caret-up\"></i>\n                            Hide <span ng-if=\"servicesSelected\">selected</span><span\n                                ng-if=\"!servicesSelected\">unselected</span> {{ servicesLabel }}\n                        </span>\n                    </button>\n                </div>\n            </div>\n        </div>\n    </td>\n</tr>\n\n\n<tr ng-repeat=\"service in visibleServices\"\n    ng-class-odd=\"'odd'\" class=\"service-summary--feature on-off\" ng-if=\"open\">\n    <td>\n        <div class=\"service-summary--feature-container\">\n            <div class=\"product-result\">\n                {{ service.name }}\n            </div>\n        </div>\n    </td>\n\n    <td ng-repeat=\"package in packages track by $id(package)\"\n        ng-init=\"feature = package.features[features][service.id]\">\n\n        <div class=\"product-result\" ng-init=\"limits = getLimits(package, service); benefits = getBenefits(package, service)\">\n            <div class=\"service-summary\">\n                <div\n                  class=\"service-summary--feature service-summary--feature-container on-off\"\n                  ng-class=\"{\n                    'included':feature && !feature.excluded && !feature.unknown,\n                    'excluded':!feature || feature.excluded,\n                    'unknown':feature && feature.unknown,\n                    'limited':limits,\n                    'blp':feature.sis_limitation_period_months\n                  }\"\n                >\n                    <div>\n                        <span class=\"feature-label\" ng-class=\"{'not-first': !$first}\">{{ service.name }}</span>\n                        <i\n                            tooltip-html-unsafe=\"{{ benefits }}\"\n                            position-tooltip ng-if=\"feature && !feature.excluded && !feature.unknown\"\n                            class=\"fa fa-check\"\n                        ></i>\n                        <i ng-if=\"!feature || feature.excluded\" class=\"fa fa-times\"></i>\n                        <i ng-if=\"feature.unknown\" class=\"fa fa-question\"></i>\n                        <span ng-if=\"feature.sis_cover=='Restricted'\">\n                            Restricted <i tooltip-html-unsafe=\"{{ corporate.restricted_explanation }}\" position-tooltip class=\"glyphicon glyphicon-info-sign\"></i>\n                        </span>\n                        <span ng-if=\"feature.sis_limitation_period_months\">\n                            <b>BLP:</b> {{ feature.sis_limitation_period_months }} months\n                        </span>\n                        <span ng-if=\"limits\">\n                          <span ng-if=\"showPerPerson\">\n                            {{ limits.limit_per_person === null ? \"None\" : \"$\" + limits.limit_per_person }}\n                          </span>\n                          <span ng-if=\"showPerPolicy\">\n                            <span> / </span>{{ limits.limit_per_policy === null ? \"None\" : \"$\" + limits.limit_per_policy }}\n                          </span>\n                          <span ng-if=\"showPerService\">\n                            <span> / </span>{{ limits.limit_per_service === null ? \"None\" : \"$\" + limits.limit_per_service }}\n                          </span>\n                        </span>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n    </td>\n</tr>"

/***/ }),
/* 297 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"service-summary\">\n    <div class=\"service-summary--feature service-summary--feature-heading\" ng-if=\"featureHeading\">\n        <span class=\"feature-label\" feature-label>{{ featureHeading }}</span>\n    </div>\n    <div ng-repeat=\"service in servicesList|filter:{selected:servicesSelected}\"\n         ng-class-odd=\"'odd'\"\n         ng-init=\"feature = featuresList[service.id]\"\n         class=\"service-summary--feature on-off\"\n         ng-class=\"{'included':feature && !feature.excluded, 'excluded':!feature || feature.excluded}\">\n\n        <span class=\"feature-label\" ng-class=\"{'not-first': !$first}\" feature-label>\n            {{ service.name }}\n\n            <!-- Duplicated span - shown on mobile media -->\n            <span ng-if=\"feature.sis_cover=='Restricted'\" class=\"restricted-service--mobile\">\n                Restricted <i tooltip-html-unsafe=\"{{ corporate.restricted_explanation }}\" position-tooltip\n                              class=\"glyphicon glyphicon-info-sign\"></i>\n            </span>\n        </span>\n\n        <i ng-if=\"feature && !feature.excluded && (feature.sis_cover!='Restricted')\" class=\"fa fa-check\"></i>\n        <i ng-if=\"!feature || feature.excluded && (feature.sis_cover!='Restricted')\" class=\"fa fa-times\"></i>\n\n        <!-- Duplicated span - shown on larger media -->\n        <span ng-if=\"feature.sis_cover=='Restricted'\" class=\"restricted-service--desktop\">\n            Restricted <i tooltip-html-unsafe=\"{{ corporate.restricted_explanation }}\" position-tooltip\n                          class=\"glyphicon glyphicon-info-sign\"></i>\n        </span>\n    </div>\n</div>\n"

/***/ }),
/* 298 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"form-group\">\n  <label class=\"control-label\">Suburb</label>\n  <div class=\"form-value\">\n    <input placeholder=\"Suburb\"\n           type=\"text\"\n           class=\"form-control\"\n           ng-model=\"model.suburb\"\n           typeahead=\"s.suburb as displayResult(s, 'suburb') for s in suburbLookup('suburb', $viewValue)\"\n           typeahead-loading=\"loading\"\n           typeahead-on-select=\"resultSelect($item)\"/>\n  </div>\n</div>\n<div class=\"form-group\">\n  <label class=\"control-label\">Postcode</label>\n  <div class=\"form-value\">\n    <input placeholder=\"Postcode\"\n           type=\"number\"\n           class=\"form-control\"\n           ng-model=\"model.postcode\"\n           typeahead=\"s.postcode as displayResult(s, 'postcode') for s in suburbLookup('postcode', $viewValue)\"\n           typeahead-loading=\"loading\"\n           typeahead-on-select=\"resultSelect($item)\"\n           apply-validators=\"{'minlength':1, 'maxlength':4, 'required':true}\"\n           />\n  </div>\n</div>"

/***/ }),
/* 299 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container basic-page\">\n    <div class=\"row--narrow\">\n        {{ ctrl.message }}\n    </div>\n</div>\n"

/***/ }),
/* 300 */
/***/ (function(module, exports) {

	module.exports = "<app-scaffold>\n\n  <div ng-if=\"ctrl.corporate.is_operator\" class=\"version\">v{{ ctrl.version }}</div>\n\n  <div class=\"step-progress\" id=\"step-progress-header\">\n      <ul>\n          <li class=\"step-1\" ng-class=\"{'step-current': $state.includes('comparator.step1') || ($state.includes('comparator.step2') && ctrl.refine_pane_open),\n          'step-done': $state.includes('comparator.step3') ||  ($state.includes('comparator.step2') && !ctrl.refine_pane_open)}\">\n            <div class=\"step-content\">\n              <span class=\"step-number\">Step 1</span>\n              <span class=\"step-title\">{{ ctrl.corporate.aboutyou_step_title }}</span>\n              <button class=\"next-step\">&gt;</button>\n            </div>\n          </li>\n          <li class=\"step-2\" ng-class=\"{'step-current': $state.includes('comparator.step2') && !ctrl.refine_pane_open,\n              'step-done': $state.includes('comparator.step3')}\">\n            <div class=\"step-content\">\n              <button class=\"prev-step\">&lt;</button>\n              <span class=\"step-number\">Step 2</span>\n              <span class=\"step-title\">{{ ctrl.corporate.compare_step_title }}</span>\n              <button class=\"next-step\">&gt;</button>\n            </div>\n          </li>\n          <li class=\"step-3\" ng-class=\"{'step-current': $state.includes('comparator.step3'), 'step-done': !$state.includes('comparator.step1') &&\n              !$state.includes('comparator.step2') && !$state.includes('comparator.step3')}\">\n            <div class=\"step-content\">\n              <button class=\"prev-step\">&lt;</button>\n              <span class=\"step-number\">Step 3</span>\n              <span class=\"step-title\">{{ ctrl.corporate.apply_step_title }}</span>\n              <button class=\"next-step\">&gt;</button>\n            </div>\n          </li>\n      </ul>\n  </div>\n  <div class=\"help-section\">\n      <div class=\"container\">\n      <div class=\"row--narrow\">\n          <section ng-bind-html=\"ctrl.corporate.help_message\"></section>\n      </div>\n      </div>\n  </div>\n  <div class=\"step-banner\" style=\"display:none\">\n    <div class=\"container\">\n      <div class=\"row--narrow step-banner--text\" ng-hide=\"!$state.includes('comparator.step1')\">\n        <h2>{{ ctrl.corporate.aboutyou_title }}</h2>\n        <p ng-if=\"ctrl.corporate.aboutyou_blurb\" ng-bind-html=\"ctrl.corporate.aboutyou_blurb\"></p>\n      </div>\n      <div class=\"row--narrow step-banner--text\" ng-hide=\"!$state.includes('comparator.step2')\">\n        <h2>{{ ctrl.corporate.compare_title }}</h2>\n        <p ng-if=\"ctrl.corporate.compare_blurb\" ng-bind-html=\"ctrl.corporate.compare_blurb\"></p>\n      </div>\n      <div class=\"row--narrow step-banner--text\" ng-hide=\"!$state.includes('comparator.step3')\">\n        <h2>{{ ctrl.corporate.apply_title }}</h2>\n        <p ng-if=\"ctrl.corporate.apply_blurb\" ng-bind-html=\"ctrl.corporate.apply_blurb\"></p>\n      </div>\n      <div class=\"row--narrow step-banner--text\" ng-hide=\"!$state.includes('comparator.step4')\">\n        <h2>Thank You</h2>\n      </div>\n    </div>\n  </div>\n\n  <div id=\"ui-view\" ui-view></div>\n\n</app-scaffold>"

/***/ }),
/* 301 */
/***/ (function(module, exports) {

	module.exports = "<form class=\"comparator-form\" name=\"ctrl.step1Form\" ng-submit=\"ctrl.onSubmit(ctrl.step1Form)\" ng-submit-force=\"true\" novalidate remove-external-validation-errors-on-submit=\"false\" focus-invalid>\n\n    <div class=\"container\">\n      <div class=\"row--narrow\">\n        <div class=\"form-group has-tooltip\">\n            <label for=\"step1-who\" class=\"control-label\">\n                {{ ctrl.corporate.questionConfig['step_1_who_caption'] }}\n                <i ng-if=\"ctrl.corporate.questionConfig['step_1_who_description']\"\n                   tooltip-html-unsafe=\"{{ ctrl.corporate.questionConfig['step_1_who_description'] }}\" position-tooltip\n                   class=\"glyphicon glyphicon-info-sign\"></i>\n            </label>\n            <div class=\"form-value\">\n                <select id=\"step1-who\" class=\"form-control\" required\n                        ng-model=\"ctrl.application.policy.membership_type\" name=\"membership_type\"\n                        ng-change=\"ctrl.onMembershipTypeChange()\"\n                        ng-options=\"item[0] as item[1] for item in ctrl.formChoices.membership_type\">\n                    <option value=\"\">-- Please select --</option>\n                </select>\n            </div>\n        </div>\n\n        <div class=\"form-group\" ng-if=\"ctrl.corporate.ask_if_current_cover\">\n            <span class=\"faux-label control-label\">Do you currently have health insurance?</span>\n            <div class=\"form-value\">\n                <div class=\"input-group\">\n                    <label class=\"radio-inline\">\n                        <input required type=\"radio\"\n                               ng-model=\"ctrl.application.personal.previous_fund.has_previous_fund\" ng-value=\"true\"/>Yes\n                    </label>\n                    <label class=\"radio-inline\">\n                        <input required type=\"radio\"\n                               ng-model=\"ctrl.application.personal.previous_fund.has_previous_fund\" ng-value=\"false\"/>No\n                    </label>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"form-group has-tooltip\" >\n            <label for=\"step1-why\" class=\"control-label\">\n                {{ ctrl.corporate.questionConfig['step_1_why_caption'] }}\n                <i ng-if=\"ctrl.corporate.questionConfig['step_1_why_description']\"\n                   tooltip-html-unsafe=\"{{ ctrl.corporate.questionConfig['step_1_why_description'] }}\" position-tooltip\n                   class=\"glyphicon glyphicon-info-sign\"></i>\n            </label>\n            <div class=\"form-value\">\n                <select\n                    id=\"step1-why\"\n                    class=\"form-control\"\n                    required\n                    name=\"motivation\"\n                    ng-model=\"ctrl.application.policy.motivation\"\n                    ng-options=\"item[0] as item[1] for item in ctrl.application.motivationChoices()\"\n                    ng-disabled=\"!ctrl.hasAnsweredCurrentFund()\"\n                >\n                    <option value=\"\">-- Please select --</option>\n                </select>\n            </div>\n        </div>\n\n          <div ng-if=\"ctrl.corporate.capture_date_of_birth\">\n              <div class=\"form-group has-tooltip\">\n                  <label for=\"step1-dob\" class=\"control-label\">\n                    {{ ctrl.corporate.questionConfig['step_1_date_of_birth_caption'] }}\n                      <i ng-if=\"ctrl.corporate.questionConfig['step_1_date_of_birth_description']\"\n                         tooltip-html-unsafe=\"{{ ctrl.corporate.questionConfig['step_1_date_of_birth_description'] }}\"\n                         position-tooltip\n                         class=\"glyphicon glyphicon-info-sign\"></i>\n                  </label>\n\n                  <div class=\"form-value\">\n                      <div aon-date id=\"step1-dob\"\n                           name=\"dob\"\n                           over-eighteen=\"true\"\n                           ng-model=\"ctrl.application.personal.dob\"\n                           ng-model-options=\"{updateOn: 'blur'}\"\n                           apply-validators=\"{ 'error_messages': {'underage':'Must be 18 years of age or older'}}\"></div>\n                  </div>\n              </div>\n              <!-- For couples/families, need partner DOB for LHC calculation -->\n              <div class=\"form-group has-tooltip\"\n                   ng-if=\"ctrl.application.hasPartner()\">\n                  <label for=\"step1-partner-dob\" class=\"control-label\">\n                    {{ ctrl.corporate.questionConfig['step_1_partner_date_of_birth_caption'] }}\n                      <i ng-if=\"ctrl.corporate.questionConfig['step_1_partner_date_of_birth_description']\"\n                         tooltip-html-unsafe=\"{{ ctrl.corporate.questionConfig['step_1_partner_date_of_birth_description'] }}\"\n                         position-tooltip\n                         class=\"glyphicon glyphicon-info-sign\"></i>\n                  </label>\n\n                  <div class=\"form-value\">\n                      <div aon-date id=\"step1-partner-dob\"\n                           name=\"partner-dob\"\n                           over-eighteen=\"true\"\n                           ng-model=\"ctrl.application.partner.dob\"\n                           ng-model-options=\"{updateOn: 'blur'}\"\n                           apply-validators=\"{ 'error_messages': {'underage':'Must be 18 years of age or older'}}\">\n                      </div>\n                  </div>\n              </div>\n          </div>\n\n          <div ng-if=\"ctrl.corporate.capture_age\">\n              <div class=\"form-group has-tooltip\">\n                  <label for=\"step1-age\" class=\"control-label\">\n                    {{ ctrl.corporate.questionConfig['step_1_age_caption'] }}\n                      <i ng-if=\"ctrl.corporate.questionConfig['step_1_age_description']\"\n                         tooltip-html-unsafe=\"{{ ctrl.corporate.questionConfig['step_1_age_description'] }}\"\n                         position-tooltip\n                         class=\"glyphicon glyphicon-info-sign\"></i>\n                  </label>\n\n                  <div class=\"form-value\">\n                      <input type=\"number\"\n                             class=\"form-control\"\n                             id=\"step1-age\"\n                             name=\"age\"\n                             step=\"1\"\n                             min=\"{{ ctrl.formChoices.age_capture_validation.min }}\"\n                             max=\"{{ ctrl.formChoices.age_capture_validation.max }}\"\n                             required\n                             apply-validators=\"ctrl.formChoices.age_capture_validation\"\n                             ng-model=\"ctrl.application.personal.age\"\n                             ng-model-options=\"{updateOn: 'blur'}\"\n                             ng-change=\"ctrl.onAgeChange(ctrl.application.personal)\" />\n                  </div>\n              </div>\n              <!-- For couples/families, need partner age for LHC calculation -->\n              <div class=\"form-group has-tooltip\"\n                   ng-if=\"ctrl.application.hasPartner()\">\n                  <label for=\"step1-partner-age\" class=\"control-label\">\n                    {{ ctrl.corporate.questionConfig['step_1_partner_age_caption'] }}\n                      <i ng-if=\"ctrl.corporate.questionConfig['step_1_partner_age_description']\"\n                         tooltip-html-unsafe=\"{{ ctrl.corporate.questionConfig['step_1_partner_age_description'] }}\"\n                         position-tooltip\n                         class=\"glyphicon glyphicon-info-sign\"></i>\n                  </label>\n\n                  <div class=\"form-value\">\n                      <input type=\"number\"\n                             class=\"form-control\"\n                             id=\"step1-partner-age\"\n                             name=\"partner-age\"\n                             step=\"1\"\n                             min=\"{{ ctrl.formChoices.age_capture_validation.min }}\"\n                             max=\"{{ ctrl.formChoices.age_capture_validation.max }}\"\n                             required\n                             apply-validators=\"ctrl.formChoices.age_capture_validation\"\n                             ng-model=\"ctrl.application.partner.age\"\n                             ng-model-options=\"{updateOn: 'blur'}\"\n                             ng-change=\"ctrl.onAgeChange(ctrl.application.partner)\" />\n                  </div>\n              </div>\n          </div>\n\n        <div class=\"form-group has-tooltip\">\n            <label for=\"step1-state\" class=\"control-label\">\n                {{ ctrl.corporate.questionConfig['step_1_state_caption'] }}\n                <i ng-if=\"ctrl.corporate.questionConfig['step_1_state_description']\"\n                   tooltip-html-unsafe=\"{{ ctrl.corporate.questionConfig['step_1_state_description'] }}\" position-tooltip\n                   class=\"glyphicon glyphicon-info-sign\"></i>\n            </label>\n            <div class=\"form-value\">\n                <select id=\"step1-state\" class=\"form-control\" required\n                        ng-model=\"ctrl.application.primary_address.state\" name=\"state\"\n                        ng-options=\"item[0] as item[1] for item in ctrl.formChoices.state\">\n                    <option value=\"\">-- Please select --</option>\n                </select>\n            </div>\n        </div>\n        <div class=\"form-group has-tooltip\" ng-class=\"{'has-success':ctrl.formChoices.cover_type.length==1}\">\n            <label for=\"step1-cover_type\" class=\"control-label\">\n                {{ ctrl.corporate.questionConfig['step_1_type_of_cover_caption'] }}\n                <i ng-if=\"ctrl.corporate.questionConfig['step_1_type_of_cover_description']\"\n                   tooltip-html-unsafe=\"{{ ctrl.corporate.questionConfig['step_1_type_of_cover_description'] }}\" position-tooltip\n                   class=\"glyphicon glyphicon-info-sign\"></i>\n            </label>\n            <div class=\"form-value\">\n                <select id=\"step1-cover_type\" class=\"form-control\" required\n                        ng-model=\"ctrl.application.policy.cover_type\" name=\"cover_type\"\n                        ng-options=\"item[0] as item[1] for item in ctrl.formChoices.cover_type\">\n                    <option ng-if=\"ctrl.formChoices.cover_type.length > 1\" value=\"\">-- Please select --</option>\n                </select>\n            </div>\n        </div>\n\n          <div ng-if=\"ctrl.corporate.show_previous_fund_list && ctrl.application.personal.previous_fund.has_previous_fund\">\n              <div class=\"form-group\">\n                  <label class=\"control-label\">Current Health Fund</label>\n\n                  <div class=\"form-value\">\n                      <select required class=\"form-control\"\n                              dynamic-name=\"fund_id\"\n                              ng-model=\"ctrl.application.personal.previous_fund.fund_id\"\n                              ng-options=\"f.id as f.title group by f.group for f in ctrl.formChoices.previous_fund | orderBy:['group']\">\n                          <option value=\"\">-- Select Health Fund --</option>\n                      </select>\n                  </div>\n              </div>\n          </div>\n\n\n      </div>\n    </div>\n    <div class=\"section-highlight\">\n      <div class=\"container\">\n        <div class=\"row--narrow\">\n          <div class=\"form-group step1-rebate has-tooltip\" >\n\n               <label for=\"apply_for_rebate\" class=\"control-label\">\n                {{ ctrl.corporate.questionConfig['step_1_rebate_caption'] }}\n                <i ng-if=\"ctrl.corporate.questionConfig['step_1_rebate_description']\"\n                   tooltip-html-unsafe=\"{{ ctrl.corporate.questionConfig['step_1_rebate_description'] }}\" position-tooltip\n                   class=\"glyphicon glyphicon-info-sign\"></i>\n               </label>\n\n            <div class=\"input-group\">\n              <label class=\"radio-inline\">\n                <input type=\"radio\" ng-model=\"ctrl.application.policy.federal_rebate\" name=\"apply_for_rebate\" ng-value=\"true\" required> Yes\n              </label>\n              <label class=\"radio-inline\">\n                <input type=\"radio\" ng-model=\"ctrl.application.policy.federal_rebate\" name=\"apply_for_rebate\" ng-value=\"false\" required> No\n              </label>\n            </div>\n          </div>\n          <div class=\"form-group has-tooltip\" ng-if=\"ctrl.application.policy.federal_rebate\">\n\n              <label for=\"contact--rebate-tier\" class=\"control-label\">\n                  {{ ctrl.rebate_tier_caption }}\n                <i ng-if=\"ctrl.rebate_tier_description\"\n                   tooltip-html-unsafe=\"{{ ctrl.rebate_tier_description }}\" position-tooltip\n                   class=\"glyphicon glyphicon-info-sign\"></i>\n               </label>\n\n            <div class=\"form-value\">\n              <select\n                required\n                id=\"contact--rebate-tier\" name=\"policy.rebate_tier\" class=\"form-control\" ng-model=\"ctrl.application.policy.rebate_tier\"\n                ng-options=\"item[0] as item[1] for item in ctrl.rebate_tier_choices\">\n                <option value=\"\">-- Select Tier --</option>\n              </select>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div ng-if=\"ctrl.offerCompetition\" class=\"container step1-competition\">\n        <div class=\"row--narrow\">\n          <div class=\"form-group has-tooltip\" >\n              <label for=\"enter_comp\" class=\"control-label\">\n                  {{ ctrl.corporate.questionConfig['step_1_competition_invite_caption'] }}\n                  <i ng-if=\"ctrl.corporate.questionConfig['step_1_competition_invite_description']\"\n                   tooltip-html-unsafe=\"{{ ctrl.corporate.questionConfig['step_1_competition_invite_description'] }}\" position-tooltip\n                   class=\"glyphicon glyphicon-info-sign\"></i>\n              </label>\n              <div class=\"input-group\">\n                  <label class=\"radio-inline\">\n                      <input type=\"checkbox\" ng-model=\"ctrl.enter_competition\" name=\"enter_comp\" />\n                  </label>\n              </div>\n          </div>\n            <div class=\"form-group\" ng-if=\"ctrl.enter_competition\">\n                <div class=\"form-group\">\n                    <span class=\"faux-label control-label\">Name</span>\n\n                    <div class=\"form-value\">\n                        <input id=\"step1-comp-name\" class=\"form-control\" type=\"text\"\n                               class=\"form-control\" placeholder=\"Name\" name=\"name\" ng-model=\"ctrl.application.personal.first_name\"\n                               required/>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <span class=\"faux-label control-label\">Mobile Phone</span>\n\n                    <div class=\"form-value\">\n                        <input id=\"step1-comp-phone\" class=\"form-control\" type=\"text\"\n                               placeholder=\"Phone Number\" name=\"phone\" class=\"form-control\"\n                               ng-model=\"ctrl.application.contact.phone_mobile\"\n                               required />\n                    </div>\n\n                </div>\n\n                <div class=\"form-group\">\n                    <span class=\"faux-label control-label\">Email</span>\n\n                    <div class=\"form-value\">\n                        <input id=\"step1-comp-email\" class=\"form-control\" type=\"email\"\n                               placeholder=\"Email\" name=\"email\" class=\"form-control\"\n                               ng-model=\"ctrl.application.contact.email_address\"\n                               required />\n                    </div>\n                </div>\n\n                <div>\n                    Competition Terms and Conditions\n                    <i tooltip-html-unsafe=\"{{ ctrl.corporate.competition_terms_and_conditions }}\" position-tooltip\n                       class=\"glyphicon glyphicon-info-sign\"></i>\n                </div>\n            </div>\n        </div>\n      </div>\n\n    <div class=\"container\">\n        <div class=\"row--narrow\">\n            <div class=\"form-group step1-terms\">\n                <span class=\"faux-label control-label\">&nbsp;</span>\n\n                <div class=\"form-value\">\n                    <label>\n                        <input type=\"checkbox\" ng-model=\"ctrl.application.policy.accepted_terms\" name=\"accepted_terms\"\n                               required disable-validation-message=\"\">\n\n                        <span id=\"terms_and_conditions\"></span>\n\n                        <div id=\"terms-custom-error\"\n                             class=\"help-block has-error error-msg\"\n                             ng-if=\"ctrl.step1Form.accepted_terms.$error.required\">\n                            This field is required\n                        </div>\n                    </label>\n                </div>\n            </div>\n        </div>\n    </div>\n\n        <footer>\n            <button class=\"btn btn--primary\">{{ ctrl.corporate.aboutyou_button_text }}</button>\n        </footer>\n\n</form>\n\n\n\n<div class=\"modal terms-and-conditions large\" id=\"myModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\">\n    <div class=\"modal-dialog\" role=\"document\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span\n                        aria-hidden=\"true\">&times;</span></button>\n                <h1 class=\"modal-title\" id=\"myModalLabel\">Terms and Conditions</h1>\n            </div>\n            <div class=\"modal-body\">\n                <div class=\"basic-page\">\n                    <div class=\"row--narrow\">\n                        <section ng-include=\"ctrl.deployment.legal\"></section>\n                    </div>\n                </div>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 302 */
/***/ (function(module, exports) {

	module.exports = "<debug-overlay ng-if=\"ctrl.debugOverlay\" packages=\"ctrl.packages\"></debug-overlay>\n\n<div class=\"refine-results\">\n  <div class=\"refine-results--closed\" ng-hide=\"ctrl.isRefinePaneOpen\">\n    <p ng-bind-html=\"ctrl.corporate.refine_results_closed_message\"></p>\n    <button class=\"btn refine-results--btn\" ng-click=\"ctrl.openRefinePane()\">{{ ctrl.corporate.refine_results_open_text }}</button>\n  </div>\n  <div id=\"refine\" class=\"refine-results--opened\" ng-show=\"ctrl.isRefinePaneOpen\">\n    <form class=\"comparator-form\">\n      <div class=\"form-section-header\">Select the items that are important to you:</div>\n      <div class=\"refine-hospital\" ng-if=\"ctrl.requiresHospitalProducts\">\n        <span class=\"faux-label\">Hospital</span>\n        <ul class=\"refine--left\">\n          <li ng-repeat=\"service in ctrl.servicesInColumns.hospital.left | orderBy:'-sort_order'\" ng-class=\"{'checked': service.selected}\">\n            <label><input type=\"checkbox\" ng-model=\"service.selected\"/>{{ service.name }}\n                <i ng-if=\"service.description\"\n                   tooltip-html-unsafe=\"{{ service.description }}\" position-tooltip\n                   class=\"glyphicon glyphicon-info-sign\"></i>\n            </label>\n          </li>\n        </ul>\n        <ul class=\"refine--right\">\n          <li ng-repeat=\"service in ctrl.servicesInColumns.hospital.right | orderBy:'-sort_order'\" ng-class=\"{'checked': service.selected}\">\n            <label><input type=\"checkbox\" ng-model=\"service.selected\"/>{{ service.name }}\n            <i ng-if=\"service.description\"\n               tooltip-html-unsafe=\"{{ service.description }}\" position-tooltip tooltip-append-to-body\n               class=\"glyphicon glyphicon-info-sign\"></i></label>\n          </li>\n        </ul>\n      </div>\n      <div class=\"refine-ancillary\"  ng-if=\"ctrl.requiresAncillaryProducts\">\n        <span class=\"faux-label\">Extras</span>\n        <ul class=\"refine--left\">\n          <li ng-repeat=\"service in ctrl.servicesInColumns.ancillary.left | orderBy:'-sort_order'\" ng-class=\"{'checked': service.selected}\">\n            <label><input type=\"checkbox\" ng-model=\"service.selected\"/>{{ service.name }}\n            <i ng-if=\"service.description\"\n                   tooltip-html-unsafe=\"{{ service.description }}\" position-tooltip tooltip-append-to-body\n                   class=\"glyphicon glyphicon-info-sign\"></i></label>\n          </li>\n        </ul>\n        <ul class=\"refine--right\">\n          <li ng-repeat=\"service in ctrl.servicesInColumns.ancillary.right | orderBy:'-sort_order'\" ng-class=\"{'checked': service.selected}\">\n            <label><input type=\"checkbox\" ng-model=\"service.selected\"/>{{ service.name }}\n            <i ng-if=\"service.description\"\n                   tooltip-html-unsafe=\"{{ service.description }}\" position-tooltip tooltip-append-to-body\n                   class=\"glyphicon glyphicon-info-sign\"></i></label>\n          </li>\n        </ul>\n      </div>\n      <footer>\n        <button class=\"btn btn--primary\" ng-click=\"ctrl.refine()\" button-loading-indicator=\"ctrl.isLoadingResults\">\n            {{ ctrl.results_pane_continue_text  }}\n        </button>\n      </footer>\n    </form>\n  </div>\n</div>\n\n<!-- ng-if=\"ctrl.operator.operator_type == 'zoho'\" -->\n<div class=\"comparator-results-container\">\n\n    <div class=\"comparator-results\" ng-if=\"!ctrl.isRefinePaneOpen\">\n\n        <!-- The desktop version of the pagination controls (hidden on tablet/mobile) -->\n        <div class=\"scroll-outer\">\n            <div>&nbsp;</div><!-- horizontal padding -->\n            <div class=\"scroll-control\" ng-if=\"ctrl.displayState.totalResults\">\n                <div>\n                    <a ng-if=\"ctrl.canScrollLeft()\" ng-click=\"ctrl.onScrollLeft()\" class=\"page-control left\" ng-disabled=\"ctrl.isLoadingResults\"><span class=\"glyphicon glyphicon-chevron-left\"></span>&nbsp;Previous&nbsp;options</a>\n                </div>\n                <div>\n                    <a ng-if=\"ctrl.canScrollRight()\" ng-click=\"ctrl.onScrollRight()\" class=\"page-control right\" ng-disabled=\"ctrl.isLoadingResults\">More&nbsp;options&nbsp;<span class=\"glyphicon glyphicon-chevron-right\"></span></a>\n                </div>\n            </div>\n        </div>\n        <!-- end pagination controls -->\n\n        <div id=\"your-details\" class=\"your-details\">\n            <div>\n                <div class=\"heading\">Your details:</div>\n                <ul>\n                    <li>{{ ctrl.applicant.displayValues.membership_type }}</li>\n                    <li>{{ ctrl.applicant.displayValues.cover_type }}</li>\n                    <li>Living in {{ ctrl.applicant.displayValues.state }}</li>\n                    <li>{{ ctrl.applicant.displayValues.age }} years old</li>\n                    <li>\n                        <span ng-if=\"ctrl.applicant.policy.federal_rebate\">Federal Rebate: {{ (100*ctrl.applicant.policy.rebatePercentage).toFixed(2) }}%</span>\n                        <span ng-if=\"!ctrl.applicant.policy.federal_rebate\">No Govt. Rebate Applied</span>\n                    </li>\n                    <li><a ui-sref=\"comparator.step1\">Change your details</a></li>\n                    <li ng-if=\"ctrl.corporate.is_email_quote_active\">\n                        <button class=\"btn btn--primary\" ng-click=\"ctrl.emailQuoteRequested = true\">\n                            {{ ctrl.corporate.email_quote_button_text }}\n                            <i ng-if=\"ctrl.corporate.email_quote_button_description\"\n                               tooltip-html-unsafe=\"{{ ctrl.corporate.email_quote_button_description }}\" position-tooltip\n                               class=\"glyphicon glyphicon-info-sign\"></i>\n                        </button>\n                        <div ng-if=\"ctrl.emailQuoteRequested\">\n                            <form name=\"ctrl.emailQuoteForm\"\n                                  ng-submit=\"ctrl.emailQuote(ctrl.emailQuoteForm)\"\n                                  ng-submit-force=\"true\" novalidate remove-external-validation-errors-on-submit=\"false\"\n                                  focus-invalid>\n                                <div class=\"form-group\">\n                                    <div class=\"form-value input-group\">\n                                        <input placeholder=\"Email address\" type=\"email\" id=\"personal--email\"\n                                               name=\"contact.email\"\n                                               class=\"form-control\" ng-model=\"ctrl.applicant.contact.email_address\"\n                                               required/>\n                                      <span class=\"input-group-btn\">\n                                        <input type=\"submit\" value=\"Send\" class=\"btn\"/>\n                                      </span>\n                                    </div>\n                                </div>\n                            </form>\n                            <div ng-if=\"ctrl.emailQuoteSendResult.attempted\">\n                                <span ng-if=\"!ctrl.emailQuoteSendResult.error\" class=\"email-success\">Thank you, an email has been sent</span>\n                                <span ng-if=\"ctrl.emailQuoteSendResult.error\" class=\"email-warning\">There was an error emailing your comparison</span>\n                            </div>\n                        </div>\n                    </li>\n                </ul>\n            </div>\n        </div>\n        <div class=\"product-loading\" ng-show=\"ctrl.isLoadingResults\">\n            <h4 ng-show=\"!ctrl.isFetchingPage\">Just a moment, we are adjusting the results based on your selections</h4>\n            <img src=\"/static/images/ring.gif\"/>\n        </div>\n        <div class=\"product-loading\" ng-show=\"ctrl.packages.length == 0\">\n            <h4>There are no products available that match the selected items. Please re-select items and try\n                again.</h4>\n        </div>\n        <!-- Only want to flag last column if there are at least 3 items -->\n\n        <div class=\"product-fund\"\n             ng-hide=\"ctrl.isLoadingResults\"\n             ng-class=\"{'first-column': $first, 'last-column': ($last && $index >= 2)}\"\n             ng-repeat=\"package in ctrl.viewingPackages() track by $id(package)\">\n\n            <!-- The tablet/mobile version of the pagination controls (hidden on desktop) -->\n            <div ng-if=\"$first || $last\" class=\"scroll-outer mobile\">\n                <div>&nbsp;</div><!-- horizontal padding -->\n                <div class=\"scroll-control\" ng-if=\"ctrl.displayState.totalResults\">\n                    <div ng-show=\"$first\">\n                        <a ng-if=\"ctrl.canScrollLeft()\" ng-click=\"ctrl.onScrollLeft()\" class=\"page-control left\"\n                           ng-disabled=\"ctrl.isLoadingResults\"><span class=\"glyphicon glyphicon-chevron-left\"></span>&nbsp;Previous&nbsp;options</a>\n                    </div>\n                    <div ng-show=\"$last\">\n                        <a ng-if=\"ctrl.canScrollRight()\" ng-click=\"ctrl.onScrollRight()\" class=\"page-control right\"\n                           ng-disabled=\"ctrl.isLoadingResults\">More&nbsp;options&nbsp;<span\n                                class=\"glyphicon glyphicon-chevron-right\"></span></a>\n                    </div>\n                </div>\n            </div>\n            <!-- end pagination controls -->\n\n            <div>\n                <div class=\"product-fund--image\">\n                    <img ng-src=\"{{ package.fund.logo }}\">\n                </div>\n                <div class=\"product-cost\">\n                    <span class=\"product-cost--amount\">{{ package.selectedPrice.pricing.available.monthly_adjusted_price.premium | currency }}</span>\n                    <span class=\"product-cost--frequency\">per month</span>\n                    <product-extra-information package=\"package\" placement=\"price_adjacent\"></product-extra-information>\n                </div>\n                <div ng-init=\"offers = ctrl.packageFundOffers(package.fund)\">\n                    <div ng-if=\"offers.length\" class=\"fund-price-offer\">\n                        <div class=\"heading\" ng-repeat=\"offer in offers\">\n                            <span ng-bind-html=\"offer.caption\"></span>\n                            <i tooltip-html-unsafe=\"{{ offer.offer }}\" position-tooltip\n                               class=\"glyphicon glyphicon-info-sign\"></i>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"product-excess\" ng-if=\"ctrl.applicant.requiresHospitalProducts()\">\n                    <div class=\"heading\">\n                        Excess\n                        <i ng-if=\"ctrl.corporate.excess_explanation.length\"\n                           tooltip-html-unsafe=\"{{ ctrl.corporate.excess_explanation }}\" position-tooltip\n                           class=\"glyphicon glyphicon-info-sign\"></i>\n                        <product-extra-information package=\"package\" placement=\"excess_adjacent\"></product-extra-information>\n                    </div>\n                    <ul class=\"product-excess--options\">\n                        <li\n                          ng-repeat=\"price in package.prices track by price.id\"\n                          ng-init=\"isClosed = ctrl.isProductClosed(price)\"\n                        >\n                            <label ng-class=\"{closed: isClosed}\">\n                              <input\n                                type=\"radio\"\n                                name=\"{{ package.id }}_product-excess\"\n                                ng-value=\"price\"\n                                ng-model=\"package.selectedPrice\"\n                              />\n                              {{ price.excess | nocents }}\n                              <span ng-if=\"isClosed\">CLOSED</span>\n                            </label>\n                        </li>\n                        <!-- This is just to make excess info take same vertical space across responsive columns -->\n                        <li ng-repeat=\"n in package.fillerPrices\">&nbsp;</li>\n                    </ul>\n                </div>\n                <footer>\n                    <!-- Issues with buttonLoadingIndicator and ng-disabled, so using separate definitions here -->\n                    <button ng-if=\"ctrl.corporate.disable_apply_button\"\n                            ng-disabled=\"ctrl.corporate.disable_apply_button\"\n                            class=\"btn btn--primary\">\n                        {{ ctrl.corporate.compare_button_text }}<span>  &gt;</span>\n                        <span ng-if=\"ctrl.corporate.disable_apply_button\"><br><i>(disabled)</i></span>\n                    </button>\n                    <button ng-if=\"!ctrl.corporate.disable_apply_button\"\n                            ng-click=\"ctrl.apply(package.selectedPrice, package)\"\n                            button-loading-indicator=\"package.isTransitioningToApply\"\n                            class=\"btn btn--primary\">\n                        {{ ctrl.corporate.compare_button_text }}<span>  &gt;</span>\n                    </button>\n                </footer>\n            </div>\n\n            <div>\n                <div class=\"summary-header\">\n                    <div class=\"product-name\">\n                        <span ng-if=\"package.hospital_product.name.length\">{{ package.hospital_product.name }}</span>\n                        <span ng-if=\"package.ancillary_product.name.length && !package.hospital_product.name.length\">{{ package.ancillary_product.name }}</span>\n                    </div>\n\n                    <div class=\"product-documents-list\">\n                        <ul>\n                            <li ng-repeat=\"d in package.documents\">\n                                <a target=\"_blank\" href=\"{{ d[1] }}\">{{ d[0] }}</a>\n                            </li>\n                        </ul>\n                    </div>\n                </div>\n            </div>\n\n\n            <!-- HOSPITAL SERVICE LIST -->\n            <div ng-if=\"ctrl.requiresHospitalProducts\">\n                <div\n                        services-feature-list\n                        services-list=\"ctrl.services.hospital\"\n                        services-selected=\"true\"\n                        features-list=\"package.features.hospital\"\n                        corporate=\"ctrl.corporate\"\n                        feature-heading=\"Hospital\"></div>\n\n                <div class=\"unselected-service-summary\">\n                    <button class=\"btn btn--link\" ng-click=\"ctrl.toggleUnselectedServiceSummary(package, 'hospital')\">\n            <span ng-show=\"!package.showUnselectedServices['hospital']\">\n              <i class=\"fa fa-caret-down\"></i>\n              Show unselected hospital items\n            </span>\n            <span ng-show=\"package.showUnselectedServices['hospital']\">\n              <i class=\"fa fa-caret-up\"></i>\n              Hide unselected hospital items\n            </span>\n                    </button>\n                </div>\n\n                <div ng-if=\"package.showUnselectedServices['hospital']\"\n                     services-feature-list\n                     services-list=\"ctrl.services.hospital\"\n                     services-selected=\"false\"\n                     corporate=\"ctrl.corporate\"\n                     features-list=\"package.features.hospital\"></div>\n            </div>\n\n            <!-- ANCILLARY SERVICE LIST -->\n            <div ng-if=\"ctrl.requiresAncillaryProducts\">\n                <div\n                        services-feature-list\n                        services-list=\"ctrl.services.ancillary\"\n                        services-selected=\"true\"\n                        features-list=\"package.features.ancillary\"\n                        corporate=\"ctrl.corporate\"\n                        feature-heading=\"Extras\"></div>\n\n                <div class=\"unselected-service-summary\">\n                    <button class=\"btn btn--link\" ng-click=\"ctrl.toggleUnselectedServiceSummary(package, 'ancillary')\">\n            <span ng-show=\"!package.showUnselectedServices['ancillary']\">\n              <i class=\"fa fa-caret-down\"></i>\n              Show unselected extras\n            </span>\n            <span ng-show=\"package.showUnselectedServices['ancillary']\">\n              <i class=\"fa fa-caret-up\"></i>\n              Hide unselected extras\n            </span>\n                    </button>\n                </div>\n\n                <div ng-if=\"package.showUnselectedServices['ancillary']\"\n                     services-feature-list\n                     services-list=\"ctrl.services.ancillary\"\n                     services-selected=\"false\"\n                     corporate=\"ctrl.corporate\"\n                     features-list=\"package.features.ancillary\"></div>\n            </div>\n\n        </div>\n    </div>\n</div>\n\n\n<div class=\"modal large\" id=\"fund-offers-modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"fund-offers-modal\">\n    <div class=\"modal-dialog\" role=\"document\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span\n                        aria-hidden=\"true\">&times;</span></button>\n                <h1 class=\"modal-title\" id=\"fund-offers-modal\">Special Offers</h1>\n            </div>\n            <div class=\"modal-body\">\n                <div class=\"basic-page\" ng-init=\"offers = ctrl.fundPopupOffers()\">\n                    <div ng-repeat=\"offer in offers\" class=\"row--narrow\">\n                        <div ng-bind-html=\"offer\"></div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 303 */
/***/ (function(module, exports) {

	module.exports = "<div ng-include=\"ctrl.rebateScript\"></div>\n"

/***/ }),
/* 304 */
/***/ (function(module, exports) {

	module.exports = "<form class=\"comparator-form\" name=\"ctrl.step3Form\"\n      ng-submit=\"ctrl.onSubmit(ctrl.step3Form)\"\n      ng-submit-force=\"true\" novalidate\n      remove-external-validation-errors-on-submit=\"false\" focus-invalid>\n\n\n    <div class=\"container\">\n      <div class=\"row--narrow\">\n          <div\n              ng-if=\"ctrl.corporate.show_application_product_summary\"\n              ng-include=\"'/static/application-product-summary.html'\"\n          ></div>\n\n          <div ng-if=\"ctrl.showApplicationForm\">\n            <div ui-view></div>\n\n              <div ng-if=\"ctrl.previewXML.length\" class=\"xml-preview\">\n                  <pre>{{ ctrl.previewXML }}</pre>\n              </div>\n              <div ng-if=\"ctrl.bailedOut\" class=\"xml-preview\">\n                  <pre>{{ ctrl.debugTrace }}</pre>\n              </div>\n              <div\n                  ng-if=\"!!ctrl.fundScript\"\n                  ng-bind-html=\"ctrl.fundScript\"\n                  model=\"ctrl.application.fund_script_responses\"\n              ></div>\n              <corporate-script\n                  ng-if=\"ctrl.showEndOfApplicationScript\"\n                  model=\"ctrl.application.corporate_script_responses\"\n              ></corporate-script>\n              <footer>\n                  <button type=\"button\" ng-click=\"ctrl.saveApplicationState()\" ng-if=\"!ctrl.corporate.is_preview && ctrl.application.zoho_id && ctrl.corporate.is_operator\" class=\"btn btn--primary\" button-loading-indicator=\"ctrl.isLoading\">Save In Zoho</button>\n                  <button\n                      ng-if=\"!ctrl.corporate.is_preview && ctrl.applicationValid()\"\n                      class=\"btn btn--primary\"\n                      button-loading-indicator=\"ctrl.isLoading\"\n                  >\n                      Next\n                  </button>\n                  <div ng-class=\"resultMessageClass\">{{ ctrl.resultMessage }}</div>\n              </footer>\n          </div>\n\n        <div ng-if=\"!ctrl.showApplicationForm\" style=\"font-size: 1.2em\">\n          <p ng-if=\"ctrl.applicationDisabledStageIsClosed\">\n            An application has already been processed for this client.\n          </p>\n          <p ng-if=\"ctrl.applicationDisabledPriceNotAvailable\">\n            This product is no longer for sale, please consult your health insurance consultant\n            on <span style=\"white-space: nowrap\">{{ ctrl.application.zoho.company_contact_number }}.</span>\n          </p>\n          <p ng-if=\"!(ctrl.applicationDisabledPriceNotAvailable || ctrl.applicationDisabledStageIsClosed)\">\n          Please contact one of our consultants on {{ ctrl.application.zoho.company_contact_number }} to complete your application.\n          </p>\n        </div>\n\n      </div>\n    </div>\n\n</form>\n\n<div class=\"modal fade operator-warning large\" id=\"operator-warning\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"operator-warning-label\">\n    <div class=\"modal-dialog\" role=\"document\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span\n                        aria-hidden=\"true\">&times;</span></button>\n                <h4 class=\"modal-title\" id=\"operator-warning-label\">Operator Alert</h4>\n            </div>\n            <div class=\"modal-body\">\n                {{ ctrl.operator_warning }}\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 305 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container basic-page\">\n    <div class=\"row--narrow\">\n        <div ng-if=\"ctrl.was_successful\">\n            <section ng-bind-html=\"ctrl.success_html\"></section>\n            <div ng-if=\"ctrl.showCorporateSuccessPageScript\">\n                <corporate-success-script model=\"ctrl.application.corporate_script_responses\"></corporate-success-script>\n                <div class=\"success-page__corporate-script-footer\">\n                    <button\n                        class=\"btn btn--primary\"\n                        button-loading-indicator=\"ctrl.isSavingResponses\"\n                        ng-click=\"ctrl.submitCorporateScriptResponses()\"\n                    >\n                        Submit\n                    </button>\n                    <div ng-if=\"ctrl.savedCorporateScriptResponse\" class=\"message\">\n                        Your responses have been saved.\n                    </div>\n                    <div ng-if=\"ctrl.savedScriptResponseError\" class=\"message error\">\n                        An error has occurred while attempting to save your responses.\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div ng-if=\"!ctrl.was_successful && ctrl.is_pending\">\n            <section>\n                Application has been submitted to the fund, it's current status is \"Pending\".<br/>\n                The transaction ID for this application is {{ ctrl.transaction_id }}.\n            </section>\n        </div>\n\n        <div ng-if=\"!ctrl.was_successful && !ctrl.is_pending\">\n            <section ng-bind-html=\"ctrl.failure_html\"></section>\n        </div>\n\n    </div>\n</div>\n"

/***/ }),
/* 306 */
/***/ (function(module, exports) {

	module.exports = "<app-scaffold>\n  <basic-page-header title=\"Contact Us\"></basic-page-header>\n\n  <div class=\"container basic-page\">\n    <div class=\"row--narrow\">\n      <basic-page-content content=\"ctrl.content\"></basic-page-content>\n    </div>\n  </div>\n</app-scaffold>"

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	module.exports = "<app-scaffold>\n  <basic-page-header title=\"Cookie Notice\"></basic-page-header>\n\n  <div class=\"container basic-page\">\n    <div class=\"row--narrow\">\n      <section ng-include=\"ctrl.deployment.cookies\"></section>\n    </div>\n  </div>\n</app-scaffold>"

/***/ }),
/* 308 */
/***/ (function(module, exports) {

	module.exports = "Debug\n<div class=\"debug-inner\">\n    <div ng-repeat=\"package in packages track by $id(package)\">\n        <div class=\"debug-price-calc\">\n            <div>Hospital: {{ package.hospital_product.name }}</div>\n            <div>Ancillary: {{ package.ancillary_product.name }}</div>\n            <div>Base premium: {{ package.selectedPrice.gross_monthly_full_premium | currency }}</div>\n            <div>LHC Base: {{ package.selectedPrice.gross_monthly_lhc | currency }}</div>\n            <div>Rebate: {{ package.selectedPrice.calculations.rebatePercent }}%\n                ({{ package.selectedPrice.calculations.priceWithRebate | currency }})\n            </div>\n            <div>LHC: {{ package.selectedPrice.calculations.lhcPercent }}%\n                ({{ package.selectedPrice.calculations.priceWithLHC | currency }})\n            </div>\n            <div>LHC Breakdown: {{ package.selectedPrice.calculations.lhcBreakdown }}\n            </div>\n            <div>Total before discounts: {{ package.selectedPrice.calculations.totalBeforeDiscounts | currency }}</div>\n            <div>Discounts:\n                <ul>\n                    <li ng-repeat=\"d in package.selectedPrice.calculations.discounts\">\n                        {{ d.description }}: {{ d.value }}<span ng-if=\"!d.is_absolute\">%</span>\n                        ({{ d.dollarAmount | currency }})\n                    </li>\n                </ul>\n            </div>\n            <div>Resulting premium: {{ package.selectedPrice.calculations.totalPrice | currency }}</div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 309 */
/***/ (function(module, exports) {

	module.exports = "<app-scaffold>\n  <basic-page-header title=\"Frequently Asked Questions\"></basic-page-header>\n\n  <div class=\"container basic-page\">\n    <div class=\"row--narrow\">\n      <section ng-include=\"ctrl.deployment.faq\"></section>\n    </div>\n  </div>\n</app-scaffold>\n"

/***/ }),
/* 310 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"input-group\">\n  <label>\n    <span ng-if=\"isExpanded\">-</span>\n    <span ng-if=\"!isExpanded\">+</span>\n    <a href=\"\" ng-click=\"onToggleOpen()\">{{ title }}</a>\n  </label>\n\n  <div class=\"form-value\" ng-if=\"isExpanded\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"filterModel[modelField]\" ng-change=\"onToggleAll()\"/> All\n    </label>\n\n    <div ng-if=\"splitOpenRestricted\">\n      <div class=\"fund-type-label\"><label>Open:</label></div>\n      <div ng-repeat=\"f in funds|filter:{restricted:false}\">\n        <label><input type=\"checkbox\" ng-model=\"f.selected\"/> {{ f.name }}</label>\n      </div>\n\n      <div class=\"fund-type-label\"><label>Restricted:</label></div>\n      <div ng-repeat=\"f in funds|filter:{restricted:true}\">\n        <label><input type=\"checkbox\" ng-model=\"f.selected\"/> {{ f.name }}</label>\n      </div>\n    </div>\n\n    <div ng-if=\"!splitOpenRestricted\">\n      <div ng-repeat=\"f in funds\">\n        <label><input type=\"checkbox\" ng-model=\"f.selected\"/> {{ f.name }}</label>\n      </div>\n    </div>\n\n    <button class=\"form-control\" ng-click=\"onRefresh(true)\">Refresh</button>\n  </div>\n</div>"

/***/ }),
/* 311 */
/***/ (function(module, exports) {

	module.exports = "<app-scaffold>\n\n  <div ng-if=\"ctrl.corporate.is_active\">\n      <div class=\"hero-banner\">\n          <img ng-src=\"{{ ctrl.corporate.landing_hero_image }}\"/>\n      </div>\n      <div class=\"container landing\">\n\n          <!-- For corporates without sub-corporates, this is the entry to the comparator !DISABLED FOR NOW - FEATURE NOT REQUIRED! -->\n          <div>\n              <section class=\"landing--top\">\n                  <div class=\"landing--welcome\">\n                      <p>\n                          <section ng-bind-html=\"ctrl.corporate.landing_page_message\"></section>\n                      </p>\n                  </div>\n                  <div class=\"landing--login\" ng-class=\"{'suppressed':ctrl.suppress_login}\">\n                      <form name=\"ctrl.loginForm\">\n                          <div class=\"form-group\" ng-class=\"{'has-error': ctrl.loginFailed}\" ng-if=\"!ctrl.suppress_login\">\n\n                              <input ng-if=\"ctrl.corporate.mask_code_entry\" type=\"password\" class=\"form-control\" placeholder=\"Enter your password\" ng-model=\"ctrl.password\"/>\n                              <input ng-if=\"!ctrl.corporate.mask_code_entry\" type=\"text\" class=\"form-control\" placeholder=\"Enter your password\" ng-model=\"ctrl.password\"/>\n\n                              <div ng-if=\"ctrl.loginFailed\">\n                                  Sorry, the code you entered was not valid. Please check it and try again.<br><br>\n                              </div>\n\n                              <span ng-bind-html=\"ctrl.corporate.landing_dont_know_password_text\"></span>\n                          </div>\n                          <button class=\"btn btn--primary\"\n                                  ng-click=\"ctrl.submit(ctrl.password)\">{{ ctrl.corporate.landing_button_text }}</button>\n                      </form>\n                  </div>\n              </section>\n              <section class=\"landing--intro\" ng-if=\"ctrl.corporate.landing_intro_text\"\n                       ng-bind-html=\"ctrl.corporate.landing_intro_text\">\n              </section>\n          </div>\n\n          <!-- For corporates that have sub-corporates, just link through to those sub-corps !DISABLED FOR NOW - FEATURE NOT REQUIRED! -->\n          <section ng-if=\"false\">\n              <div class=\"row--narrow\">\n                  <div ng-repeat=\"child in ctrl.corporate.children | orderBy:['-sortKey', 'name']\" class=\"col-sm-4 landing--child-section\">\n                      <a ng-href=\"/{{ child.url }}\"><img class=\"landing--child-logo\" ng-src=\"{{ child.logo }}\" class=\"\"/></a>\n                      <div class=\"landing--child-title\">{{ child.name }}</div>\n                  </div>\n              </div>\n          </section>\n      </div>\n  </div>\n  <div class=\"container landing\" ng-if=\"!ctrl.corporate.is_active\">\n      This corporate is currently inactive\n  </div>\n\n</app-scaffold>"

/***/ }),
/* 312 */
/***/ (function(module, exports) {

	module.exports = "<app-scaffold>\n  <basic-page-header title=\"Terms of Use\"></basic-page-header>\n\n  <div class=\"container basic-page\">\n    <div class=\"row--narrow\">\n      <section ng-include=\"ctrl.deployment.legal\"></section>\n    </div>\n  </div>\n</app-scaffold>"

/***/ }),
/* 313 */
/***/ (function(module, exports) {

	module.exports = "<app-scaffold>\n\n  <div class=\"version\">v{{ ctrl.version }}</div>\n  <zoho-error error=\"ctrl.zohoApiError\"></zoho-error>\n\n  <div class=\"step-progress\">\n      <ul>\n          <li class=\"step-1\" ng-class=\"{'step-current': $state.includes('operator.step1'), 'step-done': $state.includes('operator.step3')}\">\n            <div class=\"step-content\">\n              <span class=\"step-number\">Step 1</span>\n              <span class=\"step-title\">{{ ctrl.corporate.aboutyou_step_title }}</span>\n              <button class=\"next-step\">&gt;</button>\n            </div>\n          </li>\n          <li class=\"step-2\" ng-class=\"{'step-current': $state.includes('operator.step2'), 'step-done': $state.includes('operator.step3')}\">\n            <div class=\"step-content\">\n              <button class=\"prev-step\">&lt;</button>\n              <span class=\"step-number\">Step 2</span>\n              <span class=\"step-title\">{{ ctrl.corporate.compare_step_title }}</span>\n              <button class=\"next-step\">&gt;</button>\n            </div>\n          </li>\n          <li\n              ng-if=\"!ctrl.corporate.is_service_comparison_tool\"\n              class=\"step-3\"\n              ng-class=\"{'step-current': $state.includes('operator.step3'), 'step-done': !$state.includes('operator.step1') &&\n              !$state.includes('comparator.step2') && !$state.includes('operator.step3')}\"\n          >\n            <div class=\"step-content\">\n              <button class=\"prev-step\">&lt;</button>\n              <span class=\"step-number\">Step 3</span>\n              <span class=\"step-title\">{{ ctrl.corporate.apply_step_title }}</span>\n              <button class=\"next-step\">&gt;</button>\n            </div>\n          </li>\n      </ul>\n  </div>\n  <div class=\"help-section\">\n      <div class=\"container\">\n      <div class=\"row--narrow\">\n          <section ng-bind-html=\"ctrl.corporate.help_message\"></section>\n      </div>\n      </div>\n  </div>\n  <div class=\"step-banner\" style=\"display:none\">\n    <div class=\"container\">\n      <div class=\"row--narrow step-banner--text\" ng-hide=\"!$state.includes('comparator.step1')\">\n        <h2>{{ ctrl.corporate.aboutyou_title }}</h2>\n        <p ng-if=\"ctrl.corporate.aboutyou_blurb\" ng-bind-html=\"ctrl.corporate.aboutyou_blurb\"></p>\n      </div>\n      <div class=\"row--narrow step-banner--text\" ng-hide=\"!$state.includes('comparator.step2')\">\n        <h2>{{ ctrl.corporate.compare_title }}</h2>\n        <p ng-if=\"ctrl.corporate.compare_blurb\" ng-bind-html=\"ctrl.corporate.compare_blurb\"></p>\n      </div>\n      <div class=\"row--narrow step-banner--text\" ng-hide=\"!$state.includes('comparator.step3')\">\n        <h2>{{ ctrl.corporate.apply_title }}</h2>\n        <p ng-if=\"ctrl.corporate.apply_blurb\" ng-bind-html=\"ctrl.corporate.apply_blurb\"></p>\n      </div>\n      <div class=\"row--narrow step-banner--text\" ng-hide=\"!$state.includes('comparator.step4')\">\n        <h2>Thank You</h2>\n      </div>\n    </div>\n  </div>\n\n  <active-quote-banner\n      ng-if=\"ctrl.applicantHasActiveQuote()\"\n      application=\"ctrl.application\"\n  ></active-quote-banner>\n\n  <div id=\"ui-view\" ui-view></div>\n\n</app-scaffold>"

/***/ }),
/* 314 */
/***/ (function(module, exports) {

	module.exports = "<form class=\"comparator-form operator\"\n      name=\"ctrl.step1Form\"\n      ng-submit=\"ctrl.onSubmit(ctrl.step1Form)\"\n      ng-submit-force=\"true\"\n      novalidate remove-external-validation-errors-on-submit=\"false\" focus-invalid>\n\n    <div class=\"container\">\n        <div class=\"row--narrow\">\n          <div class=\"form-group\" ng-if=\"ctrl.corporate.ask_if_current_cover\">\n            <span class=\"faux-label control-label\">Do you currently have health insurance?</span>\n\n            <div class=\"form-value\">\n              <div class=\"input-group\">\n                <label class=\"radio-inline\">\n                  <input\n                    required type=\"radio\"\n                    ng-model=\"ctrl.application.personal.previous_fund.has_previous_fund\"\n                    ng-change=\"ctrl.changeHasPreviousFund()\"\n                    ng-value=\"true\"\n                  />Yes\n                </label>\n                <label class=\"radio-inline\">\n                  <input\n                    required type=\"radio\"\n                    ng-model=\"ctrl.application.personal.previous_fund.has_previous_fund\"\n                    ng-change=\"ctrl.changeHasPreviousFund()\"\n                    ng-value=\"false\"\n                  />No\n                </label>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"form-group has-tooltip\" ng-if=\"!ctrl.is_service_comparison_tool\">\n                <label for=\"step1-why\" class=\"control-label\">\n                    <corporate-question-label question=\"step_1_why_caption\" />\n                    <i ng-if=\"ctrl.corporate.questionConfig['step_1_why_description']\"\n                       tooltip-html-unsafe=\"{{ ctrl.corporate.questionConfig['step_1_why_description'] }}\" position-tooltip\n                       class=\"glyphicon glyphicon-info-sign\"></i>\n                </label>\n\n                <div class=\"form-value\">\n                    <select\n                        id=\"step1-why\"\n                        class=\"form-control\"\n                        required\n                        name=\"motivation\"\n                        ng-model=\"ctrl.application.policy.motivation\"\n                        ng-options=\"item[0] as item[1] for item in ctrl.application.motivationChoices()\"\n                        ng-disabled=\"!ctrl.hasAnsweredCurrentFund()\"\n                    >\n                        <option value=\"\">-- Please select --</option>\n                    </select>\n                </div>\n            </div>\n\n            <div\n                class=\"form-group has-tooltip\"\n                ng-if=\"!ctrl.is_service_comparison_tool && ctrl.application.motivationSubChoices()\"\n            >\n                <label for=\"step1-why2\" class=\"control-label\">Motivation 2</label>\n\n                <div class=\"form-value\">\n                    <select\n                        id=\"step1-why2\"\n                        class=\"form-control\"\n                        required\n                        name=\"motivation2\"\n                        ng-model=\"ctrl.application.policy.motivation2\"\n                        ng-options=\"item[0] as item[1] for item in ctrl.application.motivationSubChoices()\"\n                        ng-disabled=\"!ctrl.hasAnsweredCurrentFund()\"\n                    >\n                        <option value=\"\">-- Please select --</option>\n                    </select>\n                </div>\n            </div>\n\n            <div class=\"form-group has-tooltip\">\n                <label for=\"step1-who\" class=\"control-label\">\n                    <corporate-question-label question=\"step_1_who_caption\" />\n                    <i ng-if=\"ctrl.corporate.questionConfig['step_1_who_description']\"\n                       tooltip-html-unsafe=\"{{ ctrl.corporate.questionConfig['step_1_who_description'] }}\" position-tooltip\n                       class=\"glyphicon glyphicon-info-sign\"></i>\n                </label>\n\n                <div class=\"form-value\">\n                    <select id=\"step1-who\" class=\"form-control\" required\n                            ng-model=\"ctrl.application.policy.membership_type\" name=\"membership_type\"\n                            ng-change=\"ctrl.onMembershipTypeChange()\"\n                            ng-options=\"item[0] as item[1] for item in ctrl.formChoices.membership_type\">\n                        <option value=\"\">-- Please select --</option>\n                    </select>\n                </div>\n            </div>\n\n            <div class=\"form-group has-tooltip\">\n              <label for=\"step1-state\" class=\"control-label\">\n                <corporate-question-label question=\"step_1_state_caption\" />\n                <i ng-if=\"ctrl.corporate.questionConfig['step_1_state_description']\"\n                   tooltip-html-unsafe=\"{{ ctrl.corporate.questionConfig['step_1_state_description'] }}\"\n                   position-tooltip\n                   class=\"glyphicon glyphicon-info-sign\"></i>\n              </label>\n\n              <div class=\"form-value\">\n                <select\n                  id=\"step1-state\" class=\"form-control\" required\n                  ng-model=\"ctrl.application.primary_address.state\" name=\"state\"\n                  ng-options=\"item[0] as item[1] for item in ctrl.formChoices.state\"\n                  ng-change=\"ctrl.selectState()\"\n                >\n                  <option value=\"\">-- Please select --</option>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group has-tooltip\">\n                <label for=\"step1-cover_type\" class=\"control-label\">\n                    <corporate-question-label question=\"step_1_type_of_cover_caption\" />\n                    <i ng-if=\"ctrl.corporate.questionConfig['step_1_type_of_cover_description']\"\n                       tooltip-html-unsafe=\"{{ ctrl.corporate.questionConfig['step_1_type_of_cover_description'] }}\" position-tooltip\n                       class=\"glyphicon glyphicon-info-sign\"></i>\n                </label>\n\n                <div class=\"form-value\">\n                    <select id=\"step1-cover_type\" class=\"form-control\" required\n                            ng-model=\"ctrl.application.policy.cover_type\" name=\"cover_type\"\n                            ng-options=\"item[0] as item[1] for item in ctrl.formChoices.cover_type\">\n                        <option value=\"\">-- Please select --</option>\n                    </select>\n                </div>\n            </div>\n\n            <product-lookup\n                ng-if=\"ctrl.is_service_comparison_tool\"\n                state=\"{{ ctrl.application.primary_address.state }}\"\n                membership=\"{{ ctrl.application.policy.membership_type }}\"\n                model=\"ctrl.application.comparison_product\"\n                corporate-search=\"true\"\n            ></product-lookup>\n\n            <div ng-if=\"ctrl.corporate.show_previous_fund_list && ctrl.application.personal.previous_fund.has_previous_fund\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Current Health Fund</label>\n\n                    <div class=\"form-value\">\n                        <select required class=\"form-control\"\n                                dynamic-name=\"fund_id\"\n                                ng-change=\"ctrl.selectPreviousFund()\"\n                                ng-model=\"ctrl.application.personal.previous_fund.fund_id\"\n                                ng-options=\"f.id as f.title group by f.group for f in ctrl.formChoices.previous_fund | orderBy:['group']\">\n                            <option value=\"\">-- Select Health Fund --</option>\n                        </select>\n                    </div>\n                </div>\n\n                <product-lookup\n                  ng-if=\"ctrl.corporate.show_current_health_fund_product_lookup\"\n                  model=\"ctrl.application.personal.previous_fund\"\n                  fund=\"{{ ctrl.application.personal.previous_fund.fund_id }}\"\n                ></product-lookup>\n\n            </div>\n\n            <!-- filters -->\n\n            <div class=\"form-group\" ng-if=\"!ctrl.is_service_comparison_tool\">\n              <span class=\"faux-label control-label\">Preferred excess</span>\n\n              <div class=\"form-value\">\n                  <select\n                    name=\"operator-filter-excess\"\n                    class=\"form-control\"\n                    ng-options=\"e[0] as e[1] for e in ctrl.formChoices.excess_range_filter_options\"\n                    ng-model=\"ctrl.operatorFilters.excess_range\"\n                  >\n                    <option value=\"\">-- No preference --</option>\n                  </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\" ng-if=\"!ctrl.is_service_comparison_tool\">\n              <service-filters\n                requires-hospital=\"ctrl.application.requiresHospitalProducts()\"\n                requires-ancillary=\"ctrl.application.requiresAncillaryProducts()\"\n                services-in-columns=\"ctrl.servicesInColumns\"\n                primary-service-need=\"ctrl.application.policy.primary_service_need\"\n                previous-fund=\"ctrl.application.personal.previous_fund\"\n              />\n            </div>\n\n\n            <!-- end filters -->\n\n            <div ng-if=\"!ctrl.is_service_comparison_tool && ctrl.corporate.capture_date_of_birth\">\n                <div class=\"form-group has-tooltip\">\n                    <label for=\"step1-dob\" class=\"control-label\">\n                        <corporate-question-label question=\"step_1_date_of_birth_caption\" />\n                        <i ng-if=\"ctrl.corporate.questionConfig['step_1_date_of_birth_description']\"\n                           tooltip-html-unsafe=\"{{ ctrl.corporate.questionConfig['step_1_date_of_birth_description'] }}\"\n                           position-tooltip\n                           class=\"glyphicon glyphicon-info-sign\"></i>\n                    </label>\n\n                    <div class=\"form-value\">\n                        <div aon-date id=\"step1-dob\"\n                             name=\"dob\"\n                             min-age=\"16\"\n                             ng-model=\"ctrl.application.personal.dob\"\n                             ng-model-options=\"{updateOn: 'blur'}\"\n                             ng-change=\"ctrl.onDOBChanged()\"\n                             apply-validators=\"{ 'error_messages': {'underage':'Must be 16 years of age or older'}}\"></div>\n                    </div>\n                </div>\n                <!-- For couples/families, need partner DOB for LHC calculation -->\n                <div class=\"form-group has-tooltip\"\n                     ng-if=\"ctrl.application.hasPartner()\">\n                    <label for=\"step1-partner-dob\" class=\"control-label\">\n                        <corporate-question-label question=\"step_1_partner_date_of_birth_caption\" />\n                        <i ng-if=\"ctrl.corporate.questionConfig['step_1_partner_date_of_birth_description']\"\n                           tooltip-html-unsafe=\"{{ ctrl.corporate.questionConfig['step_1_partner_date_of_birth_description'] }}\"\n                           position-tooltip\n                           class=\"glyphicon glyphicon-info-sign\"></i>\n                    </label>\n\n                    <div class=\"form-value\">\n                        <div aon-date id=\"step1-partner-dob\"\n                             name=\"partner-dob\"\n                             min-age=\"16\"\n                             ng-model=\"ctrl.application.partner.dob\"\n                             ng-model-options=\"{updateOn: 'blur'}\"\n                             ng-change=\"ctrl.onDOBChanged()\"\n                             apply-validators=\"{ 'error_messages': {'underage':'Must be 16 years of age or older'}}\">\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n          <div\n            ng-if=\"!ctrl.is_service_comparison_tool && ctrl.showContinuousCoverQuestion()\"\n            class=\"form-group step1-continuous-cover has-tooltip\"\n          >\n            <label for=\"continuous-cover\" class=\"control-label\">\n              {{ ctrl.continuousCoverQuestionLabel() }}\n            </label>\n\n            <div class=\"input-group\">\n              <label class=\"radio-inline\">\n                <input\n                  type=\"radio\"\n                  ng-model=\"ctrl.application.policy.held_continuous_hospital_cover\"\n                  ng-change=\"ctrl.onChangeHasContinuousCover()\"\n                  name=\"continuous-cover\"\n                  ng-value=\"true\"\n                  required\n                > Yes\n              </label>\n              <label class=\"radio-inline\">\n                <input\n                  type=\"radio\"\n                  ng-model=\"ctrl.application.policy.held_continuous_hospital_cover\"\n                  ng-change=\"ctrl.onChangeHasContinuousCover()\"\n                  name=\"continuous-cover\"\n                  ng-value=\"false\"\n                  required\n                > No\n              </label>\n            </div>\n          </div>\n\n          <div ng-if=\"!ctrl.is_service_comparison_tool && ctrl.corporate.capture_age\">\n                <div class=\"form-group has-tooltip\">\n                    <label for=\"step1-age\" class=\"control-label\">\n                        <corporate-question-label question=\"step_1_age_caption\" />\n                        <i ng-if=\"ctrl.corporate.questionConfig['step_1_age_description']\"\n                           tooltip-html-unsafe=\"{{ ctrl.corporate.questionConfig['step_1_age_description'] }}\"\n                           position-tooltip\n                           class=\"glyphicon glyphicon-info-sign\"></i>\n                    </label>\n\n                    <div class=\"form-value\">\n                        <input type=\"number\"\n                               class=\"form-control\"\n                               id=\"step1-age\"\n                               name=\"age\"\n                               step=\"1\"\n                               min=\"{{ ctrl.formChoices.age_capture_validation.min }}\"\n                               max=\"{{ ctrl.formChoices.age_capture_validation.max }}\"\n                               apply-validators=\"ctrl.formChoices.age_capture_validation\"\n                               ng-model=\"ctrl.application.personal.age\"\n                               ng-model-options=\"{updateOn: 'blur'}\"\n                               ng-change=\"ctrl.onAgeChange(ctrl.application.personal)\"/>\n                    </div>\n                </div>\n                <!-- For couples/families, need partner age for LHC calculation -->\n                <div class=\"form-group has-tooltip\"\n                     ng-if=\"ctrl.application.hasPartner()\">\n                    <label for=\"step1-partner-age\" class=\"control-label\">\n                        <corporate-question-label question=\"step_1_partner_age_caption\" />\n                        <i ng-if=\"ctrl.corporate.questionConfig['step_1_partner_age_description']\"\n                           tooltip-html-unsafe=\"{{ ctrl.corporate.questionConfig['step_1_partner_age_description'] }}\"\n                           position-tooltip\n                           class=\"glyphicon glyphicon-info-sign\"></i>\n                    </label>\n\n                    <div class=\"form-value\">\n                        <input type=\"number\"\n                               class=\"form-control\"\n                               id=\"step1-partner-age\"\n                               name=\"partner-age\"\n                               step=\"1\"\n                               min=\"{{ ctrl.formChoices.age_capture_validation.min }}\"\n                               max=\"{{ ctrl.formChoices.age_capture_validation.max }}\"\n                               apply-validators=\"ctrl.formChoices.age_capture_validation\"\n                               ng-model=\"ctrl.application.partner.age\"\n                               ng-model-options=\"{updateOn: 'blur'}\"\n                               ng-change=\"ctrl.onAgeChange(ctrl.application.partner)\"/>\n                    </div>\n                </div>\n            </div>\n\n            <div ng-if=\"!ctrl.is_service_comparison_tool && ctrl.showLHCAgeQuestions()\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">LHC Age</label>\n\n                    <div class=\"form-value\">\n                        <input\n                          lhc-age-entry\n                          required\n                          class=\"form-control\"\n                          dynamic-name=\"lhc_age\"\n                          apply-validators=\"ctrl.lhc_age_validator\"\n                          ng-model=\"ctrl.application.policy.lhc_age\"\n                        />\n                    </div>\n                </div>\n\n                <div class=\"form-group\"\n                     ng-if=\"ctrl.application.hasPartner()\">\n                    <label class=\"control-label\">Partner LHC Age</label>\n\n                    <div class=\"form-value\">\n                        <input\n                          lhc-age-entry\n                          required\n                          class=\"form-control\"\n                          dynamic-name=\"lhc_age_partner\"\n                          apply-validators=\"ctrl.lhc_age_validator\"\n                          ng-model=\"ctrl.application.policy.lhc_age_partner\"\n                        />\n                    </div>\n                </div>\n            </div>\n\n            <div\n                class=\"form-group\"\n                ng-if=\"ctrl.showYouthDiscountAge(ctrl.application.personal)\"\n            >\n                <label class=\"control-label\">Youth Discount Age</label>\n\n                <div class=\"form-value\">\n                    <input type=\"number\" class=\"form-control\"\n                           dynamic-name=\"primary_youth_discount_age\"\n                           apply-validators=\"ctrl.youth_discount_age_validator\"\n                           min=\"18\"\n                           max=\"29\"\n                           step=\"1\"\n                           ng-model=\"ctrl.application.policy.primary_youth_discount_age\"\n                           ng-change=\"ctrl.onYouthDiscountAgeChange(ctrl.application.policy)\"\n                    />\n                </div>\n            </div>\n\n            <div\n                class=\"form-group\"\n                ng-if=\"ctrl.application.hasPartner() && ctrl.showYouthDiscountAge(ctrl.application.partner)\"\n            >\n                <label class=\"control-label\">Partner Youth Discount Age</label>\n\n                <div class=\"form-value\">\n                    <input type=\"number\" class=\"form-control\"\n                           dynamic-name=\"partner_youth_discount_age\"\n                           apply-validators=\"ctrl.youth_discount_age_validator\"\n                           min=\"18\"\n                           max=\"29\"\n                           step=\"1\"\n                           ng-model=\"ctrl.application.policy.partner_youth_discount_age\"\n                           ng-change=\"ctrl.onYouthDiscountAgeChange(ctrl.application.policy)\"\n                    />\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"section-highlight\" ng-if=\"!ctrl.is_service_comparison_tool\">\n        <div class=\"container\">\n            <div class=\"row--narrow\">\n                <div class=\"form-group step1-rebate has-tooltip\">\n\n                    <label for=\"apply_for_rebate\" class=\"control-label\">\n                        <corporate-question-label question=\"step_1_rebate_caption\" />\n                        <i ng-if=\"ctrl.corporate.questionConfig['step_1_rebate_description']\"\n                           tooltip-html-unsafe=\"{{ ctrl.corporate.questionConfig['step_1_rebate_description'] }}\" position-tooltip\n                           class=\"glyphicon glyphicon-info-sign\"></i>\n                    </label>\n\n                    <div class=\"input-group\">\n                        <label class=\"radio-inline\">\n                            <input type=\"radio\" ng-model=\"ctrl.application.policy.federal_rebate\"\n                                   name=\"apply_for_rebate\" ng-value=\"true\" required> Yes\n                        </label>\n                        <label class=\"radio-inline\">\n                            <input type=\"radio\" ng-model=\"ctrl.application.policy.federal_rebate\"\n                                   name=\"apply_for_rebate\" ng-value=\"false\" required> No\n                        </label>\n                    </div>\n                </div>\n                <div class=\"form-group has-tooltip\" ng-if=\"ctrl.application.policy.federal_rebate\">\n\n                    <label for=\"contact--rebate-tier\" class=\"control-label\">\n                        {{ ctrl.rebate_tier_caption }}\n                        <i ng-if=\"ctrl.rebate_tier_description\"\n                           tooltip-html-unsafe=\"{{ ctrl.rebate_tier_description }}\" position-tooltip\n                           class=\"glyphicon glyphicon-info-sign\"></i>\n                    </label>\n\n                    <div class=\"form-value\">\n                        <div ng-if=\"ctrl.rebateAge()\">\n                          {{ ctrl.rebateAge() }}\n                        </div>\n                        <div ng-if=\"ctrl.rebateAgePartner()\">\n                          {{ ctrl.rebateAgePartner() }}\n                        </div>\n\n                        <select required\n                                id=\"contact--rebate-tier\" name=\"policy.rebate_tier\" class=\"form-control\"\n                                ng-model=\"ctrl.application.policy.rebate_tier_matrix\"\n                                ng-change=\"ctrl.updateRebateTier()\"\n                                ng-options=\"f.value as f.tier group by f.group for f in ctrl.rebate_tier_matrix_choices\">\n                            <option value=\"\">-- Select Tier --</option>\n                        </select>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n    </div>\n\n    <div ng-if=\"ctrl.offerCompetition\" class=\"container step1-competition\">\n        <div class=\"row--narrow\">\n            <div class=\"form-group has-tooltip\">\n                <label for=\"enter_comp\" class=\"control-label\">\n                    <corporate-question-label question=\"step_1_competition_invite_caption\" />\n                    <i ng-if=\"ctrl.corporate.questionConfig['step_1_competition_invite_description']\"\n                       tooltip-html-unsafe=\"{{ ctrl.corporate.questionConfig['step_1_competition_invite_description'] }}\" position-tooltip\n                       class=\"glyphicon glyphicon-info-sign\"></i>\n                </label>\n\n                <div class=\"input-group\">\n                    <label class=\"radio-inline\">\n                        <input type=\"checkbox\" ng-model=\"ctrl.enter_competition\" name=\"enter_comp\"/>\n                    </label>\n                </div>\n            </div>\n            <div class=\"form-group\" ng-if=\"ctrl.enter_competition\">\n                <div class=\"form-group\">\n                    <span class=\"faux-label control-label\">Name</span>\n\n                    <div class=\"form-value\">\n                        <input id=\"step1-comp-name\" class=\"form-control\" type=\"text\"\n                               class=\"form-control\" placeholder=\"Name\" name=\"name\"\n                               ng-model=\"ctrl.application.personal.first_name\"\n                               required/>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <span class=\"faux-label control-label\">Mobile Phone</span>\n\n                    <div class=\"form-value\">\n                        <input id=\"step1-comp-phone\" class=\"form-control\" type=\"text\"\n                               placeholder=\"Phone Number\" name=\"phone\" class=\"form-control\"\n                               ng-model=\"ctrl.application.contact.phone_mobile\"\n                               required/>\n                    </div>\n\n                </div>\n\n                <div class=\"form-group\">\n                    <span class=\"faux-label control-label\">Email</span>\n\n                    <div class=\"form-value\">\n                        <input id=\"step1-comp-email\" class=\"form-control\" type=\"email\"\n                               placeholder=\"Email\" name=\"email\" class=\"form-control\"\n                               ng-model=\"ctrl.application.contact.email_address\"\n                               required/>\n                    </div>\n                </div>\n\n                <div>\n                    Competition Terms and Conditions\n                    <i tooltip-html-unsafe=\"{{ ctrl.corporate.competition_terms_and_conditions }}\" position-tooltip\n                       class=\"glyphicon glyphicon-info-sign\"></i>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"container\">\n        <div class=\"row--narrow\">\n            <footer>\n                <button class=\"btn btn--primary\">{{ ctrl.corporate.aboutyou_button_text }}</button>\n            </footer>\n        </div>\n    </div>\n</form>\n\n\n"

/***/ }),
/* 315 */
/***/ (function(module, exports) {

	module.exports = "<debug-overlay ng-if=\"ctrl.debugOverlay\" packages=\"ctrl.packages\"></debug-overlay>\n\n\n<!-- ng-if=\"ctrl.operator.operator_type == 'zoho'\" -->\n<div class=\"comparator-results-container\">\n\n    <div class=\"comparator-results operator\">\n\n        <div\n          id=\"your-details\"\n          class=\"your-details\"\n          ng-class=\"{'pane-hidden': !ctrl.detailsPaneOpen}\"\n        >\n            <div>\n                <div ng-if=\"!ctrl.corporate.is_service_comparison_tool\" class=\"operator-filters\">\n                    <div class=\"row\">\n                        <div class=\"form-group\">\n                            <button class=\"form-control\" ng-click=\"ctrl.prevResultPage()\">Prev</button>\n                            <button class=\"form-control\" ng-click=\"ctrl.nextResultPage()\">Next</button>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"form-group\">\n                            <div class=\"form-value\">\n                                <div class=\"input-group\">\n                                    <label class=\"radio-inline\">\n                                        Display Current Policy\n                                        <input\n                                            type=\"checkbox\"\n                                            ng-change=\"ctrl.filterUpdate(true)\"\n                                            ng-model=\"ctrl.operatorFilters.show_current_policy\"\n                                        />\n                                    </label>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"form-group\">\n                            <div class=\"form-value\">\n                                <div class=\"input-group\">\n                                    <label>Display Order</label>\n\n                                    <div class=\"form-value\">\n                                        <select name=\"display_order\" class=\"form-control\"\n                                                ng-change=\"ctrl.filterUpdate(true)\"\n                                                ng-model=\"ctrl.operatorFilters.display_order\">\n                                            <option value=\"\">-- Sort Order --</option>\n                                            <option value=\"price_lowhi\">Price Low to High</option>\n                                            <option value=\"price_hilow\">Price High to Low</option>\n                                        </select>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <div ng-if=\"ctrl.operatorFilters.discount_code_choices.length\" class=\"form-group\">\n                            <div class=\"form-value\">\n                                <div class=\"input-group\">\n                                    <label>Discount</label>\n\n                                    <div class=\"form-value\">\n                                        <select\n                                            name=\"discount_code\"\n                                            class=\"form-control\"\n                                            ng-model=\"ctrl.operatorFilters.discount_code\"\n                                            ng-options=\"discount[0] as discount[1] for discount in ctrl.formChoices.discount_code_choices\"\n                                            ng-change=\"ctrl.filterUpdate(true)\"\n                                        >\n                                          <option ng-if=\"!ctrl.hasDefaultDiscount\" value=\"\">None</option>\n                                        </select>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <div class=\"form-value\">\n                                <div class=\"input-group\">\n                                    <label>Payment Frequency</label>\n\n                                    <div class=\"form-value\">\n                                        <select\n                                            ng-disabled=\"ctrl.operatorFilters.payment_frequency_disabled\"\n                                            name=\"payment_frequency\" class=\"form-control\"\n                                            ng-options=\"e[0] as e[1] for e in ctrl.paymentFrequencyChoices\"\n                                            ng-model=\"ctrl.operatorFilters.payment_frequency\"\n                                        ></select>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <div class=\"form-value\">\n                                <div class=\"input-group\">\n                                    <label>Excess</label>\n\n                                    <div class=\"form-value\">\n                                        <select\n                                            name=\"sort_order\" class=\"form-control\"\n                                            ng-change=\"ctrl.filterUpdate(true)\"\n                                            ng-options=\"e[0] as e[1] for e in ctrl.formChoices.excess_range_filter_options\"\n                                            ng-model=\"ctrl.operatorFilters.excess_range\"\n                                        >\n                                            <option value=\"\">-- No preference --</option>\n                                        </select>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                          <div class=\"form-value\">\n                            <button\n                              class=\"form-control\"\n                              ng-click=\"ctrl.showServiceFilters()\"\n                              ng-disabled=\"ctrl.isLoadingResults\"\n                            >\n                              Select services\n                            </button>\n                          </div>\n                        </div>\n                        <div class=\"form-group\" ng-if=\"ctrl.showHospitalTiersFilter()\">\n                          <div class=\"form-value\">\n                            <div class=\"input-group\">\n                              <div class=\"form-value\">\n                                <label>\n                                  <span ng-if=\"ctrl.operatorFilterControl.showHospitalTierFilter\">-</span>\n                                  <span ng-if=\"!ctrl.operatorFilterControl.showHospitalTierFilter\">+</span>\n                                  <a href=\"\"\n                                     ng-click=\"ctrl.operatorFilterControl.showHospitalTierFilter = !ctrl.operatorFilterControl.showHospitalTierFilter\">\n                                    Filter Hospital Tier\n                                  </a>\n                                </label>\n                              </div>\n\n                              <div class=\"form-value\" ng-if=\"ctrl.operatorFilterControl.showHospitalTierFilter\">\n                                <label>\n                                  <input\n                                    type=\"checkbox\"\n                                    ng-model=\"ctrl.operatorFilterControl.allTiersSelected\"\n                                    ng-change=\"ctrl.toggleAllTierFilter()\" /> All\n                                </label>\n\n                                <div ng-repeat=\"tier in ctrl.operatorFilters.hospital_classifications\">\n                                  <label><input type=\"checkbox\" ng-model=\"tier.selected\"/> {{ tier.name }}</label>\n                                </div>\n\n                                <button class=\"form-control\" ng-click=\"ctrl.filterUpdate(true)\">Refresh</button>\n                              </div>\n                            </div>\n                          </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <div class=\"form-value\">\n                                <fund-filters\n                                    title=\"Restrict Funds\"\n                                    is-expanded=\"ctrl.operatorFilterControl.showFundFilter\"\n                                    on-toggle-open=\"ctrl.toggleFundFilterOpen\"\n                                    on-toggle-all=\"ctrl.toggleFundFilterAll\"\n                                    filter-model=\"ctrl.operatorFilterControl\"\n                                    model-field=\"allFundsSelected\"\n                                    funds=\"ctrl.operatorFilters.funds\"\n                                    on-refresh=\"ctrl.filterUpdate\"\n                                    split-open-restricted=\"true\"\n                                />\n                            </div>\n                        </div>\n                        <div class=\"form-group\" ng-if=\"ctrl.operatorFilters.non_panel_funds\">\n                            <div class=\"form-value\">\n                                <fund-filters\n                                    title=\"Select Non-panel Funds\"\n                                    is-expanded=\"ctrl.operatorFilterControl.showFundFilterNonPanel\"\n                                    on-toggle-open=\"ctrl.toggleFundFilterOpenNonPanel\"\n                                    on-toggle-all=\"ctrl.toggleFundFilterAllNonPanel\"\n                                    filter-model=\"ctrl.operatorFilterControl\"\n                                    model-field=\"allFundsSelectedNonPanel\"\n                                    funds=\"ctrl.operatorFilters.non_panel_funds\"\n                                    on-refresh=\"ctrl.filterUpdate\"\n                                    split-open-restricted=\"false\"\n                                />\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <div ng-if=\"ctrl.corporate.is_service_comparison_tool\" class=\"operator-service-comparison-actions\">\n                    <div>\n                        <a ui-sref=\"operator.step1\" class=\"btn btn--primary\">\n                            Amend Fund Details\n                        </a>\n                    </div>\n\n                    <div>\n                        <a ng-href=\"{{ ctrl.serviceComparisonLink }}\" target=\"_blank\" class=\"btn btn--primary\">\n                            Export Waiting Difference\n                        </a>\n                    </div>\n                </div>\n\n                <div class=\"heading\">Your details:</div>\n                <ul>\n                    <li>{{ ctrl.applicant.displayValues.membership_type }}</li>\n                    <li>{{ ctrl.applicant.displayValues.cover_type }}</li>\n                    <li>Living in {{ ctrl.applicant.displayValues.state }}</li>\n                    <li ng-if=\"ctrl.applicant.displayValues.age\">{{ ctrl.applicant.displayValues.age }} years old</li>\n                    <li>\n                        <span ng-if=\"ctrl.applicant.policy.federal_rebate\">Federal Rebate: {{ (100*ctrl.applicant.policy.rebatePercentage).toFixed(2) }}%</span>\n                        <span ng-if=\"!ctrl.applicant.policy.federal_rebate\">No Govt. Rebate Applied</span>\n                    </li>\n                    <li ng-if=\"ctrl.applicant.policy.lhc_age\">\n                        LHC Age: {{ ctrl.applicant.policy.lhc_age }}\n                        <span ng-if=\"ctrl.applicant.hasPartner()\"> & {{ ctrl.applicant.policy.lhc_age_partner }}</span>\n                    </li>\n                    <li>\n                        LHC Loading: {{ (100*ctrl.applicant.policy.healthCoverLoading.totalLHC).toFixed(2) }}%\n                        <span ng-if=\"ctrl.applicant.hasPartner()\">\n                            ({{ (100*ctrl.applicant.policy.healthCoverLoading.primaryLHC).toFixed(2) }}% & {{ (100*ctrl.applicant.policy.healthCoverLoading.partnerLHC).toFixed(2) }}%)\n                        </span>\n                    </li>\n                    <li ng-if=\"ctrl.applicant.policy.primary_youth_discount_age || ctrl.applicant.policy.partner_youth_discount_age\">\n                        <div>Youth Discount Age:</div>\n                        <div ng-if=\"ctrl.applicant.policy.primary_youth_discount_age\">\n                            Primary: {{ ctrl.applicant.policy.primary_youth_discount_age }}\n                        </div>\n                        <div ng-if=\"ctrl.applicant.policy.partner_youth_discount_age\">\n                            Partner: {{ ctrl.applicant.policy.partner_youth_discount_age }}\n                        </div>\n                    </li>\n                    <li ng-if=\"ctrl.applicant.personal.previous_fund.has_previous_fund\">\n                        Current Fund: {{ ctrl.applicant.personal.previous_fund.fund_name|titlecase }}\n                    </li>\n                    <li ng-if=\"ctrl.applicant.personal.previous_fund.hospital_product\">\n                      {{ ctrl.previousProductDisplay(ctrl.applicant.personal.previous_fund.hospital_product) }}\n                    </li>\n                    <li ng-if=\"ctrl.applicant.personal.previous_fund.ancillary_product\">\n                      {{ ctrl.previousProductDisplay(ctrl.applicant.personal.previous_fund.ancillary_product) }}\n                    </li>\n\n                    <li ng-if=\"!ctrl.corporate.is_service_comparison_tool\">\n                        <a ui-sref=\"operator.step1\">Change your details</a>\n                    </li>\n\n                    <li ng-if=\"ctrl.corporate.is_email_quote_active\">\n                        <button class=\"btn btn--primary\" ng-click=\"ctrl.emailQuoteRequested = true\">\n                            {{ ctrl.corporate.email_quote_button_text }}\n                            <i ng-if=\"ctrl.corporate.email_quote_button_description\"\n                               tooltip-html-unsafe=\"{{ ctrl.corporate.email_quote_button_description }}\" position-tooltip\n                               class=\"glyphicon glyphicon-info-sign\"></i>\n                        </button>\n                        <div ng-if=\"ctrl.emailQuoteRequested\">\n                            <form name=\"ctrl.emailQuoteForm\"\n                                  ng-submit=\"ctrl.emailQuote(ctrl.emailQuoteForm)\"\n                                  ng-submit-force=\"true\" novalidate remove-external-validation-errors-on-submit=\"false\"\n                                  focus-invalid>\n                                <div class=\"form-group\">\n                                    <div class=\"form-value input-group\">\n                                        <input placeholder=\"Email address\" type=\"email\" id=\"personal--email\"\n                                               name=\"contact.email\"\n                                               class=\"form-control\" ng-model=\"ctrl.applicant.contact.email_address\"\n                                               required/>\n                                      <span class=\"input-group-btn\">\n                                        <input type=\"submit\" value=\"Send\" class=\"btn\"/>\n                                      </span>\n                                    </div>\n                                </div>\n                            </form>\n                            <div ng-if=\"ctrl.emailQuoteSendResult.attempted\">\n                                <span ng-if=\"!ctrl.emailQuoteSendResult.error\" class=\"email-success\">Thank you, an email has been sent</span>\n                                <span ng-if=\"ctrl.emailQuoteSendResult.error\" class=\"email-warning\">There was an error emailing your comparison</span>\n                            </div>\n                        </div>\n                    </li>\n                </ul>\n            </div>\n        </div>\n        <div class=\"product-loading\" ng-show=\"ctrl.isLoadingResults\">\n            <h4>Just a moment, we are adjusting the results based on your selections</h4>\n            <img src=\"/static/images/ring.gif\"/>\n        </div>\n        <div class=\"product-loading\" ng-show=\"ctrl.packages.length == 0\">\n            <h4>There are no products available that match the selected items. Please re-select items and try\n                again.</h4>\n        </div>\n        <!-- Only want to flag last column if there are at least 3 items -->\n\n        <div id=\"product-table\" class=\"product-table\" ng-if=\"ctrl.packages.length\">\n            <table>\n                <tr>\n                    <td></td>\n                    <td ng-repeat=\"package in ctrl.packages track by $id(package)\">\n                        <div class=\"product-cost\" ng-if=\"package.selectedPrice.pricing.future\">\n                            <span class=\"product-cost--amount future\">\n                                {{ ctrl.futurePrice(package) | currency }} / {{ ctrl.paymentFrequencyLabel() }}\n                                    <i\n                                        ng-if=\"ctrl.showPaymentFrequencyEstimatedNotice(package, 'future')\"\n                                        tooltip-html-unsafe=\"Estimated based on monthly premium\"\n                                        position-tooltip\n                                        class=\"glyphicon glyphicon-info-sign\"></i>\n\n                                <span ng-if=\"package.selectedPrice.pricing.available\">\n                                    ({{ ctrl.futurePriceDifference(package).toFixed(1) }}%)\n                                </span>\n                            </span>\n                            <span>from {{ package.selectedPrice.pricing.future.available_from | date }}</span>\n                        </div>\n                    </td>\n                </tr>\n                <tr>\n                    <td style=\"vertical-align: top;\">\n                      <div class=\"product-cost\">\n                        <div\n                          ng-if=\"ctrl.showDirectDebitDiscountLines\"\n                          class=\"product-cost--amount product-cost--label\"\n                        >\n                          DD Discount Price\n                        </div>\n                        <div class=\"product-cost--amount product-cost--label\">Normal Price</div>\n                      </div>\n                    </td>\n                    <td\n                        ng-repeat=\"package in ctrl.packages track by $id(package)\"\n                        ng-class=\"ctrl.columnClass(package)\"\n                    >\n                        <div class=\"product-cost\" ng-if=\"package.selectedPrice.pricing.available\">\n\n                          <div ng-if=\"ctrl.showDirectDebitDiscountLines\" class=\"product-cost--amount\">\n                            {{ ctrl.currentPriceForDD(package, true) | currency }} {{ ctrl.paymentFrequencyLabel() }}\n\n                            <i\n                              ng-if=\"ctrl.showPaymentFrequencyEstimatedNotice(package, 'available')\"\n                              tooltip-html-unsafe=\"Estimated based on monthly premium\"\n                              position-tooltip\n                              class=\"glyphicon glyphicon-info-sign\"></i>\n\n                          </div>\n\n                          <div class=\"product-cost--amount\">\n                            {{ ctrl.currentPriceForDD(package, false) | currency }} {{ ctrl.paymentFrequencyLabel() }}\n\n                            <i\n                              ng-if=\"ctrl.showPaymentFrequencyEstimatedNotice(package, 'available')\"\n                              tooltip-html-unsafe=\"Estimated based on monthly premium\"\n                              position-tooltip\n                              class=\"glyphicon glyphicon-info-sign\"></i>\n\n                          </div>\n                        </div>\n                        <div class=\"product-cost\" ng-if=\"!package.selectedPrice.pricing.available\">\n                            <span class=\"product-cost--amount\">\n                                Not Yet Available\n                            </span>\n                            <!-- This is just to align the text with other prices -->\n                            <div class=\"form-value\"><div class=\"input-group\">&nbsp;</div></div>\n                        </div>\n                    </td>\n                </tr>\n                <tr ng-if=\"ctrl.showDirectDebitDiscountLines\">\n                  <td></td>\n                  <td\n                      ng-repeat=\"package in ctrl.packages track by $id(package)\"\n                      ng-class=\"ctrl.columnClass(package)\"\n                  >\n                    <div class=\"form-value\">\n                      <div\n                        class=\"input-group direct-debit__toggle\"\n                        ng-class=\"{'disabled': !package.hasDirectDebitDiscount}\"\n                      >\n                        <label>\n                          DD Discount?\n                          <input\n                            type=\"checkbox\"\n                            ng-disabled=\"!package.hasDirectDebitDiscount\"\n                            ng-model=\"package.apply_direct_debit_discount\"\n                            ng-change=\"ctrl.updatePriceCalculations(package, ctrl.operatorFilters.payment_frequency)\"\n                          />\n                        </label>\n                      </div>\n                    </div>\n                  </td>\n                </tr>\n                <tr>\n                    <td></td>\n                    <td\n                        ng-repeat=\"package in ctrl.packages track by $id(package)\"\n                        style=\"vertical-align: top\"\n                        ng-class=\"ctrl.columnClass(package)\"\n                    >\n                        <div class=\"product-cost\">\n                            <div class=\"product-cost--base\">Base\n                                Premium: {{ ctrl.getPricing(package, 'available', false, false).base_premium | currency }}\n                            </div>\n                            <div class=\"product-cost--lhc\">\n                                LHC: {{ ctrl.getPricing(package, 'available', false, false).lhc_amount | currency }}\n                                @ {{ (100*ctrl.applicant.policy.healthCoverLoading.totalLHC).toFixed(2) }}%\n                            </div>\n                            <div class=\"product-cost--discount\" ng-repeat=\"discount in ctrl.discounts(package)\">\n                                {{ discount }}\n                            </div>\n                            <div ng-if=\"ctrl.checkedPrices[package.selectedPrice.id]\" style=\"padding-top: 10px;\">\n                              <div style=\"border-bottom: 1px solid black; padding: 5px 0;\"><strong>Fund quote response</strong></div>\n                              <div><strong>Gross amount:</strong> {{ ctrl.checkedPrices[package.selectedPrice.id].gross_amount|currency}}</div>\n                              <div><strong>Net amount:</strong> {{ ctrl.checkedPrices[package.selectedPrice.id].net_amount|currency}}</div>\n                              <div><strong>Loading Amount:</strong> {{ ctrl.checkedPrices[package.selectedPrice.id].loading_amount|currency}} ({{ ctrl.checkedPrices[package.selectedPrice.id].loading_rate}}%)</div>\n                              <div><strong>Rebate Rate:</strong> {{ ctrl.checkedPrices[package.selectedPrice.id].rebate_amount|currency}} ({{ ctrl.checkedPrices[package.selectedPrice.id].rebate_rate}}%)</div>\n                            </div>\n                        </div>\n                    </td>\n                </tr>\n                <tr>\n                    <td></td>\n                    <td\n                        ng-repeat=\"package in ctrl.packages track by $id(package)\"\n                        ng-class=\"ctrl.columnClass(package)\"\n                    >\n                        <div class=\"product-result product-cost-separator\">\n                            <div class=\"product-excess\">\n                                <div class=\"heading\">\n                                    Excess\n                                    <i ng-if=\"ctrl.corporate.excess_explanation.length\"\n                                       tooltip-html-unsafe=\"{{ ctrl.corporate.excess_explanation }}\" position-tooltip\n                                       class=\"glyphicon glyphicon-info-sign\"></i>\n                                </div>\n\n                                <ul class=\"product-excess--options\">\n\n                                    <li\n                                      ng-repeat=\"price in package.prices track by price.id\"\n                                      ng-init=\"isClosed = ctrl.isProductClosed(price)\"\n                                    >\n                                        <label ng-class=\"{closed: isClosed}\">\n                                          <input\n                                            type=\"radio\"\n                                            name=\"{{ package.id }}_product-excess\"\n                                            ng-value=\"price\"\n                                            ng-model=\"package.selectedPrice\"\n                                          />\n                                          <span ng-if=\"!ctrl.showPriceSummaryLink\">{{ price.excess | nocents }}</span>\n                                          <span ng-if=\"ctrl.showPriceSummaryLink\">\n                                            <a target=\"_blank\" ng-href=\"{{ ctrl.generatePriceSummaryLink(price.id) }}\">{{ price.excess | nocents }}</a>\n                                          </span>\n                                          <span ng-if=\"package.fund.code=='ahb'\">\n                                            {{ ctrl.defenceLabel(price.fund_product_code) }}\n                                          </span>\n                                          <span ng-if=\"isClosed\">CLOSED</span>\n                                        </label>\n                                    </li>\n                                    <!-- This is just to make excess info take same vertical space across responsive columns -->\n                                    <li ng-repeat=\"n in package.fillerPrices\">&nbsp;</li>\n                                </ul>\n                            </div>\n                        </div>\n                    </td>\n                </tr>\n\n                <tr>\n                    <td></td>\n                    <td\n                        ng-repeat=\"package in ctrl.packages track by $id(package)\"\n                        ng-class=\"ctrl.columnClass(package)\"\n                    >\n                        <footer\n                            ng-if=\"!package.is_current_policy && package.selectedPrice.pricing.available && package.fund.is_panel_capable\"\n                        >\n                            <button\n                                ng-if=\"ctrl.canApply(package)\"\n                                ng-click=\"ctrl.apply(package.selectedPrice, package)\"\n                                class=\"btn btn--primary\"\n                            >\n                                Apply<span>  &gt;</span>\n                                <span ng-if=\"this.corporate.disable_apply_button\"><br><i>(disabled)</i></span>\n                            </button>\n                        </footer>\n                    </td>\n                </tr>\n\n                <tr>\n                    <td></td>\n                    <td\n                        ng-repeat=\"package in ctrl.packages track by $id(package)\"\n                        ng-class=\"ctrl.columnClass(package)\"\n                    >\n                        <footer\n                            ng-if=\"!package.is_current_policy && package.selectedPrice.pricing.available && package.fund.is_panel_capable\"\n                        >\n                            <button\n                                ng-if=\"ctrl.canSaveQuote(package)\"\n                                ng-click=\"ctrl.onSaveZohoQuote(package)\"\n                                class=\"btn btn--secondary\"\n                                button-loading-indicator=\"package.isSavingZohoQuote\"\n                            >\n                                <span ng-if=\"!package.saveZohoQuoteFailed\">Save Quote</span>\n                                <span ng-if=\"package.saveZohoQuoteFailed\">Error (retry)</span>\n                            </button>\n\n                        </footer>\n                    </td>\n                </tr>\n\n                <tr>\n                    <td></td>\n                    <td\n                        ng-repeat=\"package in ctrl.packages track by $id(package)\"\n                        style=\"vertical-align: top\"\n                        ng-class=\"ctrl.columnClass(package)\"\n                    >\n                        <div\n                            ng-if=\"!package.is_current_policy\"\n                            class=\"product-action-button-container\"\n                        >\n                            <button ng-if=\"package.fund.is_price_check_available\" class=\"btn btn--secondary\"\n                                    ng-disabled=\"ctrl.checkPriceLoading[package.id]\"\n                                    ng-click=\"ctrl.checkPrice(package)\">\n                                <span ng-if=\"ctrl.checkPriceLoading[package.id]\">Please wait...</span>\n                                <span ng-if=\"!ctrl.checkPriceLoading[package.id]\">Check Price</span>\n                            </button>\n                        </div>\n                    </td>\n                </tr>\n\n                <tr>\n                    <td></td>\n                    <td\n                        ng-repeat=\"package in ctrl.packages track by $id(package)\"\n                        style=\"vertical-align: center\"\n                        ng-class=\"ctrl.columnClass(package)\"\n                    >\n                        <div class=\"summary-package-name product-result\">\n                            <img\n                              class=\"fund-logo\"\n                              position-tooltip\n                              tooltip-html-unsafe=\"{{ package.fund.info }}\"\n                              src=\"{{ package.fund.logo }}\"\n                              alt=\"{{ package.fund.name }}\"\n                            />\n                            <div ng-if=\"!package.fund.logo\">{{ package.fund.name }}</div>\n                            <span\n                              class=\"restricted-fund-label\"\n                              ng-if=\"package.fund.is_restricted_fund\"\n                              tooltip-html-unsafe=\"{{ package.fund.restricted_fund_description }}\"\n                              position-tooltip\n                            >\n                              [Restricted]\n                            </span>\n                            <span\n                              class=\"fund-offer-label\"\n                              ng-if=\"ctrl.fundGeneralOffer(package.fund.code)\"\n                              tooltip-html-unsafe=\"{{ ctrl.fundGeneralOffer(package.fund.code).general_offer_long }}\"\n                              position-tooltip\n                            >\n                              [Offer]\n                            </span>\n                        </div>\n                    </td>\n                </tr>\n\n                <tr>\n                    <td></td>\n                    <td\n                        ng-repeat=\"package in ctrl.packages track by $id(package)\"\n                        style=\"vertical-align: top\"\n                        ng-class=\"ctrl.columnClass(package)\"\n                    >\n                        <div class=\"product-documents-list product-result\">\n                            <div ng-if=\"package.documents.length\"><b>Product Documents:</b></div>\n                            <div ng-repeat=\"d in package.documents\">\n                                <a target=\"_blank\" href=\"{{ d[1] }}\">{{ d[0] }}</a>\n                            </div>\n\n                            <span ng-if=\"package.show_fund_documents\">-</span>\n                            <span ng-if=\"!package.show_fund_documents\">+</span>\n                            <a href=\"\" ng-click=\"package.show_fund_documents = !package.show_fund_documents\">All Fund Documents</a>\n                            <div ng-if=\"package.show_fund_documents\" class=\"all-fund-documents\">\n                                <ul><li ng-repeat=\"d in package.fund_documents\"><a href=\"{{ d[1] }}\" target=\"_blank\">{{ d[0] }}</a></li></ul>\n                            </div>\n\n                            <div><b>PHIO Sheets:</b></div>\n                            <div ng-repeat=\"url in package.selectedPrice.phioUrls\">\n                                <a href=\"{{ url.url }}\" target=\"_blank\">{{ url.label }}</a>\n                            </div>\n                        </div>\n                    </td>\n                </tr>\n\n\n                <tr>\n                    <td></td>\n                    <td\n                        ng-repeat=\"package in ctrl.packages track by $id(package)\"\n                        style=\"vertical-align: top\"\n                        ng-class=\"ctrl.columnClass(package)\"\n                    >\n                        <div class=\"summary-package-name product-result\">\n                            <b><span\n                                    ng-if=\"package.hospital_product.name.length\">{{ package.hospital_product.name }}</span>\n                                <span ng-if=\"package.ancillary_product.name.length && !package.hospital_product.name.length\">{{ package.ancillary_product.name }}</span></b>\n                            <div>{{ package.selectedPrice.fund_product_code }}</div>\n                        </div>\n                    </td>\n                </tr>\n\n                <tbody services-feature-list-table\n                       packages=\"ctrl.packages\"\n                       features=\"hospital\"\n                       services-label=\"hospital items\"\n                       start-open=\"true\"\n                       services=\"ctrl.services.hospital\"\n                       services-selected=\"true\"\n                       corporate=\"ctrl.corporate\"></tbody>\n\n                <tbody services-feature-list-table\n                       packages=\"ctrl.packages\"\n                       features=\"ancillary\"\n                       services-label=\"extras\"\n                       start-open=\"true\"\n                       services=\"ctrl.services.ancillary\"\n                       services-selected=\"true\"></tbody>\n\n                <tbody services-feature-list-table\n                       packages=\"ctrl.packages\"\n                       features=\"hospital\"\n                       start-open=\"true\"\n                       services-label=\"hospital items\"\n                       services=\"ctrl.services.hospital\"\n                       services-selected=\"false\"\n                       corporate=\"ctrl.corporate\"></tbody>\n\n                <tbody services-feature-list-table\n                       packages=\"ctrl.packages\"\n                       features=\"ancillary\"\n                       start-open=\"true\"\n                       services-label=\"extras\"\n                       services=\"ctrl.services.ancillary\"\n                       services-selected=\"false\"></tbody>\n\n            </table>\n\n        </div>\n\n    </div>\n</div>\n\n\n<div class=\"modal fade price-check\" id=\"check-price\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"price-check-label\">\n    <div class=\"modal-dialog\" role=\"document\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span\n                        aria-hidden=\"true\">&times;</span></button>\n                <h1 class=\"modal-title\" id=\"price-check-label\">Price Check</h1>\n            </div>\n            <div class=\"modal-body\">\n                <div class=\"row\">\n                    <div class=\"col-sm-6\">\n                        <h1>Comparator Price</h1>\n                        <ul>\n                            <li><b>Total Premium</b>: {{ ctrl.checkedPricesProduct.pricing.available.monthly_adjusted_price.premium.toFixed(2) }}</li>\n                            <li><b>Base Premium</b>: {{ ctrl.checkedPricesProduct.pricing.available.monthly_adjusted_price.base_premium.toFixed(2) }}</li>\n                            <li><b>LHC Base</b>: {{ ctrl.checkedPricesProduct.gross_monthly_lhc }}</li>\n                            <li><b>LHC Amount</b>: {{ ctrl.checkedPricesProduct.pricing.available.monthly_adjusted_price.lhc_amount.toFixed(2) }}</li>\n                            <li><b>Rebate Amount</b>: {{ ctrl.checkedPricesProduct.pricing.available.monthly_adjusted_price.rebate_amount.toFixed(2) }}</li>\n                            <li><b>LHC Percent</b>: {{ ctrl.checkedPricesProduct.pricing.available.monthly_adjusted_price.lhc_percent.toFixed(2) }}</li>\n                            <li><b>Rebate Percent</b>: {{ ctrl.checkedPricesProduct.pricing.available.monthly_adjusted_price.rebate_percent.toFixed(2) }}</li>\n                        </ul>\n                        <ul>\n                            <li><b>Product Name</b>: {{ ctrl.checkedPricesProduct.name }}</li>\n                            <li><b>Product Code</b>: {{ ctrl.checkedPricesProduct.fund_product_code }}</li>\n                        </ul>\n                    </div>\n                    <div class=\"col-sm-6\">\n                        <h1>Price Quote</h1>\n                        <ul>\n                            <li ng-repeat=\"item in ctrl.checkedPrices.quote\">\n                                <b>{{ item[0].split(\"_\").join(\" \")|titlecase }}</b>: {{ item[1] }}\n                            </li>\n                        </ul>\n                        <h1>Quote Parameters</h1>\n                        <ul>\n                            <li ng-repeat=\"item in ctrl.checkedPrices.params\">\n                                <b>{{ item[0].split(\"_\").join(\" \")|titlecase }}</b>: {{ item[1] }}\n                            </li>\n                        </ul>\n                    </div>\n                </div>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>\n            </div>\n        </div>\n    </div>\n</div>\n\n<save-quote\n    on-close=\"ctrl.onCloseSaveQuote\"\n    on-save=\"ctrl.saveZohoQuote\"\n    visible=\"ctrl.saveQuoteVisible\"\n    applicant=\"ctrl.applicant\"\n></save-quote>\n\n<div\n  class=\"modal fade large\"\n  id=\"service-filters\"\n  tabindex=\"-1\"\n  role=\"dialog\"\n  aria-labelledby=\"service-filters-label\"\n>\n  <div class=\"modal-dialog\" role=\"document\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <h1 class=\"modal-title\" id=\"service-filters-label\">Services</h1>\n      </div>\n      <div class=\"modal-body\">\n        <service-filters\n          requires-hospital=\"ctrl.application.requiresHospitalProducts()\"\n          requires-ancillary=\"ctrl.application.requiresAncillaryProducts()\"\n          services-in-columns=\"ctrl.servicesInColumns\"\n          primary-service-need=\"ctrl.application.policy.primary_service_need\"\n          previous-fund=\"ctrl.application.personal.previous_fund\"\n        />\n      </div>\n      <div class=\"modal-footer\">\n        <button\n          type=\"button\"\n          class=\"btn btn--secondary\"\n          data-dismiss=\"modal\"\n          ng-click=\"ctrl.applyServiceFilters()\"\n        >\n          Apply\n        </button>\n        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Cancel</button>\n      </div>\n    </div>\n  </div>\n</div>"

/***/ }),
/* 316 */
/***/ (function(module, exports) {

	module.exports = "<style>\n  table {\n      border-collapse: collapse;\n      table-layout: fixed;\n      min-width: 200px;\n  }\n\n  table tr > td {\n      padding: 4px 10px;\n      border: 1px solid #ababab;\n  }\n\n  table tr > td:first-child {\n      background-color: lightgrey;\n  }\n</style>\n\n<div style=\"padding: 20px\">\n  <div ng-if=\"ctrl.loading\">Loading...</div>\n\n  <div ng-if=\"ctrl.error\">\n    <b>Error loading price ID: {{ ctrl.priceId }} </b>\n    <pre style=\"font: inherit; max-width: 500px\">{{ ctrl.error }}</pre>\n  </div>\n\n  <div ng-if=\"ctrl.price\">\n    <table>\n      <tbody>\n      <tr>\n        <td>Product</td>\n        <td>{{ ctrl.price.name }}</td>\n      </tr>\n\n      <tr>\n        <td>Product Code</td>\n        <td>{{ ctrl.price.fund_product_code }}</td>\n      </tr>\n\n      <tr>\n        <td>SIS Code</td>\n        <td>{{ ctrl.price.sis_code }}</td>\n      </tr>\n\n      <tr>\n        <td>Price ID</td>\n        <td><a href=\"/admin/productcore/productprice/{{ ctrl.price.id }}\">{{ ctrl.price.id }}</a></td>\n      </tr>\n\n      <tr>\n        <td>State</td>\n        <td>{{ ctrl.price.state }}</td>\n      </tr>\n\n      <tr>\n        <td>Membership Type</td>\n        <td>{{ ctrl.price.membership_label }}</td>\n      </tr>\n\n      <tr>\n        <td>Product Type</td>\n        <td>{{ ctrl.price.type_label }}</td>\n      </tr>\n\n      <tr>\n        <td>LHC Age(s)</td>\n        <td>{{ ctrl.applicant.policy.lhc_age }}<span ng-if=\"ctrl.applicant.policy.lhc_age_partner\"> & {{ ctrl.applicant.policy.lhc_age_partner }}</span> = {{ ctrl.lhc_percent }}%</td>\n      </tr>\n\n      <tr>\n        <td>Rebate Tier</td>\n        <td>{{ ctrl.applicant.policy.rebate_tier }}</td>\n      </tr>\n\n      <tr>\n        <td></td>\n        <td ng-if=\"ctrl.current\">Current Pricing</td>\n        <td ng-if=\"ctrl.future\">Future Pricing (from {{ ctrl.price.future_available_from }})</td>\n      </tr>\n\n      <tr>\n        <td>AGR %</td>\n        <td ng-if=\"ctrl.current\">{{ ctrl.value(ctrl.current.rebate_percent.toFixed(3), '', '%') }}</td>\n        <td ng-if=\"ctrl.future\">{{ ctrl.value(ctrl.future.rebate_percent.toFixed(3), '', '%') }}</td>\n      </tr>\n\n      <tr>\n        <td>Base Premium</td>\n        <td ng-if=\"ctrl.current\">{{ ctrl.value(ctrl.current.base_premium.toFixed(2), '$', '') }}</td>\n        <td ng-if=\"ctrl.future\">{{ ctrl.value(ctrl.future.base_premium.toFixed(2), '$', '') }}</td>\n      </tr>\n\n      <tr>\n        <td>LHC Component</td>\n        <td ng-if=\"ctrl.current\">{{ ctrl.value(ctrl.price.gross_monthly_lhc, '$', '') }}</td>\n        <td ng-if=\"ctrl.future\">{{ ctrl.value(ctrl.price.future_gross_monthly_lhc, '$', '') }}</td>\n      </tr>\n\n      <tr>\n        <td>LHC</td>\n        <td ng-if=\"ctrl.current\">{{ ctrl.value(ctrl.current.lhc_amount.toFixed(2), '$', '') }}</td>\n        <td ng-if=\"ctrl.future\">{{ ctrl.value(ctrl.future.lhc_amount.toFixed(2), '$', '') }}</td>\n      </tr>\n\n      <tr>\n        <td>AGR</td>\n        <td ng-if=\"ctrl.current\">{{ ctrl.value(ctrl.current.rebate_amount.toFixed(2), '$', '') }}</td>\n        <td ng-if=\"ctrl.future\">{{ ctrl.value(ctrl.future.rebate_amount.toFixed(2), '$', '') }}</td>\n      </tr>\n\n      <tr>\n        <td>Discounts Applied</td>\n        <td ng-if=\"ctrl.current\">\n          <div ng-repeat=\"discount in ctrl.current.discounts\">\n            {{ discount }}\n          </div>\n        </td>\n        <td ng-if=\"ctrl.future\">\n          <div ng-repeat=\"discount in ctrl.future.discounts\">\n            {{ discount }}\n          </div>\n        </td>\n      </tr>\n\n      <tr>\n        <td>Total Discounts</td>\n        <td ng-if=\"ctrl.current\">{{ ctrl.value(ctrl.current.total_discounts.toFixed(2), '$', '') }}</td>\n        <td ng-if=\"ctrl.future\">{{ ctrl.value(ctrl.future.total_discounts.toFixed(2), '$', '') }}</td>\n      </tr>\n\n      <tr>\n        <td>Premium</td>\n        <td ng-if=\"ctrl.current\">{{ ctrl.value(ctrl.current.premium.toFixed(2), '$', '') }}</td>\n        <td ng-if=\"ctrl.future\">{{ ctrl.value(ctrl.future.premium.toFixed(2), '$', '') }}</td>\n      </tr>\n\n      </tbody>\n    </table>\n\n  </div>\n\n</div>\n"

/***/ }),
/* 317 */
/***/ (function(module, exports) {

	module.exports = "<app-scaffold>\n  <basic-page-header title=\"Privacy\"></basic-page-header>\n\n  <div class=\"container basic-page\">\n    <div class=\"row--narrow\">\n      <section ng-include=\"ctrl.deployment.privacy\"></section>\n    </div>\n  </div>\n</app-scaffold>"

/***/ }),
/* 318 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"quote {{ ctrl.quoteClass }}\">\n\n  <div ng-if=\"ctrl.loading\" class=\"quote-loading\">\n    <h1 ng-show=\"!ctrl.isFetchingPage\">One moment please while we retrieve your quote...</h1>\n    <img src=\"/static/images/ring.gif\"/>\n  </div>\n\n  <div ng-if=\"ctrl.error\" ng-include=\"ctrl.errorTemplate\"></div>\n\n  <div ng-if=\"!ctrl.loading && !ctrl.error && ctrl.template\" ng-include=\"ctrl.template\"></div>\n\n</div>\n"

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container basic-page\">\n    <div class=\"row--narrow\">\n\n        <h1><b>Retention</b></h1>\n        <p>{{ ctrl.product.fund.name }}</p>\n\n        <form\n            class=\"comparator-form\"\n            name=\"ctrl.retentionForm\"\n            ng-submit=\"\"\n            remove-external-validation-errors-on-submit=\"false\"\n            novalidate\n            focus-invalid\n        >\n\n            <fieldset ngForm=\"retentionForm\">\n                <legend>Personal Details</legend>\n\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Member Number</label>\n\n                    <div class=\"form-value\">\n                        <input\n                            required\n                            class=\"form-control\"\n                            name=\"membership_number\"\n                            ng-model=\"ctrl.application.personal.previous_fund.member_number\"\n                        />\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label class=\"control-label\">First Name</label>\n\n                    <div class=\"form-value\">\n                        <input\n                            required\n                            type=\"text\"\n                            class=\"form-control\"\n                            ng-model=\"ctrl.application.personal.first_name\"\n                        />\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Last Name</label>\n\n                    <div class=\"form-value\">\n                        <input\n                            required\n                            type=\"text\"\n                            class=\"form-control\"\n                            ng-model=\"ctrl.application.personal.last_name\"\n                        />\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Mobile Phone</label>\n\n                    <div class=\"form-value\">\n                        <input\n                            required\n                            class=\"form-control\"\n                            name=\"phone_mobile\"\n                            ng-model=\"ctrl.ctrl.application.contact.phone_mobile\"\n                            apply-validators=\"ctrl.mobileValidatorPattern\"\n                        />\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Email</label>\n\n                    <div class=\"form-value\">\n                        <input\n                            required\n                            class=\"form-control\"\n                            name=\"email_address\"\n                            ng-model=\"ctrl.application.contact.email_address\"\n                            apply-validators=\"ctrl.emailValidatorPattern\"\n                        />\n                    </div>\n                </div>\n            </fieldset>\n\n            <fieldset>\n                <legend>Current Product</legend>\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Product Name</label>\n\n                    <div class=\"form-value\">\n                        <input\n                            required\n                            class=\"form-control\"\n                            name=\"product_name\"\n                            ng-model=\"ctrl.email_data.current_product.product_name\"\n                        />\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Excess Level</label>\n\n                    <div class=\"form-value\">\n                        <input\n                            required\n                            class=\"form-control\"\n                            name=\"excess\"\n                            ng-model=\"ctrl.email_data.current_product.excess\"\n                        />\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Cover Type</label>\n\n                    <div class=\"form-value\">\n                        <select\n                            required\n                            class=\"form-control\"\n                            name=\"membership_type\"\n                            ng-model=\"ctrl.email_data.current_product.membership_type\"\n                            ng-options=\"item[0] as item[1] for item in ctrl.formChoices.membership_type\"\n                        >\n                            <option value=\"\">-- Please select --</option>\n                        </select>\n                    </div>\n                </div>\n            </fieldset>\n\n            <fieldset>\n                <legend>New Product</legend>\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Product Name</label>\n\n                    <div class=\"form-value\">\n                        <input\n                            required\n                            class=\"form-control\"\n                            name=\"new_product_name\"\n                            ng-model=\"ctrl.product.name\"\n                        />\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Excess Level</label>\n\n                    <div class=\"form-value\">\n                        <input\n                            required\n                            class=\"form-control\"\n                            name=\"new_excess\"\n                            ng-model=\"ctrl.product.excess\"\n                        />\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Cover Type</label>\n\n                    <div class=\"form-value\">\n                        <select\n                            required\n                            class=\"form-control\"\n                            name=\"new_membership_type\"\n                            ng-model=\"ctrl.application.policy.membership_type\"\n                            ng-options=\"item[0] as item[1] for item in ctrl.formChoices.membership_type\"\n                        >\n                            <option value=\"\">-- Please select --</option>\n                        </select>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Quoted Price</label>\n\n                    <div class=\"form-value\">\n                        <input\n                            class=\"form-control\"\n                            name=\"quoted_price\"\n                            ng-model=\"ctrl.product.calculations.totalPrice\"\n                            readonly\n                        />\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Rebate Tier</label>\n\n                    <div class=\"form-value\">\n                        <input\n                            required\n                            name=\"rebate_tier\"\n                            class=\"form-control\"\n                            type=\"number\"\n                            ng-model=\"ctrl.application.policy.rebate_tier\"\n                        />\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Payment Type</label>\n\n                    <div class=\"form-value\">\n                        <select\n                            required\n                            class=\"form-control\"\n                            name=\"payment_type\"\n                            ng-model=\"ctrl.application.payment.type\"\n                        >\n                            <option value=\"\">-- Select Payment Type --</option>\n                            <option value=\"Credit card\">Credit Card</option>\n                            <option value=\"Direct debit\">Direct Debit</option>\n                            <option value=\"Cheque\">Cheque</option>\n                            <option value=\"Other\">Other</option>\n                        </select>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Payment Frequency</label>\n\n                    <div class=\"form-value\">\n                        <select\n                            required\n                            class=\"form-control\"\n                            name=\"payment_frequency\"\n                            ng-model=\"ctrl.application.payment.frequency\"\n                        >\n                            <option value=\"\">-- Select Payment Frequency --</option>\n                            <option value=\"0\">Weekly</option>\n                            <option value=\"1\">Fortnightly</option>\n                            <option value=\"2\">Monthly</option>\n                            <option value=\"3\">Quarterly</option>\n                            <option value=\"4\">Half Yearly</option>\n                            <option value=\"5\">Yearly</option>\n                        </select>\n\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Payment Date</label>\n\n                    <div class=\"form-value\">\n                        <input\n                            required\n                            class=\"form-control\"\n                            name=\"debit_date\"\n                            type=\"date\"\n                            ng-model=\"ctrl.application.payment.debit_date\"\n                        />\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Address</label>\n\n                    <div class=\"form-value\">\n                        <input\n                            required\n                            class=\"form-control\"\n                            name=\"address\"\n                            ng-model=\"ctrl.email_data.address\"\n                        />\n                    </div>\n                </div>\n            </fieldset>\n\n            <fieldset>\n            <legend>Notes</legend>\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Note Title</label>\n\n                    <div class=\"form-value\">\n                        <input\n                            type=\"text\"\n                            class=\"form-control\"\n                            name=\"new-product-notes\"\n                            ng-model=\"ctrl.email_data.note_title\"\n                        />\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Notes</label>\n\n                    <div class=\"form-value\">\n                        <textarea\n                            class=\"form-control\"\n                            name=\"new-product-notes\"\n                            ng-model=\"ctrl.email_data.notes\"\n                        >\n                        </textarea>\n                    </div>\n                </div>\n            </fieldset>\n\n            <div style=\"text-align:center\">\n                <button\n                    class=\"btn btn--primary\"\n                    type=\"submit\"\n                    ng-click=\"ctrl.submit()\"\n                    button-loading-indicator=\"ctrl.isSaving\"\n                >\n                    Submit Data to Fund and Update Zoho\n                </button>\n                <br><br>\n                <div ng-if=\"ctrl.resultMessage\">{{ ctrl.resultMessage }}</div>\n            </div>\n\n        </form>\n    </div>\n</div>"

/***/ }),
/* 320 */
/***/ (function(module, exports) {

	module.exports = "<basic-page-header title=\"Retrieve Password\"></basic-page-header>\n\n<div class=\"container basic-page\">\n    <div class=\"row--narrow\">\n        <p>\n            <span ng-bind-html=\"ctrl.corporateConfig.code_email_retrieval_help\"></span>\n        </p>\n        <form name=\"ctrl.emailForm\"\n              ng-submit=\"ctrl.submit(ctrl.emailForm)\"\n              novalidate focus-invalid\n              remove-external-validation-errors-on-submit=\"false\">\n            <div class=\"form-group\">\n                <label class=\"control-label\">Email Address</label>\n\n                <div class=\"form-value\">\n                    <input type=\"email\"\n                           name=\"email_address\"\n                           class=\"form-control\"\n                           ng-model=\"ctrl.email_address\"\n                           ng-model-options=\"{updateOn: 'submit'}\"\n                           required/>\n                </div>\n            </div>\n            <p ng-if=\"ctrl.messages.success\">\n                <span ng-bind-html=\"ctrl.messages.success\"></span>\n            </p>\n            <p ng-if=\"ctrl.messages.failure\">\n                <span ng-bind-html=\"ctrl.messages.failure\"></span>\n            </p>\n            <button class=\"btn btn--primary\" button-loading-indicator=\"ctrl.messages.loading\">Send Password</button>\n        </form>\n    </div>\n</div>\n"

/***/ }),
/* 321 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"refine-results operator\">\n  <div id=\"refine\" class=\"refine-results--opened\">\n    <div class=\"comparator-form\">\n\n      <div class=\"form-value\">\n        <label for=\"primary-service-need\" class=\"control-label\">\n          Primary Service Need\n        </label>\n        <select\n          id=\"primary-service-need\"\n          name=\"primary-service-need\"\n          class=\"form-control\"\n          ng-model=\"primaryServiceNeed\"\n          ng-change=\"onSelectPrimaryServiceNeed()\"\n          ng-options=\"choice.code as choice.description for choice in primaryServiceNeeds\"\n          required\n        >\n            <option value=\"\">-- Please select most appropriate Primary Need --</option>\n        </select>\n      </div>\n\n      <button\n          ng-if=\"hasCurrentPolicy()\"\n          ng-click=\"selectCurrentProductServices()\"\n          type=\"button\"\n          class=\"btn btn--plain\"\n          button-loading-indicator=\"isLoadingCurrentPolicyServices\"\n          style=\"margin-top: 10px;\"\n      >\n          Select services from current policy\n      </button>\n\n\n      <div class=\"form-section-header\">Select the items that are important to you:</div>\n      <div class=\"refine-hospital\" ng-if=\"requiresHospital\">\n        <div class=\"refine-hospital-header\">\n          <span class=\"faux-label\">Hospital</span>\n        </div>\n        <ul class=\"refine--left\">\n          <li\n            ng-repeat=\"service in servicesInColumns.hospital.left | orderBy:'-sort_order'\"\n            ng-class=\"getServiceCSSClass(service)\"\n          >\n            <label style=\"{{ getStyle(service) }}\">\n              <input type=\"checkbox\" ng-model=\"service.selected\"/>{{ service.name }}\n              <i ng-if=\"service.description\"\n                 tooltip-html-unsafe=\"{{ service.description }}\" position-tooltip\n                 class=\"glyphicon glyphicon-info-sign\"></i>\n            </label>\n          </li>\n        </ul>\n        <ul class=\"refine--right\">\n          <li\n            ng-repeat=\"service in servicesInColumns.hospital.right | orderBy:'-sort_order'\"\n            ng-class=\"getServiceCSSClass(service)\"\n          >\n            <label style=\"{{ getStyle(service) }}\">\n              <input type=\"checkbox\" ng-model=\"service.selected\"/> {{ service.name }}\n              <i ng-if=\"service.description\"\n                 tooltip-html-unsafe=\"{{ service.description }}\" position-tooltip\n                 class=\"glyphicon glyphicon-info-sign\"></i>\n            </label>\n          </li>\n        </ul>\n      </div>\n      <div class=\"refine-ancillary\" ng-if=\"requiresAncillary\">\n        <span class=\"faux-label\">Extras</span>\n        <ul class=\"refine--left\">\n          <li\n            ng-repeat=\"service in servicesInColumns.ancillary.left | orderBy:'-sort_order'\"\n            ng-class=\"getServiceCSSClass(service)\"\n          >\n            <label style=\"{{ getStyle(service) }}\">\n              <input type=\"checkbox\" ng-model=\"service.selected\"/> {{ service.name }}\n              <i ng-if=\"service.description\"\n                 tooltip-html-unsafe=\"{{ service.description }}\" position-tooltip\n                 class=\"glyphicon glyphicon-info-sign\"></i>\n            </label>\n          </li>\n        </ul>\n        <ul class=\"refine--right\">\n          <li\n            ng-repeat=\"service in servicesInColumns.ancillary.right | orderBy:'-sort_order'\"\n            ng-class=\"getServiceCSSClass(service)\"\n          >\n            <label style=\"{{ getStyle(service) }}\">\n              <input type=\"checkbox\" ng-model=\"service.selected\"/> {{ service.name }}\n              <i ng-if=\"service.description\"\n                 tooltip-html-unsafe=\"{{ service.description }}\" position-tooltip\n                 class=\"glyphicon glyphicon-info-sign\"></i>\n            </label>\n          </li>\n        </ul>\n      </div>\n    </div>\n  </div>\n</div>"

/***/ }),
/* 322 */
/***/ (function(module, exports) {

	module.exports = "<div\n  class=\"modal\"\n  id=\"zoho-api-error\"\n  tabindex=\"-1\"\n  role=\"dialog\"\n  aria-labelledby=\"zoho-api-error\"\n>\n  <div class=\"modal-dialog\" role=\"document\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <h1 class=\"modal-title\" id=\"zoho-api-error\">ERROR: Zoho API</h1>\n      </div>\n      <div class=\"modal-body\">\n        <p>There was an error updating Zoho, please check opportunity record</p>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Dismiss</button>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 323 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"status\">\n    <h1 ng-show=\"!ctrl.isFetchingPage\">{{ ctrl.status }}</h1>\n    <img src=\"/static/images/ring.gif\"/>\n  </div>\n</div>\n"

/***/ }),
/* 324 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var iteratorSymbol =
	    typeof Symbol === "function" && Symbol.iterator || "@@iterator";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    return new Generator(innerFn, outerFn, self || null, tryLocsList || []);
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunction.displayName = "GeneratorFunction";
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    genFun.__proto__ = GeneratorFunctionPrototype;
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    return new Promise(function(resolve, reject) {
	      var generator = wrap(innerFn, outerFn, self, tryLocsList);
	      var callNext = step.bind(generator.next);
	      var callThrow = step.bind(generator["throw"]);
	
	      function step(arg) {
	        var record = tryCatch(this, null, arg);
	        if (record.type === "throw") {
	          reject(record.arg);
	          return;
	        }
	
	        var info = record.arg;
	        if (info.done) {
	          resolve(info.value);
	        } else {
	          Promise.resolve(info.value).then(callNext, callThrow);
	        }
	      }
	
	      callNext();
	    });
	  };
	
	  function Generator(innerFn, outerFn, self, tryLocsList) {
	    var generator = outerFn ? Object.create(outerFn.prototype) : this;
	    var context = new Context(tryLocsList);
	    var state = GenStateSuspendedStart;
	
	    function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          if (state === GenStateSuspendedStart &&
	              typeof arg !== "undefined") {
	            // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	            throw new TypeError(
	              "attempt to send " + JSON.stringify(arg) + " to newborn generator"
	            );
	          }
	
	          if (state === GenStateSuspendedYield) {
	            context.sent = arg;
	          } else {
	            delete context.sent;
	          }
	
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	
	          if (method === "next") {
	            context.dispatchException(record.arg);
	          } else {
	            arg = record.arg;
	          }
	        }
	      }
	    }
	
	    generator.next = invoke.bind(generator, "next");
	    generator["throw"] = invoke.bind(generator, "throw");
	    generator["return"] = invoke.bind(generator, "return");
	
	    return generator;
	  }
	
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset();
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function() {
	      this.prev = 0;
	      this.next = 0;
	      this.sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      // Pre-initialize at least 20 temporary variables to enable hidden
	      // class optimizations for simple generators.
	      for (var tempIndex = 0, tempName;
	           hasOwn.call(this, tempName = "t" + tempIndex) || tempIndex < 20;
	           ++tempIndex) {
	        this[tempName] = null;
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg < finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          return this.complete(entry.completion, entry.afterLoc);
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ })
/******/ ])));


// WEBPACK FOOTER //
// js/app-f2469b0409a3f32043b6-hashed.js